import { jsx as f, jsxs as U, Fragment as at } from "react/jsx-runtime";
import * as y from "react";
import xt, { forwardRef as Ii, createElement as Ia, useRef as Ee, useCallback as Ue, useEffect as te, useState as re, useContext as wi, useMemo as gt, createContext as pd, useLayoutEffect as X3, memo as U3, Component as B3 } from "react";
import { useFocusable as gd, updateAllLayouts as w3, init as Y3 } from "@noriginmedia/norigin-spatial-navigation";
import T3 from "lodash.throttle";
import { CountdownCircleTimer as fd } from "react-countdown-circle-timer";
import L3 from "react-countup";
let pr = 0, Na = [];
function k3() {
  return pr += 1, () => {
    if (pr -= 1, pr === 0) {
      let t = Na;
      Na = [];
      for (let e of t) e();
    }
  };
}
let mt = [], en = 0;
const Pi = 4;
let As = 0;
const Pt = /* @__NO_SIDE_EFFECTS__ */ (t) => {
  let e = [], n = {
    get() {
      return n.lc || n.listen(() => {
      })(), n.value;
    },
    lc: 0,
    listen(i) {
      return n.lc = e.push(i), () => {
        for (let r = en + Pi; r < mt.length; )
          mt[r] === i ? mt.splice(r, Pi) : r += Pi;
        let s = e.indexOf(i);
        ~s && (e.splice(s, 1), --n.lc || n.off());
      };
    },
    notify(i, s) {
      As++;
      let r = !mt.length;
      for (let o of e)
        mt.push(o, n.value, i, s);
      if (r) {
        for (en = 0; en < mt.length; en += Pi)
          mt[en](
            mt[en + 1],
            mt[en + 2],
            mt[en + 3]
          );
        mt.length = 0;
      }
    },
    /* It will be called on last listener unsubscribing.
       We will redefine it in onMount and onStop. */
    off() {
    },
    set(i) {
      let s = n.value;
      s !== i && (n.value = i, n.notify(s));
    },
    subscribe(i) {
      let s = n.listen(i);
      return i(n.value), s;
    },
    value: t
  };
  return n;
}, J3 = 0, x3 = 1, M3 = 5, _i = 6, ji = 10;
let Nl = (t, e, n, i) => (t.events = t.events || {}, t.events[n + ji] || (t.events[n + ji] = i((s) => {
  t.events[n].reduceRight((r, o) => (o(r), r), {
    shared: {},
    ...s
  });
})), t.events[n] = t.events[n] || [], t.events[n].push(e), () => {
  let s = t.events[n], r = s.indexOf(e);
  s.splice(r, 1), s.length || (delete t.events[n], t.events[n + ji](), delete t.events[n + ji]);
}), bd = (t, e) => Nl(t, e, J3, (n) => {
  let i = t.listen;
  return t.listen = (s) => (!t.lc && !t.starting && (t.starting = !0, n(), delete t.starting), i(s)), () => {
    t.listen = i;
  };
}), Fa = (t, e) => Nl(t, e, x3, (n) => {
  let i = t.off;
  return t.off = () => {
    n(), i();
  }, () => {
    t.off = i;
  };
}), Q3 = 1e3, Hs = (t, e) => Nl(t, (i) => {
  let s = e(i);
  s && t.events[_i].push(s);
}, M3, (i) => {
  let s = t.listen;
  t.listen = (...o) => (!t.lc && !t.active && (t.active = !0, i()), s(...o));
  let r = t.off;
  return t.events[_i] = [], t.off = () => {
    r(), setTimeout(() => {
      if (t.active && !t.lc) {
        t.active = !1;
        for (let o of t.events[_i]) o();
        t.events[_i] = [];
      }
    }, Q3);
  }, () => {
    t.listen = s, t.off = r;
  };
}), Ad = (t, e, n) => {
  Array.isArray(t) || (t = [t]);
  let i, s, r = () => {
    if (s === As) return;
    s = As;
    let u = t.map((h) => h.get());
    if (!i || u.some((h, d) => h !== i[d])) {
      i = u;
      let h = e(...u);
      h && h.then && h.t ? h.then((d) => {
        i === u && o.set(d);
      }) : (o.set(h), s = As);
    }
  }, o = /* @__PURE__ */ Pt(void 0), l = o.get;
  o.get = () => (r(), l());
  let a, c = n ? () => {
    clearTimeout(a), a = setTimeout(r);
  } : r;
  return Hs(o, () => {
    let u = t.map((h) => h.listen(c));
    return r(), () => {
      for (let h of u) h();
    };
  }), o;
};
const z3 = /* @__NO_SIDE_EFFECTS__ */ (t, e) => Ad(t, e), Po = /* @__NO_SIDE_EFFECTS__ */ (t, e) => Ad(t, e, !0);
function K3(t, e, n) {
  let i = new Set(e).add(void 0);
  return t.listen((s, r, o) => {
    i.has(o) && n(s, r, o);
  });
}
const _o = /* @__NO_SIDE_EFFECTS__ */ (t = {}) => {
  let e = /* @__PURE__ */ Pt(t);
  return e.setKey = function(n, i) {
    let s = e.value;
    typeof i > "u" && n in e.value ? (e.value = { ...e.value }, delete e.value[n], e.notify(s, n)) : e.value[n] !== i && (e.value = {
      ...e.value,
      [n]: i
    }, e.notify(s, n));
  }, e;
};
function H3(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var gr = { exports: {} }, fr = {};
var Ga;
function O3() {
  if (Ga) return fr;
  Ga = 1;
  var t = xt;
  function e(h, d) {
    return h === d && (h !== 0 || 1 / h === 1 / d) || h !== h && d !== d;
  }
  var n = typeof Object.is == "function" ? Object.is : e, i = t.useState, s = t.useEffect, r = t.useLayoutEffect, o = t.useDebugValue;
  function l(h, d) {
    var m = d(), p = i({ inst: { value: m, getSnapshot: d } }), g = p[0].inst, A = p[1];
    return r(
      function() {
        g.value = m, g.getSnapshot = d, a(g) && A({ inst: g });
      },
      [h, m, d]
    ), s(
      function() {
        return a(g) && A({ inst: g }), h(function() {
          a(g) && A({ inst: g });
        });
      },
      [h]
    ), o(m), m;
  }
  function a(h) {
    var d = h.getSnapshot;
    h = h.value;
    try {
      var m = d();
      return !n(h, m);
    } catch {
      return !0;
    }
  }
  function c(h, d) {
    return d();
  }
  var u = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? c : l;
  return fr.useSyncExternalStore = t.useSyncExternalStore !== void 0 ? t.useSyncExternalStore : u, fr;
}
var Xa;
function D3() {
  return Xa || (Xa = 1, gr.exports = O3()), gr.exports;
}
var P3 = D3();
const br = (t, e) => (n) => {
  t.current !== n && (t.current = n, e());
};
function _3(t, { keys: e, deps: n = [t, e] } = {}) {
  const i = xt.useRef();
  i.current = t.get();
  const s = xt.useCallback((o) => (br(i, o)(t.value), e?.length > 0 ? K3(t, e, br(i, o)) : t.listen(br(i, o))), n), r = () => i.current;
  return xt.useSyncExternalStore ? xt.useSyncExternalStore(s, r, r) : P3.useSyncExternalStore(s, r, r);
}
const He = _3, j3 = () => [
  !1,
  (t) => {
    window.requestAnimationFrame(() => t());
  }
];
xt.useTransition;
var $3 = function() {
  const e = Array.prototype.slice.call(arguments).filter(Boolean), n = {}, i = [];
  e.forEach((r) => {
    (r ? r.split(" ") : []).forEach((l) => {
      if (l.startsWith("atm_")) {
        const [, a] = l.split("_");
        n[a] = l;
      } else
        i.push(l);
    });
  });
  const s = [];
  for (const r in n)
    Object.prototype.hasOwnProperty.call(n, r) && s.push(n[r]);
  return s.push(...i), s.join(" ");
}, Oe = $3;
const q3 = {
  BLUE_QUESTION_ACTION_BTN: "#1589ee",
  WHITE: "#FFFFFF",
  BLUE: "#2d6ffd",
  GREY_PRIMARY: "#909395",
  GREY_PRIMARY_ONBOARDING_INAPP: "#B5B7B8",
  PRIMARY_1: "#1D7BFF",
  // main
  PRIMARY_2: "#095CD1",
  // hover, active, ...etc (darken 10%)
  PRIMARY_TEXT: "#090E13",
  SECONDARY_TEXT: "rgba(10, 14, 19, 0.70)",
  QUESTION_TYPE_ICON: "#1D7BFF",
  QUESTION_BODY_TEXT: "#090E13",
  PRESENTED_BY_TEXT: "#090E13",
  SUCCESS: "#107D57",
  UNSUCCESS: "#DF2F3B",
  SECONDARY_RED1: "#DF2F3B",
  NEUTRALS_WHITE: "#FFFFFF",
  NEUTRALS_WHITE1: "#FFFFFF",
  NEUTRALS_GRAY1: "#F7F7F7",
  NEUTRALS_GRAY2: "#F2F2F1",
  NEUTRALS_GRAY3: "#E8E8E8",
  NEUTRALS_GRAY4: "#D9D9D6",
  NEUTRALS_GRAY5: "#B1B3B3",
  NEUTRALS_GRAY6: "#888B8D",
  NEUTRALS_GRAY7: "#6B6F73",
  NEUTRALS_GRAY9: "#25282A",
  SDK_CONTAINER_BG: "#F7F7F7",
  SDK_WHITE_CONTAINER_BG: "#fff",
  SDK_DARK_CONTAINER_BG: "#fff",
  SDK_PREDICTION_RESULT_SUCCESS_BG: "#fff",
  SDK_PREDICTION_RESULT_INCORRECT_BG: "#fff",
  SDK_PREDICTION_RESULT_SUCCESS_TEXT: "#107D57",
  SDK_PREDICTION_RESULT_ERROR_TITLE: "#090E13",
  SDK_PREDICTION_RESULT_ERROR_SUBTITLE: "#DF2F3B",
  SDK_PREDICTION_RESULT_CLOSE_ICON: "#6B6F73",
  SDK_PREDICTION_FEEDBACK_SUCCESS_ICON: "#107D57",
  SDK_PREDICTION_FEEDBACK_INCORRECT_RECT1: "#CD2525",
  SDK_PREDICTION_FEEDBACK_INCORRECT_RECT2: "#fff",
  PREDICTION_BG_LINES_CORRECT: "#01AB58",
  PREDICTION_BG_LINES_INCORRECT: "#888B8D",
  SKELETON_COLOR_1: "#f1efef",
  SKELETON_COLOR_2: "#f9f8f8",
  TABS_CONTAINER_BG: "#F2F2F1",
  TABS_ACTIVE_BG: "#FFFFFF",
  TABS_COLOR: "#6B6F73",
  TABS_ACTIVE_COLOR: "#1D7BFF",
  CARD_BG: "#FFFFFF",
  CARD_BORDER: "#fff",
  BORDER: "#E8E8E8",
  VOTE_BTN_BG: "#F7F7F7",
  VOTE_BTN_BORDER: "rgb(232, 232, 232)",
  VOTE_BTN_DISABLED_BORDER: "#B1B3B3",
  VOTE_BTN_SELECTED_BORDER: "#25282A",
  VOTE_BTN_NOT_SELECTED_BORDER: "#E8E8E8",
  VOTE_BTN_SELECTED_BG: "#FFFFFF",
  VOTE_BTN_SELECTED_BG_AD_UNIT: "#FFFFFF",
  VOTE_BTN_NOT_SELECTED_BG: "#FFFFFF",
  VOTE_BTN_NOT_SELECTED_BG_UNSET: "rgb(196, 196, 196)",
  VOTED_ANSWER_BG: "#FFFFFF",
  VOTED_BTN_RCT_BG: "#2d5694",
  IN_APP_BG: "rgba(255, 255, 255, 0.90)",
  IN_APP_QUESTION_TYPE_ICON: "#1D7BFF",
  IN_APP_QUESTION_TYPE_LABEL: "#82899E",
  IN_APP_QUESTION_QUOTE: "rgba(10, 14, 19, 0.70)",
  IN_APP_QUESTION_RESULT_SUBTITLE_BG: "#1D7BFF",
  IN_APP_QUESTION_RESULT_LINE: "#babfc5",
  QUOTE_BORDER: "#E8E8E8",
  QUOTE_TEXT: "rgba(10, 14, 19, 0.70)"
}, e5 = {
  BG_PRIMARY: "#13212b",
  BG_SECONDARY: "#152430",
  BG_SECONDARY1: "#435059",
  BORDER_PRIMARY: "rgba(255, 255, 255, 0.1)",
  TEXT_PRIMARY: "#f9f9f9",
  TEXT_PRIMARY1: "#f9f9f9",
  TEXT_SECONDARY: "rgba(255, 255, 255, 0.8)",
  TEXT_SECONDARY1: "#878787",
  WHITE: "#fff"
}, t5 = ["#107D57", "#DF2F3B", "#DF2F3B", "#E8E8E8"], n5 = "#cee5de", i5 = "#f9d6d8", s5 = "#E8E8E8", r5 = {
  xl: 1200
};
Object.entries(q3).reduce((t, [e, n]) => `
    ${t}
    --color-${e.toLowerCase().replaceAll("_", "-")}: ${n};
  `, "");
Object.entries(e5).reduce((t, [e, n]) => `
    ${t}
    --color-adv-${e.toLowerCase().replaceAll("_", "-")}: ${n};
  `, "");
const o5 = "ttkj0ah", Fl = ({ children: t, customTheme: e, themeMode: n, style: i }) => /* @__PURE__ */ f("div", { className: "StreamLayerSDKTheme", children: /* @__PURE__ */ f("div", { className: Oe(o5, n, e), style: i, children: t }) });
function l5(t) {
  var e = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return e[n] === void 0 && (e[n] = t(n)), e[n];
  };
}
var a5 = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, Ar = /* @__PURE__ */ l5(
  function(t) {
    return a5.test(t) || t.charCodeAt(0) === 111 && t.charCodeAt(1) === 110 && t.charCodeAt(2) < 91;
  }
  /* Z+1 */
), c5 = (t) => t.toUpperCase() === t, u5 = (t) => (e) => t.indexOf(e) === -1, Vd = (t, e) => {
  const n = {};
  return Object.keys(t).filter(u5(e)).forEach((i) => {
    n[i] = t[i];
  }), n;
};
function h5(t, e, n) {
  const i = Vd(e, n);
  if (!t) {
    const s = typeof Ar == "function" ? { default: Ar } : Ar;
    Object.keys(i).forEach((r) => {
      s.default(r) || delete i[r];
    });
  }
  return i;
}
var d5 = (t, e) => {
};
function m5(t) {
  let e = "";
  return (n) => {
    const i = (r, o) => {
      const { as: l = t, class: a = e } = r, c = n.propsAsIs === void 0 ? !(typeof l == "string" && l.indexOf("-") === -1 && !c5(l[0])) : n.propsAsIs, u = h5(c, r, [
        "as",
        "class"
      ]);
      u.ref = o, u.className = n.atomic ? Oe(n.class, u.className || a) : Oe(u.className || a, n.class);
      const { vars: h } = n;
      if (h) {
        const d = {};
        for (const g in h) {
          const A = h[g], b = A[0], R = A[1] || "", S = typeof b == "function" ? b(r) : b;
          d5(S, n.name), d[`--${g}`] = `${S}${R}`;
        }
        const m = u.style || {}, p = Object.keys(m);
        p.length > 0 && p.forEach((g) => {
          d[g] = m[g];
        }), u.style = d;
      }
      return t.__wyw_meta && t !== l ? (u.as = l, Ia(t, u)) : Ia(l, u);
    }, s = Ii ? Ii(i) : (
      // React.forwardRef won't available on older React versions and in Preact
      // Fallback to a innerRef prop in that case
      ((r) => {
        const o = Vd(r, ["innerRef"]);
        return i(o, r.innerRef);
      })
    );
    return s.displayName = n.name, s.__wyw_meta = {
      className: n.class || e,
      extends: t
    }, s;
  };
}
var V = m5;
const p5 = /* @__PURE__ */ V("div")({
  name: "Container",
  class: "c6rz41d",
  propsAsIs: !1
}), g5 = /* @__PURE__ */ V("div")({
  name: "ContentContainer",
  class: "clv6awu",
  propsAsIs: !1
}), f5 = /* @__PURE__ */ V("div")({
  name: "Sidebar",
  class: "ssfv9z7",
  propsAsIs: !1
}), b5 = /* @__PURE__ */ V("div")({
  name: "SideBarOverlay",
  class: "sweyrp8",
  propsAsIs: !1
}), A5 = /* @__PURE__ */ V("div")({
  name: "Banner",
  class: "b5w8mb1",
  propsAsIs: !1
}), V5 = /* @__PURE__ */ V("div")({
  name: "VideoContainer",
  class: "v1uhtlpt",
  propsAsIs: !1
}), R5 = /* @__PURE__ */ V("div")({
  name: "VideoBox",
  class: "v7viet2",
  propsAsIs: !1
}), E5 = /* @__PURE__ */ V("div")({
  name: "VideoPlayer",
  class: "v9y7cje",
  propsAsIs: !1
}), y5 = /* @__PURE__ */ V("div")({
  name: "Overlay",
  class: "opmmtyi",
  propsAsIs: !1
}), C5 = /* @__PURE__ */ V("div")({
  name: "Notification",
  class: "nk5geky",
  propsAsIs: !1
}), W5 = () => {
  const [t, e] = re("desktop");
  return te(() => {
    const n = T3(() => {
      const i = window.innerWidth, s = window.innerHeight, r = i > s ? "landscape" : "portrait";
      e(i < 1024 && r === "portrait" ? "mobile" : "desktop");
    }, 200);
    return window.addEventListener("resize", n), () => {
      window.removeEventListener("resize", n);
    };
  }, []), t;
}, Ua = ({ delay: t, children: e }) => {
  const n = Ee(null), [i, s] = re(!1);
  return te(() => (n.current && clearTimeout(n.current), n.current = setTimeout(() => s(!0), t), () => {
    n.current && clearTimeout(n.current);
  }), [t]), i ? e : null;
}, S5 = Ii(function({ sdk: t, sidebar: e, overlay: n, notification: i, banner: s, children: r, webos: o }, l) {
  const a = He(t.uiState), { containerId: c } = He(t.options), u = Ee(null), h = Ee(null), d = Ue(() => {
    if (!h.current || !u.current)
      return;
    const { width: S, height: E } = h.current.getBoundingClientRect(), { width: Z, height: G } = u.current.getBoundingClientRect();
    (S > Z || E > G) && (h.current.style.width === "100%" ? (h.current.style.height = "100%", h.current.style.width = "auto") : (h.current.style.width = "100%", h.current.style.height = "auto"));
  }, []);
  te(() => {
    const S = u.current;
    if (S) {
      const E = new ResizeObserver((Z) => {
        for (const G of Z)
          G.contentBoxSize && d();
      });
      return E.observe(S), () => {
        E.disconnect();
      };
    }
    return () => {
    };
  }, [d]), te(d);
  const m = W5(), p = a.exposedPauseAd, g = !p && (a.promotionSidebar || a.app || a.appSidebar || a.polymarket), A = !p && a.promotionOverlay, b = !p && (a.promotionBanner || a.appBanner), R = !p && (a.promotionNotification || a.onboardingNotification || a.appNotification);
  return /* @__PURE__ */ U(
    p5,
    {
      id: c || "SlLayoutContainer",
      className: Oe("Container", o && "SL-ContainerWebOs"),
      ref: l,
      children: [
        /* @__PURE__ */ U(
          g5,
          {
            className: "ContentContainer",
            style: {
              width: g ? `calc(100% - var(${o ? "--sidebar-width-webos" : "--sidebar-width"}))` : "100%"
            },
            children: [
              /* @__PURE__ */ f(
                V5,
                {
                  className: Oe("VideoContainer", g && "WithSidebar", b && "WithBanner"),
                  ref: u,
                  style: {
                    height: b ? `calc(100% - var(${o ? "--banner-height-webos" : "--banner-height"}))` : "100%"
                  },
                  children: /* @__PURE__ */ f(R5, { ref: h, className: "VideoBox", children: /* @__PURE__ */ f(E5, { className: "VideoPlayer", children: r }) })
                }
              ),
              /* @__PURE__ */ f(
                A5,
                {
                  className: "Banner",
                  style: {
                    height: b ? `var(${o ? "--banner-height-webos" : "--banner-height"})` : "0px",
                    padding: b ? `var(${o ? "--banner-padding-webos" : "--banner-padding"})` : "0px"
                  },
                  children: b && s
                }
              ),
              R && /* @__PURE__ */ f(Ua, { delay: o ? 1e3 : 0, children: /* @__PURE__ */ f(C5, { children: typeof i == "function" ? i({ promo: !!a.promotionNotification, app: !!a.appNotification }) : i }) }),
              A && m === "desktop" && /* @__PURE__ */ f(y5, { className: "Overlay", children: n })
            ]
          }
        ),
        m === "desktop" && /* @__PURE__ */ f(Ua, { delay: o ? 1e3 : 0, children: /* @__PURE__ */ f(
          f5,
          {
            style: {
              width: g ? `var(${o ? "--sidebar-width-webos" : "--sidebar-width"})` : "0px",
              ...o ? { height: "100%" } : {}
            },
            className: "Sidebar",
            children: g && (typeof e == "function" ? e({ promo: !!a.promotionSidebar, app: !!a.appSidebar }) : e)
          }
        ) }),
        (g || A) && m === "mobile" && /* @__PURE__ */ f(b5, { className: "Demo-SideBarOverlay", children: n })
      ]
    }
  );
}), Ba = globalThis || void 0 || self;
var mi = { exports: {} }, Vr, wa;
function Z5() {
  if (wa) return Vr;
  wa = 1;
  function t(n) {
    try {
      return JSON.stringify(n);
    } catch {
      return '"[Circular]"';
    }
  }
  Vr = e;
  function e(n, i, s) {
    var r = s && s.stringify || t, o = 1;
    if (typeof n == "object" && n !== null) {
      var l = i.length + o;
      if (l === 1) return n;
      var a = new Array(l);
      a[0] = r(n);
      for (var c = 1; c < l; c++)
        a[c] = r(i[c]);
      return a.join(" ");
    }
    if (typeof n != "string")
      return n;
    var u = i.length;
    if (u === 0) return n;
    for (var h = "", d = 1 - o, m = -1, p = n && n.length || 0, g = 0; g < p; ) {
      if (n.charCodeAt(g) === 37 && g + 1 < p) {
        switch (m = m > -1 ? m : 0, n.charCodeAt(g + 1)) {
          case 100:
          // 'd'
          case 102:
            if (d >= u || i[d] == null) break;
            m < g && (h += n.slice(m, g)), h += Number(i[d]), m = g + 2, g++;
            break;
          case 105:
            if (d >= u || i[d] == null) break;
            m < g && (h += n.slice(m, g)), h += Math.floor(Number(i[d])), m = g + 2, g++;
            break;
          case 79:
          // 'O'
          case 111:
          // 'o'
          case 106:
            if (d >= u || i[d] === void 0) break;
            m < g && (h += n.slice(m, g));
            var A = typeof i[d];
            if (A === "string") {
              h += "'" + i[d] + "'", m = g + 2, g++;
              break;
            }
            if (A === "function") {
              h += i[d].name || "<anonymous>", m = g + 2, g++;
              break;
            }
            h += r(i[d]), m = g + 2, g++;
            break;
          case 115:
            if (d >= u)
              break;
            m < g && (h += n.slice(m, g)), h += String(i[d]), m = g + 2, g++;
            break;
          case 37:
            m < g && (h += n.slice(m, g)), h += "%", m = g + 2, g++, d--;
            break;
        }
        ++d;
      }
      ++g;
    }
    return m === -1 ? n : (m < p && (h += n.slice(m)), h);
  }
  return Vr;
}
var Ya;
function v5() {
  if (Ya) return mi.exports;
  Ya = 1;
  const t = Z5();
  mi.exports = u;
  const e = ie().console || {}, n = {
    mapHttpRequest: T,
    mapHttpResponse: T,
    wrapRequestSerializer: C,
    wrapResponseSerializer: C,
    wrapErrorSerializer: C,
    req: T,
    res: T,
    err: Z,
    errWithCause: Z
  };
  function i(X, Q) {
    return X === "silent" ? 1 / 0 : Q.levels.values[X];
  }
  const s = /* @__PURE__ */ Symbol("pino.logFuncs"), r = /* @__PURE__ */ Symbol("pino.hierarchy"), o = {
    error: "log",
    fatal: "error",
    warn: "error",
    info: "log",
    debug: "log",
    trace: "log"
  };
  function l(X, Q) {
    const J = {
      logger: Q,
      parent: X[r]
    };
    Q[r] = J;
  }
  function a(X, Q, J) {
    const q = {};
    Q.forEach((k) => {
      q[k] = J[k] ? J[k] : e[k] || e[o[k] || "log"] || N;
    }), X[s] = q;
  }
  function c(X, Q) {
    return Array.isArray(X) ? X.filter(function(q) {
      return q !== "!stdSerializers.err";
    }) : X === !0 ? Object.keys(Q) : !1;
  }
  function u(X) {
    X = X || {}, X.browser = X.browser || {};
    const Q = X.browser.transmit;
    if (Q && typeof Q.send != "function")
      throw Error("pino: transmit option must have a send function");
    const J = X.browser.write || e;
    X.browser.write && (X.browser.asObject = !0);
    const q = X.serializers || {}, k = c(X.browser.serialize, q);
    let O = X.browser.serialize;
    Array.isArray(X.browser.serialize) && X.browser.serialize.indexOf("!stdSerializers.err") > -1 && (O = !1);
    const ee = Object.keys(X.customLevels || {}), W = ["error", "fatal", "warn", "info", "debug", "trace"].concat(ee);
    typeof J == "function" && W.forEach(function(P) {
      J[P] = J;
    }), (X.enabled === !1 || X.browser.disabled) && (X.level = "silent");
    const v = X.level || "info", F = Object.create(J);
    F.log || (F.log = N), a(F, W, J), l({}, F), Object.defineProperty(F, "levelVal", {
      get: _
    }), Object.defineProperty(F, "level", {
      get: $,
      set: j
    });
    const K = {
      transmit: Q,
      serialize: k,
      asObject: X.browser.asObject,
      formatters: X.browser.formatters,
      levels: W,
      timestamp: G(X),
      messageKey: X.messageKey || "msg",
      onChild: X.onChild || N
    };
    F.levels = h(X), F.level = v, F.setMaxListeners = F.getMaxListeners = F.emit = F.addListener = F.on = F.prependListener = F.once = F.prependOnceListener = F.removeListener = F.removeAllListeners = F.listeners = F.listenerCount = F.eventNames = F.write = F.flush = N, F.serializers = q, F._serialize = k, F._stdErrSerialize = O, F.child = function(...P) {
      return z.call(this, K, ...P);
    }, Q && (F._logEvent = E());
    function _() {
      return i(this.level, this);
    }
    function $() {
      return this._level;
    }
    function j(P) {
      if (P !== "silent" && !this.levels.values[P])
        throw Error("unknown level " + P);
      this._level = P, p(this, K, F, "error"), p(this, K, F, "fatal"), p(this, K, F, "warn"), p(this, K, F, "info"), p(this, K, F, "debug"), p(this, K, F, "trace"), ee.forEach((ne) => {
        p(this, K, F, ne);
      });
    }
    function z(P, ne, le) {
      if (!ne)
        throw new Error("missing bindings for child Pino");
      le = le || {}, k && ne.serializers && (le.serializers = ne.serializers);
      const Ce = le.serializers;
      if (k && Ce) {
        var ue = Object.assign({}, q, Ce), ye = X.browser.serialize === !0 ? Object.keys(ue) : k;
        delete ne.serializers, R([ne], ye, ue, this._stdErrSerialize);
      }
      function Qe(dt) {
        this._childLevel = (dt._childLevel | 0) + 1, this.bindings = ne, ue && (this.serializers = ue, this._serialize = ye), Q && (this._logEvent = E(
          [].concat(dt._logEvent.bindings, ne)
        ));
      }
      Qe.prototype = this;
      const qe = new Qe(this);
      return l(this, qe), qe.child = function(...dt) {
        return z.call(this, P, ...dt);
      }, qe.level = le.level || this.level, P.onChild(qe), qe;
    }
    return F;
  }
  function h(X) {
    const Q = X.customLevels || {}, J = Object.assign({}, u.levels.values, Q), q = Object.assign({}, u.levels.labels, d(Q));
    return {
      values: J,
      labels: q
    };
  }
  function d(X) {
    const Q = {};
    return Object.keys(X).forEach(function(J) {
      Q[X[J]] = J;
    }), Q;
  }
  u.levels = {
    values: {
      fatal: 60,
      error: 50,
      warn: 40,
      info: 30,
      debug: 20,
      trace: 10
    },
    labels: {
      10: "trace",
      20: "debug",
      30: "info",
      40: "warn",
      50: "error",
      60: "fatal"
    }
  }, u.stdSerializers = n, u.stdTimeFunctions = Object.assign({}, { nullTime: Y, epochTime: L, unixTime: w, isoTime: D });
  function m(X) {
    const Q = [];
    X.bindings && Q.push(X.bindings);
    let J = X[r];
    for (; J.parent; )
      J = J.parent, J.logger.bindings && Q.push(J.logger.bindings);
    return Q.reverse();
  }
  function p(X, Q, J, q) {
    if (Object.defineProperty(X, q, {
      value: i(X.level, J) > i(q, J) ? N : J[s][q],
      writable: !0,
      enumerable: !0,
      configurable: !0
    }), X[q] === N) {
      if (!Q.transmit) return;
      const O = Q.transmit.level || X.level, ee = J.levels.values[O];
      if (J.levels.values[q] < ee) return;
    }
    X[q] = A(X, Q, J, q);
    const k = m(X);
    k.length !== 0 && (X[q] = g(k, X[q]));
  }
  function g(X, Q) {
    return function() {
      return Q.apply(this, [...X, ...arguments]);
    };
  }
  function A(X, Q, J, q) {
    return /* @__PURE__ */ (function(k) {
      return function() {
        const ee = Q.timestamp(), W = new Array(arguments.length), v = Object.getPrototypeOf && Object.getPrototypeOf(this) === e ? e : this;
        for (var F = 0; F < W.length; F++) W[F] = arguments[F];
        var K = !1;
        if (Q.serialize && (R(W, this._serialize, this.serializers, this._stdErrSerialize), K = !0), Q.asObject || Q.formatters ? k.call(v, b(this, q, W, ee, Q)) : k.apply(v, W), Q.transmit) {
          const _ = Q.transmit.level || X._level, $ = J.levels.values[_], j = J.levels.values[q];
          if (j < $) return;
          S(this, {
            ts: ee,
            methodLevel: q,
            methodValue: j,
            transmitValue: J.levels.values[Q.transmit.level || X._level],
            send: Q.transmit.send,
            val: i(X._level, J)
          }, W, K);
        }
      };
    })(X[s][q]);
  }
  function b(X, Q, J, q, k) {
    const {
      level: O,
      log: ee = ($) => $
    } = k.formatters || {}, W = J.slice();
    let v = W[0];
    const F = {};
    if (q && (F.time = q), O) {
      const $ = O(Q, X.levels.values[Q]);
      Object.assign(F, $);
    } else
      F.level = X.levels.values[Q];
    let K = (X._childLevel | 0) + 1;
    if (K < 1 && (K = 1), v !== null && typeof v == "object") {
      for (; K-- && typeof W[0] == "object"; )
        Object.assign(F, W.shift());
      v = W.length ? t(W.shift(), W) : void 0;
    } else typeof v == "string" && (v = t(W.shift(), W));
    return v !== void 0 && (F[k.messageKey] = v), ee(F);
  }
  function R(X, Q, J, q) {
    for (const k in X)
      if (q && X[k] instanceof Error)
        X[k] = u.stdSerializers.err(X[k]);
      else if (typeof X[k] == "object" && !Array.isArray(X[k]) && Q)
        for (const O in X[k])
          Q.indexOf(O) > -1 && O in J && (X[k][O] = J[O](X[k][O]));
  }
  function S(X, Q, J, q = !1) {
    const k = Q.send, O = Q.ts, ee = Q.methodLevel, W = Q.methodValue, v = Q.val, F = X._logEvent.bindings;
    q || R(
      J,
      X._serialize || Object.keys(X.serializers),
      X.serializers,
      X._stdErrSerialize === void 0 ? !0 : X._stdErrSerialize
    ), X._logEvent.ts = O, X._logEvent.messages = J.filter(function(K) {
      return F.indexOf(K) === -1;
    }), X._logEvent.level.label = ee, X._logEvent.level.value = W, k(ee, X._logEvent, v), X._logEvent = E(F);
  }
  function E(X) {
    return {
      ts: 0,
      messages: [],
      bindings: X || [],
      level: { label: "", value: 0 }
    };
  }
  function Z(X) {
    const Q = {
      type: X.constructor.name,
      msg: X.message,
      stack: X.stack
    };
    for (const J in X)
      Q[J] === void 0 && (Q[J] = X[J]);
    return Q;
  }
  function G(X) {
    return typeof X.timestamp == "function" ? X.timestamp : X.timestamp === !1 ? Y : L;
  }
  function T() {
    return {};
  }
  function C(X) {
    return X;
  }
  function N() {
  }
  function Y() {
    return !1;
  }
  function L() {
    return Date.now();
  }
  function w() {
    return Math.round(Date.now() / 1e3);
  }
  function D() {
    return new Date(Date.now()).toISOString();
  }
  function ie() {
    function X(Q) {
      return typeof Q < "u" && Q;
    }
    try {
      return typeof globalThis < "u" || Object.defineProperty(Object.prototype, "globalThis", {
        get: function() {
          return delete Object.prototype.globalThis, this.globalThis = this;
        },
        configurable: !0
      }), globalThis;
    } catch {
      return X(self) || X(window) || X(this) || {};
    }
  }
  return mi.exports.default = u, mi.exports.pino = u, mi.exports;
}
var Rd = v5();
function Ni(t) {
  let e = !1;
  const n = [];
  for (let i = 0; i < t.length; i++) {
    let s = t.charAt(i);
    switch (s) {
      case "_":
        e = !0;
        break;
      case "0":
      case "1":
      case "2":
      case "3":
      case "4":
      case "5":
      case "6":
      case "7":
      case "8":
      case "9":
        n.push(s), e = !1;
        break;
      default:
        e && (e = !1, s = s.toUpperCase()), n.push(s);
        break;
    }
  }
  return n.join("");
}
const I5 = /* @__PURE__ */ new Set([
  // names reserved by JavaScript
  "constructor",
  "toString",
  "toJSON",
  "valueOf"
]);
function Fi(t) {
  return I5.has(t) ? t + "$" : t;
}
function N5(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var Ed = { exports: {} }, Te = Ed.exports = {}, Wt, St;
function jo() {
  throw new Error("setTimeout has not been defined");
}
function $o() {
  throw new Error("clearTimeout has not been defined");
}
(function() {
  try {
    typeof setTimeout == "function" ? Wt = setTimeout : Wt = jo;
  } catch {
    Wt = jo;
  }
  try {
    typeof clearTimeout == "function" ? St = clearTimeout : St = $o;
  } catch {
    St = $o;
  }
})();
function yd(t) {
  if (Wt === setTimeout)
    return setTimeout(t, 0);
  if ((Wt === jo || !Wt) && setTimeout)
    return Wt = setTimeout, setTimeout(t, 0);
  try {
    return Wt(t, 0);
  } catch {
    try {
      return Wt.call(null, t, 0);
    } catch {
      return Wt.call(this, t, 0);
    }
  }
}
function F5(t) {
  if (St === clearTimeout)
    return clearTimeout(t);
  if ((St === $o || !St) && clearTimeout)
    return St = clearTimeout, clearTimeout(t);
  try {
    return St(t);
  } catch {
    try {
      return St.call(null, t);
    } catch {
      return St.call(this, t);
    }
  }
}
var Mt = [], Pn = !1, An, Vs = -1;
function G5() {
  !Pn || !An || (Pn = !1, An.length ? Mt = An.concat(Mt) : Vs = -1, Mt.length && Cd());
}
function Cd() {
  if (!Pn) {
    var t = yd(G5);
    Pn = !0;
    for (var e = Mt.length; e; ) {
      for (An = Mt, Mt = []; ++Vs < e; )
        An && An[Vs].run();
      Vs = -1, e = Mt.length;
    }
    An = null, Pn = !1, F5(t);
  }
}
Te.nextTick = function(t) {
  var e = new Array(arguments.length - 1);
  if (arguments.length > 1)
    for (var n = 1; n < arguments.length; n++)
      e[n - 1] = arguments[n];
  Mt.push(new Wd(t, e)), Mt.length === 1 && !Pn && yd(Cd);
};
function Wd(t, e) {
  this.fun = t, this.array = e;
}
Wd.prototype.run = function() {
  this.fun.apply(null, this.array);
};
Te.title = "browser";
Te.browser = !0;
Te.env = {};
Te.argv = [];
Te.version = "";
Te.versions = {};
function _t() {
}
Te.on = _t;
Te.addListener = _t;
Te.once = _t;
Te.off = _t;
Te.removeListener = _t;
Te.removeAllListeners = _t;
Te.emit = _t;
Te.prependListener = _t;
Te.prependOnceListener = _t;
Te.listeners = function(t) {
  return [];
};
Te.binding = function(t) {
  throw new Error("process.binding is not supported");
};
Te.cwd = function() {
  return "/";
};
Te.chdir = function(t) {
  throw new Error("process.chdir is not supported");
};
Te.umask = function() {
  return 0;
};
var X5 = Ed.exports;
const Ta = /* @__PURE__ */ N5(X5);
function U5() {
  let t = 0, e = 0;
  for (let i = 0; i < 28; i += 7) {
    let s = this.buf[this.pos++];
    if (t |= (s & 127) << i, (s & 128) == 0)
      return this.assertBounds(), [t, e];
  }
  let n = this.buf[this.pos++];
  if (t |= (n & 15) << 28, e = (n & 112) >> 4, (n & 128) == 0)
    return this.assertBounds(), [t, e];
  for (let i = 3; i <= 31; i += 7) {
    let s = this.buf[this.pos++];
    if (e |= (s & 127) << i, (s & 128) == 0)
      return this.assertBounds(), [t, e];
  }
  throw new Error("invalid varint");
}
function Rr(t, e, n) {
  for (let r = 0; r < 28; r = r + 7) {
    const o = t >>> r, l = !(!(o >>> 7) && e == 0), a = (l ? o | 128 : o) & 255;
    if (n.push(a), !l)
      return;
  }
  const i = t >>> 28 & 15 | (e & 7) << 4, s = e >> 3 != 0;
  if (n.push((s ? i | 128 : i) & 255), !!s) {
    for (let r = 3; r < 31; r = r + 7) {
      const o = e >>> r, l = !!(o >>> 7), a = (l ? o | 128 : o) & 255;
      if (n.push(a), !l)
        return;
    }
    n.push(e >>> 31 & 1);
  }
}
const Rs = 4294967296;
function La(t) {
  const e = t[0] === "-";
  e && (t = t.slice(1));
  const n = 1e6;
  let i = 0, s = 0;
  function r(o, l) {
    const a = Number(t.slice(o, l));
    s *= n, i = i * n + a, i >= Rs && (s = s + (i / Rs | 0), i = i % Rs);
  }
  return r(-24, -18), r(-18, -12), r(-12, -6), r(-6), e ? Zd(i, s) : Gl(i, s);
}
function B5(t, e) {
  let n = Gl(t, e);
  const i = n.hi & 2147483648;
  i && (n = Zd(n.lo, n.hi));
  const s = Sd(n.lo, n.hi);
  return i ? "-" + s : s;
}
function Sd(t, e) {
  if ({ lo: t, hi: e } = w5(t, e), e <= 2097151)
    return String(Rs * e + t);
  const n = t & 16777215, i = (t >>> 24 | e << 8) & 16777215, s = e >> 16 & 65535;
  let r = n + i * 6777216 + s * 6710656, o = i + s * 8147497, l = s * 2;
  const a = 1e7;
  return r >= a && (o += Math.floor(r / a), r %= a), o >= a && (l += Math.floor(o / a), o %= a), l.toString() + ka(o) + ka(r);
}
function w5(t, e) {
  return { lo: t >>> 0, hi: e >>> 0 };
}
function Gl(t, e) {
  return { lo: t | 0, hi: e | 0 };
}
function Zd(t, e) {
  return e = ~e, t ? t = ~t + 1 : e += 1, Gl(t, e);
}
const ka = (t) => {
  const e = String(t);
  return "0000000".slice(e.length) + e;
};
function Ja(t, e) {
  if (t >= 0) {
    for (; t > 127; )
      e.push(t & 127 | 128), t = t >>> 7;
    e.push(t);
  } else {
    for (let n = 0; n < 9; n++)
      e.push(t & 127 | 128), t = t >> 7;
    e.push(1);
  }
}
function Y5() {
  let t = this.buf[this.pos++], e = t & 127;
  if ((t & 128) == 0)
    return this.assertBounds(), e;
  if (t = this.buf[this.pos++], e |= (t & 127) << 7, (t & 128) == 0)
    return this.assertBounds(), e;
  if (t = this.buf[this.pos++], e |= (t & 127) << 14, (t & 128) == 0)
    return this.assertBounds(), e;
  if (t = this.buf[this.pos++], e |= (t & 127) << 21, (t & 128) == 0)
    return this.assertBounds(), e;
  t = this.buf[this.pos++], e |= (t & 15) << 28;
  for (let n = 5; (t & 128) !== 0 && n < 10; n++)
    t = this.buf[this.pos++];
  if ((t & 128) != 0)
    throw new Error("invalid varint");
  return this.assertBounds(), e >>> 0;
}
const Ze = /* @__PURE__ */ T5();
function T5() {
  const t = new DataView(new ArrayBuffer(8));
  if (typeof BigInt == "function" && typeof t.getBigInt64 == "function" && typeof t.getBigUint64 == "function" && typeof t.setBigInt64 == "function" && typeof t.setBigUint64 == "function" && (typeof Ta != "object" || typeof Ta.env != "object" || !1)) {
    const n = BigInt("-9223372036854775808"), i = BigInt("9223372036854775807"), s = BigInt("0"), r = BigInt("18446744073709551615");
    return {
      zero: BigInt(0),
      supported: !0,
      parse(o) {
        const l = typeof o == "bigint" ? o : BigInt(o);
        if (l > i || l < n)
          throw new Error(`invalid int64: ${o}`);
        return l;
      },
      uParse(o) {
        const l = typeof o == "bigint" ? o : BigInt(o);
        if (l > r || l < s)
          throw new Error(`invalid uint64: ${o}`);
        return l;
      },
      enc(o) {
        return t.setBigInt64(0, this.parse(o), !0), {
          lo: t.getInt32(0, !0),
          hi: t.getInt32(4, !0)
        };
      },
      uEnc(o) {
        return t.setBigInt64(0, this.uParse(o), !0), {
          lo: t.getInt32(0, !0),
          hi: t.getInt32(4, !0)
        };
      },
      dec(o, l) {
        return t.setInt32(0, o, !0), t.setInt32(4, l, !0), t.getBigInt64(0, !0);
      },
      uDec(o, l) {
        return t.setInt32(0, o, !0), t.setInt32(4, l, !0), t.getBigUint64(0, !0);
      }
    };
  }
  return {
    zero: "0",
    supported: !1,
    parse(n) {
      return typeof n != "string" && (n = n.toString()), xa(n), n;
    },
    uParse(n) {
      return typeof n != "string" && (n = n.toString()), Ma(n), n;
    },
    enc(n) {
      return typeof n != "string" && (n = n.toString()), xa(n), La(n);
    },
    uEnc(n) {
      return typeof n != "string" && (n = n.toString()), Ma(n), La(n);
    },
    dec(n, i) {
      return B5(n, i);
    },
    uDec(n, i) {
      return Sd(n, i);
    }
  };
}
function xa(t) {
  if (!/^-?[0-9]+$/.test(t))
    throw new Error("invalid int64: " + t);
}
function Ma(t) {
  if (!/^[0-9]+$/.test(t))
    throw new Error("invalid uint64: " + t);
}
var I;
(function(t) {
  t[t.DOUBLE = 1] = "DOUBLE", t[t.FLOAT = 2] = "FLOAT", t[t.INT64 = 3] = "INT64", t[t.UINT64 = 4] = "UINT64", t[t.INT32 = 5] = "INT32", t[t.FIXED64 = 6] = "FIXED64", t[t.FIXED32 = 7] = "FIXED32", t[t.BOOL = 8] = "BOOL", t[t.STRING = 9] = "STRING", t[t.BYTES = 12] = "BYTES", t[t.UINT32 = 13] = "UINT32", t[t.SFIXED32 = 15] = "SFIXED32", t[t.SFIXED64 = 16] = "SFIXED64", t[t.SINT32 = 17] = "SINT32", t[t.SINT64 = 18] = "SINT64";
})(I || (I = {}));
function Wn(t, e) {
  switch (t) {
    case I.STRING:
      return "";
    case I.BOOL:
      return !1;
    default:
      return 0;
    case I.DOUBLE:
    case I.FLOAT:
      return 0;
    case I.INT64:
    case I.UINT64:
    case I.SFIXED64:
    case I.FIXED64:
    case I.SINT64:
      return e ? "0" : Ze.zero;
    case I.BYTES:
      return new Uint8Array(0);
  }
}
function L5(t, e) {
  switch (t) {
    case I.BOOL:
      return e === !1;
    case I.STRING:
      return e === "";
    case I.BYTES:
      return e instanceof Uint8Array && !e.byteLength;
    default:
      return e == 0;
  }
}
const vd = 2, Qt = /* @__PURE__ */ Symbol.for("reflect unsafe local");
function Id(t, e) {
  const n = t[e.localName].case;
  return n === void 0 ? n : e.fields.find((i) => i.localName === n);
}
function k5(t, e) {
  const n = e.localName;
  if (e.oneof)
    return t[e.oneof.localName].case === n;
  if (e.presence != vd)
    return t[n] !== void 0 && Object.prototype.hasOwnProperty.call(t, n);
  switch (e.fieldKind) {
    case "list":
      return t[n].length > 0;
    case "map":
      return Object.keys(t[n]).length > 0;
    // eslint-disable-line @typescript-eslint/no-unsafe-argument
    case "scalar":
      return !L5(e.scalar, t[n]);
    case "enum":
      return t[n] !== e.enum.values[0].number;
  }
  throw new Error("message field with implicit presence");
}
function Gi(t, e) {
  return Object.prototype.hasOwnProperty.call(t, e) && t[e] !== void 0;
}
function Nd(t, e) {
  if (e.oneof) {
    const n = t[e.oneof.localName];
    return n.case === e.localName ? n.value : void 0;
  }
  return t[e.localName];
}
function Fd(t, e, n) {
  e.oneof ? t[e.oneof.localName] = {
    case: e.localName,
    value: n
  } : t[e.localName] = n;
}
function J5(t, e) {
  const n = e.localName;
  if (e.oneof) {
    const i = e.oneof.localName;
    t[i].case === n && (t[i] = { case: void 0 });
  } else if (e.presence != vd)
    delete t[n];
  else
    switch (e.fieldKind) {
      case "map":
        t[n] = {};
        break;
      case "list":
        t[n] = [];
        break;
      case "enum":
        t[n] = e.enum.values[0].number;
        break;
      case "scalar":
        t[n] = Wn(e.scalar, e.longAsString);
        break;
    }
}
function Xl(t) {
  for (const e of t.field)
    Gi(e, "jsonName") || (e.jsonName = Ni(e.name));
  t.nestedType.forEach(Xl);
}
function x5(t, e) {
  const n = t.values.find((i) => i.name === e);
  if (!n)
    throw new Error(`cannot parse ${t} default value: ${e}`);
  return n.number;
}
function M5(t, e) {
  switch (t) {
    case I.STRING:
      return e;
    case I.BYTES: {
      const n = Q5(e);
      if (n === !1)
        throw new Error(`cannot parse ${I[t]} default value: ${e}`);
      return n;
    }
    case I.INT64:
    case I.SFIXED64:
    case I.SINT64:
      return Ze.parse(e);
    case I.UINT64:
    case I.FIXED64:
      return Ze.uParse(e);
    case I.DOUBLE:
    case I.FLOAT:
      switch (e) {
        case "inf":
          return Number.POSITIVE_INFINITY;
        case "-inf":
          return Number.NEGATIVE_INFINITY;
        case "nan":
          return Number.NaN;
        default:
          return parseFloat(e);
      }
    case I.BOOL:
      return e === "true";
    case I.INT32:
    case I.UINT32:
    case I.SINT32:
    case I.FIXED32:
    case I.SFIXED32:
      return parseInt(e, 10);
  }
}
function Q5(t) {
  const e = [], n = {
    tail: t,
    c: "",
    next() {
      return this.tail.length == 0 ? !1 : (this.c = this.tail[0], this.tail = this.tail.substring(1), !0);
    },
    take(i) {
      if (this.tail.length >= i) {
        const s = this.tail.substring(0, i);
        return this.tail = this.tail.substring(i), s;
      }
      return !1;
    }
  };
  for (; n.next(); )
    switch (n.c) {
      case "\\":
        if (n.next())
          switch (n.c) {
            case "\\":
              e.push(n.c.charCodeAt(0));
              break;
            case "b":
              e.push(8);
              break;
            case "f":
              e.push(12);
              break;
            case "n":
              e.push(10);
              break;
            case "r":
              e.push(13);
              break;
            case "t":
              e.push(9);
              break;
            case "v":
              e.push(11);
              break;
            case "0":
            case "1":
            case "2":
            case "3":
            case "4":
            case "5":
            case "6":
            case "7": {
              const i = n.c, s = n.take(2);
              if (s === !1)
                return !1;
              const r = parseInt(i + s, 8);
              if (isNaN(r))
                return !1;
              e.push(r);
              break;
            }
            case "x": {
              const i = n.c, s = n.take(2);
              if (s === !1)
                return !1;
              const r = parseInt(i + s, 16);
              if (isNaN(r))
                return !1;
              e.push(r);
              break;
            }
            case "u": {
              const i = n.c, s = n.take(4);
              if (s === !1)
                return !1;
              const r = parseInt(i + s, 16);
              if (isNaN(r))
                return !1;
              const o = new Uint8Array(4);
              new DataView(o.buffer).setInt32(0, r, !0), e.push(o[0], o[1], o[2], o[3]);
              break;
            }
            case "U": {
              const i = n.c, s = n.take(8);
              if (s === !1)
                return !1;
              const r = Ze.uEnc(i + s), o = new Uint8Array(8), l = new DataView(o.buffer);
              l.setInt32(0, r.lo, !0), l.setInt32(4, r.hi, !0), e.push(o[0], o[1], o[2], o[3], o[4], o[5], o[6], o[7]);
              break;
            }
          }
        break;
      default:
        e.push(n.c.charCodeAt(0));
    }
  return new Uint8Array(e);
}
function* qo(t) {
  switch (t.kind) {
    case "file":
      for (const e of t.messages)
        yield e, yield* qo(e);
      yield* t.enums, yield* t.services, yield* t.extensions;
      break;
    case "message":
      for (const e of t.nestedMessages)
        yield e, yield* qo(e);
      yield* t.nestedEnums, yield* t.nestedExtensions;
      break;
  }
}
function Gd(...t) {
  const e = z5();
  if (!t.length)
    return e;
  if ("$typeName" in t[0] && t[0].$typeName == "google.protobuf.FileDescriptorSet") {
    for (const n of t[0].file)
      Ka(n, e);
    return e;
  }
  if ("$typeName" in t[0]) {
    let r = function(o) {
      const l = [];
      for (const a of o.dependency) {
        if (e.getFile(a) != null || s.has(a))
          continue;
        const c = i(a);
        if (!c)
          throw new Error(`Unable to resolve ${a}, imported by ${o.name}`);
        "kind" in c ? e.addFile(c, !1, !0) : (s.add(c.name), l.push(c));
      }
      return l.concat(...l.map(r));
    };
    const n = t[0], i = t[1], s = /* @__PURE__ */ new Set();
    for (const o of [n, ...r(n)].reverse())
      Ka(o, e);
  } else
    for (const n of t)
      for (const i of n.files)
        e.addFile(i);
  return e;
}
function z5() {
  const t = /* @__PURE__ */ new Map(), e = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map();
  return {
    kind: "registry",
    types: t,
    extendees: e,
    [Symbol.iterator]() {
      return t.values();
    },
    get files() {
      return n.values();
    },
    addFile(i, s, r) {
      if (n.set(i.proto.name, i), !s)
        for (const o of qo(i))
          this.add(o);
      if (r)
        for (const o of i.dependencies)
          this.addFile(o, s, r);
    },
    add(i) {
      if (i.kind == "extension") {
        let s = e.get(i.extendee.typeName);
        s || e.set(i.extendee.typeName, s = /* @__PURE__ */ new Map()), s.set(i.number, i);
      }
      t.set(i.typeName, i);
    },
    get(i) {
      return t.get(i);
    },
    getFile(i) {
      return n.get(i);
    },
    getMessage(i) {
      const s = t.get(i);
      return s?.kind == "message" ? s : void 0;
    },
    getEnum(i) {
      const s = t.get(i);
      return s?.kind == "enum" ? s : void 0;
    },
    getExtension(i) {
      const s = t.get(i);
      return s?.kind == "extension" ? s : void 0;
    },
    getExtensionFor(i, s) {
      var r;
      return (r = e.get(i.typeName)) === null || r === void 0 ? void 0 : r.get(s);
    },
    getService(i) {
      const s = t.get(i);
      return s?.kind == "service" ? s : void 0;
    }
  };
}
const K5 = 998, H5 = 999, O5 = 9, Ns = 10, yi = 11, D5 = 12, Qa = 14, Ul = 3, P5 = 2, za = 1, _5 = 0, Er = 1, j5 = 2, $5 = 3, q5 = 1, em = 2, tm = 1, Xd = {
  // EDITION_PROTO2
  998: {
    fieldPresence: 1,
    // EXPLICIT,
    enumType: 2,
    // CLOSED,
    repeatedFieldEncoding: 2,
    // EXPANDED,
    utf8Validation: 3,
    // NONE,
    messageEncoding: 1,
    // LENGTH_PREFIXED,
    jsonFormat: 2,
    // LEGACY_BEST_EFFORT,
    enforceNamingStyle: 2
    // STYLE_LEGACY,
  },
  // EDITION_PROTO3
  999: {
    fieldPresence: 2,
    // IMPLICIT,
    enumType: 1,
    // OPEN,
    repeatedFieldEncoding: 1,
    // PACKED,
    utf8Validation: 2,
    // VERIFY,
    messageEncoding: 1,
    // LENGTH_PREFIXED,
    jsonFormat: 1,
    // ALLOW,
    enforceNamingStyle: 2
    // STYLE_LEGACY,
  },
  // EDITION_2023
  1e3: {
    fieldPresence: 1,
    // EXPLICIT,
    enumType: 1,
    // OPEN,
    repeatedFieldEncoding: 1,
    // PACKED,
    utf8Validation: 2,
    // VERIFY,
    messageEncoding: 1,
    // LENGTH_PREFIXED,
    jsonFormat: 1,
    // ALLOW,
    enforceNamingStyle: 2
    // STYLE_LEGACY,
  }
};
function Ka(t, e) {
  var n, i;
  const s = {
    kind: "file",
    proto: t,
    deprecated: (i = (n = t.options) === null || n === void 0 ? void 0 : n.deprecated) !== null && i !== void 0 ? i : !1,
    edition: rm(t),
    name: t.name.replace(/\.proto$/, ""),
    dependencies: om(t, e),
    enums: [],
    messages: [],
    extensions: [],
    services: [],
    toString() {
      return `file ${t.name}`;
    }
  }, r = /* @__PURE__ */ new Map(), o = {
    get(l) {
      return r.get(l);
    },
    add(l) {
      var a;
      ft(((a = l.proto.options) === null || a === void 0 ? void 0 : a.mapEntry) === !0), r.set(l.typeName, l);
    }
  };
  for (const l of t.enumType)
    Ud(l, s, void 0, e);
  for (const l of t.messageType)
    Bd(l, s, void 0, e, o);
  for (const l of t.service)
    nm(l, s, e);
  el(s, e);
  for (const l of r.values())
    tl(l, e, o);
  for (const l of s.messages)
    tl(l, e, o), el(l, e);
  e.addFile(s, !0);
}
function el(t, e) {
  switch (t.kind) {
    case "file":
      for (const n of t.proto.extension) {
        const i = nl(n, t, e);
        t.extensions.push(i), e.add(i);
      }
      break;
    case "message":
      for (const n of t.proto.extension) {
        const i = nl(n, t, e);
        t.nestedExtensions.push(i), e.add(i);
      }
      for (const n of t.nestedMessages)
        el(n, e);
      break;
  }
}
function tl(t, e, n) {
  const i = t.proto.oneofDecl.map((r) => sm(r, t)), s = /* @__PURE__ */ new Set();
  for (const r of t.proto.field) {
    const o = cm(r, i), l = nl(r, t, e, o, n);
    t.fields.push(l), t.field[l.localName] = l, o === void 0 ? t.members.push(l) : (o.fields.push(l), s.has(o) || (s.add(o), t.members.push(o)));
  }
  for (const r of i.filter((o) => s.has(o)))
    t.oneofs.push(r);
  for (const r of t.nestedMessages)
    tl(r, e, n);
}
function Ud(t, e, n, i) {
  var s, r, o;
  const l = lm(t.name, t.value), a = {
    kind: "enum",
    proto: t,
    deprecated: (r = (s = t.options) === null || s === void 0 ? void 0 : s.deprecated) !== null && r !== void 0 ? r : !1,
    file: e,
    parent: n,
    open: !0,
    name: t.name,
    typeName: Os(t, n, e),
    value: {},
    values: [],
    sharedPrefix: l,
    toString() {
      return `enum ${this.typeName}`;
    }
  };
  a.open = mm(a), i.add(a), t.value.forEach((c) => {
    var u, h;
    const d = c.name;
    a.values.push(a.value[c.number] = {
      kind: "enum_value",
      proto: c,
      deprecated: (h = (u = c.options) === null || u === void 0 ? void 0 : u.deprecated) !== null && h !== void 0 ? h : !1,
      parent: a,
      name: d,
      localName: Fi(l == null ? d : d.substring(l.length)),
      number: c.number,
      toString() {
        return `enum value ${a.typeName}.${d}`;
      }
    });
  }), ((o = n?.nestedEnums) !== null && o !== void 0 ? o : e.enums).push(a);
}
function Bd(t, e, n, i, s) {
  var r, o, l, a;
  const c = {
    kind: "message",
    proto: t,
    deprecated: (o = (r = t.options) === null || r === void 0 ? void 0 : r.deprecated) !== null && o !== void 0 ? o : !1,
    file: e,
    parent: n,
    name: t.name,
    typeName: Os(t, n, e),
    fields: [],
    field: {},
    oneofs: [],
    members: [],
    nestedEnums: [],
    nestedMessages: [],
    nestedExtensions: [],
    toString() {
      return `message ${this.typeName}`;
    }
  };
  ((l = t.options) === null || l === void 0 ? void 0 : l.mapEntry) === !0 ? s.add(c) : (((a = n?.nestedMessages) !== null && a !== void 0 ? a : e.messages).push(c), i.add(c));
  for (const u of t.enumType)
    Ud(u, e, c, i);
  for (const u of t.nestedType)
    Bd(u, e, c, i, s);
}
function nm(t, e, n) {
  var i, s;
  const r = {
    kind: "service",
    proto: t,
    deprecated: (s = (i = t.options) === null || i === void 0 ? void 0 : i.deprecated) !== null && s !== void 0 ? s : !1,
    file: e,
    name: t.name,
    typeName: Os(t, void 0, e),
    methods: [],
    method: {},
    toString() {
      return `service ${this.typeName}`;
    }
  };
  e.services.push(r), n.add(r);
  for (const o of t.method) {
    const l = im(o, r, n);
    r.methods.push(l), r.method[l.localName] = l;
  }
}
function im(t, e, n) {
  var i, s, r, o;
  let l;
  t.clientStreaming && t.serverStreaming ? l = "bidi_streaming" : t.clientStreaming ? l = "client_streaming" : t.serverStreaming ? l = "server_streaming" : l = "unary";
  const a = n.getMessage(Bt(t.inputType)), c = n.getMessage(Bt(t.outputType));
  ft(a, `invalid MethodDescriptorProto: input_type ${t.inputType} not found`), ft(c, `invalid MethodDescriptorProto: output_type ${t.inputType} not found`);
  const u = t.name;
  return {
    kind: "rpc",
    proto: t,
    deprecated: (s = (i = t.options) === null || i === void 0 ? void 0 : i.deprecated) !== null && s !== void 0 ? s : !1,
    parent: e,
    name: u,
    localName: Fi(u.length ? Fi(u[0].toLowerCase() + u.substring(1)) : u),
    methodKind: l,
    input: a,
    output: c,
    idempotency: (o = (r = t.options) === null || r === void 0 ? void 0 : r.idempotencyLevel) !== null && o !== void 0 ? o : _5,
    toString() {
      return `rpc ${e.typeName}.${u}`;
    }
  };
}
function sm(t, e) {
  return {
    kind: "oneof",
    proto: t,
    deprecated: !1,
    parent: e,
    fields: [],
    name: t.name,
    localName: Fi(Ni(t.name)),
    toString() {
      return `oneof ${e.typeName}.${this.name}`;
    }
  };
}
function nl(t, e, n, i, s) {
  var r, o, l;
  const a = s === void 0, c = {
    kind: "field",
    proto: t,
    deprecated: (o = (r = t.options) === null || r === void 0 ? void 0 : r.deprecated) !== null && o !== void 0 ? o : !1,
    name: t.name,
    number: t.number,
    scalar: void 0,
    message: void 0,
    enum: void 0,
    presence: um(t, i, a, e),
    listKind: void 0,
    mapKind: void 0,
    mapKey: void 0,
    delimitedEncoding: void 0,
    packed: void 0,
    longAsString: !1,
    getDefaultValue: void 0
  };
  if (a) {
    const m = e.kind == "file" ? e : e.file, p = e.kind == "file" ? void 0 : e, g = Os(t, p, m);
    c.kind = "extension", c.file = m, c.parent = p, c.oneof = void 0, c.typeName = g, c.jsonName = `[${g}]`, c.toString = () => `extension ${g}`;
    const A = n.getMessage(Bt(t.extendee));
    ft(A, `invalid FieldDescriptorProto: extendee ${t.extendee} not found`), c.extendee = A;
  } else {
    const m = e;
    ft(m.kind == "message"), c.parent = m, c.oneof = i, c.localName = i ? Ni(t.name) : Fi(Ni(t.name)), c.jsonName = t.jsonName, c.toString = () => `field ${m.typeName}.${t.name}`;
  }
  const u = t.label, h = t.type, d = (l = t.options) === null || l === void 0 ? void 0 : l.jstype;
  if (u === Ul) {
    const m = h == yi ? s?.get(Bt(t.typeName)) : void 0;
    if (m) {
      c.fieldKind = "map";
      const { key: p, value: g } = dm(m);
      return c.mapKey = p.scalar, c.mapKind = g.fieldKind, c.message = g.message, c.delimitedEncoding = !1, c.enum = g.enum, c.scalar = g.scalar, c;
    }
    switch (c.fieldKind = "list", h) {
      case yi:
      case Ns:
        c.listKind = "message", c.message = n.getMessage(Bt(t.typeName)), ft(c.message), c.delimitedEncoding = Ha(t, e);
        break;
      case Qa:
        c.listKind = "enum", c.enum = n.getEnum(Bt(t.typeName)), ft(c.enum);
        break;
      default:
        c.listKind = "scalar", c.scalar = h, c.longAsString = d == za;
        break;
    }
    return c.packed = hm(t, e), c;
  }
  switch (h) {
    case yi:
    case Ns:
      c.fieldKind = "message", c.message = n.getMessage(Bt(t.typeName)), ft(
        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
        c.message,
        `invalid FieldDescriptorProto: type_name ${t.typeName} not found`
      ), c.delimitedEncoding = Ha(t, e), c.getDefaultValue = () => {
      };
      break;
    case Qa: {
      const m = n.getEnum(Bt(t.typeName));
      ft(m !== void 0, `invalid FieldDescriptorProto: type_name ${t.typeName} not found`), c.fieldKind = "enum", c.enum = n.getEnum(Bt(t.typeName)), c.getDefaultValue = () => Gi(t, "defaultValue") ? x5(m, t.defaultValue) : void 0;
      break;
    }
    default: {
      c.fieldKind = "scalar", c.scalar = h, c.longAsString = d == za, c.getDefaultValue = () => Gi(t, "defaultValue") ? M5(h, t.defaultValue) : void 0;
      break;
    }
  }
  return c;
}
function rm(t) {
  switch (t.syntax) {
    case "":
    case "proto2":
      return K5;
    case "proto3":
      return H5;
    case "editions":
      if (t.edition in Xd)
        return t.edition;
      throw new Error(`${t.name}: unsupported edition`);
    default:
      throw new Error(`${t.name}: unsupported syntax "${t.syntax}"`);
  }
}
function om(t, e) {
  return t.dependency.map((n) => {
    const i = e.getFile(n);
    if (!i)
      throw new Error(`Cannot find ${n}, imported by ${t.name}`);
    return i;
  });
}
function lm(t, e) {
  const n = am(t) + "_";
  for (const i of e) {
    if (!i.name.toLowerCase().startsWith(n))
      return;
    const s = i.name.substring(n.length);
    if (s.length == 0 || /^\d/.test(s))
      return;
  }
  return n;
}
function am(t) {
  return (t.substring(0, 1) + t.substring(1).replace(/[A-Z]/g, (e) => "_" + e)).toLowerCase();
}
function Os(t, e, n) {
  let i;
  return e ? i = `${e.typeName}.${t.name}` : n.proto.package.length > 0 ? i = `${n.proto.package}.${t.name}` : i = `${t.name}`, i;
}
function Bt(t) {
  return t.startsWith(".") ? t.substring(1) : t;
}
function cm(t, e) {
  if (!Gi(t, "oneofIndex") || t.proto3Optional)
    return;
  const n = e[t.oneofIndex];
  return ft(
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    n,
    `invalid FieldDescriptorProto: oneof #${t.oneofIndex} for field #${t.number} not found`
  ), n;
}
function um(t, e, n, i) {
  return t.label == P5 ? $5 : t.label == Ul ? j5 : e || t.proto3Optional || t.type == yi || n ? Er : ei("fieldPresence", { proto: t, parent: i });
}
function hm(t, e) {
  if (t.label != Ul)
    return !1;
  switch (t.type) {
    case O5:
    case D5:
    case Ns:
    case yi:
      return !1;
  }
  const n = t.options;
  return n && Gi(n, "packed") ? n.packed : q5 == ei("repeatedFieldEncoding", {
    proto: t,
    parent: e
  });
}
function dm(t) {
  const e = t.fields.find((i) => i.number === 1), n = t.fields.find((i) => i.number === 2);
  return ft(e && e.fieldKind == "scalar" && e.scalar != I.BYTES && e.scalar != I.FLOAT && e.scalar != I.DOUBLE && n && n.fieldKind != "list" && n.fieldKind != "map"), { key: e, value: n };
}
function mm(t) {
  var e;
  return tm == ei("enumType", {
    proto: t.proto,
    parent: (e = t.parent) !== null && e !== void 0 ? e : t.file
  });
}
function Ha(t, e) {
  return t.type == Ns ? !0 : em == ei("messageEncoding", {
    proto: t,
    parent: e
  });
}
function ei(t, e) {
  var n, i;
  const s = (n = e.proto.options) === null || n === void 0 ? void 0 : n.features;
  if (s) {
    const r = s[t];
    if (r != 0)
      return r;
  }
  if ("kind" in e) {
    if (e.kind == "message")
      return ei(t, (i = e.parent) !== null && i !== void 0 ? i : e.file);
    const r = Xd[e.edition];
    if (!r)
      throw new Error(`feature default for edition ${e.edition} not found`);
    return r[t];
  }
  return ei(t, e.parent);
}
function ft(t, e) {
  if (!t)
    throw new Error(e);
}
function pm(t) {
  const e = gm(t);
  return e.messageType.forEach(Xl), Gd(e, () => {
  }).getFile(e.name);
}
function gm(t) {
  return Object.assign(/* @__PURE__ */ Object.create({
    syntax: "",
    edition: 0
  }), Object.assign(Object.assign({ $typeName: "google.protobuf.FileDescriptorProto", dependency: [], publicDependency: [], weakDependency: [], service: [], extension: [] }, t), { messageType: t.messageType.map(wd), enumType: t.enumType.map(Yd) }));
}
function wd(t) {
  var e, n, i, s, r, o, l, a;
  return {
    $typeName: "google.protobuf.DescriptorProto",
    name: t.name,
    field: (n = (e = t.field) === null || e === void 0 ? void 0 : e.map(fm)) !== null && n !== void 0 ? n : [],
    extension: [],
    nestedType: (s = (i = t.nestedType) === null || i === void 0 ? void 0 : i.map(wd)) !== null && s !== void 0 ? s : [],
    enumType: (o = (r = t.enumType) === null || r === void 0 ? void 0 : r.map(Yd)) !== null && o !== void 0 ? o : [],
    extensionRange: (a = (l = t.extensionRange) === null || l === void 0 ? void 0 : l.map((c) => Object.assign({ $typeName: "google.protobuf.DescriptorProto.ExtensionRange" }, c))) !== null && a !== void 0 ? a : [],
    oneofDecl: [],
    reservedRange: [],
    reservedName: []
  };
}
function fm(t) {
  return Object.assign(/* @__PURE__ */ Object.create({
    label: 1,
    typeName: "",
    extendee: "",
    defaultValue: "",
    oneofIndex: 0,
    jsonName: "",
    proto3Optional: !1
  }), Object.assign(Object.assign({ $typeName: "google.protobuf.FieldDescriptorProto" }, t), { options: t.options ? bm(t.options) : void 0 }));
}
function bm(t) {
  var e, n, i;
  return Object.assign(/* @__PURE__ */ Object.create({
    ctype: 0,
    packed: !1,
    jstype: 0,
    lazy: !1,
    unverifiedLazy: !1,
    deprecated: !1,
    weak: !1,
    debugRedact: !1,
    retention: 0
  }), Object.assign(Object.assign({ $typeName: "google.protobuf.FieldOptions" }, t), { targets: (e = t.targets) !== null && e !== void 0 ? e : [], editionDefaults: (i = (n = t.editionDefaults) === null || n === void 0 ? void 0 : n.map((r) => Object.assign({ $typeName: "google.protobuf.FieldOptions.EditionDefault" }, r))) !== null && i !== void 0 ? i : [], uninterpretedOption: [] }));
}
function Yd(t) {
  return {
    $typeName: "google.protobuf.EnumDescriptorProto",
    name: t.name,
    reservedName: [],
    reservedRange: [],
    value: t.value.map((e) => Object.assign({ $typeName: "google.protobuf.EnumValueDescriptorProto" }, e))
  };
}
function Bl(t) {
  const e = Vm();
  let n = t.length * 3 / 4;
  t[t.length - 2] == "=" ? n -= 2 : t[t.length - 1] == "=" && (n -= 1);
  let i = new Uint8Array(n), s = 0, r = 0, o, l = 0;
  for (let a = 0; a < t.length; a++) {
    if (o = e[t.charCodeAt(a)], o === void 0)
      switch (t[a]) {
        // @ts-expect-error TS7029: Fallthrough case in switch
        case "=":
          r = 0;
        // reset state when padding found
        // eslint-disable-next-line no-fallthrough
        case `
`:
        case "\r":
        case "	":
        case " ":
          continue;
        // skip white-space, and padding
        default:
          throw Error("invalid base64 string");
      }
    switch (r) {
      case 0:
        l = o, r = 1;
        break;
      case 1:
        i[s++] = l << 2 | (o & 48) >> 4, l = o, r = 2;
        break;
      case 2:
        i[s++] = (l & 15) << 4 | (o & 60) >> 2, l = o, r = 3;
        break;
      case 3:
        i[s++] = (l & 3) << 6 | o, r = 0;
        break;
    }
  }
  if (r == 1)
    throw Error("invalid base64 string");
  return i.subarray(0, s);
}
function Am(t, e = "std") {
  const n = Td(e), i = e == "std";
  let s = "", r = 0, o, l = 0;
  for (let a = 0; a < t.length; a++)
    switch (o = t[a], r) {
      case 0:
        s += n[o >> 2], l = (o & 3) << 4, r = 1;
        break;
      case 1:
        s += n[l | o >> 4], l = (o & 15) << 2, r = 2;
        break;
      case 2:
        s += n[l | o >> 6], s += n[o & 63], r = 0;
        break;
    }
  return r && (s += n[l], i && (s += "=", r == 1 && (s += "="))), s;
}
let $i, Oa, Bn;
function Td(t) {
  return $i || ($i = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".split(""), Oa = $i.slice(0, -2).concat("-", "_")), t == "url" ? Oa : $i;
}
function Vm() {
  if (!Bn) {
    Bn = [];
    const t = Td("std");
    for (let e = 0; e < t.length; e++)
      Bn[t[e].charCodeAt(0)] = e;
    Bn[45] = t.indexOf("+"), Bn[95] = t.indexOf("/");
  }
  return Bn;
}
function wl(t, e) {
  return t !== null && typeof t == "object" && "$typeName" in t && typeof t.$typeName == "string" ? e === void 0 ? !0 : e.typeName === t.$typeName : !1;
}
const Rm = [
  "FieldValueInvalidError",
  "FieldListRangeError",
  "ForeignFieldError"
];
class je extends Error {
  constructor(e, n, i = "FieldValueInvalidError") {
    super(n), this.name = i, this.field = () => e;
  }
}
function Em(t) {
  return t instanceof Error && Rm.includes(t.name) && "field" in t && typeof t.field == "function";
}
function hn(t) {
  return t !== null && typeof t == "object" && !Array.isArray(t);
}
function Yl(t, e) {
  var n, i, s, r;
  if (hn(t) && Qt in t && "add" in t && "field" in t && typeof t.field == "function") {
    if (e !== void 0) {
      const o = e, l = t.field();
      return o.listKind == l.listKind && o.scalar === l.scalar && ((n = o.message) === null || n === void 0 ? void 0 : n.typeName) === ((i = l.message) === null || i === void 0 ? void 0 : i.typeName) && ((s = o.enum) === null || s === void 0 ? void 0 : s.typeName) === ((r = l.enum) === null || r === void 0 ? void 0 : r.typeName);
    }
    return !0;
  }
  return !1;
}
function Tl(t, e) {
  var n, i, s, r;
  if (hn(t) && Qt in t && "has" in t && "field" in t && typeof t.field == "function") {
    if (e !== void 0) {
      const o = e, l = t.field();
      return o.mapKey === l.mapKey && o.mapKind == l.mapKind && o.scalar === l.scalar && ((n = o.message) === null || n === void 0 ? void 0 : n.typeName) === ((i = l.message) === null || i === void 0 ? void 0 : i.typeName) && ((s = o.enum) === null || s === void 0 ? void 0 : s.typeName) === ((r = l.enum) === null || r === void 0 ? void 0 : r.typeName);
    }
    return !0;
  }
  return !1;
}
function Ll(t, e) {
  return hn(t) && Qt in t && "desc" in t && hn(t.desc) && t.desc.kind === "message" && (e === void 0 || t.desc.typeName == e.typeName);
}
const yr = /* @__PURE__ */ Symbol.for("@bufbuild/protobuf/text-encoding");
function kl() {
  if (globalThis[yr] == null) {
    const t = new globalThis.TextEncoder(), e = new globalThis.TextDecoder();
    globalThis[yr] = {
      encodeUtf8(n) {
        return t.encode(n);
      },
      decodeUtf8(n) {
        return e.decode(n);
      },
      checkUtf8(n) {
        try {
          return encodeURIComponent(n), !0;
        } catch {
          return !1;
        }
      }
    };
  }
  return globalThis[yr];
}
var Be;
(function(t) {
  t[t.Varint = 0] = "Varint", t[t.Bit64 = 1] = "Bit64", t[t.LengthDelimited = 2] = "LengthDelimited", t[t.StartGroup = 3] = "StartGroup", t[t.EndGroup = 4] = "EndGroup", t[t.Bit32 = 5] = "Bit32";
})(Be || (Be = {}));
const Ld = 34028234663852886e22, kd = -34028234663852886e22, Jd = 4294967295, xd = 2147483647, Md = -2147483648;
class Qd {
  constructor(e = kl().encodeUtf8) {
    this.encodeUtf8 = e, this.stack = [], this.chunks = [], this.buf = [];
  }
  /**
   * Return all bytes written and reset this writer.
   */
  finish() {
    this.buf.length && (this.chunks.push(new Uint8Array(this.buf)), this.buf = []);
    let e = 0;
    for (let s = 0; s < this.chunks.length; s++)
      e += this.chunks[s].length;
    let n = new Uint8Array(e), i = 0;
    for (let s = 0; s < this.chunks.length; s++)
      n.set(this.chunks[s], i), i += this.chunks[s].length;
    return this.chunks = [], n;
  }
  /**
   * Start a new fork for length-delimited data like a message
   * or a packed repeated field.
   *
   * Must be joined later with `join()`.
   */
  fork() {
    return this.stack.push({ chunks: this.chunks, buf: this.buf }), this.chunks = [], this.buf = [], this;
  }
  /**
   * Join the last fork. Write its length and bytes, then
   * return to the previous state.
   */
  join() {
    let e = this.finish(), n = this.stack.pop();
    if (!n)
      throw new Error("invalid state, fork stack empty");
    return this.chunks = n.chunks, this.buf = n.buf, this.uint32(e.byteLength), this.raw(e);
  }
  /**
   * Writes a tag (field number and wire type).
   *
   * Equivalent to `uint32( (fieldNo << 3 | type) >>> 0 )`.
   *
   * Generated code should compute the tag ahead of time and call `uint32()`.
   */
  tag(e, n) {
    return this.uint32((e << 3 | n) >>> 0);
  }
  /**
   * Write a chunk of raw bytes.
   */
  raw(e) {
    return this.buf.length && (this.chunks.push(new Uint8Array(this.buf)), this.buf = []), this.chunks.push(e), this;
  }
  /**
   * Write a `uint32` value, an unsigned 32 bit varint.
   */
  uint32(e) {
    for (Da(e); e > 127; )
      this.buf.push(e & 127 | 128), e = e >>> 7;
    return this.buf.push(e), this;
  }
  /**
   * Write a `int32` value, a signed 32 bit varint.
   */
  int32(e) {
    return Cr(e), Ja(e, this.buf), this;
  }
  /**
   * Write a `bool` value, a variant.
   */
  bool(e) {
    return this.buf.push(e ? 1 : 0), this;
  }
  /**
   * Write a `bytes` value, length-delimited arbitrary data.
   */
  bytes(e) {
    return this.uint32(e.byteLength), this.raw(e);
  }
  /**
   * Write a `string` value, length-delimited data converted to UTF-8 text.
   */
  string(e) {
    let n = this.encodeUtf8(e);
    return this.uint32(n.byteLength), this.raw(n);
  }
  /**
   * Write a `float` value, 32-bit floating point number.
   */
  float(e) {
    ym(e);
    let n = new Uint8Array(4);
    return new DataView(n.buffer).setFloat32(0, e, !0), this.raw(n);
  }
  /**
   * Write a `double` value, a 64-bit floating point number.
   */
  double(e) {
    let n = new Uint8Array(8);
    return new DataView(n.buffer).setFloat64(0, e, !0), this.raw(n);
  }
  /**
   * Write a `fixed32` value, an unsigned, fixed-length 32-bit integer.
   */
  fixed32(e) {
    Da(e);
    let n = new Uint8Array(4);
    return new DataView(n.buffer).setUint32(0, e, !0), this.raw(n);
  }
  /**
   * Write a `sfixed32` value, a signed, fixed-length 32-bit integer.
   */
  sfixed32(e) {
    Cr(e);
    let n = new Uint8Array(4);
    return new DataView(n.buffer).setInt32(0, e, !0), this.raw(n);
  }
  /**
   * Write a `sint32` value, a signed, zigzag-encoded 32-bit varint.
   */
  sint32(e) {
    return Cr(e), e = (e << 1 ^ e >> 31) >>> 0, Ja(e, this.buf), this;
  }
  /**
   * Write a `fixed64` value, a signed, fixed-length 64-bit integer.
   */
  sfixed64(e) {
    let n = new Uint8Array(8), i = new DataView(n.buffer), s = Ze.enc(e);
    return i.setInt32(0, s.lo, !0), i.setInt32(4, s.hi, !0), this.raw(n);
  }
  /**
   * Write a `fixed64` value, an unsigned, fixed-length 64 bit integer.
   */
  fixed64(e) {
    let n = new Uint8Array(8), i = new DataView(n.buffer), s = Ze.uEnc(e);
    return i.setInt32(0, s.lo, !0), i.setInt32(4, s.hi, !0), this.raw(n);
  }
  /**
   * Write a `int64` value, a signed 64-bit varint.
   */
  int64(e) {
    let n = Ze.enc(e);
    return Rr(n.lo, n.hi, this.buf), this;
  }
  /**
   * Write a `sint64` value, a signed, zig-zag-encoded 64-bit varint.
   */
  sint64(e) {
    let n = Ze.enc(e), i = n.hi >> 31, s = n.lo << 1 ^ i, r = (n.hi << 1 | n.lo >>> 31) ^ i;
    return Rr(s, r, this.buf), this;
  }
  /**
   * Write a `uint64` value, an unsigned 64-bit varint.
   */
  uint64(e) {
    let n = Ze.uEnc(e);
    return Rr(n.lo, n.hi, this.buf), this;
  }
}
class Jl {
  constructor(e, n = kl().decodeUtf8) {
    this.decodeUtf8 = n, this.varint64 = U5, this.uint32 = Y5, this.buf = e, this.len = e.length, this.pos = 0, this.view = new DataView(e.buffer, e.byteOffset, e.byteLength);
  }
  /**
   * Reads a tag - field number and wire type.
   */
  tag() {
    let e = this.uint32(), n = e >>> 3, i = e & 7;
    if (n <= 0 || i < 0 || i > 5)
      throw new Error("illegal tag: field no " + n + " wire type " + i);
    return [n, i];
  }
  /**
   * Skip one element and return the skipped data.
   *
   * When skipping StartGroup, provide the tags field number to check for
   * matching field number in the EndGroup tag.
   */
  skip(e, n) {
    let i = this.pos;
    switch (e) {
      case Be.Varint:
        for (; this.buf[this.pos++] & 128; )
          ;
        break;
      // eslint-disable-next-line
      // @ts-expect-error TS7029: Fallthrough case in switch
      case Be.Bit64:
        this.pos += 4;
      // eslint-disable-next-line no-fallthrough
      case Be.Bit32:
        this.pos += 4;
        break;
      case Be.LengthDelimited:
        let s = this.uint32();
        this.pos += s;
        break;
      case Be.StartGroup:
        for (; ; ) {
          const [r, o] = this.tag();
          if (o === Be.EndGroup) {
            if (n !== void 0 && r !== n)
              throw new Error("invalid end group tag");
            break;
          }
          this.skip(o, r);
        }
        break;
      default:
        throw new Error("cant skip wire type " + e);
    }
    return this.assertBounds(), this.buf.subarray(i, this.pos);
  }
  /**
   * Throws error if position in byte array is out of range.
   */
  assertBounds() {
    if (this.pos > this.len)
      throw new RangeError("premature EOF");
  }
  /**
   * Read a `int32` field, a signed 32 bit varint.
   */
  int32() {
    return this.uint32() | 0;
  }
  /**
   * Read a `sint32` field, a signed, zigzag-encoded 32-bit varint.
   */
  sint32() {
    let e = this.uint32();
    return e >>> 1 ^ -(e & 1);
  }
  /**
   * Read a `int64` field, a signed 64-bit varint.
   */
  int64() {
    return Ze.dec(...this.varint64());
  }
  /**
   * Read a `uint64` field, an unsigned 64-bit varint.
   */
  uint64() {
    return Ze.uDec(...this.varint64());
  }
  /**
   * Read a `sint64` field, a signed, zig-zag-encoded 64-bit varint.
   */
  sint64() {
    let [e, n] = this.varint64(), i = -(e & 1);
    return e = (e >>> 1 | (n & 1) << 31) ^ i, n = n >>> 1 ^ i, Ze.dec(e, n);
  }
  /**
   * Read a `bool` field, a variant.
   */
  bool() {
    let [e, n] = this.varint64();
    return e !== 0 || n !== 0;
  }
  /**
   * Read a `fixed32` field, an unsigned, fixed-length 32-bit integer.
   */
  fixed32() {
    return this.view.getUint32((this.pos += 4) - 4, !0);
  }
  /**
   * Read a `sfixed32` field, a signed, fixed-length 32-bit integer.
   */
  sfixed32() {
    return this.view.getInt32((this.pos += 4) - 4, !0);
  }
  /**
   * Read a `fixed64` field, an unsigned, fixed-length 64 bit integer.
   */
  fixed64() {
    return Ze.uDec(this.sfixed32(), this.sfixed32());
  }
  /**
   * Read a `fixed64` field, a signed, fixed-length 64-bit integer.
   */
  sfixed64() {
    return Ze.dec(this.sfixed32(), this.sfixed32());
  }
  /**
   * Read a `float` field, 32-bit floating point number.
   */
  float() {
    return this.view.getFloat32((this.pos += 4) - 4, !0);
  }
  /**
   * Read a `double` field, a 64-bit floating point number.
   */
  double() {
    return this.view.getFloat64((this.pos += 8) - 8, !0);
  }
  /**
   * Read a `bytes` field, length-delimited arbitrary data.
   */
  bytes() {
    let e = this.uint32(), n = this.pos;
    return this.pos += e, this.assertBounds(), this.buf.subarray(n, n + e);
  }
  /**
   * Read a `string` field, length-delimited data converted to UTF-8 text.
   */
  string() {
    return this.decodeUtf8(this.bytes());
  }
}
function Cr(t) {
  if (typeof t == "string")
    t = Number(t);
  else if (typeof t != "number")
    throw new Error("invalid int32: " + typeof t);
  if (!Number.isInteger(t) || t > xd || t < Md)
    throw new Error("invalid int32: " + t);
}
function Da(t) {
  if (typeof t == "string")
    t = Number(t);
  else if (typeof t != "number")
    throw new Error("invalid uint32: " + typeof t);
  if (!Number.isInteger(t) || t > Jd || t < 0)
    throw new Error("invalid uint32: " + t);
}
function ym(t) {
  if (typeof t == "string") {
    const e = t;
    if (t = Number(t), isNaN(t) && e !== "NaN")
      throw new Error("invalid float32: " + e);
  } else if (typeof t != "number")
    throw new Error("invalid float32: " + typeof t);
  if (Number.isFinite(t) && (t > Ld || t < kd))
    throw new Error("invalid float32: " + t);
}
function fn(t, e) {
  const n = t.fieldKind == "list" ? Yl(e, t) : t.fieldKind == "map" ? Tl(e, t) : xl(t, e);
  if (n === !0)
    return;
  let i;
  switch (t.fieldKind) {
    case "list":
      i = `expected ${Hd(t)}, got ${Me(e)}`;
      break;
    case "map":
      i = `expected ${Od(t)}, got ${Me(e)}`;
      break;
    default:
      i = Fs(t, e, n);
  }
  return new je(t, i);
}
function Pa(t, e, n) {
  const i = xl(t, n);
  if (i !== !0)
    return new je(t, `list item #${e + 1}: ${Fs(t, n, i)}`);
}
function Cm(t, e, n) {
  const i = zd(e, t.mapKey);
  if (i !== !0)
    return new je(t, `invalid map key: ${Fs({ scalar: t.mapKey }, e, i)}`);
  const s = xl(t, n);
  if (s !== !0)
    return new je(t, `map entry ${Me(e)}: ${Fs(t, n, s)}`);
}
function xl(t, e) {
  return t.scalar !== void 0 ? zd(e, t.scalar) : t.enum !== void 0 ? t.enum.open ? Number.isInteger(e) : t.enum.values.some((n) => n.number === e) : Ll(e, t.message);
}
function zd(t, e) {
  switch (e) {
    case I.DOUBLE:
      return typeof t == "number";
    case I.FLOAT:
      return typeof t != "number" ? !1 : Number.isNaN(t) || !Number.isFinite(t) ? !0 : t > Ld || t < kd ? `${t.toFixed()} out of range` : !0;
    case I.INT32:
    case I.SFIXED32:
    case I.SINT32:
      return typeof t != "number" || !Number.isInteger(t) ? !1 : t > xd || t < Md ? `${t.toFixed()} out of range` : !0;
    case I.FIXED32:
    case I.UINT32:
      return typeof t != "number" || !Number.isInteger(t) ? !1 : t > Jd || t < 0 ? `${t.toFixed()} out of range` : !0;
    case I.BOOL:
      return typeof t == "boolean";
    case I.STRING:
      return typeof t != "string" ? !1 : kl().checkUtf8(t) || "invalid UTF8";
    case I.BYTES:
      return t instanceof Uint8Array;
    case I.INT64:
    case I.SFIXED64:
    case I.SINT64:
      if (typeof t == "bigint" || typeof t == "number" || typeof t == "string" && t.length > 0)
        try {
          return Ze.parse(t), !0;
        } catch {
          return `${t} out of range`;
        }
      return !1;
    case I.FIXED64:
    case I.UINT64:
      if (typeof t == "bigint" || typeof t == "number" || typeof t == "string" && t.length > 0)
        try {
          return Ze.uParse(t), !0;
        } catch {
          return `${t} out of range`;
        }
      return !1;
  }
}
function Fs(t, e, n) {
  return n = typeof n == "string" ? `: ${n}` : `, got ${Me(e)}`, t.scalar !== void 0 ? `expected ${Wm(t.scalar)}` + n : t.enum !== void 0 ? `expected ${t.enum.toString()}` + n : `expected ${Kd(t.message)}` + n;
}
function Me(t) {
  switch (typeof t) {
    case "object":
      return t === null ? "null" : t instanceof Uint8Array ? `Uint8Array(${t.length})` : Array.isArray(t) ? `Array(${t.length})` : Yl(t) ? Hd(t.field()) : Tl(t) ? Od(t.field()) : Ll(t) ? Kd(t.desc) : wl(t) ? `message ${t.$typeName}` : "object";
    case "string":
      return t.length > 30 ? "string" : `"${t.split('"').join('\\"')}"`;
    case "boolean":
      return String(t);
    case "number":
      return String(t);
    case "bigint":
      return String(t) + "n";
    default:
      return typeof t;
  }
}
function Kd(t) {
  return `ReflectMessage (${t.typeName})`;
}
function Hd(t) {
  switch (t.listKind) {
    case "message":
      return `ReflectList (${t.message.toString()})`;
    case "enum":
      return `ReflectList (${t.enum.toString()})`;
    case "scalar":
      return `ReflectList (${I[t.scalar]})`;
  }
}
function Od(t) {
  switch (t.mapKind) {
    case "message":
      return `ReflectMap (${I[t.mapKey]}, ${t.message.toString()})`;
    case "enum":
      return `ReflectMap (${I[t.mapKey]}, ${t.enum.toString()})`;
    case "scalar":
      return `ReflectMap (${I[t.mapKey]}, ${I[t.scalar]})`;
  }
}
function Wm(t) {
  switch (t) {
    case I.STRING:
      return "string";
    case I.BOOL:
      return "boolean";
    case I.INT64:
    case I.SINT64:
    case I.SFIXED64:
      return "bigint (int64)";
    case I.UINT64:
    case I.FIXED64:
      return "bigint (uint64)";
    case I.BYTES:
      return "Uint8Array";
    case I.DOUBLE:
      return "number (float64)";
    case I.FLOAT:
      return "number (float32)";
    case I.FIXED32:
    case I.UINT32:
      return "number (uint32)";
    case I.INT32:
    case I.SFIXED32:
    case I.SINT32:
      return "number (int32)";
  }
}
function Sm(t) {
  return Dd(t.$typeName);
}
function Yi(t) {
  const e = t.fields[0];
  return Dd(t.typeName) && e !== void 0 && e.fieldKind == "scalar" && e.name == "value" && e.number == 1;
}
function Dd(t) {
  return t.startsWith("google.protobuf.") && [
    "DoubleValue",
    "FloatValue",
    "Int64Value",
    "UInt64Value",
    "Int32Value",
    "UInt32Value",
    "BoolValue",
    "StringValue",
    "BytesValue"
  ].includes(t.substring(16));
}
const Zm = 999, vm = 998, Es = 2;
function At(t, e) {
  if (wl(e, t))
    return e;
  const n = Xm(t);
  return e !== void 0 && Im(t, n, e), n;
}
function Im(t, e, n) {
  for (const i of t.members) {
    let s = n[i.localName];
    if (s == null)
      continue;
    let r;
    if (i.kind == "oneof") {
      const o = Id(n, i);
      if (!o)
        continue;
      r = o, s = Nd(n, o);
    } else
      r = i;
    switch (r.fieldKind) {
      case "message":
        s = Ml(r, s);
        break;
      case "scalar":
        s = Pd(r, s);
        break;
      case "list":
        s = Fm(r, s);
        break;
      case "map":
        s = Nm(r, s);
        break;
    }
    Fd(e, r, s);
  }
  return e;
}
function Pd(t, e) {
  return t.scalar == I.BYTES ? Ql(e) : e;
}
function Nm(t, e) {
  if (hn(e)) {
    if (t.scalar == I.BYTES)
      return _a(e, Ql);
    if (t.mapKind == "message")
      return _a(e, (n) => Ml(t, n));
  }
  return e;
}
function Fm(t, e) {
  if (Array.isArray(e)) {
    if (t.scalar == I.BYTES)
      return e.map(Ql);
    if (t.listKind == "message")
      return e.map((n) => Ml(t, n));
  }
  return e;
}
function Ml(t, e) {
  if (t.fieldKind == "message" && !t.oneof && Yi(t.message))
    return Pd(t.message.fields[0], e);
  if (hn(e)) {
    if (t.message.typeName == "google.protobuf.Struct" && t.parent.typeName !== "google.protobuf.Value")
      return e;
    if (!wl(e, t.message))
      return At(t.message, e);
  }
  return e;
}
function Ql(t) {
  return Array.isArray(t) ? new Uint8Array(t) : t;
}
function _a(t, e) {
  const n = {};
  for (const i of Object.entries(t))
    n[i[0]] = e(i[1]);
  return n;
}
const Gm = /* @__PURE__ */ Symbol(), ja = /* @__PURE__ */ new WeakMap();
function Xm(t) {
  let e;
  if (Um(t)) {
    const n = ja.get(t);
    let i, s;
    if (n)
      ({ prototype: i, members: s } = n);
    else {
      i = {}, s = /* @__PURE__ */ new Set();
      for (const r of t.members)
        r.kind != "oneof" && (r.fieldKind != "scalar" && r.fieldKind != "enum" || r.presence != Es && (s.add(r), i[r.localName] = Wr(r)));
      ja.set(t, { prototype: i, members: s });
    }
    e = Object.create(i), e.$typeName = t.typeName;
    for (const r of t.members)
      s.has(r) || r.kind == "field" && (r.fieldKind == "message" || (r.fieldKind == "scalar" || r.fieldKind == "enum") && r.presence != Es) || (e[r.localName] = Wr(r));
  } else {
    e = {
      $typeName: t.typeName
    };
    for (const n of t.members)
      (n.kind == "oneof" || n.presence == Es) && (e[n.localName] = Wr(n));
  }
  return e;
}
function Um(t) {
  switch (t.file.edition) {
    case Zm:
      return !1;
    case vm:
      return !0;
    default:
      return t.fields.some((e) => e.presence != Es && e.fieldKind != "message" && !e.oneof);
  }
}
function Wr(t) {
  if (t.kind == "oneof")
    return { case: void 0 };
  if (t.fieldKind == "list")
    return [];
  if (t.fieldKind == "map")
    return {};
  if (t.fieldKind == "message")
    return Gm;
  const e = t.getDefaultValue();
  return e !== void 0 ? t.fieldKind == "scalar" && t.longAsString ? e.toString() : e : t.fieldKind == "scalar" ? Wn(t.scalar, t.longAsString) : t.enum.values[0].number;
}
function ut(t, e, n = !0) {
  return new _d(t, e, n);
}
class _d {
  get sortedFields() {
    var e;
    return (e = this._sortedFields) !== null && e !== void 0 ? e : this._sortedFields = this.desc.fields.concat().sort((n, i) => n.number - i.number);
  }
  constructor(e, n, i = !0) {
    this.lists = /* @__PURE__ */ new Map(), this.maps = /* @__PURE__ */ new Map(), this.check = i, this.desc = e, this.message = this[Qt] = n ?? At(e), this.fields = e.fields, this.oneofs = e.oneofs, this.members = e.members;
  }
  findNumber(e) {
    return this._fieldsByNumber || (this._fieldsByNumber = new Map(this.desc.fields.map((n) => [n.number, n]))), this._fieldsByNumber.get(e);
  }
  oneofCase(e) {
    return pi(this.message, e), Id(this.message, e);
  }
  isSet(e) {
    return pi(this.message, e), k5(this.message, e);
  }
  clear(e) {
    pi(this.message, e), J5(this.message, e);
  }
  get(e) {
    pi(this.message, e);
    const n = Nd(this.message, e);
    switch (e.fieldKind) {
      case "list":
        let i = this.lists.get(e);
        return (!i || i[Qt] !== n) && this.lists.set(e, i = new Bm(e, n, this.check)), i;
      case "map":
        let s = this.maps.get(e);
        return (!s || s[Qt] !== n) && this.maps.set(e, s = new wm(e, n, this.check)), s;
      case "message":
        return Kl(e, n, this.check);
      case "scalar":
        return n === void 0 ? Wn(e.scalar, !1) : Hl(e, n);
      case "enum":
        return n ?? e.enum.values[0].number;
    }
  }
  set(e, n) {
    if (pi(this.message, e), this.check) {
      const s = fn(e, n);
      if (s)
        throw s;
    }
    let i;
    e.fieldKind == "message" ? i = zl(e, n) : Tl(n) || Yl(n) ? i = n[Qt] : i = Ol(e, n), Fd(this.message, e, i);
  }
  getUnknown() {
    return this.message.$unknown;
  }
  setUnknown(e) {
    this.message.$unknown = e;
  }
}
function pi(t, e) {
  if (e.parent.typeName !== t.$typeName)
    throw new je(e, `cannot use ${e.toString()} with message ${t.$typeName}`, "ForeignFieldError");
}
class Bm {
  field() {
    return this._field;
  }
  get size() {
    return this._arr.length;
  }
  constructor(e, n, i) {
    this._field = e, this._arr = this[Qt] = n, this.check = i;
  }
  get(e) {
    const n = this._arr[e];
    return n === void 0 ? void 0 : Sr(this._field, n, this.check);
  }
  set(e, n) {
    if (e < 0 || e >= this._arr.length)
      throw new je(this._field, `list item #${e + 1}: out of range`);
    if (this.check) {
      const i = Pa(this._field, e, n);
      if (i)
        throw i;
    }
    this._arr[e] = $a(this._field, n);
  }
  add(e) {
    if (this.check) {
      const n = Pa(this._field, this._arr.length, e);
      if (n)
        throw n;
    }
    this._arr.push($a(this._field, e));
  }
  clear() {
    this._arr.splice(0, this._arr.length);
  }
  [Symbol.iterator]() {
    return this.values();
  }
  keys() {
    return this._arr.keys();
  }
  *values() {
    for (const e of this._arr)
      yield Sr(this._field, e, this.check);
  }
  *entries() {
    for (let e = 0; e < this._arr.length; e++)
      yield [e, Sr(this._field, this._arr[e], this.check)];
  }
}
class wm {
  constructor(e, n, i = !0) {
    this.obj = this[Qt] = n ?? {}, this.check = i, this._field = e;
  }
  field() {
    return this._field;
  }
  set(e, n) {
    if (this.check) {
      const i = Cm(this._field, e, n);
      if (i)
        throw i;
    }
    return this.obj[qi(e)] = Ym(this._field, n), this;
  }
  delete(e) {
    const n = qi(e), i = Object.prototype.hasOwnProperty.call(this.obj, n);
    return i && delete this.obj[n], i;
  }
  clear() {
    for (const e of Object.keys(this.obj))
      delete this.obj[e];
  }
  get(e) {
    let n = this.obj[qi(e)];
    return n !== void 0 && (n = Zr(this._field, n, this.check)), n;
  }
  has(e) {
    return Object.prototype.hasOwnProperty.call(this.obj, qi(e));
  }
  *keys() {
    for (const e of Object.keys(this.obj))
      yield qa(e, this._field.mapKey);
  }
  *entries() {
    for (const e of Object.entries(this.obj))
      yield [
        qa(e[0], this._field.mapKey),
        Zr(this._field, e[1], this.check)
      ];
  }
  [Symbol.iterator]() {
    return this.entries();
  }
  get size() {
    return Object.keys(this.obj).length;
  }
  *values() {
    for (const e of Object.values(this.obj))
      yield Zr(this._field, e, this.check);
  }
  forEach(e, n) {
    for (const i of this.entries())
      e.call(n, i[1], i[0], this);
  }
}
function zl(t, e) {
  return Ll(e) ? Sm(e.message) && !t.oneof && t.fieldKind == "message" ? e.message.value : e.desc.typeName == "google.protobuf.Struct" && t.parent.typeName != "google.protobuf.Value" ? $d(e.message) : e.message : e;
}
function Kl(t, e, n) {
  return e !== void 0 && (Yi(t.message) && !t.oneof && t.fieldKind == "message" ? e = {
    $typeName: t.message.typeName,
    value: Hl(t.message.fields[0], e)
  } : t.message.typeName == "google.protobuf.Struct" && t.parent.typeName != "google.protobuf.Value" && hn(e) && (e = jd(e))), new _d(t.message, e, n);
}
function $a(t, e) {
  return t.listKind == "message" ? zl(t, e) : Ol(t, e);
}
function Sr(t, e, n) {
  return t.listKind == "message" ? Kl(t, e, n) : Hl(t, e);
}
function Ym(t, e) {
  return t.mapKind == "message" ? zl(t, e) : Ol(t, e);
}
function Zr(t, e, n) {
  return t.mapKind == "message" ? Kl(t, e, n) : e;
}
function qi(t) {
  return typeof t == "string" || typeof t == "number" ? t : String(t);
}
function qa(t, e) {
  switch (e) {
    case I.STRING:
      return t;
    case I.INT32:
    case I.FIXED32:
    case I.UINT32:
    case I.SFIXED32:
    case I.SINT32: {
      const n = Number.parseInt(t);
      if (Number.isFinite(n))
        return n;
      break;
    }
    case I.BOOL:
      switch (t) {
        case "true":
          return !0;
        case "false":
          return !1;
      }
      break;
    case I.UINT64:
    case I.FIXED64:
      try {
        return Ze.uParse(t);
      } catch {
      }
      break;
    default:
      try {
        return Ze.parse(t);
      } catch {
      }
      break;
  }
  return t;
}
function Hl(t, e) {
  switch (t.scalar) {
    case I.INT64:
    case I.SFIXED64:
    case I.SINT64:
      "longAsString" in t && t.longAsString && typeof e == "string" && (e = Ze.parse(e));
      break;
    case I.FIXED64:
    case I.UINT64:
      "longAsString" in t && t.longAsString && typeof e == "string" && (e = Ze.uParse(e));
      break;
  }
  return e;
}
function Ol(t, e) {
  switch (t.scalar) {
    case I.INT64:
    case I.SFIXED64:
    case I.SINT64:
      "longAsString" in t && t.longAsString ? e = String(e) : (typeof e == "string" || typeof e == "number") && (e = Ze.parse(e));
      break;
    case I.FIXED64:
    case I.UINT64:
      "longAsString" in t && t.longAsString ? e = String(e) : (typeof e == "string" || typeof e == "number") && (e = Ze.uParse(e));
      break;
  }
  return e;
}
function jd(t) {
  const e = {
    $typeName: "google.protobuf.Struct",
    fields: {}
  };
  if (hn(t))
    for (const [n, i] of Object.entries(t))
      e.fields[n] = e0(i);
  return e;
}
function $d(t) {
  const e = {};
  for (const [n, i] of Object.entries(t.fields))
    e[n] = qd(i);
  return e;
}
function qd(t) {
  switch (t.kind.case) {
    case "structValue":
      return $d(t.kind.value);
    case "listValue":
      return t.kind.value.values.map(qd);
    case "nullValue":
    case void 0:
      return null;
    default:
      return t.kind.value;
  }
}
function e0(t) {
  const e = {
    $typeName: "google.protobuf.Value",
    kind: { case: void 0 }
  };
  switch (typeof t) {
    case "number":
      e.kind = { case: "numberValue", value: t };
      break;
    case "string":
      e.kind = { case: "stringValue", value: t };
      break;
    case "boolean":
      e.kind = { case: "boolValue", value: t };
      break;
    case "object":
      if (t === null)
        e.kind = { case: "nullValue", value: 0 };
      else if (Array.isArray(t)) {
        const n = {
          $typeName: "google.protobuf.ListValue",
          values: []
        };
        if (Array.isArray(t))
          for (const i of t)
            n.values.push(e0(i));
        e.kind = {
          case: "listValue",
          value: n
        };
      } else
        e.kind = {
          case: "structValue",
          value: jd(t)
        };
      break;
  }
  return e;
}
const Tm = 3, ec = {
  writeUnknownFields: !0
};
function Lm(t) {
  return t ? Object.assign(Object.assign({}, ec), t) : ec;
}
function t0(t, e, n) {
  return Gs(new Qd(), Lm(n), ut(t, e)).finish();
}
function Gs(t, e, n) {
  var i;
  for (const s of n.sortedFields) {
    if (!n.isSet(s)) {
      if (s.presence == Tm)
        throw new Error(`cannot encode field ${n.desc.typeName}.${s.name} to binary: required field not set`);
      continue;
    }
    n0(t, e, n, s);
  }
  if (e.writeUnknownFields)
    for (const { no: s, wireType: r, data: o } of (i = n.getUnknown()) !== null && i !== void 0 ? i : [])
      t.tag(s, r).raw(o);
  return t;
}
function n0(t, e, n, i) {
  var s;
  switch (i.fieldKind) {
    case "scalar":
    case "enum":
      Xs(t, n.desc.typeName, i.name, (s = i.scalar) !== null && s !== void 0 ? s : I.INT32, i.number, n.get(i));
      break;
    case "list":
      km(t, e, i, n.get(i));
      break;
    case "message":
      i0(t, e, i, n.get(i));
      break;
    case "map":
      for (const [r, o] of n.get(i))
        Jm(t, e, i, r, o);
      break;
  }
}
function Xs(t, e, n, i, s, r) {
  s0(t.tag(s, xm(i)), e, n, i, r);
}
function i0(t, e, n, i) {
  n.delimitedEncoding ? Gs(t.tag(n.number, Be.StartGroup), e, i).tag(n.number, Be.EndGroup) : Gs(t.tag(n.number, Be.LengthDelimited).fork(), e, i).join();
}
function km(t, e, n, i) {
  var s;
  if (n.listKind == "message") {
    for (const o of i)
      i0(t, e, n, o);
    return;
  }
  const r = (s = n.scalar) !== null && s !== void 0 ? s : I.INT32;
  if (n.packed) {
    if (!i.size)
      return;
    t.tag(n.number, Be.LengthDelimited).fork();
    for (const o of i)
      s0(t, n.parent.typeName, n.name, r, o);
    t.join();
    return;
  }
  for (const o of i)
    Xs(t, n.parent.typeName, n.name, r, n.number, o);
}
function Jm(t, e, n, i, s) {
  var r;
  switch (t.tag(n.number, Be.LengthDelimited).fork(), Xs(t, n.parent.typeName, n.name, n.mapKey, 1, i), n.mapKind) {
    case "scalar":
    case "enum":
      Xs(t, n.parent.typeName, n.name, (r = n.scalar) !== null && r !== void 0 ? r : I.INT32, 2, s);
      break;
    case "message":
      Gs(t.tag(2, Be.LengthDelimited).fork(), e, s).join();
      break;
  }
  t.join();
}
function s0(t, e, n, i, s) {
  try {
    switch (i) {
      case I.STRING:
        t.string(s);
        break;
      case I.BOOL:
        t.bool(s);
        break;
      case I.DOUBLE:
        t.double(s);
        break;
      case I.FLOAT:
        t.float(s);
        break;
      case I.INT32:
        t.int32(s);
        break;
      case I.INT64:
        t.int64(s);
        break;
      case I.UINT64:
        t.uint64(s);
        break;
      case I.FIXED64:
        t.fixed64(s);
        break;
      case I.BYTES:
        t.bytes(s);
        break;
      case I.FIXED32:
        t.fixed32(s);
        break;
      case I.SFIXED32:
        t.sfixed32(s);
        break;
      case I.SFIXED64:
        t.sfixed64(s);
        break;
      case I.SINT64:
        t.sint64(s);
        break;
      case I.UINT32:
        t.uint32(s);
        break;
      case I.SINT32:
        t.sint32(s);
        break;
    }
  } catch (r) {
    throw r instanceof Error ? new Error(`cannot encode field ${e}.${n} to binary: ${r.message}`) : r;
  }
}
function xm(t) {
  switch (t) {
    case I.BYTES:
    case I.STRING:
      return Be.LengthDelimited;
    case I.DOUBLE:
    case I.FIXED64:
    case I.SFIXED64:
      return Be.Bit64;
    case I.FIXED32:
    case I.SFIXED32:
    case I.FLOAT:
      return Be.Bit32;
    default:
      return Be.Varint;
  }
}
function ui(t, e, ...n) {
  return n.reduce((i, s) => i.nestedMessages[s], t.messages[e]);
}
function he(t, e, ...n) {
  if (n.length == 0)
    return t.enums[e];
  const i = n.pop();
  return n.reduce((s, r) => s.nestedMessages[r], t.messages[e]).nestedEnums[i];
}
function de(t) {
  const e = {};
  for (const n of t.values)
    e[n.localName] = n.number, e[n.number] = n.localName;
  return e;
}
const r0 = /* @__PURE__ */ pm({ name: "google/protobuf/descriptor.proto", package: "google.protobuf", messageType: [{ name: "FileDescriptorSet", field: [{ name: "file", number: 1, type: 11, label: 3, typeName: ".google.protobuf.FileDescriptorProto" }], extensionRange: [{ start: 536e6, end: 536000001 }] }, { name: "FileDescriptorProto", field: [{ name: "name", number: 1, type: 9, label: 1 }, { name: "package", number: 2, type: 9, label: 1 }, { name: "dependency", number: 3, type: 9, label: 3 }, { name: "public_dependency", number: 10, type: 5, label: 3 }, { name: "weak_dependency", number: 11, type: 5, label: 3 }, { name: "message_type", number: 4, type: 11, label: 3, typeName: ".google.protobuf.DescriptorProto" }, { name: "enum_type", number: 5, type: 11, label: 3, typeName: ".google.protobuf.EnumDescriptorProto" }, { name: "service", number: 6, type: 11, label: 3, typeName: ".google.protobuf.ServiceDescriptorProto" }, { name: "extension", number: 7, type: 11, label: 3, typeName: ".google.protobuf.FieldDescriptorProto" }, { name: "options", number: 8, type: 11, label: 1, typeName: ".google.protobuf.FileOptions" }, { name: "source_code_info", number: 9, type: 11, label: 1, typeName: ".google.protobuf.SourceCodeInfo" }, { name: "syntax", number: 12, type: 9, label: 1 }, { name: "edition", number: 14, type: 14, label: 1, typeName: ".google.protobuf.Edition" }] }, { name: "DescriptorProto", field: [{ name: "name", number: 1, type: 9, label: 1 }, { name: "field", number: 2, type: 11, label: 3, typeName: ".google.protobuf.FieldDescriptorProto" }, { name: "extension", number: 6, type: 11, label: 3, typeName: ".google.protobuf.FieldDescriptorProto" }, { name: "nested_type", number: 3, type: 11, label: 3, typeName: ".google.protobuf.DescriptorProto" }, { name: "enum_type", number: 4, type: 11, label: 3, typeName: ".google.protobuf.EnumDescriptorProto" }, { name: "extension_range", number: 5, type: 11, label: 3, typeName: ".google.protobuf.DescriptorProto.ExtensionRange" }, { name: "oneof_decl", number: 8, type: 11, label: 3, typeName: ".google.protobuf.OneofDescriptorProto" }, { name: "options", number: 7, type: 11, label: 1, typeName: ".google.protobuf.MessageOptions" }, { name: "reserved_range", number: 9, type: 11, label: 3, typeName: ".google.protobuf.DescriptorProto.ReservedRange" }, { name: "reserved_name", number: 10, type: 9, label: 3 }], nestedType: [{ name: "ExtensionRange", field: [{ name: "start", number: 1, type: 5, label: 1 }, { name: "end", number: 2, type: 5, label: 1 }, { name: "options", number: 3, type: 11, label: 1, typeName: ".google.protobuf.ExtensionRangeOptions" }] }, { name: "ReservedRange", field: [{ name: "start", number: 1, type: 5, label: 1 }, { name: "end", number: 2, type: 5, label: 1 }] }] }, { name: "ExtensionRangeOptions", field: [{ name: "uninterpreted_option", number: 999, type: 11, label: 3, typeName: ".google.protobuf.UninterpretedOption" }, { name: "declaration", number: 2, type: 11, label: 3, typeName: ".google.protobuf.ExtensionRangeOptions.Declaration", options: { retention: 2 } }, { name: "features", number: 50, type: 11, label: 1, typeName: ".google.protobuf.FeatureSet" }, { name: "verification", number: 3, type: 14, label: 1, typeName: ".google.protobuf.ExtensionRangeOptions.VerificationState", defaultValue: "UNVERIFIED", options: { retention: 2 } }], nestedType: [{ name: "Declaration", field: [{ name: "number", number: 1, type: 5, label: 1 }, { name: "full_name", number: 2, type: 9, label: 1 }, { name: "type", number: 3, type: 9, label: 1 }, { name: "reserved", number: 5, type: 8, label: 1 }, { name: "repeated", number: 6, type: 8, label: 1 }] }], enumType: [{ name: "VerificationState", value: [{ name: "DECLARATION", number: 0 }, { name: "UNVERIFIED", number: 1 }] }], extensionRange: [{ start: 1e3, end: 536870912 }] }, { name: "FieldDescriptorProto", field: [{ name: "name", number: 1, type: 9, label: 1 }, { name: "number", number: 3, type: 5, label: 1 }, { name: "label", number: 4, type: 14, label: 1, typeName: ".google.protobuf.FieldDescriptorProto.Label" }, { name: "type", number: 5, type: 14, label: 1, typeName: ".google.protobuf.FieldDescriptorProto.Type" }, { name: "type_name", number: 6, type: 9, label: 1 }, { name: "extendee", number: 2, type: 9, label: 1 }, { name: "default_value", number: 7, type: 9, label: 1 }, { name: "oneof_index", number: 9, type: 5, label: 1 }, { name: "json_name", number: 10, type: 9, label: 1 }, { name: "options", number: 8, type: 11, label: 1, typeName: ".google.protobuf.FieldOptions" }, { name: "proto3_optional", number: 17, type: 8, label: 1 }], enumType: [{ name: "Type", value: [{ name: "TYPE_DOUBLE", number: 1 }, { name: "TYPE_FLOAT", number: 2 }, { name: "TYPE_INT64", number: 3 }, { name: "TYPE_UINT64", number: 4 }, { name: "TYPE_INT32", number: 5 }, { name: "TYPE_FIXED64", number: 6 }, { name: "TYPE_FIXED32", number: 7 }, { name: "TYPE_BOOL", number: 8 }, { name: "TYPE_STRING", number: 9 }, { name: "TYPE_GROUP", number: 10 }, { name: "TYPE_MESSAGE", number: 11 }, { name: "TYPE_BYTES", number: 12 }, { name: "TYPE_UINT32", number: 13 }, { name: "TYPE_ENUM", number: 14 }, { name: "TYPE_SFIXED32", number: 15 }, { name: "TYPE_SFIXED64", number: 16 }, { name: "TYPE_SINT32", number: 17 }, { name: "TYPE_SINT64", number: 18 }] }, { name: "Label", value: [{ name: "LABEL_OPTIONAL", number: 1 }, { name: "LABEL_REPEATED", number: 3 }, { name: "LABEL_REQUIRED", number: 2 }] }] }, { name: "OneofDescriptorProto", field: [{ name: "name", number: 1, type: 9, label: 1 }, { name: "options", number: 2, type: 11, label: 1, typeName: ".google.protobuf.OneofOptions" }] }, { name: "EnumDescriptorProto", field: [{ name: "name", number: 1, type: 9, label: 1 }, { name: "value", number: 2, type: 11, label: 3, typeName: ".google.protobuf.EnumValueDescriptorProto" }, { name: "options", number: 3, type: 11, label: 1, typeName: ".google.protobuf.EnumOptions" }, { name: "reserved_range", number: 4, type: 11, label: 3, typeName: ".google.protobuf.EnumDescriptorProto.EnumReservedRange" }, { name: "reserved_name", number: 5, type: 9, label: 3 }], nestedType: [{ name: "EnumReservedRange", field: [{ name: "start", number: 1, type: 5, label: 1 }, { name: "end", number: 2, type: 5, label: 1 }] }] }, { name: "EnumValueDescriptorProto", field: [{ name: "name", number: 1, type: 9, label: 1 }, { name: "number", number: 2, type: 5, label: 1 }, { name: "options", number: 3, type: 11, label: 1, typeName: ".google.protobuf.EnumValueOptions" }] }, { name: "ServiceDescriptorProto", field: [{ name: "name", number: 1, type: 9, label: 1 }, { name: "method", number: 2, type: 11, label: 3, typeName: ".google.protobuf.MethodDescriptorProto" }, { name: "options", number: 3, type: 11, label: 1, typeName: ".google.protobuf.ServiceOptions" }] }, { name: "MethodDescriptorProto", field: [{ name: "name", number: 1, type: 9, label: 1 }, { name: "input_type", number: 2, type: 9, label: 1 }, { name: "output_type", number: 3, type: 9, label: 1 }, { name: "options", number: 4, type: 11, label: 1, typeName: ".google.protobuf.MethodOptions" }, { name: "client_streaming", number: 5, type: 8, label: 1, defaultValue: "false" }, { name: "server_streaming", number: 6, type: 8, label: 1, defaultValue: "false" }] }, { name: "FileOptions", field: [{ name: "java_package", number: 1, type: 9, label: 1 }, { name: "java_outer_classname", number: 8, type: 9, label: 1 }, { name: "java_multiple_files", number: 10, type: 8, label: 1, defaultValue: "false" }, { name: "java_generate_equals_and_hash", number: 20, type: 8, label: 1, options: { deprecated: !0 } }, { name: "java_string_check_utf8", number: 27, type: 8, label: 1, defaultValue: "false" }, { name: "optimize_for", number: 9, type: 14, label: 1, typeName: ".google.protobuf.FileOptions.OptimizeMode", defaultValue: "SPEED" }, { name: "go_package", number: 11, type: 9, label: 1 }, { name: "cc_generic_services", number: 16, type: 8, label: 1, defaultValue: "false" }, { name: "java_generic_services", number: 17, type: 8, label: 1, defaultValue: "false" }, { name: "py_generic_services", number: 18, type: 8, label: 1, defaultValue: "false" }, { name: "deprecated", number: 23, type: 8, label: 1, defaultValue: "false" }, { name: "cc_enable_arenas", number: 31, type: 8, label: 1, defaultValue: "true" }, { name: "objc_class_prefix", number: 36, type: 9, label: 1 }, { name: "csharp_namespace", number: 37, type: 9, label: 1 }, { name: "swift_prefix", number: 39, type: 9, label: 1 }, { name: "php_class_prefix", number: 40, type: 9, label: 1 }, { name: "php_namespace", number: 41, type: 9, label: 1 }, { name: "php_metadata_namespace", number: 44, type: 9, label: 1 }, { name: "ruby_package", number: 45, type: 9, label: 1 }, { name: "features", number: 50, type: 11, label: 1, typeName: ".google.protobuf.FeatureSet" }, { name: "uninterpreted_option", number: 999, type: 11, label: 3, typeName: ".google.protobuf.UninterpretedOption" }], enumType: [{ name: "OptimizeMode", value: [{ name: "SPEED", number: 1 }, { name: "CODE_SIZE", number: 2 }, { name: "LITE_RUNTIME", number: 3 }] }], extensionRange: [{ start: 1e3, end: 536870912 }] }, { name: "MessageOptions", field: [{ name: "message_set_wire_format", number: 1, type: 8, label: 1, defaultValue: "false" }, { name: "no_standard_descriptor_accessor", number: 2, type: 8, label: 1, defaultValue: "false" }, { name: "deprecated", number: 3, type: 8, label: 1, defaultValue: "false" }, { name: "map_entry", number: 7, type: 8, label: 1 }, { name: "deprecated_legacy_json_field_conflicts", number: 11, type: 8, label: 1, options: { deprecated: !0 } }, { name: "features", number: 12, type: 11, label: 1, typeName: ".google.protobuf.FeatureSet" }, { name: "uninterpreted_option", number: 999, type: 11, label: 3, typeName: ".google.protobuf.UninterpretedOption" }], extensionRange: [{ start: 1e3, end: 536870912 }] }, { name: "FieldOptions", field: [{ name: "ctype", number: 1, type: 14, label: 1, typeName: ".google.protobuf.FieldOptions.CType", defaultValue: "STRING" }, { name: "packed", number: 2, type: 8, label: 1 }, { name: "jstype", number: 6, type: 14, label: 1, typeName: ".google.protobuf.FieldOptions.JSType", defaultValue: "JS_NORMAL" }, { name: "lazy", number: 5, type: 8, label: 1, defaultValue: "false" }, { name: "unverified_lazy", number: 15, type: 8, label: 1, defaultValue: "false" }, { name: "deprecated", number: 3, type: 8, label: 1, defaultValue: "false" }, { name: "weak", number: 10, type: 8, label: 1, defaultValue: "false" }, { name: "debug_redact", number: 16, type: 8, label: 1, defaultValue: "false" }, { name: "retention", number: 17, type: 14, label: 1, typeName: ".google.protobuf.FieldOptions.OptionRetention" }, { name: "targets", number: 19, type: 14, label: 3, typeName: ".google.protobuf.FieldOptions.OptionTargetType" }, { name: "edition_defaults", number: 20, type: 11, label: 3, typeName: ".google.protobuf.FieldOptions.EditionDefault" }, { name: "features", number: 21, type: 11, label: 1, typeName: ".google.protobuf.FeatureSet" }, { name: "feature_support", number: 22, type: 11, label: 1, typeName: ".google.protobuf.FieldOptions.FeatureSupport" }, { name: "uninterpreted_option", number: 999, type: 11, label: 3, typeName: ".google.protobuf.UninterpretedOption" }], nestedType: [{ name: "EditionDefault", field: [{ name: "edition", number: 3, type: 14, label: 1, typeName: ".google.protobuf.Edition" }, { name: "value", number: 2, type: 9, label: 1 }] }, { name: "FeatureSupport", field: [{ name: "edition_introduced", number: 1, type: 14, label: 1, typeName: ".google.protobuf.Edition" }, { name: "edition_deprecated", number: 2, type: 14, label: 1, typeName: ".google.protobuf.Edition" }, { name: "deprecation_warning", number: 3, type: 9, label: 1 }, { name: "edition_removed", number: 4, type: 14, label: 1, typeName: ".google.protobuf.Edition" }] }], enumType: [{ name: "CType", value: [{ name: "STRING", number: 0 }, { name: "CORD", number: 1 }, { name: "STRING_PIECE", number: 2 }] }, { name: "JSType", value: [{ name: "JS_NORMAL", number: 0 }, { name: "JS_STRING", number: 1 }, { name: "JS_NUMBER", number: 2 }] }, { name: "OptionRetention", value: [{ name: "RETENTION_UNKNOWN", number: 0 }, { name: "RETENTION_RUNTIME", number: 1 }, { name: "RETENTION_SOURCE", number: 2 }] }, { name: "OptionTargetType", value: [{ name: "TARGET_TYPE_UNKNOWN", number: 0 }, { name: "TARGET_TYPE_FILE", number: 1 }, { name: "TARGET_TYPE_EXTENSION_RANGE", number: 2 }, { name: "TARGET_TYPE_MESSAGE", number: 3 }, { name: "TARGET_TYPE_FIELD", number: 4 }, { name: "TARGET_TYPE_ONEOF", number: 5 }, { name: "TARGET_TYPE_ENUM", number: 6 }, { name: "TARGET_TYPE_ENUM_ENTRY", number: 7 }, { name: "TARGET_TYPE_SERVICE", number: 8 }, { name: "TARGET_TYPE_METHOD", number: 9 }] }], extensionRange: [{ start: 1e3, end: 536870912 }] }, { name: "OneofOptions", field: [{ name: "features", number: 1, type: 11, label: 1, typeName: ".google.protobuf.FeatureSet" }, { name: "uninterpreted_option", number: 999, type: 11, label: 3, typeName: ".google.protobuf.UninterpretedOption" }], extensionRange: [{ start: 1e3, end: 536870912 }] }, { name: "EnumOptions", field: [{ name: "allow_alias", number: 2, type: 8, label: 1 }, { name: "deprecated", number: 3, type: 8, label: 1, defaultValue: "false" }, { name: "deprecated_legacy_json_field_conflicts", number: 6, type: 8, label: 1, options: { deprecated: !0 } }, { name: "features", number: 7, type: 11, label: 1, typeName: ".google.protobuf.FeatureSet" }, { name: "uninterpreted_option", number: 999, type: 11, label: 3, typeName: ".google.protobuf.UninterpretedOption" }], extensionRange: [{ start: 1e3, end: 536870912 }] }, { name: "EnumValueOptions", field: [{ name: "deprecated", number: 1, type: 8, label: 1, defaultValue: "false" }, { name: "features", number: 2, type: 11, label: 1, typeName: ".google.protobuf.FeatureSet" }, { name: "debug_redact", number: 3, type: 8, label: 1, defaultValue: "false" }, { name: "feature_support", number: 4, type: 11, label: 1, typeName: ".google.protobuf.FieldOptions.FeatureSupport" }, { name: "uninterpreted_option", number: 999, type: 11, label: 3, typeName: ".google.protobuf.UninterpretedOption" }], extensionRange: [{ start: 1e3, end: 536870912 }] }, { name: "ServiceOptions", field: [{ name: "features", number: 34, type: 11, label: 1, typeName: ".google.protobuf.FeatureSet" }, { name: "deprecated", number: 33, type: 8, label: 1, defaultValue: "false" }, { name: "uninterpreted_option", number: 999, type: 11, label: 3, typeName: ".google.protobuf.UninterpretedOption" }], extensionRange: [{ start: 1e3, end: 536870912 }] }, { name: "MethodOptions", field: [{ name: "deprecated", number: 33, type: 8, label: 1, defaultValue: "false" }, { name: "idempotency_level", number: 34, type: 14, label: 1, typeName: ".google.protobuf.MethodOptions.IdempotencyLevel", defaultValue: "IDEMPOTENCY_UNKNOWN" }, { name: "features", number: 35, type: 11, label: 1, typeName: ".google.protobuf.FeatureSet" }, { name: "uninterpreted_option", number: 999, type: 11, label: 3, typeName: ".google.protobuf.UninterpretedOption" }], enumType: [{ name: "IdempotencyLevel", value: [{ name: "IDEMPOTENCY_UNKNOWN", number: 0 }, { name: "NO_SIDE_EFFECTS", number: 1 }, { name: "IDEMPOTENT", number: 2 }] }], extensionRange: [{ start: 1e3, end: 536870912 }] }, { name: "UninterpretedOption", field: [{ name: "name", number: 2, type: 11, label: 3, typeName: ".google.protobuf.UninterpretedOption.NamePart" }, { name: "identifier_value", number: 3, type: 9, label: 1 }, { name: "positive_int_value", number: 4, type: 4, label: 1 }, { name: "negative_int_value", number: 5, type: 3, label: 1 }, { name: "double_value", number: 6, type: 1, label: 1 }, { name: "string_value", number: 7, type: 12, label: 1 }, { name: "aggregate_value", number: 8, type: 9, label: 1 }], nestedType: [{ name: "NamePart", field: [{ name: "name_part", number: 1, type: 9, label: 2 }, { name: "is_extension", number: 2, type: 8, label: 2 }] }] }, { name: "FeatureSet", field: [{ name: "field_presence", number: 1, type: 14, label: 1, typeName: ".google.protobuf.FeatureSet.FieldPresence", options: { retention: 1, targets: [4, 1], editionDefaults: [{ value: "EXPLICIT", edition: 900 }, { value: "IMPLICIT", edition: 999 }, { value: "EXPLICIT", edition: 1e3 }] } }, { name: "enum_type", number: 2, type: 14, label: 1, typeName: ".google.protobuf.FeatureSet.EnumType", options: { retention: 1, targets: [6, 1], editionDefaults: [{ value: "CLOSED", edition: 900 }, { value: "OPEN", edition: 999 }] } }, { name: "repeated_field_encoding", number: 3, type: 14, label: 1, typeName: ".google.protobuf.FeatureSet.RepeatedFieldEncoding", options: { retention: 1, targets: [4, 1], editionDefaults: [{ value: "EXPANDED", edition: 900 }, { value: "PACKED", edition: 999 }] } }, { name: "utf8_validation", number: 4, type: 14, label: 1, typeName: ".google.protobuf.FeatureSet.Utf8Validation", options: { retention: 1, targets: [4, 1], editionDefaults: [{ value: "NONE", edition: 900 }, { value: "VERIFY", edition: 999 }] } }, { name: "message_encoding", number: 5, type: 14, label: 1, typeName: ".google.protobuf.FeatureSet.MessageEncoding", options: { retention: 1, targets: [4, 1], editionDefaults: [{ value: "LENGTH_PREFIXED", edition: 900 }] } }, { name: "json_format", number: 6, type: 14, label: 1, typeName: ".google.protobuf.FeatureSet.JsonFormat", options: { retention: 1, targets: [3, 6, 1], editionDefaults: [{ value: "LEGACY_BEST_EFFORT", edition: 900 }, { value: "ALLOW", edition: 999 }] } }, { name: "enforce_naming_style", number: 7, type: 14, label: 1, typeName: ".google.protobuf.FeatureSet.EnforceNamingStyle", options: { retention: 2, targets: [1, 2, 3, 4, 5, 6, 7, 8, 9], editionDefaults: [{ value: "STYLE_LEGACY", edition: 900 }, { value: "STYLE2024", edition: 1001 }] } }], enumType: [{ name: "FieldPresence", value: [{ name: "FIELD_PRESENCE_UNKNOWN", number: 0 }, { name: "EXPLICIT", number: 1 }, { name: "IMPLICIT", number: 2 }, { name: "LEGACY_REQUIRED", number: 3 }] }, { name: "EnumType", value: [{ name: "ENUM_TYPE_UNKNOWN", number: 0 }, { name: "OPEN", number: 1 }, { name: "CLOSED", number: 2 }] }, { name: "RepeatedFieldEncoding", value: [{ name: "REPEATED_FIELD_ENCODING_UNKNOWN", number: 0 }, { name: "PACKED", number: 1 }, { name: "EXPANDED", number: 2 }] }, { name: "Utf8Validation", value: [{ name: "UTF8_VALIDATION_UNKNOWN", number: 0 }, { name: "VERIFY", number: 2 }, { name: "NONE", number: 3 }] }, { name: "MessageEncoding", value: [{ name: "MESSAGE_ENCODING_UNKNOWN", number: 0 }, { name: "LENGTH_PREFIXED", number: 1 }, { name: "DELIMITED", number: 2 }] }, { name: "JsonFormat", value: [{ name: "JSON_FORMAT_UNKNOWN", number: 0 }, { name: "ALLOW", number: 1 }, { name: "LEGACY_BEST_EFFORT", number: 2 }] }, { name: "EnforceNamingStyle", value: [{ name: "ENFORCE_NAMING_STYLE_UNKNOWN", number: 0 }, { name: "STYLE2024", number: 1 }, { name: "STYLE_LEGACY", number: 2 }] }], extensionRange: [{ start: 1e3, end: 9995 }, { start: 9995, end: 1e4 }, { start: 1e4, end: 10001 }] }, { name: "FeatureSetDefaults", field: [{ name: "defaults", number: 1, type: 11, label: 3, typeName: ".google.protobuf.FeatureSetDefaults.FeatureSetEditionDefault" }, { name: "minimum_edition", number: 4, type: 14, label: 1, typeName: ".google.protobuf.Edition" }, { name: "maximum_edition", number: 5, type: 14, label: 1, typeName: ".google.protobuf.Edition" }], nestedType: [{ name: "FeatureSetEditionDefault", field: [{ name: "edition", number: 3, type: 14, label: 1, typeName: ".google.protobuf.Edition" }, { name: "overridable_features", number: 4, type: 11, label: 1, typeName: ".google.protobuf.FeatureSet" }, { name: "fixed_features", number: 5, type: 11, label: 1, typeName: ".google.protobuf.FeatureSet" }] }] }, { name: "SourceCodeInfo", field: [{ name: "location", number: 1, type: 11, label: 3, typeName: ".google.protobuf.SourceCodeInfo.Location" }], nestedType: [{ name: "Location", field: [{ name: "path", number: 1, type: 5, label: 3, options: { packed: !0 } }, { name: "span", number: 2, type: 5, label: 3, options: { packed: !0 } }, { name: "leading_comments", number: 3, type: 9, label: 1 }, { name: "trailing_comments", number: 4, type: 9, label: 1 }, { name: "leading_detached_comments", number: 6, type: 9, label: 3 }] }], extensionRange: [{ start: 536e6, end: 536000001 }] }, { name: "GeneratedCodeInfo", field: [{ name: "annotation", number: 1, type: 11, label: 3, typeName: ".google.protobuf.GeneratedCodeInfo.Annotation" }], nestedType: [{ name: "Annotation", field: [{ name: "path", number: 1, type: 5, label: 3, options: { packed: !0 } }, { name: "source_file", number: 2, type: 9, label: 1 }, { name: "begin", number: 3, type: 5, label: 1 }, { name: "end", number: 4, type: 5, label: 1 }, { name: "semantic", number: 5, type: 14, label: 1, typeName: ".google.protobuf.GeneratedCodeInfo.Annotation.Semantic" }], enumType: [{ name: "Semantic", value: [{ name: "NONE", number: 0 }, { name: "SET", number: 1 }, { name: "ALIAS", number: 2 }] }] }] }], enumType: [{ name: "Edition", value: [{ name: "EDITION_UNKNOWN", number: 0 }, { name: "EDITION_LEGACY", number: 900 }, { name: "EDITION_PROTO2", number: 998 }, { name: "EDITION_PROTO3", number: 999 }, { name: "EDITION_2023", number: 1e3 }, { name: "EDITION_2024", number: 1001 }, { name: "EDITION_1_TEST_ONLY", number: 1 }, { name: "EDITION_2_TEST_ONLY", number: 2 }, { name: "EDITION_99997_TEST_ONLY", number: 99997 }, { name: "EDITION_99998_TEST_ONLY", number: 99998 }, { name: "EDITION_99999_TEST_ONLY", number: 99999 }, { name: "EDITION_MAX", number: 2147483647 }] }] }), Mm = /* @__PURE__ */ ui(r0, 1);
var tc;
(function(t) {
  t[t.DECLARATION = 0] = "DECLARATION", t[t.UNVERIFIED = 1] = "UNVERIFIED";
})(tc || (tc = {}));
var nc;
(function(t) {
  t[t.DOUBLE = 1] = "DOUBLE", t[t.FLOAT = 2] = "FLOAT", t[t.INT64 = 3] = "INT64", t[t.UINT64 = 4] = "UINT64", t[t.INT32 = 5] = "INT32", t[t.FIXED64 = 6] = "FIXED64", t[t.FIXED32 = 7] = "FIXED32", t[t.BOOL = 8] = "BOOL", t[t.STRING = 9] = "STRING", t[t.GROUP = 10] = "GROUP", t[t.MESSAGE = 11] = "MESSAGE", t[t.BYTES = 12] = "BYTES", t[t.UINT32 = 13] = "UINT32", t[t.ENUM = 14] = "ENUM", t[t.SFIXED32 = 15] = "SFIXED32", t[t.SFIXED64 = 16] = "SFIXED64", t[t.SINT32 = 17] = "SINT32", t[t.SINT64 = 18] = "SINT64";
})(nc || (nc = {}));
var ic;
(function(t) {
  t[t.OPTIONAL = 1] = "OPTIONAL", t[t.REPEATED = 3] = "REPEATED", t[t.REQUIRED = 2] = "REQUIRED";
})(ic || (ic = {}));
var sc;
(function(t) {
  t[t.SPEED = 1] = "SPEED", t[t.CODE_SIZE = 2] = "CODE_SIZE", t[t.LITE_RUNTIME = 3] = "LITE_RUNTIME";
})(sc || (sc = {}));
var rc;
(function(t) {
  t[t.STRING = 0] = "STRING", t[t.CORD = 1] = "CORD", t[t.STRING_PIECE = 2] = "STRING_PIECE";
})(rc || (rc = {}));
var oc;
(function(t) {
  t[t.JS_NORMAL = 0] = "JS_NORMAL", t[t.JS_STRING = 1] = "JS_STRING", t[t.JS_NUMBER = 2] = "JS_NUMBER";
})(oc || (oc = {}));
var lc;
(function(t) {
  t[t.RETENTION_UNKNOWN = 0] = "RETENTION_UNKNOWN", t[t.RETENTION_RUNTIME = 1] = "RETENTION_RUNTIME", t[t.RETENTION_SOURCE = 2] = "RETENTION_SOURCE";
})(lc || (lc = {}));
var ac;
(function(t) {
  t[t.TARGET_TYPE_UNKNOWN = 0] = "TARGET_TYPE_UNKNOWN", t[t.TARGET_TYPE_FILE = 1] = "TARGET_TYPE_FILE", t[t.TARGET_TYPE_EXTENSION_RANGE = 2] = "TARGET_TYPE_EXTENSION_RANGE", t[t.TARGET_TYPE_MESSAGE = 3] = "TARGET_TYPE_MESSAGE", t[t.TARGET_TYPE_FIELD = 4] = "TARGET_TYPE_FIELD", t[t.TARGET_TYPE_ONEOF = 5] = "TARGET_TYPE_ONEOF", t[t.TARGET_TYPE_ENUM = 6] = "TARGET_TYPE_ENUM", t[t.TARGET_TYPE_ENUM_ENTRY = 7] = "TARGET_TYPE_ENUM_ENTRY", t[t.TARGET_TYPE_SERVICE = 8] = "TARGET_TYPE_SERVICE", t[t.TARGET_TYPE_METHOD = 9] = "TARGET_TYPE_METHOD";
})(ac || (ac = {}));
var cc;
(function(t) {
  t[t.IDEMPOTENCY_UNKNOWN = 0] = "IDEMPOTENCY_UNKNOWN", t[t.NO_SIDE_EFFECTS = 1] = "NO_SIDE_EFFECTS", t[t.IDEMPOTENT = 2] = "IDEMPOTENT";
})(cc || (cc = {}));
var uc;
(function(t) {
  t[t.FIELD_PRESENCE_UNKNOWN = 0] = "FIELD_PRESENCE_UNKNOWN", t[t.EXPLICIT = 1] = "EXPLICIT", t[t.IMPLICIT = 2] = "IMPLICIT", t[t.LEGACY_REQUIRED = 3] = "LEGACY_REQUIRED";
})(uc || (uc = {}));
var hc;
(function(t) {
  t[t.ENUM_TYPE_UNKNOWN = 0] = "ENUM_TYPE_UNKNOWN", t[t.OPEN = 1] = "OPEN", t[t.CLOSED = 2] = "CLOSED";
})(hc || (hc = {}));
var dc;
(function(t) {
  t[t.REPEATED_FIELD_ENCODING_UNKNOWN = 0] = "REPEATED_FIELD_ENCODING_UNKNOWN", t[t.PACKED = 1] = "PACKED", t[t.EXPANDED = 2] = "EXPANDED";
})(dc || (dc = {}));
var mc;
(function(t) {
  t[t.UTF8_VALIDATION_UNKNOWN = 0] = "UTF8_VALIDATION_UNKNOWN", t[t.VERIFY = 2] = "VERIFY", t[t.NONE = 3] = "NONE";
})(mc || (mc = {}));
var pc;
(function(t) {
  t[t.MESSAGE_ENCODING_UNKNOWN = 0] = "MESSAGE_ENCODING_UNKNOWN", t[t.LENGTH_PREFIXED = 1] = "LENGTH_PREFIXED", t[t.DELIMITED = 2] = "DELIMITED";
})(pc || (pc = {}));
var gc;
(function(t) {
  t[t.JSON_FORMAT_UNKNOWN = 0] = "JSON_FORMAT_UNKNOWN", t[t.ALLOW = 1] = "ALLOW", t[t.LEGACY_BEST_EFFORT = 2] = "LEGACY_BEST_EFFORT";
})(gc || (gc = {}));
var fc;
(function(t) {
  t[t.ENFORCE_NAMING_STYLE_UNKNOWN = 0] = "ENFORCE_NAMING_STYLE_UNKNOWN", t[t.STYLE2024 = 1] = "STYLE2024", t[t.STYLE_LEGACY = 2] = "STYLE_LEGACY";
})(fc || (fc = {}));
var bc;
(function(t) {
  t[t.NONE = 0] = "NONE", t[t.SET = 1] = "SET", t[t.ALIAS = 2] = "ALIAS";
})(bc || (bc = {}));
var Ac;
(function(t) {
  t[t.EDITION_UNKNOWN = 0] = "EDITION_UNKNOWN", t[t.EDITION_LEGACY = 900] = "EDITION_LEGACY", t[t.EDITION_PROTO2 = 998] = "EDITION_PROTO2", t[t.EDITION_PROTO3 = 999] = "EDITION_PROTO3", t[t.EDITION_2023 = 1e3] = "EDITION_2023", t[t.EDITION_2024 = 1001] = "EDITION_2024", t[t.EDITION_1_TEST_ONLY = 1] = "EDITION_1_TEST_ONLY", t[t.EDITION_2_TEST_ONLY = 2] = "EDITION_2_TEST_ONLY", t[t.EDITION_99997_TEST_ONLY = 99997] = "EDITION_99997_TEST_ONLY", t[t.EDITION_99998_TEST_ONLY = 99998] = "EDITION_99998_TEST_ONLY", t[t.EDITION_99999_TEST_ONLY = 99999] = "EDITION_99999_TEST_ONLY", t[t.EDITION_MAX = 2147483647] = "EDITION_MAX";
})(Ac || (Ac = {}));
const Vc = {
  readUnknownFields: !0
};
function Qm(t) {
  return t ? Object.assign(Object.assign({}, Vc), t) : Vc;
}
function Ti(t, e, n) {
  const i = ut(t, void 0, !1);
  return o0(i, new Jl(e), Qm(n), !1, e.byteLength), i.message;
}
function o0(t, e, n, i, s) {
  var r;
  const o = i ? e.len : e.pos + s;
  let l, a;
  const c = (r = t.getUnknown()) !== null && r !== void 0 ? r : [];
  for (; e.pos < o && ([l, a] = e.tag(), !(i && a == Be.EndGroup)); ) {
    const u = t.findNumber(l);
    if (!u) {
      const h = e.skip(a, l);
      n.readUnknownFields && c.push({ no: l, wireType: a, data: h });
      continue;
    }
    l0(t, e, u, a, n);
  }
  if (i && (a != Be.EndGroup || l !== s))
    throw new Error("invalid end group tag");
  c.length > 0 && t.setUnknown(c);
}
function l0(t, e, n, i, s) {
  switch (n.fieldKind) {
    case "scalar":
      t.set(n, ti(e, n.scalar));
      break;
    case "enum":
      t.set(n, ti(e, I.INT32));
      break;
    case "message":
      t.set(n, Dl(e, s, n, t.get(n)));
      break;
    case "list":
      Km(e, i, t.get(n), s);
      break;
    case "map":
      zm(e, t.get(n), s);
      break;
  }
}
function zm(t, e, n) {
  const i = e.field();
  let s, r;
  const o = t.pos + t.uint32();
  for (; t.pos < o; ) {
    const [l] = t.tag();
    switch (l) {
      case 1:
        s = ti(t, i.mapKey);
        break;
      case 2:
        switch (i.mapKind) {
          case "scalar":
            r = ti(t, i.scalar);
            break;
          case "enum":
            r = t.int32();
            break;
          case "message":
            r = Dl(t, n, i);
            break;
        }
        break;
    }
  }
  if (s === void 0 && (s = Wn(i.mapKey, !1)), r === void 0)
    switch (i.mapKind) {
      case "scalar":
        r = Wn(i.scalar, !1);
        break;
      case "enum":
        r = i.enum.values[0].number;
        break;
      case "message":
        r = ut(i.message, void 0, !1);
        break;
    }
  e.set(s, r);
}
function Km(t, e, n, i) {
  var s;
  const r = n.field();
  if (r.listKind === "message") {
    n.add(Dl(t, i, r));
    return;
  }
  const o = (s = r.scalar) !== null && s !== void 0 ? s : I.INT32;
  if (!(e == Be.LengthDelimited && o != I.STRING && o != I.BYTES)) {
    n.add(ti(t, o));
    return;
  }
  const a = t.uint32() + t.pos;
  for (; t.pos < a; )
    n.add(ti(t, o));
}
function Dl(t, e, n, i) {
  const s = n.delimitedEncoding, r = i ?? ut(n.message, void 0, !1);
  return o0(r, t, e, s, s ? n.number : t.uint32()), r;
}
function ti(t, e) {
  switch (e) {
    case I.STRING:
      return t.string();
    case I.BOOL:
      return t.bool();
    case I.DOUBLE:
      return t.double();
    case I.FLOAT:
      return t.float();
    case I.INT32:
      return t.int32();
    case I.INT64:
      return t.int64();
    case I.UINT64:
      return t.uint64();
    case I.FIXED64:
      return t.fixed64();
    case I.BYTES:
      return t.bytes();
    case I.FIXED32:
      return t.fixed32();
    case I.SFIXED32:
      return t.sfixed32();
    case I.SFIXED64:
      return t.sfixed64();
    case I.SINT64:
      return t.sint64();
    case I.UINT32:
      return t.uint32();
    case I.SINT32:
      return t.sint32();
  }
}
function ge(t, e) {
  var n;
  const i = Ti(Mm, Bl(t));
  return i.messageType.forEach(Xl), i.dependency = (n = e?.map((r) => r.proto.name)) !== null && n !== void 0 ? n : [], Gd(i, (r) => e?.find((o) => o.proto.name === r)).getFile(i.name);
}
function jt(t, e, ...n) {
  if (n.length > 0)
    throw new Error();
  return t.services[e];
}
const Fn = /* @__PURE__ */ ge("Ch9nb29nbGUvcHJvdG9idWYvdGltZXN0YW1wLnByb3RvEg9nb29nbGUucHJvdG9idWYiKwoJVGltZXN0YW1wEg8KB3NlY29uZHMYASABKAMSDQoFbmFub3MYAiABKAVChQEKE2NvbS5nb29nbGUucHJvdG9idWZCDlRpbWVzdGFtcFByb3RvUAFaMmdvb2dsZS5nb2xhbmcub3JnL3Byb3RvYnVmL3R5cGVzL2tub3duL3RpbWVzdGFtcHBi+AEBogIDR1BCqgIeR29vZ2xlLlByb3RvYnVmLldlbGxLbm93blR5cGVzYgZwcm90bzM"), a0 = /* @__PURE__ */ ge("Chlnb29nbGUvcHJvdG9idWYvYW55LnByb3RvEg9nb29nbGUucHJvdG9idWYiJgoDQW55EhAKCHR5cGVfdXJsGAEgASgJEg0KBXZhbHVlGAIgASgMQnYKE2NvbS5nb29nbGUucHJvdG9idWZCCEFueVByb3RvUAFaLGdvb2dsZS5nb2xhbmcub3JnL3Byb3RvYnVmL3R5cGVzL2tub3duL2FueXBiogIDR1BCqgIeR29vZ2xlLlByb3RvYnVmLldlbGxLbm93blR5cGVzYgZwcm90bzM"), Hm = /* @__PURE__ */ ui(a0, 0);
function Om(t, e, n) {
  let i = !1;
  return n || (n = At(Hm), i = !0), n.value = t0(t, e), n.typeUrl = _m(e.$typeName), i ? n : void 0;
}
function Dm(t, e) {
  if (t.typeUrl === "")
    return !1;
  const n = typeof e == "string" ? e : e.typeName, i = c0(t.typeUrl);
  return n === i;
}
function Pm(t, e) {
  if (t.typeUrl === "")
    return;
  const n = e.kind == "message" ? e : e.getMessage(c0(t.typeUrl));
  if (!(!n || !Dm(t, n)))
    return Ti(n, t.value);
}
function _m(t) {
  return `type.googleapis.com/${t}`;
}
function c0(t) {
  const e = t.lastIndexOf("/"), n = e >= 0 ? t.substring(e + 1) : t;
  if (!n.length)
    throw new Error(`invalid type url: ${t}`);
  return n;
}
const Pl = /* @__PURE__ */ ge("Chxnb29nbGUvcHJvdG9idWYvc3RydWN0LnByb3RvEg9nb29nbGUucHJvdG9idWYihAEKBlN0cnVjdBIzCgZmaWVsZHMYASADKAsyIy5nb29nbGUucHJvdG9idWYuU3RydWN0LkZpZWxkc0VudHJ5GkUKC0ZpZWxkc0VudHJ5EgsKA2tleRgBIAEoCRIlCgV2YWx1ZRgCIAEoCzIWLmdvb2dsZS5wcm90b2J1Zi5WYWx1ZToCOAEi6gEKBVZhbHVlEjAKCm51bGxfdmFsdWUYASABKA4yGi5nb29nbGUucHJvdG9idWYuTnVsbFZhbHVlSAASFgoMbnVtYmVyX3ZhbHVlGAIgASgBSAASFgoMc3RyaW5nX3ZhbHVlGAMgASgJSAASFAoKYm9vbF92YWx1ZRgEIAEoCEgAEi8KDHN0cnVjdF92YWx1ZRgFIAEoCzIXLmdvb2dsZS5wcm90b2J1Zi5TdHJ1Y3RIABIwCgpsaXN0X3ZhbHVlGAYgASgLMhouZ29vZ2xlLnByb3RvYnVmLkxpc3RWYWx1ZUgAQgYKBGtpbmQiMwoJTGlzdFZhbHVlEiYKBnZhbHVlcxgBIAMoCzIWLmdvb2dsZS5wcm90b2J1Zi5WYWx1ZSobCglOdWxsVmFsdWUSDgoKTlVMTF9WQUxVRRAAQn8KE2NvbS5nb29nbGUucHJvdG9idWZCC1N0cnVjdFByb3RvUAFaL2dvb2dsZS5nb2xhbmcub3JnL3Byb3RvYnVmL3R5cGVzL2tub3duL3N0cnVjdHBi+AEBogIDR1BCqgIeR29vZ2xlLlByb3RvYnVmLldlbGxLbm93blR5cGVzYgZwcm90bzM"), jm = /* @__PURE__ */ ui(Pl, 0), u0 = /* @__PURE__ */ ui(Pl, 1), $m = /* @__PURE__ */ ui(Pl, 2);
var il;
(function(t) {
  t[t.NULL_VALUE = 0] = "NULL_VALUE";
})(il || (il = {}));
const nt = /* @__PURE__ */ ge("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", [Fn]), qm = /* @__PURE__ */ he(nt, 1), me = /* @__PURE__ */ de(qm), e9 = /* @__PURE__ */ he(nt, 2), Je = /* @__PURE__ */ de(e9), t9 = /* @__PURE__ */ he(nt, 3), Rc = /* @__PURE__ */ de(t9), n9 = /* @__PURE__ */ he(nt, 4), fe = /* @__PURE__ */ de(n9), i9 = /* @__PURE__ */ he(nt, 5), We = /* @__PURE__ */ de(i9), s9 = /* @__PURE__ */ he(nt, 6), Se = /* @__PURE__ */ de(s9), Rt = /* @__PURE__ */ ge("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", [r0]), h0 = /* @__PURE__ */ ge("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", [Rt]), Ie = /* @__PURE__ */ ge("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", [Fn, nt, h0]), r9 = /* @__PURE__ */ he(Ie, 1), M = /* @__PURE__ */ de(r9), o9 = /* @__PURE__ */ he(Ie, 3), ve = /* @__PURE__ */ de(o9), l9 = /* @__PURE__ */ he(Ie, 4), a9 = /* @__PURE__ */ de(l9), c9 = /* @__PURE__ */ he(Ie, 6), xe = /* @__PURE__ */ de(c9), u9 = /* @__PURE__ */ he(Ie, 7), h9 = /* @__PURE__ */ de(u9), d9 = /* @__PURE__ */ he(Ie, 8), ot = /* @__PURE__ */ de(d9), m9 = /* @__PURE__ */ he(Ie, 9), d0 = /* @__PURE__ */ de(m9), p9 = /* @__PURE__ */ he(Ie, 10), sl = /* @__PURE__ */ de(p9), g9 = /* @__PURE__ */ he(Ie, 12), ce = /* @__PURE__ */ de(g9), f9 = /* @__PURE__ */ he(Ie, 18), gi = /* @__PURE__ */ de(f9), b9 = /* @__PURE__ */ he(Ie, 19), Ec = /* @__PURE__ */ de(b9), A9 = /* @__PURE__ */ he(Ie, 21), V9 = /* @__PURE__ */ de(A9), R9 = /* @__PURE__ */ he(Ie, 22), Us = /* @__PURE__ */ de(R9), E9 = /* @__PURE__ */ he(Ie, 23), rl = /* @__PURE__ */ de(E9), y9 = /* @__PURE__ */ he(Ie, 24), yc = /* @__PURE__ */ de(y9), C9 = /* @__PURE__ */ he(Ie, 25), W9 = /* @__PURE__ */ de(C9), S9 = /* @__PURE__ */ he(Ie, 26), Bs = /* @__PURE__ */ de(S9), Z9 = /* @__PURE__ */ he(Ie, 27), m0 = /* @__PURE__ */ de(Z9), v9 = /* @__PURE__ */ he(Ie, 36), Ne = /* @__PURE__ */ de(v9), I9 = /* @__PURE__ */ he(Ie, 38), N9 = /* @__PURE__ */ de(I9), F9 = /* @__PURE__ */ he(Ie, 43), G9 = /* @__PURE__ */ de(F9), p0 = /* @__PURE__ */ ge("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", [Rt, Ie, h0]), X9 = /* @__PURE__ */ he(p0, 0), on = /* @__PURE__ */ de(X9), it = /* @__PURE__ */ jt(p0, 0), U9 = /* @__PURE__ */ ge("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"), B9 = /* @__PURE__ */ ge("CkFzdHJlYW1sYXllci9zZGtTZXR0aW5ncy9tb2RlcmF0aW9uL2NvbW1vbi9tb2RlcmF0aW9uX2NvbW1vbi5wcm90bxIpc3RyZWFtbGF5ZXIuc2RrU2V0dGluZ3MubW9kZXJhdGlvbi5jb21tb24ioAIKEU1vZGVyYXRpb25HZW5lcmFsEhUKDWRlZmF1bHRfY29sb3IYASABKAkSDgoGcG9pbnRzGAIgASgNEhoKEmF1dG9faGlkZV9pbnRlcnZhbBgDIAEoBBIgChhpbnNpZ2h0c19oaXN0b3J5X2VuYWJsZWQYBCABKAgSHAoUcGlja19oaXN0b3J5X2VuYWJsZWQYBSABKAgSQgoRY29ycmVjdF9mZWVkYmFja3MYBiADKAsyJy5zdHJlYW1sYXllci5pbnRlcmFjdGl2ZS5BbnN3ZXJGZWVkYmFjaxJEChNpbmNvcnJlY3RfZmVlZGJhY2tzGAcgAygLMicuc3RyZWFtbGF5ZXIuaW50ZXJhY3RpdmUuQW5zd2VyRmVlZGJhY2sibQoXTW9kZXJhdGlvbk5vdGlmaWNhdGlvbnMSFQoNZGVmYXVsdF9pbWFnZRgBIAEoCRI7CgppbWFnZV9tb2RlGAIgASgOMicuc3RyZWFtbGF5ZXIuaW50ZXJhY3RpdmUuUXVlc3Rpb25JbWFnZXMidAoWTW9kZXJhdGlvblNwb25zb3JzaGlwcxIOCgZyb3RhdGUYASABKAgSEgoKbm9fc3BvbnNvchgCIAEoCBI2CghzcG9uc29ycxgDIAMoCzIkLnN0cmVhbWxheWVyLmludGVyYWN0aXZlLlNwb25zb3JzaGlwIpcCChJNb2RlcmF0aW9uU2V0dGluZ3MSTQoHZ2VuZXJhbBgBIAEoCzI8LnN0cmVhbWxheWVyLnNka1NldHRpbmdzLm1vZGVyYXRpb24uY29tbW9uLk1vZGVyYXRpb25HZW5lcmFsElkKDW5vdGlmaWNhdGlvbnMYAiABKAsyQi5zdHJlYW1sYXllci5zZGtTZXR0aW5ncy5tb2RlcmF0aW9uLmNvbW1vbi5Nb2RlcmF0aW9uTm90aWZpY2F0aW9ucxJXCgxzcG9uc29yc2hpcHMYAyABKAsyQS5zdHJlYW1sYXllci5zZGtTZXR0aW5ncy5tb2RlcmF0aW9uLmNvbW1vbi5Nb2RlcmF0aW9uU3BvbnNvcnNoaXBzQuIBCi1jb20uc3RyZWFtbGF5ZXIuc2RrU2V0dGluZ3MubW9kZXJhdGlvbi5jb21tb25CK1N0cmVhbUxheWVyU2RrU2V0dGluZ3NNb2RlcmF0aW9uQ29tbW9uUHJvdG9QAVp5Z2l0aHViLmNvbS9zdHJlYW1sYXllci9zbC1wcm90b2ZpbGVzLy5idWlsZC9nby9zdHJlYW1sYXllci9zZGtTZXR0aW5ncy9tb2RlcmF0aW9uLmNvbW1vbjtzbF9zZGtTZXR0aW5nc19tb2RlcmF0aW9uX2NvbW1vbqICBlNMX0FQSWIGcHJvdG8z", [Ie]), g0 = /* @__PURE__ */ ge("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", [Rt, U9, B9]), w9 = /* @__PURE__ */ he(g0, 0), pe = /* @__PURE__ */ de(w9), _l = /* @__PURE__ */ ge("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", [nt, Fn]), Y9 = /* @__PURE__ */ he(_l, 0), Cc = /* @__PURE__ */ de(Y9), T9 = /* @__PURE__ */ he(_l, 1), Wc = /* @__PURE__ */ de(T9), ze = [];
for (let t = 0; t < 256; ++t)
  ze.push((t + 256).toString(16).slice(1));
function L9(t, e = 0) {
  return (ze[t[e + 0]] + ze[t[e + 1]] + ze[t[e + 2]] + ze[t[e + 3]] + "-" + ze[t[e + 4]] + ze[t[e + 5]] + "-" + ze[t[e + 6]] + ze[t[e + 7]] + "-" + ze[t[e + 8]] + ze[t[e + 9]] + "-" + ze[t[e + 10]] + ze[t[e + 11]] + ze[t[e + 12]] + ze[t[e + 13]] + ze[t[e + 14]] + ze[t[e + 15]]).toLowerCase();
}
let vr;
const k9 = new Uint8Array(16);
function J9() {
  if (!vr) {
    if (typeof crypto > "u" || !crypto.getRandomValues)
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    vr = crypto.getRandomValues.bind(crypto);
  }
  return vr(k9);
}
const x9 = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), Sc = { randomUUID: x9 };
function zn(t, e, n) {
  if (Sc.randomUUID && !t)
    return Sc.randomUUID();
  t = t || {};
  const i = t.random ?? t.rng?.() ?? J9();
  if (i.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return i[6] = i[6] & 15 | 64, i[8] = i[8] & 63 | 128, L9(i);
}
var se;
(function(t) {
  t[t.Canceled = 1] = "Canceled", t[t.Unknown = 2] = "Unknown", t[t.InvalidArgument = 3] = "InvalidArgument", t[t.DeadlineExceeded = 4] = "DeadlineExceeded", t[t.NotFound = 5] = "NotFound", t[t.AlreadyExists = 6] = "AlreadyExists", t[t.PermissionDenied = 7] = "PermissionDenied", t[t.ResourceExhausted = 8] = "ResourceExhausted", t[t.FailedPrecondition = 9] = "FailedPrecondition", t[t.Aborted = 10] = "Aborted", t[t.OutOfRange = 11] = "OutOfRange", t[t.Unimplemented = 12] = "Unimplemented", t[t.Internal = 13] = "Internal", t[t.Unavailable = 14] = "Unavailable", t[t.DataLoss = 15] = "DataLoss", t[t.Unauthenticated = 16] = "Unauthenticated";
})(se || (se = {}));
function M9(t, e) {
  f0(e, t);
  const n = z9(t.$unknown, e), [i, s, r] = Ds(e);
  for (const o of n)
    l0(i, new Jl(o.data), s, o.wireType, {
      readUnknownFields: !0
    });
  return r();
}
function Q9(t, e, n) {
  var i;
  f0(e, t);
  const s = ((i = t.$unknown) !== null && i !== void 0 ? i : []).filter((c) => c.no !== e.number), [r, o] = Ds(e, n), l = new Qd();
  n0(l, { writeUnknownFields: !0 }, r, o);
  const a = new Jl(l.finish());
  for (; a.pos < a.len; ) {
    const [c, u] = a.tag(), h = a.skip(u, c);
    s.push({ no: c, wireType: u, data: h });
  }
  t.$unknown = s;
}
function z9(t, e) {
  if (t === void 0)
    return [];
  if (e.fieldKind === "enum" || e.fieldKind === "scalar") {
    for (let n = t.length - 1; n >= 0; --n)
      if (t[n].no == e.number)
        return [t[n]];
    return [];
  }
  return t.filter((n) => n.no === e.number);
}
function Ds(t, e) {
  const n = t.typeName, i = Object.assign(Object.assign({}, t), { kind: "field", parent: t.extendee, localName: n }), s = Object.assign(Object.assign({}, t.extendee), { fields: [i], members: [i], oneofs: [] }), r = At(s, e !== void 0 ? { [n]: e } : void 0);
  return [
    ut(s, r),
    i,
    () => {
      const o = r[n];
      if (o === void 0) {
        const l = t.message;
        return Yi(l) ? Wn(l.fields[0].scalar, l.fields[0].longAsString) : At(l);
      }
      return o;
    }
  ];
}
function f0(t, e) {
  if (t.extendee.typeName != e.$typeName)
    throw new Error(`extension ${t.typeName} can only be applied to message ${t.extendee.typeName}`);
}
const K9 = 3, H9 = 2, Zc = {
  alwaysEmitImplicit: !1,
  enumAsInteger: !1,
  useProtoFieldName: !1
};
function O9(t) {
  return t ? Object.assign(Object.assign({}, Zc), t) : Zc;
}
function D9(t, e, n) {
  return Li(ut(t, e), O9(n));
}
function P9(t, e, n) {
  var i;
  const s = D9(t, e, n);
  return JSON.stringify(s, null, (i = n?.prettySpaces) !== null && i !== void 0 ? i : 0);
}
function Li(t, e) {
  var n;
  const i = q9(t, e);
  if (i !== void 0)
    return i;
  const s = {};
  for (const r of t.sortedFields) {
    if (!t.isSet(r)) {
      if (r.presence == K9)
        throw new Error(`cannot encode field ${t.desc.typeName}.${r.name} to JSON: required field not set`);
      if (!e.alwaysEmitImplicit || r.presence !== H9)
        continue;
    }
    const o = vc(r, t.get(r), e);
    o !== void 0 && (s[$9(r, e)] = o);
  }
  if (e.registry) {
    const r = /* @__PURE__ */ new Set();
    for (const o of (n = t.getUnknown()) !== null && n !== void 0 ? n : []) {
      if (r.has(o.no))
        continue;
      const l = e.registry.getExtensionFor(t.desc, o.no);
      if (!l)
        continue;
      const a = M9(t.message, l), [c, u] = Ds(l, a), h = vc(u, c.get(u), e);
      h !== void 0 && (s[l.jsonName] = h);
    }
  }
  return s;
}
function vc(t, e, n) {
  switch (t.fieldKind) {
    case "scalar":
      return Ps(t, e);
    case "message":
      return Li(e, n);
    case "enum":
      return jl(t.enum, e, n.enumAsInteger);
    case "list":
      return j9(e, n);
    case "map":
      return _9(e, n);
  }
}
function _9(t, e) {
  const n = t.field(), i = {};
  switch (n.mapKind) {
    case "scalar":
      for (const [s, r] of t)
        i[s] = Ps(n, r);
      break;
    case "message":
      for (const [s, r] of t)
        i[s] = Li(r, e);
      break;
    case "enum":
      for (const [s, r] of t)
        i[s] = jl(n.enum, r, e.enumAsInteger);
      break;
  }
  return e.alwaysEmitImplicit || t.size > 0 ? i : void 0;
}
function j9(t, e) {
  const n = t.field(), i = [];
  switch (n.listKind) {
    case "scalar":
      for (const s of t)
        i.push(Ps(n, s));
      break;
    case "enum":
      for (const s of t)
        i.push(jl(n.enum, s, e.enumAsInteger));
      break;
    case "message":
      for (const s of t)
        i.push(Li(s, e));
      break;
  }
  return e.alwaysEmitImplicit || i.length > 0 ? i : void 0;
}
function jl(t, e, n) {
  var i;
  if (typeof e != "number")
    throw new Error(`cannot encode ${t} to JSON: expected number, got ${Me(e)}`);
  if (t.typeName == "google.protobuf.NullValue")
    return null;
  if (n)
    return e;
  const s = t.value[e];
  return (i = s?.name) !== null && i !== void 0 ? i : e;
}
function Ps(t, e) {
  var n, i, s, r, o, l;
  switch (t.scalar) {
    // int32, fixed32, uint32: JSON value will be a decimal number. Either numbers or strings are accepted.
    case I.INT32:
    case I.SFIXED32:
    case I.SINT32:
    case I.FIXED32:
    case I.UINT32:
      if (typeof e != "number")
        throw new Error(`cannot encode ${t} to JSON: ${(n = fn(t, e)) === null || n === void 0 ? void 0 : n.message}`);
      return e;
    // float, double: JSON value will be a number or one of the special string values "NaN", "Infinity", and "-Infinity".
    // Either numbers or strings are accepted. Exponent notation is also accepted.
    case I.FLOAT:
    case I.DOUBLE:
      if (typeof e != "number")
        throw new Error(`cannot encode ${t} to JSON: ${(i = fn(t, e)) === null || i === void 0 ? void 0 : i.message}`);
      return isNaN(e) ? "NaN" : e === Number.POSITIVE_INFINITY ? "Infinity" : e === Number.NEGATIVE_INFINITY ? "-Infinity" : e;
    // string:
    case I.STRING:
      if (typeof e != "string")
        throw new Error(`cannot encode ${t} to JSON: ${(s = fn(t, e)) === null || s === void 0 ? void 0 : s.message}`);
      return e;
    // bool:
    case I.BOOL:
      if (typeof e != "boolean")
        throw new Error(`cannot encode ${t} to JSON: ${(r = fn(t, e)) === null || r === void 0 ? void 0 : r.message}`);
      return e;
    // JSON value will be a decimal string. Either numbers or strings are accepted.
    case I.UINT64:
    case I.FIXED64:
    case I.INT64:
    case I.SFIXED64:
    case I.SINT64:
      if (typeof e != "bigint" && typeof e != "string")
        throw new Error(`cannot encode ${t} to JSON: ${(o = fn(t, e)) === null || o === void 0 ? void 0 : o.message}`);
      return e.toString();
    // bytes: JSON value will be the data encoded as a string using standard base64 encoding with paddings.
    // Either standard or URL-safe base64 encoding with/without paddings are accepted.
    case I.BYTES:
      if (e instanceof Uint8Array)
        return Am(e);
      throw new Error(`cannot encode ${t} to JSON: ${(l = fn(t, e)) === null || l === void 0 ? void 0 : l.message}`);
  }
}
function $9(t, e) {
  return e.useProtoFieldName ? t.name : t.jsonName;
}
function q9(t, e) {
  if (t.desc.typeName.startsWith("google.protobuf."))
    switch (t.desc.typeName) {
      case "google.protobuf.Any":
        return ep(t.message, e);
      case "google.protobuf.Timestamp":
        return ip(t.message);
      case "google.protobuf.Duration":
        return tp(t.message);
      case "google.protobuf.FieldMask":
        return np(t.message);
      case "google.protobuf.Struct":
        return b0(t.message);
      case "google.protobuf.Value":
        return $l(t.message);
      case "google.protobuf.ListValue":
        return A0(t.message);
      default:
        if (Yi(t.desc)) {
          const n = t.desc.fields[0];
          return Ps(n, t.get(n));
        }
        return;
    }
}
function ep(t, e) {
  if (t.typeUrl === "")
    return {};
  const { registry: n } = e;
  let i, s;
  if (n && (i = Pm(t, n), i && (s = n.getMessage(i.$typeName))), !s || !i)
    throw new Error(`cannot encode message ${t.$typeName} to JSON: "${t.typeUrl}" is not in the type registry`);
  let r = Li(ut(s, i), e);
  return (s.typeName.startsWith("google.protobuf.") || r === null || Array.isArray(r) || typeof r != "object") && (r = { value: r }), r["@type"] = t.typeUrl, r;
}
function tp(t) {
  if (Number(t.seconds) > 315576e6 || Number(t.seconds) < -315576e6)
    throw new Error(`cannot encode message ${t.$typeName} to JSON: value out of range`);
  let e = t.seconds.toString();
  if (t.nanos !== 0) {
    let n = Math.abs(t.nanos).toString();
    n = "0".repeat(9 - n.length) + n, n.substring(3) === "000000" ? n = n.substring(0, 3) : n.substring(6) === "000" && (n = n.substring(0, 6)), e += "." + n, t.nanos < 0 && Number(t.seconds) == 0 && (e = "-" + e);
  }
  return e + "s";
}
function np(t) {
  return t.paths.map((e) => {
    if (e.match(/_[0-9]?_/g) || e.match(/[A-Z]/g))
      throw new Error(`cannot encode message ${t.$typeName} to JSON: lowerCamelCase of path name "` + e + '" is irreversible');
    return Ni(e);
  }).join(",");
}
function b0(t) {
  const e = {};
  for (const [n, i] of Object.entries(t.fields))
    e[n] = $l(i);
  return e;
}
function $l(t) {
  switch (t.kind.case) {
    case "nullValue":
      return null;
    case "numberValue":
      if (!Number.isFinite(t.kind.value))
        throw new Error(`${t.$typeName} cannot be NaN or Infinity`);
      return t.kind.value;
    case "boolValue":
      return t.kind.value;
    case "stringValue":
      return t.kind.value;
    case "structValue":
      return b0(t.kind.value);
    case "listValue":
      return A0(t.kind.value);
    default:
      throw new Error(`${t.$typeName} must have a value`);
  }
}
function A0(t) {
  return t.values.map($l);
}
function ip(t) {
  const e = Number(t.seconds) * 1e3;
  if (e < Date.parse("0001-01-01T00:00:00Z") || e > Date.parse("9999-12-31T23:59:59Z"))
    throw new Error(`cannot encode message ${t.$typeName} to JSON: must be from 0001-01-01T00:00:00Z to 9999-12-31T23:59:59Z inclusive`);
  if (t.nanos < 0)
    throw new Error(`cannot encode message ${t.$typeName} to JSON: nanos must not be negative`);
  let n = "Z";
  if (t.nanos > 0) {
    const i = (t.nanos + 1e9).toString().substring(1);
    i.substring(3) === "000000" ? n = "." + i.substring(0, 3) + "Z" : i.substring(6) === "000" ? n = "." + i.substring(0, 6) + "Z" : n = "." + i + "Z";
  }
  return new Date(e).toISOString().replace(".000Z", n);
}
const Ic = {
  ignoreUnknownFields: !1
};
function sp(t) {
  return t ? Object.assign(Object.assign({}, Ic), t) : Ic;
}
function rp(t, e, n) {
  return op(t, mp(e, t.typeName), n);
}
function op(t, e, n) {
  const i = ut(t);
  try {
    ni(i, e, sp(n));
  } catch (s) {
    throw Em(s) ? new Error(`cannot decode ${s.field()} from JSON: ${s.message}`, {
      cause: s
    }) : s;
  }
  return i.message;
}
function ni(t, e, n) {
  var i;
  if (pp(t, e, n))
    return;
  if (e == null || Array.isArray(e) || typeof e != "object")
    throw new Error(`cannot decode ${t.desc} from JSON: ${Me(e)}`);
  const s = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  for (const o of t.desc.fields)
    r.set(o.name, o).set(o.jsonName, o);
  for (const [o, l] of Object.entries(e)) {
    const a = r.get(o);
    if (a) {
      if (a.oneof) {
        if (l === null && a.fieldKind == "scalar")
          continue;
        const c = s.get(a.oneof);
        if (c !== void 0)
          throw new je(a.oneof, `oneof set multiple times by ${c.name} and ${a.name}`);
        s.set(a.oneof, a);
      }
      Nc(t, a, l, n);
    } else {
      let c;
      if (o.startsWith("[") && o.endsWith("]") && (c = (i = n.registry) === null || i === void 0 ? void 0 : i.getExtension(o.substring(1, o.length - 1))) && c.extendee.typeName === t.desc.typeName) {
        const [u, h, d] = Ds(c);
        Nc(u, h, l, n), Q9(t.message, c, d());
      }
      if (!c && !n.ignoreUnknownFields)
        throw new Error(`cannot decode ${t.desc} from JSON: key "${o}" is unknown`);
    }
  }
}
function Nc(t, e, n, i) {
  switch (e.fieldKind) {
    case "scalar":
      hp(t, e, n);
      break;
    case "enum":
      up(t, e, n, i);
      break;
    case "message":
      cp(t, e, n, i);
      break;
    case "list":
      ap(t.get(e), n, i);
      break;
    case "map":
      lp(t.get(e), n, i);
      break;
  }
}
function lp(t, e, n) {
  if (e === null)
    return;
  const i = t.field();
  if (typeof e != "object" || Array.isArray(e))
    throw new je(i, "expected object, got " + Me(e));
  for (const [s, r] of Object.entries(e)) {
    if (r === null)
      throw new je(i, "map value must not be null");
    let o;
    switch (i.mapKind) {
      case "message":
        const a = ut(i.message);
        ni(a, r, n), o = a;
        break;
      case "enum":
        if (o = ql(i.enum, r, n.ignoreUnknownFields, !0), o === _s)
          return;
        break;
      case "scalar":
        o = $s(i, r, !0);
        break;
    }
    const l = dp(i.mapKey, s);
    t.set(l, o);
  }
}
function ap(t, e, n) {
  if (e === null)
    return;
  const i = t.field();
  if (!Array.isArray(e))
    throw new je(i, "expected Array, got " + Me(e));
  for (const s of e) {
    if (s === null)
      throw new je(i, "list item must not be null");
    switch (i.listKind) {
      case "message":
        const r = ut(i.message);
        ni(r, s, n), t.add(r);
        break;
      case "enum":
        const o = ql(i.enum, s, n.ignoreUnknownFields, !0);
        o !== _s && t.add(o);
        break;
      case "scalar":
        t.add($s(i, s, !0));
        break;
    }
  }
}
function cp(t, e, n, i) {
  if (n === null && e.message.typeName != "google.protobuf.Value") {
    t.clear(e);
    return;
  }
  const s = t.isSet(e) ? t.get(e) : ut(e.message);
  ni(s, n, i), t.set(e, s);
}
function up(t, e, n, i) {
  const s = ql(e.enum, n, i.ignoreUnknownFields, !1);
  s === js ? t.clear(e) : s !== _s && t.set(e, s);
}
function hp(t, e, n) {
  const i = $s(e, n, !1);
  i === js ? t.clear(e) : t.set(e, i);
}
const _s = /* @__PURE__ */ Symbol();
function ql(t, e, n, i) {
  if (e === null)
    return t.typeName == "google.protobuf.NullValue" ? 0 : i ? t.values[0].number : js;
  switch (typeof e) {
    case "number":
      if (Number.isInteger(e))
        return e;
      break;
    case "string":
      const s = t.values.find((r) => r.name === e);
      if (s !== void 0)
        return s.number;
      if (n)
        return _s;
      break;
  }
  throw new Error(`cannot decode ${t} from JSON: ${Me(e)}`);
}
const js = /* @__PURE__ */ Symbol();
function $s(t, e, n) {
  if (e === null)
    return n ? Wn(t.scalar, !1) : js;
  switch (t.scalar) {
    // float, double: JSON value will be a number or one of the special string values "NaN", "Infinity", and "-Infinity".
    // Either numbers or strings are accepted. Exponent notation is also accepted.
    case I.DOUBLE:
    case I.FLOAT:
      if (e === "NaN")
        return NaN;
      if (e === "Infinity")
        return Number.POSITIVE_INFINITY;
      if (e === "-Infinity")
        return Number.NEGATIVE_INFINITY;
      if (typeof e == "number") {
        if (isNaN(e))
          throw new je(t, "unexpected NaN number");
        if (!isFinite(e))
          throw new je(t, "unexpected infinite number");
        break;
      }
      if (typeof e == "string") {
        if (e === "" || e.trim().length !== e.length)
          break;
        const i = Number(e);
        if (!isFinite(i))
          break;
        return i;
      }
      break;
    // int32, fixed32, uint32: JSON value will be a decimal number. Either numbers or strings are accepted.
    case I.INT32:
    case I.FIXED32:
    case I.SFIXED32:
    case I.SINT32:
    case I.UINT32:
      return V0(e);
    // bytes: JSON value will be the data encoded as a string using standard base64 encoding with paddings.
    // Either standard or URL-safe base64 encoding with/without paddings are accepted.
    case I.BYTES:
      if (typeof e == "string") {
        if (e === "")
          return new Uint8Array(0);
        try {
          return Bl(e);
        } catch (i) {
          const s = i instanceof Error ? i.message : String(i);
          throw new je(t, s);
        }
      }
      break;
  }
  return e;
}
function dp(t, e) {
  switch (t) {
    case I.BOOL:
      switch (e) {
        case "true":
          return !0;
        case "false":
          return !1;
      }
      return e;
    case I.INT32:
    case I.FIXED32:
    case I.UINT32:
    case I.SFIXED32:
    case I.SINT32:
      return V0(e);
    default:
      return e;
  }
}
function V0(t) {
  if (typeof t == "string") {
    if (t === "" || t.trim().length !== t.length)
      return t;
    const e = Number(t);
    return Number.isNaN(e) ? t : e;
  }
  return t;
}
function mp(t, e) {
  try {
    return JSON.parse(t);
  } catch (n) {
    const i = n instanceof Error ? n.message : String(n);
    throw new Error(
      `cannot decode message ${e} from JSON: ${i}`,
      // @ts-expect-error we use the ES2022 error CTOR option "cause" for better stack traces
      { cause: n }
    );
  }
}
function pp(t, e, n) {
  if (!t.desc.typeName.startsWith("google.protobuf."))
    return !1;
  switch (t.desc.typeName) {
    case "google.protobuf.Any":
      return gp(t.message, e, n), !0;
    case "google.protobuf.Timestamp":
      return fp(t.message, e), !0;
    case "google.protobuf.Duration":
      return bp(t.message, e), !0;
    case "google.protobuf.FieldMask":
      return Ap(t.message, e), !0;
    case "google.protobuf.Struct":
      return R0(t.message, e), !0;
    case "google.protobuf.Value":
      return ea(t.message, e), !0;
    case "google.protobuf.ListValue":
      return E0(t.message, e), !0;
    default:
      if (Yi(t.desc)) {
        const i = t.desc.fields[0];
        return e === null ? t.clear(i) : t.set(i, $s(i, e, !0)), !0;
      }
      return !1;
  }
}
function gp(t, e, n) {
  var i;
  if (e === null || Array.isArray(e) || typeof e != "object")
    throw new Error(`cannot decode message ${t.$typeName} from JSON: expected object but got ${Me(e)}`);
  if (Object.keys(e).length == 0)
    return;
  const s = e["@type"];
  if (typeof s != "string" || s == "")
    throw new Error(`cannot decode message ${t.$typeName} from JSON: "@type" is empty`);
  const r = s.includes("/") ? s.substring(s.lastIndexOf("/") + 1) : s;
  if (!r.length)
    throw new Error(`cannot decode message ${t.$typeName} from JSON: "@type" is invalid`);
  const o = (i = n.registry) === null || i === void 0 ? void 0 : i.getMessage(r);
  if (!o)
    throw new Error(`cannot decode message ${t.$typeName} from JSON: ${s} is not in the type registry`);
  const l = ut(o);
  if (r.startsWith("google.protobuf.") && Object.prototype.hasOwnProperty.call(e, "value")) {
    const a = e.value;
    ni(l, a, n);
  } else {
    const a = Object.assign({}, e);
    delete a["@type"], ni(l, a, n);
  }
  Om(l.desc, l.message, t);
}
function fp(t, e) {
  if (typeof e != "string")
    throw new Error(`cannot decode message ${t.$typeName} from JSON: ${Me(e)}`);
  const n = e.match(/^([0-9]{4})-([0-9]{2})-([0-9]{2})T([0-9]{2}):([0-9]{2}):([0-9]{2})(?:\.([0-9]{1,9}))?(?:Z|([+-][0-9][0-9]:[0-9][0-9]))$/);
  if (!n)
    throw new Error(`cannot decode message ${t.$typeName} from JSON: invalid RFC 3339 string`);
  const i = Date.parse(
    //prettier-ignore
    n[1] + "-" + n[2] + "-" + n[3] + "T" + n[4] + ":" + n[5] + ":" + n[6] + (n[8] ? n[8] : "Z")
  );
  if (Number.isNaN(i))
    throw new Error(`cannot decode message ${t.$typeName} from JSON: invalid RFC 3339 string`);
  if (i < Date.parse("0001-01-01T00:00:00Z") || i > Date.parse("9999-12-31T23:59:59Z"))
    throw new Error(`cannot decode message ${t.$typeName} from JSON: must be from 0001-01-01T00:00:00Z to 9999-12-31T23:59:59Z inclusive`);
  t.seconds = Ze.parse(i / 1e3), t.nanos = 0, n[7] && (t.nanos = parseInt("1" + n[7] + "0".repeat(9 - n[7].length)) - 1e9);
}
function bp(t, e) {
  if (typeof e != "string")
    throw new Error(`cannot decode message ${t.$typeName} from JSON: ${Me(e)}`);
  const n = e.match(/^(-?[0-9]+)(?:\.([0-9]+))?s/);
  if (n === null)
    throw new Error(`cannot decode message ${t.$typeName} from JSON: ${Me(e)}`);
  const i = Number(n[1]);
  if (i > 315576e6 || i < -315576e6)
    throw new Error(`cannot decode message ${t.$typeName} from JSON: ${Me(e)}`);
  if (t.seconds = Ze.parse(i), typeof n[2] != "string")
    return;
  const s = n[2] + "0".repeat(9 - n[2].length);
  t.nanos = parseInt(s), (i < 0 || Object.is(i, -0)) && (t.nanos = -t.nanos);
}
function Ap(t, e) {
  if (typeof e != "string")
    throw new Error(`cannot decode message ${t.$typeName} from JSON: ${Me(e)}`);
  if (e === "")
    return;
  function n(i) {
    if (i.includes("_"))
      throw new Error(`cannot decode message ${t.$typeName} from JSON: path names must be lowerCamelCase`);
    const s = i.replace(/[A-Z]/g, (r) => "_" + r.toLowerCase());
    return s[0] === "_" ? s.substring(1) : s;
  }
  t.paths = e.split(",").map(n);
}
function R0(t, e) {
  if (typeof e != "object" || e == null || Array.isArray(e))
    throw new Error(`cannot decode message ${t.$typeName} from JSON ${Me(e)}`);
  for (const [n, i] of Object.entries(e)) {
    const s = At(u0);
    ea(s, i), t.fields[n] = s;
  }
}
function ea(t, e) {
  switch (typeof e) {
    case "number":
      t.kind = { case: "numberValue", value: e };
      break;
    case "string":
      t.kind = { case: "stringValue", value: e };
      break;
    case "boolean":
      t.kind = { case: "boolValue", value: e };
      break;
    case "object":
      if (e === null)
        t.kind = { case: "nullValue", value: il.NULL_VALUE };
      else if (Array.isArray(e)) {
        const n = At($m);
        E0(n, e), t.kind = { case: "listValue", value: n };
      } else {
        const n = At(jm);
        R0(n, e), t.kind = { case: "structValue", value: n };
      }
      break;
    default:
      throw new Error(`cannot decode message ${t.$typeName} from JSON ${Me(e)}`);
  }
  return t;
}
function E0(t, e) {
  if (!Array.isArray(e))
    throw new Error(`cannot decode message ${t.$typeName} from JSON ${Me(e)}`);
  for (const n of e) {
    const i = At(u0);
    ea(i, n), t.values.push(i);
  }
}
function Fc(t) {
  const e = se[t];
  return typeof e != "string" ? t.toString() : e[0].toLowerCase() + e.substring(1).replace(/[A-Z]/g, (n) => "_" + n.toLowerCase());
}
class Ae extends Error {
  /**
   * Create a new ConnectError.
   * If no code is provided, code "unknown" is used.
   * Outgoing details are only relevant for the server side - a service may
   * raise an error with details, and it is up to the protocol implementation
   * to encode and send the details along with error.
   */
  constructor(e, n = se.Unknown, i, s, r) {
    super(Vp(e, n)), this.name = "ConnectError", Object.setPrototypeOf(this, new.target.prototype), this.rawMessage = e, this.code = n, this.metadata = new Headers(i ?? {}), this.details = s ?? [], this.cause = r;
  }
  /**
   * Convert any value - typically a caught error into a ConnectError,
   * following these rules:
   * - If the value is already a ConnectError, return it as is.
   * - If the value is an AbortError from the fetch API, return the message
   *   of the AbortError with code Canceled.
   * - For other Errors, return the error message with code Unknown by default.
   * - For other values, return the values String representation as a message,
   *   with the code Unknown by default.
   * The original value will be used for the "cause" property for the new
   * ConnectError.
   */
  static from(e, n = se.Unknown) {
    return e instanceof Ae ? e : e instanceof Error ? e.name == "AbortError" ? new Ae(e.message, se.Canceled) : new Ae(e.message, n, void 0, void 0, e) : new Ae(String(e), n, void 0, void 0, e);
  }
  static [Symbol.hasInstance](e) {
    return e instanceof Error ? Object.getPrototypeOf(e) === Ae.prototype ? !0 : e.name === "ConnectError" && "code" in e && typeof e.code == "number" && "metadata" in e && "details" in e && Array.isArray(e.details) && "rawMessage" in e && typeof e.rawMessage == "string" && "cause" in e : !1;
  }
  findDetails(e) {
    const n = e.kind === "message" ? {
      getMessage: (s) => s === e.typeName ? e : void 0
    } : e, i = [];
    for (const s of this.details) {
      if ("desc" in s) {
        n.getMessage(s.desc.typeName) && i.push(At(s.desc, s.value));
        continue;
      }
      const r = n.getMessage(s.type);
      if (r)
        try {
          i.push(Ti(r, s.value));
        } catch {
        }
    }
    return i;
  }
}
function Vp(t, e) {
  return t.length ? `[${Fc(e)}] ${t}` : `[${Fc(e)}]`;
}
function Rp(t, e, n) {
  try {
    const i = Bl(t);
    return e ? Ti(e, i, n) : i;
  } catch (i) {
    throw Ae.from(i, se.DataLoss);
  }
}
function Ep(t, e) {
  const n = {};
  for (const i of t.methods) {
    const s = e(i);
    s != null && (n[i.localName] = s);
  }
  return n;
}
const Gc = 1;
function Xc(t) {
  let e, n = new Uint8Array(0);
  function i(s) {
    const r = new Uint8Array(n.length + s.length);
    r.set(n), r.set(s, n.length), n = r;
  }
  return new ReadableStream({
    start() {
      e = t.getReader();
    },
    async pull(s) {
      let r;
      for (; ; ) {
        if (r === void 0 && n.byteLength >= 5) {
          let a = 0;
          for (let c = 1; c < 5; c++)
            a = (a << 8) + n[c];
          r = { flags: n[0], length: a };
        }
        if (r !== void 0 && n.byteLength >= r.length + 5)
          break;
        const l = await e.read();
        if (l.done)
          break;
        i(l.value);
      }
      if (r === void 0) {
        if (n.byteLength == 0) {
          s.close();
          return;
        }
        s.error(new Ae("premature end of stream", se.DataLoss));
        return;
      }
      const o = n.subarray(5, 5 + r.length);
      n = n.subarray(5 + r.length), s.enqueue({
        flags: r.flags,
        data: o
      });
    }
  });
}
function Uc(t, e) {
  const n = new Uint8Array(e.length + 5);
  n.set(e, 5);
  const i = new DataView(n.buffer, n.byteOffset, n.byteLength);
  return i.setUint8(0, t), i.setUint32(1, e.length), n;
}
var yp = function(t) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var e = t[Symbol.asyncIterator], n;
  return e ? e.call(t) : (t = typeof __values == "function" ? __values(t) : t[Symbol.iterator](), n = {}, i("next"), i("throw"), i("return"), n[Symbol.asyncIterator] = function() {
    return this;
  }, n);
  function i(r) {
    n[r] = t[r] && function(o) {
      return new Promise(function(l, a) {
        o = t[r](o), s(l, a, o.done, o.value);
      });
    };
  }
  function s(r, o, l, a) {
    Promise.resolve(a).then(function(c) {
      r({ value: c, done: l });
    }, o);
  }
}, Xi = function(t) {
  return this instanceof Xi ? (this.v = t, this) : new Xi(t);
}, Cp = function(t, e, n) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var i = n.apply(t, e || []), s, r = [];
  return s = Object.create((typeof AsyncIterator == "function" ? AsyncIterator : Object).prototype), l("next"), l("throw"), l("return", o), s[Symbol.asyncIterator] = function() {
    return this;
  }, s;
  function o(m) {
    return function(p) {
      return Promise.resolve(p).then(m, h);
    };
  }
  function l(m, p) {
    i[m] && (s[m] = function(g) {
      return new Promise(function(A, b) {
        r.push([m, g, A, b]) > 1 || a(m, g);
      });
    }, p && (s[m] = p(s[m])));
  }
  function a(m, p) {
    try {
      c(i[m](p));
    } catch (g) {
      d(r[0][3], g);
    }
  }
  function c(m) {
    m.value instanceof Xi ? Promise.resolve(m.value.v).then(u, h) : d(r[0][2], m);
  }
  function u(m) {
    a("next", m);
  }
  function h(m) {
    a("throw", m);
  }
  function d(m, p) {
    m(p), r.shift(), r.length && a(r[0][0], r[0][1]);
  }
}, Wp = function(t) {
  var e, n;
  return e = {}, i("next"), i("throw", function(s) {
    throw s;
  }), i("return"), e[Symbol.iterator] = function() {
    return this;
  }, e;
  function i(s, r) {
    e[s] = t[s] ? function(o) {
      return (n = !n) ? { value: Xi(t[s](o)), done: !1 } : r ? r(o) : o;
    } : r;
  }
};
function Sp(t) {
  return Cp(this, arguments, function* () {
    yield Xi(yield* Wp(yp(t)));
  });
}
var y0 = function(t) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var e = t[Symbol.asyncIterator], n;
  return e ? e.call(t) : (t = typeof __values == "function" ? __values(t) : t[Symbol.iterator](), n = {}, i("next"), i("throw"), i("return"), n[Symbol.asyncIterator] = function() {
    return this;
  }, n);
  function i(r) {
    n[r] = t[r] && function(o) {
      return new Promise(function(l, a) {
        o = t[r](o), s(l, a, o.done, o.value);
      });
    };
  }
  function s(r, o, l, a) {
    Promise.resolve(a).then(function(c) {
      r({ value: c, done: l });
    }, o);
  }
}, ii = function(t) {
  return this instanceof ii ? (this.v = t, this) : new ii(t);
}, Zp = function(t) {
  var e, n;
  return e = {}, i("next"), i("throw", function(s) {
    throw s;
  }), i("return"), e[Symbol.iterator] = function() {
    return this;
  }, e;
  function i(s, r) {
    e[s] = t[s] ? function(o) {
      return (n = !n) ? { value: ii(t[s](o)), done: !1 } : r ? r(o) : o;
    } : r;
  }
}, vp = function(t, e, n) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var i = n.apply(t, e || []), s, r = [];
  return s = Object.create((typeof AsyncIterator == "function" ? AsyncIterator : Object).prototype), l("next"), l("throw"), l("return", o), s[Symbol.asyncIterator] = function() {
    return this;
  }, s;
  function o(m) {
    return function(p) {
      return Promise.resolve(p).then(m, h);
    };
  }
  function l(m, p) {
    i[m] && (s[m] = function(g) {
      return new Promise(function(A, b) {
        r.push([m, g, A, b]) > 1 || a(m, g);
      });
    }, p && (s[m] = p(s[m])));
  }
  function a(m, p) {
    try {
      c(i[m](p));
    } catch (g) {
      d(r[0][3], g);
    }
  }
  function c(m) {
    m.value instanceof ii ? Promise.resolve(m.value.v).then(u, h) : d(r[0][2], m);
  }
  function u(m) {
    a("next", m);
  }
  function h(m) {
    a("throw", m);
  }
  function d(m, p) {
    m(p), r.shift(), r.length && a(r[0][0], r[0][1]);
  }
};
function Bc(t, e) {
  return Ep(t, (n) => {
    switch (n.methodKind) {
      case "unary":
        return Ip(e, n);
      case "server_streaming":
        return Np(e, n);
      case "client_streaming":
        return Fp(e, n);
      case "bidi_streaming":
        return Gp(e, n);
      default:
        return null;
    }
  });
}
function Ip(t, e) {
  return async function(n, i) {
    var s, r;
    const o = await t.unary(e, i?.signal, i?.timeoutMs, i?.headers, n, i?.contextValues);
    return (s = i?.onHeader) === null || s === void 0 || s.call(i, o.header), (r = i?.onTrailer) === null || r === void 0 || r.call(i, o.trailer), o.message;
  };
}
function Np(t, e) {
  return function(n, i) {
    return C0(t.stream(e, i?.signal, i?.timeoutMs, i?.headers, Sp([n]), i?.contextValues), i);
  };
}
function Fp(t, e) {
  return async function(n, i) {
    var s, r, o, l, a, c;
    const u = await t.stream(e, i?.signal, i?.timeoutMs, i?.headers, n, i?.contextValues);
    (a = i?.onHeader) === null || a === void 0 || a.call(i, u.header);
    let h, d = 0;
    try {
      for (var m = !0, p = y0(u.message), g; g = await p.next(), s = g.done, !s; m = !0)
        l = g.value, m = !1, h = l, d++;
    } catch (A) {
      r = { error: A };
    } finally {
      try {
        !m && !s && (o = p.return) && await o.call(p);
      } finally {
        if (r) throw r.error;
      }
    }
    if (!h)
      throw new Ae("protocol error: missing response message", se.Unimplemented);
    if (d > 1)
      throw new Ae("protocol error: received extra messages for client streaming method", se.Unimplemented);
    return (c = i?.onTrailer) === null || c === void 0 || c.call(i, u.trailer), h;
  };
}
function Gp(t, e) {
  return function(n, i) {
    return C0(t.stream(e, i?.signal, i?.timeoutMs, i?.headers, n, i?.contextValues), i);
  };
}
function C0(t, e) {
  const n = (function() {
    return vp(this, arguments, function* () {
      var i, s;
      const r = yield ii(t);
      (i = e?.onHeader) === null || i === void 0 || i.call(e, r.header), yield ii(yield* Zp(y0(r.message))), (s = e?.onTrailer) === null || s === void 0 || s.call(e, r.trailer);
    });
  })()[Symbol.asyncIterator]();
  return {
    [Symbol.asyncIterator]: () => ({
      next: () => n.next()
    })
  };
}
function Xp(...t) {
  const e = new AbortController(), n = t.filter((s) => s !== void 0).concat(e.signal);
  for (const s of n) {
    if (s.aborted) {
      i.apply(s);
      break;
    }
    s.addEventListener("abort", i);
  }
  function i() {
    e.signal.aborted || e.abort(W0(this));
    for (const s of n)
      s.removeEventListener("abort", i);
  }
  return e;
}
function Up(t) {
  const e = new AbortController(), n = () => {
    e.abort(new Ae("the operation timed out", se.DeadlineExceeded));
  };
  let i;
  return t !== void 0 && (t <= 0 ? n() : i = setTimeout(n, t)), {
    signal: e.signal,
    cleanup: () => clearTimeout(i)
  };
}
function W0(t) {
  if (!t.aborted)
    return;
  if (t.reason !== void 0)
    return t.reason;
  const e = new Error("This operation was aborted");
  return e.name = "AbortError", e;
}
function ol() {
  return {
    get(t) {
      return t.id in this ? this[t.id] : t.defaultValue;
    },
    set(t, e) {
      return this[t.id] = e, this;
    },
    delete(t) {
      return delete this[t.id], this;
    }
  };
}
function ws(t, e) {
  return { id: Symbol(e?.description), defaultValue: t };
}
const Ir = 128;
function wc(t) {
  const e = new Headers(), n = new TextDecoder().decode(t).split(`\r
`);
  for (const i of n) {
    if (i === "")
      continue;
    const s = i.indexOf(":");
    if (s > 0) {
      const r = i.substring(0, s).trim(), o = i.substring(s + 1).trim();
      e.append(r, o);
    }
  }
  return e;
}
const Bp = "Content-Type", wp = "Grpc-Timeout", si = "Grpc-Status", S0 = "Grpc-Message", Yp = "Grpc-Status-Details-Bin", Yc = "User-Agent", Nr = "X-User-Agent", Tp = "X-Grpc-Web", Lp = "application/grpc-web+proto", kp = "application/grpc-web+json", Jp = /* @__PURE__ */ ge("CgxzdGF0dXMucHJvdG8SCmdvb2dsZS5ycGMiTgoGU3RhdHVzEgwKBGNvZGUYASABKAUSDwoHbWVzc2FnZRgCIAEoCRIlCgdkZXRhaWxzGAMgAygLMhQuZ29vZ2xlLnByb3RvYnVmLkFueUJeCg5jb20uZ29vZ2xlLnJwY0ILU3RhdHVzUHJvdG9QAVo3Z29vZ2xlLmdvbGFuZy5vcmcvZ2VucHJvdG8vZ29vZ2xlYXBpcy9ycGMvc3RhdHVzO3N0YXR1c6ICA1JQQ2IGcHJvdG8z", [a0]), xp = /* @__PURE__ */ ui(Jp, 0), Mp = "0";
function Z0(t) {
  var e;
  const n = t.get(Yp);
  if (n != null) {
    const s = Rp(n, xp);
    if (s.code == 0)
      return;
    const r = new Ae(s.message, s.code, t);
    return r.details = s.details.map((o) => ({
      type: o.typeUrl.substring(o.typeUrl.lastIndexOf("/") + 1),
      value: o.value
    })), r;
  }
  const i = t.get(si);
  if (i != null) {
    if (i === Mp)
      return;
    const s = parseInt(i, 10);
    return s in se ? new Ae(decodeURIComponent((e = t.get(S0)) !== null && e !== void 0 ? e : ""), s, t) : new Ae(`invalid grpc-status: ${i}`, se.Internal, t);
  }
}
function Tc(t, e) {
  return t.toString().replace(/\/?$/, `/${e.parent.typeName}/${e.name}`);
}
function v0(t, e) {
  return At(t, e);
}
function Qp(t, e) {
  function n(i) {
    return i.done === !0 ? i : {
      done: i.done,
      value: v0(t, i.value)
    };
  }
  return {
    [Symbol.asyncIterator]() {
      const i = e[Symbol.asyncIterator](), s = {
        next: () => i.next().then(n)
      };
      return i.throw !== void 0 && (s.throw = (r) => i.throw(r).then(n)), i.return !== void 0 && (s.return = (r) => i.return(r).then(n)), s;
    }
  };
}
function I0(t, e) {
  var n;
  return (n = e?.concat().reverse().reduce(
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    (i, s) => s(i),
    t
  )) !== null && n !== void 0 ? n : t;
}
function zp(t) {
  var e;
  const n = Object.assign({}, t);
  return (e = n.ignoreUnknownFields) !== null && e !== void 0 || (n.ignoreUnknownFields = !0), n;
}
function Lc(t, e, n, i) {
  const s = e ? kc(t.input, i) : Jc(t.input, n);
  return { parse: (e ? kc(t.output, i) : Jc(t.output, n)).parse, serialize: s.serialize };
}
function kc(t, e) {
  return {
    parse(n) {
      try {
        return Ti(t, n, e);
      } catch (i) {
        const s = i instanceof Error ? i.message : String(i);
        throw new Ae(`parse binary: ${s}`, se.Internal);
      }
    },
    serialize(n) {
      try {
        return t0(t, n, e);
      } catch (i) {
        const s = i instanceof Error ? i.message : String(i);
        throw new Ae(`serialize binary: ${s}`, se.Internal);
      }
    }
  };
}
function Jc(t, e) {
  var n, i;
  const s = (n = e?.textEncoder) !== null && n !== void 0 ? n : new TextEncoder(), r = (i = e?.textDecoder) !== null && i !== void 0 ? i : new TextDecoder(), o = zp(e);
  return {
    parse(l) {
      try {
        const a = r.decode(l);
        return rp(t, a, o);
      } catch (a) {
        throw Ae.from(a, se.InvalidArgument);
      }
    },
    serialize(l) {
      try {
        const a = P9(t, l, o);
        return s.encode(a);
      } catch (a) {
        throw Ae.from(a, se.Internal);
      }
    }
  };
}
function Kp(t) {
  const e = I0(t.next, t.interceptors), [n, i, s] = N0(t), r = Object.assign(Object.assign({}, t.req), { message: v0(t.req.method.input, t.req.message), signal: n });
  return e(r).then((o) => (s(), o), i);
}
function Hp(t) {
  const e = I0(t.next, t.interceptors), [n, i, s] = N0(t), r = Object.assign(Object.assign({}, t.req), { message: Qp(t.req.method.input, t.req.message), signal: n });
  let o = !1;
  return n.addEventListener("abort", function() {
    var l, a;
    const c = t.req.message[Symbol.asyncIterator]();
    o || (l = c.throw) === null || l === void 0 || l.call(c, this.reason).catch(() => {
    }), (a = c.return) === null || a === void 0 || a.call(c).catch(() => {
    });
  }), e(r).then((l) => Object.assign(Object.assign({}, l), { message: {
    [Symbol.asyncIterator]() {
      const a = l.message[Symbol.asyncIterator]();
      return {
        next() {
          return a.next().then((c) => (c.done == !0 && (o = !0, s()), c), i);
        }
        // We deliberately omit throw/return.
      };
    }
  } }), i);
}
function N0(t) {
  const { signal: e, cleanup: n } = Up(t.timeoutMs), i = Xp(t.signal, e);
  return [
    i.signal,
    function(r) {
      const o = Ae.from(e.aborted ? W0(e) : r);
      return i.abort(o), n(), Promise.reject(o);
    },
    function() {
      n(), i.abort();
    }
  ];
}
function Op() {
  try {
    new Headers();
  } catch {
    throw new Error("connect-web requires the fetch API. Are you running on an old version of Node.js? Node.js is not supported in Connect for Web - please stay tuned for Connect for Node.");
  }
}
function xc(t, e) {
  const n = Z0(t);
  if (n)
    throw e.forEach((i, s) => {
      n.metadata.append(s, i);
    }), n;
  if (!e.has(si) && !t.has(si))
    throw new Ae("protocol error: missing status", se.Internal);
}
function Mc(t, e, n, i) {
  const s = new Headers(n ?? {});
  s.set(Bp, t ? Lp : kp), s.set(Tp, "1");
  let r = "connect-es/2.0.2";
  return r = s.has(Yc) ? s.get(Yc) : s.has(Nr) ? s.get(Nr) : r, s.set(Nr, r), e !== void 0 && s.set(wp, `${e}m`), s;
}
function Dp(t) {
  switch (t) {
    case 400:
      return se.Internal;
    case 401:
      return se.Unauthenticated;
    case 403:
      return se.PermissionDenied;
    case 404:
      return se.Unimplemented;
    case 429:
      return se.Unavailable;
    case 502:
      return se.Unavailable;
    case 503:
      return se.Unavailable;
    case 504:
      return se.Unavailable;
    default:
      return se.Unknown;
  }
}
function Qc(t, e) {
  var n;
  if (t >= 200 && t < 300)
    return {
      foundStatus: e.has(si),
      headerError: Z0(e)
    };
  throw new Ae(decodeURIComponent((n = e.get(S0)) !== null && n !== void 0 ? n : `HTTP ${t}`), Dp(t), e);
}
var Vn = function(t) {
  return this instanceof Vn ? (this.v = t, this) : new Vn(t);
}, Pp = function(t, e, n) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var i = n.apply(t, e || []), s, r = [];
  return s = Object.create((typeof AsyncIterator == "function" ? AsyncIterator : Object).prototype), l("next"), l("throw"), l("return", o), s[Symbol.asyncIterator] = function() {
    return this;
  }, s;
  function o(m) {
    return function(p) {
      return Promise.resolve(p).then(m, h);
    };
  }
  function l(m, p) {
    i[m] && (s[m] = function(g) {
      return new Promise(function(A, b) {
        r.push([m, g, A, b]) > 1 || a(m, g);
      });
    }, p && (s[m] = p(s[m])));
  }
  function a(m, p) {
    try {
      c(i[m](p));
    } catch (g) {
      d(r[0][3], g);
    }
  }
  function c(m) {
    m.value instanceof Vn ? Promise.resolve(m.value.v).then(u, h) : d(r[0][2], m);
  }
  function u(m) {
    a("next", m);
  }
  function h(m) {
    a("throw", m);
  }
  function d(m, p) {
    m(p), r.shift(), r.length && a(r[0][0], r[0][1]);
  }
};
const zc = {
  redirect: "error"
};
function Kc(t) {
  var e;
  Op();
  const n = (e = t.useBinaryFormat) !== null && e !== void 0 ? e : !0;
  return {
    async unary(i, s, r, o, l, a) {
      const { serialize: c, parse: u } = Lc(i, n, t.jsonOptions, t.binaryOptions);
      return r = r === void 0 ? t.defaultTimeoutMs : r <= 0 ? void 0 : r, await Kp({
        interceptors: t.interceptors,
        signal: s,
        timeoutMs: r,
        req: {
          stream: !1,
          service: i.parent,
          method: i,
          requestMethod: "POST",
          url: Tc(t.baseUrl, i),
          header: Mc(n, r, o),
          contextValues: a ?? ol(),
          message: l
        },
        next: async (h) => {
          var d;
          const p = await ((d = t.fetch) !== null && d !== void 0 ? d : globalThis.fetch)(h.url, Object.assign(Object.assign({}, zc), { method: h.requestMethod, headers: h.header, signal: h.signal, body: Uc(0, c(h.message)) })), { headerError: g } = Qc(p.status, p.headers);
          if (!p.body)
            throw g !== void 0 ? g : "missing response body";
          const A = Xc(p.body).getReader();
          let b, R;
          for (; ; ) {
            const S = await A.read();
            if (S.done)
              break;
            const { flags: E, data: Z } = S.value;
            if ((E & Gc) === Gc)
              throw new Ae("protocol error: received unsupported compressed output", se.Internal);
            if (E === Ir) {
              if (b !== void 0)
                throw "extra trailer";
              b = wc(Z);
              continue;
            }
            if (R !== void 0)
              throw new Ae("extra message", se.Unimplemented);
            R = u(Z);
          }
          if (b === void 0)
            throw g !== void 0 ? g : new Ae("missing trailer", p.headers.has(si) ? se.Unimplemented : se.Unknown);
          if (xc(b, p.headers), R === void 0)
            throw new Ae("missing message", b.has(si) ? se.Unimplemented : se.Unknown);
          return {
            stream: !1,
            service: i.parent,
            method: i,
            header: p.headers,
            message: R,
            trailer: b
          };
        }
      });
    },
    async stream(i, s, r, o, l, a) {
      const { serialize: c, parse: u } = Lc(i, n, t.jsonOptions, t.binaryOptions);
      function h(m, p, g, A, b) {
        return Pp(this, arguments, function* () {
          const S = Xc(m).getReader();
          if (p) {
            if (!(yield Vn(S.read())).done)
              throw "extra data for trailers-only";
            return yield Vn(void 0);
          }
          let E = !1;
          for (; ; ) {
            const Z = yield Vn(S.read());
            if (Z.done)
              break;
            const { flags: G, data: T } = Z.value;
            if ((G & Ir) === Ir) {
              if (E)
                throw "extra trailer";
              E = !0;
              const C = wc(T);
              xc(C, A), C.forEach((N, Y) => g.set(Y, N));
              continue;
            }
            if (E)
              throw "extra message";
            yield yield Vn(u(T));
          }
          if ("throwIfAborted" in b && b.throwIfAborted(), !E)
            throw "missing trailer";
        });
      }
      async function d(m) {
        if (i.methodKind != "server_streaming")
          throw "The fetch API does not support streaming request bodies";
        const p = await m[Symbol.asyncIterator]().next();
        if (p.done == !0)
          throw "missing request message";
        return Uc(0, c(p.value));
      }
      return r = r === void 0 ? t.defaultTimeoutMs : r <= 0 ? void 0 : r, Hp({
        interceptors: t.interceptors,
        signal: s,
        timeoutMs: r,
        req: {
          stream: !0,
          service: i.parent,
          method: i,
          requestMethod: "POST",
          url: Tc(t.baseUrl, i),
          header: Mc(n, r, o),
          contextValues: a ?? ol(),
          message: l
        },
        next: async (m) => {
          var p;
          const A = await ((p = t.fetch) !== null && p !== void 0 ? p : globalThis.fetch)(m.url, Object.assign(Object.assign({}, zc), { method: m.requestMethod, headers: m.header, signal: m.signal, body: await d(m.message) })), { foundStatus: b, headerError: R } = Qc(A.status, A.headers);
          if (R != null)
            throw R;
          if (!A.body)
            throw "missing response body";
          const S = new Headers();
          return Object.assign(Object.assign({}, m), { header: A.headers, trailer: S, message: h(A.body, b, S, A.headers, m.signal) });
        }
      });
    }
  };
}
let _p = () => ({
  emit(t, ...e) {
    for (let n = this.events[t] || [], i = 0, s = n.length; i < s; i++)
      n[i](...e);
  },
  events: {},
  on(t, e) {
    return (this.events[t] ||= []).push(e), () => {
      this.events[t] = this.events[t]?.filter((n) => e !== n);
    };
  }
});
function jp({ retryCount: t }) {
  return ~~((Math.random() + 0.5) * (1 << (t < 8 ? t : 8))) * 2e3;
}
const $p = ([
  t,
  e,
  n
]) => {
  const i = ({
    cache: b = /* @__PURE__ */ new Map(),
    fetcher: R,
    ...S
  } = {}) => {
    const E = _p();
    let Z = !0;
    e(() => {
      Z = t(), Z && E.emit(l);
    }), n(() => E.emit(a));
    const G = /* @__PURE__ */ new Map(), T = /* @__PURE__ */ new Map(), C = /* @__PURE__ */ new Map();
    let N = {};
    const Y = (k) => {
      const O = b.get(k);
      return O ? (O.expires || 0) > m() ? [O.data, O.error] : [] : [];
    }, L = async ([k, O], ee, W) => {
      if (!Z)
        return;
      const v = (ue) => {
        ee.key === k && (ee.set(ue), E.emit(h, k, ue, !0));
      }, F = (ue) => {
        v({
          ...ue === void 0 ? {} : { data: ue },
          ...g,
          promise: C.get(k)
        });
      };
      let {
        dedupeTime: K = 4e3,
        cacheLifetime: _ = 1 / 0,
        fetcher: $,
        onErrorRetry: j = jp
      } = {
        ...W,
        ...N
      };
      _ < K && (_ = K);
      const z = m();
      if (C.has(k)) {
        ee.value.loading || F(Y(k)[0]);
        return;
      }
      let P, ne;
      const le = b.get(k);
      if ((le?.data !== void 0 || le?.error) && ([P, ne] = Y(k), (le.created || 0) + K > z)) {
        (ee.value.data != P || ee.value.error != ne) && v({ ...A, data: P, error: ne });
        return;
      }
      const Ce = k3();
      try {
        clearTimeout(T.get(k));
        const ue = $(...O);
        C.set(k, ue), F(P);
        const ye = await ue;
        b.set(k, {
          data: ye,
          created: m(),
          expires: m() + _
        }), v({ data: ye, ...A });
      } catch (ue) {
        W.onError?.(ue);
        const ye = (b.get(k)?.retryCount || 0) + 1;
        if (b.set(k, {
          error: ue,
          created: m(),
          expires: m() + _,
          retryCount: ye
        }), j) {
          const Qe = j({
            error: ue,
            key: k,
            retryCount: ye
          });
          Qe && T.set(
            k,
            setTimeout(() => {
              ie(k), b.set(k, { retryCount: ye });
            }, Qe)
          );
        }
        v({ data: ee.value.data, error: ue, ...A });
      } finally {
        Ce(), C.delete(k);
      }
    }, w = (k, {
      fetcher: O = R,
      ...ee
    } = {}) => {
      const W = /* @__PURE__ */ _o({
        ...A
      }), v = { ...S, ...ee, fetcher: O };
      W._ = p, W.invalidate = () => {
        const { key: le } = W;
        le && ie(le);
      }, W.revalidate = () => {
        const { key: le } = W;
        le && X(le);
      }, W.mutate = (le) => {
        const { key: Ce } = W;
        Ce && Q(Ce, le);
      }, W.fetch = async () => {
        let le;
        const Ce = new Promise((ye) => le = ye), ue = W.listen(({ error: ye, data: Qe }) => {
          ye !== void 0 && le({ error: ye }), Qe !== void 0 && le({ data: Qe });
        });
        return Ce.finally(ue);
      };
      let F, K, _, $, j, z = [];
      bd(W, () => {
        const le = !F;
        [j, F] = r(k), $ = j.subscribe((x) => {
          if (x) {
            const [rt, Xn] = x;
            W.key = rt, L([rt, Xn], W, v), K = rt, _ = Xn;
          } else
            W.key = K = _ = void 0, W.set({ ...A });
        });
        const Ce = j.get();
        Ce && ([K, _] = Ce, le && P());
        const {
          revalidateInterval: ue = 0,
          revalidateOnFocus: ye,
          revalidateOnReconnect: Qe
        } = v, qe = () => {
          K && L([K, _], W, v);
        };
        ue > 0 && G.set(
          k,
          setInterval(qe, ue)
        ), ye && z.push(E.on(l, qe)), Qe && z.push(E.on(a, qe));
        const dt = (x) => {
          K && d(K, x) && L([K, _], W, v);
        };
        z.push(
          E.on(c, dt),
          E.on(u, dt),
          E.on(h, (x, rt, Xn) => {
            K && d(K, x) && W.value !== rt && W.value.data !== rt && W.set(
              Xn ? rt : { data: rt, ...A }
            );
          })
        );
      });
      const P = () => {
        K && _ && L([K, _], W, v);
      }, ne = W.listen;
      return W.listen = (le) => {
        const Ce = ne(le);
        return le(W.value), P(), Ce;
      }, Fa(W, () => {
        W.value = { ...A }, F?.(), z.forEach((le) => le()), z = [], $?.(), clearInterval(G.get(k));
      }), W;
    }, D = (k, O) => {
      for (const ee of b.keys())
        d(ee, k) && O(ee);
    }, ie = (k) => {
      D(k, (O) => {
        b.delete(O);
      }), E.emit(c, k);
    }, X = (k) => {
      D(k, (O) => {
        const ee = b.get(O);
        ee && b.set(O, { ...ee, created: -1 / 0 });
      }), E.emit(u, k);
    }, Q = (k, O) => {
      D(k, (ee) => {
        O === void 0 ? b.delete(ee) : b.set(ee, {
          data: O,
          created: m(),
          expires: m() + (S.cacheLifetime ?? 8e3)
        });
      }), E.emit(h, k, O);
    };
    function J(k, O) {
      const { throttleCalls: ee, onError: W } = O ?? {
        throttleCalls: !0,
        onError: S?.onError
      }, v = async (K) => {
        if (ee && F.value?.loading)
          return;
        const _ = N.fetcher ?? k, $ = [], j = [], z = (P, ne) => {
          F.lc && F.setKey(P, ne);
        };
        try {
          F.set({
            error: void 0,
            data: void 0,
            mutate: v,
            ...g
          });
          const P = await _({
            data: K,
            invalidate: (ne) => {
              $.push(ne);
            },
            revalidate: (ne) => {
              j.push(ne);
            },
            getCacheUpdater: (ne, le = !0) => [
              (Ce) => {
                Q(ne, Ce), le && j.push(ne);
              },
              b.get(ne)?.data
            ]
          });
          return z("data", P), P;
        } catch (P) {
          W?.(P), z("error", P), F.setKey("error", P);
        } finally {
          z("loading", !1), $.forEach(ie), j.forEach(X);
        }
      }, F = /* @__PURE__ */ _o({
        mutate: v,
        ...A
      });
      return Fa(
        F,
        () => F.set({ mutate: v, ...A })
      ), F.mutate = v, F;
    }
    return [
      w,
      J,
      { __unsafeOverruleSettings: (k) => {
        console.warn(
          "You should only use __unsafeOverruleSettings in test environment"
        ), N = k;
      }, invalidateKeys: ie, revalidateKeys: X, mutateCache: Q }
    ];
  };
  function s(b) {
    return typeof b == "string" || typeof b == "number" || b === !0;
  }
  const r = (b) => {
    if (s(b))
      return [
        /* @__PURE__ */ Pt(["" + b, [b]]),
        () => {
        }
      ];
    const R = [], S = /* @__PURE__ */ Pt(null), E = /* @__PURE__ */ new Map(), Z = () => {
      R.some((C) => C == null || C === !1) ? S.set(null) : S.set([R.join(""), R]);
    };
    for (let C = 0; C < b.length; C++) {
      const N = b[C];
      s(N) ? R.push(N) : (R.push(null), E.set(N, C));
    }
    const G = [...E.keys()], T = /* @__PURE__ */ Po(G, (...C) => {
      for (let N = 0; N < C.length; N++) {
        const Y = G[N], L = E.get(Y);
        R[L] = Y._ === p ? Y.value && "data" in Y.value ? Y.key : null : C[N];
      }
      Z();
    });
    return Z(), [S, T.subscribe(o)];
  };
  function o() {
  }
  const l = 1, a = 2, c = 3, u = 4, h = 5, d = (b, R) => Array.isArray(R) ? R.includes(b) : typeof R == "function" ? R(b) : b === R, m = () => (/* @__PURE__ */ new Date()).getTime(), p = /* @__PURE__ */ Symbol(), g = { loading: !0 }, A = { loading: !1 };
  return i;
}, Hc = (t, e) => {
  typeof window > "u" || addEventListener(t, e);
}, qp = [
  () => !document.hidden,
  (t) => Hc("visibilitychange", t),
  (t) => Hc("online", t)
], Oc = $p(qp), ki = /* @__PURE__ */ ge("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"), eg = /* @__PURE__ */ ge("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", [ki]), tg = /* @__PURE__ */ ge("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", [ki]), ng = /* @__PURE__ */ ge("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", [ki]), ig = /* @__PURE__ */ ge("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", [ki]), sg = /* @__PURE__ */ ge("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", [Rt, ki, eg, tg, ng, ig]), F0 = /* @__PURE__ */ jt(sg, 0), rg = /* @__PURE__ */ ge("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", [Rt, g0]), Ji = /* @__PURE__ */ jt(rg, 0), og = /* @__PURE__ */ ge("CiRzdHJlYW1sYXllci91c2Vycy91c2Vyc19jb21tb24ucHJvdG8SEXN0cmVhbWxheWVyLnVzZXJzIh4KDlB1YmxpY0NoYXRVc2VyEgwKBG5hbWUYASABKAkioAEKDlVzZXJBdHRyaWJ1dGVzEhAKCHVzZXJuYW1lGAEgASgJEgwKBG5hbWUYAiABKAkSDQoFYWxpYXMYAyABKAkSDgoGYXZhdGFyGAUgASgJEjoKC3B1YmxpY19jaGF0GAYgASgLMiEuc3RyZWFtbGF5ZXIudXNlcnMuUHVibGljQ2hhdFVzZXJCAhgBEhMKC3B1YmxpY19uYW1lGAcgASgJIjMKEFVzZXJPcmdhbml6YXRpb24SCgoCaWQYASABKAkSEwoLcGVybWlzc2lvbnMYAiADKAki/wEKDFVzZXJNZXRhZGF0YRIOCgZhdmF0YXIYAiABKAkSIAoYYXZhdGFyX2JhY2tncm91bmRfY29sb3VyGAMgASgJEhAKCHRpbWV6b25lGAQgASgJEk4KF25vdGlmaWNhdGlvbl9wcmVmZXJlbmNlGAUgASgOMi0uc3RyZWFtbGF5ZXIudXNlcnMuVXNlck5vdGlmaWNhdGlvblByZWZlcmVuY2USDgoGYWN0aXZlGAYgASgIEhIKCmZpcnN0X25hbWUYByABKAkSEQoJbGFzdF9uYW1lGAggASgJEg0KBXJvbGVzGAkgAygJEhUKDWF1ZGllbmNlX3RhZ3MYCiADKAkiegoWRXh0ZW5kZWRVc2VyQXR0cmlidXRlcxIQCgh1c2VybmFtZRgBIAEoCRIMCgRuYW1lGAIgASgJEg0KBWFsaWFzGAMgASgJEjEKCG1ldGFkYXRhGAQgASgLMh8uc3RyZWFtbGF5ZXIudXNlcnMuVXNlck1ldGFkYXRhIlcKBFVzZXISCgoCaWQYASABKAkSDAoEdHlwZRgCIAEoCRI1CgphdHRyaWJ1dGVzGAMgASgLMiEuc3RyZWFtbGF5ZXIudXNlcnMuVXNlckF0dHJpYnV0ZXMiZwoMRXh0ZW5kZWRVc2VyEgoKAmlkGAEgASgJEgwKBHR5cGUYAiABKAkSPQoKYXR0cmlidXRlcxgDIAEoCzIpLnN0cmVhbWxheWVyLnVzZXJzLkV4dGVuZGVkVXNlckF0dHJpYnV0ZXMq5gEKGlVzZXJOb3RpZmljYXRpb25QcmVmZXJlbmNlEiYKIlVTRVJfTk9USUZJQ0FUSU9OX1BSRUZFUkVOQ0VfVU5TRVQQABIrCidVU0VSX05PVElGSUNBVElPTl9QUkVGRVJFTkNFX0FMTF9FVkVOVFMQARI2CjJVU0VSX05PVElGSUNBVElPTl9QUkVGRVJFTkNFX0lNUE9SVEFOVF9FVkVOVFNfT05MWRACEjsKN1VTRVJfTk9USUZJQ0FUSU9OX1BSRUZFUkVOQ0VfREFJTFlfU1VNTUFSWV9BTkRfTUVOVElPTlMQA0KKAQoVY29tLnN0cmVhbWxheWVyLnVzZXJzQhtTdHJlYW1MYXllclVzZXJzQ29tbW9uUHJvdG9QAVpJZ2l0aHViLmNvbS9zdHJlYW1sYXllci9zbC1wcm90b2ZpbGVzLy5idWlsZC9nby9zdHJlYW1sYXllci91c2VycztzbF91c2Vyc6ICBlNMX0FQSWIGcHJvdG8z"), lg = /* @__PURE__ */ ge("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", [Rt, og]), qs = /* @__PURE__ */ jt(lg, 0), ag = /* @__PURE__ */ ge("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", [Rt, Ie]), G0 = /* @__PURE__ */ jt(ag, 0), ta = /* @__PURE__ */ ge("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", [Rt]), cg = /* @__PURE__ */ he(ta, 2), ug = /* @__PURE__ */ de(cg), hg = /* @__PURE__ */ he(ta, 3), Fr = /* @__PURE__ */ de(hg), dg = /* @__PURE__ */ jt(ta, 0), mg = /* @__PURE__ */ ge("CihzdHJlYW1sYXllci9zaG9ydExpbmtzL2xpbmtzQ2xpZW50LnByb3RvEhZzdHJlYW1sYXllci5zaG9ydExpbmtzIi4KD0dlbmVyYXRlUmVxdWVzdBILCgN3ZWIYASABKAkSDgoGbW9iaWxlGAIgASgJIoUBChBHZW5lcmF0ZVJlc3BvbnNlEksKBGRhdGEYASABKAsyPS5zdHJlYW1sYXllci5zaG9ydExpbmtzLkdlbmVyYXRlUmVzcG9uc2UuR2VuZXJhdGVSZXNwb25zZURhdGEaJAoUR2VuZXJhdGVSZXNwb25zZURhdGESDAoEbGluaxgBIAEoCTKTAQoLTGlua3NDbGllbnQScwoIR2VuZXJhdGUSJy5zdHJlYW1sYXllci5zaG9ydExpbmtzLkdlbmVyYXRlUmVxdWVzdBooLnN0cmVhbWxheWVyLnNob3J0TGlua3MuR2VuZXJhdGVSZXNwb25zZSIUiqYdCGdlbmVyYXRloKYdAqimHQIaD4q1GAtzaG9ydC1saW5rc0LCAQomY29tLnN0cmVhbWxheWVyLnNob3J0TGlua3MubGlua3NDbGllbnRCIFN0cmVhbUxheWVyU2hvcnRMaW5rc0NsaWVudFByb3RvUAFaa2dpdGh1Yi5jb20vc3RyZWFtbGF5ZXIvc2wtcHJvdG9maWxlcy8uYnVpbGQvZ28vc3RyZWFtbGF5ZXIvc2hvcnRMaW5rcy9saW5rc0NsaWVudDtzbF9zaG9ydExpbmtzX2xpbmtzQ2xpZW50ogIGU0xfQVBJYgZwcm90bzM", [Rt]), pg = /* @__PURE__ */ jt(mg, 0), X0 = /* @__PURE__ */ ge("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", [Rt]), gg = /* @__PURE__ */ he(X0, 1), fg = /* @__PURE__ */ de(gg), bg = /* @__PURE__ */ jt(X0, 0), U0 = /* @__PURE__ */ ge("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", [nt, Fn]), Ag = /* @__PURE__ */ he(U0, 0), Dc = /* @__PURE__ */ de(Ag), na = /* @__PURE__ */ ge("CjpzdHJlYW1sYXllci9hbmFseXRpY3MvdjEvbm90aWZpY2F0aW9ucy9ub3RpZmljYXRpb25zLnByb3RvEiZzdHJlYW1sYXllci5hbmFseXRpY3MudjEubm90aWZpY2F0aW9ucyKaBAoZVG90YWxOb3RpZmljYXRpb25zUmVxdWVzdBJkCgZmaWx0ZXIYASABKAsyVC5zdHJlYW1sYXllci5hbmFseXRpY3MudjEubm90aWZpY2F0aW9ucy5Ub3RhbE5vdGlmaWNhdGlvbnNSZXF1ZXN0LlRvdGFsUmVxdWVzdEZpbHRlchqWAwoSVG90YWxSZXF1ZXN0RmlsdGVyEjcKBnBlcmlvZBgBIAEoCzInLnN0cmVhbWxheWVyLmFuYWx5dGljcy52MS5jb21tb24uUGVyaW9kEhEKCWV2ZW50X2lkcxgCIAMoBBI9CgpjYXRlZ29yaWVzGAMgAygOMikuc3RyZWFtbGF5ZXIuYW5hbHl0aWNzLnYxLmNvbW1vbi5DYXRlZ29yeRJUChJub3RpZmljYXRpb25fa2luZHMYBCADKA4yOC5zdHJlYW1sYXllci5hbmFseXRpY3MudjEubm90aWZpY2F0aW9ucy5Ob3RpZmljYXRpb25LaW5kElQKEm5vdGlmaWNhdGlvbl90eXBlcxgFIAMoDjI4LnN0cmVhbWxheWVyLmFuYWx5dGljcy52MS5ub3RpZmljYXRpb25zLk5vdGlmaWNhdGlvblR5cGUSMwoEa2luZBgGIAEoDjIlLnN0cmVhbWxheWVyLmFuYWx5dGljcy52MS5jb21tb24uS2luZBIUCgxjb3VudF91bmlxdWUYByABKAgitgEKGlRvdGFsTm90aWZpY2F0aW9uc1Jlc3BvbnNlEmIKBGRhdGEYASADKAsyVC5zdHJlYW1sYXllci5hbmFseXRpY3MudjEubm90aWZpY2F0aW9ucy5Ub3RhbE5vdGlmaWNhdGlvbnNSZXNwb25zZS5Ub3RhbFJlc3BvbnNlRGF0YRo0ChFUb3RhbFJlc3BvbnNlRGF0YRIQCghldmVudF9pZBgBIAEoBBINCgVjb3VudBgCIAEoBCK2BgoXU2VuZE5vdGlmaWNhdGlvblJlcXVlc3QSXwoEZGF0YRgBIAMoCzJRLnN0cmVhbWxheWVyLmFuYWx5dGljcy52MS5ub3RpZmljYXRpb25zLlNlbmROb3RpZmljYXRpb25SZXF1ZXN0LkNyZWF0ZVJlcXVlc3REYXRhGrkFChFDcmVhdGVSZXF1ZXN0RGF0YRIQCghldmVudF9pZBgBIAEoBBIPCgd1c2VyX2lkGAIgASgEEjsKCGNhdGVnb3J5GAMgASgOMikuc3RyZWFtbGF5ZXIuYW5hbHl0aWNzLnYxLmNvbW1vbi5DYXRlZ29yeRJTChFub3RpZmljYXRpb25fa2luZBgEIAEoDjI4LnN0cmVhbWxheWVyLmFuYWx5dGljcy52MS5ub3RpZmljYXRpb25zLk5vdGlmaWNhdGlvbktpbmQSUwoRbm90aWZpY2F0aW9uX3R5cGUYBSABKA4yOC5zdHJlYW1sYXllci5hbmFseXRpY3MudjEubm90aWZpY2F0aW9ucy5Ob3RpZmljYXRpb25UeXBlEjMKBGtpbmQYBiABKA4yJS5zdHJlYW1sYXllci5hbmFseXRpY3MudjEuY29tbW9uLktpbmQSMwoPdHJhY2tfdGltZXN0YW1wGAcgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIRCglkZXZpY2VfaWQYCCABKAkSCgoCb3MYCSABKAkSEgoKdXNlcl9hZ2VudBgKIAEoCRIWCg5zbF9zZGtfdmVyc2lvbhgLIAEoCRISCgpzZXNzaW9uX2lkGAwgASgJEhoKEm92ZXJsYXlfc2Vzc2lvbl9pZBgNIAEoCRIQCgh0b3BpY19pZBgOIAEoCRI+Cgp0b3BpY190eXBlGBUgASgOMiouc3RyZWFtbGF5ZXIuYW5hbHl0aWNzLnYxLmNvbW1vbi5Ub3BpY1R5cGUSEwoLdXNlcl9pZF9zdHIYEyABKAkSTgoSc2NyZWVuX29yaWVudGF0aW9uGBQgASgOMjIuc3RyZWFtbGF5ZXIuYW5hbHl0aWNzLnYxLmNvbW1vbi5TY3JlZW5PcmllbnRhdGlvbiLSAQoYU2VuZE5vdGlmaWNhdGlvblJlc3BvbnNlEmEKBGRhdGEYASABKAsyUy5zdHJlYW1sYXllci5hbmFseXRpY3MudjEubm90aWZpY2F0aW9ucy5TZW5kTm90aWZpY2F0aW9uUmVzcG9uc2UuQ3JlYXRlUmVzcG9uc2VEYXRhGlMKEkNyZWF0ZVJlc3BvbnNlRGF0YRI9CgZyZXN1bHQYASABKA4yLS5zdHJlYW1sYXllci5hbmFseXRpY3MudjEuY29tbW9uLlJlc3VsdFN0YXR1cyKYAwolVG90YWxOb3RpZmljYXRpb25zQnlDYXRlZ29yaWVzUmVxdWVzdBJwCgZmaWx0ZXIYASABKAsyYC5zdHJlYW1sYXllci5hbmFseXRpY3MudjEubm90aWZpY2F0aW9ucy5Ub3RhbE5vdGlmaWNhdGlvbnNCeUNhdGVnb3JpZXNSZXF1ZXN0LlRvdGFsUmVxdWVzdEZpbHRlchr8AQoSVG90YWxSZXF1ZXN0RmlsdGVyEjcKBnBlcmlvZBgBIAEoCzInLnN0cmVhbWxheWVyLmFuYWx5dGljcy52MS5jb21tb24uUGVyaW9kEhAKCGV2ZW50X2lkGAIgASgEEjMKBGtpbmQYAyABKA4yJS5zdHJlYW1sYXllci5hbmFseXRpY3MudjEuY29tbW9uLktpbmQSPQoKY2F0ZWdvcmllcxgEIAMoDjIpLnN0cmVhbWxheWVyLmFuYWx5dGljcy52MS5jb21tb24uQ2F0ZWdvcnkSEQoJcm91dGVfbWFwGAUgASgJEhQKDGNvdW50X3VuaXF1ZRgGIAEoCCLOAQomVG90YWxOb3RpZmljYXRpb25zQnlDYXRlZ29yaWVzUmVzcG9uc2USbgoEZGF0YRgBIAMoCzJgLnN0cmVhbWxheWVyLmFuYWx5dGljcy52MS5ub3RpZmljYXRpb25zLlRvdGFsTm90aWZpY2F0aW9uc0J5Q2F0ZWdvcmllc1Jlc3BvbnNlLlRvdGFsUmVzcG9uc2VEYXRhGjQKEVRvdGFsUmVzcG9uc2VEYXRhEhAKCGV2ZW50X2lkGAEgASgEEg0KBWNvdW50GAIgASgEKvECChBOb3RpZmljYXRpb25LaW5kEhsKF05PVElGSUNBVElPTl9LSU5EX1VOU0VUEAASHQoZTk9USUZJQ0FUSU9OX0tJTkRfTUVTU0FHRRABEhoKFk5PVElGSUNBVElPTl9LSU5EX0NBTEwQAhIdChlOT1RJRklDQVRJT05fS0lORF9UV0lUVEVSEAMSGgoWTk9USUZJQ0FUSU9OX0tJTkRfV0FWRRAEEhwKGE5PVElGSUNBVElPTl9LSU5EX0lOUExBWRAFEiAKHE5PVElGSUNBVElPTl9LSU5EX0dST1VQX0NBTEwQBhIhCh1OT1RJRklDQVRJT05fS0lORF9NSVNTRURfQ0FMTBAHEicKI05PVElGSUNBVElPTl9LSU5EX01JU1NFRF9HUk9VUF9DQUxMEAgSIQodTk9USUZJQ0FUSU9OX0tJTkRfV0FUQ0hfUEFSVFkQCRIbChdOT1RJRklDQVRJT05fS0lORF9QT0xMUxAKKmkKEE5vdGlmaWNhdGlvblR5cGUSGwoXTk9USUZJQ0FUSU9OX1RZUEVfVU5TRVQQABIcChhOT1RJRklDQVRJT05fVFlQRV9JTl9BUFAQARIaChZOT1RJRklDQVRJT05fVFlQRV9QVVNIEAJCvgEKKmNvbS5zdHJlYW1sYXllci5hbmFseXRpY3Mubm90aWZpY2F0aW9ucy52MUIdU3RyZWFtTGF5ZXJOb3RpZmljYXRpb25zUHJvdG9QAVpmZ2l0aHViLmNvbS9zdHJlYW1sYXllci9zbC1wcm90b2ZpbGVzLy5idWlsZC9nby9zdHJlYW1sYXllci9hbmFseXRpY3MvdjEvbm90aWZpY2F0aW9ucztzbF9ub3RpZmljYXRpb25zogIGU0xfQVBJYgZwcm90bzM", [nt, Fn]), Vg = /* @__PURE__ */ he(na, 0), wt = /* @__PURE__ */ de(Vg), Rg = /* @__PURE__ */ he(na, 1), Pc = /* @__PURE__ */ de(Rg), Eg = /* @__PURE__ */ ge("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", [nt, Fn]), yg = /* @__PURE__ */ ge("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", [nt, Fn]), Cg = /* @__PURE__ */ ge("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", [Rt, nt, U0, _l, na, Eg, yg]), B0 = /* @__PURE__ */ jt(Cg, 0);
function Wg(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var w0 = { exports: {} }, Le = w0.exports = {}, Zt, vt;
function ll() {
  throw new Error("setTimeout has not been defined");
}
function al() {
  throw new Error("clearTimeout has not been defined");
}
(function() {
  try {
    typeof setTimeout == "function" ? Zt = setTimeout : Zt = ll;
  } catch {
    Zt = ll;
  }
  try {
    typeof clearTimeout == "function" ? vt = clearTimeout : vt = al;
  } catch {
    vt = al;
  }
})();
function Y0(t) {
  if (Zt === setTimeout)
    return setTimeout(t, 0);
  if ((Zt === ll || !Zt) && setTimeout)
    return Zt = setTimeout, setTimeout(t, 0);
  try {
    return Zt(t, 0);
  } catch {
    try {
      return Zt.call(null, t, 0);
    } catch {
      return Zt.call(this, t, 0);
    }
  }
}
function Sg(t) {
  if (vt === clearTimeout)
    return clearTimeout(t);
  if ((vt === al || !vt) && clearTimeout)
    return vt = clearTimeout, clearTimeout(t);
  try {
    return vt(t);
  } catch {
    try {
      return vt.call(null, t);
    } catch {
      return vt.call(this, t);
    }
  }
}
var zt = [], _n = !1, Rn, ys = -1;
function Zg() {
  !_n || !Rn || (_n = !1, Rn.length ? zt = Rn.concat(zt) : ys = -1, zt.length && T0());
}
function T0() {
  if (!_n) {
    var t = Y0(Zg);
    _n = !0;
    for (var e = zt.length; e; ) {
      for (Rn = zt, zt = []; ++ys < e; )
        Rn && Rn[ys].run();
      ys = -1, e = zt.length;
    }
    Rn = null, _n = !1, Sg(t);
  }
}
Le.nextTick = function(t) {
  var e = new Array(arguments.length - 1);
  if (arguments.length > 1)
    for (var n = 1; n < arguments.length; n++)
      e[n - 1] = arguments[n];
  zt.push(new L0(t, e)), zt.length === 1 && !_n && Y0(T0);
};
function L0(t, e) {
  this.fun = t, this.array = e;
}
L0.prototype.run = function() {
  this.fun.apply(null, this.array);
};
Le.title = "browser";
Le.browser = !0;
Le.env = {};
Le.argv = [];
Le.version = "";
Le.versions = {};
function $t() {
}
Le.on = $t;
Le.addListener = $t;
Le.once = $t;
Le.off = $t;
Le.removeListener = $t;
Le.removeAllListeners = $t;
Le.emit = $t;
Le.prependListener = $t;
Le.prependOnceListener = $t;
Le.listeners = function(t) {
  return [];
};
Le.binding = function(t) {
  throw new Error("process.binding is not supported");
};
Le.cwd = function() {
  return "/";
};
Le.chdir = function(t) {
  throw new Error("process.chdir is not supported");
};
Le.umask = function() {
  return 0;
};
var vg = w0.exports;
const ae = /* @__PURE__ */ Wg(vg), Ig = Rd.pino({
  level: "trace",
  enabled: typeof window < "u" && !!window.localStorage.getItem("SL_DEBUG"),
  browser: {
    write: (t) => {
      console.log(t);
    }
  }
}), st = (t, e) => Ig.child({ name: t }, e);
let Ng = class extends Event {
  slEventBus;
  constructor(e, n) {
    super(e), this.slEventBus = n;
  }
};
const Fg = st("event-bus");
let Gg = class {
  name;
  listeners;
  constructor(e = "sl-event-bus") {
    this.name = e, this.listeners = /* @__PURE__ */ new Set();
  }
  emit = (e, n) => {
    const i = new Ng(this.name, { ...n, type: e });
    Fg.debug(i, "Emitting event"), window.dispatchEvent(i);
  };
  listen(e) {
    return window.addEventListener(this.name, e), this.listeners.add(e), () => {
      this.off(e);
    };
  }
  off(e) {
    window.removeEventListener(this.name, e), this.listeners.delete(e);
  }
  destroy = () => {
    this.listeners.forEach((e) => {
      window.removeEventListener(this.name, e), this.listeners.delete(e);
    }), this.listeners.clear();
  };
}, Xg = class {
};
var Kt;
(function(t) {
  t[t.ONBOARDING = 1] = "ONBOARDING", t[t.QUESTION = 2] = "QUESTION", t[t.QUESTION_RESOLVED = 3] = "QUESTION_RESOLVED";
})(Kt || (Kt = {}));
window.slStore = /* @__PURE__ */ Object.create(null);
let er = class {
  /**
   * store instance (nanostores)
   */
  store;
  name;
  constructor(e, n) {
    this.store = e, this.name = n;
  }
  /**
   * return store instance
   */
  getStore() {
    return this.store;
  }
};
const Ug = (t) => {
  const e = Object.keys(t);
  return /* @__PURE__ */ z3(e.map((n) => t[n].getStore()), (...n) => Object.fromEntries(e.map((i, s) => [i, n[s]])));
};
class yn extends er {
  getValues = () => this.getStore().get();
  getValue = (e) => this.getStore().get()[e];
  setValue = (e, n) => this.getStore().setKey(e, n);
  subscribe = (...e) => this.getStore().subscribe(...e);
  unsubscribe = () => this.getStore().off();
}
const et = (t) => /* @__PURE__ */ _o(t);
var Lt;
(function(t) {
  t.ORGANIZATION = "ORGANIZATION", t.STREAM = "STREAM";
})(Lt || (Lt = {}));
const Bg = {
  [pe.BETTING]: "betting",
  [pe.GAMES]: "games",
  [pe.PUBLIC_CHAT]: "publicChat",
  [pe.TWITTER]: "twitter"
};
var un;
(function(t) {
  t.Ready = "ready", t.Suspended = "suspended";
})(un || (un = {}));
const wg = /* @__PURE__ */ new Set([
  "equals",
  "clone",
  "fromBinary",
  "fromJson",
  "fromJsonString",
  "toBinary",
  "toJson",
  "toJsonString",
  "getType"
]);
let k0 = class {
  status;
  listeners = /* @__PURE__ */ new Set();
  constructor() {
    this.status = /* @__PURE__ */ Pt(un.Suspended);
  }
  registerEventListener(e) {
    this.listeners.add(e);
  }
  enable = () => {
    this.status.set(un.Ready);
  };
  disable = () => {
    this.status.set(un.Suspended);
  };
  fireEvent(e) {
    for (const n of this.listeners.values())
      try {
        n.onEvent(e);
      } catch (i) {
        console.error(i);
      }
  }
}, J0 = class {
  status;
  source;
  config;
  settings;
  listeners = /* @__PURE__ */ new Set();
  settingsKey;
  constructor({ settings: e, ...n }, i) {
    this.settingsKey = Bg[n.type], this.status = /* @__PURE__ */ Pt(un.Suspended), this.config = new yn(et(n), `feature:config:${this.settingsKey}`), this.settingsKey !== void 0 && e?.overlaySettings.case === this.settingsKey ? this.settings = new yn(et(e.overlaySettings.value), `feature:settings:${this.settingsKey}`) : this.settings = new yn(et({}), `feature:settings:${this.settingsKey}`), this.source = i;
  }
  get featureConfig() {
    return this.config.getStore();
  }
  get featureSettings() {
    return this.settings.getStore();
  }
  registerEventListener(e) {
    this.listeners.add(e);
  }
  enable = () => {
    this.status.set(un.Ready);
  };
  disable = () => {
    this.status.set(un.Suspended);
  };
  setFeatureConfig = ({ settings: e, ...n }) => {
    let i;
    for (i in n)
      this.config.setValue(i, n[i]);
    if (e?.overlaySettings?.case !== void 0 && e?.overlaySettings.case === this.settingsKey) {
      const s = e.overlaySettings.value;
      if (s !== void 0) {
        let r;
        for (r in s)
          !wg.has(r) && s[r] && this.settings.setValue(r, s[r]);
      }
    }
  };
  update = (e, n) => {
    this.source === Lt.STREAM && n === Lt.ORGANIZATION || (this.setFeatureConfig(e), this.source = n);
  };
  fireEvent(e) {
    for (const n of this.listeners.values())
      try {
        n.onEvent(e);
      } catch (i) {
        console.error(i);
      }
  }
};
class ct extends er {
  getValue = () => this.getStore().get();
  getValues() {
    throw new Error("not implemented");
  }
  setValue = (e) => this.getStore().set(e);
  subscribe = (e) => this.getStore().subscribe(e);
  unsubscribe = () => this.getStore().off();
  listen(e) {
    return this.getStore().listen(e);
  }
  get() {
    return this.getStore().get();
  }
}
const we = (t) => /* @__PURE__ */ Pt(t);
class bt extends er {
  atomStore;
  pendingGetValue = null;
  constructor(e, n, i) {
    super(e, `api:${n}`), this.atomStore = /* @__PURE__ */ Pt(), i && e.subscribe((s) => {
      const r = this.atomStore.get(), o = i(s, r);
      r !== o && this.atomStore.set(o);
    });
  }
  getAtomStore = () => this.atomStore;
  getValue = () => {
    const e = this.getStore(), n = async () => (await e.fetch())?.data ?? e.get().data;
    return e.key ? n() : this.pendingGetValue ? this.pendingGetValue : (this.pendingGetValue = new Promise((i, s) => {
      let r = !1, o = null;
      const l = setTimeout(() => {
        r || (r = !0, o?.(), this.pendingGetValue = null, console.warn(`[ApiStore.getValue] ${this.name}: timed out waiting for store key`), i(void 0));
      }, 1e3);
      o = e.listen(() => {
        !e.key || r || (r = !0, clearTimeout(l), o?.(), this.pendingGetValue = null, n().then(i, s));
      }), r ? o() : e.key && (r = !0, clearTimeout(l), o(), this.pendingGetValue = null, n().then(i, s));
    }), this.pendingGetValue);
  };
  getValues = () => this.getStore().get();
  setValue = (e) => this.getStore().set({ loading: !1, data: e?.data });
  subscribe = (e) => this.getStore().subscribe(e);
  unsubscribe = () => {
    throw new Error("not implemented");
  };
  invalidate = () => {
    this.store.invalidate();
  };
  listen = (e) => this.getStore().listen(e);
  get() {
    throw new Error("not implemented");
  }
  key = () => this.getStore().key;
  off = () => this.getStore().off();
}
const Ve = new Gg();
async function* Yg(t, e) {
  for await (const n of e) {
    t.response.message = n, t.received_at = Date.now(), t.id = Date.now();
    const i = {
      type: "__GRPC_DEVTOOLS_EXTENSION__",
      data: t
    };
    window.postMessage(i), yield n;
  }
}
const Tg = () => (t) => async (e) => {
  const n = {
    id: Date.now(),
    name: e.url,
    stream: e.stream,
    sent_at: Date.now(),
    request: {
      // clone headers to avoid mutating
      header: Object.fromEntries(e.header.entries()),
      message: e.message
    },
    response: {}
  };
  try {
    window.postMessage({
      type: "__GRPC_DEVTOOLS_EXTENSION__",
      data: n
    });
  } catch (i) {
    console.log("devtools error", i);
  }
  try {
    const i = await t(e);
    if (n.received_at = Date.now(), n.response.header = Object.fromEntries(i.header.entries()), n.response.trailer = Object.fromEntries(i.trailer.entries()), e.stream) {
      const s = {
        type: "__GRPC_DEVTOOLS_EXTENSION__",
        data: {
          ...n,
          stream: !0
        }
      };
      try {
        window.postMessage(s);
      } catch (r) {
        console.log("devtools error", r);
      }
      return {
        ...i,
        message: Yg(n, i.message)
      };
    } else {
      n.response.message = i.message, n.latency = n.received_at - n.sent_at;
      const s = {
        type: "__GRPC_DEVTOOLS_EXTENSION__",
        data: n
      };
      try {
        window.postMessage(s);
      } catch (r) {
        console.log("devtools error", r);
      }
    }
    return i;
  } catch (i) {
    n.received_at = Date.now(), n.response.trailer = {
      "grpc-status": i.code,
      "grpc-message": i.rawMessage
    }, n.response.message = i.rawMessage, n.latency = n.received_at - n.sent_at;
    const s = {
      type: "__GRPC_DEVTOOLS_EXTENSION__",
      data: n
    };
    try {
      window.postMessage(s);
    } catch (r) {
      console.log("devtools error", r);
    }
    throw i;
  }
};
window.dispatchEvent(new CustomEvent("grpc_devtools_loaded"));
function x0(t) {
  return t instanceof DOMException && // everything except Firefox
  (t.code === 22 || // Firefox
  t.code === 1014 || // test name field too, because code might not be present
  // everything except Firefox
  t.name === "QuotaExceededError" || // Firefox
  t.name === "NS_ERROR_DOM_QUOTA_REACHED");
}
class hi {
  delimiter = ":";
  prefix;
  storage;
  constructor(e = "main", n = window.localStorage) {
    this.prefix = `sl-sdk${this.delimiter}${e}`, this.storage = n;
  }
  clear = () => {
    for (const e in window.localStorage)
      e.startsWith(this.prefix) && this.storage.removeItem(e);
  };
  generateKey = (e) => `${this.prefix}${this.delimiter}${e.join(this.delimiter)}`;
  write = (...e) => {
    const n = e.pop() || "", i = this.generateKey(e);
    try {
      this.storage.setItem(i, n);
    } catch (s) {
      x0(s) && this.storage === window.sessionStorage && (window.sessionStorage.removeItem("slstreamlogs"), this.storage.setItem(i, n));
    }
  };
  read = (...e) => {
    const n = this.storage.getItem(this.generateKey(e));
    return n === null ? void 0 : n;
  };
  remove = (...e) => {
    this.storage.removeItem(this.generateKey(e));
  };
}
var pt;
(function(t) {
  t.Init = "init", t.Ready = "ready", t.Connecting = "connecting", t.Connected = "connected", t.Disconnected = "disconnected", t.Failed = "failed", t.Reconnect = "reconnect", t.Reconnecting = "reconnecting";
})(pt || (pt = {}));
const _c = st("grpc:stream");
let Lg = class {
  params;
  streamCancel;
  method;
  options;
  headers;
  listeners;
  state;
  store;
  paramsListener;
  reconnectTimeout;
  attempt = 0;
  constructor(e, n, i, s) {
    const r = {
      status: pt.Init,
      ts: /* @__PURE__ */ new Date(),
      log: []
    };
    this.state = new yn(et(r), `subscription:${s.name}:state`), this.options = {
      ...s,
      reconnectDelay: s.reconnectDelay ?? 1e3,
      reconnectMaxDelay: s.reconnectMaxDelay ?? 3e4,
      reconnectMaxAttempts: s.reconnectMaxAttempts ?? 10,
      withStore: s.withStore ?? !1
    }, this.headers = e, this.listeners = /* @__PURE__ */ new Map(), this.params = i, this.method = n, s.withStore && (this.store = new ct(we(null), `subscription:${s.name}:store`)), "subscribe" in i && typeof i.subscribe == "function" && (this.paramsListener = i.subscribe((o) => {
      this.state.getValue("status") === pt.Connected && (this.addStateLog(`params updated, reconnect => ${JSON.stringify(o)}`), this.reconnect());
    })), this.updateState(pt.Ready);
  }
  updateState = (e) => {
    this.state.setValue("status", e), this.state.setValue("ts", /* @__PURE__ */ new Date()), this.addStateLog(`status => ${e}`);
  };
  addStateLog = (e) => {
    const n = this.state.getStore().get().log, i = `${this.options.name} ${(/* @__PURE__ */ new Date()).toISOString()}: ${e}`;
    if (n.push(i), this.state.setValue("log", n), localStorage.getItem("SL_DEBUG")) {
      e.startsWith("received data") ? _c.trace({ name: this.options.name, attempt: this.attempt }, "received data") : _c.trace({ name: this.options.name, attempt: this.attempt }, e);
      try {
        window.sessionStorage.setItem("slstreamlogs", window.sessionStorage.getItem("slstreamlogs") + `
` + i);
      } catch (s) {
        x0(s) && window.sessionStorage.removeItem("slstreamlogs"), window.sessionStorage.setItem("slstreamlogs", i);
      }
    }
  };
  addListener = (e, n) => this.listeners.has(e) ? (this.addStateLog(`listener '${e}' not added, already exists`), () => {
  }) : (this.listeners.set(e, n), this.addStateLog(`listener '${e}' added`), () => this.removeListener(e));
  removeListener = (e) => {
    this.listeners.delete(e), this.addStateLog(`listener '${e}' removed`);
  };
  connect = () => {
    this.updateState(pt.Connecting), this.streamCancel && (this.addStateLog("disconnect prev connection"), this.streamCancel.abort(), this.streamCancel = void 0);
    const e = "get" in this.params && typeof this.params.get == "function" ? this.params.get() : this.params;
    (async () => {
      this.streamCancel = new AbortController();
      try {
        const n = {
          headers: this.headers.getValues(),
          signal: this.streamCancel.signal
        }, i = this.method(e, n);
        for await (const s of i)
          this.attempt = 0, this.onData(s);
      } catch (n) {
        n instanceof Ae && n.code != se.Canceled && this.onStreamError(n);
      }
    })(), this.updateState(pt.Connected);
  };
  disconnect = () => {
    this.streamCancel && this.streamCancel.abort(), this.listeners.clear(), this.paramsListener?.(), clearTimeout(this.reconnectTimeout), this.reconnectTimeout = void 0, this.updateState(pt.Disconnected);
  };
  /**
   * Reconnect after delay, if not already reconnecting, otherwise do nothing
   */
  reconnect = () => {
    if (this.reconnectTimeout)
      this.addStateLog("already reconnecting");
    else if (this.attempt < this.options.reconnectMaxAttempts) {
      this.updateState(pt.Reconnect);
      const e = Math.min(this.options.reconnectMaxDelay, Math.pow(2, this.attempt) * this.options.reconnectDelay), n = Math.round(e * (1 + Math.random()) / 2);
      this.reconnectTimeout = setTimeout(() => {
        this.attempt++, this.updateState(pt.Reconnecting), this.addStateLog(`reconnect attempt ${this.attempt} after ${n}ms`), this.connect(), this.reconnectTimeout = void 0;
      }, n);
    } else
      this.addStateLog("max reconnect attempts reached"), this.disconnect();
  };
  getStore = () => this.store?.getStore();
  onData = (e) => {
    try {
      this.addStateLog(`received data => ${JSON.stringify(e)}`), this.store && this.store.setValue(e);
      for (const [, n] of this.listeners)
        n(e);
      this.addStateLog(`data routed to ${this.listeners.size} listeners`);
    } catch (n) {
      this.addStateLog(`error process data => ${n}`);
    }
  };
  /**
   * Disconnect if error is not instance of ConnectError or stream is Canceled,
   * Reconnect in other cases
   * Do nothing if error is undefined
   */
  onStreamError = (e) => {
    if (this.addStateLog(`error => ${e ? JSON.stringify(e) : "undefined"}}`), e !== void 0) {
      if (e instanceof Ae && e.code !== se.Canceled) {
        this.updateState(pt.Failed), this.state.setValue("error", e), e.code === se.Unknown && e.cause === "missing trailer" && (this.attempt = 0), this.reconnect();
        return;
      }
      this.disconnect();
    }
  };
};
const kg = /* @__PURE__ */ new Set([
  se.Unknown,
  se.Internal,
  se.DeadlineExceeded,
  se.ResourceExhausted,
  se.FailedPrecondition,
  se.Unavailable,
  se.DataLoss
]), jc = st("grpc:retry"), Jg = (t) => async (e) => {
  const n = e.contextValues.get(cl.retryAttempts), i = 300, s = e.contextValues.get(cl.retryDelay);
  if (e.stream || n === 0)
    return t(e);
  jc.trace({ url: e.url, attempts: n, maxDelay: s }, "retry options");
  for (let r = 0; ; r++)
    try {
      return await t(e);
    } catch (o) {
      jc.trace({ attempt: r, error: o, url: e.url }, "retry attempt");
      const l = Ae.from(o);
      if (r >= n || !(l instanceof Ae) || !kg.has(l.code))
        throw o;
      const a = Math.min(s, Math.pow(2, r) * i), c = Math.round(a * (1 + Math.random()) / 2);
      await new Promise((u) => setTimeout(u, c));
    }
}, cl = {
  retryAttempts: ws(10, { description: "Number of attempts to retry" }),
  retryDelay: ws(3e4, { description: "Max delay between retries in milliseconds" })
}, xg = () => {
  const t = localStorage.getItem("sl-device-id");
  if (t)
    return t;
  const e = zn();
  return localStorage.setItem("sl-device-id", e), e;
}, Mg = () => navigator.userAgentData?.platform || navigator.platform, Qg = (t) => t ? "webOS" : navigator.userAgentData && navigator.userAgentData.mobile || "ontouchstart" in window || navigator.maxTouchPoints > 0 ? "mobile-web" : "desktop-web";
class $c {
  toJsonOptions = {
    emitDefaultValues: !1,
    enumAsInteger: !0,
    useProtoFieldName: !1
  };
  // with timeout, using for unary requests
  transport;
  // without timeout, using for server streaming requests
  streamTransport;
  nanoquery;
  host;
  $headers;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  storeCache;
  interceptors = [];
  clients;
  streamClients;
  subscriptions;
  opts;
  constructor(e, n) {
    this.host = e, this.opts = n, this.$headers = new yn(et({
      "sl-device-id": xg(),
      "sl-device-os": Mg(),
      "sl-platform": Qg(n?.webOS)
    }), "transport:headers"), this.initInterceptors(), this.clients = /* @__PURE__ */ new Map(), this.streamClients = /* @__PURE__ */ new Map(), this.subscriptions = /* @__PURE__ */ new Map(), this.storeCache = /* @__PURE__ */ new Map();
    const [i, s, r] = Oc({
      dedupeTime: n?.dedupeTime,
      revalidateInterval: n?.refetchInterval
    });
    this.nanoquery = { createFetcherStore: i, createMutatorStore: s, utils: r }, this.transport = Kc({
      baseUrl: e,
      defaultTimeoutMs: 1e4,
      interceptors: this.interceptors
      // useBinaryFormat: true,
    }), this.streamTransport = Kc({
      baseUrl: e,
      interceptors: this.interceptors
      // useBinaryFormat: true,
    });
  }
  // use shared request params, based on Atom, each new Atom will create new subscription
  // mutate Atom, subscription automatically reconnect  with new params
  // if headers changed, reconnect subscription with new headers automatically
  addSubscription = (e, n, i) => {
    const s = this.subscriptions.get(n);
    if (s)
      return s;
    const r = new Lg(
      this.$headers,
      e,
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      n,
      i
    );
    return this.subscriptions.set(n, r), r;
  };
  removeSubscription = (e) => {
    e.disconnect(), this.subscriptions.delete(e.params);
  };
  // cleanup subscriptions
  disconnect = () => {
    for (const [s, r] of this.subscriptions)
      r.disconnect(), this.subscriptions.delete(s);
    this.clients.clear(), this.streamClients.clear(), this.subscriptions.clear();
    const [e, n, i] = Oc({
      dedupeTime: this.opts?.dedupeTime,
      revalidateInterval: this.opts?.refetchInterval
    });
    this.nanoquery = { createFetcherStore: e, createMutatorStore: n, utils: i };
  };
  registerInterceptor = (e) => {
    this.interceptors.push(e);
  };
  removeInterceptor = (e) => {
    this.interceptors = this.interceptors.filter((n) => n !== e);
  };
  getClient = (e) => {
    const n = e.typeName;
    if (this.clients.has(n))
      return this.clients.get(n);
    const i = Bc(e, this.transport);
    return this.clients.set(n, i), i;
  };
  getStreamClient = (e) => {
    const n = `stream-${e.typeName}`;
    if (this.clients.has(n))
      return this.clients.get(n);
    const i = Bc(e, this.streamTransport);
    return this.clients.set(n, i), i;
  };
  // create unary client, used for query request
  createPromiseClient = (e, { params: n = [], method: i }) => {
    const s = this.getClient(e), r = i.toString(), o = [
      e.typeName,
      r.charAt(0).toLowerCase() + r.slice(1),
      ...Array.isArray(n) ? n : [n]
    ], l = [e.typeName, r.charAt(0).toLowerCase() + r.slice(1)];
    return { client: s, createRequestOptions: (a) => {
      const c = ol();
      for (const u in a) {
        const h = cl[u];
        c.set(h, a[u]);
      }
      return c;
    }, queryKey: o, queryKeyStr: l.join("") };
  };
  // create promise client, used for server stream subscriptions
  createStreamClient = (e) => ({ client: this.getStreamClient(e) });
  setSdkKey = (e) => {
    this.$headers.setValue("sdk", e);
  };
  setAuth = (e, n) => {
    this.$headers.setValue("authorization", e), this.$headers.setValue("sl-user-id", n);
  };
  setHeader = (e, n) => this.$headers.setValue(e, n);
  getHeader = (e) => this.$headers.getValue(e);
  getHeaders = () => this.$headers.getValues();
  initInterceptors = () => {
    if (this.interceptors.length !== 0)
      return;
    const e = (n) => (i) => {
      const s = this.$headers.getValues();
      for (const r in s)
        i.header.set(r, s[r]);
      return n(i);
    };
    this.interceptors.push(e), window.localStorage.getItem("SL_GRPC_DEVTOOLS") === "true" ? this.interceptors.push(Tg()) : console.warn("SL GRPC DevTools is disabled. To enable, set SL_GRPC_DEVTOOLS to true in localStorage."), this.opts?.retryable && this.interceptors.push(Jg);
  };
}
const zg = (t, e) => {
  const { client: n, queryKey: i } = e.createPromiseClient(F0, {
    method: "retrieveEventId",
    params: [t]
  });
  return e.nanoquery.createFetcherStore(i, {
    fetcher: async (s, r, o) => {
      if (!o || typeof o != "string")
        return "";
      try {
        return (await n.retrieveEventId({
          id: o
        })).data?.id || "";
      } catch {
        return "";
      }
    }
  });
}, Kg = (t, e) => {
  const { client: n, queryKey: i } = e.createPromiseClient(Ji, { method: "getStream", params: [t] });
  return e.nanoquery.createFetcherStore(i, {
    fetcher: async (s, r, o) => o ? (await n.getStream({
      id: o
      // we are sure that id is a string
    })).data?.attributes : void 0
  });
}, Hg = (t, e) => {
  const { client: n, queryKey: i } = e.createPromiseClient(F0, { method: "summary", params: [t] });
  return e.nanoquery.createFetcherStore(i, {
    fetcher: async (s, r, o) => o ? (await n.summary({
      id: o
    })).data?.attributes : void 0
  });
}, Og = (t, e) => {
  const { queryKey: n, client: i } = e.createPromiseClient(qs, { method: "me", params: [t] });
  return e.nanoquery.createFetcherStore(n, {
    fetcher: async () => {
      if (!e.getHeader("authorization"))
        return { data: void 0 };
      const { data: s } = await i.me({});
      return { data: s };
    }
  });
}, Dg = (t) => {
  const { client: e, createRequestOptions: n } = t.createPromiseClient(qs, { method: "bypassAuth" }), i = n({ retryAttempts: 0 });
  return ({ userKey: s, schema: r, init: o, inviterKey: l }) => e.bypassAuth({ userKey: s, schema: r, init: o, inviterKey: l }, { contextValues: i });
}, Pg = (t, e) => {
  const { client: n, queryKey: i } = e.createPromiseClient(Ji, { method: "get", params: [t] });
  return e.nanoquery.createFetcherStore(i, {
    fetcher: async () => (await n.get({})).data?.attributes
  });
}, _g = (t, e) => {
  const { client: n, queryKey: i } = e.createPromiseClient(Ji, { method: "getOrganization", params: [t] });
  return e.nanoquery.createFetcherStore(i, {
    fetcher: async () => {
      const s = await n.getOrganization({});
      return s.data ? {
        ...s.data.attributes,
        id: s.data.id
      } : void 0;
    }
  });
}, jg = (t, e) => {
  const { client: n, queryKey: i } = e.createPromiseClient(Ji, {
    method: "getOrganizationAdvertising",
    params: [t]
  });
  return e.nanoquery.createFetcherStore(i, {
    fetcher: async () => (await n.getOrganizationAdvertising({})).data?.attributes
  });
}, $g = (t, e, n) => {
  t.transport = new $c(e.host, {
    dedupeTime: 1e3 * 60 * 5,
    // 5 minutes
    refetchInterval: 1e3 * 60 * 5,
    // 5 minutes
    retryable: !0,
    webOS: e.webOS
  }), t.analyticsTransport = new $c(e.analyticsHost), t.sdk.host = t.transport.host, t.transport.setSdkKey(e.sdkKey), t.transport.setHeader("sl-sdk-version", e.version || "-"), t.transport.$headers.subscribe((i) => {
    t.analyticsTransport.$headers.getStore().set(i);
  }), t.sdk.onMount({ name: "transport" }, () => () => {
    t.transport.disconnect(), t.analyticsTransport.disconnect();
  }), n();
};
var Yt;
(function(t) {
  t.SCHEMA = "schema", t.EXTERNAL_TOKEN = "eToken", t.TOKEN = "token";
})(Yt || (Yt = {}));
class Kn extends hi {
  constructor() {
    super("user");
  }
  // Schema
  setSchema = (e) => {
    this.write(Yt.SCHEMA, e);
  };
  getSchema = () => this.read(Yt.SCHEMA);
  // Token
  setToken = (e) => {
    this.write(Yt.TOKEN, e);
  };
  getToken = () => this.read(Yt.TOKEN);
  // External Token
  setExternalToken = (e) => {
    this.write(Yt.EXTERNAL_TOKEN, e);
  };
  getExternalToken = () => this.read(Yt.EXTERNAL_TOKEN);
  removeToken = () => {
    this.remove(Yt.TOKEN);
  };
}
var kt;
(function(t) {
  t.DISABLED = "disabled", t.INITIALIZATION = "initialization", t.READY = "ready", t.FAILED = "failed", t.SUSPENDED = "suspended";
})(kt || (kt = {}));
const qg = (t) => {
  const e = new Kn(), n = new ct(we(e.getExternalToken()), "userKey"), i = new ct(we(e.getToken()), "userToken"), s = new bt(Og(i.getStore(), t), "user", ({ data: o, error: l, loading: a }, c) => {
    if (!l)
      return o?.data?.id ? o.data.id : a === !1 ? void 0 : c;
  }), r = new bt(Pg(i.getStore(), t), "userSettings");
  return {
    userKey: n,
    userToken: i,
    user: s,
    userSettings: r
  };
}, ef = (t) => {
  const e = new ct(we(void 0), "providerStreamId"), n = new bt(zg(e.getStore(), t), "slStreamId", (r) => r?.data), i = new bt(Kg(n.getAtomStore(), t), "streamSettings"), s = new bt(Hg(n.getAtomStore(), t), "streamSettings");
  return n.getAtomStore().listen((r) => {
    (r === "" || r === void 0) && (i.getStore().mutate(void 0), s.getStore().mutate(void 0));
  }), {
    providerStreamId: e,
    slStreamId: n,
    streamSettings: i,
    streamSummary: s
  };
}, tf = (t) => {
  const e = new ct(we(void 0), "enabled"), n = new ct(we(kt.DISABLED), "status"), i = new bt(_g(e.getStore(), t), "organizationSettings", (l) => l?.data?.id), s = new bt(jg(i.getAtomStore(), t), "organizationAdvertising"), r = qg(t), o = ef(t);
  return {
    enabled: e,
    status: n,
    providerStreamId: o.providerStreamId,
    slStreamId: o.slStreamId,
    streamSettings: o.streamSettings,
    streamSummary: o.streamSummary,
    user: r.user,
    userKey: r.userKey,
    userToken: r.userToken,
    userSettings: r.userSettings,
    organizationSettings: i,
    organizationAdvertising: s
  };
};
let nf = class extends er {
  stores;
  constructor(e) {
    const n = tf(e), i = Ug(n);
    super(i, "core"), this.stores = n;
  }
  getValue() {
    throw new Error("Not implemented");
  }
  getValues() {
    return this.stores;
  }
  setValue() {
    throw new Error("Not implemented");
  }
  subscribe = (e) => {
    let n;
    for (n in this.stores) {
      const i = e[n];
      n in e && i !== void 0 && this.stores[n].subscribe(e[n]);
    }
  };
  unsubscribe = () => this.getStore().off();
};
const sf = (t, e, n) => {
  t.store = new nf(t.transport), t.stores = t.store.getValues(), t.sdk.enabled = t.stores.enabled.getStore(), t.sdk.status = t.stores.status.getStore(), t.sdk.sdkStore = Object.fromEntries(Object.entries(t.stores).map(([i, s]) => [i, s.getStore()])), t.sdk.organizationStore = () => t.stores.organizationSettings.getStore(), t.sdk.streamStore = () => t.stores.streamSettings.getStore(), t.sdk.streamSummary = () => t.stores.streamSummary.getStore(), t.storeUnsubscribe = () => {
    t.store.unsubscribe();
  }, n();
}, rf = (t) => {
  const { client: e } = t.createPromiseClient(G0, { method: "list" });
  return (n) => e.list(n);
}, M0 = (t) => {
  const { client: e } = t.createPromiseClient(G0, { method: "summary" });
  return (n) => e.summary(n);
}, of = (t, e) => {
  const { client: n, queryKey: i } = e.createPromiseClient(qs, {
    method: "getFriends",
    params: [t]
  });
  return e.nanoquery.createFetcherStore(i, {
    fetcher: async (s, r, o) => {
      if (!o)
        return [];
      try {
        return (await n.getFriends({})).data;
      } catch {
        return [];
      }
    }
  });
}, lf = (t, e) => {
  const { client: n, queryKey: i } = e.createPromiseClient(it, { method: "get", params: [t] });
  return e.nanoquery.createFetcherStore(i, {
    fetcher: async (s, r, o) => (await n.get({
      eventId: o
    })).data?.attributes,
    revalidateInterval: 0,
    dedupeTime: 1e3 * 60 * 60
  });
}, af = (t, e, n) => {
  const { client: i, queryKey: s } = n.createPromiseClient(it, {
    method: "syncQuestion",
    params: [t, e ? "true" : ""]
  });
  return n.nanoquery.createFetcherStore(s, {
    fetcher: async (r, o, l, a) => {
      if (!l || a)
        return;
      const c = await i.syncQuestion({
        filter: {
          eventId: l
        }
      });
      if (c.data?.attributes?.question?.type !== M.PROMOTION)
        return c.data?.attributes;
    },
    dedupeTime: 1e3 * 60 * 10,
    // 10 minutes
    revalidateInterval: 0
  });
}, cf = async (t, e) => {
  const { client: n } = e.createPromiseClient(it, { method: "item", params: [t] });
  return (await n.item({
    id: t
  })).data;
}, uf = (t, e) => {
  const { client: n } = e.createStreamClient(it), i = /* @__PURE__ */ Pt({ eventId: t.get() || "", feedId: "" });
  return t.subscribe((s = "") => {
    i.set({ eventId: s, feedId: "" });
  }), e.addSubscription(n.subscription, i, { name: "feedSubscription" });
}, hf = (t, e) => {
  const { client: n } = e.createStreamClient(it);
  return e.addSubscription(n.questionSubscription, { questionId: t }, { name: "questionSubscription" });
}, Q0 = async (t, e) => {
  const { client: n } = e.createPromiseClient(it, { method: "questionByUser", params: [t] });
  return (await n.questionByUser({
    questionId: t
  })).data?.attributes?.question;
}, Cs = (t, e) => {
  const { client: n, queryKey: i, queryKeyStr: s } = e.createPromiseClient(it, {
    method: "questionByUser",
    params: [t]
  });
  let r = s;
  if (typeof t != "object" ? r += t : r += "atom", e.storeCache.has(r))
    return e.storeCache.get(r);
  {
    const o = e.nanoquery.createFetcherStore(i, {
      fetcher: async (l, a, c) => (await n.questionByUser({
        questionId: c
      })).data?.attributes?.question,
      dedupeTime: 1 / 0,
      revalidateInterval: 0
    });
    return e.storeCache.set(r, o), o;
  }
}, z0 = async (t, e) => {
  if (!t)
    return;
  const { client: n } = e.createPromiseClient(it, { method: "getQuestion", params: [t] }), i = await n.getQuestion({
    id: t
  });
  if (!i.data?.attributes)
    return;
  const { options: s, notification: r, ...o } = i.data.attributes, l = s?.options.case === "promotion" ? s?.options.value : void 0;
  return { id: o.id, question: o, promotion: l, notification: r };
}, df = (t, e, n, i, s, r, o, l) => {
  const { client: a, queryKey: c } = l.createPromiseClient(it, {
    method: "list",
    params: [t, e, r ? "true" : "", o]
  });
  return l.nanoquery.createFetcherStore(c, {
    fetcher: async (u, h, d, m, p, g) => {
      if (!d || p || !g)
        return [];
      const A = await a.list({
        eventId: d,
        filter: {
          types: m === ln.ALLOWED ? [] : [M.FACTOID, M.PROMOTION, M.TWEET],
          statuses: [ve.ACTIVE, ve.RESOLVED]
        }
      }), b = {
        eventId: d,
        userId: n.get(),
        organizationId: i.get()
      };
      for (const R of A.data)
        s.isQuestionReceived(b, R.id) || (Ve.emit("poll", {
          action: "received",
          payload: {
            isAd: R.attributes?.adUnit == Ne.UNSET,
            questionId: R.id,
            questionType: R.attributes?.type
          }
        }), s.saveQuestionReceived(b, R.id));
      return A.data;
    },
    dedupeTime: 1 / 0,
    revalidateInterval: 0
  });
}, mf = (t, e) => {
  const { client: n, queryKey: i } = e.createPromiseClient(it, {
    method: "list",
    params: [t]
  });
  return e.nanoquery.createFetcherStore(i, {
    fetcher: async (s, r, o) => {
      if (!o)
        return;
      const l = (await n.list({
        eventId: o,
        filter: {
          types: [M.PROMOTION],
          statuses: [ve.ACTIVE]
        },
        pagination: {
          page: 0,
          pageSize: 1
        }
      })).data?.[0];
      if (l?.type === "promotion")
        return z0(l.id, e);
    },
    dedupeTime: 1 / 0,
    revalidateInterval: 0
  });
}, pf = (t, e, n, i, s) => {
  const { client: r, queryKey: o } = s.createPromiseClient(it, {
    method: "betPack",
    params: [t, e, n]
  });
  return s.nanoquery.createFetcherStore(o, {
    fetcher: async (l, a, c, u, h) => {
      if (!c || !u || !h)
        return {
          timestamp: Date.now(),
          data: null
        };
      const d = await r.betPack({
        eventId: c,
        types: [M.PREDICTION],
        statuses: [ve.ACTIVE, ve.RESOLVED],
        limit: 5,
        sort: {
          field: "activated_at",
          order: "asc"
        }
      });
      return !d.data || !d.data.length ? {
        timestamp: Date.now(),
        data: null
      } : {
        timestamp: Date.now(),
        data: d.data?.reduce((m, p) => {
          const g = p?.attributes?.question;
          if (!g?.id)
            return m;
          const A = {
            eventId: c,
            userId: u,
            organizationId: h
          };
          return i.isQuestionReceived(A, g.id) || (Ve.emit("poll", {
            action: "received",
            payload: {
              isAd: g?.adUnit == Ne.UNSET,
              questionId: g.id,
              questionType: g.type
            }
          }), i.saveQuestionReceived(A, g.id)), g.answers = g.answers.sort((b, R) => b.id > R.id ? 1 : -1), { ...m, [g.id]: g };
        }, {})
      };
    },
    dedupeTime: 1 / 0,
    revalidateInterval: 0
  });
}, gf = (t, e, n) => {
  const i = /* @__PURE__ */ new Map(), s = (c, u) => {
    i.has(c) || i.set(c, /* @__PURE__ */ new Set()), i.get(c)?.add(u);
  }, r = (c, u) => i.get(c)?.has(u) ?? !1, o = /* @__PURE__ */ Po([e, n], () => {
    const c = e.get();
    if (!c)
      return;
    const u = n.get().data?.find((m) => m.id === c?.questionId), h = c?.question?.openedFrom, d = c.questionId;
    if (u)
      return u.openedFrom = h, Object.assign(u, {
        fireEvent: (m) => s(d, m),
        isEventFired: (m) => r(d, m)
      });
    if (c.question)
      return Object.assign(c.question, {
        fireEvent: (m) => s(d, m),
        isEventFired: (m) => r(d, m)
      });
  }), l = /* @__PURE__ */ Po(o, (c) => c?.id), a = Cs(l, t);
  return { $store: o, $extendedStore: a, updateExtendedQuestion: (c) => {
    const u = a.get().data, h = (d, m) => {
      if (!d || !m)
        return (d || m || []).sort((b, R) => b.id > R.id ? 1 : -1);
      const p = d.sort((b, R) => b.id > R.id ? 1 : -1), g = m.sort((b, R) => b.id > R.id ? 1 : -1), A = [];
      for (let b = 0; b < p.length; b++)
        A.push({
          ...p[b],
          ...g[b],
          correct: p[b].correct,
          youVoted: p[b].youVoted,
          pointsEarned: p[b].pointsEarned
        });
      return A;
    };
    a.mutate({
      ...c,
      options: u?.options,
      subject: u?.subject,
      appearance: u?.appearance,
      answers: h(u?.answers, c?.answers)
    });
  } };
};
var Hn;
(function(t) {
  t.SHOWED = "showed", t.EVENT = "ev";
})(Hn || (Hn = {}));
let ff = class extends hi {
  constructor() {
    super("advertisement");
  }
  setShowed = (e) => {
    this.write(Hn.SHOWED, e, "true");
  };
  isViewed = (e) => this.read(Hn.SHOWED, e);
  fireEvent = (e, n) => {
    this.write(Hn.EVENT, n, e, "true");
  };
  isEventFired = (e, n) => this.read(Hn.EVENT, n, e) === "true";
};
const bf = (t) => {
  const e = t.data?.attributes?.question;
  if ((t.data?.attributes?.feedItem?.type === "promotion" ? t.data.attributes.feedItem : void 0) === void 0 || !e)
    return;
  const { options: n, notification: i, ...s } = e, r = n?.options.case === "promotion" ? n.options.value : void 0;
  return {
    id: s.id,
    question: s,
    notification: i,
    promotion: r
  };
}, es = (t) => t.startsWith("http://") || t.startsWith("https://") ? new URL(t).toString() : t, Af = ({ gamOptions: t, gamBaseUrl: e }) => {
  const n = `${e}?`, i = [];
  for (const s in t) {
    const r = s.replace(/([a-zA-Z])(?=[A-Z])/g, "$1_").toLowerCase(), o = t[s];
    if (o)
      if (typeof o == "string")
        i.push(`${r}=${es(o)}`);
      else if (Array.isArray(o))
        i.push(`${r}=${o.map(es).join(",")}`);
      else {
        const l = Object.entries(o).map(([a, c]) => Array.isArray(c) ? `${a}=${c.map(es).join(",")}` : typeof c == "string" ? `${a}=${es(c)}` : `${a}=${c}`).join("&").replaceAll("=", "%3D").replaceAll("&", "%26").replaceAll(",", "%2C");
        i.push(`${r}=${l}`);
      }
  }
  return n + i.join("&");
}, wn = (t) => (t?.promotion?.type === ce.INGAME_IAB11_LBAR || t?.promotion?.type === ce.INGAME_IAB21_LBAR) && !!t.promotion.additionalBanner?.imageUrl, Vf = (t, e, n) => {
  let i = !1;
  const s = n.transport, r = st("advertisement"), o = new ff(), l = (b, R) => {
    o.fireEvent(b, R);
  }, a = (b, R) => o.isEventFired(b, R), c = et({}), u = mf(t, s), h = (b) => {
    const R = c.get(), S = R.data?.question.id, E = R.data?.promotion?.type;
    S && (c.get()?.isOpened || (c.setKey("isOpened", !0), Ve.emit("advertisement", {
      action: "opened",
      payload: {
        id: S,
        type: E,
        hasBanner: wn(R.data),
        openedFrom: b?.fromNotification ? "notification" : "auto"
      }
    })), b?.fromNotification && (c.setKey("hasNotification", !1), Ve.emit("advertisement", {
      action: "notification-opened",
      payload: {
        id: S,
        type: E,
        hasBanner: wn(R.data)
      }
    })));
  }, d = () => {
    const b = c.get(), R = b.data?.question.id, S = b.data?.promotion?.type, E = c.get()?.isOpened;
    R && !E && (r.debug({ id: R }, "markAsViewed: %o"), o.setShowed(R), c.setKey("isOpened", !0), Ve.emit("advertisement", {
      action: "viewed",
      payload: {
        id: R,
        type: S,
        hasBanner: wn(b.data)
      }
    }));
  }, m = (b, R) => {
    R ? c.set({
      loading: !1,
      error: void 0,
      data: R,
      hasNotification: R?.notification?.enabled === Us.NOTIFICATION_ENABLED,
      close: () => p(R.question.id),
      togglePause: (S) => g(R.question.id, S),
      toggleMute: (S) => A(R.question.id, S),
      isViewed: !!o.isViewed(R.question.id),
      fireEvent: (S) => l(b, S),
      isEventFired: (S) => a(b, S)
    }) : (c.setKey("loading", !0), z0(b, s).then((S) => c.set({
      loading: !1,
      error: void 0,
      data: S,
      hasNotification: S?.notification?.enabled === Us.NOTIFICATION_ENABLED,
      close: () => p(S?.question.id),
      togglePause: (E) => g(S?.question.id, E),
      toggleMute: (E) => A(S?.question.id, E),
      isViewed: S && !!o.isViewed(S.question.id),
      fireEvent: (E) => l(b, E),
      isEventFired: (E) => a(b, E)
    })).catch((S) => c.set({
      loading: !1,
      error: S,
      data: void 0,
      fireEvent: () => {
      },
      isEventFired: () => !1
    })));
  };
  c.subscribe((b, R) => {
    if (!(b.data?.id === R?.data?.id && b.isPaused !== R?.isPaused)) {
      if (b.data?.promotion?.type === ce.EXTERNAL_AD && !b?.externalAd && b.data.promotion.adCampaigns?.desktopWebSettings) {
        const S = Af(b.data.promotion.adCampaigns.desktopWebSettings);
        c.setKey("externalAd", { type: "gam", url: S });
      }
      b.data?.promotion && !b.isOpened && (Ve.emit("advertisement", {
        action: "received",
        payload: {
          id: b.data.question.id,
          type: b.data.promotion.type,
          hasNotification: !!b.hasNotification,
          hasBanner: wn(b.data),
          isViewed: !!o.isViewed(b.data.question.id)
        },
        skipAnalytics: b.data.question.id === R?.data?.question.id
      }), b.data.question.id !== R?.data?.question.id && !o.isViewed(b.data.question.id) && Ve.emit("advertisement", {
        action: "notification-received",
        payload: {
          id: b.data.question.id,
          type: b.data.promotion.type,
          hasNotification: !0,
          hasBanner: wn(b.data),
          isViewed: !1
        }
      })), !b?.data && R?.data && Ve.emit("advertisement", {
        action: "closed",
        payload: {
          id: R.data.question.id,
          type: R.data.promotion?.type,
          hasNotification: !!R.hasNotification,
          hasBanner: wn(R.data),
          isViewed: !!o.isViewed(R.data.question.id)
        }
      });
    }
  });
  const p = (b) => {
    (!b || c.get()?.data?.question.id === b) && c.set({});
  }, g = (b, R) => {
    c.get()?.data?.question.id === b && c.setKey("isPaused", R);
  }, A = (b, R) => {
    c.get()?.data?.question.id === b && c.setKey("isMuted", R);
  };
  return { connect: () => {
    i || (i = !0, u.subscribe((b, R) => {
      b.data && (!R?.data || b.data.id !== R.data.id) && m(b.data.question.id, b.data);
    }), e.addListener("promotion", (b) => {
      const R = bf(b);
      if (R) {
        if (R.question.status === ve.RESOLVED) {
          p(R.question.id), r.debug({ promotion: R }, "resolved: %o");
          return;
        }
        if (R.question.status === ve.ACTIVE) {
          r.debug({ promotion: R }, "active: %o"), m(R.question.id, R);
          return;
        }
        r.debug({ promotion: R }, "skip: %o");
      }
    }));
  }, hide: p, show: m, open: h, markAsViewed: d, $store: c };
};
var Ct;
(function(t) {
  t.ONBOARDING = "onboarding", t.ONBOARDING_IO = "onboarding_io", t.QUESTION_RECEIVED = "q-received", t.QUESTION_OPENED = "q-opened";
})(Ct || (Ct = {}));
let Rf = class extends hi {
  constructor() {
    super("gamification-session", window.sessionStorage);
  }
  writeValue = (e, n) => {
    this.write(...e, n);
  };
  readValue = (e) => this.read(...e);
}, Ef = class extends hi {
  sessionStorage;
  constructor() {
    super("gamification"), this.sessionStorage = new Rf();
  }
  saveQuestionReceived = ({ userId: e, eventId: n, organizationId: i }, s) => {
    this.write(Ct.QUESTION_RECEIVED, i, e, n, s, "1");
  };
  isQuestionReceived = ({ userId: e, eventId: n, organizationId: i }, s) => !!this.read(Ct.QUESTION_RECEIVED, i, e, n, s);
  saveQuestionOpened = ({ userId: e, eventId: n, organizationId: i }, s) => {
    this.write(Ct.QUESTION_OPENED, i, e, n, s, "1");
  };
  isQuestionOpened = ({ userId: e, eventId: n, organizationId: i }, s) => !!this.read(Ct.QUESTION_OPENED, i, e, n, s);
  saveOnboardingStatus = ({ userId: e, eventId: n, organizationId: i }, s) => {
    this.write(Ct.ONBOARDING, i, e, n, s);
  };
  getOnboardingStatus = ({ userId: e, eventId: n, organizationId: i }) => this.read(Ct.ONBOARDING, i, e, n);
  setOnboardingInstantOpen = ({ userId: e, eventId: n, organizationId: i }) => {
    this.sessionStorage.writeValue([Ct.ONBOARDING_IO, i, e, n], "1");
  };
  getOnboardingInstantOpen = ({ userId: e, eventId: n, organizationId: i }) => this.sessionStorage.readValue([Ct.ONBOARDING_IO, i, e, n]);
};
var ln;
(function(t) {
  t.ALLOWED = "allowed", t.DISALLOWED = "disallowed";
})(ln || (ln = {}));
let yf = class {
  /** sl event id */
  slStreamId;
  /** organization id */
  organizationId;
  /** current user id */
  userId;
  /**
   * flag to allow interactive questions (polls, trivia, predictions)
   * controlled by opt-in and onboarding flags
   */
  interactiveAllowed;
  /** opened question, using to download statistics */
  openedQuestionId;
  /** opened question statistics */
  openedQuestion;
  /** last active question in feed */
  activeQuestionId;
  feedList;
  betPack;
  /** moderation id */
  moderationId;
  /** moderation */
  moderation;
  /** feed subscription to receive new active question, update last active question */
  feedSubscription;
  /** subscription to opened question (vote percentage) */
  questionSubscription;
  advertisement;
  withPickHistory;
  storage;
  notifications;
  log;
  transport;
  cancels = /* @__PURE__ */ new Set();
  constructor(e) {
    this.transport = e.transport, this.log = st("gamification-background"), this.storage = new Ef(), this.slStreamId = e.stores.slStreamId.getAtomStore(), this.organizationId = e.stores.organizationSettings.getAtomStore(), this.userId = e.stores.user.getAtomStore(), this.moderationId = new ct(we(void 0), "moderationId").getStore(), this.interactiveAllowed = new ct(we(ln.DISALLOWED), "interactiveAllowed").getStore(), this.openedQuestionId = new ct(we(void 0), "openedQuestionId").getStore(), this.withPickHistory = we(!1), this.notifications = e.notifications, this.moderation = new bt(lf(this.slStreamId, e.transport), "gamification:moderation");
    const n = !!e.sdk.options.get().betPack;
    this.feedList = new bt(df(this.slStreamId, this.interactiveAllowed, this.userId, this.organizationId, this.storage, n, this.withPickHistory, e.transport), "gamification:feedList"), this.betPack = new bt(pf(this.slStreamId, this.userId, this.organizationId, this.storage, e.transport), "gamification:betPack"), this.activeQuestionId = af(this.slStreamId, n, e.transport), this.openedQuestion = gf(e.transport, this.openedQuestionId, this.feedList.getStore()), this.cancels.add(this.openedQuestionId.listen((i) => {
      this.log.debug({ item: i }, "received question"), i?.questionId ? (this.log.info("cleanup on close question"), this.questionSubscription !== void 0 && (e.transport.removeSubscription(this.questionSubscription), this.questionSubscription = void 0), this.questionSubscription = hf(i.questionId, e.transport), this.questionSubscription.addListener("feed-subscription-opened-question", (s) => {
        const r = s.data?.attributes?.question;
        if (this.openedQuestion.updateExtendedQuestion(r), this.betPack && r?.type === M.PREDICTION && (r.status === ve.ACTIVE || r.status === ve.RESOLVED)) {
          const o = this.betPack.getValues().data?.data || {}, l = o?.[r.id];
          if (l) {
            const a = [], c = l.answers.sort((h, d) => h.id > d.id ? 1 : -1), u = r.answers.sort((h, d) => h.id > d.id ? 1 : -1);
            for (let h = 0; h < c.length; h++)
              a.push({
                ...c[h],
                ...u[h],
                correct: c[h].correct,
                youVoted: c[h].youVoted,
                pointsEarned: c[h].pointsEarned
              });
            this.betPack.getStore().mutate({
              timestamp: Date.now(),
              data: {
                ...o,
                [r.id]: {
                  ...l,
                  status: r.status,
                  marketClosed: r.marketClosed,
                  activatedAt: r.activatedAt,
                  answerSetAt: r.answerSetAt,
                  answers: a
                }
              }
            });
          }
        }
      }), this.questionSubscription.connect()) : (this.log.info("cleanup on close question"), this.questionSubscription !== void 0 && (e.transport.removeSubscription(this.questionSubscription), this.questionSubscription = void 0));
    })), this.feedSubscription = uf(this.slStreamId, e.transport), this.cancels.add(this.feedSubscription.addListener("bet-pack-update", async (i) => {
      const s = i.data?.attributes?.question;
      if (this.betPack && s?.type === M.PREDICTION && (s.status === ve.ACTIVE || s.status === ve.RESOLVED)) {
        const r = this.betPack.getValues().data?.data || {}, o = r?.[s.id];
        if (o)
          this.betPack.getStore().mutate({
            timestamp: Date.now(),
            data: {
              ...r,
              [s.id]: {
                ...o,
                status: s.status,
                marketClosed: s.marketClosed,
                activatedAt: s.activatedAt,
                answerSetAt: s.answerSetAt
              }
            }
          });
        else if (!o && Object.keys(r).length < 5) {
          const l = await Q0(s.id, this.transport);
          this.betPack.getStore().mutate({
            timestamp: Date.now(),
            data: {
              ...r,
              [s.id]: l
            }
          });
        }
      }
    })), this.cancels.add(this.feedSubscription.addListener("feed-subscription-active-question", (i) => {
      const s = this.activeQuestionId.get().data?.question?.id, r = i.data?.attributes?.question;
      if (!(!r || r.type === M.PROMOTION)) {
        if (r.status === ve.RESOLVED) {
          s === r.id && this.activeQuestionId.mutate(void 0);
          return;
        }
        window.requestAnimationFrame(() => {
          this.activeQuestionId.mutate(i.data?.attributes);
        });
      }
    })), this.cancels.add(this.feedSubscription.addListener("moderation update", (i) => {
      window.requestAnimationFrame(() => {
        i.data?.attributes?.question === void 0 && i.data?.attributes?.moderation && this.moderation.invalidate();
      });
    })), this.cancels.add(this.activeQuestionId.subscribe((i, s) => {
      i.data?.feedItem && i.data?.feedItem?.id !== s?.data?.feedItem?.id && e.onQuestionActivate({
        stage: "activate",
        id: i.data.feedItem.id,
        isViewed: !!this.notifications.isViewed(this.getCurrentSessionId({
          prefix: "notification",
          entity: i.data.feedItem.id
        })),
        hasNotification: !0,
        type: i.data.feedItem.type
      }), !i.data?.feedItem && s?.data?.feedItem && e.onQuestionActivate({
        stage: "deactivate",
        id: s.data.feedItem.id,
        isViewed: !!this.notifications.isViewed(this.getCurrentSessionId({
          prefix: "notification",
          entity: s.data.feedItem.id
        })),
        hasNotification: !0,
        type: s.data.feedItem.type
      });
    })), this.feedSubscription.connect(), this.cancels.add(this.interactiveAllowed.listen(() => {
      window.requestAnimationFrame(() => {
        this.activeQuestionId.invalidate();
      });
    })), e.sdk.onMount({ name: "gamification-background" }, () => () => {
      this.activeQuestionId.off();
      for (const i of this.cancels)
        i(), this.cancels.delete(i);
    }), n || (this.advertisement = Vf(this.slStreamId, this.feedSubscription, e));
  }
  /**
   * Get id for notifications and link with current session
   * @param opts.prefix - id prefix (onboarding, question, tweet, ...etc)
   * @param opts.userId - current user id, if not presented get from sdk automatically
   * @param opts.eventId - current event id, if not presented get from sdk automatically
   * @param opts.organizationId - current organization id, if not presented get from sdk automatically
   * @param opts.entity - entity id (question id, tweet id, ...etc)
   */
  getCurrentSessionId = (e) => {
    const n = e.eventId || this.slStreamId.get() || "", i = e.userId || this.userId.get() || "", s = e.organizationId || this.organizationId.get() || "", r = e.entity || "", o = e.prefix || "";
    return [s, n, i, o, r].join(":");
  };
  disconnect = () => {
    this.feedSubscription?.disconnect(), this.questionSubscription !== void 0 && (this.transport.removeSubscription(this.questionSubscription), this.questionSubscription = void 0);
  };
  /**
   * Open question and mark notification for this question as viewed
   */
  openQuestion = (e, n) => {
    this.openedQuestionId.set({ questionId: e, question: n }), this.notifications.markAsViewed(this.getCurrentSessionId({ prefix: "notification", entity: e }));
  };
  /**
   * Close question and mark notification for this question as viewed
   */
  closeQuestion = (e) => {
    this.openedQuestionId.set(void 0), e && this.notifications.markAsViewed(this.getCurrentSessionId({ prefix: "notification", entity: e }));
  };
}, Cf = class {
  notificationsList;
  store;
  timeouts;
  waitingQueue;
  activeQueue;
  options;
  logger;
  constructor(e) {
    this.options = e, this.logger = st("notifications"), this.store = /* @__PURE__ */ new Map(), this.timeouts = /* @__PURE__ */ new Map(), this.waitingQueue = /* @__PURE__ */ new Set(), this.activeQueue = /* @__PURE__ */ new Set(), this.notificationsList = we(/* @__PURE__ */ new Map());
  }
  addToQueue = (e) => {
    if (this.store.has(e.id)) {
      this.logger.debug({ notification: e }, "skip existed notification: %o");
      return;
    }
    const n = e.close, i = e.action;
    if (this.store.set(e.id, {
      ...e,
      close: (...s) => {
        n && n(...s), this.closeNotification(e.id);
      },
      action: (...s) => {
        i && i(...s), this.closeNotification(e.id, { animateHiding: !1 });
      }
    }), this.waitingQueue.add(e.id), this.activeQueue.size === this.options.concurrency) {
      const [s] = this.activeQueue;
      if (this.store.get(s)?.persistent !== !0)
        this.closeNotification(s);
      else {
        const [r] = this.waitingQueue;
        this.waitingQueue.size > 1 && this.closeNotification(r), this.tickWaitingQueue();
      }
    } else
      this.tickWaitingQueue();
  };
  tickWaitingQueue = () => {
    if (this.activeQueue.size < this.options.concurrency) {
      const [e] = this.waitingQueue;
      if (!e)
        return;
      this.activeQueue.add(e), this.waitingQueue.delete(e), this.logger.debug({ job: e }, "waiting queue tick"), this.tickActiveQueue(e);
    } else
      this.logger.debug({ queueSize: this.activeQueue.size, concurrency: this.options.concurrency }, "waiting queue tick skipped");
  };
  tickActiveQueue = (e) => {
    if (!e)
      return;
    const n = this.store.get(e);
    if (!n) {
      this.logger.debug({ notificationId: e }, "active queue tick skipped, notification not exist");
      return;
    }
    Ve.emit("notification", {
      action: "received",
      payload: {
        type: n.type,
        questionId: n.data.questionId,
        questionType: n.data.questionType
      }
    });
    const i = setTimeout(() => {
      const s = e, r = new Map(this.notificationsList.get());
      r.set(n.id, n), this.notificationsList.set(r);
      const o = setTimeout(() => {
        this.logger.debug({ notificationId: s, delay: n.autoHideDuration || 5e3 }, "notification hiding by autoHideDuration"), this.closeNotification(s);
      }, n.autoHideDuration || 5e3);
      this.timeouts.set(s, o), this.logger.debug({ notificationId: s, queue: [...r.values()] }, "notification displayed");
    }, n.delay || 0);
    this.timeouts.set(e, i), this.logger.debug({ notificationId: e }, "active queue tick completed"), this.tickWaitingQueue();
  };
  closeNotification = (e, { animateHiding: n = !0 } = {}) => {
    const i = new Map(this.notificationsList.get()), s = i.get(e);
    if (s) {
      const r = !(this.waitingQueue.size >= this.options.concurrency) && n;
      s.hiding = r, this.notificationsList.set(i);
      const o = () => {
        const l = new Map(this.notificationsList.get());
        l.delete(e), this.notificationsList.set(l);
        const a = this.timeouts.get(e);
        a !== void 0 && (clearTimeout(a), this.timeouts.delete(e)), this.logger.debug({ notificationId: e }, "notification hidden"), Ve.emit("notification", {
          action: "closed",
          payload: {
            type: s.type,
            questionId: s.data.questionId,
            questionType: s.data.questionType
          }
        });
      };
      if (r) {
        const l = setTimeout(o, this.options.animationDelay || 0);
        this.timeouts.set(e, l);
      } else
        o();
    }
    return this.store.delete(e), this.activeQueue.delete(e), this.waitingQueue.delete(e), this.tickWaitingQueue(), this.logger.debug({ notificationId: e }, "notification hiding"), s;
  };
  drain = () => {
    this.store.clear(), this.timeouts.clear(), this.waitingQueue.clear(), this.activeQueue.clear(), this.notificationsList.off(), this.notificationsList.set(/* @__PURE__ */ new Map());
  };
};
var Ys;
(function(t) {
  t.OPENED = "opened";
})(Ys || (Ys = {}));
let Wf = class extends hi {
  constructor() {
    super("notification");
  }
  setOpened = (e) => {
    this.write(Ys.OPENED, e, "true");
  };
  isOpened = (e) => this.read(Ys.OPENED, e);
  clearNotification = () => {
    this.clear();
  };
}, Sf = class {
  queue;
  storage;
  constructor(e = {}) {
    this.storage = new Wf(), this.queue = new Cf({ concurrency: 1, animationDelay: 1600, ...e });
  }
  isViewed = (e) => this.storage.isOpened(e);
  add = (e) => {
    if (!this.isViewed(e.id)) {
      if (e.data && e.emitEvent) {
        const n = e.action;
        e.action = (...i) => {
          n && n(...i), Ve.emit("notification", {
            action: "opened",
            payload: {
              questionId: e.data.questionId,
              questionType: e.data.questionType
            }
          });
        };
      }
      this.queue.addToQueue(e);
    }
  };
  close = (e, { markAsViewed: n = !0, animateHiding: i } = {}) => {
    this.queue.closeNotification(e, { animateHiding: i }), n && this.markAsViewed(e);
  };
  update = (e, n) => {
    const i = this.queue.notificationsList.get()?.get(e);
    n(i);
  };
  getActiveNotification = () => {
    const e = this.queue.notificationsList.get();
    if (!e?.size)
      return null;
    for (const n of e.values())
      if (n.type === Kt.ONBOARDING)
        return n;
    return e.values().next().value;
  };
  getQueueStore = () => this.queue.notificationsList;
  markAsViewed = (e) => {
    this.storage.setOpened(e);
  };
};
const Zf = (t, e, n) => {
  t.notifications = new Sf(void 0), t.addNotification = t.notifications.add, t.sdk.getNotificationsStore = () => t.notifications.getQueueStore(), t.sdk.getActiveNotification = () => t.notifications.getActiveNotification(), t.sdk.onMount({ name: "notifications" }, () => () => {
    t.notifications.queue.drain();
  }), n();
};
var ri;
(function(t) {
  t.UNKNOWN = "unknown", t.ALREADY_VOTED = "already_voted";
})(ri || (ri = {}));
const qc = async (t, e) => {
  const { client: n, createRequestOptions: i } = t.createPromiseClient(it, { method: "submitAnswer" }), s = i({ retryAttempts: 0 });
  try {
    return await n.submitAnswer({ data: e }, { contextValues: s });
  } catch (r) {
    throw Ae.from(r)?.code === se.AlreadyExists ? new Error(ri.ALREADY_VOTED) : new Error(ri.UNKNOWN);
  }
}, K0 = (t, e) => {
  const { client: n, createRequestOptions: i } = t.createPromiseClient(it, { method: "submitInplay" }), s = i({ retryAttempts: 0 });
  return n.submitInplay({ data: { eventId: +e } }, { contextValues: s });
}, vf = (t) => {
  switch (t) {
    case Ec.PHONE:
      return Fr.PHONE;
    case Ec.EMAIL:
      return Fr.MAIL;
    default:
      return Fr.UNSET;
  }
}, If = (t, e) => {
  const { client: n, createRequestOptions: i } = t.createPromiseClient(dg, {
    method: "sendWebhookEvent"
  }), s = i({ retryAttempts: 0 });
  return n.sendWebhookEvent({
    eventId: e.eventId,
    questionId: e.questionId,
    data: {
      event: ug.CLICK_BUTTON,
      notificationType: vf(e.userAccountInfo),
      userId: e.userId,
      description: "",
      metadata: {},
      customFields: {}
    }
  }, { contextValues: s });
}, Nf = {
  pageSize: 10
}, Ff = (t, e, n, i, s) => {
  let r = 0;
  const o = we({ pageSize: Nf.pageSize, page: 0 }), l = et({
    data: [],
    key: Date.now(),
    hasMore: !0,
    loading: void 0,
    error: void 0
  }), a = rf(t), c = async () => {
    const d = e.get(), m = i?.getStore().get().data?.map((p) => p.slId) || [];
    if (d && m?.length) {
      const p = n.get();
      p && m.push(p), l.setKey("loading", !0), l.setKey("data", []);
      const g = await a({
        eventId: d,
        usersIds: m,
        leaderboardId: ""
      });
      l.set({
        data: g.data.map((A, b) => ({
          ...A.attributes,
          friendsRank: b + 1
        })),
        hasMore: !1,
        key: Date.now(),
        loading: !1
      }), g.meta && (r = Math.round(g.meta.count / g.meta.pageSize));
    }
  }, u = () => {
    c();
  }, h = (d) => {
    const m = o.get(), p = d || m.page + 1;
    p <= r && o.set({ ...m, page: p });
  };
  return Hs(l, () => {
    const d = e.listen(c), m = i?.listen(c);
    return () => {
      d(), m?.();
    };
  }), { $store: l, fetchMore: h, invalidate: u };
};
class Gf extends hi {
  get = this.read;
  set = this.write;
  del = this.remove;
  constructor() {
    super("deep-link-context", window.sessionStorage);
  }
}
const e1 = "sldl", tr = "sldl_uid", H0 = "sldl_eid", O0 = "sldl_e_eid", Xf = /* @__PURE__ */ new Set([tr, H0, O0]), t1 = (t) => {
  const e = {}, n = {};
  for (const [i, s] of t)
    Xf.has(i) ? e[i] = s : n[i] = s;
  return { result: e, remain: n };
}, Uf = ({ hash: t, search: e }) => {
  if (t && t.includes(e1)) {
    const n = new URLSearchParams(t.substr(1));
    return { hash: t1(n) };
  }
  if (e && e.includes(e1)) {
    const n = new URLSearchParams(e);
    return { search: t1(n) };
  }
  return null;
}, n1 = st("deep_link"), Ft = {
  debug: (...t) => {
    n1.debug(...t), localStorage.getItem("SL_DEBUG") && console.log(...t);
  },
  trace: (...t) => {
    n1.trace(...t), localStorage.getItem("SL_DEBUG") && console.log(...t);
  }
}, Bf = (t, e) => {
  const { hash: n, search: i } = window.location;
  if (Ft.debug({ hash: n, search: i }, "get deep link data from"), n || i) {
    const s = Uf({ hash: n, search: i });
    if (Ft.debug(s, "parse deep link result"), s) {
      const { hash: r, search: o } = s, { result: l, remain: a } = r || o;
      if (Object.keys(l).length !== 0) {
        t.setValue("data", l);
        const c = Object.keys(a).length !== 0;
        if (r) {
          let u = "";
          c && (u = `#${new URLSearchParams(a).toString()}`, Ft.debug({ updatedHash: u }, "update hash")), window.history.replaceState(null, "", window.location.pathname + window.location.search + u);
        }
        if (o) {
          let u = "";
          c && (u = `?${new URLSearchParams(a).toString()}`, Ft.debug({ updatedSearch: u }, "update search")), window.history.replaceState(null, "", window.location.pathname + u + window.location.hash);
        }
        e(l);
      }
    }
  }
  t.setValue("parsed", !0);
}, wf = (t, e, n) => {
  const i = new Gf(), s = i.get("sl-deep-link-store");
  let r = {};
  if (s)
    try {
      r = JSON.parse(s);
    } catch (l) {
      Ft.debug(l);
    }
  t.deepLink = {
    $store: new yn(et(r), "deep-link-context"),
    getDeepLinkData: () => {
      const { data: l, used: a } = t.deepLink.$store.getValues();
      return { data: l, used: a };
    },
    // we are logged in with inviter id
    deepLinkUsed: (l) => {
      Ft.debug(`logged in with inviterId: ${l}`), t.deepLink.$store.setValue("used", !0);
    },
    onDeepLinkHandlers: /* @__PURE__ */ new Set()
  }, t.sdk.getInviter = () => {
    const { data: l, used: a } = t.deepLink.getDeepLinkData();
    return a ? l?.[tr] : void 0;
  }, t.sdk.inviteDisplayed = () => {
    t.deepLink.$store.getStore().set({}), t.deepLink.$store.getStore().off(), i.del("sl-deep-link-store");
  }, t.deepLink.$store.subscribe((l) => i.set("sl-deep-link-store", JSON.stringify(l))), t.sdk.addDeepLinkHandler = (l) => {
    localStorage.getItem("SL_DEBUG") && Ft.trace("adding deep link handler"), t.deepLink.onDeepLinkHandlers.add(l);
  }, e.onDeepLinkHandled && t.sdk.addDeepLinkHandler(e.onDeepLinkHandled), t.sdk.removeDeepLinkHandler = (l) => {
    Ft.trace("removing deep link handler"), t.deepLink.onDeepLinkHandlers.delete(l);
  };
  const o = (l) => {
    t.deepLink.$store.setValue("handled", !0), Ft.trace({ size: t.deepLink.onDeepLinkHandlers.size }, "deep link handled, call callbacks");
    for (const a of t.deepLink.onDeepLinkHandlers)
      try {
        Ft.trace("called handler"), a(l);
      } catch (c) {
        console.error(c);
      }
  };
  Bf(t.deepLink.$store, o), n();
}, Yf = st("bypass");
class Tf extends Xg {
  $coreStore;
  deepLink;
  transport;
  bypassLogin;
  constructor(e, n, i) {
    super(), this.$coreStore = e, this.deepLink = i, this.transport = n, this.bypassLogin = Dg(this.transport), this.connect();
  }
  me = async () => (this.$coreStore.getValues().user.invalidate(), (await this.$coreStore.getValues().user.getValue())?.data);
  /**
   * Login user by token and schema.
   * On success, save the user and update the token to the Transport, UserStore and cache.
   * @param schema - schema created by the host app and provided to the StreamLayer SDK.
   * @param userKey - user token received from the host app.
   */
  login = async (e, n) => {
    this.$coreStore.getValues().userKey.setValue(n);
    const { used: i, data: s } = this.deepLink?.getDeepLinkData() || {}, r = i ? "" : s?.[tr];
    Yf.debug({ inviterKey: r }, "login with inviterKey");
    const o = await this.bypassLogin({
      schema: e,
      userKey: n,
      inviterKey: r,
      init: !1
    }), l = o.meta?.jwt, a = o.data?.id;
    if (!l || !a)
      throw new Error("internal: token missing");
    return o.meta?.inviterKey && this.deepLink && this.deepLink.deepLinkUsed(o.meta.inviterKey), this.$coreStore.getValues().user.getStore().mutate({ data: o.data }), this.saveUser(l, a), l;
  };
  isAuthenticated = () => this.me();
  /**
   * Logout user. Clears the all user data from the store.
   */
  logout = () => {
    this.$coreStore.getValues().user.setValue(), this.$coreStore.getValues().userKey.setValue(), this.$coreStore.getValues().userToken.setValue(), this.transport.setAuth("", ""), new Kn().clear();
  };
  /**
   * Soft logout, only clears the StreamLayer user data from the store.
   * Does not clear the external token. And automatically tries to re-login by external token.
   */
  softLogout = () => {
    const e = new Kn();
    this.transport.setAuth("", ""), e.setToken(""), this.reLogin();
  };
  /**
   * Try to re-login.
   * - If the user has an token, then try to login by it, by calling the me() method.
   * - If the user has an external token, then try to login by it, by calling the login() method. On failure, logout.
   * -
   * - If no one of the above is true, then logout.
   */
  reLogin = ({ skipLogin: e } = { skipLogin: !1 }) => {
    const n = new Kn(), i = n.getToken(), s = n.getExternalToken();
    if (this.$coreStore.getValues().userKey.setValue(s), i)
      return this.saveUser(i, ""), this.me().then((r) => {
        if (r?.id) {
          const o = r.id;
          this.saveUser(i, o);
        }
        return r;
      });
    if (s && !i && !e) {
      const r = n.getSchema();
      r && s && this.login(r, s).catch(() => {
        this.logout();
      });
    }
  };
  /**
   * Write token to the Transport and UserStore
   */
  saveUser = (e, n) => {
    this.transport.setAuth(e, n), this.$coreStore.getValues().userToken.setValue(e), new Kn().setToken(e);
  };
  /**
   * Add interceptor to the Transport to handle 401 and 403 errors.
   * If the user is logged in (auth header is set), then make a soft logout.
   */
  connect = () => {
    this.transport.registerInterceptor((e) => async (n) => {
      try {
        return await e(n);
      } catch (i) {
        throw i.code && (i.code === 7 || i.code === 16) && this.transport.getHeader("authorization") && this.softLogout(), i;
      }
    });
  };
}
const fi = new Kn(), Lf = (t, e, n) => {
  t.auth = new Tf(t.store, t.transport, t.deepLink), t.stores.status.listen((i) => {
    i === kt.READY && t.auth.reLogin();
  }), t.sdk.userId = t.stores.user.getAtomStore, t.sdk.authorizationBypass = async (i, s) => {
    if (!(fi.getSchema() === i && fi.getExternalToken() === s && t.transport.getHeader("authorization")))
      try {
        console.log("login", i, s), await t.auth.login(i, s), fi.setSchema(i), fi.setExternalToken(s);
      } catch (r) {
        console.log("login error", r), t.sdk.logout();
      }
  }, t.sdk.logout = () => {
    t.auth.logout(), fi.clear();
  }, t.sdk.getUserStore = () => t.stores.user.getStore(), t.sdk.isUserAuthorized = () => t.auth.isAuthenticated(), n();
}, i1 = st("video_player"), ts = {
  debug: (...t) => {
    i1.debug(...t), localStorage.getItem("SL_DEBUG") && console.log(...t);
  },
  trace: (...t) => {
    i1.trace(...t), localStorage.getItem("SL_DEBUG") && console.log(...t);
  }
}, kf = (t, e, n) => {
  t.videoPlayer = {
    controllers: /* @__PURE__ */ new Set()
  }, t.sdk.addVideoPlayerController = (i) => {
    ts.trace("adding video player controller"), t.videoPlayer.controllers.add(i);
  }, e.videoPlayerController && t.sdk.addVideoPlayerController(e.videoPlayerController), t.sdk.removeVideoPlayerController = (i) => {
    ts.trace("removing video player controller"), t.videoPlayer.controllers.delete(i);
  }, t.sdk.controlVideoPlayer = (i) => {
    ts.trace("controlling video player");
    for (const s of t.videoPlayer.controllers) {
      ts.trace("calling video player controller");
      try {
        s(i);
      } catch (r) {
        console.error(r);
      }
    }
  }, n();
}, Jf = {
  [M.FACTOID]: "insight",
  [M.POLL]: "poll",
  [M.TRIVIA]: "trivia",
  [M.PREDICTION]: "prediction",
  [M.TWEET]: "tweet"
}, Yn = (t) => t === ce.INGAME_IAB11 || t === ce.INGAME_IAB21 || t === ce.NFL_SHOP_OVERLAY || t === ce.SHOP_OVERLAY, xf = (t, e, n) => {
  t.sdk.uiState = et({}), t.ui = {
    enableAppNotification: function() {
      t.sdk.uiState.setKey("appNotification", !0);
    },
    disableAppNotification: function() {
      t.sdk.uiState.get().app || t.sdk.uiState.setKey("appNotification", !1);
    },
    enableOnboardingNotification: function() {
      t.sdk.uiState.setKey("onboardingNotification", !0);
    },
    disableOnboardingNotification: function() {
      t.sdk.uiState.setKey("onboardingNotification", !1);
    },
    enablePolymarket: function() {
      t.sdk.uiState.setKey("polymarket", !0);
    },
    disablePolymarket: function() {
      t.sdk.uiState.setKey("polymarket", !1);
    },
    enableApp: function() {
      t.sdk.uiState.set({
        app: !0,
        appNotification: !0
      });
    },
    disableApp: function() {
      t.sdk.uiState.set({
        ...t.sdk.uiState.get(),
        onboardingNotification: !1,
        appBanner: !1,
        appSidebar: !1,
        appNotification: !1,
        app: !1
      });
    },
    enableExposedPauseAd: function() {
      t.sdk.uiState.set({
        ...t.sdk.uiState.get(),
        exposedPauseAd: !0
      });
    },
    disableExposedPauseAd: function() {
      t.sdk.uiState.set({
        ...t.sdk.uiState.get(),
        exposedPauseAd: !1
      });
    }
  }, t.sdk.uiHandlers = {
    enablePolymarket: t.ui.enablePolymarket,
    disablePolymarket: t.ui.disablePolymarket
  }, e.onContentActivate && (t.ui.onContentActivate = e.onContentActivate);
  const i = (s) => {
    t.ui.onContentActivate && t.ui.onContentActivate({ ...s, type: "advertisement" });
  };
  t.onQuestionActivate = ({ questionType: s, ...r }) => {
    if (t.ui.enableAppNotification(), t.ui.onContentActivate) {
      const o = r.type || s && Jf[s] || "question";
      t.ui.onContentActivate({ ...r, type: o });
    }
  }, t.sdk.onMount({ name: "ui" }, () => {
    const s = (l) => {
      if (l.slEventBus?.type === "exposedPauseAd")
        switch (l.slEventBus.action) {
          case "enabled":
            t.ui.enableExposedPauseAd();
            break;
          case "disabled":
            t.ui.disableExposedPauseAd();
            break;
        }
      if (l.slEventBus?.type === "app")
        switch (l.slEventBus.action) {
          case "open":
            t.ui.enableApp();
            break;
          case "close":
            t.ui.disableApp();
            break;
        }
      if (l.slEventBus?.type === "poll") {
        const a = l.slEventBus.action, { hasBanner: c } = l.slEventBus.payload;
        switch (a) {
          case "onboardingOpen":
            t.sdk.uiState.set({
              app: !0
            });
            break;
          case "opened":
            t.sdk.uiState.set({
              ...t.sdk.uiState.get(),
              appBanner: c,
              appSidebar: !0
            });
            break;
          case "closed":
            t.sdk.uiState.set({
              ...t.sdk.uiState.get(),
              appBanner: !1,
              appSidebar: !1
            });
            break;
        }
      }
      if (l.slEventBus?.type === "notification") {
        const a = l.slEventBus.action;
        if (l.slEventBus.payload.type === Kt.ONBOARDING)
          switch (a) {
            case "received":
              t.ui.enableOnboardingNotification();
              break;
            case "closed":
              t.ui.disableOnboardingNotification();
              break;
          }
        else
          switch (a) {
            case "received":
              t.ui.enableAppNotification();
              break;
            case "closed":
              t.ui.disableAppNotification();
              break;
          }
      }
      if (l.slEventBus?.type === "advertisement" && e.withAd) {
        const a = l.slEventBus, { hasNotification: c, hasBanner: u, id: h, isViewed: d, type: m } = a.payload;
        switch (a.action) {
          case "notification-opened":
            t.sdk.uiState.set({
              promotionExternalAd: m === ce.EXTERNAL_AD,
              promotionBanner: u,
              promotionNotification: !1,
              promotionOverlay: Yn(m),
              promotionSidebar: !Yn(m)
            });
            break;
          case "received":
            if (t.sdk.closeFeature(), i({
              stage: "activate",
              id: h,
              hasNotification: c,
              hasBanner: u,
              isViewed: d
            }), !e.withAdNotification) {
              t.sdk.uiState.set({
                promotionBanner: u,
                onboardingNotification: t.sdk.uiState.get().onboardingNotification,
                promotionOverlay: Yn(m),
                promotionSidebar: !Yn(m),
                promotionExternalAd: m === ce.EXTERNAL_AD
              });
              break;
            }
            c ? t.sdk.uiState.set({
              onboardingNotification: t.sdk.uiState.get().onboardingNotification,
              promotionNotification: !0
            }) : t.sdk.uiState.set({
              onboardingNotification: t.sdk.uiState.get().onboardingNotification,
              promotionBanner: u,
              promotionOverlay: Yn(m),
              promotionSidebar: !Yn(m),
              promotionExternalAd: m === ce.EXTERNAL_AD
            });
            break;
          case "closed":
            t.sdk.uiState.set({
              ...t.sdk.uiState.get(),
              promotionNotification: !1,
              promotionBanner: !1,
              promotionOverlay: !1,
              promotionExternalAd: !1,
              promotionSidebar: !1
            }), i({
              stage: "deactivate",
              id: h,
              hasNotification: c,
              hasBanner: u,
              isViewed: d
            });
            break;
        }
      }
    }, r = Ve.listen(s), o = t.activeFeature.subscribe((l) => {
      l || t.ui.disableApp();
    });
    return () => {
      r(), o();
    };
  }), n();
}, Mf = (t, e, n) => {
  const i = { onMountedFired: !1 }, s = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  t.sdk = /* @__PURE__ */ Object.create(null), t.sdk.options = et(e), t.sdk.withAuth = !1, t.sdk.onMount = ({ name: o, clear: l }, a) => {
    if (s.has(o)) {
      const c = r.get(o);
      c && c(), s.delete(o), r.delete(o);
    }
    s.set(o, { cb: a, clear: l }), t?.stores?.enabled?.get() === "on" && r.set(o, a());
  }, t.ready = () => {
    t.stores.enabled.subscribe((o) => {
      o === "on" && i.onMountedFired === !1 && (s.forEach(({ cb: l }, a) => r.set(a, l())), i.onMountedFired = !0), o !== "on" && i.onMountedFired === !0 && (r.forEach((l) => l()), r.clear(), s.forEach(({ clear: l }, a) => l && s.delete(a)), i.onMountedFired = !1);
    });
  }, t.sdk.initializeApp = (o) => (t.contextConfig = o, t.stores.enabled.get() === "on" ? Promise.resolve({ enabled: !0 }) : (t.storeSubscribe(), t.stores.enabled.setValue("on"), t.stores.status.setValue(kt.INITIALIZATION), t.stores.organizationSettings.getValue().then((l) => l ? (t.stores.status.setValue(kt.READY), { enabled: !!l }) : (t.stores.status.setValue(kt.FAILED), { err: "failed" }), (l) => (t.stores.enabled.setValue(), t.stores.status.setValue(kt.FAILED), { err: `${l}` })))), t.sdk.disableApp = () => {
    t.stores.enabled.get() === "on" && (t.stores.enabled.setValue(), t.stores.status.setValue(kt.DISABLED), t.stores.slStreamId.setValue(), t.stores.providerStreamId.setValue(), t.sdk.closeFeature(!0), t.storeUnsubscribe(), t.transport.disconnect());
  }, t.sdk.createEventSession = (o, l) => {
    l ? t.stores.slStreamId.getStore().set({ loading: !1, data: o }) : t.stores.providerStreamId.setValue(o);
  }, n();
}, Qf = (t, e) => {
  const { client: n, queryKey: i } = t.createPromiseClient(Ji, {
    method: "generateDeepLink",
    params: e
  });
  return t.nanoquery.createFetcherStore(i, {
    fetcher: async (s, r, o, l) => {
      if (!o)
        return {};
      try {
        return (await n.generateDeepLink({
          data: { gamification: !0, externalEventId: l, eventId: o }
        })).data?.attributes;
      } catch {
        return;
      }
    },
    dedupeTime: 1e3 * 60 * 60 * 24,
    // 24 hours
    revalidateInterval: 0
  });
}, zf = (t, { web: e, mobile: n }) => {
  const { client: i } = t.createPromiseClient(pg, { method: "generate" });
  return i.generate({ web: e, mobile: n });
}, s1 = (t, e) => {
  const n = new URLSearchParams(t);
  for (const [i, s] of Object.entries(e))
    n.append(i, s);
  return n.toString();
}, Kf = (t, e, n, i) => {
  const s = et({});
  return Hs(s, () => Qf(t, [e, n]).subscribe(async ({ data: r, loading: o }) => {
    const l = r === void 0 && o === !1 ? "https://streamlayer.io" : r?.url, a = i.get() || "", c = e.get() || "", u = n.get() || "", h = {
      [tr]: a,
      [H0]: c,
      [O0]: u
    };
    if (!o && l) {
      s.setKey("loading", !0);
      let d = window.location.search, m = window.location.hash;
      d && m || m ? d = `?${s1(d, h)}` : m = `#${s1("", h)}`;
      const p = window.location.origin + window.location.pathname + d + m;
      try {
        const g = await zf(t, { web: p, mobile: l });
        s.set({
          data: g.data?.link,
          loading: !1
        });
      } catch {
        s.set({
          loading: !1,
          error: "Failed to generate short link",
          data: void 0
        });
      }
    } else
      s.setKey("loading", !0);
  })), { $store: s, fetch };
};
var Xe;
(function(t) {
  t.Unset = "unset", t.Required = "required", t.Optional = "optional", t.Completed = "completed", t.Disabled = "disabled", t.Unavailable = "unavailable";
})(Xe || (Xe = {}));
const Hf = (t, e, n, i) => {
  const { inplayGame: s } = t.featureSettings.get(), r = e.getCurrentSessionId({ prefix: "onboarding" });
  s && n.add({
    type: Kt.ONBOARDING,
    id: r,
    action: t.openFeature,
    close: () => {
      t.onboardingProcessed.set(!0);
    },
    persistent: !0,
    autoHideDuration: 1e6,
    data: {
      questionId: "onboarding",
      questionType: M.UNSET,
      onboarding: {
        ...s,
        instantOpen: !i.getOnboardingInstantOpen({
          userId: e.userId.get() || "",
          organizationId: e.organizationId.get() || "",
          eventId: e.slStreamId.get() || ""
        }),
        markIstantOpen: () => {
          i.setOnboardingInstantOpen({
            userId: e.userId.get() || "",
            organizationId: e.organizationId.get() || "",
            eventId: e.slStreamId.get() || ""
          }), n.update(r, (o) => {
            o?.data?.onboarding && (o.data.onboarding.instantOpen = !0);
          });
        }
      }
    }
  });
}, ns = (t, e, n, i, s, r, o, l) => {
  try {
    const a = e.userId.get(), c = e.organizationId.get(), u = e.slStreamId.get();
    if (!a || !c || !u)
      return;
    const h = s.getOnboardingStatus({
      userId: a,
      organizationId: c,
      eventId: u
    });
    if (h === Xe.Completed || l?.skipOnboarding) {
      t.set(Xe.Completed);
      for (const A of r)
        A();
      l?.skipOnboarding && h !== Xe.Completed && (s.saveOnboardingStatus({
        organizationId: c,
        userId: a,
        eventId: u
      }, Xe.Completed), K0(o, u));
      return;
    }
    const d = e.moderation.getStore().value?.data, m = n.featureSettings.get().inplayGame;
    if (d === void 0 || m === void 0)
      return;
    const p = d?.options?.onboardingEnabled, g = m?.titleCard?.optIn;
    p ? g ? t.set(Xe.Required) : t.set(Xe.Optional) : (g ? t.set(Xe.Unavailable) : t.set(Xe.Disabled), i.close(e.getCurrentSessionId({ prefix: "onboarding" }), { markAsViewed: !1 }));
  } catch (a) {
    console.error(a);
  }
}, r1 = (t, e, n, i, s) => {
  let r = !!s?.skipOnboarding;
  const o = e.storage, l = we(Xe.Unset);
  l.subscribe((c) => {
    c !== Xe.Unset && (c === Xe.Optional || c === Xe.Required ? r === !1 && (Hf(t, e, i, o), r = !0) : t.onboardingProcessed.set(!0), c === Xe.Completed && e.activeQuestionId.invalidate(), o.setOnboardingInstantOpen({
      userId: e.userId.get() || "",
      organizationId: e.organizationId.get() || "",
      eventId: e.slStreamId.get() || ""
    }));
  });
  const a = [];
  return l.get() !== Xe.Completed && (a.push(e.userId.listen((c) => {
    c && ns(l, e, t, i, o, a, n, s);
  })), a.push(e.moderation.listen((c) => {
    c.data && ns(l, e, t, i, o, a, n, s);
  })), a.push(t.featureSettings.listen((c) => {
    c && ns(l, e, t, i, o, a, n, s);
  }))), ns(l, e, t, i, o, a, n, s), { $store: l, submitInplay: async () => {
    const c = e.slStreamId.get();
    if (c) {
      await K0(n, c), l.set(Xe.Completed), o.saveOnboardingStatus({
        organizationId: e.organizationId.get() || "",
        userId: e.userId.get() || "",
        eventId: c
      }, Xe.Completed), Ve.emit("poll", {
        action: "onboardingPassed",
        payload: {}
      }), t.openFeature();
      const u = e.getCurrentSessionId({ prefix: "onboarding" });
      i.close(u);
    }
  } };
}, Of = (t, e, n, i) => {
  const s = et(void 0), r = M0(i), o = async () => {
    const a = t.get(), c = e.get(), u = n ? n.getStore().get().data?.map((m) => m.slId) : [];
    if (!u || !a || !c)
      return;
    const h = {
      eventId: a,
      userId: c,
      leaderboardId: "",
      usersIds: [...u, c]
    }, d = await r(h);
    s.set(d.data?.attributes);
  }, l = () => {
    o();
  };
  return Hs(s, () => {
    l();
    const a = t.listen(o), c = n?.listen(o), u = e.listen(o);
    return () => {
      a(), c?.(), u();
    };
  }), { $store: s, invalidate: l };
}, Df = async (t, e, n, i, s) => {
  const r = M0(s), o = t.get(), l = e.get(), a = n?.getStore().get().data?.map((u) => u.slId) || [], c = {
    eventId: o,
    userId: i,
    leaderboardId: "",
    usersIds: [...a, l]
  };
  return (await r(c)).data?.attributes?.summary;
}, o1 = /* @__PURE__ */ new Set([M.POLL, M.PREDICTION, M.TRIVIA]);
class Pf extends J0 {
  /** user statistics (leaderboard panel) */
  userSummary;
  /** feed list (pick history) */
  feedList;
  /** list (pack) of predefined questions */
  betPack;
  /** friends list */
  friends;
  /** pinned leaderboard id */
  leaderboardId;
  /** leaderboard list */
  leaderboardList;
  deepLink;
  /** onboarding status */
  onboardingStatus;
  /** opened question */
  openedQuestion;
  /** current user id */
  currentUserId;
  /** pinned leaderboard id */
  openedUser;
  closeFeature;
  openFeature;
  feedSubscription;
  activeQuestionId;
  openedQuestionId;
  advertisement;
  withPickHistory;
  onboardingProcessed;
  friendsTabEnabled;
  skipOnboarding;
  notifications;
  transport;
  /** gamification background class, handle subscriptions and notifications for closed overlay */
  background;
  /** Browser cache */
  storage;
  submitAnswerTimeout;
  cancels = /* @__PURE__ */ new Set();
  onQuestionActivate;
  constructor(e, n, i) {
    if (super(e, n), this.background = new yf(i), this.advertisement = this.background.advertisement, this.onQuestionActivate = i.onQuestionActivate, this.feedSubscription = this.background.feedSubscription, this.activeQuestionId = this.background.activeQuestionId, this.openedQuestionId = this.background.openedQuestionId, this.storage = this.background.storage, this.feedList = this.background.feedList, this.betPack = this.background.betPack, this.currentUserId = this.background.userId, this.withPickHistory = this.background.withPickHistory, this.onboardingProcessed = we(!i.sdk.withAuth), this.leaderboardId = new ct(we(this.settings.getValue("pinnedLeaderboardId")), "pinnedLeaderboardId").getStore(), this.notifications = i.notifications, this.transport = i.transport, this.closeFeature = (s = !0) => i.sdk.closeFeature(s), this.openFeature = () => i.sdk.openFeature(pe.GAMES), this.openedQuestion = this.background.openedQuestion, this.deepLink = Kf(this.transport, this.background.slStreamId, i.stores.providerStreamId.getStore(), this.background.userId), this.userSummary = Of(this.background.slStreamId, this.background.userId, this.friends, this.transport), !i.sdk.options.get().hideFriends) {
      this.friends = new bt(of(this.background.userId, i.transport), "gamification:friends"), this.openedUser = we(void 0);
      const s = this.leaderboardList = Ff(this.transport, this.background.slStreamId, this.background.userId, this.friends);
      this.cancels.add(this.userSummary.$store.listen((r, o) => {
        o?.summary && r?.summary && s.invalidate();
      }));
    }
    this.connect(), this.skipOnboarding = !!i.sdk.options.get().skipOnboarding, this.onboardingStatus = r1(this, this.background, i.transport, i.notifications, {
      skipOnboarding: i.sdk.options.get().skipOnboarding
    }), i.sdk.options.get().skipOnboarding || (this.onboardingStatus = r1(this, this.background, i.transport, i.notifications, {
      skipOnboarding: i.sdk.options.get().skipOnboarding
    })), this.cancels.add(this.onboardingStatus.$store.listen(this.checkInteractiveFlag)), this.cancels.add(this.background.moderation.getStore().listen(this.checkInteractiveFlag)), this.cancels.add(this.settings.subscribe(this.checkInteractiveFlag)), this.cancels.add(this.onboardingStatus.$store.listen((s, r) => {
      (r === void 0 || s !== Xe.Unset) && this.background.activeQuestionId.invalidate();
    })), this.background.activeQuestionId.listen(this.showInApp), this.friendsTabEnabled = we(!1), this.cancels.add(i.sdk.options.subscribe((s) => {
      s.friendsTab === "disabled" ? this.friendsTabEnabled.set(!1) : s.friendsTab === "enabled" && this.friendsTabEnabled.set(!0);
    })), this.cancels.add(this.settings.subscribe((s) => {
      i.sdk.options.get().friendsTab === "activatedGame" && this.friendsTabEnabled.set(!!s.inplayGame?.titleCard?.optIn);
    })), i.sdk.onMount({ name: "gamification", clear: !0 }, () => () => {
      for (const s of this.cancels)
        s(), this.cancels.delete(s);
    });
  }
  get isInteractiveAllowed() {
    return this.background.interactiveAllowed.get() === ln.ALLOWED;
  }
  checkInteractiveFlag = () => {
    if (this.skipOnboarding)
      this.background.interactiveAllowed.set(ln.ALLOWED);
    else {
      const e = this.onboardingStatus.$store.get(), n = this.background.moderation.getStore().value?.data?.options?.onboardingEnabled, i = this.settings.getValues().inplayGame?.titleCard?.optIn, s = e === Xe.Completed, r = !n || s || i !== !0;
      this.background.interactiveAllowed.set(r ? ln.ALLOWED : ln.DISALLOWED);
    }
  };
  connect = () => {
    this.onboardingProcessed.subscribe((e) => {
      e && this.advertisement && this.advertisement.connect();
    }), this.cancels.add(this.background.feedSubscription.addListener("feed-subscription-prediction-close", async (e) => {
      if (!this.isInteractiveAllowed)
        return;
      const n = e.data?.attributes?.question, i = e.data?.attributes?.feedItem;
      if (!n || !i?.attributes)
        return;
      const { status: s, type: r, id: o, answers: l } = n;
      if (s === ve.RESOLVED && r === M.PREDICTION) {
        const a = this.background.getCurrentSessionId({
          prefix: `notification-id:${o}`
        }), c = [...this.feedList.getValues().data || []], u = c.findIndex((S) => S.id === o), h = c[u];
        let d = h?.attributes?.attributes?.value?.answerId;
        const m = Cs(o, this.transport), p = m.subscribe(() => {
        });
        await m.fetch();
        let g = m.get().data;
        g || (g = await Q0(o, this.transport), m.mutate(g)), p(), window.requestAnimationFrame(() => {
          m.invalidate();
        }), d || (d = g?.answers.find(({ youVoted: S }) => S)?.id);
        const A = l.find(({ correct: S }) => S), b = d ? l.find(({ id: S }) => S === d) : void 0, R = !!b?.correct;
        if (h && c[u]?.attributes?.attributes.case === "question") {
          try {
            c[u].attributes.attributes.value.answerId = d, c[u].attributes.attributes.value.openForVoting = !1, d && (c[u].attributes.attributes.value.status = R ? on.WON : on.LOST);
          } catch {
          }
          this.feedList.getStore().mutate(c);
        }
        if (!b || !A)
          return;
        this.openedQuestionId.get()?.questionId !== n.id && this.notifications.add({
          type: Kt.QUESTION_RESOLVED,
          action: () => this.openQuestion(n.id, i),
          close: () => this.closeQuestion(o),
          autoHideDuration: R ? 15e3 : 14e3,
          id: a,
          emitEvent: !1,
          data: {
            questionId: o,
            questionType: M.PREDICTION,
            question: {
              title: R ? `Congratulations! You answered correctly! You won ${A.points} pts!` : `Better luck next time! Correct: ${A?.text}!`,
              votedAnswer: {
                title: b?.text,
                points: b?.points
              },
              correctAnswerTitle: A?.text,
              correct: !!R,
              predictionResult: !0,
              questionTitle: n?.subject
            },
            inApp: {
              notification: n.notification,
              appearance: n.appearance,
              sponsorship: n.sponsorship,
              adUnit: n?.adUnit,
              sponsorLogo: n.promotion?.sponsor?.logo
            }
          }
        }), this.userSummary.invalidate();
      }
    })), bd(this.feedList.getStore(), () => {
      this.cancels.add(this.feedList.subscribe(() => {
      }));
    }), this.cancels.add(this.background.feedSubscription.addListener("feed-subscription-questions-list", (e) => {
      const n = [...this.feedList.getStore().value?.data || []], i = e.data?.attributes?.feedItem, s = n.findIndex((r) => r.id === i?.id);
      if (i?.attributes && i.attributes.attributes.case !== "promotion" && !(i.attributes.status !== ve.ACTIVE && i.attributes.status !== ve.RESOLVED) && !(!this.isInteractiveAllowed && o1.has(i.attributes.type) && i?.attributes?.adUnit !== Ne.STANDART)) {
        if (s !== -1)
          if (i.attributes.attributes.case === "question" && n[s].attributes?.attributes.case === "question") {
            const r = n[s];
            r.attributes && (n[s] = {
              ...n[s],
              attributes: {
                ...r.attributes,
                // @ts-expect-error
                attributes: {
                  ...r.attributes.attributes,
                  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                  // @ts-ignore
                  value: {
                    ...r.attributes.attributes.value,
                    ...i.attributes.attributes.value,
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    answerId: r.attributes.attributes.value.answerId,
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    status: r.attributes.attributes.value.status,
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    openForVoting: (
                      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                      // @ts-ignore
                      r.attributes.attributes.value.openForVoting === !1 ? !1 : i.attributes.attributes.value.openForVoting
                    )
                  }
                }
              }
            });
          } else {
            const r = n[s];
            r.attributes && i.attributes && (n[s] = {
              ...n[s],
              attributes: {
                ...r.attributes,
                attributes: {
                  ...r.attributes.attributes,
                  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                  // @ts-ignore
                  value: {
                    ...r.attributes.attributes.value,
                    ...i.attributes.attributes.value
                  }
                }
              }
            });
          }
        s === -1 && (n.unshift(i), Ve.emit("poll", {
          action: "received",
          payload: {
            isAd: i.attributes?.adUnit == Ne.UNSET,
            questionId: i.id,
            questionType: i.attributes?.type
          }
        })), this.feedList.getStore().mutate(n);
      }
    }));
  };
  // not used
  disconnect = () => {
    this.background.feedSubscription.removeListener("feed-subscription-prediction-close"), this.background.feedSubscription.removeListener("feed-subscription-questions-list");
  };
  betPackVote = async (e, n) => {
    if (!this.betPack)
      return;
    try {
      await qc(this.transport, { questionId: e, answerId: n });
    } catch (r) {
      if (r.message === ri.ALREADY_VOTED) {
        const o = Cs(e, this.transport), l = o.subscribe(() => {
        });
        o.invalidate(), l();
      }
      throw r;
    }
    const i = { ...this.betPack.getValues().data?.data }, s = i?.[e];
    s && (Ve.emit("poll", {
      action: "voted",
      payload: {
        questionId: e,
        isAd: s?.adUnit == Ne.STANDART || s?.promotion?.adUnit == Ne.STANDART,
        questionType: s.type
      }
    }), s.answers = s.answers.map((r) => r.id === n ? {
      ...r,
      youVoted: !0
    } : r), this.betPack.getStore().mutate({ data: i, timestamp: Date.now() }));
  };
  submitAnswer = async (e, n) => {
    const i = Cs(e, this.transport), s = i.subscribe(() => {
    }), r = { ...i.get().data || {} }, o = () => {
      const l = this.feedList.getValues().data;
      if (!l)
        return;
      const a = l.findIndex((h) => h.id === e), c = l[a], u = c?.attributes?.attributes.case === "question" && c.attributes.attributes.value;
      if (u) {
        Ve.emit("poll", {
          action: "voted",
          payload: {
            isAd: c.attributes?.adUnit == Ne.STANDART || c.attributes?.adPromotion?.adUnit == Ne.STANDART,
            questionId: e,
            questionType: u.questionType
          }
        });
        const h = i.get().data;
        if (s(), h) {
          const d = h.answers.find((A) => A.correct === !0), m = h.answers.findIndex((A) => A.id === n), p = h.answers[m], g = h.answers.every(({ percentageDecimal: A }, b) => A === r?.answers[b].percentageDecimal);
          l[a].attributes.attributes.value.answerId = n, l[a].attributes.attributes.value.openForVoting = !1, l[a].attributes.attributes.value.text = p?.text || "", d && (l[a].attributes.attributes.value.status = d.id === n ? on.WON : on.LOST), this.feedList.getStore().mutate([...l]), h.answers[m].correct = d?.id === n, h.answers[m].youVoted = !0, g && h.answers.forEach((A) => {
            A.percentageDecimal = 0;
          }), d?.id === n && (h.answers[m].pointsEarned = h.status === ve.RESOLVED ? 0 : d.points), i.mutate({ ...h });
        }
        this.submitAnswerTimeout && clearTimeout(this.submitAnswerTimeout), this.submitAnswerTimeout = setTimeout(() => {
          this.userSummary.invalidate();
        }, 1e3);
      }
    };
    try {
      await qc(this.transport, { questionId: e, answerId: n }), o();
    } catch (l) {
      if (l.message === ri.ALREADY_VOTED) {
        this.userSummary.invalidate();
        const a = i.subscribe(() => {
        });
        i.invalidate(), a();
      }
      throw l;
    }
  };
  openQuestion = (e, n) => {
    if (!e)
      return () => {
      };
    const i = n?.openedFrom === "bet-pack";
    this.notifications.close(this.background.getCurrentSessionId({
      prefix: "notification",
      entity: e
    }), {
      animateHiding: !1
    });
    let s = n?.attributes?.type, r = (n?.attributes?.adUnit === Ne.STANDART || n?.attributes?.adPromotion?.adUnit === Ne.STANDART) && !!n?.attributes?.adPromotion?.banner?.imageUrl;
    if (!s && !i) {
      const l = (this.feedList.getStore().value?.data || []).find((a) => a.id === e)?.attributes;
      s = l?.type, r = (l?.adUnit === Ne.STANDART || l?.adPromotion?.adUnit === Ne.STANDART) && !!l?.adPromotion?.banner?.imageUrl;
    }
    const o = {
      eventId: this.background.slStreamId.get() || "",
      userId: this.background.userId.get() || "",
      organizationId: this.background.organizationId.get() || ""
    };
    return Ve.emit("poll", {
      action: "opened",
      payload: {
        questionId: e,
        questionType: s,
        isAd: n?.attributes?.adUnit == Ne.UNSET,
        questionOpenedFrom: n?.openedFrom === "bet-pack" ? "list" : n?.openedFrom,
        hasBanner: r
      }
    }), this.storage.isQuestionOpened(o, e) || (Ve.emit("poll", {
      action: "viewed",
      payload: {
        questionId: e,
        questionType: s,
        isAd: n?.attributes?.adUnit == Ne.UNSET,
        questionOpenedFrom: n?.openedFrom === "bet-pack" ? "list" : n?.openedFrom
      }
    }), this.storage.saveQuestionOpened(o, e)), i || this.openFeature(), this.background.openQuestion(e, n ? {
      ...n,
      openedFrom: n?.openedFrom === "bet-pack" ? "list" : n?.openedFrom
    } : void 0);
  };
  getFeedItem = (e) => cf(e, this.transport);
  isOpenedQuestion = (e) => !!this.notifications.isViewed(e);
  closeQuestion = (e) => (e && (this.onQuestionActivate({
    stage: "deactivate",
    id: e,
    isViewed: !!this.notifications.isViewed(this.background.getCurrentSessionId({
      prefix: "notification",
      entity: e
    }))
  }), Ve.emit("poll", {
    action: "closed",
    payload: {
      questionId: e
    }
  })), this.background.closeQuestion(e));
  openUser = async (e) => {
    if (!this.leaderboardList)
      return;
    const n = this.leaderboardList?.$store.get().data?.find((s) => s.userId === e);
    if (!n) {
      this.openedUser?.set(n);
      return;
    }
    if (n.summaryLoaded) {
      this.openedUser?.set(n);
      return;
    }
    const i = { ...n };
    try {
      const s = await Df(this.background.slStreamId, this.background.userId, this.friends, e, this.transport);
      s?.inTop !== void 0 && (this.leaderboardList?.$store.setKey("data", this.leaderboardList.$store.get().data?.map((r) => (r.userId === e && (r.inTop = s.inTop), r))), i.inTop = s.inTop);
    } catch (s) {
      console.error(s);
    }
    this.openedUser.set(i);
  };
  closeUser = () => {
    this.openedUser?.set(void 0);
  };
  openOnboarding = () => {
    this.openFeature(), Ve.emit("poll", {
      action: "onboardingOpen",
      payload: {}
    });
  };
  sendWebhookEvent = (e, n) => If(this.transport, {
    eventId: this.background.slStreamId.get(),
    questionId: e,
    userId: this.background.userId.get(),
    userAccountInfo: n
  });
  /**
   * Show in-app notification for active question
   * for interactive questions we show notification only if interactiveAllowed
   * for factoid and tweet questions we show notification always
   * skipping questions with inAppSilence === ON
   */
  showInApp = (e) => {
    const n = this.onboardingStatus.$store.get(), i = e?.data?.question?.adUnit === Ne.STANDART;
    if (e && e.data && (i || n && n !== Xe.Unset) && e.data.question?.id !== void 0 && e.data.question?.bypassNotifications?.inAppSilence !== G9.ON && e.data.question.status === ve.ACTIVE && !e.data.question.marketClosed) {
      if (o1.has(e.data.question.type))
        (this.isInteractiveAllowed || i) && e.data.question.notification !== void 0 && this.notifications.add({
          type: Kt.QUESTION,
          action: () => this.openQuestion(e.data?.question?.id, e.data?.feedItem),
          close: () => this.closeQuestion(e.data?.question?.id),
          autoHideDuration: 1e3 * 60,
          id: this.background.getCurrentSessionId({
            prefix: "notification",
            entity: e.data.question.id
          }),
          emitEvent: !0,
          data: {
            questionId: e.data.question.id,
            questionType: e.data.question.type,
            question: {
              title: e.data.question.notification.title
            },
            inApp: {
              notification: e.data.question.notification,
              appearance: e.data.question.appearance,
              sponsorship: e.data.question.sponsorship,
              adUnit: e.data.question?.adUnit,
              sponsorLogo: e.data.question.promotion?.sponsor?.logo
            }
          }
        });
      else if (e.data.question.type === M.FACTOID) {
        const s = e.data.question.options?.options.value, r = e.data.question.notification?.useContentTexts === yc.ENABLED ? e.data.question.subject : e.data.question.notification?.title || "", o = e.data.question.notification?.useContentTexts === yc.ENABLED ? s.body : e.data.question.notification?.body, l = {
          heading: r,
          body: o,
          imageMode: s?.imageMode,
          image: s?.image,
          video: {
            id: s?.video?.id || "",
            url: s?.video?.url || "",
            thumbnailUrl: s?.video?.thumbnailUrl || ""
          },
          webLink: {
            label: "",
            url: ""
          }
        };
        this.notifications.add({
          type: Kt.QUESTION,
          action: () => this.openQuestion(e?.data?.question?.id, e?.data?.feedItem),
          close: () => this.closeQuestion(e?.data?.question?.id),
          autoHideDuration: 1e3 * 120,
          emitEvent: !0,
          id: this.background.getCurrentSessionId({ prefix: "notification", entity: e.data.question.id }),
          data: {
            questionId: e.data.question.id,
            questionType: e.data.question.type,
            insight: l,
            inApp: {
              useMediaFromContent: s?.useAsNotification === V9.ENABLED,
              notification: e.data.question.notification,
              appearance: e.data.question.appearance,
              sponsorship: e.data.question.sponsorship,
              adUnit: e.data.question?.adUnit,
              sponsorLogo: e.data.question.promotion?.sponsor?.logo,
              isVideo: s?.mode === N9.VIDEO
            }
          }
        });
      } else if (e.data.question.type === M.TWEET && e.data.question.notification !== void 0) {
        const s = e.data.question.options?.options.value, r = {
          image: "",
          video: ""
        };
        if (s.tweetMeta?.tweet?.meta?.extendedEntities?.media?.[0]) {
          const l = s.tweetMeta.tweet.meta.extendedEntities.media;
          if (l) {
            const a = l.find(({ type: c }) => c === "photo") || l[0];
            r.image = a.mediaUrlHttps, a.type === "video" && (r.video = a.url);
          }
        }
        const o = {
          title: e.data.question.notification?.title,
          body: e.data.question.notification?.body,
          image: e.data.question.notification?.image,
          account: s?.tweetMeta?.account || "",
          accountVerified: !!s?.tweetMeta?.accountVerified,
          tweet: s?.tweetMeta?.tweet,
          tweetId: e.data.question.id,
          tweetMedia: r
        };
        this.notifications.add({
          type: Kt.QUESTION,
          action: () => this.openQuestion(e.data?.question?.id, e.data?.feedItem),
          close: () => this.closeQuestion(e.data?.question?.id),
          autoHideDuration: 1e3 * 120,
          emitEvent: !0,
          id: this.background.getCurrentSessionId({ prefix: "notification", entity: e.data.question.id }),
          data: {
            questionId: e.data.question.id,
            questionType: e.data.question.type,
            tweet: o,
            inApp: {
              notification: e.data.question.notification,
              appearance: e.data.question.appearance,
              sponsorship: e.data.question.sponsorship
            }
          }
        });
      }
    }
  };
}
const _f = {
  [pe.GAMES]: !0
};
class jf extends J0 {
  constructor(e, n) {
    super(e, n);
  }
}
const $f = (t, e, n) => t.type === pe.GAMES ? new Pf(t, e, n) : new jf(t, e), qf = (t, e, n) => {
  t.features = /* @__PURE__ */ new Map(), t.sdk.featuresList = new ct(we(/* @__PURE__ */ new Set()), "features-list"), t.activeFeature = new ct(we(pe.UNSET), "activeFeature"), t.sdk.getFeatures = () => t.features, t.sdk.getFeature = (i) => t.features.get(i), t.sdk.getActiveFeature = () => t.activeFeature.getStore(), t.sdk.openFeature = (i) => {
    t.sdk.initializeApp().then(() => {
      t.activeFeature.setValue(i);
    });
  }, t.sdk.closeFeature = (i = !1) => {
    const s = t.activeFeature.getValue();
    if (t.activeFeature.setValue(pe.UNSET), i && s) {
      t.features.delete(s);
      const r = t.sdk.featuresList.getValue();
      r && r.delete(s), t.sdk.featuresList.setValue(r);
    }
  }, t.initFeature = (i, s = Lt.ORGANIZATION) => {
    if (i.type in _f && !t.features.has(i.type)) {
      const r = $f(i, s, t);
      t.features.set(i.type, r);
      let o = t.sdk.featuresList.getValue();
      o ? o.add(i.type) : o = /* @__PURE__ */ new Set([i.type]), t.sdk.featuresList.setValue(new Set(o));
    }
  }, t.updateFeature = (i, s) => {
    t.features.get(i.type)?.update(i, s);
  }, t.destroyFeature = (i) => {
    t.features.delete(i.type);
    const s = t.sdk.featuresList.getValue();
    s && s.delete(i.type), t.sdk.featuresList.setValue(new Set(s));
  }, t.reinitializeFeatures = async () => {
    const i = await t.stores.organizationSettings.getValue();
    t.features.clear(), t.sdk.featuresList.setValue(/* @__PURE__ */ new Set());
    for (const s of i?.overlays || [])
      t.initFeature(s, Lt.ORGANIZATION);
  }, t.stores.providerStreamId.listen((i) => {
    i || t.reinitializeFeatures();
  }), t.storeSubscribe = () => {
    const i = (r, o) => {
      if (o?.overlays && !(t.contextConfig?.skipOrganizationSettings && r === Lt.ORGANIZATION))
        for (const l of o.overlays)
          l.sdkEnable === !0 && (t.features.has(l.type) ? t.updateFeature(l, r) : t.initFeature(l, r));
    }, s = {
      /**
       * During the initial SDK initialization, it's imperative to initialize features first,
       * followed by their direct subscriptions to store fields.
       * This section is currently in development, and it's
       * essential to implement checks to determine whether a feature
       * has already been initialized. If it has, events related to
       * that feature should be skipped. Conversely, if a feature is
       * missing in the new settings, it should be initialized again.
       */
      organizationSettings: (r) => {
        if (r.data)
          try {
            i(Lt.ORGANIZATION, r.data);
          } catch (o) {
            console.log(o);
          }
      },
      streamSettings: (r) => {
        if (r.data)
          try {
            i(Lt.STREAM, r.data);
          } catch (o) {
            console.log(o);
          }
      }
    };
    t.store.subscribe(s);
  }, n();
}, eb = (t, e, n) => {
  const { client: i, queryKey: s } = n.createPromiseClient(bg, {
    method: "getMarketWithSeries",
    params: [t, e]
  });
  return n.nanoquery.createFetcherStore(s, {
    fetcher: async (r, o, l, a) => {
      if (a)
        try {
          return (await i.getMarketWithSeries({
            eventId: l,
            timeframe: fg.TIMEFRAME_ALL
          })).event;
        } catch {
          return;
        }
    }
  });
}, tb = (t) => {
  const e = t.stores.slStreamId.getAtomStore(), n = t.stores.user.getAtomStore();
  return eb(e, n, t.transport);
};
class nb extends k0 {
  marketWithSeries;
  log;
  constructor(e) {
    super(), this.log = st("polymarket"), this.marketWithSeries = tb(e);
  }
  connect = () => {
    this.log.debug("connect");
  };
  disconnect = () => {
    this.marketWithSeries.off(), this.log.debug("disconnect");
  };
}
const ib = (t, e, n) => {
  t.sdk.polymarket = new nb(t), t.sdk.onMount({ name: "polymarket" }, () => (t.sdk.polymarket.connect(), () => {
    t.sdk.polymarket.disconnect();
  })), n();
};
function ia() {
  let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  return { id: t.id || null, adId: t.adId || null, sequence: t.sequence || null, apiFramework: t.apiFramework || null, universalAdIds: [], creativeExtensions: [] };
}
const sb = ["ADCATEGORIES", "ADCOUNT", "ADPLAYHEAD", "ADSERVINGID", "ADTYPE", "APIFRAMEWORKS", "APPBUNDLE", "ASSETURI", "BLOCKEDADCATEGORIES", "BREAKMAXADLENGTH", "BREAKMAXADS", "BREAKMAXDURATION", "BREAKMINADLENGTH", "BREAKMINDURATION", "BREAKPOSITION", "CLICKPOS", "CLICKTYPE", "CLIENTUA", "CONTENTID", "CONTENTPLAYHEAD", "CONTENTURI", "DEVICEIP", "DEVICEUA", "DOMAIN", "EXTENSIONS", "GDPRCONSENT", "IFA", "IFATYPE", "INVENTORYSTATE", "LATLONG", "LIMITADTRACKING", "MEDIAMIME", "MEDIAPLAYHEAD", "OMIDPARTNER", "PAGEURL", "PLACEMENTTYPE", "PLAYERCAPABILITIES", "PLAYERSIZE", "PLAYERSTATE", "PODSEQUENCE", "REGULATIONS", "SERVERSIDE", "SERVERUA", "TRANSACTIONID", "UNIVERSALADID", "VASTVERSIONS", "VERIFICATIONVENDORS"];
function l1(t) {
  let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  const i = [], s = P0(t);
  !e.ERRORCODE || n.isCustomCode || /^[0-9]{3}$/.test(e.ERRORCODE) || (e.ERRORCODE = 900), e.CACHEBUSTING = $0(Math.round(1e8 * Math.random())), e.TIMESTAMP = (/* @__PURE__ */ new Date()).toISOString(), e.RANDOM = e.random = e.CACHEBUSTING;
  for (const r in e) e[r] = j0(e[r]);
  for (const r in s) {
    const o = s[r];
    typeof o == "string" && i.push(D0(o, e));
  }
  return i;
}
function D0(t, e) {
  const n = (t = a1(t, e)).match(/[^[\]]+(?=])/g);
  if (!n) return t;
  let i = n.filter(((s) => sb.indexOf(s) > -1));
  return i.length === 0 ? t : (i = i.reduce(((s, r) => (s[r] = -1, s)), {}), a1(t, i));
}
function a1(t, e) {
  let n = t;
  for (const i in e) {
    const s = e[i];
    n = n.replace(new RegExp("(?:\\[|%%)(".concat(i, ")(?:\\]|%%)"), "g"), s);
  }
  return n;
}
function P0(t) {
  return Array.isArray(t) ? t.map(((e) => e && e.hasOwnProperty("url") ? e.url : e)) : t;
}
function c1(t) {
  return /^(https?:\/\/|\/\/)/.test(t);
}
function u1(t, e) {
  for (let n = 0; n < e.length; n++) if (_0(e[n], t)) return !0;
  return !1;
}
function _0(t, e) {
  if (t && e) {
    const n = Object.getOwnPropertyNames(t), i = Object.getOwnPropertyNames(e);
    return n.length === i.length && t.id === e.id && t.url === e.url;
  }
  return !1;
}
function j0(t) {
  return encodeURIComponent(t).replace(/[!'()*]/g, ((e) => "%".concat(e.charCodeAt(0).toString(16))));
}
function $0(t) {
  let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 8;
  return t.toString().padStart(e, "0");
}
const Sn = { track: function(t, e, n) {
  l1(t, e, n).forEach(((i) => {
    typeof window < "u" && window !== null && (new Image().src = i);
  }));
}, resolveURLTemplates: l1, extractURLsFromTemplates: P0, filterUrlTemplates: function(t) {
  return t.reduce(((e, n) => {
    const i = n.url || n;
    return c1(i) ? e.validUrls.push(i) : e.invalidUrls.push(i), e;
  }), { validUrls: [], invalidUrls: [] });
}, containsTemplateObject: u1, isTemplateObjectEqual: _0, encodeURIComponentRFC3986: j0, replaceUrlMacros: D0, isNumeric: function(t) {
  return !isNaN(parseFloat(t)) && isFinite(t);
}, flatten: function t(e) {
  return e.reduce(((n, i) => n.concat(Array.isArray(i) ? t(i) : i)), []);
}, joinArrayOfUniqueTemplateObjs: function() {
  let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  const n = Array.isArray(t) ? t : [], i = Array.isArray(e) ? e : [];
  return n.concat(i).reduce(((s, r) => (u1(r, s) || s.push(r), s)), []);
}, isValidTimeValue: function(t) {
  return Number.isFinite(t) && t >= -2;
}, addLeadingZeros: $0, isValidUrl: c1, isBrowserEnvironment: function() {
  return typeof window < "u";
}, formatMacrosValues: function(t) {
  return typeof t != "object" ? t : JSON.stringify(t);
} };
function h1(t) {
  return ["true", "TRUE", "True", "1"].includes(t);
}
function rb(t) {
  if (t == null) return -1;
  if (Sn.isNumeric(t)) return parseInt(t);
  const e = t.split(":");
  if (e.length !== 3) return -1;
  const n = e[2].split(".");
  let i = parseInt(n[0]);
  n.length === 2 && (i += parseFloat("0.".concat(n[1])));
  const s = parseInt(60 * e[1]), r = parseInt(60 * e[0] * 60);
  return isNaN(r) || isNaN(s) || isNaN(i) || s > 3600 || i > 60 ? -1 : r + s + i;
}
const B = { childByName: function(t, e) {
  return Array.from(t.childNodes).find(((n) => n.nodeName === e));
}, childrenByName: function(t, e) {
  return Array.from(t.childNodes).filter(((n) => n.nodeName === e));
}, resolveVastAdTagURI: function(t, e) {
  if (!e) return t;
  if (t.startsWith("//")) {
    const { protocol: n } = location;
    return "".concat(n).concat(t);
  }
  if (!t.includes("://")) {
    const n = e.slice(0, e.lastIndexOf("/"));
    return "".concat(n, "/").concat(t);
  }
  return t;
}, parseBoolean: h1, parseNodeText: function(t) {
  return t && (t.textContent || t.text || "").trim();
}, copyNodeAttribute: function(t, e, n) {
  const i = e.getAttribute(t);
  i && n.setAttribute(t, i);
}, parseAttributes: function(t) {
  return Array.from(t.attributes).reduce(((e, n) => (e[n.nodeName] = n.nodeValue, e)), {});
}, parseDuration: rb, getStandAloneAds: function() {
  return (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : []).filter(((t) => !parseInt(t.sequence, 10)));
}, getSortedAdPods: function() {
  return (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : []).filter(((t) => parseInt(t.sequence, 10))).sort(((t, e) => t.sequence - e.sequence));
}, assignAttributes: function(t, e) {
  t && Array.from(t).forEach(((n) => {
    let { nodeName: i, nodeValue: s } = n;
    if (i && s && e.hasOwnProperty(i)) {
      let r = s;
      typeof e[i] == "boolean" && (r = h1(r)), e[i] = r;
    }
  }));
}, mergeWrapperAdData: function(t, e) {
  var n;
  t.errorURLTemplates = e.errorURLTemplates.concat(t.errorURLTemplates), t.impressionURLTemplates = e.impressionURLTemplates.concat(t.impressionURLTemplates), t.extensions = e.extensions.concat(t.extensions), e.viewableImpression.length > 0 && (t.viewableImpression = [...t.viewableImpression, ...e.viewableImpression]), t.followAdditionalWrappers = e.followAdditionalWrappers, t.allowMultipleAds = e.allowMultipleAds, t.fallbackOnNoAd = e.fallbackOnNoAd;
  const i = (e.creatives || []).filter(((l) => l && l.type === "companion")), s = i.reduce(((l, a) => ((a.variations || []).forEach(((c) => {
    (c.companionClickTrackingURLTemplates || []).forEach(((u) => {
      Sn.containsTemplateObject(u, l) || l.push(u);
    }));
  })), l)), []);
  t.creatives = i.concat(t.creatives);
  const r = e.videoClickTrackingURLTemplates && e.videoClickTrackingURLTemplates.length, o = e.videoCustomClickURLTemplates && e.videoCustomClickURLTemplates.length;
  if (t.creatives.forEach(((l) => {
    if (e.trackingEvents && e.trackingEvents[l.type]) for (const a in e.trackingEvents[l.type]) {
      const c = e.trackingEvents[l.type][a];
      Array.isArray(l.trackingEvents[a]) || (l.trackingEvents[a] = []), l.trackingEvents[a] = l.trackingEvents[a].concat(c);
    }
    l.type === "linear" && (r && (l.videoClickTrackingURLTemplates = l.videoClickTrackingURLTemplates.concat(e.videoClickTrackingURLTemplates)), o && (l.videoCustomClickURLTemplates = l.videoCustomClickURLTemplates.concat(e.videoCustomClickURLTemplates)), !e.videoClickThroughURLTemplate || l.videoClickThroughURLTemplate !== null && l.videoClickThroughURLTemplate !== void 0 || (l.videoClickThroughURLTemplate = e.videoClickThroughURLTemplate)), l.type === "companion" && s.length && (l.variations || []).forEach(((a) => {
      a.companionClickTrackingURLTemplates = Sn.joinArrayOfUniqueTemplateObjs(a.companionClickTrackingURLTemplates, s);
    }));
  })), e.adVerifications && (t.adVerifications = t.adVerifications.concat(e.adVerifications)), e.blockedAdCategories && (t.blockedAdCategories = t.blockedAdCategories.concat(e.blockedAdCategories)), (n = e.creatives) !== null && n !== void 0 && n.length) {
    const l = e.creatives.filter(((a) => {
      var c;
      return ((c = a.icons) === null || c === void 0 ? void 0 : c.length) && !a.mediaFiles.length;
    }));
    l.length && (t.creatives = t.creatives.concat(l));
  }
} };
function ob(t, e) {
  const n = (function() {
    let i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { id: s, adId: r, sequence: o, apiFramework: l } = ia(i);
    return { id: s, adId: r, sequence: o, apiFramework: l, type: "companion", required: null, variations: [] };
  })(e);
  return n.required = t.getAttribute("required") || null, n.variations = B.childrenByName(t, "Companion").map(((i) => {
    const s = (function() {
      let l = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      return { id: l.id || null, adType: "companionAd", width: l.width || 0, height: l.height || 0, assetWidth: l.assetWidth || null, assetHeight: l.assetHeight || null, expandedWidth: l.expandedWidth || null, expandedHeight: l.expandedHeight || null, apiFramework: l.apiFramework || null, adSlotId: l.adSlotId || null, pxratio: l.pxratio || "1", renderingMode: l.renderingMode || "default", staticResources: [], htmlResources: [], iframeResources: [], adParameters: null, altText: null, companionClickThroughURLTemplate: null, companionClickTrackingURLTemplates: [], trackingEvents: {} };
    })(B.parseAttributes(i));
    s.htmlResources = B.childrenByName(i, "HTMLResource").reduce(((l, a) => {
      const c = B.parseNodeText(a);
      return c ? l.concat(c) : l;
    }), []), s.iframeResources = B.childrenByName(i, "IFrameResource").reduce(((l, a) => {
      const c = B.parseNodeText(a);
      return c ? l.concat(c) : l;
    }), []), s.staticResources = B.childrenByName(i, "StaticResource").reduce(((l, a) => {
      const c = B.parseNodeText(a);
      return c ? l.concat({ url: c, creativeType: a.getAttribute("creativeType") || null }) : l;
    }), []), s.altText = B.parseNodeText(B.childByName(i, "AltText")) || null;
    const r = B.childByName(i, "TrackingEvents");
    r && B.childrenByName(r, "Tracking").forEach(((l) => {
      const a = l.getAttribute("event"), c = B.parseNodeText(l);
      a && c && (Array.isArray(s.trackingEvents[a]) || (s.trackingEvents[a] = []), s.trackingEvents[a].push(c));
    })), s.companionClickTrackingURLTemplates = B.childrenByName(i, "CompanionClickTracking").map(((l) => ({ id: l.getAttribute("id") || null, url: B.parseNodeText(l) }))), s.companionClickThroughURLTemplate = B.parseNodeText(B.childByName(i, "CompanionClickThrough")) || null;
    const o = B.childByName(i, "AdParameters");
    return o && (s.adParameters = { value: B.parseNodeText(o), xmlEncoded: o.getAttribute("xmlEncoded") || null }), s;
  })), n;
}
function lb(t, e) {
  let n;
  const i = (function() {
    let a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { id: c, adId: u, sequence: h, apiFramework: d } = ia(a);
    return { id: c, adId: u, sequence: h, apiFramework: d, type: "linear", duration: 0, skipDelay: null, mediaFiles: [], mezzanine: null, interactiveCreativeFile: null, closedCaptionFiles: [], videoClickThroughURLTemplate: null, videoClickTrackingURLTemplates: [], videoCustomClickURLTemplates: [], adParameters: null, icons: [], trackingEvents: {} };
  })(e);
  i.duration = B.parseDuration(B.parseNodeText(B.childByName(t, "Duration")));
  const s = t.getAttribute("skipoffset");
  if (s == null) i.skipDelay = null;
  else if (s.charAt(s.length - 1) === "%" && i.duration !== -1) {
    const a = parseInt(s, 10);
    i.skipDelay = i.duration * (a / 100);
  } else i.skipDelay = B.parseDuration(s);
  const r = B.childByName(t, "VideoClicks");
  if (r) {
    const a = B.childByName(r, "ClickThrough");
    i.videoClickThroughURLTemplate = a ? { id: a.getAttribute("id") || null, url: B.parseNodeText(a) } : null, B.childrenByName(r, "ClickTracking").forEach(((c) => {
      i.videoClickTrackingURLTemplates.push({ id: c.getAttribute("id") || null, url: B.parseNodeText(c) });
    })), B.childrenByName(r, "CustomClick").forEach(((c) => {
      i.videoCustomClickURLTemplates.push({ id: c.getAttribute("id") || null, url: B.parseNodeText(c) });
    }));
  }
  const o = B.childByName(t, "AdParameters");
  o && (i.adParameters = { value: B.parseNodeText(o), xmlEncoded: o.getAttribute("xmlEncoded") || null }), B.childrenByName(t, "TrackingEvents").forEach(((a) => {
    B.childrenByName(a, "Tracking").forEach(((c) => {
      let u = c.getAttribute("event");
      const h = B.parseNodeText(c);
      if (u && h) {
        if (u === "progress") {
          if (n = c.getAttribute("offset"), !n) return;
          u = n.charAt(n.length - 1) === "%" ? "progress-".concat(n) : "progress-".concat(B.parseDuration(n));
        }
        Array.isArray(i.trackingEvents[u]) || (i.trackingEvents[u] = []), i.trackingEvents[u].push(h);
      }
    }));
  })), B.childrenByName(t, "MediaFiles").forEach(((a) => {
    B.childrenByName(a, "MediaFile").forEach(((m) => {
      i.mediaFiles.push((function(p) {
        const g = { id: null, fileURL: null, fileSize: 0, deliveryType: "progressive", mimeType: null, mediaType: null, codec: null, bitrate: 0, minBitrate: 0, maxBitrate: 0, width: 0, height: 0, apiFramework: null, scalable: null, maintainAspectRatio: null };
        g.id = p.getAttribute("id"), g.fileURL = B.parseNodeText(p), g.deliveryType = p.getAttribute("delivery"), g.codec = p.getAttribute("codec"), g.mimeType = p.getAttribute("type"), g.mediaType = p.getAttribute("mediaType") || "2D", g.apiFramework = p.getAttribute("apiFramework"), g.fileSize = parseInt(p.getAttribute("fileSize") || 0), g.bitrate = parseInt(p.getAttribute("bitrate") || 0), g.minBitrate = parseInt(p.getAttribute("minBitrate") || 0), g.maxBitrate = parseInt(p.getAttribute("maxBitrate") || 0), g.width = parseInt(p.getAttribute("width") || 0), g.height = parseInt(p.getAttribute("height") || 0);
        const A = p.getAttribute("scalable");
        A && typeof A == "string" && (g.scalable = B.parseBoolean(A));
        const b = p.getAttribute("maintainAspectRatio");
        return b && typeof b == "string" && (g.maintainAspectRatio = B.parseBoolean(b)), g;
      })(m));
    }));
    const c = B.childByName(a, "InteractiveCreativeFile");
    c && (i.interactiveCreativeFile = (function(m) {
      const p = (function() {
        let g = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        return { type: g.type || null, apiFramework: g.apiFramework || null, variableDuration: B.parseBoolean(g.variableDuration), fileURL: null };
      })(B.parseAttributes(m));
      return p.fileURL = B.parseNodeText(m), p;
    })(c));
    const u = B.childByName(a, "ClosedCaptionFiles");
    u && B.childrenByName(u, "ClosedCaptionFile").forEach(((m) => {
      const p = (function() {
        let g = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        return { type: g.type || null, language: g.language || null, fileURL: null };
      })(B.parseAttributes(m));
      p.fileURL = B.parseNodeText(m), i.closedCaptionFiles.push(p);
    }));
    const h = B.childByName(a, "Mezzanine"), d = (function(m, p) {
      const g = {};
      let A = !1;
      return p.forEach(((b) => {
        m && m.getAttribute(b) ? g[b] = m.getAttribute(b) : A = !0;
      })), A ? null : g;
    })(h, ["delivery", "type", "width", "height"]);
    if (d) {
      const m = { id: null, fileURL: null, delivery: null, codec: null, type: null, width: 0, height: 0, fileSize: 0, mediaType: "2D" };
      m.id = h.getAttribute("id"), m.fileURL = B.parseNodeText(h), m.delivery = d.delivery, m.codec = h.getAttribute("codec"), m.type = d.type, m.width = parseInt(d.width, 10), m.height = parseInt(d.height, 10), m.fileSize = parseInt(h.getAttribute("fileSize"), 10), m.mediaType = h.getAttribute("mediaType") || "2D", i.mezzanine = m;
    }
  }));
  const l = B.childByName(t, "Icons");
  return l && B.childrenByName(l, "Icon").forEach(((a) => {
    i.icons.push((function(c) {
      const u = { program: null, height: 0, width: 0, xPosition: 0, yPosition: 0, apiFramework: null, offset: null, duration: 0, type: null, staticResource: null, htmlResource: null, iframeResource: null, pxratio: "1", iconClickThroughURLTemplate: null, iconClickTrackingURLTemplates: [], iconViewTrackingURLTemplate: null, iconClickFallbackImages: [], altText: null, hoverText: null };
      u.program = c.getAttribute("program"), u.height = parseInt(c.getAttribute("height") || 0), u.width = parseInt(c.getAttribute("width") || 0), u.xPosition = (function(d) {
        return ["left", "right"].indexOf(d) !== -1 ? d : parseInt(d || 0);
      })(c.getAttribute("xPosition")), u.yPosition = (function(d) {
        return ["top", "bottom"].indexOf(d) !== -1 ? d : parseInt(d || 0);
      })(c.getAttribute("yPosition")), u.apiFramework = c.getAttribute("apiFramework"), u.pxratio = c.getAttribute("pxratio") || "1", u.offset = B.parseDuration(c.getAttribute("offset")), u.duration = B.parseDuration(c.getAttribute("duration")), u.altText = c.getAttribute("altText"), u.hoverText = c.getAttribute("hoverText"), B.childrenByName(c, "HTMLResource").forEach(((d) => {
        u.type = d.getAttribute("creativeType") || "text/html", u.htmlResource = B.parseNodeText(d);
      })), B.childrenByName(c, "IFrameResource").forEach(((d) => {
        u.type = d.getAttribute("creativeType") || 0, u.iframeResource = B.parseNodeText(d);
      })), B.childrenByName(c, "StaticResource").forEach(((d) => {
        u.type = d.getAttribute("creativeType") || 0, u.staticResource = B.parseNodeText(d);
      }));
      const h = B.childByName(c, "IconClicks");
      if (h) {
        u.iconClickThroughURLTemplate = B.parseNodeText(B.childByName(h, "IconClickThrough")), B.childrenByName(h, "IconClickTracking").forEach(((m) => {
          u.iconClickTrackingURLTemplates.push({ id: m.getAttribute("id") || null, url: B.parseNodeText(m) });
        }));
        const d = B.childByName(h, "IconClickFallbackImages");
        d && B.childrenByName(d, "IconClickFallbackImage").forEach(((m) => {
          u.iconClickFallbackImages.push({ url: B.parseNodeText(m) || null, width: m.getAttribute("width") || null, height: m.getAttribute("height") || null });
        }));
      }
      return u.iconViewTrackingURLTemplate = B.parseNodeText(B.childByName(c, "IconViewTracking")), u;
    })(a));
  })), i;
}
function ab(t, e) {
  const n = (function() {
    let i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { id: s, adId: r, sequence: o, apiFramework: l } = ia(i);
    return { id: s, adId: r, sequence: o, apiFramework: l, type: "nonlinear", variations: [], trackingEvents: {} };
  })(e);
  return B.childrenByName(t, "TrackingEvents").forEach(((i) => {
    let s, r;
    B.childrenByName(i, "Tracking").forEach(((o) => {
      s = o.getAttribute("event"), r = B.parseNodeText(o), s && r && (Array.isArray(n.trackingEvents[s]) || (n.trackingEvents[s] = []), n.trackingEvents[s].push(r));
    }));
  })), B.childrenByName(t, "NonLinear").forEach(((i) => {
    const s = { id: null, width: 0, height: 0, expandedWidth: 0, expandedHeight: 0, scalable: !0, maintainAspectRatio: !0, minSuggestedDuration: 0, apiFramework: "static", adType: "nonLinearAd", type: null, staticResource: null, htmlResource: null, iframeResource: null, nonlinearClickThroughURLTemplate: null, nonlinearClickTrackingURLTemplates: [], adParameters: null };
    s.id = i.getAttribute("id") || null, s.width = i.getAttribute("width"), s.height = i.getAttribute("height"), s.expandedWidth = i.getAttribute("expandedWidth"), s.expandedHeight = i.getAttribute("expandedHeight"), s.scalable = B.parseBoolean(i.getAttribute("scalable")), s.maintainAspectRatio = B.parseBoolean(i.getAttribute("maintainAspectRatio")), s.minSuggestedDuration = B.parseDuration(i.getAttribute("minSuggestedDuration")), s.apiFramework = i.getAttribute("apiFramework"), B.childrenByName(i, "HTMLResource").forEach(((o) => {
      s.type = o.getAttribute("creativeType") || "text/html", s.htmlResource = B.parseNodeText(o);
    })), B.childrenByName(i, "IFrameResource").forEach(((o) => {
      s.type = o.getAttribute("creativeType") || 0, s.iframeResource = B.parseNodeText(o);
    })), B.childrenByName(i, "StaticResource").forEach(((o) => {
      s.type = o.getAttribute("creativeType") || 0, s.staticResource = B.parseNodeText(o);
    }));
    const r = B.childByName(i, "AdParameters");
    r && (s.adParameters = { value: B.parseNodeText(r), xmlEncoded: r.getAttribute("xmlEncoded") || null }), s.nonlinearClickThroughURLTemplate = B.parseNodeText(B.childByName(i, "NonLinearClickThrough")), B.childrenByName(i, "NonLinearClickTracking").forEach(((o) => {
      s.nonlinearClickTrackingURLTemplates.push({ id: o.getAttribute("id") || null, url: B.parseNodeText(o) });
    })), n.variations.push(s);
  })), n;
}
function d1(t) {
  const e = [];
  return t.forEach(((n) => {
    const i = q0(n);
    i && e.push(i);
  })), e;
}
function q0(t) {
  if (t.nodeName === "#comment") return null;
  const e = { name: null, value: null, attributes: {}, children: [] }, n = t.attributes, i = t.childNodes;
  if (e.name = t.nodeName, t.attributes) {
    for (const r in n) if (n.hasOwnProperty(r)) {
      const o = n[r];
      o.nodeName && o.nodeValue && (e.attributes[o.nodeName] = o.nodeValue);
    }
  }
  for (const r in i) if (i.hasOwnProperty(r)) {
    const o = q0(i[r]);
    o && e.children.push(o);
  }
  if (e.children.length === 0 || e.children.length === 1 && ["#cdata-section", "#text"].indexOf(e.children[0].name) >= 0) {
    const r = B.parseNodeText(t);
    r !== "" && (e.value = r), e.children = [];
  }
  return (s = e).value === null && Object.keys(s.attributes).length === 0 && s.children.length === 0 ? null : e;
  var s;
}
function cb(t) {
  return t.getAttribute("AdID") || t.getAttribute("adID") || t.getAttribute("adId") || null;
}
const Ws = { Wrapper: { subElements: ["VASTAdTagURI", "Impression"] }, BlockedAdCategories: { attributes: ["authority"] }, InLine: { subElements: ["AdSystem", "AdTitle", "Impression", "AdServingId", "Creatives"] }, Category: { attributes: ["authority"] }, Pricing: { attributes: ["model", "currency"] }, Verification: { oneOfinLineResources: ["JavaScriptResource", "ExecutableResource"], attributes: ["vendor"] }, UniversalAdId: { attributes: ["idRegistry"] }, JavaScriptResource: { attributes: ["apiFramework", "browserOptional"] }, ExecutableResource: { attributes: ["apiFramework", "type"] }, Tracking: { attributes: ["event"] }, Creatives: { subElements: ["Creative"] }, Creative: { subElements: ["UniversalAdId"] }, Linear: { subElements: ["MediaFiles", "Duration"] }, MediaFiles: { subElements: ["MediaFile"] }, MediaFile: { attributes: ["delivery", "type", "width", "height"] }, Mezzanine: { attributes: ["delivery", "type", "width", "height"] }, NonLinear: { oneOfinLineResources: ["StaticResource", "IFrameResource", "HTMLResource"], attributes: ["width", "height"] }, Companion: { oneOfinLineResources: ["StaticResource", "IFrameResource", "HTMLResource"], attributes: ["width", "height"] }, StaticResource: { attributes: ["creativeType"] }, Icons: { subElements: ["Icon"] }, Icon: { oneOfinLineResources: ["StaticResource", "IFrameResource", "HTMLResource"] } };
function m1(t, e) {
  if (!Ws[t.nodeName] || !Ws[t.nodeName].attributes) return;
  const n = Ws[t.nodeName].attributes.filter(((i) => !t.getAttribute(i)));
  n.length > 0 && Ui({ name: t.nodeName, parentName: t.parentNode.nodeName, attributes: n }, e);
}
function p1(t, e, n) {
  const i = Ws[t.nodeName], s = !n && t.nodeName !== "Wrapper";
  if (!(!i || s)) {
    if (i.subElements) {
      const r = i.subElements.filter(((o) => !B.childByName(t, o)));
      r.length > 0 && Ui({ name: t.nodeName, parentName: t.parentNode.nodeName, subElements: r }, e);
    }
    !n || !i.oneOfinLineResources || i.oneOfinLineResources.some(((r) => B.childByName(t, r))) || Ui({ name: t.nodeName, parentName: t.parentNode.nodeName, oneOfResources: i.oneOfinLineResources }, e);
  }
}
function g1(t) {
  return t.children && t.children.length !== 0;
}
function Ui(t, e) {
  let { name: n, parentName: i, attributes: s, subElements: r, oneOfResources: o } = t, l = "Element '".concat(n, "'");
  l += s ? " missing required attribute(s) '".concat(s.join(", "), "' ") : r ? " missing required sub element(s) '".concat(r.join(", "), "' ") : o ? " must provide one of the following '".concat(o.join(", "), "' ") : " is empty", e("VAST-warning", { message: l, parentElement: i, specVersion: 4.1 });
}
const ub = { verifyRequiredValues: function t(e, n, i) {
  if (e && e.nodeName) if (e.nodeName === "InLine" && (i = !0), m1(e, n), g1(e)) {
    p1(e, n, i);
    for (let s = 0; s < e.children.length; s++) t(e.children[s], n, i);
  } else B.parseNodeText(e).length === 0 && Ui({ name: e.nodeName, parentName: e.parentNode.nodeName }, n);
}, hasSubElements: g1, emitMissingValueWarning: Ui, verifyRequiredAttributes: m1, verifyRequiredSubElements: p1 };
function hb(t, e) {
  let { allowMultipleAds: n, followAdditionalWrappers: i } = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  const s = Array.from(t.childNodes).filter(((r) => {
    const o = r.nodeName.toLowerCase();
    return o === "inline" || i !== !1 && o === "wrapper";
  }));
  for (const r of s) {
    if (B.copyNodeAttribute("id", t, r), B.copyNodeAttribute("sequence", t, r), B.copyNodeAttribute("adType", t, r), r.nodeName === "Wrapper") return { ad: mb(r, e), type: "WRAPPER" };
    if (r.nodeName === "InLine") return { ad: db(r, e, { allowMultipleAds: n }), type: "INLINE" };
    const o = r.nodeName.toLowerCase();
    e("VAST-warning", { message: "<".concat(r.nodeName, o === "inline" ? "> must be written <InLine>" : "> must be written <Wrapper>"), wrongNode: r });
  }
}
function db(t, e) {
  let { allowMultipleAds: n } = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  return n === !1 && t.getAttribute("sequence") ? null : e2(t, e);
}
function e2(t, e) {
  let n = [];
  e && ub.verifyRequiredValues(t, e);
  const i = Array.from(t.childNodes), s = (function() {
    let r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return { id: r.id || null, sequence: r.sequence || null, adType: r.adType || null, adServingId: null, categories: [], expires: null, viewableImpression: [], system: null, title: null, description: null, advertiser: null, pricing: null, survey: null, errorURLTemplates: [], impressionURLTemplates: [], creatives: [], extensions: [], adVerifications: [], blockedAdCategories: [], followAdditionalWrappers: !0, allowMultipleAds: !1, fallbackOnNoAd: null };
  })(B.parseAttributes(t));
  return i.forEach(((r) => {
    switch (r.nodeName) {
      case "Error":
        s.errorURLTemplates.push(B.parseNodeText(r));
        break;
      case "Impression":
        s.impressionURLTemplates.push({ id: r.getAttribute("id") || null, url: B.parseNodeText(r) });
        break;
      case "Creatives":
        s.creatives = (function(o) {
          const l = [];
          return o.forEach(((a) => {
            const c = { id: a.getAttribute("id") || null, adId: cb(a), sequence: a.getAttribute("sequence") || null, apiFramework: a.getAttribute("apiFramework") || null }, u = [];
            let h;
            B.childrenByName(a, "UniversalAdId").forEach(((m) => {
              const p = { idRegistry: m.getAttribute("idRegistry") || "unknown", value: B.parseNodeText(m) };
              u.push(p);
            }));
            const d = B.childByName(a, "CreativeExtensions");
            d && (h = d1(B.childrenByName(d, "CreativeExtension")));
            for (const m in a.childNodes) {
              const p = a.childNodes[m];
              let g;
              switch (p.nodeName) {
                case "Linear":
                  g = lb(p, c);
                  break;
                case "NonLinearAds":
                  g = ab(p, c);
                  break;
                case "CompanionAds":
                  g = ob(p, c);
              }
              g && (u && (g.universalAdIds = u), h && (g.creativeExtensions = h), l.push(g));
            }
          })), l;
        })(B.childrenByName(r, "Creative"));
        break;
      case "Extensions": {
        const o = B.childrenByName(r, "Extension");
        s.extensions = d1(o), s.adVerifications.length || (n = (function(l) {
          let a = null, c = [];
          return l.some(((u) => a = B.childByName(u, "AdVerifications"))), a && (c = f1(B.childrenByName(a, "Verification"))), c;
        })(o));
        break;
      }
      case "AdVerifications":
        s.adVerifications = f1(B.childrenByName(r, "Verification"));
        break;
      case "AdSystem":
        s.system = { value: B.parseNodeText(r), version: r.getAttribute("version") || null };
        break;
      case "AdTitle":
        s.title = B.parseNodeText(r);
        break;
      case "AdServingId":
        s.adServingId = B.parseNodeText(r);
        break;
      case "Category":
        s.categories.push({ authority: r.getAttribute("authority") || null, value: B.parseNodeText(r) });
        break;
      case "Expires":
        s.expires = parseInt(B.parseNodeText(r), 10);
        break;
      case "ViewableImpression":
        s.viewableImpression.push((function(o) {
          const l = (a, c) => {
            const u = B.parseNodeText(c);
            return u && a.push(u), a;
          };
          return { id: o.getAttribute("id") || null, viewable: B.childrenByName(o, "Viewable").reduce(l, []), notViewable: B.childrenByName(o, "NotViewable").reduce(l, []), viewUndetermined: B.childrenByName(o, "ViewUndetermined").reduce(l, []) };
        })(r));
        break;
      case "Description":
        s.description = B.parseNodeText(r);
        break;
      case "Advertiser":
        s.advertiser = { id: r.getAttribute("id") || null, value: B.parseNodeText(r) };
        break;
      case "Pricing":
        s.pricing = { value: B.parseNodeText(r), model: r.getAttribute("model") || null, currency: r.getAttribute("currency") || null };
        break;
      case "Survey":
        s.survey = { value: B.parseNodeText(r), type: r.getAttribute("type") || null };
        break;
      case "BlockedAdCategories":
        s.blockedAdCategories.push({ authority: r.getAttribute("authority") || null, value: B.parseNodeText(r) });
    }
  })), n.length && (s.adVerifications = s.adVerifications.concat(n)), s;
}
function mb(t, e) {
  const n = e2(t, e), i = t.getAttribute("followAdditionalWrappers"), s = t.getAttribute("allowMultipleAds"), r = t.getAttribute("fallbackOnNoAd");
  n.followAdditionalWrappers = !i || B.parseBoolean(i), n.allowMultipleAds = !!s && B.parseBoolean(s), n.fallbackOnNoAd = r ? B.parseBoolean(r) : null;
  let o = B.childByName(t, "VASTAdTagURI");
  if (o ? n.nextWrapperURL = B.parseNodeText(o) : (o = B.childByName(t, "VASTAdTagURL"), o && (n.nextWrapperURL = B.parseNodeText(B.childByName(o, "URL")))), n.creatives.forEach(((l) => {
    if (["linear", "nonlinear"].includes(l.type)) {
      if (l.trackingEvents) {
        n.trackingEvents || (n.trackingEvents = {}), n.trackingEvents[l.type] || (n.trackingEvents[l.type] = {});
        for (const a in l.trackingEvents) {
          const c = l.trackingEvents[a];
          Array.isArray(n.trackingEvents[l.type][a]) || (n.trackingEvents[l.type][a] = []), c.forEach(((u) => {
            n.trackingEvents[l.type][a].push(u);
          }));
        }
      }
      l.videoClickTrackingURLTemplates && (Array.isArray(n.videoClickTrackingURLTemplates) || (n.videoClickTrackingURLTemplates = []), l.videoClickTrackingURLTemplates.forEach(((a) => {
        n.videoClickTrackingURLTemplates.push(a);
      }))), l.videoClickThroughURLTemplate && (n.videoClickThroughURLTemplate = l.videoClickThroughURLTemplate), l.videoCustomClickURLTemplates && (Array.isArray(n.videoCustomClickURLTemplates) || (n.videoCustomClickURLTemplates = []), l.videoCustomClickURLTemplates.forEach(((a) => {
        n.videoCustomClickURLTemplates.push(a);
      })));
    }
  })), n.nextWrapperURL) return n;
}
function f1(t) {
  const e = [];
  return t.forEach(((n) => {
    const i = { resource: null, vendor: null, browserOptional: !1, apiFramework: null, type: null, parameters: null, trackingEvents: {} }, s = Array.from(n.childNodes);
    B.assignAttributes(n.attributes, i), s.forEach(((o) => {
      let { nodeName: l, textContent: a, attributes: c } = o;
      switch (l) {
        case "JavaScriptResource":
        case "ExecutableResource":
          i.resource = a.trim(), B.assignAttributes(c, i);
          break;
        case "VerificationParameters":
          i.parameters = a.trim();
      }
    }));
    const r = B.childByName(n, "TrackingEvents");
    r && B.childrenByName(r, "Tracking").forEach(((o) => {
      const l = o.getAttribute("event"), a = B.parseNodeText(o);
      l && a && (Array.isArray(i.trackingEvents[l]) || (i.trackingEvents[l] = []), i.trackingEvents[l].push(a));
    })), e.push(i);
  })), e;
}
class pb {
  constructor() {
    this._handlers = [];
  }
  on(e, n) {
    if (typeof n != "function") throw new TypeError("The handler argument must be of type Function. Received type ".concat(typeof n));
    if (!e) throw new TypeError("The event argument must be of type String. Received type ".concat(typeof e));
    return this._handlers.push({ event: e, handler: n }), this;
  }
  once(e, n) {
    return this.on(e, (function(i, s, r) {
      const o = { fired: !1, wrapFn: void 0 };
      function l() {
        o.fired || (i.off(s, o.wrapFn), o.fired = !0, r.bind(i)(...arguments));
      }
      return o.wrapFn = l, l;
    })(this, e, n));
  }
  off(e, n) {
    return this._handlers = this._handlers.filter(((i) => i.event !== e || i.handler !== n)), this;
  }
  emit(e) {
    for (var n = arguments.length, i = new Array(n > 1 ? n - 1 : 0), s = 1; s < n; s++) i[s - 1] = arguments[s];
    let r = !1;
    return this._handlers.forEach(((o) => {
      o.event === "*" && (r = !0, o.handler(e, ...i)), o.event === e && (r = !0, o.handler(...i));
    })), r;
  }
  removeAllListeners(e) {
    return e ? (this._handlers = this._handlers.filter(((n) => n.event !== e)), this) : (this._handlers = [], this);
  }
  listenerCount(e) {
    return this._handlers.filter(((n) => n.event === e)).length;
  }
  listeners(e) {
    return this._handlers.reduce(((n, i) => (i.event === e && n.push(i.handler), n)), []);
  }
  eventNames() {
    return this._handlers.map(((e) => e.event));
  }
}
let b1 = 0, ul = 0;
const t2 = (t, e) => {
  !t || !e || t <= 0 || e <= 0 || (ul = (ul * b1 + 8 * t / e) / ++b1);
}, gb = { ERRORCODE: 900, extensions: [] }, A1 = "VAST response version not supported";
class fb extends pb {
  constructor() {
    let { fetcher: e } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    super(), this.maxWrapperDepth = null, this.rootErrorURLTemplates = [], this.errorURLTemplates = [], this.remainingAds = [], this.parsingOptions = {}, this.fetcher = e || null, this.keepFailedAdPod = !1;
  }
  trackVastError(e, n) {
    for (var i = arguments.length, s = new Array(i > 2 ? i - 2 : 0), r = 2; r < i; r++) s[r - 2] = arguments[r];
    this.emit("VAST-error", Object.assign({}, gb, n, ...s)), Sn.track(e, n);
  }
  getErrorURLTemplates() {
    return this.rootErrorURLTemplates.concat(this.errorURLTemplates);
  }
  getEstimatedBitrate() {
    return ul;
  }
  initParsingStatus() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.maxWrapperDepth = e.wrapperLimit || 10, this.parsingOptions = { allowMultipleAds: e.allowMultipleAds }, this.keepFailedAdPod = e.keepFailedAdPod || !1, this.rootURL = "", this.resetParsingStatus(), t2(e.byteLength, e.requestDuration);
  }
  resetParsingStatus() {
    this.errorURLTemplates = [], this.rootErrorURLTemplates = [], this.vastVersion = null;
  }
  getRemainingAds(e) {
    if (this.remainingAds.length === 0) return Promise.reject(new Error("No more ads are available for the given VAST"));
    const n = e ? this.remainingAds : [this.remainingAds.shift()];
    return this.errorURLTemplates = [], this.resolveAds(n, { wrapperDepth: 0, url: this.rootURL }).then(((i) => this.buildVASTResponse(i)));
  }
  parseVAST(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return this.initParsingStatus(n), n.isRootVAST = !0, this.parse(e, n).then(((i) => this.buildVASTResponse(i)));
  }
  buildVASTResponse(e) {
    const n = (function(i) {
      let { ads: s, errorURLTemplates: r, version: o } = i;
      return { ads: s || [], errorURLTemplates: r || [], version: o || null };
    })({ ads: e, errorURLTemplates: this.getErrorURLTemplates(), version: this.vastVersion });
    return this.completeWrapperResolving(n), n;
  }
  parseVastXml(e, n) {
    let { isRootVAST: i = !1, url: s = null, wrapperDepth: r = 0, allowMultipleAds: o, followAdditionalWrappers: l } = n;
    if (!e || !e.documentElement || e.documentElement.nodeName !== "VAST") {
      var a;
      this.emit("VAST-ad-parsed", { type: "ERROR", url: s, wrapperDepth: r });
      const d = (e == null || (a = e.documentElement) === null || a === void 0 ? void 0 : a.nodeName) === "VideoAdServingTemplate";
      throw new Error(d ? A1 : "Invalid VAST XMLDocument");
    }
    const c = [], u = e.documentElement.childNodes, h = e.documentElement.getAttribute("version");
    i && h && (this.vastVersion = h);
    for (const d in u) {
      const m = u[d];
      if (m.nodeName === "Error") {
        const p = B.parseNodeText(m);
        i ? this.rootErrorURLTemplates.push(p) : this.errorURLTemplates.push(p);
      } else if (m.nodeName === "Ad") {
        if (this.vastVersion && parseFloat(this.vastVersion) < 3) o = !0;
        else if (o === !1 && c.length > 1) break;
        const p = hb(m, this.emit.bind(this), { allowMultipleAds: o, followAdditionalWrappers: l });
        p.ad ? (c.push(p.ad), this.emit("VAST-ad-parsed", { type: p.type, url: s, wrapperDepth: r, adIndex: c.length - 1, vastVersion: h })) : this.trackVastError(this.getErrorURLTemplates(), { ERRORCODE: 101 });
      }
    }
    return c;
  }
  parse(e) {
    let { url: n = null, resolveAll: i = !0, wrapperSequence: s = null, previousUrl: r = null, wrapperDepth: o = 0, isRootVAST: l = !1, followAdditionalWrappers: a, allowMultipleAds: c } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, u = [];
    this.vastVersion && parseFloat(this.vastVersion) < 3 && l && (c = !0);
    try {
      u = this.parseVastXml(e, { isRootVAST: l, url: n, wrapperDepth: o, allowMultipleAds: c, followAdditionalWrappers: a });
    } catch (h) {
      return Promise.reject(h);
    }
    if (u.length === 1 && s != null && (u[0].sequence = s), i === !1) {
      const h = B.getSortedAdPods(u), d = B.getStandAloneAds(u);
      h.length ? u = h : d.length && (u = [d.shift()]), this.remainingAds = d;
    }
    return this.resolveAds(u, { wrapperDepth: o, previousUrl: r, url: n });
  }
  resolveAds() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], { wrapperDepth: n, previousUrl: i, url: s } = arguments.length > 1 ? arguments[1] : void 0;
    const r = [];
    return i = s, e.forEach(((o) => {
      const l = this.resolveWrappers(o, n, i);
      r.push(l);
    })), Promise.all(r).then(((o) => Sn.flatten(o)));
  }
  resolveWrappers(e, n, i) {
    const s = { ...e };
    return new Promise(((r) => {
      var o;
      if (n++, !s.nextWrapperURL) return delete s.nextWrapperURL, r(s);
      if (!this.fetcher) return s.VASTAdTagURI = s.nextWrapperURL, delete s.nextWrapperURL, r(s);
      if (n >= this.maxWrapperDepth) return s.errorCode = 302, delete s.nextWrapperURL, r(s);
      s.nextWrapperURL = B.resolveVastAdTagURI(s.nextWrapperURL, i);
      const l = (o = this.parsingOptions.allowMultipleAds) !== null && o !== void 0 ? o : s.allowMultipleAds, a = s.sequence;
      this.fetcher.fetchVAST({ url: s.nextWrapperURL, emitter: this.emit.bind(this), maxWrapperDepth: this.maxWrapperDepth }).then(((c) => this.parse(c, { url: s.nextWrapperURL, previousUrl: i, wrapperSequence: a, wrapperDepth: n, followAdditionalWrappers: s.followAdditionalWrappers, allowMultipleAds: l }).then(((u) => {
        if (delete s.nextWrapperURL, u.length === 0) return s.creatives = [], r(s);
        u.forEach(((h) => {
          h && B.mergeWrapperAdData(h, s);
        })), r(u);
      })))).catch(((c) => {
        s.errorCode = c.message === A1 ? 102 : 301, s.errorMessage = c.message, r(s);
      }));
    }));
  }
  completeWrapperResolving(e) {
    if (e.ads.length === 0) this.trackVastError(e.errorURLTemplates, { ERRORCODE: 303 });
    else for (let n = e.ads.length - 1; n >= 0; n--) {
      const i = e.ads[n], s = !i.creatives.some(((r) => {
        var o, l;
        return ((o = r.mediaFiles) === null || o === void 0 ? void 0 : o.length) > 0 || ((l = r.variations) === null || l === void 0 ? void 0 : l.length) > 0;
      }));
      !i.errorCode && !s || i.VASTAdTagURI || (this.trackVastError(i.errorURLTemplates.concat(e.errorURLTemplates), { ERRORCODE: i.errorCode || 303 }, { ERRORMESSAGE: i.errorMessage || "" }, { extensions: i.extensions }, { system: i.system }), this.keepFailedAdPod && i.sequence ? i.hasFailed = !0 : e.ads.splice(n, 1));
    }
  }
}
let Ut = null;
const bb = { data: {}, length: 0, getItem(t) {
  return this.data[t];
}, setItem(t, e) {
  this.data[t] = e, this.length = Object.keys(this.data).length;
}, removeItem(t) {
  delete this.data[t], this.length = Object.keys(this.data).length;
}, clear() {
  this.data = {}, this.length = 0;
} };
class Ab {
  constructor() {
    this.storage = this.initStorage();
  }
  initStorage() {
    if (Ut) return Ut;
    try {
      Ut = typeof window < "u" && window !== null ? window.localStorage || window.sessionStorage : null;
    } catch {
      Ut = null;
    }
    return Ut && !this.isStorageDisabled(Ut) || (Ut = bb, Ut.clear()), Ut;
  }
  isStorageDisabled(e) {
    const n = "__VASTStorage__";
    try {
      if (e.setItem(n, n), e.getItem(n) !== n) return e.removeItem(n), !0;
    } catch {
      return !0;
    }
    return e.removeItem(n), !1;
  }
  getItem(e) {
    return this.storage.getItem(e);
  }
  setItem(e, n) {
    return this.storage.setItem(e, n);
  }
  removeItem(e) {
    return this.storage.removeItem(e);
  }
  clear() {
    return this.storage.clear();
  }
}
const hl = 12e4, Vb = { get: async function(t, e) {
  try {
    const n = new AbortController(), i = setTimeout((() => {
      throw n.abort(), new Error("URLHandler: Request timed out after ".concat(e.timeout || hl, " ms (408)"));
    }), e.timeout || hl), s = await fetch(t, { ...e, signal: n.signal, credentials: e.withCredentials ? "include" : "omit" }).finally((() => {
      clearTimeout(i);
    })), r = (function(o) {
      return Sn.isBrowserEnvironment() && window.location.protocol === "https:" && o.url.includes("http://") ? "URLHandler: Cannot go from HTTPS to HTTP." : o.status === 200 && o.ok ? null : "URLHandler: ".concat(o.statusText, " (").concat(o.status, ")");
    })(s);
    return r ? { error: new Error(r), statusCode: s.status } : (async function(o) {
      const l = await o.text();
      let a;
      return a = Sn.isBrowserEnvironment() ? new DOMParser() : new (await import("./index-BSNzoic3.js").then((c) => c.i)).DOMParser(), { xml: a.parseFromString(l, "text/xml"), details: { byteLength: l.length, statusCode: o.status, rawXml: l } };
    })(s);
  } catch (n) {
    return { error: n, statusCode: n.name === "AbortError" ? 408 : null };
  }
} };
class Rb {
  constructor() {
    this.URLTemplateFilters = [];
  }
  setOptions() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.urlHandler = e.urlHandler || e.urlhandler || Vb, this.fetchingOptions = { ...e.fetchOptions, timeout: e.timeout || hl, withCredentials: !!e.withCredentials };
  }
  addURLTemplateFilter(e) {
    typeof e == "function" && this.URLTemplateFilters.push(e);
  }
  removeLastURLTemplateFilter() {
    this.URLTemplateFilters.pop();
  }
  countURLTemplateFilters() {
    return this.URLTemplateFilters.length;
  }
  clearURLTemplateFilters() {
    this.URLTemplateFilters = [];
  }
  async fetchVAST(e) {
    var n;
    let { url: i, maxWrapperDepth: s, emitter: r, wrapperDepth: o = 0, previousUrl: l = null, wrapperAd: a = null } = e;
    const c = Date.now();
    this.URLTemplateFilters.forEach(((d) => {
      i = d(i);
    })), r("VAST-resolving", { url: i, previousUrl: l, wrapperDepth: o, maxWrapperDepth: s, timeout: this.fetchingOptions.timeout, wrapperAd: a });
    const u = await this.urlHandler.get(i, this.fetchingOptions), h = Math.round(Date.now() - c);
    if (r("VAST-resolved", { url: i, previousUrl: l, wrapperDepth: o, error: u?.error || null, duration: h, statusCode: u?.statusCode || null, ...u?.details }), t2(u == null || (n = u.details) === null || n === void 0 ? void 0 : n.byteLength, h), u.error) throw new Error(u.error);
    return u.xml;
  }
}
class Eb {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : new Ab();
    this.cappingFreeLunch = e, this.cappingMinimumTimeInterval = n, this.fetcher = new Rb(), this.vastParser = new fb({ fetcher: this.fetcher }), this.storage = i, this.lastSuccessfulAd === void 0 && (this.lastSuccessfulAd = 0), this.totalCalls === void 0 && (this.totalCalls = 0), this.totalCallsTimeout === void 0 && (this.totalCallsTimeout = 0);
  }
  addURLTemplateFilter(e) {
    this.fetcher.addURLTemplateFilter(e);
  }
  removeLastURLTemplateFilter() {
    this.fetcher.removeLastURLTemplateFilter();
  }
  countURLTemplateFilters() {
    return this.fetcher.countURLTemplateFilters();
  }
  clearURLTemplateFilters() {
    this.fetcher.clearURLTemplateFilters();
  }
  getParser() {
    return this.vastParser;
  }
  get lastSuccessfulAd() {
    return this.storage.getItem("vast-client-last-successful-ad");
  }
  set lastSuccessfulAd(e) {
    this.storage.setItem("vast-client-last-successful-ad", e);
  }
  get totalCalls() {
    return this.storage.getItem("vast-client-total-calls");
  }
  set totalCalls(e) {
    this.storage.setItem("vast-client-total-calls", e);
  }
  get totalCallsTimeout() {
    return this.storage.getItem("vast-client-total-calls-timeout");
  }
  set totalCallsTimeout(e) {
    this.storage.setItem("vast-client-total-calls-timeout", e);
  }
  hasRemainingAds() {
    return this.vastParser.remainingAds.length > 0;
  }
  getNextAds(e) {
    return this.vastParser.getRemainingAds(e);
  }
  parseVAST(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return this.fetcher.setOptions(n), this.vastParser.parseVAST(e, n);
  }
  get(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const i = Date.now();
    return n.hasOwnProperty("resolveAll") || (n.resolveAll = !1), this.totalCallsTimeout < i ? (this.totalCalls = 1, this.totalCallsTimeout = i + 36e5) : this.totalCalls++, new Promise(((s, r) => {
      if (this.cappingFreeLunch >= this.totalCalls) return r(new Error("VAST call canceled – FreeLunch capping not reached yet ".concat(this.totalCalls, "/").concat(this.cappingFreeLunch)));
      const o = i - this.lastSuccessfulAd;
      if (o < 0) this.lastSuccessfulAd = 0;
      else if (o < this.cappingMinimumTimeInterval) return r(new Error("VAST call canceled – (".concat(this.cappingMinimumTimeInterval, ")ms minimum interval reached")));
      this.vastParser.initParsingStatus(n), this.fetcher.setOptions(n), this.vastParser.rootURL = e, this.fetcher.fetchVAST({ url: e, emitter: this.vastParser.emit.bind(this.vastParser), maxWrapperDepth: this.vastParser.maxWrapperDepth }).then(((l) => (n.previousUrl = e, n.isRootVAST = !0, n.url = e, this.vastParser.parse(l, n).then(((a) => {
        const c = this.vastParser.buildVASTResponse(a);
        s(c);
      }))))).catch(((l) => r(l)));
    }));
  }
}
const yb = new Eb(), Gr = st("ui:gam-static"), V1 = (t) => new Promise((e, n) => {
  const i = new Image();
  i.onload = () => e(t), i.onerror = () => n(), i.src = t;
}), Cb = (t) => (e, n, i) => t.transport.nanoquery.createFetcherStore([e, n], {
  dedupeTime: i.prefetch ? i.refetchInterval : 1 / 0,
  revalidateInterval: i.refetchInterval > 0 ? i.refetchInterval : 0,
  fetcher: async (s) => {
    if (!s || typeof s != "string")
      throw new Error("ad url is empty");
    Ve.emit("exposedPauseAd", {
      action: "load",
      payload: {}
    });
    try {
      const r = (await yb.get(s)).ads.find((o) => o.creatives.length > 0);
      if (r) {
        const o = r.id || "";
        Gr.debug(r, "validAd");
        const l = r.creatives.find((h) => h.type === "nonlinear");
        if (l) {
          const h = l.adId || l.id || o;
          Gr.debug(l, "nonlinear");
          const d = l.variations?.[0]?.staticResource, m = l.variations?.[0]?.nonlinearClickThroughURLTemplate;
          if (d)
            return await V1(d), Ve.emit("exposedPauseAd", {
              action: "loaded",
              payload: {
                id: h,
                parentId: o
              }
            }), {
              id: h,
              parentId: o,
              url: s,
              imageSrc: d,
              adUrl: m
            };
        }
        const a = r.creatives.find((h) => h.type === "companion");
        Gr.debug(a, "companion");
        const c = a?.variations?.[0]?.staticResources?.[0]?.url, u = a?.variations?.[0]?.companionClickThroughURLTemplate;
        if (c) {
          const h = a.adId || a.id || o;
          return await V1(c), Ve.emit("exposedPauseAd", {
            action: "loaded",
            payload: {
              id: h,
              parentId: o
            }
          }), {
            id: h,
            parentId: o,
            url: s,
            imageSrc: c,
            adUrl: u
          };
        }
      }
      throw new Error("no_valid_ad");
    } catch (r) {
      throw r.message !== "no_valid_ad" && r.message !== "ad url is empty" && console.error(r), r;
    }
  }
});
class Wb extends k0 {
  getExternalPauseAd;
  externalPauseAdStores = /* @__PURE__ */ new Map();
  externalPauseAdEnabled = /* @__PURE__ */ new Map();
  log;
  constructor(e) {
    super(), this.log = st("advertisement");
    const n = Cb(e);
    this.getExternalPauseAd = (i, s) => {
      if (this.externalPauseAdStores.has(i)) {
        const l = this.externalPauseAdEnabled.get(i), a = this.externalPauseAdStores.get(i), c = l.get() === !1 && s.$enabled === !0;
        return l.set(s.$enabled), c && window.requestAnimationFrame(() => {
          a.revalidate();
        }), [a, i];
      }
      const r = we(s.$enabled), o = n(i, r, s);
      return this.externalPauseAdEnabled.set(i, r), this.externalPauseAdStores.set(i, o), [o, i];
    };
  }
  connect = () => {
    this.log.debug("connect");
  };
  disconnect = () => {
    this.log.debug("disconnect"), this.externalPauseAdStores.forEach((e) => {
      e.off();
    }), this.externalPauseAdEnabled.forEach((e) => {
      e.off();
    }), this.externalPauseAdEnabled.clear(), this.externalPauseAdStores.clear();
  };
}
const Sb = (t, e, n) => {
  t.sdk.advertisement = new Wb(t), t.sdk.onMount({ name: "advertisement" }, () => (t.sdk.advertisement.connect(), () => {
    t.sdk.advertisement.disconnect();
  })), n();
};
class Zb {
  analytics;
  constructor(e) {
    this.analytics = e, this.analytics.onConnect(() => {
      const n = (i) => {
        i.slEventBus?.type === "invitation" && i.slEventBus.action === "sent" && this.sent(i.slEventBus.payload);
      };
      return Ve.listen(n);
    });
  }
  accepted = () => {
    this.analytics.write("invitation", {
      common: {
        ...this.analytics.commonStore.getValues(),
        kind: me.INVITATION_ACCEPTED
      },
      category: Cc.GAMES,
      from: Wc.UNSET
    });
  };
  sent = ({ from: e }) => {
    this.analytics.write("invitation", {
      common: {
        ...this.analytics.commonStore.getValues(),
        kind: me.INVITATION_SENT
      },
      category: Cc.GAMES,
      from: e || Wc.UNSET
    });
  };
}
class vb {
  analytics;
  constructor(e) {
    this.analytics = e, this.analytics.onConnect(() => {
      const n = (i) => {
        if (i.slEventBus?.type === "interactions")
          switch (i.slEventBus.action) {
            case "tap":
              this.tap();
              break;
            case "scroll":
              this.scroll();
              break;
          }
      };
      return Ve.listen(n);
    });
  }
  tap = () => {
    this.analytics.write("interactions", {
      common: {
        ...this.analytics.commonStore.getValues(),
        kind: me.INTERACTIONS
      },
      actionType: Dc.TAP
    });
  };
  scroll = () => {
    this.analytics.write("interactions", {
      common: {
        ...this.analytics.commonStore.getValues(),
        kind: me.INTERACTIONS
      },
      actionType: Dc.SCROLL
    });
  };
}
const Ib = {
  [ce.UNSET]: We.UNSET,
  [ce.INGAME_IAB21]: We.PROMOTION_INGAME_IAB21,
  [ce.INGAME_IAB21_SIDEBAR]: We.PROMOTION_INGAME_IAB21,
  [ce.INGAME_IAB11_LBAR]: We.PROMOTION_INGAME_IAB11_LBAR,
  [ce.INGAME_IAB11]: We.PROMOTION_INGAME_IAB11,
  [ce.INGAME_IAB11_SIDEBAR]: We.PROMOTION_INGAME_IAB11,
  [ce.INGAME_IAB21_LBAR]: We.PROMOTION_INGAME_IAB21_LBAR,
  [ce.INGAME_IAB61]: We.PROMOTION_INGAME_IAB61,
  [ce.INGAME_IAB61_SIDEBAR]: We.PROMOTION_INGAME_IAB61,
  [ce.EXTERNAL_AD]: We.PROMOTION_GAM,
  [ce.VIDEO_SIDE_BY_SIDE]: We.PROMOTION_VIDEO_SIDE_BY_SIDE,
  [ce.PICTURE_IN_PICTURE]: We.PROMOTION_PICTURE_IN_PICTURE,
  [ce.LOWER_THIRD]: We.PROMOTION_LOWER_THIRD,
  [ce.SHOP_LBAR]: We.PROMOTION_SHOP_LBAR,
  [ce.SHOP_OVERLAY]: We.PROMOTION_SHOP_OVERLAY,
  [ce.SHOP_SIDEBAR]: We.PROMOTION_SHOP_SIDEBAR,
  [ce.NFL_SHOP_LBAR]: We.PROMOTION_SHOP_LBAR,
  [ce.NFL_SHOP_OVERLAY]: We.PROMOTION_SHOP_OVERLAY,
  [ce.NFL_SHOP_SIDEBAR]: We.PROMOTION_SHOP_SIDEBAR,
  [ce.STATS]: We.UNSET,
  [ce.STANDARD]: We.UNSET,
  [ce.SHOP]: We.UNSET,
  [ce.NFL_SHOP]: We.UNSET
}, dl = (t) => t ? Ib[t] : We.UNSET, Nb = {
  25: me.AD_VIDEO_Q25,
  50: me.AD_VIDEO_Q50,
  75: me.AD_VIDEO_Q75
};
class Fb {
  analytics;
  constructor(e) {
    this.analytics = e, this.analytics.onConnect(() => {
      const n = (i) => {
        if (!i.slEventBus?.skipAnalytics) {
          if (i.slEventBus?.type === "exposedPauseAd") {
            const s = i.slEventBus.payload;
            switch (i.slEventBus.action) {
              case "enabled":
                this.exposedPauseAdEnabled(s);
                break;
              case "disabled":
                this.exposedPauseAdDisabled(s);
                break;
              case "closed":
                this.exposedPauseAdClosed(s);
                break;
              case "load":
                this.exposedPauseAdLoad(s, !1);
                break;
              case "loaded":
                this.exposedPauseAdLoad(s, !0);
                break;
              case "rendered":
                this.exposedPauseAdOpened(s);
                break;
              case "navigated":
                this.exposedPauseAdNavigated(s);
                break;
            }
          }
          if (i.slEventBus?.type === "advertisement") {
            const s = i.slEventBus.payload, r = dl(s.type);
            switch (i.slEventBus.action) {
              case "videoPlay":
                this.videoPlay(s, { topicSubType: r });
                break;
              case "videoEnd":
                this.videoEnd(s, { topicSubType: r });
                break;
              case "videoRendered":
                this.videoRendered(s, { topicSubType: r });
                break;
              case "buttonSelect":
                this.buttonSelect(s, { topicSubType: r });
                break;
              case "bannerSelect":
                this.bannerSelect(s, { topicSubType: r });
                break;
              case "bannerShown":
                this.bannerShown(s, { topicSubType: r });
                break;
              case "received":
                this.received(s, { topicSubType: r });
                break;
              case "opened":
                this.opened(s, { topicSubType: r });
                break;
              case "viewed":
                this.viewed(s, { topicSubType: r });
                break;
              case "videoMuted":
              case "videoUnmuted":
                this.videoMuted(s, {
                  topicSubType: r,
                  muted: i.slEventBus.action === "videoMuted"
                });
                break;
              case "videoReplayed":
                this.videoReplayed(s, { topicSubType: r });
                break;
              case "quartileCompleted":
                this.quartileCompleted(s, { topicSubType: r });
                break;
            }
          }
        }
      };
      return Ve.listen(n);
    });
  }
  exposedPauseAdEnabled = ({ id: e, parentId: n }) => {
    const i = this.analytics.commonStore.getValues();
    this.analytics.write("games", {
      common: {
        ...i,
        kind: me.STREAM_PAUSED,
        topicId: e,
        parentTopicId: n,
        topicType: fe.EXPOSED_PAUSED_AD
      },
      pollOpenedFrom: Se.UNSET
    });
  };
  exposedPauseAdClosed = ({ id: e, parentId: n }) => {
    const i = this.analytics.commonStore.getValues();
    this.analytics.write("games", {
      common: {
        ...i,
        kind: me.EXTERNAL_AD_CLOSED,
        topicId: e,
        parentTopicId: n,
        topicType: fe.EXPOSED_PAUSED_AD
      },
      pollOpenedFrom: Se.UNSET
    });
  };
  exposedPauseAdDisabled = ({ id: e, parentId: n }) => {
    const i = this.analytics.commonStore.getValues();
    this.analytics.write("games", {
      common: {
        ...i,
        kind: me.STREAM_RESUMED,
        topicId: e,
        parentTopicId: n,
        topicType: fe.EXPOSED_PAUSED_AD
      },
      pollOpenedFrom: Se.UNSET
    });
  };
  exposedPauseAdOpened = ({ id: e, parentId: n }) => {
    const i = this.analytics.commonStore.getValues();
    this.analytics.write("games", {
      common: {
        ...i,
        kind: me.EXTERNAL_AD_RENDERED,
        topicId: e,
        parentTopicId: n,
        topicType: fe.EXPOSED_PAUSED_AD
      },
      pollOpenedFrom: Se.UNSET
    });
  };
  exposedPauseAdNavigated = ({ id: e, parentId: n }) => {
    const i = this.analytics.commonStore.getValues();
    this.analytics.write("games", {
      common: {
        ...i,
        kind: me.AD_INTERACTION_BANNER_NAVIGATED,
        topicId: e,
        parentTopicId: n,
        topicType: fe.EXPOSED_PAUSED_AD
      },
      pollOpenedFrom: Se.UNSET
    });
  };
  exposedPauseAdLoad = ({ id: e, parentId: n }, i) => {
    const s = this.analytics.commonStore.getValues();
    this.analytics.write("games", {
      common: {
        ...s,
        kind: i ? me.EXTERNAL_AD_LOADED : me.EXTERNAL_AD_REQUESTED,
        topicId: e,
        parentTopicId: n,
        topicType: fe.EXPOSED_PAUSED_AD
      },
      pollOpenedFrom: Se.UNSET
    });
  };
  received = ({ id: e }, { topicSubType: n }) => {
    this.analytics.write("games", {
      common: {
        ...this.analytics.commonStore.getValues(),
        kind: me.POLLS_RECEIVED,
        topicId: e,
        topicType: fe.POLLS_PROMOTION,
        topicSubType: n
      },
      pollOpenedFrom: Se.UNSET
    });
  };
  opened = ({ id: e, openedFrom: n }, { topicSubType: i }) => {
    this.analytics.write("games", {
      common: {
        ...this.analytics.commonStore.getValues(),
        kind: me.POLLS_AD_OPENED,
        topicId: e,
        topicType: fe.POLLS_PROMOTION,
        topicSubType: i
      },
      pollOpenedFrom: n === "notification" ? Se.IN_APP : Se.UNSET
    });
  };
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  viewed = ({ id: e }, { topicSubType: n }) => {
  };
  videoMuted = ({ id: e }, { topicSubType: n, muted: i }) => {
    this.analytics.write("games", {
      common: {
        ...this.analytics.commonStore.getValues(),
        topicId: e,
        kind: i ? me.AD_VIDEO_MUTED : me.AD_VIDEO_UNMUTED,
        topicType: fe.POLLS_PROMOTION,
        topicSubType: n
      },
      pollOpenedFrom: Se.UNSET
    });
  };
  quartileCompleted = ({ id: e, quartile: n }, { topicSubType: i }) => {
    n && this.analytics.write("games", {
      common: {
        ...this.analytics.commonStore.getValues(),
        topicId: e,
        kind: Nb[n],
        topicType: fe.POLLS_PROMOTION,
        topicSubType: i
      },
      pollOpenedFrom: Se.UNSET
    });
  };
  videoReplayed = ({ id: e }, { topicSubType: n }) => {
    this.analytics.write("games", {
      common: {
        ...this.analytics.commonStore.getValues(),
        topicId: e,
        kind: me.AD_VIDEO_REPLAYED,
        topicType: fe.POLLS_PROMOTION,
        topicSubType: n
      },
      pollOpenedFrom: Se.UNSET
    });
  };
  videoPlay = ({ id: e }, { topicSubType: n }) => {
    this.analytics.write("games", {
      common: {
        ...this.analytics.commonStore.getValues(),
        topicId: e,
        kind: me.AD_VIDEO_PLAYED,
        topicType: fe.POLLS_PROMOTION,
        topicSubType: n
      },
      pollOpenedFrom: Se.UNSET
    });
  };
  videoEnd = ({ id: e }, { topicSubType: n }) => {
    this.analytics.write("games", {
      common: {
        ...this.analytics.commonStore.getValues(),
        topicId: e,
        kind: me.AD_VIDEO_COMPLETE,
        topicType: fe.POLLS_PROMOTION,
        topicSubType: n
      },
      pollOpenedFrom: Se.UNSET
    });
  };
  videoRendered = ({ id: e }, { topicSubType: n }) => {
    this.analytics.write("games", {
      common: {
        ...this.analytics.commonStore.getValues(),
        topicId: e,
        kind: me.AD_VIDEO_RENDERED,
        topicType: fe.POLLS_PROMOTION,
        topicSubType: n
      },
      pollOpenedFrom: Se.UNSET
    });
  };
  buttonSelect = ({ id: e }, { topicSubType: n }) => {
    this.analytics.write("games", {
      common: {
        ...this.analytics.commonStore.getValues(),
        topicId: e,
        kind: me.AD_INTERACTION_BUTTON_NAVIGATED,
        topicType: fe.POLLS_PROMOTION,
        topicSubType: n
      },
      pollOpenedFrom: Se.UNSET
    });
  };
  bannerSelect = ({ id: e }, { topicSubType: n }) => {
    this.analytics.write("games", {
      common: {
        ...this.analytics.commonStore.getValues(),
        topicId: e,
        kind: me.AD_INTERACTION_BANNER_NAVIGATED,
        topicType: fe.POLLS_PROMOTION,
        topicSubType: n
      },
      pollOpenedFrom: Se.UNSET
    });
  };
  bannerShown = ({ id: e }, { topicSubType: n }) => {
    this.analytics.write("games", {
      common: {
        ...this.analytics.commonStore.getValues(),
        topicId: e,
        kind: me.AD_BANNER_SHOWN,
        topicType: fe.POLLS_PROMOTION,
        topicSubType: n
      },
      pollOpenedFrom: Se.UNSET
    });
  };
}
const Ci = {
  [M.UNSET]: fe.UNSET,
  [M.FACTOID]: fe.POLLS_INSIGHT,
  [M.POLL]: fe.POLLS_POLL,
  [M.PREDICTION]: fe.POLLS_PREDICTION,
  [M.PROMOTION]: fe.POLLS_PROMOTION,
  [M.TRIVIA]: fe.POLLS_TRIVIA,
  [M.TWEET]: fe.POLLS_TWITTER
};
M.UNSET + "", wt.UNSET, M.FACTOID + "", wt.POLLS, M.POLL + "", wt.POLLS, M.PREDICTION + "", wt.POLLS, M.PROMOTION + "", wt.POLLS, M.TRIVIA + "", wt.POLLS, M.TWEET + "", wt.POLLS;
const Gb = {
  [pe.UNSET]: Je.UNSET,
  [pe.INPLAY]: Je.INPLAY,
  [pe.MESSAGING]: Je.MESSAGING,
  [pe.STATISTICS]: Je.STATS,
  [pe.BETTING]: Je.BETTING,
  [pe.TWITTER]: Je.TWITTER,
  [pe.MERCHANDISE]: Je.MERCHANDISE,
  [pe.CONTESTS]: Je.CONTESTS,
  [pe.VOICE_CHAT]: Je.CALLING,
  [pe.TICKETS]: Je.TICKETS,
  [pe.WHOIS_WATCHING]: Je.WHOISWATCHING,
  [pe.PROFILE]: Je.PROFILE,
  [pe.GAMES]: Je.POLLS,
  // ??
  [pe.GOLF_STATISTICS]: Je.STATS,
  // ??
  [pe.HIGHLIGHTS]: Je.HIGHLIGHTS,
  [pe.PUBLIC_CHAT]: Je.PUBLIC_CHAT
};
class Xb {
  analytics;
  constructor(e) {
    this.analytics = e, this.analytics.onConnect(() => {
      const n = (i) => {
        if (i.slEventBus?.type === "notification")
          switch (i.slEventBus.action) {
            case "rendered":
              this.received(i.slEventBus.payload);
              break;
            case "opened":
              this.opened(i.slEventBus.payload);
              break;
          }
        if (i.slEventBus?.type === "advertisement")
          switch (i.slEventBus.action) {
            case "notification-received":
              this.received({
                questionId: i.slEventBus.payload.id,
                questionType: M.PROMOTION,
                topicSubType: dl(i.slEventBus.payload.type)
              });
              break;
            case "notification-opened":
              this.opened({
                questionId: i.slEventBus.payload.id,
                questionType: M.PROMOTION,
                topicSubType: dl(i.slEventBus.payload.type)
              });
              break;
          }
      };
      return Ve.listen(n);
    });
  }
  received = ({ questionId: e, questionType: n, topicSubType: i }) => {
    this.analytics.write("notification", {
      common: {
        ...this.analytics.commonStore.getValues(),
        kind: me.NOTIFICATION_RECEIVED,
        topicId: e,
        topicType: n ? Ci[n] : fe.UNSET,
        topicSubType: i
      },
      notificationKind: wt.POLLS,
      notificationType: Pc.IN_APP
    });
  };
  opened = ({ questionId: e, questionType: n, topicSubType: i }) => {
    this.analytics.write("notification", {
      common: {
        ...this.analytics.commonStore.getValues(),
        kind: me.NOTIFICATION_OPENED,
        topicId: e,
        topicType: n ? Ci[n] : fe.UNSET,
        topicSubType: i
      },
      notificationKind: wt.POLLS,
      notificationType: Pc.IN_APP
    });
  };
}
class Ub {
  analytics;
  constructor(e) {
    this.analytics = e, this.analytics.onConnect(() => {
      const n = (i) => {
        if (i.slEventBus?.type === "poll")
          switch (i.slEventBus.action) {
            case "voted":
              this.voted(i.slEventBus.payload);
              break;
            case "navigated":
              this.navigated();
              break;
            case "onboardingPassed":
              this.onboardingPassed();
              break;
            case "received":
              this.received(i.slEventBus.payload);
              break;
            case "viewed":
              this.viewed(i.slEventBus.payload);
              break;
          }
      };
      return Ve.listen(n);
    });
  }
  // event when a poll is received from subscription or active question request
  received = ({ questionId: e, questionType: n }) => {
    this.analytics.write("games", {
      common: {
        ...this.analytics.commonStore.getValues(),
        kind: me.POLLS_RECEIVED,
        topicId: e,
        topicType: n ? Ci[n] : fe.UNSET
      },
      pollOpenedFrom: Se.UNSET
    });
  };
  // poll is viewed from notification or list
  viewed = ({ questionId: e, questionType: n, questionOpenedFrom: i, isAd: s }) => {
    this.analytics.write("games", {
      common: {
        ...this.analytics.commonStore.getValues(),
        kind: s ? me.POLLS_AD_OPENED : me.POLLS_OPENED,
        topicId: e,
        topicType: n ? Ci[n] : fe.UNSET
      },
      pollOpenedFrom: i === "list" ? Se.PICK_HISTORY : Se.IN_APP
    });
  };
  // poll is voted
  voted = ({ questionId: e, questionType: n, isAd: i }) => {
    this.analytics.write("games", {
      common: {
        ...this.analytics.commonStore.getValues(),
        kind: i ? me.POLLS_AD_VOTE : me.POLLS_VOTE,
        topicId: e,
        topicType: n ? Ci[n] : fe.UNSET
      },
      pollOpenedFrom: Se.UNSET
    });
  };
  // onboarding passed, user is now able to vote
  onboardingPassed = () => {
    this.analytics.write("games", {
      common: {
        ...this.analytics.commonStore.getValues(),
        kind: me.GAMES_JOINED
      },
      pollOpenedFrom: Se.UNSET
    });
  };
  // user clicked on link in poll and navigated to another page
  navigated = () => {
    this.analytics.write("games", {
      common: {
        ...this.analytics.commonStore.getValues(),
        kind: me.POLLS_NAVIGATED
      },
      pollOpenedFrom: Se.UNSET
    });
  };
}
const Bb = ({ transport: t, $commonStore: e }) => {
  let n;
  const i = we(!1), s = 3e4, { client: r, queryKey: o } = t.createPromiseClient(B0, {
    method: "send",
    params: [i]
  }), l = t.nanoquery.createFetcherStore(o, {
    fetcher: async () => {
      const h = e.getStore().get();
      try {
        await r.unary({
          message: {
            case: "heartbeat",
            value: {
              common: {
                ...h,
                kind: me.SESSION_HEARTBEAT
              }
            }
          }
        });
      } catch (d) {
        Jt.error(d, "send heartbeat failed");
      }
      return Date.now();
    },
    revalidateInterval: s
  }), a = () => {
    Jt.debug("mounted heartbeat"), n = l.subscribe(() => {
    });
  }, c = () => {
    Jt.debug("enabled heartbeat"), i.set(!0), l.lc === 0 && a();
  }, u = () => {
    Jt.debug("disabled heartbeat"), i.set(!1);
  };
  return { enable: c, disable: u, mount: a, unmount: () => {
    Jt.debug("unmounted heartbeat"), l.off(), n?.(), n = void 0, u();
  } };
}, Jt = st("analytics");
class wb {
  commonStore;
  notifications;
  polls;
  invitation;
  interactions;
  advertisement;
  heartbeat;
  analyticsClient;
  listeners;
  listenersCancels;
  connected = !1;
  constructor(e) {
    this.listeners = /* @__PURE__ */ new Set(), this.listenersCancels = /* @__PURE__ */ new Set(), this.commonStore = new yn(et({}), "common-analytics"), this.connectToSDK(e), this.heartbeat = Bb({ transport: e.analyticsTransport, $commonStore: this.commonStore }), this.notifications = new Xb(this), this.polls = new Ub(this), this.invitation = new Zb(this), this.interactions = new vb(this), this.advertisement = new Fb(this);
    const { client: n } = e.analyticsTransport.createPromiseClient(B0, {
      method: "send"
    });
    this.analyticsClient = n;
  }
  connect = () => {
    this.writeCommon("sessionId", zn()), this.heartbeat.enable(), this.listeners.forEach((e) => this.listenersCancels.add(e())), this.connected = !0, Jt.debug("analytics connected");
  };
  disconnect = () => {
    this.writeCommon("sessionId", ""), this.writeCommon("overlaySessionId", ""), this.heartbeat.unmount(), this.listenersCancels.forEach((e) => e()), this.connected = !1, Jt.debug("analytics disconnected");
  };
  write = (e, n) => {
    n && this.analyticsClient.unary({ message: { case: e, value: n } }).then(() => {
      Jt.trace("send analytics success", e, n);
    }).catch((i) => {
      Jt.error(i, "send analytics failed");
    });
  };
  writeCommon = (e, n) => {
    this.commonStore.setValue(e, n);
  };
  // calls the cb when connected/reconnected, callbacks return a cancel function to be called when disconnected
  onConnect = (e) => {
    this.listeners.add(e), this.connected && this.listenersCancels.add(e());
  };
  connectToSDK = (e) => {
    this.onConnect(() => e.stores.slStreamId.getAtomStore().subscribe((n) => {
      this.writeCommon("eventId", n);
    })), this.onConnect(() => e.sdk.getActiveFeature().subscribe((n) => {
      n && this.writeCommon("category", Gb[n]), n !== pe.UNSET ? this.writeCommon("overlaySessionId", zn()) : this.writeCommon("overlaySessionId", "");
    })), this.onConnect(() => {
      const n = (i) => {
        if (!i.slEventBus)
          return;
        const s = i.slEventBus?.action;
        i.slEventBus?.type === "exposedPauseAd" && ((s === "disabled" || s === "closed") && setTimeout(() => {
          this.writeCommon("overlaySessionId", ""), this.writeCommon("topicId", ""), this.writeCommon("parentTopicId", ""), this.writeCommon("topicType", fe.UNSET), this.writeCommon("category", Je.UNSET);
        }, 200), s === "enabled" && (this.writeCommon("overlaySessionId", zn()), this.writeCommon("category", Je.EXPOSED_PAUSED_AD))), i.slEventBus?.type === "advertisement" && (s === "opened" && this.writeCommon("overlaySessionId", zn()), s === "closed" && this.writeCommon("overlaySessionId", ""));
      };
      return Ve.listen(n);
    }), this.onConnect(() => e.sdk.uiState.subscribe((n) => {
      Object.values(n).every((i) => i === !1) && this.writeCommon("overlaySessionId", "");
    })), this.onConnect(() => {
      const n = window.matchMedia("(orientation: portrait)"), i = (s) => {
        this.writeCommon("screenOrientation", s.matches ? Rc.PORTRAIT : Rc.LANDSCAPE);
      };
      return n.addEventListener("change", i), () => {
        n.removeEventListener("change", i);
      };
    }), e.deepLink && this.onConnect(() => e.deepLink.$store.subscribe((n) => {
      n?.handled && this.invitation.accepted();
    }));
  };
}
const Yb = (t, e, n) => {
  t.analytics = new wb(t), t.sdk.onMount({ name: "analytics" }, () => (t.analytics.connect(), t.sdk.writeOverlaySessionId = (i) => {
    i === "" ? t.analytics.writeCommon("overlaySessionId", "") : t.analytics.writeCommon("overlaySessionId", zn());
  }, () => {
    t.analytics.disconnect();
  })), n();
};
var sa = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof Ba < "u" ? Ba : typeof self < "u" ? self : {};
function Tb(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var is = { exports: {} }, ss = { exports: {} }, Xr, R1;
function Lb() {
  if (R1) return Xr;
  R1 = 1;
  function t(e) {
    var n = new e(), i = n;
    function s() {
      var o = n;
      return o.next ? n = o.next : (n = new e(), i = n), o.next = null, o;
    }
    function r(o) {
      i.next = o, i = o;
    }
    return {
      get: s,
      release: r
    };
  }
  return Xr = t, Xr;
}
var E1;
function n2() {
  if (E1) return ss.exports;
  E1 = 1;
  var t = Lb();
  function e(r, o, l) {
    if (typeof r == "function" && (l = o, o = r, r = null), !(l >= 1))
      throw new Error("fastqueue concurrency must be equal to or greater than 1");
    var a = t(i), c = null, u = null, h = 0, d = null, m = {
      push: E,
      drain: n,
      saturated: n,
      pause: g,
      paused: !1,
      get concurrency() {
        return l;
      },
      set concurrency(Y) {
        if (!(Y >= 1))
          throw new Error("fastqueue concurrency must be equal to or greater than 1");
        if (l = Y, !m.paused)
          for (; c && h < l; )
            h++, G();
      },
      running: p,
      resume: R,
      idle: S,
      length: A,
      getQueue: b,
      unshift: Z,
      empty: n,
      kill: T,
      killAndDrain: C,
      error: N
    };
    return m;
    function p() {
      return h;
    }
    function g() {
      m.paused = !0;
    }
    function A() {
      for (var Y = c, L = 0; Y; )
        Y = Y.next, L++;
      return L;
    }
    function b() {
      for (var Y = c, L = []; Y; )
        L.push(Y.value), Y = Y.next;
      return L;
    }
    function R() {
      if (m.paused) {
        if (m.paused = !1, c === null) {
          h++, G();
          return;
        }
        for (; c && h < l; )
          h++, G();
      }
    }
    function S() {
      return h === 0 && m.length() === 0;
    }
    function E(Y, L) {
      var w = a.get();
      w.context = r, w.release = G, w.value = Y, w.callback = L || n, w.errorHandler = d, h >= l || m.paused ? u ? (u.next = w, u = w) : (c = w, u = w, m.saturated()) : (h++, o.call(r, w.value, w.worked));
    }
    function Z(Y, L) {
      var w = a.get();
      w.context = r, w.release = G, w.value = Y, w.callback = L || n, w.errorHandler = d, h >= l || m.paused ? c ? (w.next = c, c = w) : (c = w, u = w, m.saturated()) : (h++, o.call(r, w.value, w.worked));
    }
    function G(Y) {
      Y && a.release(Y);
      var L = c;
      L && h <= l ? m.paused ? h-- : (u === c && (u = null), c = L.next, L.next = null, o.call(r, L.value, L.worked), u === null && m.empty()) : --h === 0 && m.drain();
    }
    function T() {
      c = null, u = null, m.drain = n;
    }
    function C() {
      c = null, u = null, m.drain(), m.drain = n;
    }
    function N(Y) {
      d = Y;
    }
  }
  function n() {
  }
  function i() {
    this.value = null, this.callback = n, this.next = null, this.release = n, this.context = null, this.errorHandler = null;
    var r = this;
    this.worked = function(o, l) {
      var a = r.callback, c = r.errorHandler, u = r.value;
      r.value = null, r.callback = n, r.errorHandler && c(o, u), a.call(r.context, o, l), r.release(r);
    };
  }
  function s(r, o, l) {
    typeof r == "function" && (l = o, o = r, r = null);
    function a(g, A) {
      o.call(this, g).then(function(b) {
        A(null, b);
      }, A);
    }
    var c = e(r, a, l), u = c.push, h = c.unshift;
    return c.push = d, c.unshift = m, c.drained = p, c;
    function d(g) {
      var A = new Promise(function(b, R) {
        u(g, function(S, E) {
          if (S) {
            R(S);
            return;
          }
          b(E);
        });
      });
      return A.catch(n), A;
    }
    function m(g) {
      var A = new Promise(function(b, R) {
        h(g, function(S, E) {
          if (S) {
            R(S);
            return;
          }
          b(E);
        });
      });
      return A.catch(n), A;
    }
    function p() {
      if (c.idle())
        return new Promise(function(b) {
          b();
        });
      var g = c.drain, A = new Promise(function(b) {
        c.drain = function() {
          g(), b();
        };
      });
      return A;
    }
  }
  return ss.exports = e, ss.exports.promise = s, ss.exports;
}
var rs = { exports: {} }, y1;
function i2() {
  if (y1) return rs.exports;
  y1 = 1;
  var t = typeof Reflect == "object" ? Reflect : null, e = t && typeof t.apply == "function" ? t.apply : function(E, Z, G) {
    return Function.prototype.apply.call(E, Z, G);
  }, n;
  t && typeof t.ownKeys == "function" ? n = t.ownKeys : Object.getOwnPropertySymbols ? n = function(E) {
    return Object.getOwnPropertyNames(E).concat(Object.getOwnPropertySymbols(E));
  } : n = function(E) {
    return Object.getOwnPropertyNames(E);
  };
  function i(E) {
    console && console.warn && console.warn(E);
  }
  var s = Number.isNaN || function(E) {
    return E !== E;
  };
  function r() {
    r.init.call(this);
  }
  rs.exports = r, rs.exports.once = b, r.EventEmitter = r, r.prototype._events = void 0, r.prototype._eventsCount = 0, r.prototype._maxListeners = void 0;
  var o = 10;
  function l(E) {
    if (typeof E != "function")
      throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof E);
  }
  Object.defineProperty(r, "defaultMaxListeners", {
    enumerable: !0,
    get: function() {
      return o;
    },
    set: function(E) {
      if (typeof E != "number" || E < 0 || s(E))
        throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + E + ".");
      o = E;
    }
  }), r.init = function() {
    (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
  }, r.prototype.setMaxListeners = function(E) {
    if (typeof E != "number" || E < 0 || s(E))
      throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + E + ".");
    return this._maxListeners = E, this;
  };
  function a(E) {
    return E._maxListeners === void 0 ? r.defaultMaxListeners : E._maxListeners;
  }
  r.prototype.getMaxListeners = function() {
    return a(this);
  }, r.prototype.emit = function(E) {
    for (var Z = [], G = 1; G < arguments.length; G++) Z.push(arguments[G]);
    var T = E === "error", C = this._events;
    if (C !== void 0)
      T = T && C.error === void 0;
    else if (!T)
      return !1;
    if (T) {
      var N;
      if (Z.length > 0 && (N = Z[0]), N instanceof Error)
        throw N;
      var Y = new Error("Unhandled error." + (N ? " (" + N.message + ")" : ""));
      throw Y.context = N, Y;
    }
    var L = C[E];
    if (L === void 0)
      return !1;
    if (typeof L == "function")
      e(L, this, Z);
    else
      for (var w = L.length, D = p(L, w), G = 0; G < w; ++G)
        e(D[G], this, Z);
    return !0;
  };
  function c(E, Z, G, T) {
    var C, N, Y;
    if (l(G), N = E._events, N === void 0 ? (N = E._events = /* @__PURE__ */ Object.create(null), E._eventsCount = 0) : (N.newListener !== void 0 && (E.emit(
      "newListener",
      Z,
      G.listener ? G.listener : G
    ), N = E._events), Y = N[Z]), Y === void 0)
      Y = N[Z] = G, ++E._eventsCount;
    else if (typeof Y == "function" ? Y = N[Z] = T ? [G, Y] : [Y, G] : T ? Y.unshift(G) : Y.push(G), C = a(E), C > 0 && Y.length > C && !Y.warned) {
      Y.warned = !0;
      var L = new Error("Possible EventEmitter memory leak detected. " + Y.length + " " + String(Z) + " listeners added. Use emitter.setMaxListeners() to increase limit");
      L.name = "MaxListenersExceededWarning", L.emitter = E, L.type = Z, L.count = Y.length, i(L);
    }
    return E;
  }
  r.prototype.addListener = function(E, Z) {
    return c(this, E, Z, !1);
  }, r.prototype.on = r.prototype.addListener, r.prototype.prependListener = function(E, Z) {
    return c(this, E, Z, !0);
  };
  function u() {
    if (!this.fired)
      return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
  }
  function h(E, Z, G) {
    var T = { fired: !1, wrapFn: void 0, target: E, type: Z, listener: G }, C = u.bind(T);
    return C.listener = G, T.wrapFn = C, C;
  }
  r.prototype.once = function(E, Z) {
    return l(Z), this.on(E, h(this, E, Z)), this;
  }, r.prototype.prependOnceListener = function(E, Z) {
    return l(Z), this.prependListener(E, h(this, E, Z)), this;
  }, r.prototype.removeListener = function(E, Z) {
    var G, T, C, N, Y;
    if (l(Z), T = this._events, T === void 0)
      return this;
    if (G = T[E], G === void 0)
      return this;
    if (G === Z || G.listener === Z)
      --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete T[E], T.removeListener && this.emit("removeListener", E, G.listener || Z));
    else if (typeof G != "function") {
      for (C = -1, N = G.length - 1; N >= 0; N--)
        if (G[N] === Z || G[N].listener === Z) {
          Y = G[N].listener, C = N;
          break;
        }
      if (C < 0)
        return this;
      C === 0 ? G.shift() : g(G, C), G.length === 1 && (T[E] = G[0]), T.removeListener !== void 0 && this.emit("removeListener", E, Y || Z);
    }
    return this;
  }, r.prototype.off = r.prototype.removeListener, r.prototype.removeAllListeners = function(E) {
    var Z, G, T;
    if (G = this._events, G === void 0)
      return this;
    if (G.removeListener === void 0)
      return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : G[E] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete G[E]), this;
    if (arguments.length === 0) {
      var C = Object.keys(G), N;
      for (T = 0; T < C.length; ++T)
        N = C[T], N !== "removeListener" && this.removeAllListeners(N);
      return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
    }
    if (Z = G[E], typeof Z == "function")
      this.removeListener(E, Z);
    else if (Z !== void 0)
      for (T = Z.length - 1; T >= 0; T--)
        this.removeListener(E, Z[T]);
    return this;
  };
  function d(E, Z, G) {
    var T = E._events;
    if (T === void 0)
      return [];
    var C = T[Z];
    return C === void 0 ? [] : typeof C == "function" ? G ? [C.listener || C] : [C] : G ? A(C) : p(C, C.length);
  }
  r.prototype.listeners = function(E) {
    return d(this, E, !0);
  }, r.prototype.rawListeners = function(E) {
    return d(this, E, !1);
  }, r.listenerCount = function(E, Z) {
    return typeof E.listenerCount == "function" ? E.listenerCount(Z) : m.call(E, Z);
  }, r.prototype.listenerCount = m;
  function m(E) {
    var Z = this._events;
    if (Z !== void 0) {
      var G = Z[E];
      if (typeof G == "function")
        return 1;
      if (G !== void 0)
        return G.length;
    }
    return 0;
  }
  r.prototype.eventNames = function() {
    return this._eventsCount > 0 ? n(this._events) : [];
  };
  function p(E, Z) {
    for (var G = new Array(Z), T = 0; T < Z; ++T)
      G[T] = E[T];
    return G;
  }
  function g(E, Z) {
    for (; Z + 1 < E.length; Z++)
      E[Z] = E[Z + 1];
    E.pop();
  }
  function A(E) {
    for (var Z = new Array(E.length), G = 0; G < Z.length; ++G)
      Z[G] = E[G].listener || E[G];
    return Z;
  }
  function b(E, Z) {
    return new Promise(function(G, T) {
      function C(Y) {
        E.removeListener(Z, N), T(Y);
      }
      function N() {
        typeof E.removeListener == "function" && E.removeListener("error", C), G([].slice.call(arguments));
      }
      S(E, Z, N, { once: !0 }), Z !== "error" && R(E, C, { once: !0 });
    });
  }
  function R(E, Z, G) {
    typeof E.on == "function" && S(E, "error", Z, G);
  }
  function S(E, Z, G, T) {
    if (typeof E.on == "function")
      T.once ? E.once(Z, G) : E.on(Z, G);
    else if (typeof E.addEventListener == "function")
      E.addEventListener(Z, function C(N) {
        T.once && E.removeEventListener(Z, C), G(N);
      });
    else
      throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof E);
  }
  return rs.exports;
}
var C1 = {}, W1 = {}, S1, Z1;
function s2() {
  return Z1 || (Z1 = 1, S1 = function() {
    if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
      return !1;
    if (typeof Symbol.iterator == "symbol")
      return !0;
    var t = {}, e = /* @__PURE__ */ Symbol("test"), n = Object(e);
    if (typeof e == "string" || Object.prototype.toString.call(e) !== "[object Symbol]" || Object.prototype.toString.call(n) !== "[object Symbol]")
      return !1;
    var i = 42;
    t[e] = i;
    for (e in t)
      return !1;
    if (typeof Object.keys == "function" && Object.keys(t).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(t).length !== 0)
      return !1;
    var s = Object.getOwnPropertySymbols(t);
    if (s.length !== 1 || s[0] !== e || !Object.prototype.propertyIsEnumerable.call(t, e))
      return !1;
    if (typeof Object.getOwnPropertyDescriptor == "function") {
      var r = Object.getOwnPropertyDescriptor(t, e);
      if (r.value !== i || r.enumerable !== !0)
        return !1;
    }
    return !0;
  }), S1;
}
var Ur, v1;
function nr() {
  if (v1) return Ur;
  v1 = 1;
  var t = s2();
  return Ur = function() {
    return t() && !!Symbol.toStringTag;
  }, Ur;
}
var I1, N1;
function kb() {
  return N1 || (N1 = 1, I1 = Error), I1;
}
var F1, G1;
function Jb() {
  return G1 || (G1 = 1, F1 = EvalError), F1;
}
var X1, U1;
function xb() {
  return U1 || (U1 = 1, X1 = RangeError), X1;
}
var B1, w1;
function Mb() {
  return w1 || (w1 = 1, B1 = ReferenceError), B1;
}
var Y1, T1;
function r2() {
  return T1 || (T1 = 1, Y1 = SyntaxError), Y1;
}
var L1, k1;
function ir() {
  return k1 || (k1 = 1, L1 = TypeError), L1;
}
var J1, x1;
function Qb() {
  return x1 || (x1 = 1, J1 = URIError), J1;
}
var Br, M1;
function zb() {
  if (M1) return Br;
  M1 = 1;
  var t = typeof Symbol < "u" && Symbol, e = s2();
  return Br = function() {
    return typeof t != "function" || typeof Symbol != "function" || typeof t("foo") != "symbol" || typeof /* @__PURE__ */ Symbol("bar") != "symbol" ? !1 : e();
  }, Br;
}
var wr, Q1;
function Kb() {
  if (Q1) return wr;
  Q1 = 1;
  var t = {
    __proto__: null,
    foo: {}
  }, e = Object;
  return wr = function() {
    return { __proto__: t }.foo === t.foo && !(t instanceof e);
  }, wr;
}
var Yr, z1;
function Hb() {
  if (z1) return Yr;
  z1 = 1;
  var t = "Function.prototype.bind called on incompatible ", e = Object.prototype.toString, n = Math.max, i = "[object Function]", s = function(l, a) {
    for (var c = [], u = 0; u < l.length; u += 1)
      c[u] = l[u];
    for (var h = 0; h < a.length; h += 1)
      c[h + l.length] = a[h];
    return c;
  }, r = function(l, a) {
    for (var c = [], u = a, h = 0; u < l.length; u += 1, h += 1)
      c[h] = l[u];
    return c;
  }, o = function(l, a) {
    for (var c = "", u = 0; u < l.length; u += 1)
      c += l[u], u + 1 < l.length && (c += a);
    return c;
  };
  return Yr = function(l) {
    var a = this;
    if (typeof a != "function" || e.apply(a) !== i)
      throw new TypeError(t + a);
    for (var c = r(arguments, 1), u, h = function() {
      if (this instanceof u) {
        var A = a.apply(
          this,
          s(c, arguments)
        );
        return Object(A) === A ? A : this;
      }
      return a.apply(
        l,
        s(c, arguments)
      );
    }, d = n(0, a.length - c.length), m = [], p = 0; p < d; p++)
      m[p] = "$" + p;
    if (u = Function("binder", "return function (" + o(m, ",") + "){ return binder.apply(this,arguments); }")(h), a.prototype) {
      var g = function() {
      };
      g.prototype = a.prototype, u.prototype = new g(), g.prototype = null;
    }
    return u;
  }, Yr;
}
var Tr, K1;
function ra() {
  if (K1) return Tr;
  K1 = 1;
  var t = Hb();
  return Tr = Function.prototype.bind || t, Tr;
}
var Lr, H1;
function Ob() {
  if (H1) return Lr;
  H1 = 1;
  var t = Function.prototype.call, e = Object.prototype.hasOwnProperty, n = ra();
  return Lr = n.call(t, e), Lr;
}
var kr, O1;
function xi() {
  if (O1) return kr;
  O1 = 1;
  var t, e = /* @__PURE__ */ kb(), n = /* @__PURE__ */ Jb(), i = /* @__PURE__ */ xb(), s = /* @__PURE__ */ Mb(), r = /* @__PURE__ */ r2(), o = /* @__PURE__ */ ir(), l = /* @__PURE__ */ Qb(), a = Function, c = function(J) {
    try {
      return a('"use strict"; return (' + J + ").constructor;")();
    } catch {
    }
  }, u = Object.getOwnPropertyDescriptor;
  if (u)
    try {
      u({}, "");
    } catch {
      u = null;
    }
  var h = function() {
    throw new o();
  }, d = u ? (function() {
    try {
      return arguments.callee, h;
    } catch {
      try {
        return u(arguments, "callee").get;
      } catch {
        return h;
      }
    }
  })() : h, m = zb()(), p = /* @__PURE__ */ Kb()(), g = Object.getPrototypeOf || (p ? function(J) {
    return J.__proto__;
  } : null), A = {}, b = typeof Uint8Array > "u" || !g ? t : g(Uint8Array), R = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError > "u" ? t : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer > "u" ? t : ArrayBuffer,
    "%ArrayIteratorPrototype%": m && g ? g([][Symbol.iterator]()) : t,
    "%AsyncFromSyncIteratorPrototype%": t,
    "%AsyncFunction%": A,
    "%AsyncGenerator%": A,
    "%AsyncGeneratorFunction%": A,
    "%AsyncIteratorPrototype%": A,
    "%Atomics%": typeof Atomics > "u" ? t : Atomics,
    "%BigInt%": typeof BigInt > "u" ? t : BigInt,
    "%BigInt64Array%": typeof BigInt64Array > "u" ? t : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array > "u" ? t : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView > "u" ? t : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": e,
    "%eval%": eval,
    // eslint-disable-line no-eval
    "%EvalError%": n,
    "%Float32Array%": typeof Float32Array > "u" ? t : Float32Array,
    "%Float64Array%": typeof Float64Array > "u" ? t : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? t : FinalizationRegistry,
    "%Function%": a,
    "%GeneratorFunction%": A,
    "%Int8Array%": typeof Int8Array > "u" ? t : Int8Array,
    "%Int16Array%": typeof Int16Array > "u" ? t : Int16Array,
    "%Int32Array%": typeof Int32Array > "u" ? t : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": m && g ? g(g([][Symbol.iterator]())) : t,
    "%JSON%": typeof JSON == "object" ? JSON : t,
    "%Map%": typeof Map > "u" ? t : Map,
    "%MapIteratorPrototype%": typeof Map > "u" || !m || !g ? t : g((/* @__PURE__ */ new Map())[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise > "u" ? t : Promise,
    "%Proxy%": typeof Proxy > "u" ? t : Proxy,
    "%RangeError%": i,
    "%ReferenceError%": s,
    "%Reflect%": typeof Reflect > "u" ? t : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set > "u" ? t : Set,
    "%SetIteratorPrototype%": typeof Set > "u" || !m || !g ? t : g((/* @__PURE__ */ new Set())[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? t : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": m && g ? g(""[Symbol.iterator]()) : t,
    "%Symbol%": m ? Symbol : t,
    "%SyntaxError%": r,
    "%ThrowTypeError%": d,
    "%TypedArray%": b,
    "%TypeError%": o,
    "%Uint8Array%": typeof Uint8Array > "u" ? t : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? t : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array > "u" ? t : Uint16Array,
    "%Uint32Array%": typeof Uint32Array > "u" ? t : Uint32Array,
    "%URIError%": l,
    "%WeakMap%": typeof WeakMap > "u" ? t : WeakMap,
    "%WeakRef%": typeof WeakRef > "u" ? t : WeakRef,
    "%WeakSet%": typeof WeakSet > "u" ? t : WeakSet
  };
  if (g)
    try {
      null.error;
    } catch (J) {
      var S = g(g(J));
      R["%Error.prototype%"] = S;
    }
  var E = function J(q) {
    var k;
    if (q === "%AsyncFunction%")
      k = c("async function () {}");
    else if (q === "%GeneratorFunction%")
      k = c("function* () {}");
    else if (q === "%AsyncGeneratorFunction%")
      k = c("async function* () {}");
    else if (q === "%AsyncGenerator%") {
      var O = J("%AsyncGeneratorFunction%");
      O && (k = O.prototype);
    } else if (q === "%AsyncIteratorPrototype%") {
      var ee = J("%AsyncGenerator%");
      ee && g && (k = g(ee.prototype));
    }
    return R[q] = k, k;
  }, Z = {
    __proto__: null,
    "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
    "%ArrayPrototype%": ["Array", "prototype"],
    "%ArrayProto_entries%": ["Array", "prototype", "entries"],
    "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
    "%ArrayProto_keys%": ["Array", "prototype", "keys"],
    "%ArrayProto_values%": ["Array", "prototype", "values"],
    "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
    "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
    "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
    "%BooleanPrototype%": ["Boolean", "prototype"],
    "%DataViewPrototype%": ["DataView", "prototype"],
    "%DatePrototype%": ["Date", "prototype"],
    "%ErrorPrototype%": ["Error", "prototype"],
    "%EvalErrorPrototype%": ["EvalError", "prototype"],
    "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
    "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
    "%FunctionPrototype%": ["Function", "prototype"],
    "%Generator%": ["GeneratorFunction", "prototype"],
    "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
    "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
    "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
    "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
    "%JSONParse%": ["JSON", "parse"],
    "%JSONStringify%": ["JSON", "stringify"],
    "%MapPrototype%": ["Map", "prototype"],
    "%NumberPrototype%": ["Number", "prototype"],
    "%ObjectPrototype%": ["Object", "prototype"],
    "%ObjProto_toString%": ["Object", "prototype", "toString"],
    "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
    "%PromisePrototype%": ["Promise", "prototype"],
    "%PromiseProto_then%": ["Promise", "prototype", "then"],
    "%Promise_all%": ["Promise", "all"],
    "%Promise_reject%": ["Promise", "reject"],
    "%Promise_resolve%": ["Promise", "resolve"],
    "%RangeErrorPrototype%": ["RangeError", "prototype"],
    "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
    "%RegExpPrototype%": ["RegExp", "prototype"],
    "%SetPrototype%": ["Set", "prototype"],
    "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
    "%StringPrototype%": ["String", "prototype"],
    "%SymbolPrototype%": ["Symbol", "prototype"],
    "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
    "%TypedArrayPrototype%": ["TypedArray", "prototype"],
    "%TypeErrorPrototype%": ["TypeError", "prototype"],
    "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
    "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
    "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
    "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
    "%URIErrorPrototype%": ["URIError", "prototype"],
    "%WeakMapPrototype%": ["WeakMap", "prototype"],
    "%WeakSetPrototype%": ["WeakSet", "prototype"]
  }, G = ra(), T = Ob(), C = G.call(Function.call, Array.prototype.concat), N = G.call(Function.apply, Array.prototype.splice), Y = G.call(Function.call, String.prototype.replace), L = G.call(Function.call, String.prototype.slice), w = G.call(Function.call, RegExp.prototype.exec), D = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, ie = /\\(\\)?/g, X = function(J) {
    var q = L(J, 0, 1), k = L(J, -1);
    if (q === "%" && k !== "%")
      throw new r("invalid intrinsic syntax, expected closing `%`");
    if (k === "%" && q !== "%")
      throw new r("invalid intrinsic syntax, expected opening `%`");
    var O = [];
    return Y(J, D, function(ee, W, v, F) {
      O[O.length] = v ? Y(F, ie, "$1") : W || ee;
    }), O;
  }, Q = function(J, q) {
    var k = J, O;
    if (T(Z, k) && (O = Z[k], k = "%" + O[0] + "%"), T(R, k)) {
      var ee = R[k];
      if (ee === A && (ee = E(k)), typeof ee > "u" && !q)
        throw new o("intrinsic " + J + " exists, but is not available. Please file an issue!");
      return {
        alias: O,
        name: k,
        value: ee
      };
    }
    throw new r("intrinsic " + J + " does not exist!");
  };
  return kr = function(J, q) {
    if (typeof J != "string" || J.length === 0)
      throw new o("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof q != "boolean")
      throw new o('"allowMissing" argument must be a boolean');
    if (w(/^%?[^%]*%?$/, J) === null)
      throw new r("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var k = X(J), O = k.length > 0 ? k[0] : "", ee = Q("%" + O + "%", q), W = ee.name, v = ee.value, F = !1, K = ee.alias;
    K && (O = K[0], N(k, C([0, 1], K)));
    for (var _ = 1, $ = !0; _ < k.length; _ += 1) {
      var j = k[_], z = L(j, 0, 1), P = L(j, -1);
      if ((z === '"' || z === "'" || z === "`" || P === '"' || P === "'" || P === "`") && z !== P)
        throw new r("property names with quotes must have matching quotes");
      if ((j === "constructor" || !$) && (F = !0), O += "." + j, W = "%" + O + "%", T(R, W))
        v = R[W];
      else if (v != null) {
        if (!(j in v)) {
          if (!q)
            throw new o("base intrinsic for " + J + " exists, but the property is not available.");
          return;
        }
        if (u && _ + 1 >= k.length) {
          var ne = u(v, j);
          $ = !!ne, $ && "get" in ne && !("originalValue" in ne.get) ? v = ne.get : v = v[j];
        } else
          $ = T(v, j), v = v[j];
        $ && !F && (R[W] = v);
      }
    }
    return v;
  }, kr;
}
var D1 = { exports: {} }, Jr, P1;
function oa() {
  if (P1) return Jr;
  P1 = 1;
  var t = /* @__PURE__ */ xi(), e = t("%Object.defineProperty%", !0) || !1;
  if (e)
    try {
      e({}, "a", { value: 1 });
    } catch {
      e = !1;
    }
  return Jr = e, Jr;
}
var xr, _1;
function sr() {
  if (_1) return xr;
  _1 = 1;
  var t = /* @__PURE__ */ xi(), e = t("%Object.getOwnPropertyDescriptor%", !0);
  if (e)
    try {
      e([], "length");
    } catch {
      e = null;
    }
  return xr = e, xr;
}
var Mr, j1;
function Db() {
  if (j1) return Mr;
  j1 = 1;
  var t = /* @__PURE__ */ oa(), e = /* @__PURE__ */ r2(), n = /* @__PURE__ */ ir(), i = /* @__PURE__ */ sr();
  return Mr = function(s, r, o) {
    if (!s || typeof s != "object" && typeof s != "function")
      throw new n("`obj` must be an object or a function`");
    if (typeof r != "string" && typeof r != "symbol")
      throw new n("`property` must be a string or a symbol`");
    if (arguments.length > 3 && typeof arguments[3] != "boolean" && arguments[3] !== null)
      throw new n("`nonEnumerable`, if provided, must be a boolean or null");
    if (arguments.length > 4 && typeof arguments[4] != "boolean" && arguments[4] !== null)
      throw new n("`nonWritable`, if provided, must be a boolean or null");
    if (arguments.length > 5 && typeof arguments[5] != "boolean" && arguments[5] !== null)
      throw new n("`nonConfigurable`, if provided, must be a boolean or null");
    if (arguments.length > 6 && typeof arguments[6] != "boolean")
      throw new n("`loose`, if provided, must be a boolean");
    var l = arguments.length > 3 ? arguments[3] : null, a = arguments.length > 4 ? arguments[4] : null, c = arguments.length > 5 ? arguments[5] : null, u = arguments.length > 6 ? arguments[6] : !1, h = !!i && i(s, r);
    if (t)
      t(s, r, {
        configurable: c === null && h ? h.configurable : !c,
        enumerable: l === null && h ? h.enumerable : !l,
        value: o,
        writable: a === null && h ? h.writable : !a
      });
    else if (u || !l && !a && !c)
      s[r] = o;
    else
      throw new e("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
  }, Mr;
}
var Qr, $1;
function Pb() {
  if ($1) return Qr;
  $1 = 1;
  var t = /* @__PURE__ */ oa(), e = function() {
    return !!t;
  };
  return e.hasArrayLengthDefineBug = function() {
    if (!t)
      return null;
    try {
      return t([], "length", { value: 1 }).length !== 1;
    } catch {
      return !0;
    }
  }, Qr = e, Qr;
}
var zr, q1;
function _b() {
  if (q1) return zr;
  q1 = 1;
  var t = /* @__PURE__ */ xi(), e = /* @__PURE__ */ Db(), n = /* @__PURE__ */ Pb()(), i = /* @__PURE__ */ sr(), s = /* @__PURE__ */ ir(), r = t("%Math.floor%");
  return zr = function(o, l) {
    if (typeof o != "function")
      throw new s("`fn` is not a function");
    if (typeof l != "number" || l < 0 || l > 4294967295 || r(l) !== l)
      throw new s("`length` must be a positive 32-bit integer");
    var a = arguments.length > 2 && !!arguments[2], c = !0, u = !0;
    if ("length" in o && i) {
      var h = i(o, "length");
      h && !h.configurable && (c = !1), h && !h.writable && (u = !1);
    }
    return (c || u || !a) && (n ? e(
      /** @type {Parameters<define>[0]} */
      o,
      "length",
      l,
      !0,
      !0
    ) : e(
      /** @type {Parameters<define>[0]} */
      o,
      "length",
      l
    )), o;
  }, zr;
}
var eu;
function la() {
  return eu || (eu = 1, (function(t) {
    var e = ra(), n = /* @__PURE__ */ xi(), i = /* @__PURE__ */ _b(), s = /* @__PURE__ */ ir(), r = n("%Function.prototype.apply%"), o = n("%Function.prototype.call%"), l = n("%Reflect.apply%", !0) || e.call(o, r), a = /* @__PURE__ */ oa(), c = n("%Math.max%");
    t.exports = function(h) {
      if (typeof h != "function")
        throw new s("a function is required");
      var d = l(e, o, arguments);
      return i(
        d,
        1 + c(0, h.length - (arguments.length - 1)),
        !0
      );
    };
    var u = function() {
      return l(e, r, arguments);
    };
    a ? a(t.exports, "apply", { value: u }) : t.exports.apply = u;
  })(D1)), D1.exports;
}
var Kr, tu;
function aa() {
  if (tu) return Kr;
  tu = 1;
  var t = /* @__PURE__ */ xi(), e = la(), n = e(t("String.prototype.indexOf"));
  return Kr = function(i, s) {
    var r = t(i, !!s);
    return typeof r == "function" && n(i, ".prototype.") > -1 ? e(r) : r;
  }, Kr;
}
var Hr, nu;
function jb() {
  if (nu) return Hr;
  nu = 1;
  var t = nr()(), e = aa(), n = e("Object.prototype.toString"), i = function(o) {
    return t && o && typeof o == "object" && Symbol.toStringTag in o ? !1 : n(o) === "[object Arguments]";
  }, s = function(o) {
    return i(o) ? !0 : o !== null && typeof o == "object" && typeof o.length == "number" && o.length >= 0 && n(o) !== "[object Array]" && n(o.callee) === "[object Function]";
  }, r = (function() {
    return i(arguments);
  })();
  return i.isLegacyArguments = s, Hr = r ? i : s, Hr;
}
var Or, iu;
function $b() {
  if (iu) return Or;
  iu = 1;
  var t = Object.prototype.toString, e = Function.prototype.toString, n = /^\s*(?:function)?\*/, i = nr()(), s = Object.getPrototypeOf, r = function() {
    if (!i)
      return !1;
    try {
      return Function("return function*() {}")();
    } catch {
    }
  }, o;
  return Or = function(l) {
    if (typeof l != "function")
      return !1;
    if (n.test(e.call(l)))
      return !0;
    if (!i) {
      var a = t.call(l);
      return a === "[object GeneratorFunction]";
    }
    if (!s)
      return !1;
    if (typeof o > "u") {
      var c = r();
      o = c ? s(c) : !1;
    }
    return s(l) === o;
  }, Or;
}
var Dr, su;
function qb() {
  if (su) return Dr;
  su = 1;
  var t = Function.prototype.toString, e = typeof Reflect == "object" && Reflect !== null && Reflect.apply, n, i;
  if (typeof e == "function" && typeof Object.defineProperty == "function")
    try {
      n = Object.defineProperty({}, "length", {
        get: function() {
          throw i;
        }
      }), i = {}, e(function() {
        throw 42;
      }, null, n);
    } catch (R) {
      R !== i && (e = null);
    }
  else
    e = null;
  var s = /^\s*class\b/, r = function(R) {
    try {
      var S = t.call(R);
      return s.test(S);
    } catch {
      return !1;
    }
  }, o = function(R) {
    try {
      return r(R) ? !1 : (t.call(R), !0);
    } catch {
      return !1;
    }
  }, l = Object.prototype.toString, a = "[object Object]", c = "[object Function]", u = "[object GeneratorFunction]", h = "[object HTMLAllCollection]", d = "[object HTML document.all class]", m = "[object HTMLCollection]", p = typeof Symbol == "function" && !!Symbol.toStringTag, g = !(0 in [,]), A = function() {
    return !1;
  };
  if (typeof document == "object") {
    var b = document.all;
    l.call(b) === l.call(document.all) && (A = function(R) {
      if ((g || !R) && (typeof R > "u" || typeof R == "object"))
        try {
          var S = l.call(R);
          return (S === h || S === d || S === m || S === a) && R("") == null;
        } catch {
        }
      return !1;
    });
  }
  return Dr = e ? function(R) {
    if (A(R))
      return !0;
    if (!R || typeof R != "function" && typeof R != "object")
      return !1;
    try {
      e(R, null, n);
    } catch (S) {
      if (S !== i)
        return !1;
    }
    return !r(R) && o(R);
  } : function(R) {
    if (A(R))
      return !0;
    if (!R || typeof R != "function" && typeof R != "object")
      return !1;
    if (p)
      return o(R);
    if (r(R))
      return !1;
    var S = l.call(R);
    return S !== c && S !== u && !/^\[object HTML/.test(S) ? !1 : o(R);
  }, Dr;
}
var Pr, ru;
function o2() {
  if (ru) return Pr;
  ru = 1;
  var t = qb(), e = Object.prototype.toString, n = Object.prototype.hasOwnProperty, i = function(l, a, c) {
    for (var u = 0, h = l.length; u < h; u++)
      n.call(l, u) && (c == null ? a(l[u], u, l) : a.call(c, l[u], u, l));
  }, s = function(l, a, c) {
    for (var u = 0, h = l.length; u < h; u++)
      c == null ? a(l.charAt(u), u, l) : a.call(c, l.charAt(u), u, l);
  }, r = function(l, a, c) {
    for (var u in l)
      n.call(l, u) && (c == null ? a(l[u], u, l) : a.call(c, l[u], u, l));
  }, o = function(l, a, c) {
    if (!t(a))
      throw new TypeError("iterator must be a function");
    var u;
    arguments.length >= 3 && (u = c), e.call(l) === "[object Array]" ? i(l, a, u) : typeof l == "string" ? s(l, a, u) : r(l, a, u);
  };
  return Pr = o, Pr;
}
var ou, lu;
function e4() {
  return lu || (lu = 1, ou = [
    "Float32Array",
    "Float64Array",
    "Int8Array",
    "Int16Array",
    "Int32Array",
    "Uint8Array",
    "Uint8ClampedArray",
    "Uint16Array",
    "Uint32Array",
    "BigInt64Array",
    "BigUint64Array"
  ]), ou;
}
var _r, au;
function l2() {
  if (au) return _r;
  au = 1;
  var t = /* @__PURE__ */ e4(), e = typeof globalThis > "u" ? sa : globalThis;
  return _r = function() {
    for (var n = [], i = 0; i < t.length; i++)
      typeof e[t[i]] == "function" && (n[n.length] = t[i]);
    return n;
  }, _r;
}
var jr, cu;
function t4() {
  if (cu) return jr;
  cu = 1;
  var t = o2(), e = /* @__PURE__ */ l2(), n = la(), i = aa(), s = /* @__PURE__ */ sr(), r = i("Object.prototype.toString"), o = nr()(), l = typeof globalThis > "u" ? sa : globalThis, a = e(), c = i("String.prototype.slice"), u = Object.getPrototypeOf, h = i("Array.prototype.indexOf", !0) || function(g, A) {
    for (var b = 0; b < g.length; b += 1)
      if (g[b] === A)
        return b;
    return -1;
  }, d = { __proto__: null };
  o && s && u ? t(a, function(g) {
    var A = new l[g]();
    if (Symbol.toStringTag in A) {
      var b = u(A), R = s(b, Symbol.toStringTag);
      if (!R) {
        var S = u(b);
        R = s(S, Symbol.toStringTag);
      }
      d["$" + g] = n(R.get);
    }
  }) : t(a, function(g) {
    var A = new l[g](), b = A.slice || A.set;
    b && (d["$" + g] = n(b));
  });
  var m = function(g) {
    var A = !1;
    return t(d, function(b, R) {
      if (!A)
        try {
          "$" + b(g) === R && (A = c(R, 1));
        } catch {
        }
    }), A;
  }, p = function(g) {
    var A = !1;
    return t(d, function(b, R) {
      if (!A)
        try {
          b(g), A = c(R, 1);
        } catch {
        }
    }), A;
  };
  return jr = function(g) {
    if (!g || typeof g != "object")
      return !1;
    if (!o) {
      var A = c(r(g), 8, -1);
      return h(a, A) > -1 ? A : A !== "Object" ? !1 : p(g);
    }
    return s ? m(g) : null;
  }, jr;
}
var $r, uu;
function n4() {
  if (uu) return $r;
  uu = 1;
  var t = o2(), e = /* @__PURE__ */ l2(), n = la(), i = aa(), s = /* @__PURE__ */ sr(), r = i("Object.prototype.toString"), o = nr()(), l = typeof globalThis > "u" ? sa : globalThis, a = e(), c = i("String.prototype.slice"), u = Object.getPrototypeOf, h = i("Array.prototype.indexOf", !0) || function(g, A) {
    for (var b = 0; b < g.length; b += 1)
      if (g[b] === A)
        return b;
    return -1;
  }, d = { __proto__: null };
  o && s && u ? t(a, function(g) {
    var A = new l[g]();
    if (Symbol.toStringTag in A) {
      var b = u(A), R = s(b, Symbol.toStringTag);
      if (!R) {
        var S = u(b);
        R = s(S, Symbol.toStringTag);
      }
      d["$" + g] = n(R.get);
    }
  }) : t(a, function(g) {
    var A = new l[g](), b = A.slice || A.set;
    b && (d["$" + g] = n(b));
  });
  var m = function(g) {
    var A = !1;
    return t(
      // eslint-disable-next-line no-extra-parens
      /** @type {Record<`\$${TypedArrayName}`, Getter>} */
      /** @type {any} */
      d,
      /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */
      function(b, R) {
        if (!A)
          try {
            "$" + b(g) === R && (A = c(R, 1));
          } catch {
          }
      }
    ), A;
  }, p = function(g) {
    var A = !1;
    return t(
      // eslint-disable-next-line no-extra-parens
      /** @type {Record<`\$${TypedArrayName}`, Getter>} */
      /** @type {any} */
      d,
      /** @type {(getter: typeof cache, name: `\$${import('.').TypedArrayName}`) => void} */
      function(b, R) {
        if (!A)
          try {
            b(g), A = c(R, 1);
          } catch {
          }
      }
    ), A;
  };
  return $r = function(g) {
    if (!g || typeof g != "object")
      return !1;
    if (!o) {
      var A = c(r(g), 8, -1);
      return h(a, A) > -1 ? A : A !== "Object" ? !1 : p(g);
    }
    return s ? m(g) : null;
  }, $r;
}
var qr, hu;
function i4() {
  if (hu) return qr;
  hu = 1;
  var t = /* @__PURE__ */ n4();
  return qr = function(e) {
    return !!t(e);
  }, qr;
}
var du;
function s4() {
  return du || (du = 1, (function(t) {
    var e = jb(), n = $b(), i = /* @__PURE__ */ t4(), s = i4();
    function r(x) {
      return x.call.bind(x);
    }
    var o = typeof BigInt < "u", l = typeof Symbol < "u", a = r(Object.prototype.toString), c = r(Number.prototype.valueOf), u = r(String.prototype.valueOf), h = r(Boolean.prototype.valueOf);
    if (o)
      var d = r(BigInt.prototype.valueOf);
    if (l)
      var m = r(Symbol.prototype.valueOf);
    function p(x, rt) {
      if (typeof x != "object")
        return !1;
      try {
        return rt(x), !0;
      } catch {
        return !1;
      }
    }
    t.isArgumentsObject = e, t.isGeneratorFunction = n, t.isTypedArray = s;
    function g(x) {
      return typeof Promise < "u" && x instanceof Promise || x !== null && typeof x == "object" && typeof x.then == "function" && typeof x.catch == "function";
    }
    t.isPromise = g;
    function A(x) {
      return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? ArrayBuffer.isView(x) : s(x) || v(x);
    }
    t.isArrayBufferView = A;
    function b(x) {
      return i(x) === "Uint8Array";
    }
    t.isUint8Array = b;
    function R(x) {
      return i(x) === "Uint8ClampedArray";
    }
    t.isUint8ClampedArray = R;
    function S(x) {
      return i(x) === "Uint16Array";
    }
    t.isUint16Array = S;
    function E(x) {
      return i(x) === "Uint32Array";
    }
    t.isUint32Array = E;
    function Z(x) {
      return i(x) === "Int8Array";
    }
    t.isInt8Array = Z;
    function G(x) {
      return i(x) === "Int16Array";
    }
    t.isInt16Array = G;
    function T(x) {
      return i(x) === "Int32Array";
    }
    t.isInt32Array = T;
    function C(x) {
      return i(x) === "Float32Array";
    }
    t.isFloat32Array = C;
    function N(x) {
      return i(x) === "Float64Array";
    }
    t.isFloat64Array = N;
    function Y(x) {
      return i(x) === "BigInt64Array";
    }
    t.isBigInt64Array = Y;
    function L(x) {
      return i(x) === "BigUint64Array";
    }
    t.isBigUint64Array = L;
    function w(x) {
      return a(x) === "[object Map]";
    }
    w.working = typeof Map < "u" && w(/* @__PURE__ */ new Map());
    function D(x) {
      return typeof Map > "u" ? !1 : w.working ? w(x) : x instanceof Map;
    }
    t.isMap = D;
    function ie(x) {
      return a(x) === "[object Set]";
    }
    ie.working = typeof Set < "u" && ie(/* @__PURE__ */ new Set());
    function X(x) {
      return typeof Set > "u" ? !1 : ie.working ? ie(x) : x instanceof Set;
    }
    t.isSet = X;
    function Q(x) {
      return a(x) === "[object WeakMap]";
    }
    Q.working = typeof WeakMap < "u" && Q(/* @__PURE__ */ new WeakMap());
    function J(x) {
      return typeof WeakMap > "u" ? !1 : Q.working ? Q(x) : x instanceof WeakMap;
    }
    t.isWeakMap = J;
    function q(x) {
      return a(x) === "[object WeakSet]";
    }
    q.working = typeof WeakSet < "u" && q(/* @__PURE__ */ new WeakSet());
    function k(x) {
      return q(x);
    }
    t.isWeakSet = k;
    function O(x) {
      return a(x) === "[object ArrayBuffer]";
    }
    O.working = typeof ArrayBuffer < "u" && O(new ArrayBuffer());
    function ee(x) {
      return typeof ArrayBuffer > "u" ? !1 : O.working ? O(x) : x instanceof ArrayBuffer;
    }
    t.isArrayBuffer = ee;
    function W(x) {
      return a(x) === "[object DataView]";
    }
    W.working = typeof ArrayBuffer < "u" && typeof DataView < "u" && W(new DataView(new ArrayBuffer(1), 0, 1));
    function v(x) {
      return typeof DataView > "u" ? !1 : W.working ? W(x) : x instanceof DataView;
    }
    t.isDataView = v;
    var F = typeof SharedArrayBuffer < "u" ? SharedArrayBuffer : void 0;
    function K(x) {
      return a(x) === "[object SharedArrayBuffer]";
    }
    function _(x) {
      return typeof F > "u" ? !1 : (typeof K.working > "u" && (K.working = K(new F())), K.working ? K(x) : x instanceof F);
    }
    t.isSharedArrayBuffer = _;
    function $(x) {
      return a(x) === "[object AsyncFunction]";
    }
    t.isAsyncFunction = $;
    function j(x) {
      return a(x) === "[object Map Iterator]";
    }
    t.isMapIterator = j;
    function z(x) {
      return a(x) === "[object Set Iterator]";
    }
    t.isSetIterator = z;
    function P(x) {
      return a(x) === "[object Generator]";
    }
    t.isGeneratorObject = P;
    function ne(x) {
      return a(x) === "[object WebAssembly.Module]";
    }
    t.isWebAssemblyCompiledModule = ne;
    function le(x) {
      return p(x, c);
    }
    t.isNumberObject = le;
    function Ce(x) {
      return p(x, u);
    }
    t.isStringObject = Ce;
    function ue(x) {
      return p(x, h);
    }
    t.isBooleanObject = ue;
    function ye(x) {
      return o && p(x, d);
    }
    t.isBigIntObject = ye;
    function Qe(x) {
      return l && p(x, m);
    }
    t.isSymbolObject = Qe;
    function qe(x) {
      return le(x) || Ce(x) || ue(x) || ye(x) || Qe(x);
    }
    t.isBoxedPrimitive = qe;
    function dt(x) {
      return typeof Uint8Array < "u" && (ee(x) || _(x));
    }
    t.isAnyArrayBuffer = dt, ["isProxy", "isExternal", "isModuleNamespaceObject"].forEach(function(x) {
      Object.defineProperty(t, x, {
        enumerable: !1,
        value: function() {
          throw new Error(x + " is not supported in userland");
        }
      });
    });
  })(W1)), W1;
}
var mu, pu;
function r4() {
  return pu || (pu = 1, mu = function(t) {
    return t && typeof t == "object" && typeof t.copy == "function" && typeof t.fill == "function" && typeof t.readUInt8 == "function";
  }), mu;
}
var eo = { exports: {} }, gu;
function o4() {
  return gu || (gu = 1, typeof Object.create == "function" ? eo.exports = function(t, e) {
    e && (t.super_ = e, t.prototype = Object.create(e.prototype, {
      constructor: {
        value: t,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }));
  } : eo.exports = function(t, e) {
    if (e) {
      t.super_ = e;
      var n = function() {
      };
      n.prototype = e.prototype, t.prototype = new n(), t.prototype.constructor = t;
    }
  }), eo.exports;
}
var fu;
function ca() {
  return fu || (fu = 1, (function(t) {
    var e = Object.getOwnPropertyDescriptors || function(W) {
      for (var v = Object.keys(W), F = {}, K = 0; K < v.length; K++)
        F[v[K]] = Object.getOwnPropertyDescriptor(W, v[K]);
      return F;
    }, n = /%[sdj%]/g;
    t.format = function(W) {
      if (!Z(W)) {
        for (var v = [], F = 0; F < arguments.length; F++)
          v.push(o(arguments[F]));
        return v.join(" ");
      }
      for (var F = 1, K = arguments, _ = K.length, $ = String(W).replace(n, function(P) {
        if (P === "%%") return "%";
        if (F >= _) return P;
        switch (P) {
          case "%s":
            return String(K[F++]);
          case "%d":
            return Number(K[F++]);
          case "%j":
            try {
              return JSON.stringify(K[F++]);
            } catch {
              return "[Circular]";
            }
          default:
            return P;
        }
      }), j = K[F]; F < _; j = K[++F])
        R(j) || !N(j) ? $ += " " + j : $ += " " + o(j);
      return $;
    }, t.deprecate = function(W, v) {
      if (typeof ae < "u" && ae.noDeprecation === !0)
        return W;
      if (typeof ae > "u")
        return function() {
          return t.deprecate(W, v).apply(this, arguments);
        };
      var F = !1;
      function K() {
        if (!F) {
          if (ae.throwDeprecation)
            throw new Error(v);
          ae.traceDeprecation ? console.trace(v) : console.error(v), F = !0;
        }
        return W.apply(this, arguments);
      }
      return K;
    };
    var i = {}, s = /^$/;
    if (ae.env.NODE_DEBUG) {
      var r = ae.env.NODE_DEBUG;
      r = r.replace(/[|\\{}()[\]^$+?.]/g, "\\$&").replace(/\*/g, ".*").replace(/,/g, "$|^").toUpperCase(), s = new RegExp("^" + r + "$", "i");
    }
    t.debuglog = function(W) {
      if (W = W.toUpperCase(), !i[W])
        if (s.test(W)) {
          var v = ae.pid;
          i[W] = function() {
            var F = t.format.apply(t, arguments);
            console.error("%s %d: %s", W, v, F);
          };
        } else
          i[W] = function() {
          };
      return i[W];
    };
    function o(W, v) {
      var F = {
        seen: [],
        stylize: a
      };
      return arguments.length >= 3 && (F.depth = arguments[2]), arguments.length >= 4 && (F.colors = arguments[3]), b(v) ? F.showHidden = v : v && t._extend(F, v), T(F.showHidden) && (F.showHidden = !1), T(F.depth) && (F.depth = 2), T(F.colors) && (F.colors = !1), T(F.customInspect) && (F.customInspect = !0), F.colors && (F.stylize = l), u(F, W, F.depth);
    }
    t.inspect = o, o.colors = {
      bold: [1, 22],
      italic: [3, 23],
      underline: [4, 24],
      inverse: [7, 27],
      white: [37, 39],
      grey: [90, 39],
      black: [30, 39],
      blue: [34, 39],
      cyan: [36, 39],
      green: [32, 39],
      magenta: [35, 39],
      red: [31, 39],
      yellow: [33, 39]
    }, o.styles = {
      special: "cyan",
      number: "yellow",
      boolean: "yellow",
      undefined: "grey",
      null: "bold",
      string: "green",
      date: "magenta",
      // "name": intentionally not styling
      regexp: "red"
    };
    function l(W, v) {
      var F = o.styles[v];
      return F ? "\x1B[" + o.colors[F][0] + "m" + W + "\x1B[" + o.colors[F][1] + "m" : W;
    }
    function a(W, v) {
      return W;
    }
    function c(W) {
      var v = {};
      return W.forEach(function(F, K) {
        v[F] = !0;
      }), v;
    }
    function u(W, v, F) {
      if (W.customInspect && v && w(v.inspect) && // Filter out the util module, it's inspect function is special
      v.inspect !== t.inspect && // Also filter out any prototype objects using the circular check.
      !(v.constructor && v.constructor.prototype === v)) {
        var K = v.inspect(F, W);
        return Z(K) || (K = u(W, K, F)), K;
      }
      var _ = h(W, v);
      if (_)
        return _;
      var $ = Object.keys(v), j = c($);
      if (W.showHidden && ($ = Object.getOwnPropertyNames(v)), L(v) && ($.indexOf("message") >= 0 || $.indexOf("description") >= 0))
        return d(v);
      if ($.length === 0) {
        if (w(v)) {
          var z = v.name ? ": " + v.name : "";
          return W.stylize("[Function" + z + "]", "special");
        }
        if (C(v))
          return W.stylize(RegExp.prototype.toString.call(v), "regexp");
        if (Y(v))
          return W.stylize(Date.prototype.toString.call(v), "date");
        if (L(v))
          return d(v);
      }
      var P = "", ne = !1, le = ["{", "}"];
      if (A(v) && (ne = !0, le = ["[", "]"]), w(v)) {
        var Ce = v.name ? ": " + v.name : "";
        P = " [Function" + Ce + "]";
      }
      if (C(v) && (P = " " + RegExp.prototype.toString.call(v)), Y(v) && (P = " " + Date.prototype.toUTCString.call(v)), L(v) && (P = " " + d(v)), $.length === 0 && (!ne || v.length == 0))
        return le[0] + P + le[1];
      if (F < 0)
        return C(v) ? W.stylize(RegExp.prototype.toString.call(v), "regexp") : W.stylize("[Object]", "special");
      W.seen.push(v);
      var ue;
      return ne ? ue = m(W, v, F, j, $) : ue = $.map(function(ye) {
        return p(W, v, F, j, ye, ne);
      }), W.seen.pop(), g(ue, P, le);
    }
    function h(W, v) {
      if (T(v))
        return W.stylize("undefined", "undefined");
      if (Z(v)) {
        var F = "'" + JSON.stringify(v).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
        return W.stylize(F, "string");
      }
      if (E(v))
        return W.stylize("" + v, "number");
      if (b(v))
        return W.stylize("" + v, "boolean");
      if (R(v))
        return W.stylize("null", "null");
    }
    function d(W) {
      return "[" + Error.prototype.toString.call(W) + "]";
    }
    function m(W, v, F, K, _) {
      for (var $ = [], j = 0, z = v.length; j < z; ++j)
        q(v, String(j)) ? $.push(p(
          W,
          v,
          F,
          K,
          String(j),
          !0
        )) : $.push("");
      return _.forEach(function(P) {
        P.match(/^\d+$/) || $.push(p(
          W,
          v,
          F,
          K,
          P,
          !0
        ));
      }), $;
    }
    function p(W, v, F, K, _, $) {
      var j, z, P;
      if (P = Object.getOwnPropertyDescriptor(v, _) || { value: v[_] }, P.get ? P.set ? z = W.stylize("[Getter/Setter]", "special") : z = W.stylize("[Getter]", "special") : P.set && (z = W.stylize("[Setter]", "special")), q(K, _) || (j = "[" + _ + "]"), z || (W.seen.indexOf(P.value) < 0 ? (R(F) ? z = u(W, P.value, null) : z = u(W, P.value, F - 1), z.indexOf(`
`) > -1 && ($ ? z = z.split(`
`).map(function(ne) {
        return "  " + ne;
      }).join(`
`).slice(2) : z = `
` + z.split(`
`).map(function(ne) {
        return "   " + ne;
      }).join(`
`))) : z = W.stylize("[Circular]", "special")), T(j)) {
        if ($ && _.match(/^\d+$/))
          return z;
        j = JSON.stringify("" + _), j.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (j = j.slice(1, -1), j = W.stylize(j, "name")) : (j = j.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), j = W.stylize(j, "string"));
      }
      return j + ": " + z;
    }
    function g(W, v, F) {
      var K = W.reduce(function(_, $) {
        return $.indexOf(`
`) >= 0, _ + $.replace(/\u001b\[\d\d?m/g, "").length + 1;
      }, 0);
      return K > 60 ? F[0] + (v === "" ? "" : v + `
 `) + " " + W.join(`,
  `) + " " + F[1] : F[0] + v + " " + W.join(", ") + " " + F[1];
    }
    t.types = s4();
    function A(W) {
      return Array.isArray(W);
    }
    t.isArray = A;
    function b(W) {
      return typeof W == "boolean";
    }
    t.isBoolean = b;
    function R(W) {
      return W === null;
    }
    t.isNull = R;
    function S(W) {
      return W == null;
    }
    t.isNullOrUndefined = S;
    function E(W) {
      return typeof W == "number";
    }
    t.isNumber = E;
    function Z(W) {
      return typeof W == "string";
    }
    t.isString = Z;
    function G(W) {
      return typeof W == "symbol";
    }
    t.isSymbol = G;
    function T(W) {
      return W === void 0;
    }
    t.isUndefined = T;
    function C(W) {
      return N(W) && ie(W) === "[object RegExp]";
    }
    t.isRegExp = C, t.types.isRegExp = C;
    function N(W) {
      return typeof W == "object" && W !== null;
    }
    t.isObject = N;
    function Y(W) {
      return N(W) && ie(W) === "[object Date]";
    }
    t.isDate = Y, t.types.isDate = Y;
    function L(W) {
      return N(W) && (ie(W) === "[object Error]" || W instanceof Error);
    }
    t.isError = L, t.types.isNativeError = L;
    function w(W) {
      return typeof W == "function";
    }
    t.isFunction = w;
    function D(W) {
      return W === null || typeof W == "boolean" || typeof W == "number" || typeof W == "string" || typeof W == "symbol" || // ES6 symbol
      typeof W > "u";
    }
    t.isPrimitive = D, t.isBuffer = r4();
    function ie(W) {
      return Object.prototype.toString.call(W);
    }
    function X(W) {
      return W < 10 ? "0" + W.toString(10) : W.toString(10);
    }
    var Q = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ];
    function J() {
      var W = /* @__PURE__ */ new Date(), v = [
        X(W.getHours()),
        X(W.getMinutes()),
        X(W.getSeconds())
      ].join(":");
      return [W.getDate(), Q[W.getMonth()], v].join(" ");
    }
    t.log = function() {
      console.log("%s - %s", J(), t.format.apply(t, arguments));
    }, t.inherits = o4(), t._extend = function(W, v) {
      if (!v || !N(v)) return W;
      for (var F = Object.keys(v), K = F.length; K--; )
        W[F[K]] = v[F[K]];
      return W;
    };
    function q(W, v) {
      return Object.prototype.hasOwnProperty.call(W, v);
    }
    var k = typeof Symbol < "u" ? /* @__PURE__ */ Symbol("util.promisify.custom") : void 0;
    t.promisify = function(W) {
      if (typeof W != "function")
        throw new TypeError('The "original" argument must be of type Function');
      if (k && W[k]) {
        var v = W[k];
        if (typeof v != "function")
          throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        return Object.defineProperty(v, k, {
          value: v,
          enumerable: !1,
          writable: !1,
          configurable: !0
        }), v;
      }
      function v() {
        for (var F, K, _ = new Promise(function(z, P) {
          F = z, K = P;
        }), $ = [], j = 0; j < arguments.length; j++)
          $.push(arguments[j]);
        $.push(function(z, P) {
          z ? K(z) : F(P);
        });
        try {
          W.apply(this, $);
        } catch (z) {
          K(z);
        }
        return _;
      }
      return Object.setPrototypeOf(v, Object.getPrototypeOf(W)), k && Object.defineProperty(v, k, {
        value: v,
        enumerable: !1,
        writable: !1,
        configurable: !0
      }), Object.defineProperties(
        v,
        e(W)
      );
    }, t.promisify.custom = k;
    function O(W, v) {
      if (!W) {
        var F = new Error("Promise was rejected with a falsy value");
        F.reason = W, W = F;
      }
      return v(W);
    }
    function ee(W) {
      if (typeof W != "function")
        throw new TypeError('The "original" argument must be of type Function');
      function v() {
        for (var F = [], K = 0; K < arguments.length; K++)
          F.push(arguments[K]);
        var _ = F.pop();
        if (typeof _ != "function")
          throw new TypeError("The last argument must be of type Function");
        var $ = this, j = function() {
          return _.apply($, arguments);
        };
        W.apply(this, F).then(
          function(z) {
            ae.nextTick(j.bind(null, null, z));
          },
          function(z) {
            ae.nextTick(O.bind(null, z, j));
          }
        );
      }
      return Object.setPrototypeOf(v, Object.getPrototypeOf(W)), Object.defineProperties(
        v,
        e(W)
      ), v;
    }
    t.callbackify = ee;
  })(C1)), C1;
}
var to, bu;
function a2() {
  if (bu) return to;
  bu = 1;
  const { inherits: t, format: e } = ca();
  function n(i, s, r = Error) {
    if (!i) throw new Error("Avvio error code must not be empty");
    if (!s) throw new Error("Avvio base error message must not be empty");
    function o(l, a, c) {
      if (!new.target)
        return new o(l, a, c);
      Error.captureStackTrace(this, o), this.code = i, this.message = s, this.name = "AvvioError", l && a && c ? this.message = e(s, l, a, c) : l && a ? this.message = e(s, l, a) : l ? this.message = e(s, l) : this.message = s;
    }
    return o.prototype[Symbol.toStringTag] = "Error", o.prototype.toString = function() {
      return `${this.name} [${this.code}]: ${this.message}`;
    }, t(o, r), o;
  }
  return to = {
    createError: n,
    AVV_ERR_EXPOSE_ALREADY_DEFINED: n(
      "AVV_ERR_EXPOSE_ALREADY_DEFINED",
      "'%s' () is already defined, specify an expose option"
    ),
    AVV_ERR_CALLBACK_NOT_FN: n(
      "AVV_ERR_CALLBACK_NOT_FN",
      "Callback for '%s' hook is not a function. Received: '%s'"
    ),
    AVV_ERR_PLUGIN_NOT_VALID: n(
      "AVV_ERR_PLUGIN_NOT_VALID",
      "Plugin must be a function or a promise. Received: '%s'"
    ),
    AVV_ERR_ROOT_PLG_BOOTED: n(
      "AVV_ERR_PLUGIN_NOT_VALID",
      "Root plugin has already booted"
    ),
    AVV_ERR_PARENT_PLG_LOADED: n(
      "AVV_ERR_PARENT_PLG_LOADED",
      "Impossible to load '%s' plugin because the parent '%s' was already loaded"
    ),
    AVV_ERR_READY_TIMEOUT: n(
      "AVV_ERR_READY_TIMEOUT",
      "Plugin did not start in time: '%s'. You may have forgotten to call 'done' function or to resolve a Promise"
    )
  }, to;
}
var Au, Vu;
function l4() {
  return Vu || (Vu = 1, Au = function t(e, n, i) {
    n === void 0 && (n = ""), i || (i = {});
    var s = function(a) {
      var c = {
        "│": "|",
        "└": "`",
        "├": "+",
        "─": "-",
        "┬": "-"
      };
      return i.unicode === !1 ? c[a] : a;
    };
    typeof e == "string" && (e = { label: e });
    var r = e.nodes || [], o = (e.label || "").split(`
`), l = `
` + n + (r.length ? s("│") : " ") + " ";
    return n + o.join(l) + `
` + r.map(function(a, c) {
      var u = c === r.length - 1, h = a.nodes && a.nodes.length, d = n + (u ? " " : s("│")) + " ";
      return n + s(u ? "└" : "├") + s("─") + s(h ? "┬" : "─") + " " + t(a, d, i).slice(n.length + 2);
    }).join("");
  }), Au;
}
var no, Ru;
function a4() {
  if (Ru) return no;
  Ru = 1;
  const t = l4(), e = /* @__PURE__ */ Symbol("avvio.TimeTree.untrackNode"), n = /* @__PURE__ */ Symbol("avvio.TimeTree.trackNode"), i = /* @__PURE__ */ Symbol("avvio.TimeTree.getParent"), s = /* @__PURE__ */ Symbol("avvio.TimeTree.getNode"), r = /* @__PURE__ */ Symbol("avvio.TimeTree.addNode");
  class o {
    constructor() {
      this.root = null, this.tableId = /* @__PURE__ */ new Map(), this.tableLabel = /* @__PURE__ */ new Map();
    }
    [n](a) {
      this.tableId.set(a.id, a), this.tableLabel.has(a.label) ? this.tableLabel.get(a.label).push(a) : this.tableLabel.set(a.label, [a]);
    }
    [e](a) {
      this.tableId.delete(a.id);
      const c = this.tableLabel.get(a.label);
      if (c.id) {
        this.tableLabel.delete(a.label);
        return;
      }
      c.pop(), c.length === 0 && this.tableLabel.delete(a.label);
    }
    [i](a) {
      if (a === null)
        return this.root;
      const c = this.tableLabel.get(a);
      return c.id ? c : c[c.length - 1];
    }
    [s](a) {
      return this.tableId.get(a);
    }
    [r](a, c, u) {
      if (a === null)
        return this.root = {
          id: "root",
          label: c,
          start: u,
          nodes: []
        }, this[n](this.root), this.root.id;
      const h = this[i](a), d = `${c}-${Math.random()}`, m = {
        id: d,
        parent: a,
        start: u,
        label: c,
        nodes: []
      };
      return h.nodes.push(m), this[n](m), d;
    }
    start(a, c, u = Date.now()) {
      return this[r](a, c, u);
    }
    stop(a, c = Date.now()) {
      const u = this[s](a);
      u && (u.stop = c, u.diff = u.stop - u.start || 0, this[e](u));
    }
    toJSON() {
      return Object.assign({}, this.root);
    }
    prittyPrint() {
      const a = (u) => (u.label = `${u.label} ${u.diff} ms`, u.nodes.length > 0 && (u.nodes = u.nodes.map((h) => a(h))), u), c = a(this.toJSON());
      return t(c);
    }
  }
  return no = o, no;
}
var os = { exports: {} }, io = { exports: {} }, so, Eu;
function c4() {
  if (Eu) return so;
  Eu = 1;
  var t = 1e3, e = t * 60, n = e * 60, i = n * 24, s = i * 7, r = i * 365.25;
  so = function(u, h) {
    h = h || {};
    var d = typeof u;
    if (d === "string" && u.length > 0)
      return o(u);
    if (d === "number" && isFinite(u))
      return h.long ? a(u) : l(u);
    throw new Error(
      "val is not a non-empty string or a valid number. val=" + JSON.stringify(u)
    );
  };
  function o(u) {
    if (u = String(u), !(u.length > 100)) {
      var h = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(
        u
      );
      if (h) {
        var d = parseFloat(h[1]), m = (h[2] || "ms").toLowerCase();
        switch (m) {
          case "years":
          case "year":
          case "yrs":
          case "yr":
          case "y":
            return d * r;
          case "weeks":
          case "week":
          case "w":
            return d * s;
          case "days":
          case "day":
          case "d":
            return d * i;
          case "hours":
          case "hour":
          case "hrs":
          case "hr":
          case "h":
            return d * n;
          case "minutes":
          case "minute":
          case "mins":
          case "min":
          case "m":
            return d * e;
          case "seconds":
          case "second":
          case "secs":
          case "sec":
          case "s":
            return d * t;
          case "milliseconds":
          case "millisecond":
          case "msecs":
          case "msec":
          case "ms":
            return d;
          default:
            return;
        }
      }
    }
  }
  function l(u) {
    var h = Math.abs(u);
    return h >= i ? Math.round(u / i) + "d" : h >= n ? Math.round(u / n) + "h" : h >= e ? Math.round(u / e) + "m" : h >= t ? Math.round(u / t) + "s" : u + "ms";
  }
  function a(u) {
    var h = Math.abs(u);
    return h >= i ? c(u, h, i, "day") : h >= n ? c(u, h, n, "hour") : h >= e ? c(u, h, e, "minute") : h >= t ? c(u, h, t, "second") : u + " ms";
  }
  function c(u, h, d, m) {
    var p = h >= d * 1.5;
    return Math.round(u / d) + " " + m + (p ? "s" : "");
  }
  return so;
}
var ro, yu;
function u4() {
  if (yu) return ro;
  yu = 1;
  function t(e) {
    i.debug = i, i.default = i, i.coerce = c, i.disable = l, i.enable = r, i.enabled = a, i.humanize = c4(), i.destroy = u, Object.keys(e).forEach((h) => {
      i[h] = e[h];
    }), i.names = [], i.skips = [], i.formatters = {};
    function n(h) {
      let d = 0;
      for (let m = 0; m < h.length; m++)
        d = (d << 5) - d + h.charCodeAt(m), d |= 0;
      return i.colors[Math.abs(d) % i.colors.length];
    }
    i.selectColor = n;
    function i(h) {
      let d, m = null, p, g;
      function A(...b) {
        if (!A.enabled)
          return;
        const R = A, S = Number(/* @__PURE__ */ new Date()), E = S - (d || S);
        R.diff = E, R.prev = d, R.curr = S, d = S, b[0] = i.coerce(b[0]), typeof b[0] != "string" && b.unshift("%O");
        let Z = 0;
        b[0] = b[0].replace(/%([a-zA-Z%])/g, (G, T) => {
          if (G === "%%")
            return "%";
          Z++;
          const C = i.formatters[T];
          if (typeof C == "function") {
            const N = b[Z];
            G = C.call(R, N), b.splice(Z, 1), Z--;
          }
          return G;
        }), i.formatArgs.call(R, b), (R.log || i.log).apply(R, b);
      }
      return A.namespace = h, A.useColors = i.useColors(), A.color = i.selectColor(h), A.extend = s, A.destroy = i.destroy, Object.defineProperty(A, "enabled", {
        enumerable: !0,
        configurable: !1,
        get: () => m !== null ? m : (p !== i.namespaces && (p = i.namespaces, g = i.enabled(h)), g),
        set: (b) => {
          m = b;
        }
      }), typeof i.init == "function" && i.init(A), A;
    }
    function s(h, d) {
      const m = i(this.namespace + (typeof d > "u" ? ":" : d) + h);
      return m.log = this.log, m;
    }
    function r(h) {
      i.save(h), i.namespaces = h, i.names = [], i.skips = [];
      const d = (typeof h == "string" ? h : "").trim().replace(/\s+/g, ",").split(",").filter(Boolean);
      for (const m of d)
        m[0] === "-" ? i.skips.push(m.slice(1)) : i.names.push(m);
    }
    function o(h, d) {
      let m = 0, p = 0, g = -1, A = 0;
      for (; m < h.length; )
        if (p < d.length && (d[p] === h[m] || d[p] === "*"))
          d[p] === "*" ? (g = p, A = m, p++) : (m++, p++);
        else if (g !== -1)
          p = g + 1, A++, m = A;
        else
          return !1;
      for (; p < d.length && d[p] === "*"; )
        p++;
      return p === d.length;
    }
    function l() {
      const h = [
        ...i.names,
        ...i.skips.map((d) => "-" + d)
      ].join(",");
      return i.enable(""), h;
    }
    function a(h) {
      for (const d of i.skips)
        if (o(h, d))
          return !1;
      for (const d of i.names)
        if (o(h, d))
          return !0;
      return !1;
    }
    function c(h) {
      return h instanceof Error ? h.stack || h.message : h;
    }
    function u() {
      console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
    }
    return i.enable(i.load()), i;
  }
  return ro = t, ro;
}
var Cu;
function c2() {
  return Cu || (Cu = 1, (function(t, e) {
    e.formatArgs = i, e.save = s, e.load = r, e.useColors = n, e.storage = o(), e.destroy = /* @__PURE__ */ (() => {
      let a = !1;
      return () => {
        a || (a = !0, console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`."));
      };
    })(), e.colors = [
      "#0000CC",
      "#0000FF",
      "#0033CC",
      "#0033FF",
      "#0066CC",
      "#0066FF",
      "#0099CC",
      "#0099FF",
      "#00CC00",
      "#00CC33",
      "#00CC66",
      "#00CC99",
      "#00CCCC",
      "#00CCFF",
      "#3300CC",
      "#3300FF",
      "#3333CC",
      "#3333FF",
      "#3366CC",
      "#3366FF",
      "#3399CC",
      "#3399FF",
      "#33CC00",
      "#33CC33",
      "#33CC66",
      "#33CC99",
      "#33CCCC",
      "#33CCFF",
      "#6600CC",
      "#6600FF",
      "#6633CC",
      "#6633FF",
      "#66CC00",
      "#66CC33",
      "#9900CC",
      "#9900FF",
      "#9933CC",
      "#9933FF",
      "#99CC00",
      "#99CC33",
      "#CC0000",
      "#CC0033",
      "#CC0066",
      "#CC0099",
      "#CC00CC",
      "#CC00FF",
      "#CC3300",
      "#CC3333",
      "#CC3366",
      "#CC3399",
      "#CC33CC",
      "#CC33FF",
      "#CC6600",
      "#CC6633",
      "#CC9900",
      "#CC9933",
      "#CCCC00",
      "#CCCC33",
      "#FF0000",
      "#FF0033",
      "#FF0066",
      "#FF0099",
      "#FF00CC",
      "#FF00FF",
      "#FF3300",
      "#FF3333",
      "#FF3366",
      "#FF3399",
      "#FF33CC",
      "#FF33FF",
      "#FF6600",
      "#FF6633",
      "#FF9900",
      "#FF9933",
      "#FFCC00",
      "#FFCC33"
    ];
    function n() {
      if (typeof window < "u" && window.process && (window.process.type === "renderer" || window.process.__nwjs))
        return !0;
      if (typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/))
        return !1;
      let a;
      return typeof document < "u" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // Is firebug? http://stackoverflow.com/a/398120/376773
      typeof window < "u" && window.console && (window.console.firebug || window.console.exception && window.console.table) || // Is firefox >= v31?
      // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
      typeof navigator < "u" && navigator.userAgent && (a = navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/)) && parseInt(a[1], 10) >= 31 || // Double check webkit in userAgent just in case we are in a worker
      typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
    }
    function i(a) {
      if (a[0] = (this.useColors ? "%c" : "") + this.namespace + (this.useColors ? " %c" : " ") + a[0] + (this.useColors ? "%c " : " ") + "+" + t.exports.humanize(this.diff), !this.useColors)
        return;
      const c = "color: " + this.color;
      a.splice(1, 0, c, "color: inherit");
      let u = 0, h = 0;
      a[0].replace(/%[a-zA-Z%]/g, (d) => {
        d !== "%%" && (u++, d === "%c" && (h = u));
      }), a.splice(h, 0, c);
    }
    e.log = console.debug || console.log || (() => {
    });
    function s(a) {
      try {
        a ? e.storage.setItem("debug", a) : e.storage.removeItem("debug");
      } catch {
      }
    }
    function r() {
      let a;
      try {
        a = e.storage.getItem("debug") || e.storage.getItem("DEBUG");
      } catch {
      }
      return !a && typeof ae < "u" && "env" in ae && (a = ae.env.DEBUG), a;
    }
    function o() {
      try {
        return localStorage;
      } catch {
      }
    }
    t.exports = u4()(e);
    const { formatters: l } = t.exports;
    l.j = function(a) {
      try {
        return JSON.stringify(a);
      } catch (c) {
        return "[UnexpectedJSONParseError]: " + c.message;
      }
    };
  })(io, io.exports)), io.exports;
}
var Wu;
function h4() {
  if (Wu) return os.exports;
  Wu = 1;
  const t = n2(), e = i2().EventEmitter, n = ca().inherits, i = c2()("avvio"), { AVV_ERR_READY_TIMEOUT: s } = a2(), r = /* @__PURE__ */ Symbol.for("plugin-meta");
  function o(d, m) {
    return d[r] && d[r].name ? d[r].name : typeof m < "u" && typeof m != "function" && m.name ? m.name : d.name ? d.name : d.toString().split(`
`).slice(0, 2).map((p) => p.trim()).join(" -- ");
  }
  function l() {
    const d = {};
    return d.promise = new Promise((m, p) => {
      d.resolve = m, d.reject = p;
    }), d;
  }
  function a(d, m, p, g, A) {
    this.started = !1, this.func = m, this.opts = p, this.onFinish = null, this.parent = d, this.timeout = A === void 0 ? d._timeout : A, this.name = o(m, p), this.isAfter = g, this.q = t(d, c, 1), this.q.pause(), this._error = null, this.loaded = !1, this._promise = null;
  }
  n(a, e), a.prototype.exec = function(d, m) {
    const p = this.func;
    let g = !1;
    const A = this.name;
    if (this.parent._error && !this.isAfter) {
      i("skipping loading of plugin as parent errored and it is not an after", A), ae.nextTick(m);
      return;
    }
    if (this.isAfter)
      this.server = d;
    else
      try {
        this.server = this.parent.override(d, p, this.opts);
      } catch (E) {
        return i("override errored", A), m(E);
      }
    this.opts = typeof this.opts == "function" ? this.opts(this.server) : this.opts, i("exec", A);
    let b;
    const R = (E) => {
      if (g) {
        i("loading complete", A);
        return;
      }
      this._error = E, i(E ? "exec errored" : "exec completed", A), g = !0, b && clearTimeout(b), m(E);
    };
    this.timeout > 0 && (i("setting up timeout", A, this.timeout), b = setTimeout(function() {
      i("timed out", A), b = null;
      const E = new s(A);
      E.fn = p, R(E);
    }, this.timeout)), this.started = !0, this.emit("start", this.server ? this.server.name : null, this.name, Date.now());
    const S = p(this.server, this.opts, R);
    S && typeof S.then == "function" && (i("exec: resolving promise", A), S.then(
      () => ae.nextTick(R),
      (E) => ae.nextTick(R, E)
    ));
  }, a.prototype.loadedSoFar = function() {
    if (this.loaded)
      return Promise.resolve();
    const d = () => {
      this.server.after((p, g) => {
        this._error = p, this.q.pause(), p ? (i("rejecting promise", this.name, p), this._promise.reject(p)) : (i("resolving promise", this.name), this._promise.resolve()), this._promise = null, ae.nextTick(g, p);
      }), this.q.resume();
    };
    let m;
    return this._promise ? m = Promise.resolve() : (this._promise = l(), m = this._promise.promise, this.server ? d() : this.on("start", d)), m;
  }, a.prototype.enqueue = function(d, m) {
    i("enqueue", this.name, d.name), this.emit("enqueue", this.server ? this.server.name : null, this.name, Date.now()), this.q.push(d, m);
  }, a.prototype.finish = function(d, m) {
    i("finish", this.name, d);
    const p = () => {
      this.loaded || (i("loaded", this.name), this.emit("loaded", this.server ? this.server.name : null, this.name, Date.now()), this.loaded = !0, m(d));
    };
    if (d) {
      this._promise && (this._promise.reject(d), this._promise = null), p();
      return;
    }
    const g = () => {
      if (i("check", this.name, this.q.length(), this.q.running(), this._promise), this.q.length() === 0 && this.q.running() === 0)
        if (this._promise) {
          const A = () => {
            i("wrap"), queueMicrotask(g);
          };
          this._promise.resolve(), this._promise.promise.then(A, A), this._promise = null;
        } else
          p();
      else
        i("delayed", this.name), this.q.drain = () => {
          i("drain", this.name), this.q.drain = h, queueMicrotask(g);
        };
    };
    queueMicrotask(g), this.q.resume();
  };
  function c(d, m) {
    const p = this;
    ae.nextTick(u.bind(p), d, m);
  }
  function u(d, m) {
    if (typeof d.func.then == "function") {
      d.func.then((g) => {
        typeof g.default == "function" && (g = g.default), d.func = g, u.call(this, d, m);
      }, m);
      return;
    }
    const p = this._current[0];
    this._current.unshift(d), d.exec(p && p.server || this._server, (g) => {
      d.finish(g, (A) => {
        this._current.shift(), m(A);
      });
    });
  }
  function h() {
  }
  return os.exports = a, os.exports.loadPlugin = u, os.exports;
}
var Su;
function d4() {
  if (Su) return is.exports;
  Su = 1;
  const t = n2(), e = i2().EventEmitter, n = ca().inherits, {
    AVV_ERR_EXPOSE_ALREADY_DEFINED: i,
    AVV_ERR_CALLBACK_NOT_FN: s,
    AVV_ERR_PLUGIN_NOT_VALID: r,
    AVV_ERR_ROOT_PLG_BOOTED: o,
    AVV_ERR_READY_TIMEOUT: l
  } = a2(), a = a4(), c = h4(), u = c2()("avvio"), h = /* @__PURE__ */ Symbol("kAvvio"), d = /* @__PURE__ */ Symbol("kThenifyDoNotWrap");
  function m(C, N, Y) {
    const L = N.expose || {}, w = L.use || "use", D = L.after || "after", ie = L.ready || "ready", X = L.onClose || "onClose", Q = L.close || "close";
    if (C[w])
      throw new i(w);
    if (C[D])
      throw new i(D);
    if (C[ie])
      throw new i(ie);
    C[w] = function(J, q) {
      return Y.use(J, q), this;
    }, Object.defineProperty(C, "then", { get: R.bind(Y) }), C[h] = !0, C[D] = function(J) {
      return typeof J != "function" ? Y._loadRegistered() : (Y.after(T(J, this)), this);
    }, C[ie] = function(J) {
      if (J && typeof J != "function")
        throw new s(ie, typeof J);
      return Y.ready(J ? T(J, this) : void 0);
    }, C[X] = function(J) {
      if (typeof J != "function")
        throw new s(X, typeof J);
      return Y.onClose(G(J, this)), this;
    }, C[Q] = function(J) {
      if (J && typeof J != "function")
        throw new s(Q, typeof J);
      return J ? (Y.close(T(J, this)), this) : Y.close();
    };
  }
  function p(C, N, Y) {
    if (typeof C == "function" && arguments.length === 1 && (Y = C, N = {}, C = null), typeof N == "function" && (Y = N, N = {}), N = N || {}, !(this instanceof p)) {
      const L = new p(C, N, Y);
      return C && m(C, N, L), L;
    }
    N.autostart !== !1 && (N.autostart = !0), C = C || this, this._timeout = Number(N.timeout) || 0, this._server = C, this._current = [], this._error = null, this._isOnCloseHandlerKey = /* @__PURE__ */ Symbol("isOnCloseHandler"), this._lastUsed = null, this.setMaxListeners(0), Y && this.once("start", Y), this.started = !1, this.booted = !1, this.pluginTree = new a(), this._readyQ = t(this, S, 1), this._readyQ.pause(), this._readyQ.drain = () => {
      this.emit("start"), this._readyQ.drain = b;
    }, this._closeQ = t(this, Z, 1), this._closeQ.pause(), this._closeQ.drain = () => {
      this.emit("close"), this._closeQ.drain = b;
    }, this._doStart = null, this._root = new c(this, g.bind(this), N, !1, 0), this._root.once("start", (L, w, D) => {
      const ie = this.pluginTree.start(null, w, D);
      this._root.once("loaded", (X, Q, J) => {
        this.pluginTree.stop(ie, J);
      });
    }), c.loadPlugin.call(this, this._root, (L) => {
      u("root plugin ready");
      try {
        this.emit("preReady"), this._root = null;
      } catch (w) {
        L = L || this._error || w;
      }
      if (L) {
        if (this._error = L, this._readyQ.length() === 0)
          throw L;
      } else
        this.booted = !0;
      this._readyQ.resume();
    });
  }
  function g(C, N, Y) {
    this._doStart = Y, N.autostart && this.start();
  }
  n(p, e), p.prototype.start = function() {
    return this.started = !0, ae.nextTick(this._doStart), this;
  }, p.prototype.override = function(C, N, Y) {
    return C;
  };
  function A(C) {
    if (C && typeof C == "object" && typeof C.default == "function" && (C = C.default), !(C && (typeof C == "function" || typeof C.then == "function")))
      throw new r(typeof C);
    return C;
  }
  p.prototype[h] = !0, p.prototype.use = function(C, N) {
    return this._lastUsed = this._addPlugin(C, N, !1), this;
  }, p.prototype._loadRegistered = function() {
    const C = this._current[0];
    return !this.started && !this.booted && ae.nextTick(() => this._root.q.resume()), C ? C.loadedSoFar() : Promise.resolve();
  }, Object.defineProperty(p.prototype, "then", { get: R }), p.prototype._addPlugin = function(C, N, Y) {
    if (C = A(C), N = N || {}, this.booted)
      throw new o();
    const L = this._current[0], w = new c(this, C, N, Y);
    if (w.once("start", (D, ie, X) => {
      const Q = this.pluginTree.start(L.name, ie, X);
      w.once("loaded", (J, q, k) => {
        this.pluginTree.stop(Q, k);
      });
    }), L.loaded)
      throw new Error(w.name, L.name);
    return L.enqueue(w, (D) => {
      D && (this._error = D);
    }), w;
  }, p.prototype.after = function(C) {
    if (!C)
      return this._loadRegistered();
    this._addPlugin(N.bind(this), {}, !0);
    function N(Y, L, w) {
      S.call(this, C, w);
    }
    return this;
  }, p.prototype.onClose = function(C) {
    if (typeof C != "function")
      throw new Error("not a function");
    C[this._isOnCloseHandlerKey] = !0, this._closeQ.unshift(C, N.bind(this));
    function N(Y) {
      Y && (this._error = Y);
    }
    return this;
  }, p.prototype.close = function(C) {
    let N;
    if (C) {
      if (typeof C != "function")
        throw new s("close", typeof C);
    } else
      N = new Promise(function(Y, L) {
        C = function(w) {
          if (w)
            return L(w);
          Y();
        };
      });
    return this.ready(() => {
      this._error = null, this._closeQ.push(C), ae.nextTick(this._closeQ.resume.bind(this._closeQ));
    }), N;
  }, p.prototype.ready = function(C) {
    if (C) {
      if (typeof C != "function")
        throw new s("ready", typeof C);
      this._readyQ.push(C), queueMicrotask(this.start.bind(this));
      return;
    }
    return new Promise((N, Y) => {
      this._readyQ.push(w), this.start();
      const L = this._current[0].server;
      function w(D, ie, X) {
        D ? Y(D) : N(L), ae.nextTick(X);
      }
    });
  }, p.prototype.prettyPrint = function() {
    return this.pluginTree.prittyPrint();
  }, p.prototype.toJSON = function() {
    return this.pluginTree.toJSON();
  };
  function b() {
  }
  function R() {
    if (this.booted) {
      u("thenify returning null because we are already booted");
      return;
    }
    if (this[d]) {
      this[d] = !1;
      return;
    }
    return u("thenify"), (C, N) => this._loadRegistered().then(() => (this[d] = !0, C(this._server)), N);
  }
  function S(C, N) {
    const Y = this._server, L = this._error;
    let w;
    if (this._error = null, C.length === 0)
      this._error = L, w = C(), w && !w[h] && typeof w.then == "function" ? w.then(() => ae.nextTick(N), (D) => ae.nextTick(N, D)) : ae.nextTick(N);
    else if (C.length === 1)
      w = C(L), w && !w[h] && typeof w.then == "function" ? w.then(() => ae.nextTick(N), (D) => ae.nextTick(N, D)) : ae.nextTick(N);
    else if (this._timeout === 0) {
      const D = (ie) => {
        this._error = ie, N(this._error);
      };
      C.length === 2 ? C(L, D) : C(L, Y, D);
    } else
      E.call(this, C, L, Y, N);
  }
  function E(C, N, Y, L) {
    const w = C.name;
    u("setting up ready timeout", w, this._timeout);
    let D = setTimeout(() => {
      u("timed out", w), D = null;
      const X = new l(w);
      X.fn = C, this._error = X, L(X);
    }, this._timeout);
    C.length === 2 ? C(N, ie.bind(this)) : C(N, Y, ie.bind(this));
    function ie(X) {
      D && (clearTimeout(D), this._error = X, L(this._error));
    }
  }
  function Z(C, N) {
    const Y = this._server, L = C[this._isOnCloseHandlerKey];
    if (C.length === 0 || C.length === 1) {
      let w;
      L ? w = C(Y) : w = C(this._error), w && typeof w.then == "function" ? (u("resolving close/onClose promise"), w.then(
        () => ae.nextTick(N),
        (D) => ae.nextTick(N, D)
      )) : ae.nextTick(N);
    } else C.length === 2 ? C(L ? Y : this._error, N) : L ? C(Y, N) : C(this._error, Y, N);
  }
  function G(C, N) {
    return Y.bind(N);
    function Y(L, w) {
      let D;
      C.length === 0 ? (D = C(), D && D.then ? D.then(function() {
        ae.nextTick(w);
      }, w) : ae.nextTick(w)) : C.length === 1 ? (D = C(this), D && D.then ? D.then(function() {
        ae.nextTick(w);
      }, w) : ae.nextTick(w)) : C(this, w);
    }
  }
  function T(C, N) {
    return Y.bind(N);
    function Y(L, w) {
      let D;
      C ? C.length === 0 ? (D = C(), D && D.then ? D.then(function() {
        ae.nextTick(w, L);
      }, w) : ae.nextTick(w, L)) : C.length === 1 ? (D = C(L), D && D.then ? D.then(function() {
        ae.nextTick(w);
      }, w) : ae.nextTick(w)) : C.length === 2 ? C(L, w) : C(L, this, w) : ae.nextTick(w);
    }
  }
  return is.exports = p, is.exports.express = function(C) {
    return p(C, {
      expose: {
        use: "load"
      }
    });
  }, is.exports;
}
var m4 = d4();
const p4 = /* @__PURE__ */ Tb(m4);
(function() {
  if (window.requestAnimationFrame && window.cancelAnimationFrame)
    return;
  const t = ["webkit", "moz", "ms", "o"];
  for (const e of t)
    window.requestAnimationFrame = window.requestAnimationFrame || window[`${e}RequestAnimationFrame`], window.cancelAnimationFrame = window.cancelAnimationFrame || window[`${e}CancelAnimationFrame`] || window[`${e}CancelRequestAnimationFrame`];
  if (/iP(ad|hone|od).*OS 6/.test(window.navigator.userAgent) || !window.requestAnimationFrame || !window.cancelAnimationFrame) {
    let e = 0;
    const n = !!(window.performance && window.performance.now);
    window.requestAnimationFrame = function(i) {
      const s = n ? window.performance.now() : (/* @__PURE__ */ new Date()).getTime(), r = Math.max(0, 16 - (s - e)), o = window.setTimeout(function() {
        i(s + r);
      }, r);
      return e = s + r, o;
    }, window.cancelAnimationFrame = clearTimeout;
  }
})();
function g4(t, e = !0, n = !0, i = { friendsTab: "enabled" }) {
  const s = e ? "https://grpc-sdk.streamlayer.io:443" : "https://grpc-sdk.next.streamlayer.io:443", r = e ? "https://grpc.streamlayer.io:443" : "https://grpc.next.streamlayer.io:443", o = p4(/* @__PURE__ */ Object.create({}), { autostart: !1 });
  return o.use(Mf, {
    hideFriends: i.hideFriends,
    skipOnboarding: i.skipOnboarding,
    betPack: i.betPack,
    friendsTab: i.friendsTab,
    theme: i.theme,
    themeMode: i.themeMode
  }), o.use(wf, { onDeepLinkHandled: i?.onDeepLinkHandled }), o.use(kf, { videoPlayerController: i?.videoPlayerController }), o.use(xf, {
    onContentActivate: i?.onContentActivate,
    withAd: i?.withAd,
    withAdNotification: i?.withAdNotification
  }), o.use($g, { sdkKey: t, host: s, analyticsHost: r, version: i?.version, webOS: i?.webOS }), o.use(sf), o.use(Lf), i?.gamification !== !1 && (o.use(qf), o.use(Zf), o.use(ib)), o.use(Yb), o.use(Sb), o.after((l, a, c) => {
    if (l)
      throw l;
    a.ready(), c();
  }), n && o.after(async (l, a, c) => {
    if (l)
      throw l;
    await a.sdk.initializeApp(), c();
  }), o.onClose(() => {
    console.log("close StreamLayer instance");
  }), o;
}
function f4(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var u2 = { exports: {} }, ke = u2.exports = {}, It, Nt;
function ml() {
  throw new Error("setTimeout has not been defined");
}
function pl() {
  throw new Error("clearTimeout has not been defined");
}
(function() {
  try {
    typeof setTimeout == "function" ? It = setTimeout : It = ml;
  } catch {
    It = ml;
  }
  try {
    typeof clearTimeout == "function" ? Nt = clearTimeout : Nt = pl;
  } catch {
    Nt = pl;
  }
})();
function h2(t) {
  if (It === setTimeout)
    return setTimeout(t, 0);
  if ((It === ml || !It) && setTimeout)
    return It = setTimeout, setTimeout(t, 0);
  try {
    return It(t, 0);
  } catch {
    try {
      return It.call(null, t, 0);
    } catch {
      return It.call(this, t, 0);
    }
  }
}
function b4(t) {
  if (Nt === clearTimeout)
    return clearTimeout(t);
  if ((Nt === pl || !Nt) && clearTimeout)
    return Nt = clearTimeout, clearTimeout(t);
  try {
    return Nt(t);
  } catch {
    try {
      return Nt.call(null, t);
    } catch {
      return Nt.call(this, t);
    }
  }
}
var Ht = [], jn = !1, En, Ss = -1;
function A4() {
  !jn || !En || (jn = !1, En.length ? Ht = En.concat(Ht) : Ss = -1, Ht.length && d2());
}
function d2() {
  if (!jn) {
    var t = h2(A4);
    jn = !0;
    for (var e = Ht.length; e; ) {
      for (En = Ht, Ht = []; ++Ss < e; )
        En && En[Ss].run();
      Ss = -1, e = Ht.length;
    }
    En = null, jn = !1, b4(t);
  }
}
ke.nextTick = function(t) {
  var e = new Array(arguments.length - 1);
  if (arguments.length > 1)
    for (var n = 1; n < arguments.length; n++)
      e[n - 1] = arguments[n];
  Ht.push(new m2(t, e)), Ht.length === 1 && !jn && h2(d2);
};
function m2(t, e) {
  this.fun = t, this.array = e;
}
m2.prototype.run = function() {
  this.fun.apply(null, this.array);
};
ke.title = "browser";
ke.browser = !0;
ke.env = {};
ke.argv = [];
ke.version = "";
ke.versions = {};
function qt() {
}
ke.on = qt;
ke.addListener = qt;
ke.once = qt;
ke.off = qt;
ke.removeListener = qt;
ke.removeAllListeners = qt;
ke.emit = qt;
ke.prependListener = qt;
ke.prependOnceListener = qt;
ke.listeners = function(t) {
  return [];
};
ke.binding = function(t) {
  throw new Error("process.binding is not supported");
};
ke.cwd = function() {
  return "/";
};
ke.chdir = function(t) {
  throw new Error("process.chdir is not supported");
};
ke.umask = function() {
  return 0;
};
var V4 = u2.exports;
const R4 = /* @__PURE__ */ f4(V4), E4 = ({
  sdkKey: t,
  plugins: e,
  production: n,
  autoEnable: i,
  onDeepLinkHandled: s,
  videoPlayerController: r,
  onContentActivate: o,
  hideFriends: l,
  skipOnboarding: a,
  withAdNotification: c,
  withAd: u,
  friendsTab: h,
  betPack: d,
  webOS: m,
  gamification: p
}) => {
  const [g, A] = re(null);
  return te(() => {
    let b = !1;
    if (!t)
      return console.error("streamlayer sdk key should be provided"), A((S) => (S !== null && typeof S.disableApp == "function" && S.disableApp(), null)), () => {
        b = !0;
      };
    const R = g4(t, n, i, {
      version: R4.env.APP_VERSION,
      onDeepLinkHandled: s,
      videoPlayerController: r,
      onContentActivate: o,
      skipOnboarding: a,
      withAdNotification: c,
      withAd: u,
      hideFriends: l,
      friendsTab: h,
      betPack: d,
      webOS: m,
      gamification: p
    });
    if (e)
      for (const S of e)
        R.use(S);
    return R.ready().then((S) => {
      b || A(S.sdk);
    }).catch((S) => console.log(S)), () => {
      b = !0, R.close(function(S) {
        if (S) throw S;
      });
    };
  }, [t, n]), g;
}, y4 = ({
  event: t,
  internal: e
}) => {
  const n = Qi(), i = S4();
  return te(() => {
    n && (t && (n.createEventSession(t, e), i && (i.current = t)), !t && i?.current && (n.createEventSession("", e), i.current = ""));
  }, [t, e, i, n]), null;
}, C4 = {
  status: 0,
  sdk: null
}, Mi = pd(C4), W4 = ({
  sdkKey: t,
  theme: e,
  themeMode: n,
  plugins: i,
  children: s,
  event: r,
  production: o = !0,
  autoEnable: l = !0,
  withAdNotification: a,
  withAd: c = !0,
  betPack: u = !1,
  hideFriends: h,
  skipOnboarding: d,
  friendsTab: m = "enabled",
  onDeepLinkHandled: p,
  videoPlayerController: g,
  onContentActivate: A,
  containerId: b,
  webOS: R,
  gamification: S
}) => {
  const E = E4({
    sdkKey: t,
    plugins: i,
    production: o,
    autoEnable: l,
    onDeepLinkHandled: p,
    videoPlayerController: g,
    onContentActivate: A,
    hideFriends: h,
    skipOnboarding: d,
    withAdNotification: a,
    withAd: c,
    friendsTab: m,
    betPack: u,
    webOS: R,
    gamification: S
  }), Z = Ee(""), G = gt(() => E ? { sdk: E, status: 2, event: Z } : { status: 1, sdk: null, event: Z }, [E]);
  return te(() => {
    E && (E.options.setKey("friendsTab", m), E.options.setKey("theme", e), E.options.setKey("themeMode", n), E.options.setKey("skipOnboarding", d), E.options.setKey("betPack", u), E.options.setKey("containerId", b));
  }, [E, m, e, n, d, u, b]), te(() => () => {
    p && E?.removeDeepLinkHandler(p), g && E?.removeVideoPlayerController(g);
  }, [E]), te(() => {
    localStorage.getItem("SL_DEBUG") && console.log("StreamLayerProvider mounted with props:", {
      sdkKey: !!t,
      onDeepLinkHandled: !!p,
      videoPlayerController: !!g
    });
  }, [t, p, g]), /* @__PURE__ */ U(Mi.Provider, { value: G, children: [
    r !== void 0 && /* @__PURE__ */ f(y4, { event: r }),
    s
  ] });
}, Qi = () => {
  const { sdk: t } = wi(Mi);
  return t;
}, S4 = () => {
  const { event: t } = wi(Mi);
  return t;
}, ua = () => {
  const { sdk: t } = wi(Mi), [e, n] = re({});
  return te(() => t?.options ? t?.options?.subscribe((i) => {
    n({ theme: i.theme, themeMode: i.themeMode });
  }) : () => {
  }, [t?.options]), e;
}, Z4 = () => {
  const { sdk: t } = wi(Mi), [e, n] = re({});
  return te(() => t?.uiState ? t?.uiState.subscribe((i) => {
    n({ ...i });
  }) : () => {
  }, [t?.uiState]), e;
};
function Re(t) {
  var e = t.width, n = t.height;
  if (e < 0)
    throw new Error("Negative width is not allowed for Size");
  if (n < 0)
    throw new Error("Negative height is not allowed for Size");
  return {
    width: e,
    height: n
  };
}
function Cn(t, e) {
  return t.width === e.width && t.height === e.height;
}
var v4 = (
  /** @class */
  (function() {
    function t(e) {
      var n = this;
      this._resolutionListener = function() {
        return n._onResolutionChanged();
      }, this._resolutionMediaQueryList = null, this._observers = [], this._window = e, this._installResolutionListener();
    }
    return t.prototype.dispose = function() {
      this._uninstallResolutionListener(), this._window = null;
    }, Object.defineProperty(t.prototype, "value", {
      get: function() {
        return this._window.devicePixelRatio;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.subscribe = function(e) {
      var n = this, i = { next: e };
      return this._observers.push(i), {
        unsubscribe: function() {
          n._observers = n._observers.filter(function(s) {
            return s !== i;
          });
        }
      };
    }, t.prototype._installResolutionListener = function() {
      if (this._resolutionMediaQueryList !== null)
        throw new Error("Resolution listener is already installed");
      var e = this._window.devicePixelRatio;
      this._resolutionMediaQueryList = this._window.matchMedia("all and (resolution: ".concat(e, "dppx)")), this._resolutionMediaQueryList.addListener(this._resolutionListener);
    }, t.prototype._uninstallResolutionListener = function() {
      this._resolutionMediaQueryList !== null && (this._resolutionMediaQueryList.removeListener(this._resolutionListener), this._resolutionMediaQueryList = null);
    }, t.prototype._reinstallResolutionListener = function() {
      this._uninstallResolutionListener(), this._installResolutionListener();
    }, t.prototype._onResolutionChanged = function() {
      var e = this;
      this._observers.forEach(function(n) {
        return n.next(e._window.devicePixelRatio);
      }), this._reinstallResolutionListener();
    }, t;
  })()
);
function I4(t) {
  return new v4(t);
}
var N4 = (
  /** @class */
  (function() {
    function t(e, n, i) {
      var s;
      this._canvasElement = null, this._bitmapSizeChangedListeners = [], this._suggestedBitmapSize = null, this._suggestedBitmapSizeChangedListeners = [], this._devicePixelRatioObservable = null, this._canvasElementResizeObserver = null, this._canvasElement = e, this._canvasElementClientSize = Re({
        width: this._canvasElement.clientWidth,
        height: this._canvasElement.clientHeight
      }), this._transformBitmapSize = n ?? (function(r) {
        return r;
      }), this._allowResizeObserver = (s = i?.allowResizeObserver) !== null && s !== void 0 ? s : !0, this._chooseAndInitObserver();
    }
    return t.prototype.dispose = function() {
      var e, n;
      if (this._canvasElement === null)
        throw new Error("Object is disposed");
      (e = this._canvasElementResizeObserver) === null || e === void 0 || e.disconnect(), this._canvasElementResizeObserver = null, (n = this._devicePixelRatioObservable) === null || n === void 0 || n.dispose(), this._devicePixelRatioObservable = null, this._suggestedBitmapSizeChangedListeners.length = 0, this._bitmapSizeChangedListeners.length = 0, this._canvasElement = null;
    }, Object.defineProperty(t.prototype, "canvasElement", {
      get: function() {
        if (this._canvasElement === null)
          throw new Error("Object is disposed");
        return this._canvasElement;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "canvasElementClientSize", {
      get: function() {
        return this._canvasElementClientSize;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "bitmapSize", {
      get: function() {
        return Re({
          width: this.canvasElement.width,
          height: this.canvasElement.height
        });
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.resizeCanvasElement = function(e) {
      this._canvasElementClientSize = Re(e), this.canvasElement.style.width = "".concat(this._canvasElementClientSize.width, "px"), this.canvasElement.style.height = "".concat(this._canvasElementClientSize.height, "px"), this._invalidateBitmapSize();
    }, t.prototype.subscribeBitmapSizeChanged = function(e) {
      this._bitmapSizeChangedListeners.push(e);
    }, t.prototype.unsubscribeBitmapSizeChanged = function(e) {
      this._bitmapSizeChangedListeners = this._bitmapSizeChangedListeners.filter(function(n) {
        return n !== e;
      });
    }, Object.defineProperty(t.prototype, "suggestedBitmapSize", {
      get: function() {
        return this._suggestedBitmapSize;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.subscribeSuggestedBitmapSizeChanged = function(e) {
      this._suggestedBitmapSizeChangedListeners.push(e);
    }, t.prototype.unsubscribeSuggestedBitmapSizeChanged = function(e) {
      this._suggestedBitmapSizeChangedListeners = this._suggestedBitmapSizeChangedListeners.filter(function(n) {
        return n !== e;
      });
    }, t.prototype.applySuggestedBitmapSize = function() {
      if (this._suggestedBitmapSize !== null) {
        var e = this._suggestedBitmapSize;
        this._suggestedBitmapSize = null, this._resizeBitmap(e), this._emitSuggestedBitmapSizeChanged(e, this._suggestedBitmapSize);
      }
    }, t.prototype._resizeBitmap = function(e) {
      var n = this.bitmapSize;
      Cn(n, e) || (this.canvasElement.width = e.width, this.canvasElement.height = e.height, this._emitBitmapSizeChanged(n, e));
    }, t.prototype._emitBitmapSizeChanged = function(e, n) {
      var i = this;
      this._bitmapSizeChangedListeners.forEach(function(s) {
        return s.call(i, e, n);
      });
    }, t.prototype._suggestNewBitmapSize = function(e) {
      var n = this._suggestedBitmapSize, i = Re(this._transformBitmapSize(e, this._canvasElementClientSize)), s = Cn(this.bitmapSize, i) ? null : i;
      n === null && s === null || n !== null && s !== null && Cn(n, s) || (this._suggestedBitmapSize = s, this._emitSuggestedBitmapSizeChanged(n, s));
    }, t.prototype._emitSuggestedBitmapSizeChanged = function(e, n) {
      var i = this;
      this._suggestedBitmapSizeChangedListeners.forEach(function(s) {
        return s.call(i, e, n);
      });
    }, t.prototype._chooseAndInitObserver = function() {
      var e = this;
      if (!this._allowResizeObserver) {
        this._initDevicePixelRatioObservable();
        return;
      }
      G4().then(function(n) {
        return n ? e._initResizeObserver() : e._initDevicePixelRatioObservable();
      });
    }, t.prototype._initDevicePixelRatioObservable = function() {
      var e = this;
      if (this._canvasElement !== null) {
        var n = Zu(this._canvasElement);
        if (n === null)
          throw new Error("No window is associated with the canvas");
        this._devicePixelRatioObservable = I4(n), this._devicePixelRatioObservable.subscribe(function() {
          return e._invalidateBitmapSize();
        }), this._invalidateBitmapSize();
      }
    }, t.prototype._invalidateBitmapSize = function() {
      var e, n;
      if (this._canvasElement !== null) {
        var i = Zu(this._canvasElement);
        if (i !== null) {
          var s = (n = (e = this._devicePixelRatioObservable) === null || e === void 0 ? void 0 : e.value) !== null && n !== void 0 ? n : i.devicePixelRatio, r = this._canvasElement.getClientRects(), o = (
            // eslint-disable-next-line no-negated-condition
            r[0] !== void 0 ? X4(r[0], s) : Re({
              width: this._canvasElementClientSize.width * s,
              height: this._canvasElementClientSize.height * s
            })
          );
          this._suggestNewBitmapSize(o);
        }
      }
    }, t.prototype._initResizeObserver = function() {
      var e = this;
      this._canvasElement !== null && (this._canvasElementResizeObserver = new ResizeObserver(function(n) {
        var i = n.find(function(o) {
          return o.target === e._canvasElement;
        });
        if (!(!i || !i.devicePixelContentBoxSize || !i.devicePixelContentBoxSize[0])) {
          var s = i.devicePixelContentBoxSize[0], r = Re({
            width: s.inlineSize,
            height: s.blockSize
          });
          e._suggestNewBitmapSize(r);
        }
      }), this._canvasElementResizeObserver.observe(this._canvasElement, { box: "device-pixel-content-box" }));
    }, t;
  })()
);
function F4(t, e) {
  return new N4(t, e.transform, e.options);
}
function Zu(t) {
  return t.ownerDocument.defaultView;
}
function G4() {
  return new Promise(function(t) {
    var e = new ResizeObserver(function(n) {
      t(n.every(function(i) {
        return "devicePixelContentBoxSize" in i;
      })), e.disconnect();
    });
    e.observe(document.body, { box: "device-pixel-content-box" });
  }).catch(function() {
    return !1;
  });
}
function X4(t, e) {
  return Re({
    width: Math.round(t.left * e + t.width * e) - Math.round(t.left * e),
    height: Math.round(t.top * e + t.height * e) - Math.round(t.top * e)
  });
}
var U4 = (
  /** @class */
  (function() {
    function t(e, n, i) {
      if (n.width === 0 || n.height === 0)
        throw new TypeError("Rendering target could only be created on a media with positive width and height");
      if (this._mediaSize = n, i.width === 0 || i.height === 0)
        throw new TypeError("Rendering target could only be created using a bitmap with positive integer width and height");
      this._bitmapSize = i, this._context = e;
    }
    return t.prototype.useMediaCoordinateSpace = function(e) {
      try {
        return this._context.save(), this._context.setTransform(1, 0, 0, 1, 0, 0), this._context.scale(this._horizontalPixelRatio, this._verticalPixelRatio), e({
          context: this._context,
          mediaSize: this._mediaSize
        });
      } finally {
        this._context.restore();
      }
    }, t.prototype.useBitmapCoordinateSpace = function(e) {
      try {
        return this._context.save(), this._context.setTransform(1, 0, 0, 1, 0, 0), e({
          context: this._context,
          mediaSize: this._mediaSize,
          bitmapSize: this._bitmapSize,
          horizontalPixelRatio: this._horizontalPixelRatio,
          verticalPixelRatio: this._verticalPixelRatio
        });
      } finally {
        this._context.restore();
      }
    }, Object.defineProperty(t.prototype, "_horizontalPixelRatio", {
      get: function() {
        return this._bitmapSize.width / this._mediaSize.width;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "_verticalPixelRatio", {
      get: function() {
        return this._bitmapSize.height / this._mediaSize.height;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  })()
);
function Zn(t, e) {
  var n = t.canvasElementClientSize;
  if (n.width === 0 || n.height === 0)
    return null;
  var i = t.bitmapSize;
  if (i.width === 0 || i.height === 0)
    return null;
  var s = t.canvasElement.getContext("2d", e);
  return s === null ? null : new U4(s, n, i);
}
const p2 = { title: "", visible: !0, lastValueVisible: !0, priceLineVisible: !0, priceLineSource: 0, priceLineWidth: 1, priceLineColor: "", priceLineStyle: 2, baseLineVisible: !0, baseLineWidth: 1, baseLineColor: "#B2B5BE", baseLineStyle: 0, priceFormat: { type: "price", precision: 2, minMove: 0.01 } };
var vu, gl;
function vn(t, e) {
  const n = { 0: [], 1: [t.lineWidth, t.lineWidth], 2: [2 * t.lineWidth, 2 * t.lineWidth], 3: [6 * t.lineWidth, 6 * t.lineWidth], 4: [t.lineWidth, 4 * t.lineWidth] }[e];
  t.setLineDash(n);
}
function g2(t, e, n, i) {
  t.beginPath();
  const s = t.lineWidth % 2 ? 0.5 : 0;
  t.moveTo(n, e + s), t.lineTo(i, e + s), t.stroke();
}
function Ke(t, e) {
  if (!t) throw new Error("Assertion failed" + (e ? ": " + e : ""));
}
function $e(t) {
  if (t === void 0) throw new Error("Value is undefined");
  return t;
}
function H(t) {
  if (t === null) throw new Error("Value is null");
  return t;
}
function an(t) {
  return H($e(t));
}
(function(t) {
  t[t.Simple = 0] = "Simple", t[t.WithSteps = 1] = "WithSteps", t[t.Curved = 2] = "Curved";
})(vu || (vu = {})), (function(t) {
  t[t.Solid = 0] = "Solid", t[t.Dotted = 1] = "Dotted", t[t.Dashed = 2] = "Dashed", t[t.LargeDashed = 3] = "LargeDashed", t[t.SparseDotted = 4] = "SparseDotted";
})(gl || (gl = {}));
let Ye = class {
  constructor() {
    this.t = [];
  }
  i(e, n, i) {
    const s = { h: e, l: n, o: i === !0 };
    this.t.push(s);
  }
  _(e) {
    const n = this.t.findIndex(((i) => e === i.h));
    n > -1 && this.t.splice(n, 1);
  }
  u(e) {
    this.t = this.t.filter(((n) => n.l !== e));
  }
  p(e, n, i) {
    const s = [...this.t];
    this.t = this.t.filter(((r) => !r.o)), s.forEach(((r) => r.h(e, n, i)));
  }
  v() {
    return this.t.length > 0;
  }
  m() {
    this.t = [];
  }
};
function tt(t, ...e) {
  for (const n of e) for (const i in n) n[i] !== void 0 && Object.prototype.hasOwnProperty.call(n, i) && !["__proto__", "constructor", "prototype"].includes(i) && (typeof n[i] != "object" || t[i] === void 0 || Array.isArray(n[i]) ? t[i] = n[i] : tt(t[i], n[i]));
  return t;
}
function oi(t) {
  return typeof t == "number" && isFinite(t);
}
function Bi(t) {
  return typeof t == "number" && t % 1 == 0;
}
function zi(t) {
  return typeof t == "string";
}
function ls(t) {
  return typeof t == "boolean";
}
function Ot(t) {
  const e = t;
  if (!e || typeof e != "object") return e;
  let n, i, s;
  for (i in n = Array.isArray(e) ? [] : {}, e) e.hasOwnProperty(i) && (s = e[i], n[i] = s && typeof s == "object" ? Ot(s) : s);
  return n;
}
function Iu(t) {
  return t !== null;
}
function fl(t) {
  return t === null ? void 0 : t;
}
const f2 = "-apple-system, BlinkMacSystemFont, 'Trebuchet MS', Roboto, Ubuntu, sans-serif";
function Ts(t, e, n) {
  return e === void 0 && (e = f2), `${n = n !== void 0 ? `${n} ` : ""}${t}px ${e}`;
}
let B4 = class {
  constructor(e) {
    this.M = { S: 1, C: 5, k: NaN, P: "", T: "", R: "", D: "", I: 0, V: 0, B: 0, A: 0, L: 0 }, this.O = e;
  }
  N() {
    const e = this.M, n = this.F(), i = this.W();
    return e.k === n && e.T === i || (e.k = n, e.T = i, e.P = Ts(n, i), e.A = 2.5 / 12 * n, e.I = e.A, e.V = n / 12 * e.C, e.B = n / 12 * e.C, e.L = 0), e.R = this.H(), e.D = this.U(), this.M;
  }
  H() {
    return this.O.N().layout.textColor;
  }
  U() {
    return this.O.$();
  }
  F() {
    return this.O.N().layout.fontSize;
  }
  W() {
    return this.O.N().layout.fontFamily;
  }
};
function oo(t) {
  return t < 0 ? 0 : t > 255 ? 255 : Math.round(t) || 0;
}
function Nu(t) {
  return 0.199 * t[0] + 0.687 * t[1] + 0.114 * t[2];
}
let w4 = class {
  constructor(e, n) {
    this.q = /* @__PURE__ */ new Map(), this.j = e, n && (this.q = n);
  }
  Y(e, n) {
    if (e === "transparent") return e;
    const i = this.K(e), s = i[3];
    return `rgba(${i[0]}, ${i[1]}, ${i[2]}, ${n * s})`;
  }
  Z(e) {
    const n = this.K(e);
    return { G: `rgb(${n[0]}, ${n[1]}, ${n[2]})`, X: Nu(n) > 160 ? "black" : "white" };
  }
  J(e) {
    return Nu(this.K(e));
  }
  tt(e, n, i) {
    const [s, r, o, l] = this.K(e), [a, c, u, h] = this.K(n), d = [oo(s + i * (a - s)), oo(r + i * (c - r)), oo(o + i * (u - o)), (m = l + i * (h - l), m <= 0 || m > 1 ? Math.min(Math.max(m, 0), 1) : Math.round(1e4 * m) / 1e4)];
    var m;
    return `rgba(${d[0]}, ${d[1]}, ${d[2]}, ${d[3]})`;
  }
  K(e) {
    const n = this.q.get(e);
    if (n) return n;
    const i = (function(o) {
      const l = document.createElement("div");
      l.style.display = "none", document.body.appendChild(l), l.style.color = o;
      const a = window.getComputedStyle(l).color;
      return document.body.removeChild(l), a;
    })(e), s = i.match(/^rgba?\s*\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d*\.?\d+))?\)$/);
    if (!s) {
      if (this.j.length) for (const o of this.j) {
        const l = o(e);
        if (l) return this.q.set(e, l), l;
      }
      throw new Error(`Failed to parse color: ${e}`);
    }
    const r = [parseInt(s[1], 10), parseInt(s[2], 10), parseInt(s[3], 10), s[4] ? parseFloat(s[4]) : 1];
    return this.q.set(e, r), r;
  }
}, Y4 = class {
  constructor() {
    this.it = [];
  }
  st(e) {
    this.it = e;
  }
  nt(e, n, i) {
    this.it.forEach(((s) => {
      s.nt(e, n, i);
    }));
  }
}, di = class {
  nt(e, n, i) {
    e.useBitmapCoordinateSpace(((s) => this.et(s, n, i)));
  }
}, T4 = class extends di {
  constructor() {
    super(...arguments), this.rt = null;
  }
  ht(e) {
    this.rt = e;
  }
  et({ context: e, horizontalPixelRatio: n, verticalPixelRatio: i }) {
    if (this.rt === null || this.rt.lt === null) return;
    const s = this.rt.lt, r = this.rt, o = Math.max(1, Math.floor(n)) % 2 / 2, l = (a) => {
      e.beginPath();
      for (let c = s.to - 1; c >= s.from; --c) {
        const u = r.ot[c], h = Math.round(u._t * n) + o, d = u.ut * i, m = a * i + o;
        e.moveTo(h, d), e.arc(h, d, m, 0, 2 * Math.PI);
      }
      e.fill();
    };
    r.ct > 0 && (e.fillStyle = r.dt, l(r.ft + r.ct)), e.fillStyle = r.vt, l(r.ft);
  }
};
function L4() {
  return { ot: [{ _t: 0, ut: 0, wt: 0, gt: 0 }], vt: "", dt: "", ft: 0, ct: 0, lt: null };
}
const k4 = { from: 0, to: 1 };
let J4 = class {
  constructor(e, n, i) {
    this.Mt = new Y4(), this.bt = [], this.St = [], this.xt = !0, this.O = e, this.Ct = n, this.yt = i, this.Mt.st(this.bt);
  }
  kt(e) {
    this.Pt(), this.xt = !0;
  }
  Tt() {
    return this.xt && (this.Rt(), this.xt = !1), this.Mt;
  }
  Pt() {
    const e = this.yt.Dt();
    e.length !== this.bt.length && (this.St = e.map(L4), this.bt = this.St.map(((n) => {
      const i = new T4();
      return i.ht(n), i;
    })), this.Mt.st(this.bt));
  }
  Rt() {
    const e = this.Ct.N().mode === 2 || !this.Ct.It(), n = this.yt.Vt(), i = this.Ct.Bt(), s = this.O.Et();
    this.Pt(), n.forEach(((r, o) => {
      const l = this.St[o], a = r.At(i), c = r.Lt();
      !e && a !== null && r.It() && c !== null ? (l.vt = a.zt, l.ft = a.ft, l.ct = a.Ot, l.ot[0].gt = a.gt, l.ot[0].ut = r.Ft().Nt(a.gt, c.Wt), l.dt = a.Ht ?? this.O.Ut(l.ot[0].ut / r.Ft().$t()), l.ot[0].wt = i, l.ot[0]._t = s.qt(i), l.lt = k4) : l.lt = null;
    }));
  }
}, x4 = class extends di {
  constructor(e) {
    super(), this.jt = e;
  }
  et({ context: e, bitmapSize: n, horizontalPixelRatio: i, verticalPixelRatio: s }) {
    if (this.jt === null) return;
    const r = this.jt.Yt.It, o = this.jt.Kt.It;
    if (!r && !o) return;
    const l = Math.round(this.jt._t * i), a = Math.round(this.jt.ut * s);
    e.lineCap = "butt", r && l >= 0 && (e.lineWidth = Math.floor(this.jt.Yt.ct * i), e.strokeStyle = this.jt.Yt.R, e.fillStyle = this.jt.Yt.R, vn(e, this.jt.Yt.Zt), (function(c, u, h, d) {
      c.beginPath();
      const m = c.lineWidth % 2 ? 0.5 : 0;
      c.moveTo(u + m, h), c.lineTo(u + m, d), c.stroke();
    })(e, l, 0, n.height)), o && a >= 0 && (e.lineWidth = Math.floor(this.jt.Kt.ct * s), e.strokeStyle = this.jt.Kt.R, e.fillStyle = this.jt.Kt.R, vn(e, this.jt.Kt.Zt), g2(e, a, 0, n.width));
  }
}, M4 = class {
  constructor(e, n) {
    this.xt = !0, this.Gt = { Yt: { ct: 1, Zt: 0, R: "", It: !1 }, Kt: { ct: 1, Zt: 0, R: "", It: !1 }, _t: 0, ut: 0 }, this.Xt = new x4(this.Gt), this.Jt = e, this.yt = n;
  }
  kt() {
    this.xt = !0;
  }
  Tt(e) {
    return this.xt && (this.Rt(), this.xt = !1), this.Xt;
  }
  Rt() {
    const e = this.Jt.It(), n = this.yt.Qt().N().crosshair, i = this.Gt;
    if (n.mode === 2) return i.Kt.It = !1, void (i.Yt.It = !1);
    i.Kt.It = e && this.Jt.ti(this.yt), i.Yt.It = e && this.Jt.ii(), i.Kt.ct = n.horzLine.width, i.Kt.Zt = n.horzLine.style, i.Kt.R = n.horzLine.color, i.Yt.ct = n.vertLine.width, i.Yt.Zt = n.vertLine.style, i.Yt.R = n.vertLine.color, i._t = this.Jt.si(), i.ut = this.Jt.ni();
  }
};
function rr(t, e, n, i, s, r) {
  t.save(), t.globalCompositeOperation = "copy", t.fillStyle = r, t.fillRect(e, n, i, s), t.restore();
}
function Fu(t, e, n, i, s, r) {
  t.beginPath(), t.roundRect ? t.roundRect(e, n, i, s, r) : (t.lineTo(e + i - r[1], n), r[1] !== 0 && t.arcTo(e + i, n, e + i, n + r[1], r[1]), t.lineTo(e + i, n + s - r[2]), r[2] !== 0 && t.arcTo(e + i, n + s, e + i - r[2], n + s, r[2]), t.lineTo(e + r[3], n + s), r[3] !== 0 && t.arcTo(e, n + s, e, n + s - r[3], r[3]), t.lineTo(e, n + r[0]), r[0] !== 0 && t.arcTo(e, n, e + r[0], n, r[0]));
}
function Gu(t, e, n, i, s, r, o = 0, l = [0, 0, 0, 0], a = "") {
  if (t.save(), !o || !a || a === r) return Fu(t, e, n, i, s, l), t.fillStyle = r, t.fill(), void t.restore();
  const c = o / 2;
  var u;
  Fu(t, e + c, n + c, i - o, s - o, (u = -c, l.map(((h) => h === 0 ? h : h + u)))), r !== "transparent" && (t.fillStyle = r, t.fill()), a !== "transparent" && (t.lineWidth = o, t.strokeStyle = a, t.closePath(), t.stroke()), t.restore();
}
function b2(t, e, n, i, s, r, o) {
  t.save(), t.globalCompositeOperation = "copy";
  const l = t.createLinearGradient(0, 0, 0, s);
  l.addColorStop(0, r), l.addColorStop(1, o), t.fillStyle = l, t.fillRect(e, n, i, s), t.restore();
}
let Xu = class {
  constructor(e, n) {
    this.ht(e, n);
  }
  ht(e, n) {
    this.jt = e, this.ei = n;
  }
  $t(e, n) {
    return this.jt.It ? e.k + e.A + e.I : 0;
  }
  nt(e, n, i, s) {
    if (!this.jt.It || this.jt.ri.length === 0) return;
    const r = this.jt.R, o = this.ei.G, l = e.useBitmapCoordinateSpace(((a) => {
      const c = a.context;
      c.font = n.P;
      const u = this.hi(a, n, i, s), h = u.ai;
      return u.li ? Gu(c, h.oi, h._i, h.ui, h.ci, o, h.di, [h.ft, 0, 0, h.ft], o) : Gu(c, h.fi, h._i, h.ui, h.ci, o, h.di, [0, h.ft, h.ft, 0], o), this.jt.pi && (c.fillStyle = r, c.fillRect(h.fi, h.mi, h.wi - h.fi, h.gi)), this.jt.Mi && (c.fillStyle = n.D, c.fillRect(u.li ? h.bi - h.di : 0, h._i, h.di, h.Si - h._i)), u;
    }));
    e.useMediaCoordinateSpace((({ context: a }) => {
      const c = l.xi;
      a.font = n.P, a.textAlign = l.li ? "right" : "left", a.textBaseline = "middle", a.fillStyle = r, a.fillText(this.jt.ri, c.Ci, (c._i + c.Si) / 2 + c.yi);
    }));
  }
  hi(e, n, i, s) {
    const { context: r, bitmapSize: o, mediaSize: l, horizontalPixelRatio: a, verticalPixelRatio: c } = e, u = this.jt.pi || !this.jt.ki ? n.C : 0, h = this.jt.Pi ? n.S : 0, d = n.A + this.ei.Ti, m = n.I + this.ei.Ri, p = n.V, g = n.B, A = this.jt.ri, b = n.k, R = i.Di(r, A), S = Math.ceil(i.Ii(r, A)), E = b + d + m, Z = n.S + p + g + S + u, G = Math.max(1, Math.floor(c));
    let T = Math.round(E * c);
    T % 2 != G % 2 && (T += 1);
    const C = h > 0 ? Math.max(1, Math.floor(h * a)) : 0, N = Math.round(Z * a), Y = Math.round(u * a), L = this.ei.Vi ?? this.ei.Bi ?? this.ei.Ei, w = Math.round(L * c) - Math.floor(0.5 * c), D = Math.floor(w + G / 2 - T / 2), ie = D + T, X = s === "right", Q = X ? l.width - h : h, J = X ? o.width - C : C;
    let q, k, O;
    return X ? (q = J - N, k = J - Y, O = Q - u - p - h) : (q = J + N, k = J + Y, O = Q + u + p), { li: X, ai: { _i: D, mi: w, Si: ie, ui: N, ci: T, ft: 2 * a, di: C, oi: q, fi: J, wi: k, gi: G, bi: o.width }, xi: { _i: D / c, Si: ie / c, Ci: O, yi: R } };
  }
}, or = class {
  constructor(e) {
    this.Ai = { Ei: 0, G: "#000", Ri: 0, Ti: 0 }, this.Li = { ri: "", It: !1, pi: !0, ki: !1, Ht: "", R: "#FFF", Mi: !1, Pi: !1 }, this.zi = { ri: "", It: !1, pi: !1, ki: !0, Ht: "", R: "#FFF", Mi: !0, Pi: !0 }, this.xt = !0, this.Oi = new (e || Xu)(this.Li, this.Ai), this.Ni = new (e || Xu)(this.zi, this.Ai);
  }
  ri() {
    return this.Fi(), this.Li.ri;
  }
  Ei() {
    return this.Fi(), this.Ai.Ei;
  }
  kt() {
    this.xt = !0;
  }
  $t(e, n = !1) {
    return Math.max(this.Oi.$t(e, n), this.Ni.$t(e, n));
  }
  Wi() {
    return this.Ai.Vi ?? null;
  }
  Hi() {
    return this.Ai.Vi ?? this.Ai.Bi ?? this.Ei();
  }
  Ui(e) {
    this.Ai.Bi = e ?? void 0;
  }
  $i() {
    return this.Fi(), this.Li.It || this.zi.It;
  }
  qi() {
    return this.Fi(), this.Li.It;
  }
  Tt(e) {
    return this.Fi(), this.Li.pi = this.Li.pi && e.N().ticksVisible, this.zi.pi = this.zi.pi && e.N().ticksVisible, this.Oi.ht(this.Li, this.Ai), this.Ni.ht(this.zi, this.Ai), this.Oi;
  }
  ji() {
    return this.Fi(), this.Oi.ht(this.Li, this.Ai), this.Ni.ht(this.zi, this.Ai), this.Ni;
  }
  Fi() {
    this.xt && (this.Li.pi = !0, this.zi.pi = !1, this.Yi(this.Li, this.zi, this.Ai));
  }
}, Q4 = class extends or {
  constructor(e, n, i) {
    super(), this.Jt = e, this.Ki = n, this.Zi = i;
  }
  Yi(e, n, i) {
    if (e.It = !1, this.Jt.N().mode === 2) return;
    const s = this.Jt.N().horzLine;
    if (!s.labelVisible) return;
    const r = this.Ki.Lt();
    if (!this.Jt.It() || this.Ki.Gi() || r === null) return;
    const o = this.Ki.Xi().Z(s.labelBackgroundColor);
    i.G = o.G, e.R = o.X;
    const l = 2 / 12 * this.Ki.k();
    i.Ti = l, i.Ri = l;
    const a = this.Zi(this.Ki);
    i.Ei = a.Ei, e.ri = this.Ki.Ji(a.gt, r), e.It = !0;
  }
};
const z4 = /[1-9]/g;
let A2 = class {
  constructor() {
    this.jt = null;
  }
  ht(e) {
    this.jt = e;
  }
  nt(e, n) {
    if (this.jt === null || this.jt.It === !1 || this.jt.ri.length === 0) return;
    const i = e.useMediaCoordinateSpace((({ context: d }) => (d.font = n.P, Math.round(n.Qi.Ii(d, H(this.jt).ri, z4)))));
    if (i <= 0) return;
    const s = n.ts, r = i + 2 * s, o = r / 2, l = this.jt.ss;
    let a = this.jt.Ei, c = Math.floor(a - o) + 0.5;
    c < 0 ? (a += Math.abs(0 - c), c = Math.floor(a - o) + 0.5) : c + r > l && (a -= Math.abs(l - (c + r)), c = Math.floor(a - o) + 0.5);
    const u = c + r, h = Math.ceil(0 + n.S + n.C + n.A + n.k + n.I);
    e.useBitmapCoordinateSpace((({ context: d, horizontalPixelRatio: m, verticalPixelRatio: p }) => {
      const g = H(this.jt);
      d.fillStyle = g.G;
      const A = Math.round(c * m), b = Math.round(0 * p), R = Math.round(u * m), S = Math.round(h * p), E = Math.round(2 * m);
      if (d.beginPath(), d.moveTo(A, b), d.lineTo(A, S - E), d.arcTo(A, S, A + E, S, E), d.lineTo(R - E, S), d.arcTo(R, S, R, S - E, E), d.lineTo(R, b), d.fill(), g.pi) {
        const Z = Math.round(g.Ei * m), G = b, T = Math.round((G + n.C) * p);
        d.fillStyle = g.R;
        const C = Math.max(1, Math.floor(m)), N = Math.floor(0.5 * m);
        d.fillRect(Z - N, G, C, T - G);
      }
    })), e.useMediaCoordinateSpace((({ context: d }) => {
      const m = H(this.jt), p = 0 + n.S + n.C + n.A + n.k / 2;
      d.font = n.P, d.textAlign = "left", d.textBaseline = "middle", d.fillStyle = m.R;
      const g = n.Qi.Di(d, "Apr0");
      d.translate(c + s, p + g), d.fillText(m.ri, 0, 0);
    }));
  }
}, K4 = class {
  constructor(e, n, i) {
    this.xt = !0, this.Xt = new A2(), this.Gt = { It: !1, G: "#4c525e", R: "white", ri: "", ss: 0, Ei: NaN, pi: !0 }, this.Ct = e, this.ns = n, this.Zi = i;
  }
  kt() {
    this.xt = !0;
  }
  Tt() {
    return this.xt && (this.Rt(), this.xt = !1), this.Xt.ht(this.Gt), this.Xt;
  }
  Rt() {
    const e = this.Gt;
    if (e.It = !1, this.Ct.N().mode === 2) return;
    const n = this.Ct.N().vertLine;
    if (!n.labelVisible) return;
    const i = this.ns.Et();
    if (i.Gi()) return;
    e.ss = i.ss();
    const s = this.Zi();
    if (s === null) return;
    e.Ei = s.Ei;
    const r = i.es(this.Ct.Bt());
    e.ri = i.rs(H(r)), e.It = !0;
    const o = this.ns.Xi().Z(n.labelBackgroundColor);
    e.G = o.G, e.R = o.X, e.pi = i.N().ticksVisible;
  }
}, V2 = class {
  constructor() {
    this.hs = null, this.ls = 0;
  }
  _s() {
    return this.ls;
  }
  us(e) {
    this.ls = e;
  }
  Ft() {
    return this.hs;
  }
  cs(e) {
    this.hs = e;
  }
  ds(e) {
    return [];
  }
  fs() {
    return [];
  }
  It() {
    return !0;
  }
};
var Uu;
(function(t) {
  t[t.Normal = 0] = "Normal", t[t.Magnet = 1] = "Magnet", t[t.Hidden = 2] = "Hidden", t[t.MagnetOHLC = 3] = "MagnetOHLC";
})(Uu || (Uu = {}));
let H4 = class extends V2 {
  constructor(e, n) {
    super(), this.yt = null, this.ps = NaN, this.vs = 0, this.ws = !1, this.gs = /* @__PURE__ */ new Map(), this.Ms = !1, this.bs = /* @__PURE__ */ new WeakMap(), this.Ss = /* @__PURE__ */ new WeakMap(), this.xs = NaN, this.Cs = NaN, this.ys = NaN, this.ks = NaN, this.ns = e, this.Ps = n, this.Ts = /* @__PURE__ */ ((s, r) => (o) => {
      const l = r(), a = s();
      if (o === H(this.yt).Rs()) return { gt: a, Ei: l };
      {
        const c = H(o.Lt());
        return { gt: o.Ds(l, c), Ei: l };
      }
    })((() => this.ps), (() => this.Cs));
    const i = /* @__PURE__ */ ((s, r) => () => {
      const o = this.ns.Et().Is(s()), l = r();
      return o && Number.isFinite(l) ? { wt: o, Ei: l } : null;
    })((() => this.vs), (() => this.si()));
    this.Vs = new K4(this, e, i);
  }
  N() {
    return this.Ps;
  }
  Bs(e, n) {
    this.ys = e, this.ks = n;
  }
  Es() {
    this.ys = NaN, this.ks = NaN;
  }
  As() {
    return this.ys;
  }
  Ls() {
    return this.ks;
  }
  zs(e, n, i) {
    this.Ms || (this.Ms = !0), this.ws = !0, this.Os(e, n, i);
  }
  Bt() {
    return this.vs;
  }
  si() {
    return this.xs;
  }
  ni() {
    return this.Cs;
  }
  It() {
    return this.ws;
  }
  Ns() {
    this.ws = !1, this.Fs(), this.ps = NaN, this.xs = NaN, this.Cs = NaN, this.yt = null, this.Es(), this.Ws();
  }
  Hs(e) {
    if (!this.Ps.doNotSnapToHiddenSeriesIndices) return e;
    const n = this.ns, i = n.Et();
    let s = null, r = null;
    for (const c of n.Us()) {
      const u = c.qs().$s(e, -1);
      if (u) {
        if (u.js === e) return e;
        (s === null || u.js > s) && (s = u.js);
      }
      const h = c.qs().$s(e, 1);
      if (h) {
        if (h.js === e) return e;
        (r === null || h.js < r) && (r = h.js);
      }
    }
    const o = [s, r].filter(Iu);
    if (o.length === 0) return e;
    const l = i.qt(e), a = o.map(((c) => Math.abs(l - i.qt(c))));
    return o[a.indexOf(Math.min(...a))];
  }
  Ys(e) {
    let n = this.bs.get(e);
    n || (n = new M4(this, e), this.bs.set(e, n));
    let i = this.Ss.get(e);
    return i || (i = new J4(this.ns, this, e), this.Ss.set(e, i)), [n, i];
  }
  ti(e) {
    return e === this.yt && this.Ps.horzLine.visible;
  }
  ii() {
    return this.Ps.vertLine.visible;
  }
  Ks(e, n) {
    this.ws && this.yt === e || this.gs.clear();
    const i = [];
    return this.yt === e && i.push(this.Zs(this.gs, n, this.Ts)), i;
  }
  fs() {
    return this.ws ? [this.Vs] : [];
  }
  Gs() {
    return this.yt;
  }
  Ws() {
    this.ns.Xs().forEach(((e) => {
      this.bs.get(e)?.kt(), this.Ss.get(e)?.kt();
    })), this.gs.forEach(((e) => e.kt())), this.Vs.kt();
  }
  Js(e) {
    return e && !e.Rs().Gi() ? e.Rs() : null;
  }
  Os(e, n, i) {
    this.Qs(e, n, i) && this.Ws();
  }
  Qs(e, n, i) {
    const s = this.xs, r = this.Cs, o = this.ps, l = this.vs, a = this.yt, c = this.Js(i);
    this.vs = e, this.xs = isNaN(e) ? NaN : this.ns.Et().qt(e), this.yt = i;
    const u = c !== null ? c.Lt() : null;
    return c !== null && u !== null ? (this.ps = n, this.Cs = c.Nt(n, u)) : (this.ps = NaN, this.Cs = NaN), s !== this.xs || r !== this.Cs || l !== this.vs || o !== this.ps || a !== this.yt;
  }
  Fs() {
    const e = this.ns.tn().map(((i) => i.qs().sn())).filter(Iu), n = e.length === 0 ? null : Math.max(...e);
    this.vs = n !== null ? n : NaN;
  }
  Zs(e, n, i) {
    let s = e.get(n);
    return s === void 0 && (s = new Q4(this, n, i), e.set(n, s)), s;
  }
};
function lr(t) {
  return t === "left" || t === "right";
}
let Pe = class bl {
  constructor(e) {
    this.nn = /* @__PURE__ */ new Map(), this.en = [], this.rn = e;
  }
  hn(e, n) {
    const i = (function(s, r) {
      return s === void 0 ? r : { an: Math.max(s.an, r.an), ln: s.ln || r.ln };
    })(this.nn.get(e), n);
    this.nn.set(e, i);
  }
  _n() {
    return this.rn;
  }
  un(e) {
    const n = this.nn.get(e);
    return n === void 0 ? { an: this.rn } : { an: Math.max(this.rn, n.an), ln: n.ln };
  }
  cn() {
    this.dn(), this.en = [{ fn: 0 }];
  }
  pn(e) {
    this.dn(), this.en = [{ fn: 1, Wt: e }];
  }
  vn(e) {
    this.mn(), this.en.push({ fn: 5, Wt: e });
  }
  dn() {
    this.mn(), this.en.push({ fn: 6 });
  }
  wn() {
    this.dn(), this.en = [{ fn: 4 }];
  }
  gn(e) {
    this.dn(), this.en.push({ fn: 2, Wt: e });
  }
  Mn(e) {
    this.dn(), this.en.push({ fn: 3, Wt: e });
  }
  bn() {
    return this.en;
  }
  Sn(e) {
    for (const n of e.en) this.xn(n);
    this.rn = Math.max(this.rn, e.rn), e.nn.forEach(((n, i) => {
      this.hn(i, n);
    }));
  }
  static Cn() {
    return new bl(2);
  }
  static yn() {
    return new bl(3);
  }
  xn(e) {
    switch (e.fn) {
      case 0:
        this.cn();
        break;
      case 1:
        this.pn(e.Wt);
        break;
      case 2:
        this.gn(e.Wt);
        break;
      case 3:
        this.Mn(e.Wt);
        break;
      case 4:
        this.wn();
        break;
      case 5:
        this.vn(e.Wt);
        break;
      case 6:
        this.mn();
    }
  }
  mn() {
    const e = this.en.findIndex(((n) => n.fn === 5));
    e !== -1 && this.en.splice(e, 1);
  }
}, R2 = class {
  formatTickmarks(e) {
    return e.map(((n) => this.format(n)));
  }
};
const Bu = ".";
function Dt(t, e) {
  if (!oi(t)) return "n/a";
  if (!Bi(e)) throw new TypeError("invalid length");
  if (e < 0 || e > 16) throw new TypeError("invalid length");
  return e === 0 ? t.toString() : ("0000000000000000" + t.toString()).slice(-e);
}
let ar = class extends R2 {
  constructor(e, n) {
    if (super(), n || (n = 1), oi(e) && Bi(e) || (e = 100), e < 0) throw new TypeError("invalid base");
    this.Ki = e, this.kn = n, this.Pn();
  }
  format(e) {
    const n = e < 0 ? "−" : "";
    return e = Math.abs(e), n + this.Tn(e);
  }
  Pn() {
    if (this.Rn = 0, this.Ki > 0 && this.kn > 0) {
      let e = this.Ki;
      for (; e > 1; ) e /= 10, this.Rn++;
    }
  }
  Tn(e) {
    const n = this.Ki / this.kn;
    let i = Math.floor(e), s = "";
    const r = this.Rn !== void 0 ? this.Rn : NaN;
    if (n > 1) {
      let o = +(Math.round(e * n) - i * n).toFixed(this.Rn);
      o >= n && (o -= n, i += 1), s = Bu + Dt(+o.toFixed(this.Rn) * this.kn, r);
    } else i = Math.round(i * n) / n, r > 0 && (s = Bu + Dt(0, r));
    return i.toFixed(0) + s;
  }
};
class E2 extends ar {
  constructor(e = 100) {
    super(e);
  }
  format(e) {
    return `${super.format(e)}%`;
  }
}
let O4 = class extends R2 {
  constructor(e) {
    super(), this.Dn = e;
  }
  format(e) {
    let n = "";
    return e < 0 && (n = "-", e = -e), e < 995 ? n + this.In(e) : e < 999995 ? n + this.In(e / 1e3) + "K" : e < 999999995 ? (e = 1e3 * Math.round(e / 1e3), n + this.In(e / 1e6) + "M") : (e = 1e6 * Math.round(e / 1e6), n + this.In(e / 1e9) + "B");
  }
  In(e) {
    let n;
    const i = Math.pow(10, this.Dn);
    return n = (e = Math.round(e * i) / i) >= 1e-15 && e < 1 ? e.toFixed(this.Dn).replace(/\.?0+$/, "") : String(e), n.replace(/(\.[1-9]*)0+$/, ((s, r) => r));
  }
};
const D4 = /[2-9]/g;
let Ls = class {
  constructor(e = 50) {
    this.Vn = 0, this.Bn = 1, this.En = 1, this.An = {}, this.Ln = /* @__PURE__ */ new Map(), this.zn = e;
  }
  On() {
    this.Vn = 0, this.Ln.clear(), this.Bn = 1, this.En = 1, this.An = {};
  }
  Ii(e, n, i) {
    return this.Nn(e, n, i).width;
  }
  Di(e, n, i) {
    const s = this.Nn(e, n, i);
    return ((s.actualBoundingBoxAscent || 0) - (s.actualBoundingBoxDescent || 0)) / 2;
  }
  Nn(e, n, i) {
    const s = i || D4, r = String(n).replace(s, "0");
    if (this.Ln.has(r)) return $e(this.Ln.get(r)).Fn;
    if (this.Vn === this.zn) {
      const l = this.An[this.En];
      delete this.An[this.En], this.Ln.delete(l), this.En++, this.Vn--;
    }
    e.save(), e.textBaseline = "middle";
    const o = e.measureText(r);
    return e.restore(), o.width === 0 && n.length || (this.Ln.set(r, { Fn: o, Wn: this.Bn }), this.An[this.Bn] = r, this.Vn++, this.Bn++), o;
  }
};
class P4 {
  constructor(e) {
    this.Hn = null, this.M = null, this.Un = "right", this.$n = e;
  }
  qn(e, n, i) {
    this.Hn = e, this.M = n, this.Un = i;
  }
  nt(e) {
    this.M !== null && this.Hn !== null && this.Hn.nt(e, this.M, this.$n, this.Un);
  }
}
class y2 {
  constructor(e, n, i) {
    this.jn = e, this.$n = new Ls(50), this.Yn = n, this.O = i, this.F = -1, this.Xt = new P4(this.$n);
  }
  Tt() {
    const e = this.O.Kn(this.Yn);
    if (e === null) return null;
    const n = e.Zn(this.Yn) ? e.Gn() : this.Yn.Ft();
    if (n === null) return null;
    const i = e.Xn(n);
    if (i === "overlay") return null;
    const s = this.O.Jn();
    return s.k !== this.F && (this.F = s.k, this.$n.On()), this.Xt.qn(this.jn.ji(), s, i), this.Xt;
  }
}
class _4 extends di {
  constructor() {
    super(...arguments), this.jt = null;
  }
  ht(e) {
    this.jt = e;
  }
  Qn(e, n) {
    if (!this.jt?.It) return null;
    const { ut: i, ct: s, te: r } = this.jt;
    return n >= i - s - 7 && n <= i + s + 7 ? { ie: this.jt, te: r } : null;
  }
  et({ context: e, bitmapSize: n, horizontalPixelRatio: i, verticalPixelRatio: s }) {
    if (this.jt === null || this.jt.It === !1) return;
    const r = Math.round(this.jt.ut * s);
    r < 0 || r > n.height || (e.lineCap = "butt", e.strokeStyle = this.jt.R, e.lineWidth = Math.floor(this.jt.ct * i), vn(e, this.jt.Zt), g2(e, r, 0, n.width));
  }
}
let ha = class {
  constructor(e) {
    this.se = { ut: 0, R: "rgba(0, 0, 0, 0)", ct: 1, Zt: 0, It: !1 }, this.ne = new _4(), this.xt = !0, this.ee = e, this.re = e.Qt(), this.ne.ht(this.se);
  }
  kt() {
    this.xt = !0;
  }
  Tt() {
    return this.ee.It() ? (this.xt && (this.he(), this.xt = !1), this.ne) : null;
  }
};
class j4 extends ha {
  constructor(e) {
    super(e);
  }
  he() {
    this.se.It = !1;
    const e = this.ee.Ft(), n = e.ae().ae;
    if (n !== 2 && n !== 3) return;
    const i = this.ee.N();
    if (!i.baseLineVisible || !this.ee.It()) return;
    const s = this.ee.Lt();
    s !== null && (this.se.It = !0, this.se.ut = e.Nt(s.Wt, s.Wt), this.se.R = i.baseLineColor, this.se.ct = i.baseLineWidth, this.se.Zt = i.baseLineStyle);
  }
}
class $4 extends di {
  constructor() {
    super(...arguments), this.jt = null;
  }
  ht(e) {
    this.jt = e;
  }
  le() {
    return this.jt;
  }
  et({ context: e, horizontalPixelRatio: n, verticalPixelRatio: i }) {
    const s = this.jt;
    if (s === null) return;
    const r = Math.max(1, Math.floor(n)), o = r % 2 / 2, l = Math.round(s.oe.x * n) + o, a = s.oe.y * i;
    e.fillStyle = s._e, e.beginPath();
    const c = Math.max(2, 1.5 * s.ue) * n;
    e.arc(l, a, c, 0, 2 * Math.PI, !1), e.fill(), e.fillStyle = s.ce, e.beginPath(), e.arc(l, a, s.ft * n, 0, 2 * Math.PI, !1), e.fill(), e.lineWidth = r, e.strokeStyle = s.de, e.beginPath(), e.arc(l, a, s.ft * n + r / 2, 0, 2 * Math.PI, !1), e.stroke();
  }
}
const q4 = [{ fe: 0, pe: 0.25, ve: 4, me: 10, we: 0.25, ge: 0, Me: 0.4, be: 0.8 }, { fe: 0.25, pe: 0.525, ve: 10, me: 14, we: 0, ge: 0, Me: 0.8, be: 0 }, { fe: 0.525, pe: 1, ve: 14, me: 14, we: 0, ge: 0, Me: 0, be: 0 }];
class e8 {
  constructor(e) {
    this.Xt = new $4(), this.xt = !0, this.Se = !0, this.xe = performance.now(), this.Ce = this.xe - 1, this.ye = e;
  }
  ke() {
    this.Ce = this.xe - 1, this.kt();
  }
  Pe() {
    if (this.kt(), this.ye.N().lastPriceAnimation === 2) {
      const e = performance.now(), n = this.Ce - e;
      if (n > 0) return void (n < 650 && (this.Ce += 2600));
      this.xe = e, this.Ce = e + 2600;
    }
  }
  kt() {
    this.xt = !0;
  }
  Te() {
    this.Se = !0;
  }
  It() {
    return this.ye.N().lastPriceAnimation !== 0;
  }
  Re() {
    switch (this.ye.N().lastPriceAnimation) {
      case 0:
        return !1;
      case 1:
        return !0;
      case 2:
        return performance.now() <= this.Ce;
    }
  }
  Tt() {
    return this.xt ? (this.Rt(), this.xt = !1, this.Se = !1) : this.Se && (this.De(), this.Se = !1), this.Xt;
  }
  Rt() {
    this.Xt.ht(null);
    const e = this.ye.Qt().Et(), n = e.Ie(), i = this.ye.Lt();
    if (n === null || i === null) return;
    const s = this.ye.Ve(!0);
    if (s.Be || !n.Ee(s.js)) return;
    const r = { x: e.qt(s.js), y: this.ye.Ft().Nt(s.gt, i.Wt) }, o = s.R, l = this.ye.N().lineWidth, a = this.Ae(this.Le(), o);
    this.Xt.ht({ _e: o, ue: l, ce: a.ce, de: a.de, ft: a.ft, oe: r });
  }
  De() {
    const e = this.Xt.le();
    if (e !== null) {
      const n = this.Ae(this.Le(), e._e);
      e.ce = n.ce, e.de = n.de, e.ft = n.ft;
    }
  }
  Le() {
    return this.Re() ? performance.now() - this.xe : 2599;
  }
  ze(e, n, i, s) {
    const r = i + (s - i) * n;
    return this.ye.Qt().Xi().Y(e, r);
  }
  Ae(e, n) {
    const i = e % 2600 / 2600;
    let s;
    for (const c of q4) if (i >= c.fe && i <= c.pe) {
      s = c;
      break;
    }
    Ke(s !== void 0, "Last price animation internal logic error");
    const r = (i - s.fe) / (s.pe - s.fe);
    return { ce: this.ze(n, r, s.we, s.ge), de: this.ze(n, r, s.Me, s.be), ft: (o = r, l = s.ve, a = s.me, l + (a - l) * o) };
    var o, l, a;
  }
}
let t8 = class extends ha {
  constructor(e) {
    super(e);
  }
  he() {
    const e = this.se;
    e.It = !1;
    const n = this.ee.N();
    if (!n.priceLineVisible || !this.ee.It()) return;
    const i = this.ee.Ve(n.priceLineSource === 0);
    i.Be || (e.It = !0, e.ut = i.Ei, e.R = this.ee.Oe(i.R), e.ct = n.priceLineWidth, e.Zt = n.priceLineStyle);
  }
};
class n8 extends or {
  constructor(e) {
    super(), this.Jt = e;
  }
  Yi(e, n, i) {
    e.It = !1, n.It = !1;
    const s = this.Jt;
    if (!s.It()) return;
    const r = s.N(), o = r.lastValueVisible, l = s.Ne() !== "", a = r.seriesLastValueMode === 0, c = s.Ve(!1);
    if (c.Be) return;
    o && (e.ri = this.Fe(c, o, a), e.It = e.ri.length !== 0), (l || a) && (n.ri = this.We(c, o, l, a), n.It = n.ri.length > 0);
    const u = s.Oe(c.R), h = this.Jt.Qt().Xi().Z(u);
    i.G = h.G, i.Ei = c.Ei, n.Ht = s.Qt().Ut(c.Ei / s.Ft().$t()), e.Ht = u, e.R = h.X, n.R = h.X;
  }
  We(e, n, i, s) {
    let r = "";
    const o = this.Jt.Ne();
    return i && o.length !== 0 && (r += `${o} `), n && s && (r += this.Jt.Ft().He() ? e.Ue : e.$e), r.trim();
  }
  Fe(e, n, i) {
    return n ? i ? this.Jt.Ft().He() ? e.$e : e.Ue : e.ri : "";
  }
}
function wu(t, e, n, i) {
  const s = Number.isFinite(e), r = Number.isFinite(n);
  return s && r ? t(e, n) : s || r ? s ? e : n : i;
}
class De {
  constructor(e, n) {
    this.qe = e, this.je = n;
  }
  Ye(e) {
    return e !== null && this.qe === e.qe && this.je === e.je;
  }
  Ke() {
    return new De(this.qe, this.je);
  }
  Ze() {
    return this.qe;
  }
  Ge() {
    return this.je;
  }
  Xe() {
    return this.je - this.qe;
  }
  Gi() {
    return this.je === this.qe || Number.isNaN(this.je) || Number.isNaN(this.qe);
  }
  Sn(e) {
    return e === null ? this : new De(wu(Math.min, this.Ze(), e.Ze(), -1 / 0), wu(Math.max, this.Ge(), e.Ge(), 1 / 0));
  }
  Je(e) {
    if (!oi(e) || this.je - this.qe === 0) return;
    const n = 0.5 * (this.je + this.qe);
    let i = this.je - n, s = this.qe - n;
    i *= e, s *= e, this.je = n + i, this.qe = n + s;
  }
  Qe(e) {
    oi(e) && (this.je += e, this.qe += e);
  }
  tr() {
    return { minValue: this.qe, maxValue: this.je };
  }
  static ir(e) {
    return e === null ? null : new De(e.minValue, e.maxValue);
  }
}
class ks {
  constructor(e, n) {
    this.sr = e, this.nr = n || null;
  }
  er() {
    return this.sr;
  }
  rr() {
    return this.nr;
  }
  tr() {
    return { priceRange: this.sr === null ? null : this.sr.tr(), margins: this.nr || void 0 };
  }
  static ir(e) {
    return e === null ? null : new ks(De.ir(e.priceRange), e.margins);
  }
}
const i8 = [2, 4, 8, 16, 32, 64, 128, 256, 512], s8 = "Custom series with conflation reducer must have a priceValueBuilder method";
class r8 extends ha {
  constructor(e, n) {
    super(e), this.hr = n;
  }
  he() {
    const e = this.se;
    e.It = !1;
    const n = this.hr.N();
    if (!this.ee.It() || !n.lineVisible) return;
    const i = this.hr.ar();
    i !== null && (e.It = !0, e.ut = i, e.R = n.color, e.ct = n.lineWidth, e.Zt = n.lineStyle, e.te = this.hr.N().id);
  }
}
class o8 extends or {
  constructor(e, n) {
    super(), this.ye = e, this.hr = n;
  }
  Yi(e, n, i) {
    e.It = !1, n.It = !1;
    const s = this.hr.N(), r = s.axisLabelVisible, o = s.title !== "", l = this.ye;
    if (!r || !l.It()) return;
    const a = this.hr.ar();
    if (a === null) return;
    o && (n.ri = s.title, n.It = !0), n.Ht = l.Qt().Ut(a / l.Ft().$t()), e.ri = this.lr(s.price), e.It = !0;
    const c = this.ye.Qt().Xi().Z(s.axisLabelColor || s.color);
    i.G = c.G;
    const u = s.axisLabelTextColor || c.X;
    e.R = u, n.R = u, i.Ei = a;
  }
  lr(e) {
    const n = this.ye.Lt();
    return n === null ? "" : this.ye.Ft().Ji(e, n.Wt);
  }
}
class l8 {
  constructor(e, n) {
    this.ye = e, this.Ps = n, this._r = new r8(e, this), this.jn = new o8(e, this), this.ur = new y2(this.jn, e, e.Qt());
  }
  cr(e) {
    tt(this.Ps, e), this.kt(), this.ye.Qt().dr();
  }
  N() {
    return this.Ps;
  }
  pr() {
    return this._r;
  }
  vr() {
    return this.ur;
  }
  mr() {
    return this.jn;
  }
  kt() {
    this._r.kt(), this.jn.kt();
  }
  ar() {
    const e = this.ye, n = e.Ft();
    if (e.Qt().Et().Gi() || n.Gi()) return null;
    const i = e.Lt();
    return i === null ? null : n.Nt(this.Ps.price, i.Wt);
  }
}
class a8 {
  constructor() {
    this.wr = /* @__PURE__ */ new WeakMap();
  }
  gr(e, n, i) {
    const s = 1 / n * i;
    if (e >= s) return 1;
    const r = s / e, o = Math.pow(2, Math.floor(Math.log2(r)));
    return Math.min(o, 512);
  }
  Mr(e, n, i, s = !1, r) {
    if (e.length === 0 || n <= 1) return e;
    const o = this.br(n);
    if (o <= 1) return e;
    const l = this.Sr(e);
    let a = l.Cr.get(o);
    return a !== void 0 || (a = this.yr(e, o, i, s, r, l.Cr), l.Cr.set(o, a)), a;
  }
  kr(e, n, i, s, r = !1, o) {
    if (i < 1 || e.length === 0) return e;
    const l = this.Sr(e), a = l.Cr.get(i);
    if (!a) return this.Mr(e, i, s, r, o);
    const c = this.Pr(e, n, i, a, r, s, o);
    return l.Cr.set(i, c), c;
  }
  br(e) {
    if (e <= 2) return 2;
    for (const n of i8) if (e <= n) return n;
    return 512;
  }
  Tr(e) {
    if (e.length === 0) return 0;
    const n = e[0], i = e[e.length - 1];
    return 31 * e.length + 17 * n.js + 13 * i.js;
  }
  yr(e, n, i, s = !1, r, o = /* @__PURE__ */ new Map()) {
    if (n === 2) return this.Rr(e, 2, i, s, r);
    const l = n / 2;
    let a = o.get(l);
    return a || (a = this.yr(e, l, i, s, r, o), o.set(l, a)), this.Dr(a, i, s, r);
  }
  Rr(e, n, i, s = !1, r) {
    const o = this.Ir(e, n, i, s, r);
    return this.Vr(o, s);
  }
  Dr(e, n, i = !1, s) {
    const r = this.Ir(e, 2, n, i, s);
    return this.Vr(r, i);
  }
  Ir(e, n, i, s = !1, r) {
    const o = [];
    for (let l = 0; l < e.length; l += n)
      if (e.length - l >= n) {
        const a = this.Br(e[l], e[l + 1], i, s, r);
        a.Er = !1, o.push(a);
      } else if (o.length === 0) o.push(this.Ar(e[l], !0));
      else {
        const a = o[o.length - 1];
        o[o.length - 1] = this.Lr(a, e[l], i, s, r);
      }
    return o;
  }
  zr(e, n) {
    return (e ?? 1) + (n ?? 1);
  }
  Br(e, n, i, s = !1, r) {
    if (!s || !i || !r) {
      const c = e.Wt[1] > n.Wt[1] ? e.Wt[1] : n.Wt[1], u = e.Wt[2] < n.Wt[2] ? e.Wt[2] : n.Wt[2];
      return { Or: e.js, Nr: n.js, Fr: e.wt, Wr: n.wt, Hr: e.Wt[0], Ur: c, $r: u, qr: n.Wt[3], jr: this.zr(e.jr, n.jr), Yr: void 0, Er: !1 };
    }
    const o = i(this.Kr(e, r), this.Kr(n, r)), l = r(o), a = l.length ? l[l.length - 1] : 0;
    return { Or: e.js, Nr: n.js, Fr: e.wt, Wr: n.wt, Hr: e.Wt[0], Ur: Math.max(e.Wt[1], a), $r: Math.min(e.Wt[2], a), qr: a, jr: this.zr(e.jr, n.jr), Yr: o, Er: !1 };
  }
  Lr(e, n, i, s = !1, r) {
    if (!s || !i || !r) return { Or: e.Or, Nr: n.js, Fr: e.Fr, Wr: n.wt, Hr: e.Hr, Ur: e.Ur > n.Wt[1] ? e.Ur : n.Wt[1], $r: e.$r < n.Wt[2] ? e.$r : n.Wt[2], qr: n.Wt[3], jr: e.jr + (n.jr ?? 1), Yr: e.Yr, Er: !1 };
    const o = e.Yr, l = this.Kr(n, r), a = o ? { data: o, index: e.Or, originalTime: e.Fr, time: e.Fr, priceValues: r(o) } : null, c = a ? i(a, l) : l.data, u = a ? r(c) : l.priceValues, h = u.length ? u[u.length - 1] : 0;
    return { Or: e.Or, Nr: n.js, Fr: e.Fr, Wr: n.wt, Hr: e.Hr, Ur: Math.max(e.Ur, h), $r: Math.min(e.$r, h), qr: h, jr: e.jr + (n.jr ?? 1), Yr: c, Er: !1 };
  }
  Zr(e, n, i, s, r, o, l = !1, a) {
    const c = n === s ? r : e[n];
    if (i - n == 1) return this.Ar(c, !0);
    const u = n + 1 === s ? r : e[n + 1];
    let h = this.Br(c, u, o, l, a);
    for (let d = n + 2; d < i; d++) {
      const m = d === s ? r : e[d];
      h = this.Lr(h, m, o, l, a);
    }
    return h;
  }
  Kr(e, n) {
    const i = e.le ?? {};
    return { data: e.le, index: e.js, originalTime: e.Gr, time: e.wt, priceValues: n(i) };
  }
  Xr(e, n = !1) {
    const i = n === !0, s = !!e.Yr;
    return { js: e.Or, wt: e.Fr, Gr: e.Fr, Wt: [i ? e.qr : e.Hr, e.Ur, e.$r, e.qr], jr: e.jr, le: i ? s ? e.Yr : { wt: e.Fr } : void 0 };
  }
  Vr(e, n = !1) {
    return e.map(((i) => this.Xr(i, n)));
  }
  Pr(e, n, i, s, r = !1, o, l) {
    if (s.length === 0) return s;
    const a = e.length - 1, c = Math.floor(a / i) * i;
    if (Math.min(c + i, e.length) - c < i && e.length > i) {
      const u = e.slice();
      return u[u.length - 1] = n, this.Mr(u, i, o, r, l);
    }
    if (Math.floor((a - 1) / i) === Math.floor(a / i) || s.length === 1) {
      const u = Math.min(c + i, e.length), h = u - c;
      if (h <= 0) return s;
      const d = h === 1 ? this.Ar(c === a ? n : e[c], !0) : this.Zr(e, c, u, a, n, o, r, l);
      return s[s.length - 1] = this.Xr(d, r), s;
    }
    {
      const u = e.slice();
      return u[u.length - 1] = n, this.Mr(u, i, o, r, l);
    }
  }
  Ar(e, n = !1) {
    return { Or: e.js, Nr: e.js, Fr: e.wt, Wr: e.wt, Hr: e.Wt[0], Ur: e.Wt[1], $r: e.Wt[2], qr: e.Wt[3], jr: e.jr ?? 1, Yr: e.le, Er: n };
  }
  Sr(e) {
    const n = this.Jr(e), i = this.Tr(e);
    return n.Qr !== i && (n.Cr.clear(), n.Qr = i), n;
  }
  Jr(e) {
    let n = this.wr.get(e);
    return n === void 0 && (n = { Qr: this.Tr(e), Cr: /* @__PURE__ */ new Map() }, this.wr.set(e, n)), n;
  }
}
class c8 extends V2 {
  constructor(e) {
    super(), this.ns = e;
  }
  Qt() {
    return this.ns;
  }
}
const u8 = { Bar: (t, e, n, i) => {
  const s = e.upColor, r = e.downColor, o = H(t(n, i)), l = an(o.Wt[0]) <= an(o.Wt[3]);
  return { th: o.R ?? (l ? s : r) };
}, Candlestick: (t, e, n, i) => {
  const s = e.upColor, r = e.downColor, o = e.borderUpColor, l = e.borderDownColor, a = e.wickUpColor, c = e.wickDownColor, u = H(t(n, i)), h = an(u.Wt[0]) <= an(u.Wt[3]);
  return { th: u.R ?? (h ? s : r), ih: u.Ht ?? (h ? o : l), sh: u.nh ?? (h ? a : c) };
}, Custom: (t, e, n, i) => ({ th: H(t(n, i)).R ?? e.color }), Area: (t, e, n, i) => {
  const s = H(t(n, i));
  return { th: s.vt ?? e.lineColor, vt: s.vt ?? e.lineColor, eh: s.eh ?? e.topColor, rh: s.rh ?? e.bottomColor };
}, Baseline: (t, e, n, i) => {
  const s = H(t(n, i));
  return { th: s.Wt[3] >= e.baseValue.price ? e.topLineColor : e.bottomLineColor, hh: s.hh ?? e.topLineColor, ah: s.ah ?? e.bottomLineColor, oh: s.oh ?? e.topFillColor1, _h: s._h ?? e.topFillColor2, uh: s.uh ?? e.bottomFillColor1, dh: s.dh ?? e.bottomFillColor2 };
}, Line: (t, e, n, i) => {
  const s = H(t(n, i));
  return { th: s.R ?? e.color, vt: s.R ?? e.color };
}, Histogram: (t, e, n, i) => ({ th: H(t(n, i)).R ?? e.color }) };
class h8 {
  constructor(e) {
    this.fh = (n, i) => i !== void 0 ? i.Wt : this.ye.qs().ph(n), this.ye = e, this.mh = u8[e.wh()];
  }
  gh(e, n) {
    return this.mh(this.fh, this.ye.N(), e, n);
  }
}
function C2(t, e, n, i, s = 0, r = e.length) {
  let o = r - s;
  for (; 0 < o; ) {
    const l = o >> 1, a = s + l;
    i(e[a], n) === t ? (s = a + 1, o -= l + 1) : o = l;
  }
  return s;
}
const li = C2.bind(null, !0), W2 = C2.bind(null, !1);
var Yu;
(function(t) {
  t[t.NearestLeft = -1] = "NearestLeft", t[t.None = 0] = "None", t[t.NearestRight = 1] = "NearestRight";
})(Yu || (Yu = {}));
const tn = 30;
class d8 {
  constructor() {
    this.Mh = [], this.bh = /* @__PURE__ */ new Map(), this.Sh = /* @__PURE__ */ new Map(), this.xh = [];
  }
  Ch() {
    return this.yh() > 0 ? this.Mh[this.Mh.length - 1] : null;
  }
  kh() {
    return this.yh() > 0 ? this.Ph(0) : null;
  }
  sn() {
    return this.yh() > 0 ? this.Ph(this.Mh.length - 1) : null;
  }
  yh() {
    return this.Mh.length;
  }
  Gi() {
    return this.yh() === 0;
  }
  Ee(e) {
    return this.Th(e, 0) !== null;
  }
  ph(e) {
    return this.$s(e);
  }
  $s(e, n = 0) {
    const i = this.Th(e, n);
    return i === null ? null : { ...this.Rh(i), js: this.Ph(i) };
  }
  Dh() {
    return this.Mh;
  }
  Ih(e, n, i) {
    if (this.Gi()) return null;
    let s = null;
    for (const r of i)
      s = as(s, this.Vh(e, n, r));
    return s;
  }
  ht(e) {
    this.Sh.clear(), this.bh.clear(), this.Mh = e, this.xh = e.map(((n) => n.js));
  }
  Bh() {
    return this.xh;
  }
  Ph(e) {
    return this.Mh[e].js;
  }
  Rh(e) {
    return this.Mh[e];
  }
  Th(e, n) {
    const i = this.Eh(e);
    if (i === null && n !== 0) switch (n) {
      case -1:
        return this.Ah(e);
      case 1:
        return this.Lh(e);
      default:
        throw new TypeError("Unknown search mode");
    }
    return i;
  }
  Ah(e) {
    let n = this.zh(e);
    return n > 0 && (n -= 1), n !== this.Mh.length && this.Ph(n) < e ? n : null;
  }
  Lh(e) {
    const n = this.Oh(e);
    return n !== this.Mh.length && e < this.Ph(n) ? n : null;
  }
  Eh(e) {
    const n = this.zh(e);
    return n === this.Mh.length || e < this.Mh[n].js ? null : n;
  }
  zh(e) {
    return li(this.Mh, e, ((n, i) => n.js < i));
  }
  Oh(e) {
    return W2(this.Mh, e, ((n, i) => n.js > i));
  }
  Nh(e, n, i) {
    let s = null;
    for (let r = e; r < n; r++) {
      const o = this.Mh[r].Wt[i];
      Number.isNaN(o) || (s === null ? s = { Fh: o, Wh: o } : (o < s.Fh && (s.Fh = o), o > s.Wh && (s.Wh = o)));
    }
    return s;
  }
  Vh(e, n, i) {
    if (this.Gi()) return null;
    let s = null;
    const r = H(this.kh()), o = H(this.sn()), l = Math.max(e, r), a = Math.min(n, o), c = Math.ceil(l / tn) * tn, u = Math.max(c, Math.floor(a / tn) * tn);
    {
      const d = this.zh(l), m = this.Oh(Math.min(a, c, n));
      s = as(s, this.Nh(d, m, i));
    }
    let h = this.bh.get(i);
    h === void 0 && (h = /* @__PURE__ */ new Map(), this.bh.set(i, h));
    for (let d = Math.max(c + 1, l); d < u; d += tn) {
      const m = Math.floor(d / tn);
      let p = h.get(m);
      if (p === void 0) {
        const g = this.zh(m * tn), A = this.Oh((m + 1) * tn - 1);
        p = this.Nh(g, A, i), h.set(m, p);
      }
      s = as(s, p);
    }
    {
      const d = this.zh(u), m = this.Oh(a);
      s = as(s, this.Nh(d, m, i));
    }
    return s;
  }
}
function as(t, e) {
  return t === null ? e : e === null ? t : { Fh: Math.min(t.Fh, e.Fh), Wh: Math.max(t.Wh, e.Wh) };
}
function lo() {
  return new d8();
}
const Js = { setLineStyle: vn };
class m8 {
  constructor(e) {
    this.Hh = e;
  }
  nt(e, n, i) {
    this.Hh.draw(e, Js);
  }
  Uh(e, n, i) {
    this.Hh.drawBackground?.(e, Js);
  }
}
class p8 {
  constructor(e) {
    this.Ln = null, this.$h = e;
  }
  Tt() {
    const e = this.$h.renderer();
    if (e === null) return null;
    if (this.Ln?.qh === e) return this.Ln.jh;
    const n = new m8(e);
    return this.Ln = { qh: e, jh: n }, n;
  }
  Yh() {
    return this.$h.zOrder?.() ?? "normal";
  }
}
class S2 {
  constructor(e) {
    this.Kh = null, this.Zh = e;
  }
  Gh() {
    return this.Zh;
  }
  Ws() {
    this.Zh.updateAllViews?.();
  }
  Ys() {
    const e = this.Zh.paneViews?.() ?? [];
    if (this.Kh?.qh === e) return this.Kh.jh;
    const n = e.map(((i) => new p8(i)));
    return this.Kh = { qh: e, jh: n }, n;
  }
  Qn(e, n) {
    return this.Zh.hitTest?.(e, n) ?? null;
  }
}
let g8 = class extends S2 {
  ds() {
    return [];
  }
};
class f8 {
  constructor(e) {
    this.Hh = e;
  }
  nt(e, n, i) {
    this.Hh.draw(e, Js);
  }
  Uh(e, n, i) {
    this.Hh.drawBackground?.(e, Js);
  }
}
class Tu {
  constructor(e) {
    this.Ln = null, this.$h = e;
  }
  Tt() {
    const e = this.$h.renderer();
    if (e === null) return null;
    if (this.Ln?.qh === e) return this.Ln.jh;
    const n = new f8(e);
    return this.Ln = { qh: e, jh: n }, n;
  }
  Yh() {
    return this.$h.zOrder?.() ?? "normal";
  }
}
function Z2(t) {
  return { ri: t.text(), Ei: t.coordinate(), Vi: t.fixedCoordinate?.(), R: t.textColor(), G: t.backColor(), It: t.visible?.() ?? !0, pi: t.tickVisible?.() ?? !0 };
}
class b8 {
  constructor(e, n) {
    this.Xt = new A2(), this.Xh = e, this.Jh = n;
  }
  Tt() {
    return this.Xt.ht({ ss: this.Jh.ss(), ...Z2(this.Xh) }), this.Xt;
  }
}
class A8 extends or {
  constructor(e, n) {
    super(), this.Xh = e, this.Ki = n;
  }
  Yi(e, n, i) {
    const s = Z2(this.Xh);
    i.G = s.G, e.R = s.R;
    const r = 2 / 12 * this.Ki.k();
    i.Ti = r, i.Ri = r, i.Ei = s.Ei, i.Vi = s.Vi, e.ri = s.ri, e.It = s.It, e.pi = s.pi;
  }
}
class V8 extends S2 {
  constructor(e, n) {
    super(e), this.Qh = null, this.ta = null, this.ia = null, this.sa = null, this.ye = n;
  }
  fs() {
    const e = this.Zh.timeAxisViews?.() ?? [];
    if (this.Qh?.qh === e) return this.Qh.jh;
    const n = this.ye.Qt().Et(), i = e.map(((s) => new b8(s, n)));
    return this.Qh = { qh: e, jh: i }, i;
  }
  Ks() {
    const e = this.Zh.priceAxisViews?.() ?? [];
    if (this.ta?.qh === e) return this.ta.jh;
    const n = this.ye.Ft(), i = e.map(((s) => new A8(s, n)));
    return this.ta = { qh: e, jh: i }, i;
  }
  na() {
    const e = this.Zh.priceAxisPaneViews?.() ?? [];
    if (this.ia?.qh === e) return this.ia.jh;
    const n = e.map(((i) => new Tu(i)));
    return this.ia = { qh: e, jh: n }, n;
  }
  ea() {
    const e = this.Zh.timeAxisPaneViews?.() ?? [];
    if (this.sa?.qh === e) return this.sa.jh;
    const n = e.map(((i) => new Tu(i)));
    return this.sa = { qh: e, jh: n }, n;
  }
  ra(e, n) {
    return this.Zh.autoscaleInfo?.(e, n) ?? null;
  }
}
function ao(t, e, n, i) {
  t.forEach(((s) => {
    e(s).forEach(((r) => {
      r.Yh() === n && i.push(r);
    }));
  }));
}
function co(t) {
  return t.Ys();
}
function R8(t) {
  return t.na();
}
function E8(t) {
  return t.ea();
}
const y8 = ["Area", "Line", "Baseline"];
class cr extends c8 {
  constructor(e, n, i, s, r) {
    super(e), this.jt = lo(), this._r = new t8(this), this.ha = [], this.aa = new j4(this), this.la = null, this.oa = null, this._a = null, this.ua = [], this.ca = new a8(), this.da = /* @__PURE__ */ new Map(), this.fa = null, this.Ps = i, this.pa = n;
    const o = new n8(this);
    if (this.gs = [o], this.ur = new y2(o, this, e), y8.includes(this.pa) && (this.la = new e8(this)), this.va(), this.$h = s(this, this.Qt(), r), this.pa === "Custom") {
      const l = this.$h;
      l.ma && this.wa(l.ma);
    }
  }
  m() {
    this._a !== null && clearTimeout(this._a);
  }
  Oe(e) {
    return this.Ps.priceLineColor || e;
  }
  Ve(e) {
    const n = { Be: !0 }, i = this.Ft();
    if (this.Qt().Et().Gi() || i.Gi() || this.jt.Gi()) return n;
    const s = this.Qt().Et().Ie(), r = this.Lt();
    if (s === null || r === null) return n;
    let o, l;
    if (e) {
      const h = this.jt.Ch();
      if (h === null) return n;
      o = h, l = h.js;
    } else {
      const h = this.jt.$s(s.bi(), -1);
      if (h === null || (o = this.jt.ph(h.js), o === null)) return n;
      l = h.js;
    }
    const a = o.Wt[3], c = this.ga().gh(l, { Wt: o }), u = i.Nt(a, r.Wt);
    return { Be: !1, gt: a, ri: i.Ji(a, r.Wt), Ue: i.Ma(a), $e: i.ba(a, r.Wt), R: c.th, Ei: u, js: l };
  }
  ga() {
    return this.oa !== null || (this.oa = new h8(this)), this.oa;
  }
  N() {
    return this.Ps;
  }
  cr(e) {
    const n = this.Qt(), { priceScaleId: i, visible: s, priceFormat: r } = e;
    i !== void 0 && i !== this.Ps.priceScaleId && n.Sa(this, i), s !== void 0 && s !== this.Ps.visible && n.xa();
    const o = e.conflationThresholdFactor !== void 0;
    tt(this.Ps, e), o && (this.da.clear(), this.Qt().dr()), r !== void 0 && (this.va(), n.Ca()), n.ya(this), n.ka(), this.$h.kt("options");
  }
  ht(e, n) {
    this.jt.ht(e), this.da.clear();
    const i = this.Qt().Et().N();
    i.enableConflation && i.precomputeConflationOnInit && this.Pa(i.precomputeConflationPriority), this.$h.kt("data"), this.la !== null && (n && n.Ta ? this.la.Pe() : e.length === 0 && this.la.ke());
    const s = this.Qt().Kn(this);
    this.Qt().Ra(s), this.Qt().ya(this), this.Qt().ka(), this.Qt().dr();
  }
  Da(e) {
    const n = new l8(this, e);
    return this.ha.push(n), this.Qt().ya(this), n;
  }
  Ia(e) {
    const n = this.ha.indexOf(e);
    n !== -1 && this.ha.splice(n, 1), this.Qt().ya(this);
  }
  Va() {
    return this.ha;
  }
  wh() {
    return this.pa;
  }
  Lt() {
    const e = this.Ba();
    return e === null ? null : { Wt: e.Wt[3], Ea: e.wt };
  }
  Ba() {
    const e = this.Qt().Et().Ie();
    if (e === null) return null;
    const n = e.Aa();
    return this.jt.$s(n, 1);
  }
  qs() {
    return this.jt;
  }
  wa(e) {
    this.fa = e, this.da.clear();
  }
  La() {
    return !!this.Qt().Et().N().enableConflation && this.za() > 1;
  }
  kr(e) {
    if (!this.La()) return;
    const n = this.za();
    if (!this.da.has(n)) return;
    const i = this.pa === "Custom", s = i && this.fa || void 0, r = i && this.$h.Oa ? (a) => {
      const c = a, u = this.$h.Oa(c);
      return Array.isArray(u) ? u : [typeof u == "number" ? u : 0];
    } : void 0, o = this.ca.kr(this.jt.Dh(), e, n, s, i, r), l = lo();
    l.ht(o), this.da.set(n, l);
  }
  Na() {
    const e = this.Qt().Et().N().enableConflation;
    if (this.pa === "Custom" && this.fa === null) return this.jt;
    if (!e) return this.jt;
    const n = this.za(), i = this.da.get(n);
    return i || (this.Fa(n), this.da.get(n) ?? this.jt);
  }
  Wa(e) {
    const n = this.jt.ph(e);
    return n === null ? null : this.pa === "Bar" || this.pa === "Candlestick" || this.pa === "Custom" ? { Hr: n.Wt[0], Ur: n.Wt[1], $r: n.Wt[2], qr: n.Wt[3] } : n.Wt[3];
  }
  Ha(e) {
    const n = [];
    ao(this.ua, co, "top", n);
    const i = this.la;
    return i !== null && i.It() && (this._a === null && i.Re() && (this._a = setTimeout((() => {
      this._a = null, this.Qt().Ua();
    }), 0)), i.Te(), n.unshift(i)), n;
  }
  Ys() {
    const e = [];
    this.$a() || e.push(this.aa), e.push(this.$h, this._r);
    const n = this.ha.map(((i) => i.pr()));
    return e.push(...n), ao(this.ua, co, "normal", e), e;
  }
  qa() {
    return this.ja(co, "bottom");
  }
  Ya(e) {
    return this.ja(R8, e);
  }
  Ka(e) {
    return this.ja(E8, e);
  }
  Za(e, n) {
    return this.ua.map(((i) => i.Qn(e, n))).filter(((i) => i !== null));
  }
  ds() {
    return [this.ur, ...this.ha.map(((e) => e.vr()))];
  }
  Ks(e, n) {
    if (n !== this.hs && !this.$a()) return [];
    const i = [...this.gs];
    for (const s of this.ha) i.push(s.mr());
    return this.ua.forEach(((s) => {
      i.push(...s.Ks());
    })), i;
  }
  fs() {
    const e = [];
    return this.ua.forEach(((n) => {
      e.push(...n.fs());
    })), e;
  }
  ra(e, n) {
    if (this.Ps.autoscaleInfoProvider !== void 0) {
      const i = this.Ps.autoscaleInfoProvider((() => {
        const s = this.Ga(e, n);
        return s === null ? null : s.tr();
      }));
      return ks.ir(i);
    }
    return this.Ga(e, n);
  }
  qh() {
    const e = this.Ps.priceFormat;
    return e.base ?? 1 / e.minMove;
  }
  Xa() {
    return this.Ja;
  }
  Ws() {
    this.$h.kt();
    for (const e of this.gs) e.kt();
    for (const e of this.ha) e.kt();
    this._r.kt(), this.aa.kt(), this.la?.kt(), this.ua.forEach(((e) => e.Ws()));
  }
  Ft() {
    return H(super.Ft());
  }
  At(e) {
    if (!((this.pa === "Line" || this.pa === "Area" || this.pa === "Baseline") && this.Ps.crosshairMarkerVisible)) return null;
    const n = this.jt.ph(e);
    return n === null ? null : { gt: n.Wt[3], ft: this.Qa(), Ht: this.tl(), Ot: this.il(), zt: this.sl(e) };
  }
  Ne() {
    return this.Ps.title;
  }
  It() {
    return this.Ps.visible;
  }
  nl(e) {
    this.ua.push(new V8(e, this));
  }
  el(e) {
    this.ua = this.ua.filter(((n) => n.Gh() !== e));
  }
  rl() {
    if (this.pa === "Custom") return (e) => this.$h.Oa(e);
  }
  hl() {
    if (this.pa === "Custom") return (e) => this.$h.al(e);
  }
  ll() {
    return this.jt.Bh();
  }
  $a() {
    return !lr(this.Ft().ol());
  }
  Ga(e, n) {
    if (!Bi(e) || !Bi(n) || this.jt.Gi()) return null;
    const i = this.pa === "Line" || this.pa === "Area" || this.pa === "Baseline" || this.pa === "Histogram" ? [3] : [2, 1], s = this.jt.Ih(e, n, i);
    let r = s !== null ? new De(s.Fh, s.Wh) : null, o = null;
    if (this.wh() === "Histogram") {
      const l = this.Ps.base, a = new De(l, l);
      r = r !== null ? r.Sn(a) : a;
    }
    return this.ua.forEach(((l) => {
      const a = l.ra(e, n);
      if (a?.priceRange) {
        const c = new De(a.priceRange.minValue, a.priceRange.maxValue);
        r = r !== null ? r.Sn(c) : c;
      }
      a?.margins && (o = a.margins);
    })), new ks(r, o);
  }
  Qa() {
    switch (this.pa) {
      case "Line":
      case "Area":
      case "Baseline":
        return this.Ps.crosshairMarkerRadius;
    }
    return 0;
  }
  tl() {
    switch (this.pa) {
      case "Line":
      case "Area":
      case "Baseline": {
        const e = this.Ps.crosshairMarkerBorderColor;
        if (e.length !== 0) return e;
      }
    }
    return null;
  }
  il() {
    switch (this.pa) {
      case "Line":
      case "Area":
      case "Baseline":
        return this.Ps.crosshairMarkerBorderWidth;
    }
    return 0;
  }
  sl(e) {
    switch (this.pa) {
      case "Line":
      case "Area":
      case "Baseline": {
        const n = this.Ps.crosshairMarkerBackgroundColor;
        if (n.length !== 0) return n;
      }
    }
    return this.ga().gh(e).th;
  }
  va() {
    switch (this.Ps.priceFormat.type) {
      case "custom": {
        const e = this.Ps.priceFormat.formatter;
        this.Ja = { format: e, formatTickmarks: this.Ps.priceFormat.tickmarksFormatter ?? ((n) => n.map(e)) };
        break;
      }
      case "volume":
        this.Ja = new O4(this.Ps.priceFormat.precision);
        break;
      case "percent":
        this.Ja = new E2(this.Ps.priceFormat.precision);
        break;
      default: {
        const e = Math.pow(10, this.Ps.priceFormat.precision);
        this.Ja = new ar(e, this.Ps.priceFormat.minMove * e);
      }
    }
    this.hs !== null && this.hs._l();
  }
  ja(e, n) {
    const i = [];
    return ao(this.ua, e, n, i), i;
  }
  za() {
    const { ul: e, cl: n, dl: i } = this.fl();
    return this.ca.gr(e, n, i);
  }
  fl() {
    const e = this.Qt().Et(), n = e.ul(), i = window.devicePixelRatio || 1, s = e.N().conflationThresholdFactor;
    return { ul: n, cl: i, dl: this.Ps.conflationThresholdFactor ?? s ?? 1 };
  }
  pl(e) {
    const n = this.jt.Dh();
    let i;
    if (this.pa === "Custom" && this.fa !== null) {
      const r = this.rl();
      if (!r) throw new Error(s8);
      i = this.ca.Mr(n, e, this.fa, !0, ((o) => r(o)));
    } else i = this.ca.Mr(n, e);
    const s = lo();
    return s.ht(i), s;
  }
  Fa(e) {
    const n = this.pl(e);
    this.da.set(e, n);
  }
  Pa(e) {
    if (this.pa === "Custom" && (this.fa === null || !this.rl())) return;
    this.da.clear();
    const n = this.Qt().Et().vl();
    for (const i of n) {
      const s = () => {
        this.ml(i);
      }, r = typeof window == "object" && window || typeof self == "object" && self;
      r?.gl?.wl ? r.gl.wl((() => {
        s();
      }), { Ml: e }) : Promise.resolve().then((() => s()));
    }
  }
  ml(e) {
    if (this.da.has(e) || this.jt.Dh().length === 0) return;
    const n = this.pl(e);
    this.da.set(e, n);
  }
}
const C8 = [3], W8 = [0, 1, 2, 3];
class S8 {
  constructor(e) {
    this.Ps = e;
  }
  bl(e, n, i) {
    let s = e;
    if (this.Ps.mode === 0) return s;
    const r = i.Rs(), o = r.Lt();
    if (o === null) return s;
    const l = r.Nt(e, o), a = i.Sl().filter(((u) => u instanceof cr)).reduce(((u, h) => {
      if (i.Zn(h) || !h.It()) return u;
      const d = h.Ft(), m = h.qs();
      if (d.Gi() || !m.Ee(n)) return u;
      const p = m.ph(n);
      if (p === null) return u;
      const g = an(h.Lt()), A = this.Ps.mode === 3 ? W8 : C8;
      return u.concat(A.map(((b) => d.Nt(p.Wt[b], g.Wt))));
    }), []);
    if (a.length === 0) return s;
    a.sort(((u, h) => Math.abs(u - l) - Math.abs(h - l)));
    const c = a[0];
    return s = r.Ds(c, o), s;
  }
}
function Wi(t, e, n) {
  return Math.min(Math.max(t, e), n);
}
function cs(t, e, n) {
  return e - t <= n;
}
class Z8 extends di {
  constructor() {
    super(...arguments), this.jt = null;
  }
  ht(e) {
    this.jt = e;
  }
  et({ context: e, bitmapSize: n, horizontalPixelRatio: i, verticalPixelRatio: s }) {
    if (this.jt === null) return;
    const r = Math.max(1, Math.floor(i));
    e.lineWidth = r, (function(o, l) {
      o.save(), o.lineWidth % 2 && o.translate(0.5, 0.5), l(), o.restore();
    })(e, (() => {
      const o = H(this.jt);
      if (o.xl) {
        e.strokeStyle = o.Cl, vn(e, o.yl), e.beginPath();
        for (const l of o.kl) {
          const a = Math.round(l.Pl * i);
          e.moveTo(a, -r), e.lineTo(a, n.height + r);
        }
        e.stroke();
      }
      if (o.Tl) {
        e.strokeStyle = o.Rl, vn(e, o.Dl), e.beginPath();
        for (const l of o.Il) {
          const a = Math.round(l.Pl * s);
          e.moveTo(-r, a), e.lineTo(n.width + r, a);
        }
        e.stroke();
      }
    }));
  }
}
class v8 {
  constructor(e) {
    this.Xt = new Z8(), this.xt = !0, this.yt = e;
  }
  kt() {
    this.xt = !0;
  }
  Tt() {
    if (this.xt) {
      const e = this.yt.Qt().N().grid, n = { Tl: e.horzLines.visible, xl: e.vertLines.visible, Rl: e.horzLines.color, Cl: e.vertLines.color, Dl: e.horzLines.style, yl: e.vertLines.style, Il: this.yt.Rs().Vl(), kl: (this.yt.Qt().Et().Vl() || []).map(((i) => ({ Pl: i.coord }))) };
      this.Xt.ht(n), this.xt = !1;
    }
    return this.Xt;
  }
}
class I8 {
  constructor(e) {
    this.$h = new v8(e);
  }
  pr() {
    return this.$h;
  }
}
const uo = { Bl: 4, El: 1e-4 };
function On(t, e) {
  const n = 100 * (t - e) / e;
  return e < 0 ? -n : n;
}
function N8(t, e) {
  const n = On(t.Ze(), e), i = On(t.Ge(), e);
  return new De(n, i);
}
function Si(t, e) {
  const n = 100 * (t - e) / e + 100;
  return e < 0 ? -n : n;
}
function F8(t, e) {
  const n = Si(t.Ze(), e), i = Si(t.Ge(), e);
  return new De(n, i);
}
function xs(t, e) {
  const n = Math.abs(t);
  if (n < 1e-15) return 0;
  const i = Math.log10(n + e.El) + e.Bl;
  return t < 0 ? -i : i;
}
function Zi(t, e) {
  const n = Math.abs(t);
  if (n < 1e-15) return 0;
  const i = Math.pow(10, n - e.Bl) - e.El;
  return t < 0 ? -i : i;
}
function bi(t, e) {
  if (t === null) return null;
  const n = xs(t.Ze(), e), i = xs(t.Ge(), e);
  return new De(n, i);
}
function Dn(t, e) {
  if (t === null) return null;
  const n = Zi(t.Ze(), e), i = Zi(t.Ge(), e);
  return new De(n, i);
}
function ho(t) {
  if (t === null) return uo;
  const e = Math.abs(t.Ge() - t.Ze());
  if (e >= 1 || e < 1e-15) return uo;
  const n = Math.ceil(Math.abs(Math.log10(e))), i = uo.Bl + n;
  return { Bl: i, El: 1 / Math.pow(10, i) };
}
class mo {
  constructor(e, n) {
    if (this.Al = e, this.Ll = n, (function(i) {
      if (i < 0) return !1;
      if (i > 1e18) return !0;
      for (let s = i; s > 1; s /= 10) if (s % 10 != 0) return !1;
      return !0;
    })(this.Al)) this.zl = [2, 2.5, 2];
    else {
      this.zl = [];
      for (let i = this.Al; i !== 1; ) {
        if (i % 2 == 0) this.zl.push(2), i /= 2;
        else {
          if (i % 5 != 0) throw new Error("unexpected base");
          this.zl.push(2, 2.5), i /= 5;
        }
        if (this.zl.length > 100) throw new Error("something wrong with base");
      }
    }
  }
  Ol(e, n, i) {
    const s = this.Al === 0 ? 0 : 1 / this.Al;
    let r = Math.pow(10, Math.max(0, Math.ceil(Math.log10(e - n)))), o = 0, l = this.Ll[0];
    for (; ; ) {
      const h = cs(r, s, 1e-14) && r > s + 1e-14, d = cs(r, i * l, 1e-14), m = cs(r, 1, 1e-14);
      if (!(h && d && m)) break;
      r /= l, l = this.Ll[++o % this.Ll.length];
    }
    if (r <= s + 1e-14 && (r = s), r = Math.max(1, r), this.zl.length > 0 && (a = r, c = 1, u = 1e-14, Math.abs(a - c) < u)) for (o = 0, l = this.zl[0]; cs(r, i * l, 1e-14) && r > s + 1e-14; ) r /= l, l = this.zl[++o % this.zl.length];
    var a, c, u;
    return r;
  }
}
class Lu {
  constructor(e, n, i, s) {
    this.Nl = [], this.Ki = e, this.Al = n, this.Fl = i, this.Wl = s;
  }
  Ol(e, n) {
    if (e < n) throw new Error("high < low");
    const i = this.Ki.$t(), s = (e - n) * this.Hl() / i, r = new mo(this.Al, [2, 2.5, 2]), o = new mo(this.Al, [2, 2, 2.5]), l = new mo(this.Al, [2.5, 2, 2]), a = [];
    return a.push(r.Ol(e, n, s), o.Ol(e, n, s), l.Ol(e, n, s)), (function(c) {
      if (c.length < 1) throw Error("array is empty");
      let u = c[0];
      for (let h = 1; h < c.length; ++h) c[h] < u && (u = c[h]);
      return u;
    })(a);
  }
  Ul() {
    const e = this.Ki, n = e.Lt();
    if (n === null) return void (this.Nl = []);
    const i = e.$t(), s = this.Fl(i - 1, n), r = this.Fl(0, n), o = this.Ki.N().entireTextOnly ? this.$l() / 2 : 0, l = o, a = i - 1 - o, c = Math.max(s, r), u = Math.min(s, r);
    if (c === u) return void (this.Nl = []);
    const h = this.Ol(c, u);
    if (this.ql(n, h, c, u, l, a), e.jl() && this.Yl(h, u, c)) {
      const p = this.Ki.Kl();
      this.Zl(n, h, l, a, p, 2 * p);
    }
    const d = this.Nl.map(((p) => p.Gl)), m = this.Ki.Xl(d);
    for (let p = 0; p < this.Nl.length; p++) this.Nl[p].Jl = m[p];
  }
  Vl() {
    return this.Nl;
  }
  $l() {
    return this.Ki.k();
  }
  Hl() {
    return Math.ceil(2.5 * this.$l());
  }
  ql(e, n, i, s, r, o) {
    const l = this.Nl, a = this.Ki;
    let c = i % n;
    c += c < 0 ? n : 0;
    const u = i >= s ? 1 : -1;
    let h = null, d = 0;
    for (let m = i - c; m > s; m -= n) {
      const p = this.Wl(m, e, !0);
      h !== null && Math.abs(p - h) < this.Hl() || p < r || p > o || (d < l.length ? (l[d].Pl = p, l[d].Jl = a.Ql(m), l[d].Gl = m) : l.push({ Pl: p, Jl: a.Ql(m), Gl: m }), d++, h = p, a.io() && (n = this.Ol(m * u, s)));
    }
    l.length = d;
  }
  Zl(e, n, i, s, r, o) {
    const l = this.Nl, a = this.so(e, i, r, o), c = this.so(e, s, -o, -r), u = this.Wl(0, e, !0) - this.Wl(n, e, !0);
    l.length > 0 && l[0].Pl - a.Pl < u / 2 && l.shift(), l.length > 0 && c.Pl - l[l.length - 1].Pl < u / 2 && l.pop(), l.unshift(a), l.push(c);
  }
  so(e, n, i, s) {
    const r = (i + s) / 2, o = this.Fl(n + i, e), l = this.Fl(n + s, e), a = Math.min(o, l), c = Math.max(o, l), u = Math.max(0.1, this.Ol(c, a)), h = this.Fl(n + r, e), d = h - h % u, m = this.Wl(d, e, !0);
    return { Jl: this.Ki.Ql(d), Pl: m, Gl: d };
  }
  Yl(e, n, i) {
    let s = an(this.Ki.er());
    return this.Ki.io() && (s = Dn(s, this.Ki.no())), s.Ze() - n < e && i - s.Ge() < e;
  }
}
function v2(t) {
  return t.slice().sort(((e, n) => H(e._s()) - H(n._s())));
}
var ku;
(function(t) {
  t[t.Normal = 0] = "Normal", t[t.Logarithmic = 1] = "Logarithmic", t[t.Percentage = 2] = "Percentage", t[t.IndexedTo100 = 3] = "IndexedTo100";
})(ku || (ku = {}));
const Ju = new E2(), xu = new ar(100, 1);
class G8 {
  constructor(e, n, i, s, r) {
    this.eo = 0, this.ro = null, this.sr = null, this.ho = null, this.ao = { lo: !1, oo: null }, this._o = !1, this.uo = 0, this.co = 0, this.do = new Ye(), this.fo = new Ye(), this.po = [], this.vo = null, this.mo = null, this.wo = null, this.Mo = null, this.bo = null, this.Ja = xu, this.So = ho(null), this.xo = e, this.Ps = n, this.Co = i, this.yo = s, this.ko = r, this.Po = new Lu(this, 100, this.To.bind(this), this.Ro.bind(this));
  }
  ol() {
    return this.xo;
  }
  N() {
    return this.Ps;
  }
  cr(e) {
    if (tt(this.Ps, e), this._l(), e.mode !== void 0 && this.Do({ ae: e.mode }), e.scaleMargins !== void 0) {
      const n = $e(e.scaleMargins.top), i = $e(e.scaleMargins.bottom);
      if (n < 0 || n > 1) throw new Error(`Invalid top margin - expect value between 0 and 1, given=${n}`);
      if (i < 0 || i > 1) throw new Error(`Invalid bottom margin - expect value between 0 and 1, given=${i}`);
      if (n + i > 1) throw new Error(`Invalid margins - sum of margins must be less than 1, given=${n + i}`);
      this.Io(), this.wo = null;
    }
  }
  Vo() {
    return this.Ps.autoScale;
  }
  Bo() {
    return this._o;
  }
  io() {
    return this.Ps.mode === 1;
  }
  He() {
    return this.Ps.mode === 2;
  }
  Eo() {
    return this.Ps.mode === 3;
  }
  no() {
    return this.So;
  }
  ae() {
    return { ln: this.Ps.autoScale, Ao: this.Ps.invertScale, ae: this.Ps.mode };
  }
  Do(e) {
    const n = this.ae();
    let i = null;
    e.ln !== void 0 && (this.Ps.autoScale = e.ln), e.ae !== void 0 && (this.Ps.mode = e.ae, e.ae !== 2 && e.ae !== 3 || (this.Ps.autoScale = !0), this.ao.lo = !1), n.ae === 1 && e.ae !== n.ae && ((function(r, o) {
      if (r === null) return !1;
      const l = Zi(r.Ze(), o), a = Zi(r.Ge(), o);
      return isFinite(l) && isFinite(a);
    })(this.sr, this.So) ? (i = Dn(this.sr, this.So), i !== null && this.Lo(i)) : this.Ps.autoScale = !0), e.ae === 1 && e.ae !== n.ae && (i = bi(this.sr, this.So), i !== null && this.Lo(i));
    const s = n.ae !== this.Ps.mode;
    s && (n.ae === 2 || this.He()) && this._l(), s && (n.ae === 3 || this.Eo()) && this._l(), e.Ao !== void 0 && n.Ao !== e.Ao && (this.Ps.invertScale = e.Ao, this.zo()), this.fo.p(n, this.ae());
  }
  Oo() {
    return this.fo;
  }
  k() {
    return this.Co.fontSize;
  }
  $t() {
    return this.eo;
  }
  No(e) {
    this.eo !== e && (this.eo = e, this.Io(), this.wo = null);
  }
  Fo() {
    if (this.ro) return this.ro;
    const e = this.$t() - this.Wo() - this.Ho();
    return this.ro = e, e;
  }
  er() {
    return this.Uo(), this.sr;
  }
  Lo(e, n) {
    const i = this.sr;
    (n || i === null && e !== null || i !== null && !i.Ye(e)) && (this.wo = null, this.sr = e);
  }
  $o(e) {
    this.Lo(e), this.qo(e !== null);
  }
  Gi() {
    return this.Uo(), this.eo === 0 || !this.sr || this.sr.Gi();
  }
  jo(e) {
    return this.Ao() ? e : this.$t() - 1 - e;
  }
  Nt(e, n) {
    return this.He() ? e = On(e, n) : this.Eo() && (e = Si(e, n)), this.Ro(e, n);
  }
  Yo(e, n, i) {
    this.Uo();
    const s = this.Ho(), r = H(this.er()), o = r.Ze(), l = r.Ge(), a = this.Fo() - 1, c = this.Ao(), u = a / (l - o), h = i === void 0 ? 0 : i.from, d = i === void 0 ? e.length : i.to, m = this.Ko();
    for (let p = h; p < d; p++) {
      const g = e[p], A = g.gt;
      if (isNaN(A)) continue;
      let b = A;
      m !== null && (b = m(g.gt, n));
      const R = s + u * (b - o), S = c ? R : this.eo - 1 - R;
      g.ut = S;
    }
  }
  Zo(e, n, i) {
    this.Uo();
    const s = this.Ho(), r = H(this.er()), o = r.Ze(), l = r.Ge(), a = this.Fo() - 1, c = this.Ao(), u = a / (l - o), h = i === void 0 ? 0 : i.from, d = i === void 0 ? e.length : i.to, m = this.Ko();
    for (let p = h; p < d; p++) {
      const g = e[p];
      let A = g.Hr, b = g.Ur, R = g.$r, S = g.qr;
      m !== null && (A = m(g.Hr, n), b = m(g.Ur, n), R = m(g.$r, n), S = m(g.qr, n));
      let E = s + u * (A - o), Z = c ? E : this.eo - 1 - E;
      g.Go = Z, E = s + u * (b - o), Z = c ? E : this.eo - 1 - E, g.Xo = Z, E = s + u * (R - o), Z = c ? E : this.eo - 1 - E, g.Jo = Z, E = s + u * (S - o), Z = c ? E : this.eo - 1 - E, g.Qo = Z;
    }
  }
  Ds(e, n) {
    const i = this.To(e, n);
    return this.t_(i, n);
  }
  t_(e, n) {
    let i = e;
    return this.He() ? i = (function(s, r) {
      return r < 0 && (s = -s), s / 100 * r + r;
    })(i, n) : this.Eo() && (i = (function(s, r) {
      return s -= 100, r < 0 && (s = -s), s / 100 * r + r;
    })(i, n)), i;
  }
  Sl() {
    return this.po;
  }
  Dt() {
    return this.mo || (this.mo = v2(this.po)), this.mo;
  }
  i_(e) {
    this.po.indexOf(e) === -1 && (this.po.push(e), this._l(), this.s_());
  }
  n_(e) {
    const n = this.po.indexOf(e);
    if (n === -1) throw new Error("source is not attached to scale");
    this.po.splice(n, 1), this.po.length === 0 && (this.Do({ ln: !0 }), this.Lo(null)), this._l(), this.s_();
  }
  Lt() {
    let e = null;
    for (const n of this.po) {
      const i = n.Lt();
      i !== null && (e === null || i.Ea < e.Ea) && (e = i);
    }
    return e === null ? null : e.Wt;
  }
  Ao() {
    return this.Ps.invertScale;
  }
  Vl() {
    const e = this.Lt() === null;
    if (this.wo !== null && (e || this.wo.e_ === e)) return this.wo.Vl;
    this.Po.Ul();
    const n = this.Po.Vl();
    return this.wo = { Vl: n, e_: e }, this.do.p(), n;
  }
  r_() {
    return this.do;
  }
  h_(e) {
    this.He() || this.Eo() || this.Mo === null && this.ho === null && (this.Gi() || (this.Mo = this.eo - e, this.ho = H(this.er()).Ke()));
  }
  a_(e) {
    if (this.He() || this.Eo() || this.Mo === null) return;
    this.Do({ ln: !1 }), (e = this.eo - e) < 0 && (e = 0);
    let n = (this.Mo + 0.2 * (this.eo - 1)) / (e + 0.2 * (this.eo - 1));
    const i = H(this.ho).Ke();
    n = Math.max(n, 0.1), i.Je(n), this.Lo(i);
  }
  l_() {
    this.He() || this.Eo() || (this.Mo = null, this.ho = null);
  }
  o_(e) {
    this.Vo() || this.bo === null && this.ho === null && (this.Gi() || (this.bo = e, this.ho = H(this.er()).Ke()));
  }
  __(e) {
    if (this.Vo() || this.bo === null) return;
    const n = H(this.er()).Xe() / (this.Fo() - 1);
    let i = e - this.bo;
    this.Ao() && (i *= -1);
    const s = i * n, r = H(this.ho).Ke();
    r.Qe(s), this.Lo(r, !0), this.wo = null;
  }
  u_() {
    this.Vo() || this.bo !== null && (this.bo = null, this.ho = null);
  }
  Xa() {
    return this.Ja || this._l(), this.Ja;
  }
  Ji(e, n) {
    switch (this.Ps.mode) {
      case 2:
        return this.c_(On(e, n));
      case 3:
        return this.Xa().format(Si(e, n));
      default:
        return this.lr(e);
    }
  }
  Ql(e) {
    switch (this.Ps.mode) {
      case 2:
        return this.c_(e);
      case 3:
        return this.Xa().format(e);
      default:
        return this.lr(e);
    }
  }
  Xl(e) {
    switch (this.Ps.mode) {
      case 2:
        return this.d_(e);
      case 3:
        return this.Xa().formatTickmarks(e);
      default:
        return this.f_(e);
    }
  }
  Ma(e) {
    return this.lr(e, H(this.vo).Xa());
  }
  ba(e, n) {
    return e = On(e, n), this.c_(e, Ju);
  }
  p_() {
    return this.po;
  }
  v_(e) {
    this.ao = { oo: e, lo: !1 };
  }
  Ws() {
    this.po.forEach(((e) => e.Ws()));
  }
  jl() {
    return this.Ps.ensureEdgeTickMarksVisible && this.Vo();
  }
  Kl() {
    return this.k() / 2;
  }
  _l() {
    this.wo = null;
    let e = 1 / 0;
    this.vo = null;
    for (const i of this.po) i._s() < e && (e = i._s(), this.vo = i);
    let n = 100;
    this.vo !== null && (n = Math.round(this.vo.qh())), this.Ja = xu, this.He() ? (this.Ja = Ju, n = 100) : this.Eo() ? (this.Ja = new ar(100, 1), n = 100) : this.vo !== null && (this.Ja = this.vo.Xa()), this.Po = new Lu(this, n, this.To.bind(this), this.Ro.bind(this)), this.Po.Ul();
  }
  s_() {
    this.mo = null;
  }
  m_() {
    return this.vo === null || this.He() || this.Eo() ? 1 : 1 / this.vo.qh();
  }
  Xi() {
    return this.ko;
  }
  qo(e) {
    this._o = e;
  }
  Wo() {
    return this.Ao() ? this.Ps.scaleMargins.bottom * this.$t() + this.co : this.Ps.scaleMargins.top * this.$t() + this.uo;
  }
  Ho() {
    return this.Ao() ? this.Ps.scaleMargins.top * this.$t() + this.uo : this.Ps.scaleMargins.bottom * this.$t() + this.co;
  }
  Uo() {
    this.ao.lo || (this.ao.lo = !0, this.w_());
  }
  Io() {
    this.ro = null;
  }
  Ro(e, n) {
    if (this.Uo(), this.Gi()) return 0;
    e = this.io() && e ? xs(e, this.So) : e;
    const i = H(this.er()), s = this.Ho() + (this.Fo() - 1) * (e - i.Ze()) / i.Xe();
    return this.jo(s);
  }
  To(e, n) {
    if (this.Uo(), this.Gi()) return 0;
    const i = this.jo(e), s = H(this.er()), r = s.Ze() + s.Xe() * ((i - this.Ho()) / (this.Fo() - 1));
    return this.io() ? Zi(r, this.So) : r;
  }
  zo() {
    this.wo = null, this.Po.Ul();
  }
  w_() {
    if (this.Bo() && !this.Vo()) return;
    const e = this.ao.oo;
    if (e === null) return;
    let n = null;
    const i = this.p_();
    let s = 0, r = 0;
    for (const a of i) {
      if (!a.It()) continue;
      const c = a.Lt();
      if (c === null) continue;
      const u = a.ra(e.Aa(), e.bi());
      let h = u && u.er();
      if (h !== null) {
        switch (this.Ps.mode) {
          case 1:
            h = bi(h, this.So);
            break;
          case 2:
            h = N8(h, c.Wt);
            break;
          case 3:
            h = F8(h, c.Wt);
        }
        if (n = n === null ? h : n.Sn(H(h)), u !== null) {
          const d = u.rr();
          d !== null && (s = Math.max(s, d.above), r = Math.max(r, d.below));
        }
      }
    }
    if (this.jl() && (s = Math.max(s, this.Kl()), r = Math.max(r, this.Kl())), s === this.uo && r === this.co || (this.uo = s, this.co = r, this.wo = null, this.Io()), n !== null) {
      if (n.Ze() === n.Ge()) {
        const a = 5 * this.m_();
        this.io() && (n = Dn(n, this.So)), n = new De(n.Ze() - a, n.Ge() + a), this.io() && (n = bi(n, this.So));
      }
      if (this.io()) {
        const a = Dn(n, this.So), c = ho(a);
        if (o = c, l = this.So, o.Bl !== l.Bl || o.El !== l.El) {
          const u = this.ho !== null ? Dn(this.ho, this.So) : null;
          this.So = c, n = bi(a, c), u !== null && (this.ho = bi(u, c));
        }
      }
      this.Lo(n);
    } else this.sr === null && (this.Lo(new De(-0.5, 0.5)), this.So = ho(null));
    var o, l;
  }
  Ko() {
    return this.He() ? On : this.Eo() ? Si : this.io() ? (e) => xs(e, this.So) : null;
  }
  g_(e, n, i) {
    return n === void 0 ? (i === void 0 && (i = this.Xa()), i.format(e)) : n(e);
  }
  M_(e, n, i) {
    return n === void 0 ? (i === void 0 && (i = this.Xa()), i.formatTickmarks(e)) : n(e);
  }
  lr(e, n) {
    return this.g_(e, this.yo.priceFormatter, n);
  }
  f_(e, n) {
    const i = this.yo.priceFormatter;
    return this.M_(e, this.yo.tickmarksPriceFormatter ?? (i ? (s) => s.map(i) : void 0), n);
  }
  c_(e, n) {
    return this.g_(e, this.yo.percentageFormatter, n);
  }
  d_(e, n) {
    const i = this.yo.percentageFormatter;
    return this.M_(e, this.yo.tickmarksPercentageFormatter ?? (i ? (s) => s.map(i) : void 0), n);
  }
}
function Mu(t) {
  return t instanceof cr;
}
class Qu {
  constructor(e, n) {
    this.po = [], this.b_ = /* @__PURE__ */ new Map(), this.eo = 0, this.S_ = 0, this.x_ = 1, this.mo = null, this.C_ = !1, this.y_ = new Ye(), this.ua = [], this.Jh = e, this.ns = n, this.k_ = new I8(this);
    const i = n.N();
    this.P_ = this.T_("left", i.leftPriceScale), this.R_ = this.T_("right", i.rightPriceScale), this.P_.Oo().i(this.D_.bind(this, this.P_), this), this.R_.Oo().i(this.D_.bind(this, this.R_), this), this.I_(i);
  }
  I_(e) {
    if (e.leftPriceScale && this.P_.cr(e.leftPriceScale), e.rightPriceScale && this.R_.cr(e.rightPriceScale), e.localization && (this.P_._l(), this.R_._l()), e.overlayPriceScales) {
      const n = Array.from(this.b_.values());
      for (const i of n) {
        const s = H(i[0].Ft());
        s.cr(e.overlayPriceScales), e.localization && s._l();
      }
    }
  }
  V_(e) {
    switch (e) {
      case "left":
        return this.P_;
      case "right":
        return this.R_;
    }
    return this.b_.has(e) ? $e(this.b_.get(e))[0].Ft() : null;
  }
  m() {
    this.Qt().B_().u(this), this.P_.Oo().u(this), this.R_.Oo().u(this), this.po.forEach(((e) => {
      e.m && e.m();
    })), this.ua = this.ua.filter(((e) => {
      const n = e.Gh();
      return n.detached && n.detached(), !1;
    })), this.y_.p();
  }
  E_() {
    return this.x_;
  }
  A_(e) {
    this.x_ = e;
  }
  Qt() {
    return this.ns;
  }
  ss() {
    return this.S_;
  }
  $t() {
    return this.eo;
  }
  L_(e) {
    this.S_ = e, this.z_();
  }
  No(e) {
    this.eo = e, this.P_.No(e), this.R_.No(e), this.po.forEach(((n) => {
      if (this.Zn(n)) {
        const i = n.Ft();
        i !== null && i.No(e);
      }
    })), this.z_();
  }
  O_(e) {
    this.C_ = e;
  }
  N_() {
    return this.C_;
  }
  F_() {
    return this.po.filter(Mu);
  }
  Sl() {
    return this.po;
  }
  Zn(e) {
    const n = e.Ft();
    return n === null || this.P_ !== n && this.R_ !== n;
  }
  i_(e, n, i) {
    this.W_(e, n, i ? e._s() : this.po.length);
  }
  n_(e, n) {
    const i = this.po.indexOf(e);
    Ke(i !== -1, "removeDataSource: invalid data source"), this.po.splice(i, 1), n || this.po.forEach(((o, l) => o.us(l)));
    const s = H(e.Ft()).ol();
    if (this.b_.has(s)) {
      const o = $e(this.b_.get(s)), l = o.indexOf(e);
      l !== -1 && (o.splice(l, 1), o.length === 0 && this.b_.delete(s));
    }
    const r = e.Ft();
    r && r.Sl().indexOf(e) >= 0 && (r.n_(e), this.H_(r)), this.mo = null;
  }
  Xn(e) {
    return e === this.P_ ? "left" : e === this.R_ ? "right" : "overlay";
  }
  U_() {
    return this.P_;
  }
  q_() {
    return this.R_;
  }
  j_(e, n) {
    e.h_(n);
  }
  Y_(e, n) {
    e.a_(n), this.z_();
  }
  K_(e) {
    e.l_();
  }
  Z_(e, n) {
    e.o_(n);
  }
  G_(e, n) {
    e.__(n), this.z_();
  }
  X_(e) {
    e.u_();
  }
  z_() {
    this.po.forEach(((e) => {
      e.Ws();
    }));
  }
  Rs() {
    let e = null;
    return this.ns.N().rightPriceScale.visible && this.R_.Sl().length !== 0 ? e = this.R_ : this.ns.N().leftPriceScale.visible && this.P_.Sl().length !== 0 ? e = this.P_ : this.po.length !== 0 && (e = this.po[0].Ft()), e === null && (e = this.R_), e;
  }
  Gn() {
    let e = null;
    return this.ns.N().rightPriceScale.visible ? e = this.R_ : this.ns.N().leftPriceScale.visible && (e = this.P_), e;
  }
  H_(e) {
    e !== null && e.Vo() && this.J_(e);
  }
  Q_(e) {
    const n = this.Jh.Ie();
    e.Do({ ln: !0 }), n !== null && e.v_(n), this.z_();
  }
  tu() {
    this.J_(this.P_), this.J_(this.R_);
  }
  iu() {
    this.H_(this.P_), this.H_(this.R_), this.po.forEach(((e) => {
      this.Zn(e) && this.H_(e.Ft());
    })), this.z_(), this.ns.dr();
  }
  Dt() {
    return this.mo === null && (this.mo = v2(this.po)), this.mo;
  }
  su(e, n) {
    n = Wi(n, 0, this.po.length - 1);
    const i = this.po.indexOf(e);
    Ke(i !== -1, "setSeriesOrder: invalid data source"), this.po.splice(i, 1), this.po.splice(n, 0, e), this.po.forEach(((s, r) => s.us(r))), this.mo = null;
    for (const s of [this.P_, this.R_]) s.s_(), s._l();
    this.ns.dr();
  }
  Vt() {
    return this.Dt().filter(Mu);
  }
  nu() {
    return this.y_;
  }
  eu() {
    return this.k_;
  }
  nl(e) {
    this.ua.push(new g8(e));
  }
  el(e) {
    this.ua = this.ua.filter(((n) => n.Gh() !== e)), e.detached && e.detached(), this.ns.dr();
  }
  ru() {
    return this.ua;
  }
  Za(e, n) {
    return this.ua.map(((i) => i.Qn(e, n))).filter(((i) => i !== null));
  }
  J_(e) {
    const n = e.p_();
    if (n && n.length > 0 && !this.Jh.Gi()) {
      const i = this.Jh.Ie();
      i !== null && e.v_(i);
    }
    e.Ws();
  }
  W_(e, n, i) {
    let s = this.V_(n);
    if (s === null && (s = this.T_(n, this.ns.N().overlayPriceScales)), this.po.splice(i, 0, e), !lr(n)) {
      const r = this.b_.get(n) || [];
      r.push(e), this.b_.set(n, r);
    }
    e.us(i), s.i_(e), e.cs(s), this.H_(s), this.mo = null;
  }
  D_(e, n, i) {
    n.ae !== i.ae && this.J_(e);
  }
  T_(e, n) {
    const i = { visible: !0, autoScale: !0, ...Ot(n) }, s = new G8(e, i, this.ns.N().layout, this.ns.N().localization, this.ns.Xi());
    return s.No(this.$t()), s;
  }
}
function us(t) {
  return { hu: t.hu, au: { te: t.lu.externalId }, ou: t.lu.cursorStyle };
}
function X8(t, e, n, i) {
  for (const s of t) {
    const r = s.Tt(i);
    if (r !== null && r.Qn) {
      const o = r.Qn(e, n);
      if (o !== null) return { _u: s, au: o };
    }
  }
  return null;
}
function U8(t) {
  return t.Ys !== void 0;
}
function I2(t, e, n) {
  const i = [t, ...t.Dt()], s = (function(r, o, l) {
    let a, c;
    for (const d of r) {
      const m = d.Za?.(o, l) ?? [];
      for (const p of m) u = p.zOrder, h = a?.zOrder, (!h || u === "top" && h !== "top" || u === "normal" && h === "bottom") && (a = p, c = d);
    }
    var u, h;
    return a && c ? { lu: a, hu: c } : null;
  })(i, e, n);
  if (s?.lu.zOrder === "top") return us(s);
  for (const r of i) {
    if (s && s.hu === r && s.lu.zOrder !== "bottom" && !s.lu.isBackground) return us(s);
    if (U8(r)) {
      const o = X8(r.Ys(t), e, n, t);
      if (o !== null) return { hu: r, _u: o._u, au: o.au };
    }
    if (s && s.hu === r && s.lu.zOrder !== "bottom" && s.lu.isBackground) return us(s);
  }
  return s?.lu ? us(s) : null;
}
class B8 {
  constructor(e, n, i = 50) {
    this.Vn = 0, this.Bn = 1, this.En = 1, this.Ln = /* @__PURE__ */ new Map(), this.An = /* @__PURE__ */ new Map(), this.uu = e, this.cu = n, this.zn = i;
  }
  du(e) {
    const n = e.time, i = this.cu.cacheKey(n), s = this.Ln.get(i);
    if (s !== void 0) return s.fu;
    if (this.Vn === this.zn) {
      const o = this.An.get(this.En);
      this.An.delete(this.En), this.Ln.delete($e(o)), this.En++, this.Vn--;
    }
    const r = this.uu(e);
    return this.Ln.set(i, { fu: r, Wn: this.Bn }), this.An.set(this.Bn, i), this.Vn++, this.Bn++, r;
  }
}
class vi {
  constructor(e, n) {
    Ke(e <= n, "right should be >= left"), this.pu = e, this.vu = n;
  }
  Aa() {
    return this.pu;
  }
  bi() {
    return this.vu;
  }
  mu() {
    return this.vu - this.pu + 1;
  }
  Ee(e) {
    return this.pu <= e && e <= this.vu;
  }
  Ye(e) {
    return this.pu === e.Aa() && this.vu === e.bi();
  }
}
function zu(t, e) {
  return t === null || e === null ? t === e : t.Ye(e);
}
class w8 {
  constructor() {
    this.wu = /* @__PURE__ */ new Map(), this.Ln = null, this.gu = !1;
  }
  Mu(e) {
    this.gu = e, this.Ln = null;
  }
  bu(e, n) {
    this.Su(n), this.Ln = null;
    for (let i = n; i < e.length; ++i) {
      const s = e[i];
      let r = this.wu.get(s.timeWeight);
      r === void 0 && (r = [], this.wu.set(s.timeWeight, r)), r.push({ index: i, time: s.time, weight: s.timeWeight, originalTime: s.originalTime });
    }
  }
  xu(e, n, i, s, r) {
    const o = Math.ceil(n / e);
    return this.Ln !== null && this.Ln.Cu === o && r === this.Ln.yu && i === this.Ln.ku || (this.Ln = { yu: r, ku: i, Vl: this.Pu(o, i, s), Cu: o }), this.Ln.Vl;
  }
  Su(e) {
    if (e === 0) return void this.wu.clear();
    const n = [];
    this.wu.forEach(((i, s) => {
      e <= i[0].index ? n.push(s) : i.splice(li(i, e, ((r) => r.index < e)), 1 / 0);
    }));
    for (const i of n) this.wu.delete(i);
  }
  Pu(e, n, i) {
    let s = [];
    const r = (o) => !n || i.has(o.index);
    for (const o of Array.from(this.wu.keys()).sort(((l, a) => a - l))) {
      if (!this.wu.get(o)) continue;
      const l = s;
      s = [];
      const a = l.length;
      let c = 0;
      const u = $e(this.wu.get(o)), h = u.length;
      let d = 1 / 0, m = -1 / 0;
      for (let p = 0; p < h; p++) {
        const g = u[p], A = g.index;
        for (; c < a; ) {
          const b = l[c], R = b.index;
          if (!(R < A && r(b))) {
            d = R;
            break;
          }
          c++, s.push(b), m = R, d = 1 / 0;
        }
        if (d - A >= e && A - m >= e && r(g)) s.push(g), m = A;
        else if (this.gu) return l;
      }
      for (; c < a; c++) r(l[c]) && s.push(l[c]);
    }
    return s;
  }
}
class $n {
  constructor(e) {
    this.Tu = e;
  }
  Ru() {
    return this.Tu === null ? null : new vi(Math.floor(this.Tu.Aa()), Math.ceil(this.Tu.bi()));
  }
  Du() {
    return this.Tu;
  }
  static Iu() {
    return new $n(null);
  }
}
function Y8(t, e) {
  return t.weight > e.weight ? t : e;
}
class T8 {
  constructor(e, n, i, s) {
    this.S_ = 0, this.Vu = null, this.Bu = [], this.bo = null, this.Mo = null, this.Eu = new w8(), this.Au = /* @__PURE__ */ new Map(), this.Lu = $n.Iu(), this.zu = !0, this.Ou = new Ye(), this.Nu = new Ye(), this.Fu = new Ye(), this.Wu = null, this.Hu = null, this.Uu = /* @__PURE__ */ new Map(), this.$u = -1, this.qu = [], this.ju = 1, this.Ps = n, this.yo = i, this.Yu = n.rightOffset, this.Ku = n.barSpacing, this.ns = e, this.Zu(n), this.cu = s, this.Gu(), this.Eu.Mu(n.uniformDistribution), this.Xu(), this.Ju();
  }
  N() {
    return this.Ps;
  }
  Qu(e) {
    tt(this.yo, e), this.tc(), this.Gu();
  }
  cr(e, n) {
    tt(this.Ps, e), this.Ps.fixLeftEdge && this.sc(), this.Ps.fixRightEdge && this.nc(), e.barSpacing !== void 0 && this.ns.gn(e.barSpacing), e.rightOffset !== void 0 && this.ns.Mn(e.rightOffset), this.Zu(e), e.minBarSpacing === void 0 && e.maxBarSpacing === void 0 || this.ns.gn(e.barSpacing ?? this.Ku), e.ignoreWhitespaceIndices !== void 0 && e.ignoreWhitespaceIndices !== this.Ps.ignoreWhitespaceIndices && this.Ju(), this.tc(), this.Gu(), e.enableConflation === void 0 && e.conflationThresholdFactor === void 0 || this.Xu(), this.Fu.p();
  }
  Is(e) {
    return this.Bu[e]?.time ?? null;
  }
  es(e) {
    return this.Bu[e] ?? null;
  }
  ec(e, n) {
    if (this.Bu.length < 1) return null;
    if (this.cu.key(e) > this.cu.key(this.Bu[this.Bu.length - 1].time)) return n ? this.Bu.length - 1 : null;
    const i = li(this.Bu, this.cu.key(e), ((s, r) => this.cu.key(s.time) < r));
    return this.cu.key(e) < this.cu.key(this.Bu[i].time) ? n ? i : null : i;
  }
  Gi() {
    return this.S_ === 0 || this.Bu.length === 0 || this.Vu === null;
  }
  rc() {
    return this.Bu.length > 0;
  }
  Ie() {
    return this.hc(), this.Lu.Ru();
  }
  ac() {
    return this.hc(), this.Lu.Du();
  }
  lc() {
    const e = this.Ie();
    if (e === null) return null;
    const n = { from: e.Aa(), to: e.bi() };
    return this.oc(n);
  }
  oc(e) {
    const n = Math.round(e.from), i = Math.round(e.to), s = H(this._c()), r = H(this.uc());
    return { from: H(this.es(Math.max(s, n))), to: H(this.es(Math.min(r, i))) };
  }
  cc(e) {
    return { from: H(this.ec(e.from, !0)), to: H(this.ec(e.to, !0)) };
  }
  ss() {
    return this.S_;
  }
  L_(e) {
    if (!isFinite(e) || e <= 0 || this.S_ === e) return;
    const n = this.ac(), i = this.S_;
    if (this.S_ = e, this.zu = !0, this.Ps.lockVisibleTimeRangeOnResize && i !== 0) {
      const s = this.Ku * e / i;
      this.Ku = s;
    }
    if (this.Ps.fixLeftEdge && n !== null && n.Aa() <= 0) {
      const s = i - e;
      this.Yu -= Math.round(s / this.Ku) + 1, this.zu = !0;
    }
    this.dc(), this.fc();
  }
  qt(e) {
    if (this.Gi() || !Bi(e)) return 0;
    const n = this.vc() + this.Yu - e;
    return this.S_ - (n + 0.5) * this.Ku - 1;
  }
  mc(e, n) {
    const i = this.vc(), s = n === void 0 ? 0 : n.from, r = n === void 0 ? e.length : n.to;
    for (let o = s; o < r; o++) {
      const l = e[o].wt, a = i + this.Yu - l, c = this.S_ - (a + 0.5) * this.Ku - 1;
      e[o]._t = c;
    }
  }
  wc(e, n) {
    const i = Math.ceil(this.gc(e));
    return n && this.Ps.ignoreWhitespaceIndices && !this.Mc(i) ? this.bc(i) : i;
  }
  Mn(e) {
    this.zu = !0, this.Yu = e, this.fc(), this.ns.Sc(), this.ns.dr();
  }
  ul() {
    return this.Ku;
  }
  gn(e) {
    const n = this.Ku;
    if (this.xc(e), this.Ps.rightOffsetPixels !== void 0 && n !== 0) {
      const i = this.Yu * n / this.Ku;
      this.Yu = i;
    }
    this.fc(), this.ns.Sc(), this.ns.dr();
  }
  Cc() {
    return this.Yu;
  }
  Vl() {
    if (this.Gi()) return null;
    if (this.Hu !== null) return this.Hu;
    const e = this.Ku, n = 5 * (this.ns.N().layout.fontSize + 4) / 8 * (this.Ps.tickMarkMaxCharacterLength || 8), i = Math.round(n / e), s = H(this.Ie()), r = Math.max(s.Aa(), s.Aa() - i), o = Math.max(s.bi(), s.bi() - i), l = this.Eu.xu(e, n, this.Ps.ignoreWhitespaceIndices, this.Uu, this.$u), a = this._c() + i, c = this.uc() - i, u = this.yc(), h = this.Ps.fixLeftEdge || u, d = this.Ps.fixRightEdge || u;
    let m = 0;
    for (const p of l) {
      if (!(r <= p.index && p.index <= o)) continue;
      let g;
      m < this.qu.length ? (g = this.qu[m], g.coord = this.qt(p.index), g.label = this.kc(p), g.weight = p.weight) : (g = { needAlignCoordinate: !1, coord: this.qt(p.index), label: this.kc(p), weight: p.weight }, this.qu.push(g)), this.Ku > n / 2 && !u ? g.needAlignCoordinate = !1 : g.needAlignCoordinate = h && p.index <= a || d && p.index >= c, m++;
    }
    return this.qu.length = m, this.Hu = this.qu, this.qu;
  }
  Pc() {
    let e;
    this.zu = !0, this.gn(this.Ps.barSpacing), e = this.Ps.rightOffsetPixels !== void 0 ? this.Ps.rightOffsetPixels / this.ul() : this.Ps.rightOffset, this.Mn(e);
  }
  Tc(e) {
    this.zu = !0, this.Vu = e, this.fc(), this.sc();
  }
  Rc(e, n) {
    const i = this.gc(e), s = this.ul(), r = s + n * (s / 10);
    this.gn(r), this.Ps.rightBarStaysOnScroll || this.Mn(this.Cc() + (i - this.gc(e)));
  }
  h_(e) {
    this.bo && this.u_(), this.Mo === null && this.Wu === null && (this.Gi() || (this.Mo = e, this.Dc()));
  }
  a_(e) {
    if (this.Wu === null) return;
    const n = Wi(this.S_ - e, 0, this.S_), i = Wi(this.S_ - H(this.Mo), 0, this.S_);
    n !== 0 && i !== 0 && this.gn(this.Wu.ul * n / i);
  }
  l_() {
    this.Mo !== null && (this.Mo = null, this.Ic());
  }
  o_(e) {
    this.bo === null && this.Wu === null && (this.Gi() || (this.bo = e, this.Dc()));
  }
  __(e) {
    if (this.bo === null) return;
    const n = (this.bo - e) / this.ul();
    this.Yu = H(this.Wu).Cc + n, this.zu = !0, this.fc();
  }
  u_() {
    this.bo !== null && (this.bo = null, this.Ic());
  }
  Vc() {
    this.Bc(this.Ps.rightOffset);
  }
  Bc(e, n = 400) {
    if (!isFinite(e)) throw new RangeError("offset is required and must be finite number");
    if (!isFinite(n) || n <= 0) throw new RangeError("animationDuration (optional) must be finite positive number");
    const i = this.Yu, s = performance.now();
    this.ns.vn({ Ec: (r) => (r - s) / n >= 1, Ac: (r) => {
      const o = (r - s) / n;
      return o >= 1 ? e : i + (e - i) * o;
    } });
  }
  kt(e, n) {
    this.zu = !0, this.Bu = e, this.Eu.bu(e, n), this.fc();
  }
  Lc() {
    return this.Ou;
  }
  zc() {
    return this.Nu;
  }
  Oc() {
    return this.Fu;
  }
  vc() {
    return this.Vu || 0;
  }
  Nc(e, n) {
    const i = e.mu(), s = n && this.Ps.rightOffsetPixels || 0;
    this.xc((this.S_ - s) / i), this.Yu = e.bi() - this.vc(), n && (this.Yu = s ? s / this.ul() : this.Ps.rightOffset), this.fc(), this.zu = !0, this.ns.Sc(), this.ns.dr();
  }
  Fc() {
    const e = this._c(), n = this.uc();
    if (e === null || n === null) return;
    const i = !this.Ps.rightOffsetPixels && this.Ps.rightOffset || 0;
    this.Nc(new vi(e, n + i), !0);
  }
  Wc(e) {
    const n = new vi(e.from, e.to);
    this.Nc(n);
  }
  rs(e) {
    return this.yo.timeFormatter !== void 0 ? this.yo.timeFormatter(e.originalTime) : this.cu.formatHorzItem(e.time);
  }
  Ju() {
    if (!this.Ps.ignoreWhitespaceIndices) return;
    this.Uu.clear();
    const e = this.ns.tn();
    for (const n of e) for (const i of n.ll()) this.Uu.set(i, !0);
    this.$u++;
  }
  Hc() {
    return this.ju;
  }
  vl() {
    const e = 1 / (window.devicePixelRatio || 1), n = this.Ps.minBarSpacing;
    if (n >= e) return [1];
    const i = [1];
    let s = 2;
    for (; s <= 512; )
      n < e / s && i.push(s), s *= 2;
    return i;
  }
  yc() {
    const e = this.ns.N().handleScroll, n = this.ns.N().handleScale;
    return !(e.horzTouchDrag || e.mouseWheel || e.pressedMouseMove || e.vertTouchDrag || n.axisDoubleClickReset.time || n.axisPressedMouseMove.time || n.mouseWheel || n.pinch);
  }
  _c() {
    return this.Bu.length === 0 ? null : 0;
  }
  uc() {
    return this.Bu.length === 0 ? null : this.Bu.length - 1;
  }
  Uc(e) {
    return (this.S_ - 1 - e) / this.Ku;
  }
  gc(e) {
    const n = this.Uc(e), i = this.vc() + this.Yu - n;
    return Math.round(1e6 * i) / 1e6;
  }
  xc(e) {
    const n = this.Ku;
    this.Ku = e, this.dc(), n !== this.Ku && (this.zu = !0, this.$c(), this.Xu());
  }
  hc() {
    if (!this.zu) return;
    if (this.zu = !1, this.Gi()) return void this.qc($n.Iu());
    const e = this.vc(), n = this.S_ / this.Ku, i = this.Yu + e, s = new vi(i - n + 1, i);
    this.qc(new $n(s));
  }
  dc() {
    const e = Wi(this.Ku, this.jc(), this.Yc());
    this.Ku !== e && (this.Ku = e, this.zu = !0);
  }
  Yc() {
    return this.Ps.maxBarSpacing > 0 ? this.Ps.maxBarSpacing : 0.5 * this.S_;
  }
  jc() {
    return this.Ps.fixLeftEdge && this.Ps.fixRightEdge && this.Bu.length !== 0 ? this.S_ / this.Bu.length : this.Ps.minBarSpacing;
  }
  Xu() {
    if (!this.Ps.enableConflation) return void (this.ju = 1);
    const e = 1 / (window.devicePixelRatio || 1) * (this.Ps.conflationThresholdFactor ?? 1);
    if (this.Ku >= e) return void (this.ju = 1);
    const n = e / this.Ku, i = Math.pow(2, Math.floor(Math.log2(n)));
    this.ju = Math.min(i, 512);
  }
  fc() {
    const e = this.Kc();
    e !== null && this.Yu < e && (this.Yu = e, this.zu = !0);
    const n = this.Zc();
    this.Yu > n && (this.Yu = n, this.zu = !0);
  }
  Kc() {
    const e = this._c(), n = this.Vu;
    return e === null || n === null ? null : e - n - 1 + (this.Ps.fixLeftEdge ? this.S_ / this.Ku : Math.min(2, this.Bu.length));
  }
  Zc() {
    return this.Ps.fixRightEdge ? 0 : this.S_ / this.Ku - Math.min(2, this.Bu.length);
  }
  Dc() {
    this.Wu = { ul: this.ul(), Cc: this.Cc() };
  }
  Ic() {
    this.Wu = null;
  }
  kc(e) {
    let n = this.Au.get(e.weight);
    return n === void 0 && (n = new B8(((i) => this.Gc(i)), this.cu), this.Au.set(e.weight, n)), n.du(e);
  }
  Gc(e) {
    return this.cu.formatTickmark(e, this.yo);
  }
  qc(e) {
    const n = this.Lu;
    this.Lu = e, zu(n.Ru(), this.Lu.Ru()) || this.Ou.p(), zu(n.Du(), this.Lu.Du()) || this.Nu.p(), this.$c();
  }
  $c() {
    this.Hu = null;
  }
  tc() {
    this.$c(), this.Au.clear();
  }
  Gu() {
    this.cu.updateFormatter(this.yo);
  }
  sc() {
    if (!this.Ps.fixLeftEdge) return;
    const e = this._c();
    if (e === null) return;
    const n = this.Ie();
    if (n === null) return;
    const i = n.Aa() - e;
    if (i < 0) {
      const s = this.Yu - i - 1;
      this.Mn(s);
    }
    this.dc();
  }
  nc() {
    this.fc(), this.dc();
  }
  Mc(e) {
    return !this.Ps.ignoreWhitespaceIndices || this.Uu.get(e) || !1;
  }
  bc(e) {
    const n = (function* (s) {
      const r = Math.round(s), o = r < s;
      let l = 1;
      for (; ; ) o ? (yield r + l, yield r - l) : (yield r - l, yield r + l), l++;
    })(e), i = this.uc();
    for (; i; ) {
      const s = n.next().value;
      if (this.Uu.get(s)) return s;
      if (s < 0 || s > i) break;
    }
    return e;
  }
  Zu(e) {
    if (e.rightOffsetPixels !== void 0) {
      const n = e.rightOffsetPixels / (e.barSpacing || this.Ku);
      this.ns.Mn(n);
    }
  }
}
var Ku, Hu, Ou, Al, Du;
(function(t) {
  t[t.OnTouchEnd = 0] = "OnTouchEnd", t[t.OnNextTap = 1] = "OnNextTap";
})(Ku || (Ku = {}));
class L8 {
  constructor(e, n, i) {
    this.Xc = [], this.Jc = [], this.Qc = null, this.S_ = 0, this.td = null, this.sd = new Ye(), this.nd = new Ye(), this.ed = null, this.rd = e, this.Ps = n, this.cu = i, this.ko = new w4(this.Ps.layout.colorParsers), this.hd = new B4(this), this.Jh = new T8(this, n.timeScale, this.Ps.localization, i), this.Ct = new H4(this, n.crosshair), this.ad = new S8(n.crosshair), n.addDefaultPane && (this.ld(0), this.Xc[0].A_(2)), this.od = this._d(0), this.ud = this._d(1);
  }
  Ca() {
    this.dd(Pe.yn());
  }
  dr() {
    this.dd(Pe.Cn());
  }
  Ua() {
    this.dd(new Pe(1));
  }
  ya(e) {
    const n = this.fd(e);
    this.dd(n);
  }
  pd() {
    return this.td;
  }
  vd(e) {
    if (this.td?.hu === e?.hu && this.td?.au?.te === e?.au?.te) return;
    const n = this.td;
    this.td = e, n !== null && this.ya(n.hu), e !== null && e.hu !== n?.hu && this.ya(e.hu);
  }
  N() {
    return this.Ps;
  }
  cr(e) {
    tt(this.Ps, e), this.Xc.forEach(((n) => n.I_(e))), e.timeScale !== void 0 && this.Jh.cr(e.timeScale), e.localization !== void 0 && this.Jh.Qu(e.localization), (e.leftPriceScale || e.rightPriceScale) && this.sd.p(), this.od = this._d(0), this.ud = this._d(1), this.Ca();
  }
  md(e, n, i = 0) {
    const s = this.Xc[i];
    if (s === void 0) return;
    if (e === "left") return tt(this.Ps, { leftPriceScale: n }), s.I_({ leftPriceScale: n }), this.sd.p(), void this.Ca();
    if (e === "right") return tt(this.Ps, { rightPriceScale: n }), s.I_({ rightPriceScale: n }), this.sd.p(), void this.Ca();
    const r = this.wd(e, i);
    r !== null && (r.Ft.cr(n), this.sd.p());
  }
  wd(e, n) {
    const i = this.Xc[n];
    if (i === void 0) return null;
    const s = i.V_(e);
    return s !== null ? { Gs: i, Ft: s } : null;
  }
  Et() {
    return this.Jh;
  }
  Xs() {
    return this.Xc;
  }
  gd() {
    return this.Ct;
  }
  Md() {
    return this.nd;
  }
  bd(e, n) {
    e.No(n), this.Sc();
  }
  L_(e) {
    this.S_ = e, this.Jh.L_(this.S_), this.Xc.forEach(((n) => n.L_(e))), this.Sc();
  }
  Sd(e) {
    this.Xc.length !== 1 && (Ke(e >= 0 && e < this.Xc.length, "Invalid pane index"), this.Xc.splice(e, 1), this.Ca());
  }
  xd(e, n) {
    if (this.Xc.length < 2) return;
    Ke(e >= 0 && e < this.Xc.length, "Invalid pane index");
    const i = this.Xc[e], s = this.Xc.reduce(((h, d) => h + d.E_()), 0), r = this.Xc.reduce(((h, d) => h + d.$t()), 0), o = r - 30 * (this.Xc.length - 1);
    n = Math.min(o, Math.max(30, n));
    const l = s / r, a = i.$t();
    i.A_(n * l);
    let c = n - a, u = this.Xc.length - 1;
    for (const h of this.Xc) if (h !== i) {
      const d = Math.min(o, Math.max(30, h.$t() - c / u));
      c -= h.$t() - d, u -= 1;
      const m = d * l;
      h.A_(m);
    }
    this.Ca();
  }
  Cd(e, n) {
    Ke(e >= 0 && e < this.Xc.length && n >= 0 && n < this.Xc.length, "Invalid pane index");
    const i = this.Xc[e], s = this.Xc[n];
    this.Xc[e] = s, this.Xc[n] = i, this.Ca();
  }
  yd(e, n) {
    if (Ke(e >= 0 && e < this.Xc.length && n >= 0 && n < this.Xc.length, "Invalid pane index"), e === n) return;
    const [i] = this.Xc.splice(e, 1);
    this.Xc.splice(n, 0, i), this.Ca();
  }
  j_(e, n, i) {
    e.j_(n, i);
  }
  Y_(e, n, i) {
    e.Y_(n, i), this.ka(), this.dd(this.kd(e, 2));
  }
  K_(e, n) {
    e.K_(n), this.dd(this.kd(e, 2));
  }
  Z_(e, n, i) {
    n.Vo() || e.Z_(n, i);
  }
  G_(e, n, i) {
    n.Vo() || (e.G_(n, i), this.ka(), this.dd(this.kd(e, 2)));
  }
  X_(e, n) {
    n.Vo() || (e.X_(n), this.dd(this.kd(e, 2)));
  }
  Q_(e, n) {
    e.Q_(n), this.dd(this.kd(e, 2));
  }
  Pd(e) {
    this.Jh.h_(e);
  }
  Td(e, n) {
    const i = this.Et();
    if (i.Gi() || n === 0) return;
    const s = i.ss();
    e = Math.max(1, Math.min(e, s)), i.Rc(e, n), this.Sc();
  }
  Rd(e) {
    this.Dd(0), this.Id(e), this.Vd();
  }
  Bd(e) {
    this.Jh.a_(e), this.Sc();
  }
  Ed() {
    this.Jh.l_(), this.dr();
  }
  Dd(e) {
    this.Jh.o_(e);
  }
  Id(e) {
    this.Jh.__(e), this.Sc();
  }
  Vd() {
    this.Jh.u_(), this.dr();
  }
  tn() {
    return this.Jc;
  }
  Us() {
    return this.Qc === null && (this.Qc = this.Jc.filter(((e) => e.It()))), this.Qc;
  }
  xa() {
    this.Qc = null;
  }
  Ad(e, n, i, s, r) {
    this.Ct.Bs(e, n);
    let o = NaN, l = this.Jh.wc(e, !0);
    const a = this.Jh.Ie();
    a !== null && (l = Math.min(Math.max(a.Aa(), l), a.bi())), l = this.Ct.Hs(l);
    const c = s.Rs(), u = c.Lt();
    if (u !== null && (o = c.Ds(n, u)), o = this.ad.bl(o, l, s), this.Ct.zs(l, o, s), this.Ua(), !r) {
      const h = I2(s, e, n);
      this.vd(h && { hu: h.hu, au: h.au, ou: h.ou || null }), this.nd.p(this.Ct.Bt(), { x: e, y: n }, i);
    }
  }
  Ld(e, n, i) {
    const s = i.Rs(), r = s.Lt(), o = s.Nt(e, H(r)), l = this.Jh.ec(n, !0), a = this.Jh.qt(H(l));
    this.Ad(a, o, null, i, !0);
  }
  zd(e) {
    this.gd().Ns(), this.Ua(), e || this.nd.p(null, null, null);
  }
  ka() {
    const e = this.Ct.Gs();
    if (e !== null) {
      const n = this.Ct.As(), i = this.Ct.Ls();
      this.Ad(n, i, null, e);
    }
    this.Ct.Ws();
  }
  Od(e, n, i) {
    const s = this.Jh.Is(0);
    n !== void 0 && i !== void 0 && this.Jh.kt(n, i);
    const r = this.Jh.Is(0), o = this.Jh.vc(), l = this.Jh.Ie();
    if (l !== null && s !== null && r !== null) {
      const a = l.Ee(o), c = this.cu.key(s) > this.cu.key(r), u = e !== null && e > o && !c, h = this.Jh.N().allowShiftVisibleRangeOnWhitespaceReplacement, d = a && (i !== void 0 || h) && this.Jh.N().shiftVisibleRangeOnNewBar;
      if (u && !d) {
        const m = e - o;
        this.Jh.Mn(this.Jh.Cc() - m);
      }
    }
    this.Jh.Tc(e);
  }
  Ra(e) {
    e !== null && e.iu();
  }
  Kn(e) {
    if ((function(i) {
      return i instanceof Qu;
    })(e)) return e;
    const n = this.Xc.find(((i) => i.Dt().includes(e)));
    return n === void 0 ? null : n;
  }
  Sc() {
    this.Xc.forEach(((e) => e.iu())), this.ka();
  }
  m() {
    this.Xc.forEach(((e) => e.m())), this.Xc.length = 0, this.Ps.localization.priceFormatter = void 0, this.Ps.localization.percentageFormatter = void 0, this.Ps.localization.timeFormatter = void 0;
  }
  Nd() {
    return this.hd;
  }
  Jn() {
    return this.hd.N();
  }
  B_() {
    return this.sd;
  }
  Fd(e, n) {
    const i = this.ld(n);
    this.Wd(e, i), this.Jc.push(e), this.xa(), this.Jc.length === 1 ? this.Ca() : this.dr();
  }
  Hd(e) {
    const n = this.Kn(e), i = this.Jc.indexOf(e);
    Ke(i !== -1, "Series not found");
    const s = H(n);
    this.Jc.splice(i, 1), s.n_(e), e.m && e.m(), this.xa(), this.Jh.Ju(), this.Ud(s);
  }
  Sa(e, n) {
    const i = H(this.Kn(e));
    i.n_(e, !0), i.i_(e, n, !0);
  }
  Fc() {
    const e = Pe.Cn();
    e.cn(), this.dd(e);
  }
  $d(e) {
    const n = Pe.Cn();
    n.pn(e), this.dd(n);
  }
  wn() {
    const e = Pe.Cn();
    e.wn(), this.dd(e);
  }
  gn(e) {
    const n = Pe.Cn();
    n.gn(e), this.dd(n);
  }
  Mn(e) {
    const n = Pe.Cn();
    n.Mn(e), this.dd(n);
  }
  vn(e) {
    const n = Pe.Cn();
    n.vn(e), this.dd(n);
  }
  dn() {
    const e = Pe.Cn();
    e.dn(), this.dd(e);
  }
  qd() {
    return this.Ps.rightPriceScale.visible ? "right" : "left";
  }
  jd(e, n) {
    if (Ke(n >= 0, "Index should be greater or equal to 0"), n === this.Yd(e)) return;
    const i = H(this.Kn(e));
    i.n_(e);
    const s = this.ld(n);
    this.Wd(e, s), i.Sl().length === 0 && this.Ud(i), this.Ca();
  }
  Kd() {
    return this.ud;
  }
  $() {
    return this.od;
  }
  Ut(e) {
    const n = this.ud, i = this.od;
    if (n === i) return n;
    if (e = Math.max(0, Math.min(100, Math.round(100 * e))), this.ed === null || this.ed.eh !== i || this.ed.rh !== n) this.ed = { eh: i, rh: n, Zd: /* @__PURE__ */ new Map() };
    else {
      const r = this.ed.Zd.get(e);
      if (r !== void 0) return r;
    }
    const s = this.ko.tt(i, n, e / 100);
    return this.ed.Zd.set(e, s), s;
  }
  Gd(e) {
    return this.Xc.indexOf(e);
  }
  Xi() {
    return this.ko;
  }
  Xd() {
    return this.Jd();
  }
  Jd(e) {
    const n = new Qu(this.Jh, this);
    this.Xc.push(n);
    const i = e ?? this.Xc.length - 1, s = Pe.yn();
    return s.hn(i, { an: 0, ln: !0 }), this.dd(s), n;
  }
  ld(e) {
    return Ke(e >= 0, "Index should be greater or equal to 0"), (e = Math.min(this.Xc.length, e)) < this.Xc.length ? this.Xc[e] : this.Jd(e);
  }
  Yd(e) {
    return this.Xc.findIndex(((n) => n.F_().includes(e)));
  }
  kd(e, n) {
    const i = new Pe(n);
    if (e !== null) {
      const s = this.Xc.indexOf(e);
      i.hn(s, { an: n });
    }
    return i;
  }
  fd(e, n) {
    return n === void 0 && (n = 2), this.kd(this.Kn(e), n);
  }
  dd(e) {
    this.rd && this.rd(e), this.Xc.forEach(((n) => n.eu().pr().kt()));
  }
  Wd(e, n) {
    const i = e.N().priceScaleId, s = i !== void 0 ? i : this.qd();
    n.i_(e, s), lr(s) || e.cr(e.N());
  }
  _d(e) {
    const n = this.Ps.layout;
    return n.background.type === "gradient" ? e === 0 ? n.background.topColor : n.background.bottomColor : n.background.color;
  }
  Ud(e) {
    !e.N_() && e.Sl().length === 0 && this.Xc.length > 1 && this.Xc.splice(this.Gd(e), 1);
  }
}
function N2(t) {
  if (t >= 1) return 0;
  let e = 0;
  for (; e < 8; e++) {
    const n = Math.round(t);
    if (Math.abs(n - t) < 1e-8) return e;
    t *= 10;
  }
  return e;
}
function Vl(t) {
  return !oi(t) && !zi(t);
}
function F2(t) {
  return oi(t);
}
(function(t) {
  t[t.Disabled = 0] = "Disabled", t[t.Continuous = 1] = "Continuous", t[t.OnDataUpdate = 2] = "OnDataUpdate";
})(Hu || (Hu = {})), (function(t) {
  t[t.LastBar = 0] = "LastBar", t[t.LastVisible = 1] = "LastVisible";
})(Ou || (Ou = {})), (function(t) {
  t.Solid = "solid", t.VerticalGradient = "gradient";
})(Al || (Al = {})), (function(t) {
  t[t.Year = 0] = "Year", t[t.Month = 1] = "Month", t[t.DayOfMonth = 2] = "DayOfMonth", t[t.Time = 3] = "Time", t[t.TimeWithSeconds = 4] = "TimeWithSeconds";
})(Du || (Du = {}));
const Pu = (t) => t.getUTCFullYear();
function k8(t, e, n) {
  return e.replace(/yyyy/g, ((i) => Dt(Pu(i), 4))(t)).replace(/yy/g, ((i) => Dt(Pu(i) % 100, 2))(t)).replace(/MMMM/g, ((i, s) => new Date(i.getUTCFullYear(), i.getUTCMonth(), 1).toLocaleString(s, { month: "long" }))(t, n)).replace(/MMM/g, ((i, s) => new Date(i.getUTCFullYear(), i.getUTCMonth(), 1).toLocaleString(s, { month: "short" }))(t, n)).replace(/MM/g, ((i) => Dt(((s) => s.getUTCMonth() + 1)(i), 2))(t)).replace(/dd/g, ((i) => Dt(((s) => s.getUTCDate())(i), 2))(t));
}
class G2 {
  constructor(e = "yyyy-MM-dd", n = "default") {
    this.Qd = e, this.tf = n;
  }
  du(e) {
    return k8(e, this.Qd, this.tf);
  }
}
class J8 {
  constructor(e) {
    this.if = e || "%h:%m:%s";
  }
  du(e) {
    return this.if.replace("%h", Dt(e.getUTCHours(), 2)).replace("%m", Dt(e.getUTCMinutes(), 2)).replace("%s", Dt(e.getUTCSeconds(), 2));
  }
}
const x8 = { sf: "yyyy-MM-dd", nf: "%h:%m:%s", ef: " ", rf: "default" };
class M8 {
  constructor(e = {}) {
    const n = { ...x8, ...e };
    this.hf = new G2(n.sf, n.rf), this.af = new J8(n.nf), this.lf = n.ef;
  }
  du(e) {
    return `${this.hf.du(e)}${this.lf}${this.af.du(e)}`;
  }
}
function hs(t) {
  return 60 * t * 60 * 1e3;
}
function po(t) {
  return 60 * t * 1e3;
}
const ds = [{ _f: (_u = 1, 1e3 * _u), uf: 10 }, { _f: po(1), uf: 20 }, { _f: po(5), uf: 21 }, { _f: po(30), uf: 22 }, { _f: hs(1), uf: 30 }, { _f: hs(3), uf: 31 }, { _f: hs(6), uf: 32 }, { _f: hs(12), uf: 33 }];
var _u;
function ju(t, e) {
  if (t.getUTCFullYear() !== e.getUTCFullYear()) return 70;
  if (t.getUTCMonth() !== e.getUTCMonth()) return 60;
  if (t.getUTCDate() !== e.getUTCDate()) return 50;
  for (let n = ds.length - 1; n >= 0; --n) if (Math.floor(e.getTime() / ds[n]._f) !== Math.floor(t.getTime() / ds[n]._f)) return ds[n].uf;
  return 0;
}
function go(t) {
  let e = t;
  if (zi(t) && (e = da(t)), !Vl(e)) throw new Error("time must be of type BusinessDay");
  const n = new Date(Date.UTC(e.year, e.month - 1, e.day, 0, 0, 0, 0));
  return { cf: Math.round(n.getTime() / 1e3), df: e };
}
function $u(t) {
  if (!F2(t)) throw new Error("time must be of type isUTCTimestamp");
  return { cf: t };
}
function da(t) {
  const e = new Date(t);
  if (isNaN(e.getTime())) throw new Error(`Invalid date string=${t}, expected format=yyyy-mm-dd`);
  return { day: e.getUTCDate(), month: e.getUTCMonth() + 1, year: e.getUTCFullYear() };
}
function qu(t) {
  zi(t.time) && (t.time = da(t.time));
}
class eh {
  options() {
    return this.Ps;
  }
  setOptions(e) {
    this.Ps = e, this.updateFormatter(e.localization);
  }
  preprocessData(e) {
    Array.isArray(e) ? (function(n) {
      n.forEach(qu);
    })(e) : qu(e);
  }
  createConverterToInternalObj(e) {
    return H((function(n) {
      return n.length === 0 ? null : Vl(n[0].time) || zi(n[0].time) ? go : $u;
    })(e));
  }
  key(e) {
    return typeof e == "object" && "cf" in e ? e.cf : this.key(this.convertHorzItemToInternal(e));
  }
  cacheKey(e) {
    const n = e;
    return n.df === void 0 ? new Date(1e3 * n.cf).getTime() : new Date(Date.UTC(n.df.year, n.df.month - 1, n.df.day)).getTime();
  }
  convertHorzItemToInternal(e) {
    return F2(n = e) ? $u(n) : Vl(n) ? go(n) : go(da(n));
    var n;
  }
  updateFormatter(e) {
    if (!this.Ps) return;
    const n = e.dateFormat;
    this.Ps.timeScale.timeVisible ? this.ff = new M8({ sf: n, nf: this.Ps.timeScale.secondsVisible ? "%h:%m:%s" : "%h:%m", ef: "   ", rf: e.locale }) : this.ff = new G2(n, e.locale);
  }
  formatHorzItem(e) {
    const n = e;
    return this.ff.du(new Date(1e3 * n.cf));
  }
  formatTickmark(e, n) {
    const i = (function(r, o, l) {
      switch (r) {
        case 0:
        case 10:
          return o ? l ? 4 : 3 : 2;
        case 20:
        case 21:
        case 22:
        case 30:
        case 31:
        case 32:
        case 33:
          return o ? 3 : 2;
        case 50:
          return 2;
        case 60:
          return 1;
        case 70:
          return 0;
      }
    })(e.weight, this.Ps.timeScale.timeVisible, this.Ps.timeScale.secondsVisible), s = this.Ps.timeScale;
    if (s.tickMarkFormatter !== void 0) {
      const r = s.tickMarkFormatter(e.originalTime, i, n.locale);
      if (r !== null) return r;
    }
    return (function(r, o, l) {
      const a = {};
      switch (o) {
        case 0:
          a.year = "numeric";
          break;
        case 1:
          a.month = "short";
          break;
        case 2:
          a.day = "numeric";
          break;
        case 3:
          a.hour12 = !1, a.hour = "2-digit", a.minute = "2-digit";
          break;
        case 4:
          a.hour12 = !1, a.hour = "2-digit", a.minute = "2-digit", a.second = "2-digit";
      }
      const c = r.df === void 0 ? new Date(1e3 * r.cf) : new Date(Date.UTC(r.df.year, r.df.month - 1, r.df.day));
      return new Date(c.getUTCFullYear(), c.getUTCMonth(), c.getUTCDate(), c.getUTCHours(), c.getUTCMinutes(), c.getUTCSeconds(), c.getUTCMilliseconds()).toLocaleString(l, a);
    })(e.time, i, n.locale);
  }
  maxTickMarkWeight(e) {
    let n = e.reduce(Y8, e[0]).weight;
    return n > 30 && n < 50 && (n = 30), n;
  }
  fillWeightsForPoints(e, n) {
    (function(i, s = 0) {
      if (i.length === 0) return;
      let r = s === 0 ? null : i[s - 1].time.cf, o = r !== null ? new Date(1e3 * r) : null, l = 0;
      for (let a = s; a < i.length; ++a) {
        const c = i[a], u = new Date(1e3 * c.time.cf);
        o !== null && (c.timeWeight = ju(u, o)), l += c.time.cf - (r || c.time.cf), r = c.time.cf, o = u;
      }
      if (s === 0 && i.length > 1) {
        const a = Math.ceil(l / (i.length - 1)), c = new Date(1e3 * (i[0].time.cf - a));
        i[0].timeWeight = ju(new Date(1e3 * i[0].time.cf), c);
      }
    })(e, n);
  }
  static pf(e) {
    return tt({ localization: { dateFormat: "dd MMM 'yy" } }, e ?? {});
  }
}
const ai = typeof window < "u";
function th() {
  return !!ai && window.navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
}
function fo() {
  return !!ai && /iPhone|iPad|iPod/.test(window.navigator.platform);
}
function Rl(t) {
  return t + t % 2;
}
function Q8(t) {
  ai && window.chrome !== void 0 && t.addEventListener("mousedown", ((e) => {
    if (e.button === 1) return e.preventDefault(), !1;
  }));
}
class ur {
  constructor(e, n, i) {
    this.vf = 0, this.mf = null, this.wf = { _t: Number.NEGATIVE_INFINITY, ut: Number.POSITIVE_INFINITY }, this.gf = 0, this.Mf = null, this.bf = { _t: Number.NEGATIVE_INFINITY, ut: Number.POSITIVE_INFINITY }, this.Sf = null, this.xf = !1, this.Cf = null, this.yf = null, this.kf = !1, this.Pf = !1, this.Tf = !1, this.Rf = null, this.Df = null, this.If = null, this.Vf = null, this.Bf = null, this.Ef = null, this.Af = null, this.Lf = 0, this.zf = !1, this.Of = !1, this.Nf = !1, this.Ff = 0, this.Wf = null, this.Hf = !fo(), this.Uf = (s) => {
      this.$f(s);
    }, this.qf = (s) => {
      if (this.jf(s)) {
        const r = this.Yf(s);
        if (++this.gf, this.Mf && this.gf > 1) {
          const { Kf: o } = this.Zf(yt(s), this.bf);
          o < 30 && !this.Tf && this.Gf(r, this.Jf.Xf), this.Qf();
        }
      } else {
        const r = this.Yf(s);
        if (++this.vf, this.mf && this.vf > 1) {
          const { Kf: o } = this.Zf(yt(s), this.wf);
          o < 5 && !this.Pf && this.tp(r, this.Jf.ip), this.sp();
        }
      }
    }, this.np = e, this.Jf = n, this.Ps = i, this.ep();
  }
  m() {
    this.Rf !== null && (this.Rf(), this.Rf = null), this.Df !== null && (this.Df(), this.Df = null), this.Vf !== null && (this.Vf(), this.Vf = null), this.Bf !== null && (this.Bf(), this.Bf = null), this.Ef !== null && (this.Ef(), this.Ef = null), this.If !== null && (this.If(), this.If = null), this.rp(), this.sp();
  }
  hp(e) {
    this.Vf && this.Vf();
    const n = this.ap.bind(this);
    if (this.Vf = () => {
      this.np.removeEventListener("mousemove", n);
    }, this.np.addEventListener("mousemove", n), this.jf(e)) return;
    const i = this.Yf(e);
    this.tp(i, this.Jf.lp), this.Hf = !0;
  }
  sp() {
    this.mf !== null && clearTimeout(this.mf), this.vf = 0, this.mf = null, this.wf = { _t: Number.NEGATIVE_INFINITY, ut: Number.POSITIVE_INFINITY };
  }
  Qf() {
    this.Mf !== null && clearTimeout(this.Mf), this.gf = 0, this.Mf = null, this.bf = { _t: Number.NEGATIVE_INFINITY, ut: Number.POSITIVE_INFINITY };
  }
  ap(e) {
    if (this.Nf || this.yf !== null || this.jf(e)) return;
    const n = this.Yf(e);
    this.tp(n, this.Jf.op), this.Hf = !0;
  }
  _p(e) {
    const n = bo(e.changedTouches, H(this.Wf));
    if (n === null || (this.Ff = ms(e), this.Af !== null) || this.Of) return;
    this.zf = !0;
    const i = this.Zf(yt(n), H(this.yf)), { up: s, cp: r, Kf: o } = i;
    if (this.kf || !(o < 5)) {
      if (!this.kf) {
        const l = 0.5 * s, a = r >= l && !this.Ps.dp(), c = l > r && !this.Ps.fp();
        a || c || (this.Of = !0), this.kf = !0, this.Tf = !0, this.rp(), this.Qf();
      }
      if (!this.Of) {
        const l = this.Yf(e, n);
        this.Gf(l, this.Jf.pp), Tn(e);
      }
    }
  }
  vp(e) {
    if (e.button !== 0) return;
    const n = this.Zf(yt(e), H(this.Cf)), { Kf: i } = n;
    if (i >= 5 && (this.Pf = !0, this.sp()), this.Pf) {
      const s = this.Yf(e);
      this.tp(s, this.Jf.mp);
    }
  }
  Zf(e, n) {
    const i = Math.abs(n._t - e._t), s = Math.abs(n.ut - e.ut);
    return { up: i, cp: s, Kf: i + s };
  }
  wp(e) {
    let n = bo(e.changedTouches, H(this.Wf));
    if (n === null && e.touches.length === 0 && (n = e.changedTouches[0]), n === null) return;
    this.Wf = null, this.Ff = ms(e), this.rp(), this.yf = null, this.Ef && (this.Ef(), this.Ef = null);
    const i = this.Yf(e, n);
    if (this.Gf(i, this.Jf.gp), ++this.gf, this.Mf && this.gf > 1) {
      const { Kf: s } = this.Zf(yt(n), this.bf);
      s < 30 && !this.Tf && this.Gf(i, this.Jf.Xf), this.Qf();
    } else this.Tf || (this.Gf(i, this.Jf.Mp), this.Jf.Mp && Tn(e));
    this.gf === 0 && Tn(e), e.touches.length === 0 && this.xf && (this.xf = !1, Tn(e));
  }
  $f(e) {
    if (e.button !== 0) return;
    const n = this.Yf(e);
    if (this.Cf = null, this.Nf = !1, this.Bf && (this.Bf(), this.Bf = null), th() && this.np.ownerDocument.documentElement.removeEventListener("mouseleave", this.Uf), !this.jf(e)) if (this.tp(n, this.Jf.bp), ++this.vf, this.mf && this.vf > 1) {
      const { Kf: i } = this.Zf(yt(e), this.wf);
      i < 5 && !this.Pf && this.tp(n, this.Jf.ip), this.sp();
    } else this.Pf || this.tp(n, this.Jf.Sp);
  }
  rp() {
    this.Sf !== null && (clearTimeout(this.Sf), this.Sf = null);
  }
  xp(e) {
    if (this.Wf !== null) return;
    const n = e.changedTouches[0];
    this.Wf = n.identifier, this.Ff = ms(e);
    const i = this.np.ownerDocument.documentElement;
    this.Tf = !1, this.kf = !1, this.Of = !1, this.yf = yt(n), this.Ef && (this.Ef(), this.Ef = null);
    {
      const r = this._p.bind(this), o = this.wp.bind(this);
      this.Ef = () => {
        i.removeEventListener("touchmove", r), i.removeEventListener("touchend", o);
      }, i.addEventListener("touchmove", r, { passive: !1 }), i.addEventListener("touchend", o, { passive: !1 }), this.rp(), this.Sf = setTimeout(this.Cp.bind(this, e), 240);
    }
    const s = this.Yf(e, n);
    this.Gf(s, this.Jf.yp), this.Mf || (this.gf = 0, this.Mf = setTimeout(this.Qf.bind(this), 500), this.bf = yt(n));
  }
  kp(e) {
    if (e.button !== 0) return;
    const n = this.np.ownerDocument.documentElement;
    th() && n.addEventListener("mouseleave", this.Uf), this.Pf = !1, this.Cf = yt(e), this.Bf && (this.Bf(), this.Bf = null);
    {
      const s = this.vp.bind(this), r = this.$f.bind(this);
      this.Bf = () => {
        n.removeEventListener("mousemove", s), n.removeEventListener("mouseup", r);
      }, n.addEventListener("mousemove", s), n.addEventListener("mouseup", r);
    }
    if (this.Nf = !0, this.jf(e)) return;
    const i = this.Yf(e);
    this.tp(i, this.Jf.Pp), this.mf || (this.vf = 0, this.mf = setTimeout(this.sp.bind(this), 500), this.wf = yt(e));
  }
  ep() {
    this.np.addEventListener("mouseenter", this.hp.bind(this)), this.np.addEventListener("touchcancel", this.rp.bind(this));
    {
      const e = this.np.ownerDocument, n = (i) => {
        this.Jf.Tp && (i.composed && this.np.contains(i.composedPath()[0]) || i.target && this.np.contains(i.target) || this.Jf.Tp());
      };
      this.Df = () => {
        e.removeEventListener("touchstart", n);
      }, this.Rf = () => {
        e.removeEventListener("mousedown", n);
      }, e.addEventListener("mousedown", n), e.addEventListener("touchstart", n, { passive: !0 });
    }
    fo() && (this.If = () => {
      this.np.removeEventListener("dblclick", this.qf);
    }, this.np.addEventListener("dblclick", this.qf)), this.np.addEventListener("mouseleave", this.Rp.bind(this)), this.np.addEventListener("touchstart", this.xp.bind(this), { passive: !0 }), Q8(this.np), this.np.addEventListener("mousedown", this.kp.bind(this)), this.Dp(), this.np.addEventListener("touchmove", (() => {
    }), { passive: !1 });
  }
  Dp() {
    this.Jf.Ip === void 0 && this.Jf.Vp === void 0 && this.Jf.Bp === void 0 || (this.np.addEventListener("touchstart", ((e) => this.Ep(e.touches)), { passive: !0 }), this.np.addEventListener("touchmove", ((e) => {
      if (e.touches.length === 2 && this.Af !== null && this.Jf.Vp !== void 0) {
        const n = nh(e.touches[0], e.touches[1]) / this.Lf;
        this.Jf.Vp(this.Af, n), Tn(e);
      }
    }), { passive: !1 }), this.np.addEventListener("touchend", ((e) => {
      this.Ep(e.touches);
    })));
  }
  Ep(e) {
    e.length === 1 && (this.zf = !1), e.length !== 2 || this.zf || this.xf ? this.Ap() : this.Lp(e);
  }
  Lp(e) {
    const n = this.np.getBoundingClientRect() || { left: 0, top: 0 };
    this.Af = { _t: (e[0].clientX - n.left + (e[1].clientX - n.left)) / 2, ut: (e[0].clientY - n.top + (e[1].clientY - n.top)) / 2 }, this.Lf = nh(e[0], e[1]), this.Jf.Ip !== void 0 && this.Jf.Ip(), this.rp();
  }
  Ap() {
    this.Af !== null && (this.Af = null, this.Jf.Bp !== void 0 && this.Jf.Bp());
  }
  Rp(e) {
    if (this.Vf && this.Vf(), this.jf(e) || !this.Hf) return;
    const n = this.Yf(e);
    this.tp(n, this.Jf.zp), this.Hf = !fo();
  }
  Cp(e) {
    const n = bo(e.touches, H(this.Wf));
    if (n === null) return;
    const i = this.Yf(e, n);
    this.Gf(i, this.Jf.Op), this.Tf = !0, this.xf = !0;
  }
  jf(e) {
    return e.sourceCapabilities && e.sourceCapabilities.firesTouchEvents !== void 0 ? e.sourceCapabilities.firesTouchEvents : ms(e) < this.Ff + 500;
  }
  Gf(e, n) {
    n && n.call(this.Jf, e);
  }
  tp(e, n) {
    n && n.call(this.Jf, e);
  }
  Yf(e, n) {
    const i = n || e, s = this.np.getBoundingClientRect() || { left: 0, top: 0 };
    return { clientX: i.clientX, clientY: i.clientY, pageX: i.pageX, pageY: i.pageY, screenX: i.screenX, screenY: i.screenY, localX: i.clientX - s.left, localY: i.clientY - s.top, ctrlKey: e.ctrlKey, altKey: e.altKey, shiftKey: e.shiftKey, metaKey: e.metaKey, Np: !e.type.startsWith("mouse") && e.type !== "contextmenu" && e.type !== "click", Fp: e.type, Wp: i.target, _u: e.view, Hp: () => {
      e.type !== "touchstart" && Tn(e);
    } };
  }
}
function nh(t, e) {
  const n = t.clientX - e.clientX, i = t.clientY - e.clientY;
  return Math.sqrt(n * n + i * i);
}
function Tn(t) {
  t.cancelable && t.preventDefault();
}
function yt(t) {
  return { _t: t.pageX, ut: t.pageY };
}
function ms(t) {
  return t.timeStamp || performance.now();
}
function bo(t, e) {
  for (let n = 0; n < t.length; ++n) if (t[n].identifier === e) return t[n];
  return null;
}
class z8 {
  constructor(e, n, i) {
    this.Up = null, this.$p = null, this.qp = !0, this.jp = null, this.Yp = e, this.Kp = e.Zp()[n], this.Gp = e.Zp()[i], this.Xp = document.createElement("tr"), this.Xp.style.height = "1px", this.Jp = document.createElement("td"), this.Jp.style.position = "relative", this.Jp.style.padding = "0", this.Jp.style.margin = "0", this.Jp.setAttribute("colspan", "3"), this.Qp(), this.Xp.appendChild(this.Jp), this.qp = this.Yp.N().layout.panes.enableResize, this.qp ? this.tv() : (this.Up = null, this.$p = null);
  }
  m() {
    this.$p !== null && this.$p.m();
  }
  iv() {
    return this.Xp;
  }
  sv() {
    return Re({ width: this.Kp.sv().width, height: 1 });
  }
  nv() {
    return Re({ width: this.Kp.nv().width, height: 1 * window.devicePixelRatio });
  }
  ev(e, n, i) {
    const s = this.nv();
    e.fillStyle = this.Yp.N().layout.panes.separatorColor, e.fillRect(n, i, s.width, s.height);
  }
  kt() {
    this.Qp(), this.Yp.N().layout.panes.enableResize !== this.qp && (this.qp = this.Yp.N().layout.panes.enableResize, this.qp ? this.tv() : (this.Up !== null && (this.Jp.removeChild(this.Up.rv), this.Jp.removeChild(this.Up.hv), this.Up = null), this.$p !== null && (this.$p.m(), this.$p = null)));
  }
  tv() {
    const e = document.createElement("div"), n = e.style;
    n.position = "fixed", n.display = "none", n.zIndex = "49", n.top = "0", n.left = "0", n.width = "100%", n.height = "100%", n.cursor = "row-resize", this.Jp.appendChild(e);
    const i = document.createElement("div"), s = i.style;
    s.position = "absolute", s.zIndex = "50", s.top = "-4px", s.height = "9px", s.width = "100%", s.backgroundColor = "", s.cursor = "row-resize", this.Jp.appendChild(i);
    const r = { lp: this.av.bind(this), zp: this.lv.bind(this), Pp: this.ov.bind(this), yp: this.ov.bind(this), mp: this._v.bind(this), pp: this._v.bind(this), bp: this.uv.bind(this), gp: this.uv.bind(this) };
    this.$p = new ur(i, r, { dp: () => !1, fp: () => !0 }), this.Up = { hv: i, rv: e };
  }
  Qp() {
    this.Jp.style.background = this.Yp.N().layout.panes.separatorColor;
  }
  av(e) {
    this.Up !== null && (this.Up.hv.style.backgroundColor = this.Yp.N().layout.panes.separatorHoverColor);
  }
  lv(e) {
    this.Up !== null && this.jp === null && (this.Up.hv.style.backgroundColor = "");
  }
  ov(e) {
    if (this.Up === null) return;
    const n = this.Kp.cv().E_() + this.Gp.cv().E_(), i = n / (this.Kp.sv().height + this.Gp.sv().height), s = 30 * i;
    n <= 2 * s || (this.jp = { dv: e.pageY, fv: this.Kp.cv().E_(), pv: n - s, vv: n, mv: i, wv: s }, this.Up.rv.style.display = "block");
  }
  _v(e) {
    const n = this.jp;
    if (n === null) return;
    const i = (e.pageY - n.dv) * n.mv, s = Wi(n.fv + i, n.wv, n.pv);
    this.Kp.cv().A_(s), this.Gp.cv().A_(n.vv - s), this.Yp.Qt().Ca();
  }
  uv(e) {
    this.jp !== null && this.Up !== null && (this.jp = null, this.Up.rv.style.display = "none");
  }
}
function Ao(t, e) {
  return t.gv - e.gv;
}
function Vo(t, e, n) {
  const i = (t.gv - e.gv) / (t.wt - e.wt);
  return Math.sign(i) * Math.min(Math.abs(i), n);
}
class K8 {
  constructor(e, n, i, s) {
    this.Mv = null, this.bv = null, this.Sv = null, this.xv = null, this.Cv = null, this.yv = 0, this.kv = 0, this.Pv = e, this.Tv = n, this.Rv = i, this.kn = s;
  }
  Dv(e, n) {
    if (this.Mv !== null) {
      if (this.Mv.wt === n) return void (this.Mv.gv = e);
      if (Math.abs(this.Mv.gv - e) < this.kn) return;
    }
    this.xv = this.Sv, this.Sv = this.bv, this.bv = this.Mv, this.Mv = { wt: n, gv: e };
  }
  fe(e, n) {
    if (this.Mv === null || this.bv === null || n - this.Mv.wt > 50) return;
    let i = 0;
    const s = Vo(this.Mv, this.bv, this.Tv), r = Ao(this.Mv, this.bv), o = [s], l = [r];
    if (i += r, this.Sv !== null) {
      const c = Vo(this.bv, this.Sv, this.Tv);
      if (Math.sign(c) === Math.sign(s)) {
        const u = Ao(this.bv, this.Sv);
        if (o.push(c), l.push(u), i += u, this.xv !== null) {
          const h = Vo(this.Sv, this.xv, this.Tv);
          if (Math.sign(h) === Math.sign(s)) {
            const d = Ao(this.Sv, this.xv);
            o.push(h), l.push(d), i += d;
          }
        }
      }
    }
    let a = 0;
    for (let c = 0; c < o.length; ++c) a += l[c] / i * o[c];
    Math.abs(a) < this.Pv || (this.Cv = { gv: e, wt: n }, this.kv = a, this.yv = (function(c, u) {
      const h = Math.log(u);
      return Math.log(1 * h / -c) / h;
    })(Math.abs(a), this.Rv));
  }
  Ac(e) {
    const n = H(this.Cv), i = e - n.wt;
    return n.gv + this.kv * (Math.pow(this.Rv, i) - 1) / Math.log(this.Rv);
  }
  Ec(e) {
    return this.Cv === null || this.Iv(e) === this.yv;
  }
  Iv(e) {
    const n = e - H(this.Cv).wt;
    return Math.min(n, this.yv);
  }
}
class H8 {
  constructor(e, n) {
    this.Vv = void 0, this.Bv = void 0, this.Ev = void 0, this.ws = !1, this.Av = e, this.Lv = n, this.zv();
  }
  kt() {
    this.zv();
  }
  Ov() {
    this.Vv && this.Av.removeChild(this.Vv), this.Bv && this.Av.removeChild(this.Bv), this.Vv = void 0, this.Bv = void 0;
  }
  Nv() {
    return this.ws !== this.Fv() || this.Ev !== this.Wv();
  }
  Wv() {
    return this.Lv.Qt().Xi().J(this.Lv.N().layout.textColor) > 160 ? "dark" : "light";
  }
  Fv() {
    return this.Lv.N().layout.attributionLogo;
  }
  Hv() {
    const e = new URL(location.href);
    return e.hostname ? "&utm_source=" + e.hostname + e.pathname : "";
  }
  zv() {
    this.Nv() && (this.Ov(), this.ws = this.Fv(), this.ws && (this.Ev = this.Wv(), this.Bv = document.createElement("style"), this.Bv.innerText = "a#tv-attr-logo{--fill:#131722;--stroke:#fff;position:absolute;left:10px;bottom:10px;height:19px;width:35px;margin:0;padding:0;border:0;z-index:3;}a#tv-attr-logo[data-dark]{--fill:#D1D4DC;--stroke:#131722;}", this.Vv = document.createElement("a"), this.Vv.href = `https://www.tradingview.com/?utm_medium=lwc-link&utm_campaign=lwc-chart${this.Hv()}`, this.Vv.title = "Charting by TradingView", this.Vv.id = "tv-attr-logo", this.Vv.target = "_blank", this.Vv.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="35" height="19" fill="none"><g fill-rule="evenodd" clip-path="url(#a)" clip-rule="evenodd"><path fill="var(--stroke)" d="M2 0H0v10h6v9h21.4l.5-1.3 6-15 1-2.7H23.7l-.5 1.3-.2.6a5 5 0 0 0-7-.9V0H2Zm20 17h4l5.2-13 .8-2h-7l-1 2.5-.2.5-1.5 3.8-.3.7V17Zm-.8-10a3 3 0 0 0 .7-2.7A3 3 0 1 0 16.8 7h4.4ZM14 7V2H2v6h6v9h4V7h2Z"/><path fill="var(--fill)" d="M14 2H2v6h6v9h6V2Zm12 15h-7l6-15h7l-6 15Zm-7-9a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"/></g><defs><clipPath id="a"><path fill="var(--stroke)" d="M0 0h35v19H0z"/></clipPath></defs></svg>', this.Vv.toggleAttribute("data-dark", this.Ev === "dark"), this.Av.appendChild(this.Bv), this.Av.appendChild(this.Vv)));
  }
}
function In(t, e) {
  const n = H(t.ownerDocument).createElement("canvas");
  t.appendChild(n);
  const i = F4(n, { options: { allowResizeObserver: !0 }, transform: (s, r) => ({ width: Math.max(s.width, r.width), height: Math.max(s.height, r.height) }) });
  return i.resizeCanvasElement(e), i;
}
function Nn(t) {
  t.width = 1, t.height = 1, t.getContext("2d")?.clearRect(0, 0, 1, 1);
}
function El(t, e, n, i) {
  t.Uh && t.Uh(e, n, i);
}
function Zs(t, e, n, i) {
  t.nt(e, n, i);
}
function yl(t, e, n, i) {
  const s = t(n, i);
  for (const r of s) {
    const o = r.Tt(i);
    o !== null && e(o);
  }
}
function Ro(t, e) {
  return (n) => (function(i) {
    return i.Ft !== void 0;
  })(n) ? (n.Ft()?.ol() ?? "") !== e ? [] : n.Ya?.(t) ?? [] : [];
}
function ih(t, e, n, i) {
  if (!t.length) return;
  let s = 0;
  const r = t[0].$t(i, !0);
  let o = e === 1 ? n / 2 - (t[0].Hi() - r / 2) : t[0].Hi() - r / 2 - n / 2;
  o = Math.max(0, o);
  for (let l = 1; l < t.length; l++) {
    const a = t[l], c = t[l - 1], u = c.$t(i, !1), h = a.Hi(), d = c.Hi();
    if (e === 1 ? h > d - u : h < d + u) {
      const m = d - u * e;
      a.Ui(m);
      const p = m - e * u / 2;
      if ((e === 1 ? p < 0 : p > n) && o > 0) {
        const g = e === 1 ? -1 - p : p - n, A = Math.min(g, o);
        for (let b = s; b < t.length; b++) t[b].Ui(t[b].Hi() + e * A);
        o -= A;
      }
    } else s = l, o = e === 1 ? d - u - h : h - (d + u);
  }
}
class sh {
  constructor(e, n, i, s) {
    this.Ki = null, this.Uv = null, this.$v = !1, this.qv = new Ls(200), this.jv = null, this.Yv = 0, this.Kv = !1, this.Zv = () => {
      this.Kv || this.yt.Gv().Qt().dr();
    }, this.Xv = () => {
      this.Kv || this.yt.Gv().Qt().dr();
    }, this.yt = e, this.Ps = n, this.Co = n.layout, this.hd = i, this.Jv = s === "left", this.Qv = Ro("normal", s), this.tm = Ro("top", s), this.im = Ro("bottom", s), this.Jp = document.createElement("div"), this.Jp.style.height = "100%", this.Jp.style.overflow = "hidden", this.Jp.style.width = "25px", this.Jp.style.left = "0", this.Jp.style.position = "relative", this.sm = In(this.Jp, Re({ width: 16, height: 16 })), this.sm.subscribeSuggestedBitmapSizeChanged(this.Zv);
    const r = this.sm.canvasElement;
    r.style.position = "absolute", r.style.zIndex = "1", r.style.left = "0", r.style.top = "0", this.nm = In(this.Jp, Re({ width: 16, height: 16 })), this.nm.subscribeSuggestedBitmapSizeChanged(this.Xv);
    const o = this.nm.canvasElement;
    o.style.position = "absolute", o.style.zIndex = "2", o.style.left = "0", o.style.top = "0";
    const l = { Pp: this.ov.bind(this), yp: this.ov.bind(this), mp: this._v.bind(this), pp: this._v.bind(this), Tp: this.rm.bind(this), bp: this.uv.bind(this), gp: this.uv.bind(this), ip: this.hm.bind(this), Xf: this.hm.bind(this), lp: this.am.bind(this), zp: this.lv.bind(this) };
    this.$p = new ur(this.nm.canvasElement, l, { dp: () => !this.Ps.handleScroll.vertTouchDrag, fp: () => !0 });
  }
  m() {
    this.$p.m(), this.nm.unsubscribeSuggestedBitmapSizeChanged(this.Xv), Nn(this.nm.canvasElement), this.nm.dispose(), this.sm.unsubscribeSuggestedBitmapSizeChanged(this.Zv), Nn(this.sm.canvasElement), this.sm.dispose(), this.Ki !== null && this.Ki.r_().u(this), this.Ki = null;
  }
  iv() {
    return this.Jp;
  }
  k() {
    return this.Co.fontSize;
  }
  lm() {
    const e = this.hd.N();
    return this.jv !== e.P && (this.qv.On(), this.jv = e.P), e;
  }
  om() {
    if (this.Ki === null) return 0;
    let e = 0;
    const n = this.lm(), i = H(this.sm.canvasElement.getContext("2d", { colorSpace: this.yt.Gv().N().layout.colorSpace }));
    i.save();
    const s = this.Ki.Vl();
    i.font = this._m(), s.length > 0 && (e = Math.max(this.qv.Ii(i, s[0].Jl), this.qv.Ii(i, s[s.length - 1].Jl)));
    const r = this.um();
    for (let c = r.length; c--; ) {
      const u = this.qv.Ii(i, r[c].ri());
      u > e && (e = u);
    }
    const o = this.Ki.Lt();
    if (o !== null && this.Uv !== null && (l = this.Ps.crosshair).mode !== 2 && l.horzLine.visible && l.horzLine.labelVisible) {
      const c = this.Ki.Ds(1, o), u = this.Ki.Ds(this.Uv.height - 2, o);
      e = Math.max(e, this.qv.Ii(i, this.Ki.Ji(Math.floor(Math.min(c, u)) + 0.11111111111111, o)), this.qv.Ii(i, this.Ki.Ji(Math.ceil(Math.max(c, u)) - 0.11111111111111, o)));
    }
    var l;
    i.restore();
    const a = e || 34;
    return Rl(Math.ceil(n.S + n.C + n.V + n.B + 5 + a));
  }
  dm(e) {
    this.Uv !== null && Cn(this.Uv, e) || (this.Uv = e, this.Kv = !0, this.sm.resizeCanvasElement(e), this.nm.resizeCanvasElement(e), this.Kv = !1, this.Jp.style.width = `${e.width}px`, this.Jp.style.height = `${e.height}px`);
  }
  fm() {
    return H(this.Uv).width;
  }
  cs(e) {
    this.Ki !== e && (this.Ki !== null && this.Ki.r_().u(this), this.Ki = e, e.r_().i(this.do.bind(this), this));
  }
  Ft() {
    return this.Ki;
  }
  On() {
    const e = this.yt.cv();
    this.yt.Gv().Qt().Q_(e, H(this.Ft()));
  }
  pm(e) {
    if (this.Uv === null) return;
    const n = { colorSpace: this.yt.Gv().N().layout.colorSpace };
    if (e !== 1) {
      this.vm(), this.sm.applySuggestedBitmapSize();
      const s = Zn(this.sm, n);
      s !== null && (s.useBitmapCoordinateSpace(((r) => {
        this.wm(r), this.gm(r);
      })), this.yt.Mm(s, this.im), this.bm(s), this.yt.Mm(s, this.Qv), this.Sm(s));
    }
    this.nm.applySuggestedBitmapSize();
    const i = Zn(this.nm, n);
    i !== null && (i.useBitmapCoordinateSpace((({ context: s, bitmapSize: r }) => {
      s.clearRect(0, 0, r.width, r.height);
    })), this.xm(i), this.yt.Mm(i, this.tm));
  }
  nv() {
    return this.sm.bitmapSize;
  }
  ev(e, n, i, s) {
    const r = this.nv();
    if (r.width > 0 && r.height > 0 && (e.drawImage(this.sm.canvasElement, n, i), s)) {
      const o = this.nm.canvasElement;
      e.drawImage(o, n, i);
    }
  }
  kt() {
    this.Ki?.Vl();
  }
  ov(e) {
    if (this.Ki === null || this.Ki.Gi() || !this.Ps.handleScale.axisPressedMouseMove.price) return;
    const n = this.yt.Gv().Qt(), i = this.yt.cv();
    this.$v = !0, n.j_(i, this.Ki, e.localY);
  }
  _v(e) {
    if (this.Ki === null || !this.Ps.handleScale.axisPressedMouseMove.price) return;
    const n = this.yt.Gv().Qt(), i = this.yt.cv(), s = this.Ki;
    n.Y_(i, s, e.localY);
  }
  rm() {
    if (this.Ki === null || !this.Ps.handleScale.axisPressedMouseMove.price) return;
    const e = this.yt.Gv().Qt(), n = this.yt.cv(), i = this.Ki;
    this.$v && (this.$v = !1, e.K_(n, i));
  }
  uv(e) {
    if (this.Ki === null || !this.Ps.handleScale.axisPressedMouseMove.price) return;
    const n = this.yt.Gv().Qt(), i = this.yt.cv();
    this.$v = !1, n.K_(i, this.Ki);
  }
  hm(e) {
    this.Ps.handleScale.axisDoubleClickReset.price && this.On();
  }
  am(e) {
    this.Ki !== null && (!this.yt.Gv().Qt().N().handleScale.axisPressedMouseMove.price || this.Ki.He() || this.Ki.Eo() || this.Cm(1));
  }
  lv(e) {
    this.Cm(0);
  }
  um() {
    const e = [], n = this.Ki === null ? void 0 : this.Ki;
    return ((i) => {
      for (let s = 0; s < i.length; ++s) {
        const r = i[s].Ks(this.yt.cv(), n);
        for (let o = 0; o < r.length; o++) e.push(r[o]);
      }
    })(this.yt.cv().Dt()), e;
  }
  wm({ context: e, bitmapSize: n }) {
    const { width: i, height: s } = n, r = this.yt.cv().Qt(), o = r.$(), l = r.Kd();
    o === l ? rr(e, 0, 0, i, s, o) : b2(e, 0, 0, i, s, o, l);
  }
  gm({ context: e, bitmapSize: n, horizontalPixelRatio: i }) {
    if (this.Uv === null || this.Ki === null || !this.Ki.N().borderVisible) return;
    e.fillStyle = this.Ki.N().borderColor;
    const s = Math.max(1, Math.floor(this.lm().S * i));
    let r;
    r = this.Jv ? n.width - s : 0, e.fillRect(r, 0, s, n.height);
  }
  bm(e) {
    if (this.Uv === null || this.Ki === null) return;
    const n = this.Ki.Vl(), i = this.Ki.N(), s = this.lm(), r = this.Jv ? this.Uv.width - s.C : 0;
    i.borderVisible && i.ticksVisible && e.useBitmapCoordinateSpace((({ context: o, horizontalPixelRatio: l, verticalPixelRatio: a }) => {
      o.fillStyle = i.borderColor;
      const c = Math.max(1, Math.floor(a)), u = Math.floor(0.5 * a), h = Math.round(s.C * l);
      o.beginPath();
      for (const d of n) o.rect(Math.floor(r * l), Math.round(d.Pl * a) - u, h, c);
      o.fill();
    })), e.useMediaCoordinateSpace((({ context: o }) => {
      o.font = this._m(), o.fillStyle = i.textColor ?? this.Co.textColor, o.textAlign = this.Jv ? "right" : "left", o.textBaseline = "middle";
      const l = this.Jv ? Math.round(r - s.V) : Math.round(r + s.C + s.V), a = n.map(((c) => this.qv.Di(o, c.Jl)));
      for (let c = n.length; c--; ) {
        const u = n[c];
        o.fillText(u.Jl, l, u.Pl + a[c]);
      }
    }));
  }
  vm() {
    if (this.Uv === null || this.Ki === null) return;
    let e = this.Uv.height / 2;
    const n = [], i = this.Ki.Dt().slice(), s = this.yt.cv(), r = this.lm();
    this.Ki === s.Gn() && this.yt.cv().Dt().forEach(((a) => {
      s.Zn(a) && i.push(a);
    }));
    const o = this.Ki.Sl()[0], l = this.Ki;
    i.forEach(((a) => {
      const c = a.Ks(s, l);
      c.forEach(((u) => {
        u.$i() && u.Wi() === null && (u.Ui(null), n.push(u));
      })), o === a && c.length > 0 && (e = c[0].Ei());
    })), this.Ki.N().alignLabels && this.ym(n, r, e);
  }
  ym(e, n, i) {
    if (this.Uv === null) return;
    const s = e.filter(((o) => o.Ei() <= i)), r = e.filter(((o) => o.Ei() > i));
    s.sort(((o, l) => l.Ei() - o.Ei())), s.length && r.length && r.push(s[0]), r.sort(((o, l) => o.Ei() - l.Ei()));
    for (const o of e) {
      const l = Math.floor(o.$t(n) / 2), a = o.Ei();
      a > -l && a < l && o.Ui(l), a > this.Uv.height - l && a < this.Uv.height + l && o.Ui(this.Uv.height - l);
    }
    ih(s, 1, this.Uv.height, n), ih(r, -1, this.Uv.height, n);
  }
  Sm(e) {
    if (this.Uv === null) return;
    const n = this.um(), i = this.lm(), s = this.Jv ? "right" : "left";
    n.forEach(((r) => {
      r.qi() && r.Tt(H(this.Ki)).nt(e, i, this.qv, s);
    }));
  }
  xm(e) {
    if (this.Uv === null || this.Ki === null) return;
    const n = this.yt.Gv().Qt(), i = [], s = this.yt.cv(), r = n.gd().Ks(s, this.Ki);
    r.length && i.push(r);
    const o = this.lm(), l = this.Jv ? "right" : "left";
    i.forEach(((a) => {
      a.forEach(((c) => {
        c.Tt(H(this.Ki)).nt(e, o, this.qv, l);
      }));
    }));
  }
  Cm(e) {
    this.Jp.style.cursor = e === 1 ? "ns-resize" : "default";
  }
  do() {
    const e = this.om();
    this.Yv < e && this.yt.Gv().Qt().Ca(), this.Yv = e;
  }
  _m() {
    return Ts(this.Co.fontSize, this.Co.fontFamily);
  }
}
function O8(t, e) {
  return t.qa?.(e) ?? [];
}
function rh(t, e) {
  return t.Ys?.(e) ?? [];
}
function oh(t, e) {
  return t.ds?.(e) ?? [];
}
function D8(t, e) {
  return t.Ha?.(e) ?? [];
}
class ma {
  constructor(e, n) {
    this.Uv = Re({ width: 0, height: 0 }), this.km = null, this.Pm = null, this.Tm = null, this.Rm = null, this.Dm = !1, this.Im = new Ye(), this.Vm = new Ye(), this.Bm = 0, this.Em = !1, this.Am = null, this.Lm = !1, this.zm = null, this.Om = null, this.Kv = !1, this.Zv = () => {
      this.Kv || this.Nm === null || this.ns().dr();
    }, this.Xv = () => {
      this.Kv || this.Nm === null || this.ns().dr();
    }, this.Lv = e, this.Nm = n, this.Nm.nu().i(this.Fm.bind(this), this, !0), this.Wm = document.createElement("td"), this.Wm.style.padding = "0", this.Wm.style.position = "relative";
    const i = document.createElement("div");
    i.style.width = "100%", i.style.height = "100%", i.style.position = "relative", i.style.overflow = "hidden", this.Hm = document.createElement("td"), this.Hm.style.padding = "0", this.Um = document.createElement("td"), this.Um.style.padding = "0", this.Wm.appendChild(i), this.sm = In(i, Re({ width: 16, height: 16 })), this.sm.subscribeSuggestedBitmapSizeChanged(this.Zv);
    const s = this.sm.canvasElement;
    s.style.position = "absolute", s.style.zIndex = "1", s.style.left = "0", s.style.top = "0", this.nm = In(i, Re({ width: 16, height: 16 })), this.nm.subscribeSuggestedBitmapSizeChanged(this.Xv);
    const r = this.nm.canvasElement;
    r.style.position = "absolute", r.style.zIndex = "2", r.style.left = "0", r.style.top = "0", this.Xp = document.createElement("tr"), this.Xp.appendChild(this.Hm), this.Xp.appendChild(this.Wm), this.Xp.appendChild(this.Um), this.$m(), this.$p = new ur(this.nm.canvasElement, this, { dp: () => this.Am === null && !this.Lv.N().handleScroll.vertTouchDrag, fp: () => this.Am === null && !this.Lv.N().handleScroll.horzTouchDrag });
  }
  m() {
    this.km !== null && this.km.m(), this.Pm !== null && this.Pm.m(), this.Tm = null, this.nm.unsubscribeSuggestedBitmapSizeChanged(this.Xv), Nn(this.nm.canvasElement), this.nm.dispose(), this.sm.unsubscribeSuggestedBitmapSizeChanged(this.Zv), Nn(this.sm.canvasElement), this.sm.dispose(), this.Nm !== null && (this.Nm.nu().u(this), this.Nm.m()), this.$p.m();
  }
  cv() {
    return H(this.Nm);
  }
  qm(e) {
    this.Nm !== null && this.Nm.nu().u(this), this.Nm = e, this.Nm !== null && this.Nm.nu().i(ma.prototype.Fm.bind(this), this, !0), this.$m(), this.Lv.Zp().indexOf(this) === this.Lv.Zp().length - 1 ? (this.Tm = this.Tm ?? new H8(this.Wm, this.Lv), this.Tm.kt()) : (this.Tm?.Ov(), this.Tm = null);
  }
  Gv() {
    return this.Lv;
  }
  iv() {
    return this.Xp;
  }
  $m() {
    if (this.Nm !== null && (this.jm(), this.ns().tn().length !== 0)) {
      if (this.km !== null) {
        const e = this.Nm.U_();
        this.km.cs(H(e));
      }
      if (this.Pm !== null) {
        const e = this.Nm.q_();
        this.Pm.cs(H(e));
      }
    }
  }
  Ym() {
    this.km !== null && this.km.kt(), this.Pm !== null && this.Pm.kt();
  }
  E_() {
    return this.Nm !== null ? this.Nm.E_() : 0;
  }
  A_(e) {
    this.Nm && this.Nm.A_(e);
  }
  lp(e) {
    if (!this.Nm) return;
    this.Km();
    const n = e.localX, i = e.localY;
    this.Zm(n, i, e);
  }
  Pp(e) {
    this.Km(), this.Gm(), this.Zm(e.localX, e.localY, e);
  }
  op(e) {
    if (!this.Nm) return;
    this.Km();
    const n = e.localX, i = e.localY;
    this.Zm(n, i, e);
  }
  Sp(e) {
    this.Nm !== null && (this.Km(), this.Xm(e));
  }
  ip(e) {
    this.Nm !== null && this.Jm(this.Vm, e);
  }
  Xf(e) {
    this.ip(e);
  }
  mp(e) {
    this.Km(), this.Qm(e), this.Zm(e.localX, e.localY, e);
  }
  bp(e) {
    this.Nm !== null && (this.Km(), this.Em = !1, this.tw(e));
  }
  Mp(e) {
    this.Nm !== null && this.Xm(e);
  }
  Op(e) {
    if (this.Em = !0, this.Am === null) {
      const n = { x: e.localX, y: e.localY };
      this.iw(n, n, e);
    }
  }
  zp(e) {
    this.Nm !== null && (this.Km(), this.Nm.Qt().vd(null), this.sw());
  }
  nw() {
    return this.Im;
  }
  ew() {
    return this.Vm;
  }
  Ip() {
    this.Bm = 1, this.ns().dn();
  }
  Vp(e, n) {
    if (!this.Lv.N().handleScale.pinch) return;
    const i = 5 * (n - this.Bm);
    this.Bm = n, this.ns().Td(e._t, i);
  }
  yp(e) {
    this.Em = !1, this.Lm = this.Am !== null, this.Gm();
    const n = this.ns().gd();
    this.Am !== null && n.It() && (this.zm = { x: n.si(), y: n.ni() }, this.Am = { x: e.localX, y: e.localY });
  }
  pp(e) {
    if (this.Nm === null) return;
    const n = e.localX, i = e.localY;
    if (this.Am === null) this.Qm(e);
    else {
      this.Lm = !1;
      const s = H(this.zm), r = s.x + (n - this.Am.x), o = s.y + (i - this.Am.y);
      this.Zm(r, o, e);
    }
  }
  gp(e) {
    this.Gv().N().trackingMode.exitMode === 0 && (this.Lm = !0), this.rw(), this.tw(e);
  }
  Qn(e, n) {
    const i = this.Nm;
    return i === null ? null : I2(i, e, n);
  }
  hw(e, n) {
    H(n === "left" ? this.km : this.Pm).dm(Re({ width: e, height: this.Uv.height }));
  }
  sv() {
    return this.Uv;
  }
  dm(e) {
    Cn(this.Uv, e) || (this.Uv = e, this.Kv = !0, this.sm.resizeCanvasElement(e), this.nm.resizeCanvasElement(e), this.Kv = !1, this.Wm.style.width = e.width + "px", this.Wm.style.height = e.height + "px");
  }
  aw() {
    const e = H(this.Nm);
    e.H_(e.U_()), e.H_(e.q_());
    for (const n of e.Sl()) if (e.Zn(n)) {
      const i = n.Ft();
      i !== null && e.H_(i), n.Ws();
    }
    for (const n of e.ru()) n.Ws();
  }
  nv() {
    return this.sm.bitmapSize;
  }
  ev(e, n, i, s) {
    const r = this.nv();
    if (r.width > 0 && r.height > 0 && (e.drawImage(this.sm.canvasElement, n, i), s)) {
      const o = this.nm.canvasElement;
      e !== null && e.drawImage(o, n, i);
    }
  }
  pm(e) {
    if (e === 0 || this.Nm === null) return;
    e > 1 && this.aw(), this.km !== null && this.km.pm(e), this.Pm !== null && this.Pm.pm(e);
    const n = { colorSpace: this.Lv.N().layout.colorSpace };
    if (e !== 1) {
      this.sm.applySuggestedBitmapSize();
      const s = Zn(this.sm, n);
      s !== null && (s.useBitmapCoordinateSpace(((r) => {
        this.wm(r);
      })), this.Nm && (this.lw(s, O8), this.ow(s), this.lw(s, rh), this.lw(s, oh)));
    }
    this.nm.applySuggestedBitmapSize();
    const i = Zn(this.nm, n);
    i !== null && (i.useBitmapCoordinateSpace((({ context: s, bitmapSize: r }) => {
      s.clearRect(0, 0, r.width, r.height);
    })), this._w(i), this.lw(i, D8), this.lw(i, oh));
  }
  uw() {
    return this.km;
  }
  cw() {
    return this.Pm;
  }
  Mm(e, n) {
    this.lw(e, n);
  }
  Fm() {
    this.Nm !== null && this.Nm.nu().u(this), this.Nm = null;
  }
  Xm(e) {
    this.Jm(this.Im, e);
  }
  Jm(e, n) {
    const i = n.localX, s = n.localY;
    e.v() && e.p(this.ns().Et().wc(i), { x: i, y: s }, n);
  }
  wm({ context: e, bitmapSize: n }) {
    const { width: i, height: s } = n, r = this.ns(), o = r.$(), l = r.Kd();
    o === l ? rr(e, 0, 0, i, s, l) : b2(e, 0, 0, i, s, o, l);
  }
  ow(e) {
    const n = H(this.Nm), i = n.eu().pr().Tt(n);
    i !== null && i.nt(e, !1);
  }
  _w(e) {
    this.dw(e, rh, Zs, this.ns().gd());
  }
  lw(e, n) {
    const i = H(this.Nm), s = i.Dt(), r = i.ru();
    for (const o of r) this.dw(e, n, El, o);
    for (const o of s) this.dw(e, n, El, o);
    for (const o of r) this.dw(e, n, Zs, o);
    for (const o of s) this.dw(e, n, Zs, o);
  }
  dw(e, n, i, s) {
    const r = H(this.Nm), o = r.Qt().pd(), l = o !== null && o.hu === s, a = o !== null && l && o.au !== void 0 ? o.au.ie : void 0;
    yl(n, ((c) => i(c, e, l, a)), s, r);
  }
  jm() {
    if (this.Nm === null) return;
    const e = this.Lv, n = this.Nm.U_().N().visible, i = this.Nm.q_().N().visible;
    n || this.km === null || (this.Hm.removeChild(this.km.iv()), this.km.m(), this.km = null), i || this.Pm === null || (this.Um.removeChild(this.Pm.iv()), this.Pm.m(), this.Pm = null);
    const s = e.Qt().Nd();
    n && this.km === null && (this.km = new sh(this, e.N(), s, "left"), this.Hm.appendChild(this.km.iv())), i && this.Pm === null && (this.Pm = new sh(this, e.N(), s, "right"), this.Um.appendChild(this.Pm.iv()));
  }
  fw(e) {
    return e.Np && this.Em || this.Am !== null;
  }
  Zm(e, n, i) {
    e = Math.max(0, Math.min(e, this.Uv.width - 1)), n = Math.max(0, Math.min(n, this.Uv.height - 1)), this.ns().Ad(e, n, i, H(this.Nm));
  }
  sw() {
    this.ns().zd();
  }
  rw() {
    this.Lm && (this.Am = null, this.sw());
  }
  iw(e, n, i) {
    this.Am = e, this.Lm = !1, this.Zm(n.x, n.y, i);
    const s = this.ns().gd();
    this.zm = { x: s.si(), y: s.ni() };
  }
  ns() {
    return this.Lv.Qt();
  }
  tw(e) {
    if (!this.Dm) return;
    const n = this.ns(), i = this.cv();
    if (n.X_(i, i.Rs()), this.Rm = null, this.Dm = !1, n.Vd(), this.Om !== null) {
      const s = performance.now(), r = n.Et();
      this.Om.fe(r.Cc(), s), this.Om.Ec(s) || n.vn(this.Om);
    }
  }
  Km() {
    this.Am = null;
  }
  Gm() {
    if (this.Nm) {
      if (this.ns().dn(), document.activeElement !== document.body && document.activeElement !== document.documentElement) H(document.activeElement).blur();
      else {
        const e = document.getSelection();
        e !== null && e.removeAllRanges();
      }
      !this.Nm.Rs().Gi() && this.ns().Et().Gi();
    }
  }
  Qm(e) {
    if (this.Nm === null) return;
    const n = this.ns(), i = n.Et();
    if (i.Gi()) return;
    const s = this.Lv.N(), r = s.handleScroll, o = s.kineticScroll;
    if ((!r.pressedMouseMove || e.Np) && (!r.horzTouchDrag && !r.vertTouchDrag || !e.Np)) return;
    const l = this.Nm.Rs(), a = performance.now();
    if (this.Rm !== null || this.fw(e) || (this.Rm = { x: e.clientX, y: e.clientY, cf: a, pw: e.localX, mw: e.localY }), this.Rm !== null && !this.Dm && (this.Rm.x !== e.clientX || this.Rm.y !== e.clientY)) {
      if (e.Np && o.touch || !e.Np && o.mouse) {
        const c = i.ul();
        this.Om = new K8(0.2 / c, 7 / c, 0.997, 15 / c), this.Om.Dv(i.Cc(), this.Rm.cf);
      } else this.Om = null;
      l.Gi() || n.Z_(this.Nm, l, e.localY), n.Dd(e.localX), this.Dm = !0;
    }
    this.Dm && (l.Gi() || n.G_(this.Nm, l, e.localY), n.Id(e.localX), this.Om !== null && this.Om.Dv(i.Cc(), a));
  }
}
class lh {
  constructor(e, n, i, s, r) {
    this.xt = !0, this.Uv = Re({ width: 0, height: 0 }), this.Zv = () => this.pm(3), this.Jv = e === "left", this.hd = i.Nd, this.Ps = n, this.ww = s, this.gw = r, this.Jp = document.createElement("div"), this.Jp.style.width = "25px", this.Jp.style.height = "100%", this.Jp.style.overflow = "hidden", this.sm = In(this.Jp, Re({ width: 16, height: 16 })), this.sm.subscribeSuggestedBitmapSizeChanged(this.Zv);
  }
  m() {
    this.sm.unsubscribeSuggestedBitmapSizeChanged(this.Zv), Nn(this.sm.canvasElement), this.sm.dispose();
  }
  iv() {
    return this.Jp;
  }
  sv() {
    return this.Uv;
  }
  dm(e) {
    Cn(this.Uv, e) || (this.Uv = e, this.sm.resizeCanvasElement(e), this.Jp.style.width = `${e.width}px`, this.Jp.style.height = `${e.height}px`, this.xt = !0);
  }
  pm(e) {
    if (e < 3 && !this.xt || this.Uv.width === 0 || this.Uv.height === 0) return;
    this.xt = !1, this.sm.applySuggestedBitmapSize();
    const n = Zn(this.sm, { colorSpace: this.Ps.layout.colorSpace });
    n !== null && n.useBitmapCoordinateSpace(((i) => {
      this.wm(i), this.gm(i);
    }));
  }
  nv() {
    return this.sm.bitmapSize;
  }
  ev(e, n, i) {
    const s = this.nv();
    s.width > 0 && s.height > 0 && e.drawImage(this.sm.canvasElement, n, i);
  }
  gm({ context: e, bitmapSize: n, horizontalPixelRatio: i, verticalPixelRatio: s }) {
    if (!this.ww()) return;
    e.fillStyle = this.Ps.timeScale.borderColor;
    const r = Math.floor(this.hd.N().S * i), o = Math.floor(this.hd.N().S * s), l = this.Jv ? n.width - r : 0;
    e.fillRect(l, 0, r, o);
  }
  wm({ context: e, bitmapSize: n }) {
    rr(e, 0, 0, n.width, n.height, this.gw());
  }
}
function pa(t) {
  return (e) => e.Ka?.(t) ?? [];
}
const P8 = pa("normal"), _8 = pa("top"), j8 = pa("bottom");
class $8 {
  constructor(e, n) {
    this.Mw = null, this.bw = null, this.M = null, this.Sw = !1, this.Uv = Re({ width: 0, height: 0 }), this.xw = new Ye(), this.qv = new Ls(5), this.Kv = !1, this.Zv = () => {
      this.Kv || this.Lv.Qt().dr();
    }, this.Xv = () => {
      this.Kv || this.Lv.Qt().dr();
    }, this.Lv = e, this.cu = n, this.Ps = e.N().layout, this.Vv = document.createElement("tr"), this.Cw = document.createElement("td"), this.Cw.style.padding = "0", this.yw = document.createElement("td"), this.yw.style.padding = "0", this.Jp = document.createElement("td"), this.Jp.style.height = "25px", this.Jp.style.padding = "0", this.kw = document.createElement("div"), this.kw.style.width = "100%", this.kw.style.height = "100%", this.kw.style.position = "relative", this.kw.style.overflow = "hidden", this.Jp.appendChild(this.kw), this.sm = In(this.kw, Re({ width: 16, height: 16 })), this.sm.subscribeSuggestedBitmapSizeChanged(this.Zv);
    const i = this.sm.canvasElement;
    i.style.position = "absolute", i.style.zIndex = "1", i.style.left = "0", i.style.top = "0", this.nm = In(this.kw, Re({ width: 16, height: 16 })), this.nm.subscribeSuggestedBitmapSizeChanged(this.Xv);
    const s = this.nm.canvasElement;
    s.style.position = "absolute", s.style.zIndex = "2", s.style.left = "0", s.style.top = "0", this.Vv.appendChild(this.Cw), this.Vv.appendChild(this.Jp), this.Vv.appendChild(this.yw), this.Pw(), this.Lv.Qt().B_().i(this.Pw.bind(this), this), this.$p = new ur(this.nm.canvasElement, this, { dp: () => !0, fp: () => !this.Lv.N().handleScroll.horzTouchDrag });
  }
  m() {
    this.$p.m(), this.Mw !== null && this.Mw.m(), this.bw !== null && this.bw.m(), this.nm.unsubscribeSuggestedBitmapSizeChanged(this.Xv), Nn(this.nm.canvasElement), this.nm.dispose(), this.sm.unsubscribeSuggestedBitmapSizeChanged(this.Zv), Nn(this.sm.canvasElement), this.sm.dispose();
  }
  iv() {
    return this.Vv;
  }
  Tw() {
    return this.Mw;
  }
  Rw() {
    return this.bw;
  }
  Pp(e) {
    if (this.Sw) return;
    this.Sw = !0;
    const n = this.Lv.Qt();
    !n.Et().Gi() && this.Lv.N().handleScale.axisPressedMouseMove.time && n.Pd(e.localX);
  }
  yp(e) {
    this.Pp(e);
  }
  Tp() {
    const e = this.Lv.Qt();
    !e.Et().Gi() && this.Sw && (this.Sw = !1, this.Lv.N().handleScale.axisPressedMouseMove.time && e.Ed());
  }
  mp(e) {
    const n = this.Lv.Qt();
    !n.Et().Gi() && this.Lv.N().handleScale.axisPressedMouseMove.time && n.Bd(e.localX);
  }
  pp(e) {
    this.mp(e);
  }
  bp() {
    this.Sw = !1;
    const e = this.Lv.Qt();
    e.Et().Gi() && !this.Lv.N().handleScale.axisPressedMouseMove.time || e.Ed();
  }
  gp() {
    this.bp();
  }
  ip() {
    this.Lv.N().handleScale.axisDoubleClickReset.time && this.Lv.Qt().wn();
  }
  Xf() {
    this.ip();
  }
  lp() {
    this.Lv.Qt().N().handleScale.axisPressedMouseMove.time && this.Cm(1);
  }
  zp() {
    this.Cm(0);
  }
  sv() {
    return this.Uv;
  }
  Dw() {
    return this.xw;
  }
  Iw(e, n, i) {
    Cn(this.Uv, e) || (this.Uv = e, this.Kv = !0, this.sm.resizeCanvasElement(e), this.nm.resizeCanvasElement(e), this.Kv = !1, this.Jp.style.width = `${e.width}px`, this.Jp.style.height = `${e.height}px`, this.xw.p(e)), this.Mw !== null && this.Mw.dm(Re({ width: n, height: e.height })), this.bw !== null && this.bw.dm(Re({ width: i, height: e.height }));
  }
  Vw() {
    const e = this.Bw();
    return Math.ceil(e.S + e.C + e.k + e.A + e.I + e.Ew);
  }
  kt() {
    this.Lv.Qt().Et().Vl();
  }
  nv() {
    return this.sm.bitmapSize;
  }
  ev(e, n, i, s) {
    const r = this.nv();
    if (r.width > 0 && r.height > 0 && (e.drawImage(this.sm.canvasElement, n, i), s)) {
      const o = this.nm.canvasElement;
      e.drawImage(o, n, i);
    }
  }
  pm(e) {
    if (e === 0) return;
    const n = { colorSpace: this.Ps.colorSpace };
    if (e !== 1) {
      this.sm.applySuggestedBitmapSize();
      const s = Zn(this.sm, n);
      s !== null && (s.useBitmapCoordinateSpace(((r) => {
        this.wm(r), this.gm(r), this.Aw(s, j8);
      })), this.bm(s), this.Aw(s, P8)), this.Mw !== null && this.Mw.pm(e), this.bw !== null && this.bw.pm(e);
    }
    this.nm.applySuggestedBitmapSize();
    const i = Zn(this.nm, n);
    i !== null && (i.useBitmapCoordinateSpace((({ context: s, bitmapSize: r }) => {
      s.clearRect(0, 0, r.width, r.height);
    })), this.Lw([...this.Lv.Qt().tn(), this.Lv.Qt().gd()], i), this.Aw(i, _8));
  }
  Aw(e, n) {
    const i = this.Lv.Qt().tn();
    for (const s of i) yl(n, ((r) => El(r, e, !1, void 0)), s, void 0);
    for (const s of i) yl(n, ((r) => Zs(r, e, !1, void 0)), s, void 0);
  }
  wm({ context: e, bitmapSize: n }) {
    rr(e, 0, 0, n.width, n.height, this.Lv.Qt().Kd());
  }
  gm({ context: e, bitmapSize: n, verticalPixelRatio: i }) {
    if (this.Lv.N().timeScale.borderVisible) {
      e.fillStyle = this.zw();
      const s = Math.max(1, Math.floor(this.Bw().S * i));
      e.fillRect(0, 0, n.width, s);
    }
  }
  bm(e) {
    const n = this.Lv.Qt().Et(), i = n.Vl();
    if (!i || i.length === 0) return;
    const s = this.cu.maxTickMarkWeight(i), r = this.Bw(), o = n.N();
    o.borderVisible && o.ticksVisible && e.useBitmapCoordinateSpace((({ context: l, horizontalPixelRatio: a, verticalPixelRatio: c }) => {
      l.strokeStyle = this.zw(), l.fillStyle = this.zw();
      const u = Math.max(1, Math.floor(a)), h = Math.floor(0.5 * a);
      l.beginPath();
      const d = Math.round(r.C * c);
      for (let m = i.length; m--; ) {
        const p = Math.round(i[m].coord * a);
        l.rect(p - h, 0, u, d);
      }
      l.fill();
    })), e.useMediaCoordinateSpace((({ context: l }) => {
      const a = r.S + r.C + r.A + r.k / 2;
      l.textAlign = "center", l.textBaseline = "middle", l.fillStyle = this.H(), l.font = this._m();
      for (const c of i) if (c.weight < s) {
        const u = c.needAlignCoordinate ? this.Ow(l, c.coord, c.label) : c.coord;
        l.fillText(c.label, u, a);
      }
      this.Lv.N().timeScale.allowBoldLabels && (l.font = this.Nw());
      for (const c of i) if (c.weight >= s) {
        const u = c.needAlignCoordinate ? this.Ow(l, c.coord, c.label) : c.coord;
        l.fillText(c.label, u, a);
      }
    }));
  }
  Ow(e, n, i) {
    const s = this.qv.Ii(e, i), r = s / 2, o = Math.floor(n - r) + 0.5;
    return o < 0 ? n += Math.abs(0 - o) : o + s > this.Uv.width && (n -= Math.abs(this.Uv.width - (o + s))), n;
  }
  Lw(e, n) {
    const i = this.Bw();
    for (const s of e) for (const r of s.fs()) r.Tt().nt(n, i);
  }
  zw() {
    return this.Lv.N().timeScale.borderColor;
  }
  H() {
    return this.Ps.textColor;
  }
  F() {
    return this.Ps.fontSize;
  }
  _m() {
    return Ts(this.F(), this.Ps.fontFamily);
  }
  Nw() {
    return Ts(this.F(), this.Ps.fontFamily, "bold");
  }
  Bw() {
    this.M === null && (this.M = { S: 1, L: NaN, A: NaN, I: NaN, ts: NaN, C: 5, k: NaN, P: "", Qi: new Ls(), Ew: 0 });
    const e = this.M, n = this._m();
    if (e.P !== n) {
      const i = this.F();
      e.k = i, e.P = n, e.A = 3 * i / 12, e.I = 3 * i / 12, e.ts = 9 * i / 12, e.L = 0, e.Ew = 4 * i / 12, e.Qi.On();
    }
    return this.M;
  }
  Cm(e) {
    this.Jp.style.cursor = e === 1 ? "ew-resize" : "default";
  }
  Pw() {
    const e = this.Lv.Qt(), n = e.N();
    n.leftPriceScale.visible || this.Mw === null || (this.Cw.removeChild(this.Mw.iv()), this.Mw.m(), this.Mw = null), n.rightPriceScale.visible || this.bw === null || (this.yw.removeChild(this.bw.iv()), this.bw.m(), this.bw = null);
    const i = { Nd: this.Lv.Qt().Nd() }, s = () => n.leftPriceScale.borderVisible && e.Et().N().borderVisible, r = () => e.Kd();
    n.leftPriceScale.visible && this.Mw === null && (this.Mw = new lh("left", n, i, s, r), this.Cw.appendChild(this.Mw.iv())), n.rightPriceScale.visible && this.bw === null && (this.bw = new lh("right", n, i, s, r), this.yw.appendChild(this.bw.iv()));
  }
}
const q8 = !!ai && !!navigator.userAgentData && navigator.userAgentData.brands.some(((t) => t.brand.includes("Chromium"))) && !!ai && (navigator?.userAgentData?.platform ? navigator.userAgentData.platform === "Windows" : navigator.userAgent.toLowerCase().indexOf("win") >= 0);
class eA {
  constructor(e, n, i) {
    var s;
    this.Fw = [], this.Ww = [], this.Hw = 0, this.eo = 0, this.S_ = 0, this.Uw = 0, this.$w = 0, this.qw = null, this.jw = !1, this.Im = new Ye(), this.Vm = new Ye(), this.nd = new Ye(), this.Yw = null, this.Kw = null, this.Av = e, this.Ps = n, this.cu = i, this.Vv = document.createElement("div"), this.Vv.classList.add("tv-lightweight-charts"), this.Vv.style.overflow = "hidden", this.Vv.style.direction = "ltr", this.Vv.style.width = "100%", this.Vv.style.height = "100%", (s = this.Vv).style.userSelect = "none", s.style.webkitUserSelect = "none", s.style.msUserSelect = "none", s.style.MozUserSelect = "none", s.style.webkitTapHighlightColor = "transparent", this.Zw = document.createElement("table"), this.Zw.setAttribute("cellspacing", "0"), this.Vv.appendChild(this.Zw), this.Gw = this.Xw.bind(this), Eo(this.Ps) && this.Jw(!0), this.ns = new L8(this.rd.bind(this), this.Ps, i), this.Qt().Md().i(this.Qw.bind(this), this), this.tg = new $8(this, this.cu), this.Zw.appendChild(this.tg.iv());
    const r = n.autoSize && this.ig();
    let o = this.Ps.width, l = this.Ps.height;
    if (r || o === 0 || l === 0) {
      const a = e.getBoundingClientRect();
      o = o || a.width, l = l || a.height;
    }
    this.sg(o, l), this.ng(), e.appendChild(this.Vv), this.eg(), this.ns.Et().Oc().i(this.ns.Ca.bind(this.ns), this), this.ns.B_().i(this.ns.Ca.bind(this.ns), this);
  }
  Qt() {
    return this.ns;
  }
  N() {
    return this.Ps;
  }
  Zp() {
    return this.Fw;
  }
  rg() {
    return this.tg;
  }
  m() {
    this.Jw(!1), this.Hw !== 0 && window.cancelAnimationFrame(this.Hw), this.ns.Md().u(this), this.ns.Et().Oc().u(this), this.ns.B_().u(this), this.ns.m();
    for (const e of this.Fw) this.Zw.removeChild(e.iv()), e.nw().u(this), e.ew().u(this), e.m();
    this.Fw = [];
    for (const e of this.Ww) this.hg(e);
    this.Ww = [], H(this.tg).m(), this.Vv.parentElement !== null && this.Vv.parentElement.removeChild(this.Vv), this.nd.m(), this.Im.m(), this.Vm.m(), this.ag();
  }
  sg(e, n, i = !1) {
    if (this.eo === n && this.S_ === e) return;
    const s = (function(l) {
      const a = Math.floor(l.width), c = Math.floor(l.height);
      return Re({ width: a - a % 2, height: c - c % 2 });
    })(Re({ width: e, height: n }));
    this.eo = s.height, this.S_ = s.width;
    const r = this.eo + "px", o = this.S_ + "px";
    H(this.Vv).style.height = r, H(this.Vv).style.width = o, this.Zw.style.height = r, this.Zw.style.width = o, i ? this.lg(Pe.yn(), performance.now()) : this.ns.Ca();
  }
  pm(e) {
    e === void 0 && (e = Pe.yn());
    for (let n = 0; n < this.Fw.length; n++) this.Fw[n].pm(e.un(n).an);
    this.Ps.timeScale.visible && this.tg.pm(e._n());
  }
  cr(e) {
    const n = Eo(this.Ps);
    this.ns.cr(e);
    const i = Eo(this.Ps);
    i !== n && this.Jw(i), e.layout?.panes && this.og(), this.eg(), this._g(e);
  }
  nw() {
    return this.Im;
  }
  ew() {
    return this.Vm;
  }
  Md() {
    return this.nd;
  }
  ug(e = !1) {
    this.qw !== null && (this.lg(this.qw, performance.now()), this.qw = null);
    const n = this.cg(null), i = document.createElement("canvas");
    i.width = n.width, i.height = n.height;
    const s = H(i.getContext("2d"));
    return this.cg(s, e), i;
  }
  dg(e) {
    return e === "left" && !this.fg() || e === "right" && !this.pg() || this.Fw.length === 0 ? 0 : H(e === "left" ? this.Fw[0].uw() : this.Fw[0].cw()).fm();
  }
  vg() {
    return this.Ps.autoSize && this.Yw !== null;
  }
  hv() {
    return this.Vv;
  }
  mg(e) {
    this.Kw = e, this.Kw ? this.hv().style.setProperty("cursor", e) : this.hv().style.removeProperty("cursor");
  }
  wg() {
    return this.Kw;
  }
  gg(e) {
    return $e(this.Fw[e]).sv();
  }
  og() {
    this.Ww.forEach(((e) => {
      e.kt();
    }));
  }
  _g(e) {
    (e.autoSize !== void 0 || !this.Yw || e.width === void 0 && e.height === void 0) && (e.autoSize && !this.Yw && this.ig(), e.autoSize === !1 && this.Yw !== null && this.ag(), e.autoSize || e.width === void 0 && e.height === void 0 || this.sg(e.width || this.S_, e.height || this.eo));
  }
  cg(e, n) {
    let i = 0, s = 0;
    const r = this.Fw[0], o = (a, c) => {
      let u = 0;
      for (let h = 0; h < this.Fw.length; h++) {
        const d = this.Fw[h], m = H(a === "left" ? d.uw() : d.cw()), p = m.nv();
        if (e !== null && m.ev(e, c, u, n), u += p.height, h < this.Fw.length - 1) {
          const g = this.Ww[h], A = g.nv();
          e !== null && g.ev(e, c, u), u += A.height;
        }
      }
    };
    this.fg() && (o("left", 0), i += H(r.uw()).nv().width);
    for (let a = 0; a < this.Fw.length; a++) {
      const c = this.Fw[a], u = c.nv();
      if (e !== null && c.ev(e, i, s, n), s += u.height, a < this.Fw.length - 1) {
        const h = this.Ww[a], d = h.nv();
        e !== null && h.ev(e, i, s), s += d.height;
      }
    }
    i += r.nv().width, this.pg() && (o("right", i), i += H(r.cw()).nv().width);
    const l = (a, c, u) => {
      H(a === "left" ? this.tg.Tw() : this.tg.Rw()).ev(H(e), c, u);
    };
    if (this.Ps.timeScale.visible) {
      const a = this.tg.nv();
      if (e !== null) {
        let c = 0;
        this.fg() && (l("left", c, s), c = H(r.uw()).nv().width), this.tg.ev(e, c, s, n), c += a.width, this.pg() && l("right", c, s);
      }
      s += a.height;
    }
    return Re({ width: i, height: s });
  }
  Mg() {
    let e = 0, n = 0, i = 0;
    for (const A of this.Fw) this.fg() && (n = Math.max(n, H(A.uw()).om(), this.Ps.leftPriceScale.minimumWidth)), this.pg() && (i = Math.max(i, H(A.cw()).om(), this.Ps.rightPriceScale.minimumWidth)), e += A.E_();
    n = Rl(n), i = Rl(i);
    const s = this.S_, r = this.eo, o = Math.max(s - n - i, 0), l = 1 * this.Ww.length, a = this.Ps.timeScale.visible;
    let c = a ? Math.max(this.tg.Vw(), this.Ps.timeScale.minimumHeight) : 0;
    var u;
    c = (u = c) + u % 2;
    const h = l + c, d = r < h ? 0 : r - h, m = d / e;
    let p = 0;
    const g = window.devicePixelRatio || 1;
    for (let A = 0; A < this.Fw.length; ++A) {
      const b = this.Fw[A];
      b.qm(this.ns.Xs()[A]);
      let R = 0, S = 0;
      S = A === this.Fw.length - 1 ? Math.ceil((d - p) * g) / g : Math.round(b.E_() * m * g) / g, R = Math.max(S, 2), p += R, b.dm(Re({ width: o, height: R })), this.fg() && b.hw(n, "left"), this.pg() && b.hw(i, "right"), b.cv() && this.ns.bd(b.cv(), R);
    }
    this.tg.Iw(Re({ width: a ? o : 0, height: c }), a ? n : 0, a ? i : 0), this.ns.L_(o), this.Uw !== n && (this.Uw = n), this.$w !== i && (this.$w = i);
  }
  Jw(e) {
    e ? this.Vv.addEventListener("wheel", this.Gw, { passive: !1 }) : this.Vv.removeEventListener("wheel", this.Gw);
  }
  bg(e) {
    switch (e.deltaMode) {
      case e.DOM_DELTA_PAGE:
        return 120;
      case e.DOM_DELTA_LINE:
        return 32;
    }
    return q8 ? 1 / window.devicePixelRatio : 1;
  }
  Xw(e) {
    if (!(e.deltaX !== 0 && this.Ps.handleScroll.mouseWheel || e.deltaY !== 0 && this.Ps.handleScale.mouseWheel)) return;
    const n = this.bg(e), i = n * e.deltaX / 100, s = -n * e.deltaY / 100;
    if (e.cancelable && e.preventDefault(), s !== 0 && this.Ps.handleScale.mouseWheel) {
      const r = Math.sign(s) * Math.min(1, Math.abs(s)), o = e.clientX - this.Vv.getBoundingClientRect().left;
      this.Qt().Td(o, r);
    }
    i !== 0 && this.Ps.handleScroll.mouseWheel && this.Qt().Rd(-80 * i);
  }
  lg(e, n) {
    const i = e._n();
    i === 3 && this.Sg(), i !== 3 && i !== 2 || (this.xg(e), this.Cg(e, n), this.tg.kt(), this.Fw.forEach(((s) => {
      s.Ym();
    })), this.qw?._n() === 3 && (this.qw.Sn(e), this.Sg(), this.xg(this.qw), this.Cg(this.qw, n), e = this.qw, this.qw = null)), this.pm(e);
  }
  Cg(e, n) {
    for (const i of e.bn()) this.xn(i, n);
  }
  xg(e) {
    const n = this.ns.Xs();
    for (let i = 0; i < n.length; i++) e.un(i).ln && n[i].tu();
  }
  xn(e, n) {
    const i = this.ns.Et();
    switch (e.fn) {
      case 0:
        i.Fc();
        break;
      case 1:
        i.Wc(e.Wt);
        break;
      case 2:
        i.gn(e.Wt);
        break;
      case 3:
        i.Mn(e.Wt);
        break;
      case 4:
        i.Pc();
        break;
      case 5:
        e.Wt.Ec(n) || i.Mn(e.Wt.Ac(n));
    }
  }
  rd(e) {
    this.qw !== null ? this.qw.Sn(e) : this.qw = e, this.jw || (this.jw = !0, this.Hw = window.requestAnimationFrame(((n) => {
      if (this.jw = !1, this.Hw = 0, this.qw !== null) {
        const i = this.qw;
        this.qw = null, this.lg(i, n);
        for (const s of i.bn()) if (s.fn === 5 && !s.Wt.Ec(n)) {
          this.Qt().vn(s.Wt);
          break;
        }
      }
    })));
  }
  Sg() {
    this.ng();
  }
  hg(e) {
    this.Zw.removeChild(e.iv()), e.m();
  }
  ng() {
    const e = this.ns.Xs(), n = e.length, i = this.Fw.length;
    for (let s = n; s < i; s++) {
      const r = $e(this.Fw.pop());
      this.Zw.removeChild(r.iv()), r.nw().u(this), r.ew().u(this), r.m();
      const o = this.Ww.pop();
      o !== void 0 && this.hg(o);
    }
    for (let s = i; s < n; s++) {
      const r = new ma(this, e[s]);
      if (r.nw().i(this.yg.bind(this, r), this), r.ew().i(this.kg.bind(this, r), this), this.Fw.push(r), s > 0) {
        const o = new z8(this, s - 1, s);
        this.Ww.push(o), this.Zw.insertBefore(o.iv(), this.tg.iv());
      }
      this.Zw.insertBefore(r.iv(), this.tg.iv());
    }
    for (let s = 0; s < n; s++) {
      const r = e[s], o = this.Fw[s];
      o.cv() !== r ? o.qm(r) : o.$m();
    }
    this.eg(), this.Mg();
  }
  Pg(e, n, i, s) {
    const r = /* @__PURE__ */ new Map();
    e !== null && this.ns.tn().forEach(((h) => {
      const d = h.qs().$s(e);
      d !== null && r.set(h, d);
    }));
    let o;
    if (e !== null) {
      const h = this.ns.Et().es(e)?.originalTime;
      h !== void 0 && (o = h);
    }
    const l = this.Qt().pd(), a = l !== null && l.hu instanceof cr ? l.hu : void 0, c = l !== null && l.au !== void 0 ? l.au.te : void 0, u = this.Tg(s);
    return { Gr: o, js: e ?? void 0, Rg: n ?? void 0, Dg: u !== -1 ? u : void 0, Ig: a, Vg: r, Bg: c, Eg: i ?? void 0 };
  }
  Tg(e) {
    let n = -1;
    if (e) n = this.Fw.indexOf(e);
    else {
      const i = this.Qt().gd().Gs();
      i !== null && (n = this.Qt().Xs().indexOf(i));
    }
    return n;
  }
  yg(e, n, i, s) {
    this.Im.p((() => this.Pg(n, i, s, e)));
  }
  kg(e, n, i, s) {
    this.Vm.p((() => this.Pg(n, i, s, e)));
  }
  Qw(e, n, i) {
    this.mg(this.Qt().pd()?.ou ?? null), this.nd.p((() => this.Pg(e, n, i)));
  }
  eg() {
    const e = this.Ps.timeScale.visible ? "" : "none";
    this.tg.iv().style.display = e;
  }
  fg() {
    return this.Fw[0].cv().U_().N().visible;
  }
  pg() {
    return this.Fw[0].cv().q_().N().visible;
  }
  ig() {
    return "ResizeObserver" in window && (this.Yw = new ResizeObserver(((e) => {
      const n = e[e.length - 1];
      n && this.sg(n.contentRect.width, n.contentRect.height);
    })), this.Yw.observe(this.Av, { box: "border-box" }), !0);
  }
  ag() {
    this.Yw !== null && this.Yw.disconnect(), this.Yw = null;
  }
}
function Eo(t) {
  return !!(t.handleScroll.mouseWheel || t.handleScale.mouseWheel);
}
function tA(t) {
  return t.open === void 0 && t.value === void 0;
}
function nA(t) {
  return (function(e) {
    return e.open !== void 0;
  })(t) || (function(e) {
    return e.value !== void 0;
  })(t);
}
function ah(t, e, n, i) {
  const s = n.value, r = { js: e, wt: t, Wt: [s, s, s, s], Gr: i };
  return n.color !== void 0 && (r.R = n.color), r;
}
function iA(t, e, n, i) {
  const s = n.value, r = { js: e, wt: t, Wt: [s, s, s, s], Gr: i };
  return n.lineColor !== void 0 && (r.vt = n.lineColor), n.topColor !== void 0 && (r.eh = n.topColor), n.bottomColor !== void 0 && (r.rh = n.bottomColor), r;
}
function sA(t, e, n, i) {
  const s = n.value, r = { js: e, wt: t, Wt: [s, s, s, s], Gr: i };
  return n.topLineColor !== void 0 && (r.hh = n.topLineColor), n.bottomLineColor !== void 0 && (r.ah = n.bottomLineColor), n.topFillColor1 !== void 0 && (r.oh = n.topFillColor1), n.topFillColor2 !== void 0 && (r._h = n.topFillColor2), n.bottomFillColor1 !== void 0 && (r.uh = n.bottomFillColor1), n.bottomFillColor2 !== void 0 && (r.dh = n.bottomFillColor2), r;
}
function rA(t, e, n, i) {
  const s = { js: e, wt: t, Wt: [n.open, n.high, n.low, n.close], Gr: i };
  return n.color !== void 0 && (s.R = n.color), s;
}
function oA(t, e, n, i) {
  const s = { js: e, wt: t, Wt: [n.open, n.high, n.low, n.close], Gr: i };
  return n.color !== void 0 && (s.R = n.color), n.borderColor !== void 0 && (s.Ht = n.borderColor), n.wickColor !== void 0 && (s.nh = n.wickColor), s;
}
function lA(t, e, n, i, s) {
  const r = $e(s)(n), o = Math.max(...r), l = Math.min(...r), a = r[r.length - 1], c = [a, o, l, a], { time: u, color: h, ...d } = n;
  return { js: e, wt: t, Wt: c, Gr: i, le: d, R: h };
}
function Ln(t) {
  return t.Wt !== void 0;
}
function ch(t, e) {
  return e.customValues !== void 0 && (t.Ag = e.customValues), t;
}
function dn(t) {
  return (e, n, i, s, r, o) => (function(l, a) {
    return a ? a(l) : tA(l);
  })(i, o) ? ch({ wt: e, js: n, Gr: s }, i) : ch(t(e, n, i, s, r), i);
}
function uh(t) {
  return { Candlestick: dn(oA), Bar: dn(rA), Area: dn(iA), Baseline: dn(sA), Histogram: dn(ah), Line: dn(ah), Custom: dn(lA) }[t];
}
function hh(t) {
  return { js: 0, Lg: /* @__PURE__ */ new Map(), Ea: t };
}
function dh(t, e) {
  if (t !== void 0 && t.length !== 0) return { zg: e.key(t[0].wt), Og: e.key(t[t.length - 1].wt) };
}
function mh(t) {
  let e;
  return t.forEach(((n) => {
    e === void 0 && (e = n.Gr);
  })), $e(e);
}
class aA {
  constructor(e) {
    this.Ng = /* @__PURE__ */ new Map(), this.Fg = /* @__PURE__ */ new Map(), this.Wg = /* @__PURE__ */ new Map(), this.Hg = [], this.cu = e;
  }
  m() {
    this.Ng.clear(), this.Fg.clear(), this.Wg.clear(), this.Hg = [];
  }
  Ug(e, n) {
    let i = this.Ng.size !== 0, s = !1;
    const r = this.Fg.get(e);
    if (r !== void 0) if (this.Fg.size === 1) i = !1, s = !0, this.Ng.clear();
    else for (const a of this.Hg) a.pointData.Lg.delete(e) && (s = !0);
    let o = [];
    if (n.length !== 0) {
      const a = n.map(((m) => m.time)), c = this.cu.createConverterToInternalObj(n), u = uh(e.wh()), h = e.rl(), d = e.hl();
      o = n.map(((m, p) => {
        const g = c(m.time), A = this.cu.key(g);
        let b = this.Ng.get(A);
        b === void 0 && (b = hh(g), this.Ng.set(A, b), s = !0);
        const R = u(g, b.js, m, a[p], h, d);
        return b.Lg.set(e, R), R;
      }));
    }
    i && this.$g(), this.qg(e, o);
    let l = -1;
    if (s) {
      const a = [];
      this.Ng.forEach(((c) => {
        a.push({ timeWeight: 0, time: c.Ea, pointData: c, originalTime: mh(c.Lg) });
      })), a.sort(((c, u) => this.cu.key(c.time) - this.cu.key(u.time))), l = this.jg(a);
    }
    return this.Yg(e, l, (function(a, c, u) {
      const h = dh(a, u), d = dh(c, u);
      if (h !== void 0 && d !== void 0) return { Kg: !1, Ta: h.Og >= d.Og && h.zg >= d.zg };
    })(this.Fg.get(e), r, this.cu));
  }
  Hd(e) {
    return this.Ug(e, []);
  }
  Zg(e, n, i) {
    if (i && e.La()) throw new Error("Historical updates are not supported when conflation is enabled. Conflation requires data to be processed in order.");
    const s = n;
    (function(b) {
      b.Gr === void 0 && (b.Gr = b.time);
    })(s), this.cu.preprocessData(n);
    const r = this.cu.createConverterToInternalObj([n])(n.time), o = this.Wg.get(e);
    if (!i && o !== void 0 && this.cu.key(r) < this.cu.key(o)) throw new Error(`Cannot update oldest data, last time=${o}, new time=${r}`);
    let l = this.Ng.get(this.cu.key(r));
    if (i && l === void 0) throw new Error("Cannot update non-existing data point when historicalUpdate is true");
    const a = l === void 0;
    l === void 0 && (l = hh(r), this.Ng.set(this.cu.key(r), l));
    const c = uh(e.wh()), u = e.rl(), h = e.hl(), d = c(r, l.js, n, s.Gr, u, h), m = !i && !a && o !== void 0 && this.cu.key(r) === this.cu.key(o);
    l.Lg.set(e, d), i ? this.Gg(e, d, l.js) : m && e.La() && Ln(d) ? (e.kr(d), this.Xg(e, d)) : this.Xg(e, d);
    const p = { Ta: Ln(d), Kg: i };
    if (!a) return this.Yg(e, -1, p);
    const g = { timeWeight: 0, time: l.Ea, pointData: l, originalTime: mh(l.Lg) }, A = li(this.Hg, this.cu.key(g.time), ((b, R) => this.cu.key(b.time) < R));
    this.Hg.splice(A, 0, g);
    for (let b = A; b < this.Hg.length; ++b) ps(this.Hg[b].pointData, b);
    return this.cu.fillWeightsForPoints(this.Hg, A), this.Yg(e, A, p);
  }
  Jg(e, n) {
    const i = this.Fg.get(e);
    if (i === void 0 || n <= 0) return [[], this.Qg()];
    n = Math.min(n, i.length);
    const s = i.splice(-n).reverse();
    i.length === 0 ? this.Wg.delete(e) : this.Wg.set(e, i[i.length - 1].wt);
    for (const r of s) {
      const o = this.Ng.get(this.cu.key(r.wt));
      if (o && (o.Lg.delete(e), o.Lg.size === 0)) {
        this.Ng.delete(this.cu.key(o.Ea)), this.Hg.splice(o.js, 1);
        for (let l = o.js; l < this.Hg.length; ++l) ps(this.Hg[l].pointData, l);
      }
    }
    return [s, this.Yg(e, this.Hg.length - 1, { Kg: !1, Ta: !1 })];
  }
  Xg(e, n) {
    let i = this.Fg.get(e);
    i === void 0 && (i = [], this.Fg.set(e, i));
    const s = i.length !== 0 ? i[i.length - 1] : null;
    s === null || this.cu.key(n.wt) > this.cu.key(s.wt) ? Ln(n) && i.push(n) : Ln(n) ? i[i.length - 1] = n : i.splice(-1, 1), this.Wg.set(e, n.wt);
  }
  Gg(e, n, i) {
    const s = this.Fg.get(e);
    if (s === void 0) return;
    const r = li(s, i, ((o, l) => o.js < l));
    Ln(n) ? s[r] = n : s.splice(r, 1);
  }
  qg(e, n) {
    n.length !== 0 ? (this.Fg.set(e, n.filter(Ln)), this.Wg.set(e, n[n.length - 1].wt)) : (this.Fg.delete(e), this.Wg.delete(e));
  }
  $g() {
    for (const e of this.Hg) e.pointData.Lg.size === 0 && this.Ng.delete(this.cu.key(e.time));
  }
  jg(e) {
    let n = -1;
    for (let i = 0; i < this.Hg.length && i < e.length; ++i) {
      const s = this.Hg[i], r = e[i];
      if (this.cu.key(s.time) !== this.cu.key(r.time)) {
        n = i;
        break;
      }
      r.timeWeight = s.timeWeight, ps(r.pointData, i);
    }
    if (n === -1 && this.Hg.length !== e.length && (n = Math.min(this.Hg.length, e.length)), n === -1) return -1;
    for (let i = n; i < e.length; ++i) ps(e[i].pointData, i);
    return this.cu.fillWeightsForPoints(e, n), this.Hg = e, n;
  }
  tM() {
    if (this.Fg.size === 0) return null;
    let e = 0;
    return this.Fg.forEach(((n) => {
      n.length !== 0 && (e = Math.max(e, n[n.length - 1].js));
    })), e;
  }
  Yg(e, n, i) {
    const s = this.Qg();
    if (n !== -1) this.Fg.forEach(((r, o) => {
      s.F_.set(o, { le: r, iM: o === e ? i : void 0 });
    })), this.Fg.has(e) || s.F_.set(e, { le: [], iM: i }), s.Et.sM = this.Hg, s.Et.nM = n;
    else {
      const r = this.Fg.get(e);
      s.F_.set(e, { le: r || [], iM: i });
    }
    return s;
  }
  Qg() {
    return { F_: /* @__PURE__ */ new Map(), Et: { vc: this.tM() } };
  }
}
function ps(t, e) {
  t.js = e, t.Lg.forEach(((n) => {
    n.js = e;
  }));
}
function cA(t, e) {
  return t.wt < e;
}
function uA(t, e) {
  return e < t.wt;
}
function hA(t, e, n) {
  const i = e.Aa(), s = e.bi(), r = li(t, i, cA), o = W2(t, s, uA);
  if (!n) return { from: r, to: o };
  let l = r, a = o;
  return r > 0 && r < t.length && t[r].wt >= i && (l = r - 1), o > 0 && o < t.length && t[o - 1].wt <= s && (a = o + 1), { from: l, to: a };
}
class X2 {
  constructor(e, n, i) {
    this.eM = !0, this.rM = !0, this.hM = !0, this.aM = [], this.lM = null, this.oM = -1, this.ee = e, this.re = n, this._M = i;
  }
  kt(e) {
    this.eM = !0, e === "data" && (this.rM = !0), e === "options" && (this.hM = !0);
  }
  Tt() {
    return this.ee.It() ? (this.uM(), this.lM === null ? null : this.cM) : null;
  }
  dM() {
    this.aM = this.aM.map(((e) => ({ ...e, ...this.ee.ga().gh(e.wt) })));
  }
  fM() {
    this.lM = null;
  }
  uM() {
    const e = this.re.Et(), n = e.N().enableConflation ? e.Hc() : 0;
    n !== this.oM && (this.rM = !0, this.oM = n), this.rM && (this.pM(), this.rM = !1), this.hM && (this.dM(), this.hM = !1), this.eM && (this.vM(), this.eM = !1);
  }
  vM() {
    const e = this.ee.Ft(), n = this.re.Et();
    if (this.fM(), n.Gi() || e.Gi()) return;
    const i = n.Ie();
    if (i === null || this.ee.qs().yh() === 0) return;
    const s = this.ee.Lt();
    s !== null && (this.lM = hA(this.aM, i, this._M), this.mM(e, n, s.Wt), this.wM());
  }
}
class dA {
  constructor(e, n) {
    this.gM = e, this.Ki = n;
  }
  nt(e, n, i) {
    this.gM.draw(e, this.Ki, n, i);
  }
}
class mA extends X2 {
  constructor(e, n, i) {
    super(e, n, !1), this.$h = i, this.cM = new dA(this.$h.renderer(), ((s) => {
      const r = e.Lt();
      return r === null ? null : e.Ft().Nt(s, r.Wt);
    }));
  }
  get ma() {
    return this.$h.conflationReducer;
  }
  Oa(e) {
    return this.$h.priceValueBuilder(e);
  }
  al(e) {
    return this.$h.isWhitespace(e);
  }
  pM() {
    const e = this.ee.ga();
    this.aM = this.ee.Na().Dh().map(((n) => ({ wt: n.js, _t: NaN, ...e.gh(n.js), MM: n.le })));
  }
  mM(e, n) {
    n.mc(this.aM, fl(this.lM));
  }
  wM() {
    this.$h.update({ bars: this.aM.map(pA), barSpacing: this.re.Et().ul(), visibleRange: this.lM, conflationFactor: this.re.Et().Hc() }, this.ee.N());
  }
}
function pA(t) {
  return { x: t._t, time: t.wt, originalData: t.MM, barColor: t.th };
}
const gA = { color: "#2196f3" }, fA = (t, e, n) => {
  const i = an(n);
  return new mA(t, e, i);
};
function ga(t) {
  const e = { value: t.Wt[3], time: t.Gr };
  return t.Ag !== void 0 && (e.customValues = t.Ag), e;
}
function ph(t) {
  const e = ga(t);
  return t.R !== void 0 && (e.color = t.R), e;
}
function bA(t) {
  const e = ga(t);
  return t.vt !== void 0 && (e.lineColor = t.vt), t.eh !== void 0 && (e.topColor = t.eh), t.rh !== void 0 && (e.bottomColor = t.rh), e;
}
function AA(t) {
  const e = ga(t);
  return t.hh !== void 0 && (e.topLineColor = t.hh), t.ah !== void 0 && (e.bottomLineColor = t.ah), t.oh !== void 0 && (e.topFillColor1 = t.oh), t._h !== void 0 && (e.topFillColor2 = t._h), t.uh !== void 0 && (e.bottomFillColor1 = t.uh), t.dh !== void 0 && (e.bottomFillColor2 = t.dh), e;
}
function U2(t) {
  const e = { open: t.Wt[0], high: t.Wt[1], low: t.Wt[2], close: t.Wt[3], time: t.Gr };
  return t.Ag !== void 0 && (e.customValues = t.Ag), e;
}
function VA(t) {
  const e = U2(t);
  return t.R !== void 0 && (e.color = t.R), e;
}
function RA(t) {
  const e = U2(t), { R: n, Ht: i, nh: s } = t;
  return n !== void 0 && (e.color = n), i !== void 0 && (e.borderColor = i), s !== void 0 && (e.wickColor = s), e;
}
function vs(t) {
  return { Area: bA, Line: ph, Baseline: AA, Histogram: ph, Bar: VA, Candlestick: RA, Custom: EA }[t];
}
function EA(t) {
  const e = t.Gr;
  return { ...t.le, time: e };
}
const yA = { vertLine: { color: "#9598A1", width: 1, style: 3, visible: !0, labelVisible: !0, labelBackgroundColor: "#131722" }, horzLine: { color: "#9598A1", width: 1, style: 3, visible: !0, labelVisible: !0, labelBackgroundColor: "#131722" }, mode: 1, doNotSnapToHiddenSeriesIndices: !1 }, CA = { vertLines: { color: "#D6DCDE", style: 0, visible: !0 }, horzLines: { color: "#D6DCDE", style: 0, visible: !0 } }, WA = { background: { type: "solid", color: "#FFFFFF" }, textColor: "#191919", fontSize: 12, fontFamily: f2, panes: { enableResize: !0, separatorColor: "#E0E3EB", separatorHoverColor: "rgba(178, 181, 189, 0.2)" }, attributionLogo: !0, colorSpace: "srgb", colorParsers: [] }, yo = { autoScale: !0, mode: 0, invertScale: !1, alignLabels: !0, borderVisible: !0, borderColor: "#2B2B43", entireTextOnly: !1, visible: !1, ticksVisible: !1, scaleMargins: { bottom: 0.1, top: 0.2 }, minimumWidth: 0, ensureEdgeTickMarksVisible: !1 }, SA = { rightOffset: 0, barSpacing: 6, minBarSpacing: 0.5, maxBarSpacing: 0, fixLeftEdge: !1, fixRightEdge: !1, lockVisibleTimeRangeOnResize: !1, rightBarStaysOnScroll: !1, borderVisible: !0, borderColor: "#2B2B43", visible: !0, timeVisible: !1, secondsVisible: !0, shiftVisibleRangeOnNewBar: !0, allowShiftVisibleRangeOnWhitespaceReplacement: !1, ticksVisible: !1, uniformDistribution: !1, minimumHeight: 0, allowBoldLabels: !0, ignoreWhitespaceIndices: !1, enableConflation: !1, conflationThresholdFactor: 1, precomputeConflationOnInit: !1, precomputeConflationPriority: "background" };
function gh() {
  return { addDefaultPane: !0, width: 0, height: 0, autoSize: !1, layout: WA, crosshair: yA, grid: CA, overlayPriceScales: { ...yo }, leftPriceScale: { ...yo, visible: !1 }, rightPriceScale: { ...yo, visible: !0 }, timeScale: SA, localization: { locale: ai ? navigator.language : "", dateFormat: "dd MMM 'yy" }, handleScroll: { mouseWheel: !0, pressedMouseMove: !0, horzTouchDrag: !0, vertTouchDrag: !0 }, handleScale: { axisPressedMouseMove: { time: !0, price: !0 }, axisDoubleClickReset: { time: !0, price: !0 }, mouseWheel: !0, pinch: !0 }, kineticScroll: { mouse: !1, touch: !0 }, trackingMode: { exitMode: 1 } };
}
class B2 {
  constructor(e, n, i) {
    this.Yp = e, this.bM = n, this.SM = i ?? 0;
  }
  applyOptions(e) {
    this.Yp.Qt().md(this.bM, e, this.SM);
  }
  options() {
    return this.Ki().N();
  }
  width() {
    return lr(this.bM) ? this.Yp.dg(this.bM) : 0;
  }
  setVisibleRange(e) {
    this.setAutoScale(!1), this.Ki().$o(new De(e.from, e.to));
  }
  getVisibleRange() {
    let e, n, i = this.Ki().er();
    if (i === null) return null;
    if (this.Ki().io()) {
      const s = this.Ki().m_(), r = N2(s);
      i = Dn(i, this.Ki().no()), e = Number((Math.round(i.Ze() / s) * s).toFixed(r)), n = Number((Math.round(i.Ge() / s) * s).toFixed(r));
    } else e = i.Ze(), n = i.Ge();
    return { from: e, to: n };
  }
  setAutoScale(e) {
    this.applyOptions({ autoScale: e });
  }
  Ki() {
    return H(this.Yp.Qt().wd(this.bM, this.SM)).Ft;
  }
}
class ZA {
  constructor(e, n, i, s) {
    this.Yp = e, this.yt = i, this.xM = n, this.CM = s;
  }
  getHeight() {
    return this.yt.$t();
  }
  setHeight(e) {
    const n = this.Yp.Qt(), i = n.Gd(this.yt);
    n.xd(i, e);
  }
  getStretchFactor() {
    return this.yt.E_();
  }
  setStretchFactor(e) {
    this.yt.A_(e), this.Yp.Qt().Ca();
  }
  paneIndex() {
    return this.Yp.Qt().Gd(this.yt);
  }
  moveTo(e) {
    const n = this.paneIndex();
    n !== e && (Ke(e >= 0 && e < this.Yp.Zp().length, "Invalid pane index"), this.Yp.Qt().yd(n, e));
  }
  getSeries() {
    return this.yt.F_().map(((e) => this.xM(e))) ?? [];
  }
  getHTMLElement() {
    const e = this.Yp.Zp();
    return e && e.length !== 0 && e[this.paneIndex()] ? e[this.paneIndex()].iv() : null;
  }
  attachPrimitive(e) {
    this.yt.nl(e), e.attached && e.attached({ chart: this.CM, requestUpdate: () => this.yt.Qt().Ca() });
  }
  detachPrimitive(e) {
    this.yt.el(e);
  }
  priceScale(e) {
    if (this.yt.V_(e) === null) throw new Error(`Cannot find price scale with id: ${e}`);
    return new B2(this.Yp, e, this.paneIndex());
  }
  setPreserveEmptyPane(e) {
    this.yt.O_(e);
  }
  preserveEmptyPane() {
    return this.yt.N_();
  }
  addCustomSeries(e, n = {}, i = 0) {
    return this.CM.addCustomSeries(e, n, i);
  }
  addSeries(e, n = {}) {
    return this.CM.addSeries(e, n, this.paneIndex());
  }
}
const vA = { color: "#FF0000", price: 0, lineStyle: 2, lineWidth: 1, lineVisible: !0, axisLabelVisible: !0, title: "", axisLabelColor: "", axisLabelTextColor: "" };
class fh {
  constructor(e) {
    this.hr = e;
  }
  applyOptions(e) {
    this.hr.cr(e);
  }
  options() {
    return this.hr.N();
  }
  yM() {
    return this.hr;
  }
}
class IA {
  constructor(e, n, i, s, r, o) {
    this.kM = new Ye(), this.ee = e, this.PM = n, this.TM = i, this.cu = r, this.CM = s, this.RM = o;
  }
  m() {
    this.kM.m();
  }
  priceFormatter() {
    return this.ee.Xa();
  }
  priceToCoordinate(e) {
    const n = this.ee.Lt();
    return n === null ? null : this.ee.Ft().Nt(e, n.Wt);
  }
  coordinateToPrice(e) {
    const n = this.ee.Lt();
    return n === null ? null : this.ee.Ft().Ds(e, n.Wt);
  }
  barsInLogicalRange(e) {
    if (e === null) return null;
    const n = new $n(new vi(e.from, e.to)).Ru(), i = this.ee.qs();
    if (i.Gi()) return null;
    const s = i.$s(n.Aa(), 1), r = i.$s(n.bi(), -1), o = H(i.kh()), l = H(i.sn());
    if (s !== null && r !== null && s.js > r.js) return { barsBefore: e.from - o, barsAfter: l - e.to };
    const a = { barsBefore: s === null || s.js === o ? e.from - o : s.js - o, barsAfter: r === null || r.js === l ? l - e.to : l - r.js };
    return s !== null && r !== null && (a.from = s.Gr, a.to = r.Gr), a;
  }
  setData(e) {
    this.cu, this.ee.wh(), this.PM.DM(this.ee, e), this.IM("full");
  }
  update(e, n = !1) {
    this.ee.wh(), this.PM.VM(this.ee, e, n), this.IM("update");
  }
  pop(e = 1) {
    const n = this.PM.BM(this.ee, e);
    n.length !== 0 && this.IM("update");
    const i = vs(this.seriesType());
    return n.map(((s) => i(s)));
  }
  dataByIndex(e, n) {
    const i = this.ee.qs().$s(e, n);
    return i === null ? null : vs(this.seriesType())(i);
  }
  data() {
    const e = vs(this.seriesType());
    return this.ee.qs().Dh().map(((n) => e(n)));
  }
  subscribeDataChanged(e) {
    this.kM.i(e);
  }
  unsubscribeDataChanged(e) {
    this.kM._(e);
  }
  applyOptions(e) {
    this.ee.cr(e);
  }
  options() {
    return Ot(this.ee.N());
  }
  priceScale() {
    return this.TM.priceScale(this.ee.Ft().ol(), this.getPane().paneIndex());
  }
  createPriceLine(e) {
    const n = tt(Ot(vA), e), i = this.ee.Da(n);
    return new fh(i);
  }
  removePriceLine(e) {
    this.ee.Ia(e.yM());
  }
  priceLines() {
    return this.ee.Va().map(((e) => new fh(e)));
  }
  seriesType() {
    return this.ee.wh();
  }
  lastValueData(e) {
    const n = this.ee.Ve(e);
    return n.Be ? { noData: !0 } : { noData: !1, price: n.gt, color: n.R };
  }
  attachPrimitive(e) {
    this.ee.nl(e), e.attached && e.attached({ chart: this.CM, series: this, requestUpdate: () => this.ee.Qt().Ca(), horzScaleBehavior: this.cu });
  }
  detachPrimitive(e) {
    this.ee.el(e), e.detached && e.detached(), this.ee.Qt().Ca();
  }
  getPane() {
    const e = this.ee, n = H(this.ee.Qt().Kn(e));
    return this.RM(n);
  }
  moveToPane(e) {
    this.ee.Qt().jd(this.ee, e);
  }
  seriesOrder() {
    const e = this.ee.Qt().Kn(this.ee);
    return e === null ? -1 : e.F_().indexOf(this.ee);
  }
  setSeriesOrder(e) {
    const n = this.ee.Qt().Kn(this.ee);
    n !== null && n.su(this.ee, e);
  }
  IM(e) {
    this.kM.v() && this.kM.p(e);
  }
}
class NA {
  constructor(e, n, i) {
    this.EM = new Ye(), this.Nu = new Ye(), this.xw = new Ye(), this.ns = e, this.Jh = e.Et(), this.tg = n, this.Jh.Lc().i(this.AM.bind(this)), this.Jh.zc().i(this.LM.bind(this)), this.tg.Dw().i(this.zM.bind(this)), this.cu = i;
  }
  m() {
    this.Jh.Lc().u(this), this.Jh.zc().u(this), this.tg.Dw().u(this), this.EM.m(), this.Nu.m(), this.xw.m();
  }
  scrollPosition() {
    return this.Jh.Cc();
  }
  scrollToPosition(e, n) {
    n ? this.Jh.Bc(e, 1e3) : this.ns.Mn(e);
  }
  scrollToRealTime() {
    this.Jh.Vc();
  }
  getVisibleRange() {
    const e = this.Jh.lc();
    return e === null ? null : { from: e.from.originalTime, to: e.to.originalTime };
  }
  setVisibleRange(e) {
    const n = { from: this.cu.convertHorzItemToInternal(e.from), to: this.cu.convertHorzItemToInternal(e.to) }, i = this.Jh.cc(n);
    this.ns.$d(i);
  }
  getVisibleLogicalRange() {
    const e = this.Jh.ac();
    return e === null ? null : { from: e.Aa(), to: e.bi() };
  }
  setVisibleLogicalRange(e) {
    Ke(e.from <= e.to, "The from index cannot be after the to index."), this.ns.$d(e);
  }
  resetTimeScale() {
    this.ns.wn();
  }
  fitContent() {
    this.ns.Fc();
  }
  logicalToCoordinate(e) {
    const n = this.ns.Et();
    return n.Gi() ? null : n.qt(e);
  }
  coordinateToLogical(e) {
    return this.Jh.Gi() ? null : this.Jh.wc(e);
  }
  timeToIndex(e, n) {
    const i = this.cu.convertHorzItemToInternal(e);
    return this.Jh.ec(i, n);
  }
  timeToCoordinate(e) {
    const n = this.timeToIndex(e, !1);
    return n === null ? null : this.Jh.qt(n);
  }
  coordinateToTime(e) {
    const n = this.ns.Et(), i = n.wc(e), s = n.es(i);
    return s === null ? null : s.originalTime;
  }
  width() {
    return this.tg.sv().width;
  }
  height() {
    return this.tg.sv().height;
  }
  subscribeVisibleTimeRangeChange(e) {
    this.EM.i(e);
  }
  unsubscribeVisibleTimeRangeChange(e) {
    this.EM._(e);
  }
  subscribeVisibleLogicalRangeChange(e) {
    this.Nu.i(e);
  }
  unsubscribeVisibleLogicalRangeChange(e) {
    this.Nu._(e);
  }
  subscribeSizeChange(e) {
    this.xw.i(e);
  }
  unsubscribeSizeChange(e) {
    this.xw._(e);
  }
  applyOptions(e) {
    this.Jh.cr(e);
  }
  options() {
    return { ...Ot(this.Jh.N()), barSpacing: this.Jh.ul() };
  }
  AM() {
    this.EM.v() && this.EM.p(this.getVisibleRange());
  }
  LM() {
    this.Nu.v() && this.Nu.p(this.getVisibleLogicalRange());
  }
  zM(e) {
    this.xw.p(e.width, e.height);
  }
}
function bh(t) {
  return (function(e) {
    if (ls(e.handleScale)) {
      const i = e.handleScale;
      e.handleScale = { axisDoubleClickReset: { time: i, price: i }, axisPressedMouseMove: { time: i, price: i }, mouseWheel: i, pinch: i };
    } else if (e.handleScale !== void 0) {
      const { axisPressedMouseMove: i, axisDoubleClickReset: s } = e.handleScale;
      ls(i) && (e.handleScale.axisPressedMouseMove = { time: i, price: i }), ls(s) && (e.handleScale.axisDoubleClickReset = { time: s, price: s });
    }
    const n = e.handleScroll;
    ls(n) && (e.handleScroll = { horzTouchDrag: n, vertTouchDrag: n, mouseWheel: n, pressedMouseMove: n });
  })(t), t;
}
class FA {
  constructor(e, n, i) {
    this.OM = /* @__PURE__ */ new Map(), this.NM = /* @__PURE__ */ new Map(), this.FM = new Ye(), this.WM = new Ye(), this.HM = new Ye(), this.Xc = /* @__PURE__ */ new WeakMap(), this.UM = new aA(n);
    const s = i === void 0 ? Ot(gh()) : tt(Ot(gh()), bh(i));
    this.$M = n, this.Yp = new eA(e, s, n), this.Yp.nw().i(((o) => {
      this.FM.v() && this.FM.p(this.qM(o()));
    }), this), this.Yp.ew().i(((o) => {
      this.WM.v() && this.WM.p(this.qM(o()));
    }), this), this.Yp.Md().i(((o) => {
      this.HM.v() && this.HM.p(this.qM(o()));
    }), this);
    const r = this.Yp.Qt();
    this.jM = new NA(r, this.Yp.rg(), this.$M);
  }
  remove() {
    this.Yp.nw().u(this), this.Yp.ew().u(this), this.Yp.Md().u(this), this.jM.m(), this.Yp.m(), this.OM.clear(), this.NM.clear(), this.FM.m(), this.WM.m(), this.HM.m(), this.UM.m();
  }
  resize(e, n, i) {
    this.autoSizeActive() || this.Yp.sg(e, n, i);
  }
  addCustomSeries(e, n = {}, i = 0) {
    const s = ((r) => ({ type: "Custom", isBuiltIn: !1, defaultOptions: { ...gA, ...r.defaultOptions() }, YM: fA, KM: r }))(an(e));
    return this.ZM(s, n, i);
  }
  addSeries(e, n = {}, i = 0) {
    return this.ZM(e, n, i);
  }
  removeSeries(e) {
    const n = $e(this.OM.get(e)), i = this.UM.Hd(n);
    this.Yp.Qt().Hd(n), this.GM(i), this.OM.delete(e), this.NM.delete(n);
  }
  DM(e, n) {
    this.GM(this.UM.Ug(e, n));
  }
  VM(e, n, i) {
    this.GM(this.UM.Zg(e, n, i));
  }
  BM(e, n) {
    const [i, s] = this.UM.Jg(e, n);
    return i.length !== 0 && this.GM(s), i;
  }
  subscribeClick(e) {
    this.FM.i(e);
  }
  unsubscribeClick(e) {
    this.FM._(e);
  }
  subscribeCrosshairMove(e) {
    this.HM.i(e);
  }
  unsubscribeCrosshairMove(e) {
    this.HM._(e);
  }
  subscribeDblClick(e) {
    this.WM.i(e);
  }
  unsubscribeDblClick(e) {
    this.WM._(e);
  }
  priceScale(e, n = 0) {
    return new B2(this.Yp, e, n);
  }
  timeScale() {
    return this.jM;
  }
  applyOptions(e) {
    this.Yp.cr(bh(e));
  }
  options() {
    return this.Yp.N();
  }
  takeScreenshot(e = !1, n = !1) {
    let i, s;
    try {
      n || (i = this.Yp.Qt().N().crosshair.mode, this.Yp.cr({ crosshair: { mode: 2 } })), s = this.Yp.ug(e);
    } finally {
      n || i === void 0 || this.Yp.Qt().cr({ crosshair: { mode: i } });
    }
    return s;
  }
  addPane(e = !1) {
    const n = this.Yp.Qt().Xd();
    return n.O_(e), this.XM(n);
  }
  removePane(e) {
    this.Yp.Qt().Sd(e);
  }
  swapPanes(e, n) {
    this.Yp.Qt().Cd(e, n);
  }
  autoSizeActive() {
    return this.Yp.vg();
  }
  chartElement() {
    return this.Yp.hv();
  }
  panes() {
    return this.Yp.Qt().Xs().map(((e) => this.XM(e)));
  }
  paneSize(e = 0) {
    const n = this.Yp.gg(e);
    return { height: n.height, width: n.width };
  }
  setCrosshairPosition(e, n, i) {
    const s = this.OM.get(i);
    if (s === void 0) return;
    const r = this.Yp.Qt().Kn(s);
    r !== null && this.Yp.Qt().Ld(e, n, r);
  }
  clearCrosshairPosition() {
    this.Yp.Qt().zd(!0);
  }
  horzBehaviour() {
    return this.$M;
  }
  ZM(e, n = {}, i = 0) {
    Ke(e.YM !== void 0), (function(a) {
      if (a === void 0 || a.type === "custom") return;
      const c = a;
      c.minMove !== void 0 && c.precision === void 0 && (c.precision = N2(c.minMove));
    })(n.priceFormat), e.type === "Candlestick" && (function(a) {
      a.borderColor !== void 0 && (a.borderUpColor = a.borderColor, a.borderDownColor = a.borderColor), a.wickColor !== void 0 && (a.wickUpColor = a.wickColor, a.wickDownColor = a.wickColor);
    })(n);
    const s = tt(Ot(p2), Ot(e.defaultOptions), n), r = e.YM, o = new cr(this.Yp.Qt(), e.type, s, r, e.KM);
    this.Yp.Qt().Fd(o, i);
    const l = new IA(o, this, this, this, this.$M, ((a) => this.XM(a)));
    return this.OM.set(l, o), this.NM.set(o, l), l;
  }
  GM(e) {
    const n = this.Yp.Qt();
    n.Od(e.Et.vc, e.Et.sM, e.Et.nM), e.F_.forEach(((i, s) => s.ht(i.le, i.iM))), n.Et().Ju(), n.Sc();
  }
  JM(e) {
    return $e(this.NM.get(e));
  }
  qM(e) {
    const n = /* @__PURE__ */ new Map();
    e.Vg.forEach(((s, r) => {
      const o = r.wh(), l = vs(o)(s);
      if (o !== "Custom") Ke(nA(l));
      else {
        const a = r.hl();
        Ke(!a || a(l) === !1);
      }
      n.set(this.JM(r), l);
    }));
    const i = e.Ig !== void 0 && this.NM.has(e.Ig) ? this.JM(e.Ig) : void 0;
    return { time: e.Gr, logical: e.js, point: e.Rg, paneIndex: e.Dg, hoveredSeries: i, hoveredObjectId: e.Bg, seriesData: n, sourceEvent: e.Eg };
  }
  XM(e) {
    let n = this.Xc.get(e);
    return n || (n = new ZA(this.Yp, ((i) => this.JM(i)), e, this), this.Xc.set(e, n)), n;
  }
}
function GA(t) {
  if (zi(t)) {
    const e = document.getElementById(t);
    return Ke(e !== null, `Cannot find element in DOM with id=${t}`), e;
  }
  return t;
}
function XA(t, e, n) {
  const i = GA(t), s = new FA(i, e, n);
  return e.setOptions(s.options()), s;
}
function UA(t, e) {
  return XA(t, new eh(), eh.pf(e));
}
class BA extends X2 {
  constructor(e, n) {
    super(e, n, !0);
  }
  mM(e, n, i) {
    n.mc(this.aM, fl(this.lM)), e.Yo(this.aM, i, fl(this.lM));
  }
  QM(e, n) {
    return { wt: e, gt: n, _t: NaN, ut: NaN };
  }
  pM() {
    const e = this.ee.ga();
    this.aM = this.ee.Na().Dh().map(((n) => {
      let i;
      if ((n.jr ?? 1) > 1) {
        const s = n.Wt[1], r = n.Wt[2], o = n.Wt[3];
        i = Math.abs(s - o) > Math.abs(r - o) ? s : r;
      } else i = n.Wt[3];
      return this.tb(n.js, i, e);
    }));
  }
}
function wA(t, e, n, i, s, r, o) {
  if (e.length === 0 || i.from >= e.length || i.to <= 0) return;
  const { context: l, horizontalPixelRatio: a, verticalPixelRatio: c } = t, u = e[i.from];
  let h = r(t, u), d = u;
  if (i.to - i.from < 2) {
    const m = s / 2;
    l.beginPath();
    const p = { _t: u._t - m, ut: u.ut }, g = { _t: u._t + m, ut: u.ut };
    l.moveTo(p._t * a, p.ut * c), l.lineTo(g._t * a, g.ut * c), o(t, h, p, g);
  } else {
    const m = (g, A) => {
      o(t, h, d, A), l.beginPath(), h = g, d = A;
    };
    let p = d;
    l.beginPath(), l.moveTo(u._t * a, u.ut * c);
    for (let g = i.from + 1; g < i.to; ++g) {
      p = e[g];
      const A = r(t, p);
      switch (n) {
        case 0:
          l.lineTo(p._t * a, p.ut * c);
          break;
        case 1:
          l.lineTo(p._t * a, e[g - 1].ut * c), A !== h && (m(A, p), l.lineTo(p._t * a, e[g - 1].ut * c)), l.lineTo(p._t * a, p.ut * c);
          break;
        case 2: {
          const [b, R] = YA(e, g - 1, g);
          l.bezierCurveTo(b._t * a, b.ut * c, R._t * a, R.ut * c, p._t * a, p.ut * c);
          break;
        }
      }
      n !== 1 && A !== h && (m(A, p), l.moveTo(p._t * a, p.ut * c));
    }
    (d !== p || d === p && n === 1) && o(t, h, d, p);
  }
}
const Ah = 6;
function Co(t, e) {
  return { _t: t._t - e._t, ut: t.ut - e.ut };
}
function Vh(t, e) {
  return { _t: t._t / e, ut: t.ut / e };
}
function YA(t, e, n) {
  const i = Math.max(0, e - 1), s = Math.min(t.length - 1, n + 1);
  var r, o;
  return [(r = t[e], o = Vh(Co(t[n], t[i]), Ah), { _t: r._t + o._t, ut: r.ut + o.ut }), Co(t[n], Vh(Co(t[s], t[e]), Ah))];
}
function TA(t, e) {
  const n = t.context;
  n.strokeStyle = e, n.stroke();
}
class LA extends di {
  constructor() {
    super(...arguments), this.rt = null;
  }
  ht(e) {
    this.rt = e;
  }
  et(e) {
    if (this.rt === null) return;
    const { ot: n, lt: i, ib: s, sb: r, ct: o, Zt: l, nb: a } = this.rt;
    if (i === null) return;
    const c = e.context;
    c.lineCap = "butt", c.lineWidth = o * e.verticalPixelRatio, vn(c, l), c.lineJoin = "round";
    const u = this.eb.bind(this);
    r !== void 0 && wA(e, n, r, i, s, u, TA), a && (function(h, d, m, p, g) {
      if (p.to - p.from <= 0) return;
      const { horizontalPixelRatio: A, verticalPixelRatio: b, context: R } = h;
      let S = null;
      const E = Math.max(1, Math.floor(A)) % 2 / 2, Z = m * b + E;
      for (let G = p.to - 1; G >= p.from; --G) {
        const T = d[G];
        if (T) {
          const C = g(h, T);
          C !== S && (R.beginPath(), S !== null && R.fill(), R.fillStyle = C, S = C);
          const N = Math.round(T._t * A) + E, Y = T.ut * b;
          R.moveTo(N, Y), R.arc(N, Y, Z, 0, 2 * Math.PI);
        }
      }
      R.fill();
    })(e, n, a, i, u);
  }
}
class kA extends LA {
  eb(e, n) {
    return n.vt;
  }
}
class JA extends BA {
  constructor() {
    super(...arguments), this.cM = new kA();
  }
  tb(e, n, i) {
    return { ...this.QM(e, n), ...i.gh(e) };
  }
  wM() {
    const e = this.ee.N(), n = { ot: this.aM, Zt: e.lineStyle, sb: e.lineVisible ? e.lineType : void 0, ct: e.lineWidth, nb: e.pointMarkersVisible ? e.pointMarkersRadius || e.lineWidth / 2 + 2 : void 0, lt: this.lM, ib: this.re.Et().ul() };
    this.cM.ht(n);
  }
}
const xA = { type: "Line", isBuiltIn: !0, defaultOptions: { color: "#2196f3", lineStyle: 0, lineWidth: 3, lineType: 0, lineVisible: !0, crosshairMarkerVisible: !0, crosshairMarkerRadius: 4, crosshairMarkerBorderColor: "", crosshairMarkerBorderWidth: 2, crosshairMarkerBackgroundColor: "", lastPriceAnimation: 0, pointMarkersVisible: !1 }, YM: (t, e) => new JA(t, e) };
({ ...p2 });
const MA = /* @__PURE__ */ V("div")({
  name: "Container",
  class: "c16uapq7",
  propsAsIs: !1
}), QA = /* @__PURE__ */ V("div")({
  name: "Header",
  class: "h1bkiv31",
  propsAsIs: !1
}), zA = /* @__PURE__ */ V("img")({
  name: "Logo",
  class: "l58x1zx",
  propsAsIs: !1
}), KA = /* @__PURE__ */ V("span")({
  name: "AdTitle",
  class: "aje8tdj",
  propsAsIs: !1
}), HA = /* @__PURE__ */ V("div")({
  name: "Vol",
  class: "v1b9hkhr",
  propsAsIs: !1
}), OA = /* @__PURE__ */ V("div")({
  name: "Teams",
  class: "t103i3ll",
  propsAsIs: !1
}), DA = /* @__PURE__ */ V("div")({
  name: "Team",
  class: "tv6559o",
  propsAsIs: !1
}), PA = /* @__PURE__ */ V("img")({
  name: "TeamLogo",
  class: "td9fhm",
  propsAsIs: !1
}), _A = /* @__PURE__ */ V("span")({
  name: "TeamName",
  class: "t1bg0qru",
  propsAsIs: !1
}), jA = /* @__PURE__ */ V("span")({
  name: "TeamPercentage",
  class: "t1k3nqya",
  propsAsIs: !1
}), $A = /* @__PURE__ */ V("div")({
  name: "Draw",
  class: "du878ld",
  propsAsIs: !1
}), qA = /* @__PURE__ */ V("span")({
  name: "DrawPercentage",
  class: "d11m2h7g",
  propsAsIs: !1
}), e6 = /* @__PURE__ */ V("div")({
  name: "Chart",
  class: "cpgwa9e",
  propsAsIs: !1
}), t6 = (t) => `${(t / 1e3).toFixed(1)}`, Rh = (t) => t && !t.startsWith("#") ? `#${t}` : t ?? "#fff", n6 = ({
  logo: t,
  volume: e,
  drawProbabilityPct: n,
  teams: i,
  drawColor: s,
  chartData: r
}) => {
  const o = Ee(null);
  return te(() => {
    const l = o.current;
    if (!l || !r || r.length === 0)
      return;
    let a = 0;
    r.forEach((A) => {
      A.points.forEach((b) => {
        const R = b.p * 100;
        R > a && (a = R);
      });
    });
    const c = Math.floor(a / 10) * 10, u = 0, h = r[0]?.points || [];
    let d = "day";
    if (h.length >= 2) {
      const A = new Date(h[0].t).getTime() / 1e3, b = new Date(h[1].t).getTime() / 1e3 - A;
      b >= 1200 * 60 ? d = "day" : b >= 3600 ? d = "hour" : d = "minute";
    }
    const m = UA(l, {
      layout: {
        background: { type: Al.Solid, color: "transparent" },
        textColor: "rgba(255, 255, 255, 0.5)",
        fontSize: 12
      },
      grid: {
        vertLines: { visible: !1 },
        horzLines: {
          color: "rgba(255, 255, 255, 0.2)",
          style: gl.Dashed
        }
      },
      crosshair: {
        mode: 0,
        vertLine: {
          visible: !1,
          labelVisible: !1
        },
        horzLine: {
          visible: !1,
          labelVisible: !1
        }
      },
      width: l.clientWidth,
      handleScroll: !1,
      handleScale: !1,
      height: 300,
      localization: {
        timeFormatter: (A) => {
          const b = new Date(A * 1e3);
          if (d === "day") {
            const R = b.getUTCDate(), S = b.toLocaleDateString("en-US", { month: "short", timeZone: "UTC" });
            return `${R} ${S}`;
          } else {
            if (d === "hour")
              return `${b.getUTCHours()}h`;
            {
              const R = b.getUTCHours(), S = b.getUTCMinutes(), E = R >= 12 ? "pm" : "am";
              return `${R % 12 || 12}:${S.toString().padStart(2, "0")}${E}`;
            }
          }
        }
      },
      timeScale: {
        timeVisible: !0,
        secondsVisible: !1,
        barSpacing: 30,
        minBarSpacing: 8,
        rightOffset: 15,
        allowBoldLabels: !1,
        borderColor: "rgba(255, 255, 255, 0.5)",
        fixLeftEdge: !0,
        fixRightEdge: !0,
        tickMarkFormatter: (A) => {
          const b = new Date(A * 1e3);
          if (!h.slice(-4).map((R) => Math.floor(new Date(R.t).getTime() / 1e3)).includes(A))
            return "";
          if (d === "day") {
            const R = b.getUTCDate(), S = b.toLocaleDateString("en-US", { month: "short", timeZone: "UTC" });
            return `${R} ${S}`;
          } else {
            if (d === "hour")
              return `${b.getUTCHours()}h`;
            {
              const R = b.getUTCHours(), S = b.getUTCMinutes(), E = R >= 12 ? "pm" : "am";
              return `${R % 12 || 12}:${S.toString().padStart(2, "0")}${E}`;
            }
          }
        }
      },
      rightPriceScale: {
        visible: !0,
        borderVisible: !1,
        autoScale: !1
      },
      leftPriceScale: {
        visible: !1
      }
    }), p = [];
    if (r.forEach((A) => {
      const b = m.addSeries(xA, {
        color: A.color,
        lineWidth: 4,
        lastValueVisible: !1,
        priceLineVisible: !1,
        priceFormat: {
          type: "custom",
          formatter: (S) => `${Math.round(S)}%`
        },
        autoscaleInfoProvider: () => ({
          priceRange: {
            minValue: u,
            maxValue: c
          }
        })
      }), R = A.points?.map((S) => ({
        time: Math.floor(new Date(S.t).getTime() / 1e3),
        value: S.p * 100
      }))?.filter(
        (S, E, Z) => E === 0 || S.time !== Z[E - 1].time
      );
      b.setData(R), R.length > 0 && p.push({
        series: b,
        lastPoint: R[R.length - 1],
        color: A.color
      });
    }), h.length >= 4) {
      const A = h.slice(-4), b = Math.floor(new Date(A[0].t).getTime() / 1e3), R = Math.floor(new Date(A[3].t).getTime() / 1e3), S = R - b, E = S * 0.02, Z = S * 0.03;
      m.timeScale().setVisibleRange({
        from: b - E,
        to: R + Z
      });
    } else
      m.timeScale().fitContent();
    setTimeout(() => {
      const A = l.querySelector(".tv-lightweight-charts");
      if (!A)
        return;
      A.style.position = "relative";
      const b = A.querySelector("table");
      b && (b.style.position = "relative", b.style.zIndex = "1", b.style.pointerEvents = "none"), p.forEach(({ series: R, lastPoint: S, color: E }) => {
        const Z = R.priceToCoordinate(S.value), G = m.timeScale().timeToCoordinate(S.time);
        if (Z !== null && G !== null) {
          const T = document.createElement("div");
          T.style.cssText = `
            position: absolute !important;
            width: 40px !important;
            height: 40px !important;
            border-radius: 50% !important;
            background-color: ${E} !important;
            border: 10px solid rgba(26, 26, 26, 0.75) !important;
            left: ${G - 20}px !important;
            top: ${Z - 20}px !important;
            pointer-events: none !important;
            display: block !important;
            visibility: visible !important;
            opacity: 1 !important;
          `, T.className = "chart-endpoint-marker", A.appendChild(T);
        }
      });
    }, 100);
    const g = () => {
      l && m.applyOptions({ width: l.clientWidth });
    };
    return window.addEventListener("resize", g), () => {
      window.removeEventListener("resize", g);
      const A = l.querySelector(".tv-lightweight-charts");
      A && A.querySelectorAll(".chart-endpoint-marker").forEach((b) => b.remove()), m.remove();
    };
  }, [r]), /* @__PURE__ */ U(MA, { children: [
    /* @__PURE__ */ U(QA, { children: [
      /* @__PURE__ */ f(zA, { src: t }),
      /* @__PURE__ */ f(KA, { children: "Ad" })
    ] }),
    /* @__PURE__ */ U(HA, { children: [
      "$",
      t6(e),
      "k Vol."
    ] }),
    /* @__PURE__ */ f(OA, { children: i?.map(({ teamLogo: l, teamName: a, probabilityPct: c, teamColor: u }, h) => /* @__PURE__ */ U(DA, { children: [
      /* @__PURE__ */ f(PA, { src: l }),
      /* @__PURE__ */ f(_A, { children: a }),
      /* @__PURE__ */ U(jA, { style: { color: u ? Rh(u) : r?.[h]?.color ?? "#fff" }, children: [
        Math.round(c),
        "%"
      ] })
    ] }, a)) }),
    /* @__PURE__ */ U($A, { children: [
      "Draw",
      " ",
      /* @__PURE__ */ U(
        qA,
        {
          style: {
            color: s ? Rh(s) : r?.[i?.length ?? 0]?.color ?? "#fff"
          },
          children: [
            Math.round(n),
            "%"
          ]
        }
      )
    ] }),
    /* @__PURE__ */ f(e6, { ref: o })
  ] });
}, i6 = /* @__PURE__ */ V("div")({
  name: "Container",
  class: "claeaeg",
  propsAsIs: !1
}), s6 = /* @__PURE__ */ V("button")({
  name: "Button",
  class: "bi136qd",
  propsAsIs: !1
}), r6 = ({
  sdk: t
}) => {
  const e = Z4();
  return /* @__PURE__ */ f(s6, {
    className: "SLPolymarketButton",
    onClick: () => e.polymarket ? t.uiHandlers.disablePolymarket() : t.uiHandlers.enablePolymarket()
  });
}, o6 = ({
  sdk: t,
  webos: e
}) => {
  const n = He(t.polymarket.marketWithSeries);
  if (!n.data && !n.loading)
    return /* @__PURE__ */ f("i", {
      children: "no polymarket data"
    });
  const i = n.data?.outcomes ?? [], {
    teams: s,
    chartData: r
  } = i.reduce((a, c) => {
    const u = c.points[c.points.length - 1], h = u ? u.p * 100 : c.probabilityPct;
    return a.teams.push({
      teamName: c.label,
      probabilityPct: h,
      teamColor: c.color ?? "",
      teamLogo: c.rawMetadata.teamLogo ?? "",
      isDraw: c.type === 2
    }), a.chartData.push({
      label: c.label,
      color: c.rawMetadata.teamColor ?? `#${c.color ?? ""}`,
      points: c.points
    }), a;
  }, {
    teams: [],
    chartData: []
  }), {
    drawTeam: o,
    teamsWithoutDraw: l
  } = s.reduce((a, c) => (c.isDraw ? a.drawTeam = c : a.teamsWithoutDraw.push(c), a), {
    drawTeam: void 0,
    teamsWithoutDraw: []
  });
  return /* @__PURE__ */ f(i6, {
    className: Oe(e && "SL-CardWebOs"),
    children: /* @__PURE__ */ f(n6, {
      logo: "https://cdn.streamlayer.io/sdk-web/polymarket.png",
      volume: n.data?.volume ?? 0,
      drawProbabilityPct: o?.probabilityPct ?? 0,
      drawColor: o?.teamColor ?? "",
      teams: l,
      chartData: r
    })
  });
}, l6 = Rd.pino({
  level: "trace",
  enabled: typeof window < "u" && !!window.localStorage.getItem("SL_DEBUG"),
  browser: {
    write: (t) => {
      console.log(t);
    }
  }
}), Ki = (t, e) => l6.child({ name: t }, e);
class a6 extends Event {
  slEventBus;
  constructor(e, n) {
    super(e), this.slEventBus = n;
  }
}
const c6 = Ki("event-bus");
class u6 {
  name;
  listeners;
  constructor(e = "sl-event-bus") {
    this.name = e, this.listeners = /* @__PURE__ */ new Set();
  }
  emit = (e, n) => {
    const i = new a6(this.name, { ...n, type: e });
    c6.debug(i, "Emitting event"), window.dispatchEvent(i);
  };
  listen(e) {
    return window.addEventListener(this.name, e), this.listeners.add(e), () => {
      this.off(e);
    };
  }
  off(e) {
    window.removeEventListener(this.name, e), this.listeners.delete(e);
  }
  destroy = () => {
    this.listeners.forEach((e) => {
      window.removeEventListener(this.name, e), this.listeners.delete(e);
    }), this.listeners.clear();
  };
}
var Cl;
(function(t) {
  t[t.ONBOARDING = 1] = "ONBOARDING", t[t.QUESTION = 2] = "QUESTION", t[t.QUESTION_RESOLVED = 3] = "QUESTION_RESOLVED";
})(Cl || (Cl = {}));
window.slStore = /* @__PURE__ */ Object.create(null);
var Eh;
(function(t) {
  t.ORGANIZATION = "ORGANIZATION", t.STREAM = "STREAM";
})(Eh || (Eh = {}));
pe.BETTING + "", pe.GAMES + "", pe.PUBLIC_CHAT + "", pe.TWITTER + "";
var yh;
(function(t) {
  t.Ready = "ready", t.Suspended = "suspended";
})(yh || (yh = {}));
const be = new u6(), h6 = /* @__PURE__ */ V("div")({
  name: "Container",
  class: "c5b6wdg",
  propsAsIs: !1
}), d6 = "a1rlj479", m6 = "s35f1di", p6 = "sj4471g", g6 = "b12050d8", f6 = "b1d5ybek", b6 = (t) => t === "left" || t === "right" ? m6 : g6, A6 = (t) => t === "left" || t === "right" ? p6 : f6, V6 = (t) => t === "left" ? "avdxyl3" : t === "right" ? "a1bisd08" : t === "top" ? "a1u9y2aj" : "a1qqaks", fa = ({
  children: t,
  style: e,
  className: n,
  enabled: i = !0,
  hiding: s,
  direction: r = "left",
  onAnimationEnd: o
}) => /* @__PURE__ */ f(h6, {
  style: e,
  className: Oe(n, d6, V6(r), i && !s && b6(r), i && s && A6(r)),
  onAnimationEnd: o,
  children: t
}), R6 = /* @__PURE__ */ V("a")({
  name: "Link",
  class: "l1sgte8c",
  propsAsIs: !1
}), E6 = /* @__PURE__ */ V("div")({
  name: "BannerContainer",
  class: "b7yfc72",
  propsAsIs: !1
}), y6 = () => R6, C6 = /* @__PURE__ */ V(y6())({
  name: "BannerLink",
  class: "bejjq94",
  propsAsIs: !0
}), w2 = ({ promotion: t, promotionId: e, hiding: n, isEventFired: i, fireEvent: s, direction: r = "bottom" }) => {
  const o = t?.adUnit === Ne.STANDART, l = o ? t.banner : t.additionalBanner;
  if (te(() => {
    l?.imageUrl && e && (i?.("banner-showed") || (be.emit("advertisement", {
      action: "bannerShown",
      payload: {
        id: e,
        type: t.type
      }
    }), s?.("banner-showed")));
  }, [l?.imageUrl, s, i, t.type, e]), !l?.imageUrl)
    return null;
  let a = l?.url;
  return a && a.indexOf("http") !== 0 && (a = `https://${a}`), /* @__PURE__ */ f(fa, { direction: r, hiding: n, children: /* @__PURE__ */ f(E6, { className: "BannerContainer", "data-is-ad": o, children: /* @__PURE__ */ f(
    C6,
    {
      as: a ? "a" : "span",
      className: "BannerLink",
      href: a,
      style: {
        backgroundImage: `url(${l.imageUrl})`,
        cursor: a ? "pointer" : "default"
      },
      "data-promo-id": e,
      "data-promo-type": t.type,
      "data-a": "banner",
      target: "_blank",
      "data-is-ad": o
    }
  ) }) });
}, W6 = ({ isEventFired: t, fireEvent: e, cardId: n, promotion: i, direction: s = "bottom" }) => /* @__PURE__ */ f(
  w2,
  {
    isEventFired: t,
    fireEvent: e,
    promotion: i,
    promotionId: n,
    direction: s,
    hiding: !1
  }
), S6 = (t, e) => {
  const n = window.innerWidth < r5.xl;
  te(() => {
    const i = n && e.useDomNode ? document : t.current, s = (r) => {
      e.listener(r, t);
    };
    return e.enabled && i?.addEventListener(e.event, s), () => {
      i?.removeEventListener(e.event, s);
    };
  }, [n, e.enabled, e.listener]);
};
let Z6 = class {
  observers = /* @__PURE__ */ new Set();
  subscribe(e) {
    this.observers.add(e);
  }
  unsubscribe(e) {
    this.observers.delete(e);
  }
  notify(e) {
    this.observers.forEach((n) => n(e));
  }
};
const Ai = new Z6(), v6 = { hiding: !1, finished: !1 }, ba = () => {
  const [t, e] = re(v6), n = Ee(null);
  te(() => {
    const r = (o) => {
      e(o);
    };
    return Ai.subscribe(r), () => {
      Ai.unsubscribe(r);
    };
  }, []);
  const i = Ue((r) => {
    const o = { hiding: !0, finished: !1 };
    n.current && clearTimeout(n.current), r?.delay ? n.current = setTimeout(() => {
      Ai.notify(o);
    }, r?.delay) : Ai.notify(o);
  }, []), s = Ue(() => {
    t.hiding && (n.current = null, Ai.notify({ hiding: !1, finished: !0 }));
  }, [t.hiding]);
  return {
    ...t,
    runAnimation: i,
    onAnimationEnd: s
  };
}, I6 = `
  .sl-hide-on-modal {
    height: 0 !important;
    opacity: 0 !important;
    overflow: hidden !important;
    transition: none;
  }
`, N6 = ({
  containerId: t = "SlLayoutContainer",
  url: e
}) => `
  #${t || "SlLayoutContainer"},
  #${t || "SlLayoutContainer"} .StreamLayerSDK>.StreamLayerSDKTheme > * {
    --color-sdk-container-bg: transparent !important;
  }

  #${t || "SlLayoutContainer"}::before {
    content: '';
    display: block;
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    background-color: #1a1a1a;
    background-size: cover !important;
    background-position: center !important;
    background-repeat: no-repeat !important;
    background-image: ${e} !important;
    z-index: 0;

    opacity: 0;
    animation: fade-sl-bg-in 0.3s linear forwards;
  }

  #${t || "SlLayoutContainer"} > div {
    position: relative;
    z-index: 1;
  }

  @keyframes fade-sl-bg-in {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  ${I6}
`, Y2 = ({
  containerId: t,
  landscapeUrl: e,
  portraitUrl: n
}) => {
  const [i, s] = re(!1), r = gt(() => {
    const o = window.innerWidth, l = window.innerHeight;
    return s(!1), o > l ? e : n;
  }, [e, n]);
  return te(() => {
    if (r) {
      const o = new Image();
      o.src = r, o.onload = function() {
        s(!0);
      };
    }
  }, [r]), gt(() => {
    const o = r ? `url("${r}")` : void 0;
    return o && i ? /* @__PURE__ */ f("style", { children: N6({ containerId: t, url: o }) }) : null;
  }, [t, r, i]);
}, F6 = (t) => {
  const { Component: e, options: n, customOptions: i, autoFocus: s, ...r } = t, o = gd({
    ...n,
    ...i,
    onEnterPress: () => t.onClick?.({ currentTarget: o.ref.current, stopPropagation: () => {
    } })
  });
  return te(() => {
    s && o.focusSelf();
  }, []), /* @__PURE__ */ f(e, { ...r, ...o, "data-is-with-focus": "true" });
};
function ht(t, e) {
  return ({ webos: n, options: i, ...s }) => n ? /* @__PURE__ */ f(F6, { Component: t, options: e, customOptions: i, ...s }) : /* @__PURE__ */ f(t, { ...s });
}
const G6 = (t) => /* @__PURE__ */ y.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ y.createElement("path", { d: "M8 4L16 12L8 20", stroke: "#6B6F73", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })), X6 = (t) => /* @__PURE__ */ y.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ y.createElement("g", { id: "check" }, /* @__PURE__ */ y.createElement("path", { id: "Vector", d: "M4 13L9 18L20 6", stroke: "#107D57", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }))), U6 = (t) => /* @__PURE__ */ y.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ y.createElement("path", { d: "M10 6L16 12L10 18", stroke: "white", style: {
  stroke: "white",
  strokeOpacity: 1
}, strokeWidth: 1.25, strokeLinecap: "round", strokeLinejoin: "round" })), B6 = (t) => /* @__PURE__ */ y.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ y.createElement("rect", { width: 16, height: 16, rx: 8, fill: "#CD2525" }), /* @__PURE__ */ y.createElement("rect", { x: 5.5, y: 4.66669, width: 8.24958, height: 1.17851, rx: 0.589256, transform: "rotate(45 5.5 4.66669)", fill: "white" }), /* @__PURE__ */ y.createElement("rect", { x: 4.66669, y: 10.5, width: 8.24958, height: 1.17851, rx: 0.589256, transform: "rotate(-45 4.66669 10.5)", fill: "white" })), w6 = (t) => /* @__PURE__ */ y.createElement("svg", { width: 48, height: 48, viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ y.createElement("rect", { width: 48, height: 48, rx: 24, fill: "#00BD60" }), /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M37.3147 13.052C37.8383 13.5019 37.898 14.2912 37.448 14.8147L20.2605 34.8147C20.0292 35.0839 19.6944 35.2421 19.3395 35.2497C18.9847 35.2574 18.6433 35.1139 18.4006 34.8549L10.5881 26.5216C10.1159 26.018 10.1414 25.2269 10.6451 24.7548C11.1487 24.2826 11.9398 24.3081 12.4119 24.8118L19.2721 32.1292L35.552 13.1853C36.0019 12.6617 36.7911 12.602 37.3147 13.052Z", fill: "white" })), Y6 = (t) => /* @__PURE__ */ y.createElement("svg", { width: 12, height: 12, viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ y.createElement("g", { id: "Frame 3469478" }, /* @__PURE__ */ y.createElement("path", { id: "Vector 4", d: "M1.62695 1.62598L10.3742 10.3745", stroke: "#6B6F73", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ y.createElement("path", { id: "Vector 5", d: "M1.62695 10.376L10.3742 1.62746", stroke: "#6B6F73", strokeWidth: 1.5, strokeLinecap: "round" }))), T6 = (t) => /* @__PURE__ */ y.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ y.createElement("rect", { x: 0.56009, y: 2.8074, width: 16.55, height: 16.55, rx: 2.14375, transform: "rotate(-7.80777 0.56009 2.8074)", stroke: "#006747", style: {
  stroke: "#006747",
  stroke: "color(display-p3 0.0000 0.4039 0.2784)",
  strokeOpacity: 1
}, strokeWidth: 1.4 }), /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.62237 4.17188C10.5053 4.17188 11.2837 4.37793 11.8733 4.76716L11.8732 4.76718C12.5572 5.21938 12.9636 5.89049 13.0796 6.75908C13.2656 8.14856 12.2625 9.08727 11.5284 9.77271C11.2207 10.0589 10.956 10.3079 10.8501 10.5183C10.7752 10.6652 10.7366 10.8269 10.6992 10.9839C10.698 10.989 10.6967 10.994 10.6955 10.9991L10.6952 11.0004C10.5952 11.4278 10.4915 11.8706 9.72822 11.9721C9.67385 11.9793 9.6209 11.9821 9.56938 11.9821C9.28746 11.9821 9.03705 11.8777 8.84673 11.6788C8.67931 11.5056 8.56912 11.2738 8.53621 11.0234C8.40767 10.0551 9.08301 9.37328 9.68028 8.77031L9.68384 8.76671C10.2176 8.23011 10.7199 7.72213 10.6354 7.08534C10.5496 6.43425 10.1275 6.07652 9.44917 6.07652C9.35902 6.07652 9.26601 6.08367 9.1687 6.09655C8.22588 6.22243 8.06263 6.74456 7.88952 7.29821L7.88941 7.29854C7.73775 7.78506 7.58034 8.28732 6.85055 8.38463C6.79188 8.39178 6.73178 8.39608 6.6731 8.39608C6.1279 8.39608 5.72868 8.05407 5.65856 7.52462C5.56127 6.80772 5.86319 6.0307 6.48137 5.39534C7.0924 4.77002 7.94814 4.34216 8.8296 4.22482C9.09577 4.19048 9.36193 4.17188 9.62237 4.17188ZM9.88998 12.7224C9.94722 12.7152 10.0059 12.7109 10.0631 12.7109C10.7228 12.7109 11.2866 13.2032 11.3753 13.8586C11.4697 14.5812 10.9618 15.2466 10.2391 15.3439C10.1804 15.3511 10.1218 15.3554 10.0645 15.3554C9.40485 15.3554 8.84107 14.8617 8.75378 14.2077C8.65791 13.4851 9.16732 12.8197 9.88998 12.7224Z", fill: "#006747", style: {
  fill: "#006747",
  fill: "color(display-p3 0.0000 0.4039 0.2784)",
  fillOpacity: 1
} })), L6 = (t) => /* @__PURE__ */ y.createElement("svg", { width: 25, height: 24, viewBox: "0 0 25 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ y.createElement("rect", { x: 1, y: 0.5, width: 23, height: 23, rx: 11.5, stroke: "#B1B3B3" }), /* @__PURE__ */ y.createElement("path", { d: "M13.833 8L9.83301 12L13.833 16", stroke: "#B1B3B3", strokeLinecap: "round", strokeLinejoin: "round" })), k6 = (t) => /* @__PURE__ */ y.createElement("svg", { width: 25, height: 25, viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ y.createElement("g", { id: "Icon" }, /* @__PURE__ */ y.createElement("path", { id: "Icon_2", d: "M10.5 6.39844L16.5 12.3984L10.5 18.3984", stroke: "white", style: {
  stroke: "white",
  strokeOpacity: 1
}, strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }))), J6 = (t) => /* @__PURE__ */ y.createElement("svg", { width: 64, height: 65, viewBox: "0 0 64 65", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ y.createElement("path", { d: "M43.852 8.90765C40.2818 7.13339 36.2575 6.13574 32.0002 6.13574C17.2726 6.13574 5.3335 18.0748 5.3335 32.8024C5.3335 47.53 17.2726 59.4691 32.0002 59.4691C46.7278 59.4691 58.6668 47.53 58.6668 32.8024C58.6668 31.8009 58.6116 30.8123 58.5041 29.8394M24.0002 30.1357L32.0002 38.1357L58.6668 11.4691", stroke: "#107D57", strokeWidth: 2.5, strokeLinecap: "round", strokeLinejoin: "round" })), x6 = (t) => /* @__PURE__ */ y.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ y.createElement("path", { id: "Selected", fillRule: "evenodd", clipRule: "evenodd", d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM11.6057 5.43441C11.2933 5.12199 10.7868 5.12199 10.4744 5.43441L6.93812 9.97066L5.08382 8.73446C4.7162 8.48938 4.2195 8.58871 3.97442 8.95634C3.72934 9.32396 3.82868 9.82065 4.1963 10.0657L6.5963 11.6657C6.9136 11.8773 7.33609 11.8354 7.60574 11.5658L11.6057 6.56578C11.9182 6.25336 11.9182 5.74683 11.6057 5.43441Z", fill: "#107D57" })), M6 = (t) => /* @__PURE__ */ y.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ y.createElement("g", { id: "Checkmark" }, /* @__PURE__ */ y.createElement("path", { id: "Selected", fillRule: "evenodd", clipRule: "evenodd", d: "M24 12.002C24 18.6294 18.6274 24.002 12 24.002C5.37258 24.002 0 18.6294 0 12.002C0 5.37454 5.37258 0.00195312 12 0.00195312C18.6274 0.00195312 24 5.37454 24 12.002ZM17.4086 8.15357C16.94 7.68494 16.1802 7.68494 15.7116 8.15357L10.4072 14.9579L7.62573 13.1036C7.07429 12.736 6.32925 12.885 5.96163 13.4365C5.59401 13.9879 5.74301 14.7329 6.29445 15.1006L9.89445 17.5006C10.3704 17.8179 11.0041 17.7551 11.4086 17.3506L17.4086 9.85063C17.8772 9.382 17.8772 8.6222 17.4086 8.15357Z", fill: "#FFFFFF" }))), Q6 = (t) => /* @__PURE__ */ y.createElement("svg", { width: 12, height: 20, viewBox: "0 0 12 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ y.createElement("path", { id: "Icon / chevron.left", d: "M0 10C0 10.3818 0.145996 10.7075 0.449219 10.9995L9.20898 19.5684C9.44482 19.8154 9.75928 19.939 10.1187 19.939C10.8486 19.939 11.4214 19.3774 11.4214 18.6362C11.4214 18.2769 11.2754 17.9512 11.0283 17.7041L3.1333 10L11.0283 2.2959C11.2754 2.0376 11.4214 1.71191 11.4214 1.35254C11.4214 0.622559 10.8486 0.0610352 10.1187 0.0610352C9.75928 0.0610352 9.44482 0.18457 9.20898 0.431641L0.449219 9.00049C0.145996 9.29248 0.0112305 9.61816 0 10Z", fill: "white", fillOpacity: 0.6 })), z6 = (t) => /* @__PURE__ */ y.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ y.createElement("g", { id: "Chevron" }, /* @__PURE__ */ y.createElement("path", { id: "Chevron_2", d: "M6 11.999C6 12.1725 6.03134 12.334 6.09401 12.4837C6.15669 12.6334 6.25428 12.7756 6.3868 12.9103L14.0436 20.6565C14.2648 20.8855 14.5323 21 14.8459 21C15.0607 21 15.2544 20.9475 15.4271 20.8426C15.5998 20.7377 15.7384 20.5965 15.8431 20.4191C15.9477 20.2416 16 20.0425 16 19.8217C16 19.4989 15.8816 19.2134 15.6448 18.9654L8.74183 11.9971L15.6448 5.03271C15.8816 4.78709 16 4.5023 16 4.17834C16 3.95749 15.9477 3.75835 15.8431 3.58091C15.7384 3.40347 15.5998 3.26229 15.4271 3.15738C15.2544 3.05246 15.0607 3 14.8459 3C14.5323 3 14.2648 3.11169 14.0436 3.33508L6.3868 11.0878C6.25551 11.2225 6.15853 11.3644 6.09586 11.5134C6.03318 11.6625 6.00123 11.8244 6 11.999Z", fill: "white" }))), K6 = (t) => /* @__PURE__ */ y.createElement("svg", { width: 16, height: 17, viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ y.createElement("g", { id: "Chevron" }, /* @__PURE__ */ y.createElement("path", { id: "Chevron_2", d: "M12 8.17222C12 8.28783 11.9781 8.39553 11.9342 8.49533C11.8903 8.59513 11.822 8.68992 11.7292 8.7797L6.36949 13.9439C6.21462 14.0965 6.02742 14.1729 5.80787 14.1729C5.65752 14.1729 5.52191 14.1379 5.40104 14.0679C5.28016 13.998 5.1831 13.9039 5.10986 13.7856C5.03662 13.6673 5 13.5345 5 13.3873C5 13.1721 5.08288 12.9818 5.24863 12.8164L10.0807 8.17095L5.24863 3.52799C5.08288 3.36425 5 3.17439 5 2.95841C5 2.81118 5.03662 2.67842 5.10986 2.56013C5.1831 2.44183 5.28016 2.34771 5.40104 2.27777C5.52191 2.20782 5.65752 2.17285 5.80787 2.17285C6.02742 2.17285 6.21462 2.24731 6.36949 2.39624L11.7292 7.56473C11.8211 7.65451 11.889 7.74909 11.9329 7.84846C11.9768 7.94784 11.9991 8.05576 12 8.17222Z", fill: "#FFFFFF" }))), H6 = (t) => /* @__PURE__ */ y.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 -2.43189e-06C18.6274 -2.72158e-06 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 8.1423e-07 18.6274 5.24537e-07 12C2.34843e-07 5.37258 5.37258 -2.14219e-06 12 -2.43189e-06ZM11.9999 22.5883C17.8476 22.5883 22.5881 17.8478 22.5881 12.0001C22.5881 6.15238 17.8476 1.41187 11.9999 1.41187C6.15217 1.41187 1.41166 6.15239 1.41166 12.0001C1.41166 17.8478 6.15217 22.5883 11.9999 22.5883Z", fill: "white" }), /* @__PURE__ */ y.createElement("path", { d: "M10.8547 7.5429C10.524 7.23657 10.0131 7.23657 9.68243 7.5429C9.31416 7.88401 9.31384 8.46633 9.68174 8.80784L13.1206 12L9.68175 15.1922C9.31384 15.5337 9.31416 16.116 9.68243 16.4571C10.0131 16.7634 10.524 16.7634 10.8547 16.4571L14.9802 12.6358C15.3505 12.2928 15.3505 11.7072 14.9802 11.3642L10.8547 7.5429Z", fill: "white" })), O6 = (t) => /* @__PURE__ */ y.createElement("svg", { width: 12, height: 12, viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ y.createElement("path", { d: "M1.62695 1.62598L10.3742 10.3745", stroke: "#6B6F73", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ y.createElement("path", { d: "M1.62695 10.376L10.3742 1.62746", stroke: "#6B6F73", strokeWidth: 1.5, strokeLinecap: "round" })), D6 = (t) => /* @__PURE__ */ y.createElement("svg", { width: 10, height: 10, viewBox: "0 0 10 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ y.createElement("g", { id: "Group 465" }, /* @__PURE__ */ y.createElement("rect", { id: "Rectangle 368", x: 1.25, width: 12.3744, height: 1.76777, rx: 0.883884, transform: "rotate(45 1.25 0)", fill: "white" }), /* @__PURE__ */ y.createElement("rect", { id: "Rectangle 369", y: 8.75, width: 12.3744, height: 1.76777, rx: 0.883884, transform: "rotate(-45 0 8.75)", fill: "white" }))), P6 = (t) => /* @__PURE__ */ y.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ y.createElement("rect", { y: 195312e-8, width: 24, height: 24, rx: 12, fill: "#F80022" }), /* @__PURE__ */ y.createElement("rect", { x: 8.25, y: 7.00195, width: 12.3744, height: 1.76777, rx: 0.883884, transform: "rotate(45 8.25 7.00195)", fill: "white" }), /* @__PURE__ */ y.createElement("rect", { x: 7, y: 15.752, width: 12.3744, height: 1.76777, rx: 0.883884, transform: "rotate(-45 7 15.752)", fill: "white" })), _6 = (t) => /* @__PURE__ */ y.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ y.createElement("g", { id: "Frame" }, /* @__PURE__ */ y.createElement("path", { id: "Vector", d: "M5.79479 6.80154C5.5243 6.53492 5.11861 6.53492 4.84812 6.80154C4.57768 7.06812 4.57768 7.46803 4.84812 7.73465L7.62043 10.6673C7.75567 10.8006 7.95852 10.8672 8.09376 10.8672C8.29661 10.8672 8.49945 10.8006 8.5671 10.6007L15.1936 2.40258C15.3964 2.13598 15.3964 1.66942 15.0583 1.46947C14.8555 1.26951 14.4498 1.26951 14.1793 1.60277L12.827 3.26904C11.6099 2.06932 9.85181 1.33616 8.09376 1.33616C4.37481 1.33616 1.33203 4.33546 1.33203 8.00128C1.33203 11.6671 4.37481 14.6663 8.09376 14.6663C11.8127 14.6663 14.8555 11.6671 14.8555 8.00128C14.8555 7.40141 14.7879 6.80154 14.5851 6.20168C14.4498 5.86843 14.1117 5.66848 13.7736 5.73514C13.4355 5.80176 13.2327 6.20168 13.3003 6.53492C13.4355 7.0015 13.5031 7.5347 13.5031 8.00128C13.5031 10.9339 11.0689 13.3333 8.09376 13.3333C5.11861 13.3333 2.68438 10.9339 2.68438 8.00128C2.68438 5.06861 5.11861 2.66918 8.09376 2.66918C9.58136 2.66918 10.9337 3.26904 12.0156 4.33546L8.09376 9.20096L5.79479 6.80154Z", fill: "white" }))), j6 = (t) => /* @__PURE__ */ y.createElement("svg", { width: 25, height: 24, viewBox: "0 0 25 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ y.createElement("path", { d: "M15.8 22.0002H6C4 22.0002 2.5 20.5002 2.5 18.5002V8.7002C2.5 6.8002 4 5.2002 6 5.2002H15.8C17.7 5.2002 19.3 6.7002 19.3 8.7002V18.5002C19.2 20.5002 17.7 22.0002 15.8 22.0002ZM6 7.3002C5.2 7.3002 4.5 7.9002 4.5 8.7002V18.5002C4.5 19.3002 5.2 20.0002 6 20.0002H15.8C16.6 20.0002 17.3 19.3002 17.3 18.5002V8.7002C17.3 7.9002 16.6 7.2002 15.8 7.2002H6V7.3002Z", fill: "#107D57" }), /* @__PURE__ */ y.createElement("path", { d: "M21.5016 17.9C20.9016 17.9 20.5016 17.5 20.5016 16.9V6.3C20.5016 5 19.5016 4 18.2016 4H7.60157C7.00156 4 6.60156 3.6 6.60156 3C6.60156 2.4 7.00156 2 7.60157 2H18.2016C20.6016 2 22.5016 3.9 22.5016 6.3V16.9C22.5016 17.5 22.1016 17.9 21.5016 17.9Z", fill: "#107D57" })), $6 = (t) => /* @__PURE__ */ y.createElement("svg", { width: 35, height: 35, viewBox: "0 0 35 35", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ y.createElement("g", { id: "Features" }, /* @__PURE__ */ y.createElement("path", { id: "Icon", d: "M29.481 9.15331H24.5286V8.57275C24.5286 8.25228 24.282 7.99219 23.9783 7.99219H10.7717C10.468 7.99219 10.2215 8.25228 10.2215 8.57275V9.15331H5.26902C4.96527 9.15331 4.71875 9.4134 4.71875 9.73388V12.5945C4.71875 16.4366 7.68032 19.5612 11.322 19.5612C11.344 19.5612 11.3627 19.5508 11.3837 19.5484C12.3752 21.1508 13.9204 22.3491 15.7088 22.8205C15.6395 24.2719 15.2884 24.8688 14.2297 26.0183L13.9303 26.3411C12.416 27.9806 11.322 27.9511 11.322 29.2725C11.322 29.5929 11.5685 29.853 11.8723 29.853H22.8777C23.1815 29.853 23.428 29.5929 23.428 29.2725C23.428 27.9511 22.3341 27.9806 20.8197 26.3411L20.5215 26.0172C19.4628 24.8677 19.1117 24.2707 19.0423 22.8193C20.8307 22.3491 22.3759 21.1496 23.3675 19.5473C23.3873 19.5508 23.406 19.5612 23.428 19.5612C27.0697 19.5612 30.0313 16.4366 30.0313 12.5945V9.73388C30.0313 9.4134 29.7848 9.15331 29.481 9.15331ZM5.81929 12.5945V10.3144H10.2215V15.4973C10.2215 16.497 10.4196 17.4584 10.7717 18.342C7.99947 18.0459 5.81929 15.5971 5.81929 12.5945ZM28.9307 12.5945C28.9307 15.5971 26.7506 18.0459 23.9783 18.342C24.3305 17.4596 24.5286 16.4982 24.5286 15.4973V10.3144H28.9307V12.5945Z", fill: "white" }))), q6 = (t) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ y.createElement("g", { id: "CarbonUserAvatar 1" }, /* @__PURE__ */ y.createElement("g", { id: "Group 232" }, /* @__PURE__ */ y.createElement("path", { id: "Vector", d: "M19.9992 14.2861C19.2928 14.2861 18.6023 14.4956 18.015 14.888C17.4277 15.2805 16.9699 15.8382 16.6996 16.4908C16.4293 17.1434 16.3586 17.8615 16.4964 18.5543C16.6342 19.2471 16.9743 19.8835 17.4738 20.3829C17.9733 20.8824 18.6096 21.2226 19.3024 21.3604C19.9952 21.4982 20.7133 21.4274 21.3659 21.1571C22.0185 20.8868 22.5763 20.4291 22.9687 19.8417C23.3611 19.2544 23.5706 18.5639 23.5706 17.8576C23.5706 16.9104 23.1943 16.002 22.5245 15.3322C21.8548 14.6624 20.9464 14.2861 19.9992 14.2861ZM19.9992 20.0004C19.5753 20.0004 19.161 19.8747 18.8087 19.6393C18.4563 19.4038 18.1816 19.0692 18.0194 18.6776C17.8572 18.286 17.8148 17.8552 17.8975 17.4395C17.9802 17.0238 18.1843 16.642 18.4839 16.3423C18.7836 16.0426 19.1654 15.8386 19.5811 15.7559C19.9968 15.6732 20.4276 15.7156 20.8192 15.8778C21.2108 16.04 21.5454 16.3147 21.7809 16.6671C22.0163 17.0194 22.142 17.4337 22.142 17.8576C22.1415 18.4257 21.9155 18.9704 21.5138 19.3722C21.112 19.7739 20.5673 19.9999 19.9992 20.0004Z", fill: "white" }), /* @__PURE__ */ y.createElement("path", { id: "Vector_2", d: "M20 10C18.0222 10 16.0888 10.5865 14.4443 11.6853C12.7998 12.7841 11.5181 14.3459 10.7612 16.1732C10.0043 18.0004 9.8063 20.0111 10.1922 21.9509C10.578 23.8907 11.5304 25.6725 12.9289 27.0711C14.3275 28.4696 16.1093 29.422 18.0491 29.8078C19.9889 30.1937 21.9996 29.9957 23.8268 29.2388C25.6541 28.4819 27.2159 27.2002 28.3147 25.5557C29.4135 23.9112 30 21.9778 30 20C29.997 17.3488 28.9424 14.807 27.0677 12.9323C25.193 11.0576 22.6512 10.003 20 10ZM15.7143 27.4121V26.4286C15.7149 25.8604 15.9408 25.3157 16.3425 24.914C16.7443 24.5122 17.289 24.2863 17.8571 24.2857H22.1429C22.711 24.2863 23.2557 24.5122 23.6575 24.914C24.0592 25.3157 24.2851 25.8604 24.2857 26.4286V27.4121C22.9851 28.1716 21.5061 28.5718 20 28.5718C18.4939 28.5718 17.0149 28.1716 15.7143 27.4121ZM25.7086 26.3757C25.6943 25.4388 25.3126 24.545 24.6457 23.8868C23.9787 23.2287 23.0799 22.8589 22.1429 22.8571H17.8571C16.9201 22.8589 16.0213 23.2287 15.3544 23.8868C14.6874 24.545 14.3057 25.4388 14.2914 26.3757C12.9961 25.2191 12.0827 23.6963 11.672 22.009C11.2614 20.3218 11.3729 18.5495 11.9919 16.927C12.6108 15.3046 13.708 13.9083 15.1381 12.9233C16.5682 11.9382 18.2638 11.4107 20.0004 11.4107C21.7369 11.4107 23.4325 11.9382 24.8626 12.9233C26.2927 13.9083 27.3899 15.3046 28.0088 16.927C28.6278 18.5495 28.7393 20.3218 28.3287 22.009C27.9181 23.6963 27.0039 25.2191 25.7086 26.3757Z", fill: "white" })))), eV = (t) => /* @__PURE__ */ y.createElement("svg", { width: 12, height: 13, viewBox: "0 0 12 13", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ y.createElement("g", { id: "Features" }, /* @__PURE__ */ y.createElement("g", { id: "Icon" }, /* @__PURE__ */ y.createElement("path", { d: "M6.2368 7.85018C6.38779 7.85018 6.49435 7.75233 6.50322 7.59222C6.76084 5.50185 6.85854 5.44848 8.99025 5.09267C9.15897 5.07488 9.25666 4.98592 9.25666 4.8347C9.25666 4.69238 9.15896 4.60343 9.0258 4.57675L8.93118 4.55875C6.87281 4.16737 6.75701 4.14535 6.50322 2.08609C6.49435 1.92597 6.38779 1.82812 6.2368 1.82812C6.10356 1.82812 5.99699 1.92597 5.98805 2.07719C5.71277 4.20315 5.64167 4.26541 3.46555 4.57675C3.3323 4.59454 3.23461 4.69238 3.23461 4.8347C3.23461 4.97703 3.3323 5.07488 3.46555 5.09267L3.53156 5.10562C5.64296 5.51968 5.70672 5.53218 5.98805 7.61001C5.99699 7.75233 6.10356 7.85018 6.2368 7.85018Z", fill: "white", style: {
  fill: "white",
  fillOpacity: 1
} }), /* @__PURE__ */ y.createElement("path", { d: "M7.8622 11.3244C7.9435 11.3244 8.00088 11.2718 8.00566 11.1855C8.14438 10.06 8.19699 10.0312 9.34483 9.83963C9.43568 9.83005 9.48828 9.78216 9.48828 9.70073C9.48828 9.62409 9.43568 9.57619 9.36397 9.56183L9.31302 9.55214C8.20467 9.34139 8.14231 9.32954 8.00566 8.2207C8.00088 8.13449 7.9435 8.0818 7.8622 8.0818C7.79046 8.0818 7.73307 8.13449 7.72826 8.21591C7.58003 9.36066 7.54175 9.39419 6.36999 9.56183C6.29824 9.57141 6.24564 9.62409 6.24564 9.70073C6.24564 9.77736 6.29824 9.83005 6.36999 9.83963L6.40553 9.84661C7.54244 10.0696 7.57678 10.0763 7.72826 11.1951C7.73307 11.2718 7.79046 11.3244 7.8622 11.3244Z", fill: "white", style: {
  fill: "white",
  fillOpacity: 1
} }), /* @__PURE__ */ y.createElement("path", { d: "M2.61901 7.53919C2.61628 7.58846 2.58349 7.61857 2.53703 7.61857C2.49604 7.61857 2.46325 7.58846 2.46049 7.54467C2.37393 6.90533 2.35431 6.90149 1.70465 6.77408L1.68434 6.7701C1.64334 6.76462 1.61328 6.73452 1.61328 6.69073C1.61328 6.64693 1.64334 6.61683 1.68434 6.61135C2.35392 6.51556 2.37579 6.4964 2.46049 5.84226C2.46325 5.79573 2.49604 5.76562 2.53703 5.76562C2.58349 5.76562 2.61628 5.79573 2.61901 5.845C2.6971 6.47862 2.73273 6.48539 3.36607 6.60582L3.39519 6.61135C3.43616 6.61956 3.46622 6.64693 3.46622 6.69073C3.46622 6.73725 3.43616 6.76462 3.38425 6.7701C2.72834 6.87958 2.69828 6.896 2.61901 7.53919Z", fill: "white", style: {
  fill: "white",
  fillOpacity: 1
} })))), tV = (t) => /* @__PURE__ */ y.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ y.createElement("rect", { width: 24, height: 24, rx: 12, fill: "white", fillOpacity: 0.1 }), /* @__PURE__ */ y.createElement("rect", { x: 8.25, y: 7, width: 12.3744, height: 1.76777, rx: 0.883884, transform: "rotate(45 8.25 7)", fill: "white" }), /* @__PURE__ */ y.createElement("rect", { x: 7, y: 15.75, width: 12.3744, height: 1.76777, rx: 0.883884, transform: "rotate(-45 7 15.75)", fill: "white" })), nV = (t) => /* @__PURE__ */ y.createElement("svg", { width: 17, height: 17, viewBox: "0 0 17 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ y.createElement("path", { d: "M9.16683 2.66671H7.16683C5.29999 2.66671 4.36657 2.66671 3.65353 3.03002C3.02632 3.3496 2.51639 3.85953 2.19681 4.48674C1.8335 5.19978 1.8335 6.1332 1.8335 8.00004V9.33337C1.8335 11.2002 1.8335 12.1336 2.19681 12.8467C2.51639 13.4739 3.02632 13.9838 3.65353 14.3034C4.36657 14.6667 5.29999 14.6667 7.16683 14.6667H8.50016C10.367 14.6667 11.3004 14.6667 12.0135 14.3034C12.6407 13.9838 13.1506 13.4739 13.4702 12.8467C13.8335 12.1336 13.8335 11.2002 13.8335 9.33337V7.33337M8.50016 8.00004L15.1668 1.33337M15.1668 1.33337H11.8335M15.1668 1.33337V4.66671", stroke: "#107D57", strokeLinecap: "round", strokeLinejoin: "round" })), iV = (t) => /* @__PURE__ */ y.createElement("svg", { width: 32, height: 32, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ y.createElement("rect", { width: 32, height: 32, rx: 16, fill: "white" }), /* @__PURE__ */ y.createElement("path", { d: "M10.4615 12.6875C9.44231 12.6875 8.61538 13.4665 8.61538 14.4266C8.61538 15.3868 9.44231 16.1658 10.4615 16.1658C11.4808 16.1658 12.3077 15.3868 12.3077 14.4266C12.3077 13.4665 11.4808 12.6875 10.4615 12.6875ZM10.4615 16.1658C9.10817 16.1658 8 17.2097 8 18.4846V19.7527C8 19.7527 8.61538 20.2237 10.4615 20.2237C12.3077 20.2237 12.9231 19.7527 12.9231 19.7527V18.4846C12.9231 17.2097 11.8149 16.1658 10.4615 16.1658ZM21.5385 12.6875C20.5192 12.6875 19.6923 13.4665 19.6923 14.4266C19.6923 15.3868 20.5192 16.1658 21.5385 16.1658C22.5577 16.1658 23.3846 15.3868 23.3846 14.4266C23.3846 13.4665 22.5577 12.6875 21.5385 12.6875ZM21.5385 16.1658C20.1851 16.1658 19.0769 17.2097 19.0769 18.4846V19.7527C19.0769 19.7527 19.6923 20.2237 21.5385 20.2237C23.3846 20.2237 24 19.7527 24 19.7527V18.4846C24 17.2097 22.8918 16.1658 21.5385 16.1658ZM16 15.0063C14.9808 15.0063 14.1538 15.7853 14.1538 16.7455C14.1538 17.7056 14.9808 18.4846 16 18.4846C17.0192 18.4846 17.8462 17.7056 17.8462 16.7455C17.8462 15.7853 17.0192 15.0063 16 15.0063ZM16 18.4846C14.6466 18.4846 13.5385 19.5285 13.5385 20.8034V22.0715C13.5385 22.0715 14.1538 22.5425 16 22.5425C17.8462 22.5425 18.4615 22.0715 18.4615 22.0715V20.8034C18.4615 19.5285 17.3534 18.4846 16 18.4846Z", fill: "#107D57" }), /* @__PURE__ */ y.createElement("path", { opacity: 0.5, d: "M13.3908 9C12.3103 9 11.4336 9.82584 11.4336 10.8437C11.4336 11.8616 12.3103 12.6875 13.3908 12.6875C14.4713 12.6875 15.348 11.8616 15.348 10.8437C15.348 9.82584 14.4713 9 13.3908 9ZM13.3908 12.6875C13.1946 12.6875 12.9958 12.6827 12.7996 12.7451C13.192 13.2372 13.3908 13.8542 13.3908 14.5312C13.3908 14.7761 13.3296 15.0161 13.3296 15.261C13.8521 14.524 14.6956 14.0391 15.6742 13.9166C15.218 13.1796 14.3694 12.6875 13.3908 12.6875ZM18.61 9C17.5295 9 16.6528 9.82584 16.6528 10.8437C16.6528 11.8616 17.5295 12.6875 18.61 12.6875C19.6905 12.6875 20.5672 11.8616 20.5672 10.8437C20.5672 9.82584 19.6905 9 18.61 9ZM18.61 12.6875C17.6314 12.6875 16.7828 13.1796 16.3266 13.9166C17.3052 14.0391 18.1487 14.524 18.6712 15.261C18.6712 15.0161 18.61 14.7761 18.61 14.5312C18.61 13.8542 18.8088 13.2372 19.2012 12.7451C19.005 12.6827 18.8062 12.6875 18.61 12.6875Z", fill: "#107D57" })), sV = (t) => /* @__PURE__ */ y.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ y.createElement("g", { id: "Share" }, /* @__PURE__ */ y.createElement("path", { id: "Vector", d: "M11 4.965V1.125L18 7.845L11 14.565V10.629C6 10.629 2.5 12.165 0 15.525C1 10.725 4 5.925 11 4.965Z", fill: "white" }))), rV = (t) => /* @__PURE__ */ y.createElement("svg", { width: 17, height: 16, viewBox: "0 0 17 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: "sc-ANdsN kTVWJE", ...t }, /* @__PURE__ */ y.createElement("path", { d: "M6.6665 3.16669H4.99984C4.26346 3.16669 3.6665 3.76364 3.6665 4.50002V11.5C3.6665 12.2364 4.26346 12.8334 4.99984 12.8334H11.9998C12.7362 12.8334 13.3332 12.2364 13.3332 11.5V9.83335", stroke: "#ffffff", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ y.createElement("path", { d: "M13.3335 6.16669V3.16669H10.3335", stroke: "#ffffff", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ y.createElement("path", { d: "M13.1668 3.33331L8.3335 8.16665", stroke: "#ffffff", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })), oV = (t) => /* @__PURE__ */ y.createElement("svg", { width: 17, height: 18, viewBox: "0 0 17 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ y.createElement("g", { id: "Group" }, /* @__PURE__ */ y.createElement("path", { id: "Vector", d: "M12.5396 12.431L15.8603 9.00169L12.5396 5.57239", stroke: "#EB5757", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ y.createElement("path", { id: "Vector_2", d: "M15.8602 9.00159H5.57227", stroke: "#EB5757", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ y.createElement("path", { id: "Vector_3", d: "M12.431 1L3.2862 1.00229C2.02422 1.00343 1 2.02651 1 3.28849V14.7138C1 15.3201 1.24087 15.9016 1.66961 16.3304C2.09836 16.7591 2.67987 17 3.2862 17H12.5396", stroke: "#EB5757", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }))), lV = (t) => /* @__PURE__ */ y.createElement("svg", { width: 99, height: 96, viewBox: "0 0 99 96", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ y.createElement("g", { id: "Masters Logo Big" }, /* @__PURE__ */ y.createElement("path", { id: "Vector", d: "M67.4732 4.82378C66.1754 4.41151 64.8776 5.1433 63.5798 5.88539C63.117 6.15337 62.7951 6.60687 62.6844 7.13253L60.6421 16.9035C60.5616 17.2642 60.8836 17.594 61.2357 17.5116C63.3786 17.0065 65.4208 15.0894 67.5738 15.7594C69.9783 16.5118 72.3928 13.3888 74.7972 13.43V2.1543C72.3626 2.1646 69.8776 5.57618 67.4732 4.82378Z", fill: "white" }), /* @__PURE__ */ y.createElement("path", { id: "Vector_2", d: "M98.1678 34.7754C97.6547 34.4147 97.3429 33.8272 97.3429 33.1882V31.4051C97.3429 29.8075 96.0752 28.5089 94.5159 28.5089H93.3891C92.041 28.5089 90.8035 29.1994 90.0691 30.3538L86.4272 36.1153C86.065 36.6822 85.4514 37.0223 84.7974 37.0223H82.3427C81.1253 37.0223 80.0086 37.7026 79.4251 38.8054C78.8215 39.9392 77.7752 40.7225 76.5679 40.9905V0.917313C76.5679 0.412276 76.1756 0 75.6726 0C75.1796 0 74.7772 0.412276 74.7772 0.917313V2.15414V13.4196V41.0111C73.5699 40.7431 72.5236 39.9598 71.92 38.8261C71.3465 37.7232 70.2298 37.043 69.0125 37.043H67.3626C66.0547 37.043 64.8676 37.8366 64.3344 39.0528L62.9661 42.2067C62.7448 42.7014 62.2619 43.0313 61.7287 43.0313C61.1955 43.0313 60.7126 42.7118 60.4913 42.2067L59.123 39.0528C58.5898 37.8263 57.4027 37.0327 56.0948 37.0327H9.52479C9.14249 37.0327 8.84068 37.3419 8.84068 37.7335C8.84068 38.5478 8.18674 39.2177 7.39196 39.2177H5.37986C4.99757 39.2177 4.69575 39.5269 4.69575 39.9186V42.3098C4.69575 44.5567 4.26315 46.7624 3.42813 48.834L2.20075 51.8643C1.05385 54.6884 0.510584 57.5846 0.520645 60.4396V67.4071C0.520645 69.2932 0.782218 71.1897 1.31542 73.0449C2.81444 78.2396 6.20483 82.4963 10.893 85.0215L18.3378 89.0412C18.4384 89.0928 18.539 89.1237 18.6497 89.1237L24.1528 89.1649C25.4405 89.1752 26.7081 89.5153 27.8248 90.1544L30.7826 91.8447C30.8832 91.9065 30.9939 91.9375 31.1146 91.9375H35.0684C36.4567 91.9375 37.825 92.3291 39.0121 93.0609C39.0121 93.0609 40.9437 94.2668 41.5977 94.6585C42.6439 95.2872 43.9116 95.885 46.1148 95.9984C46.6178 96.019 47.1108 95.8438 47.483 95.483C47.8553 95.1223 48.0666 94.6172 48.0666 94.0916V91.3809C48.0666 89.4123 49.2034 87.6292 50.964 86.8355L57.0003 84.1145C57.8252 83.7435 58.7508 83.6816 59.6059 83.9496L61.8595 84.6402C62.8152 84.9288 63.8313 84.9391 64.7972 84.6402L70.1493 83.0117C70.8636 82.7952 71.6081 82.7952 72.3325 83.022L74.5055 83.6507C75.5216 83.9496 76.2259 84.8979 76.2259 85.9801V91.4118C76.2259 93.937 78.238 95.9984 80.7028 95.9984C82.5439 95.9984 84.1636 94.7822 84.7169 92.9888C85.723 89.7421 86.2361 86.3614 86.2361 82.9499V80.6411C86.2361 79.0023 86.9001 77.415 88.0671 76.2916L90.2905 74.1375C91.7895 72.6739 92.6547 70.6228 92.6547 68.4996V55.616C92.6547 53.6164 93.2382 51.6994 94.3549 50.0606C94.4354 49.9472 94.4756 49.8029 94.4756 49.6586V46.6284C94.4756 44.6494 95.0591 42.7324 96.1557 41.1039L98.359 37.8263C98.4395 37.7129 98.4797 37.5686 98.4797 37.4346V35.3732C98.4797 34.9713 98.2584 34.8373 98.1678 34.7754ZM74.7872 69.2211C73.2882 68.9943 72.1816 68.2007 72.1816 67.2628C72.1816 66.3248 73.2882 65.5312 74.7872 65.3045V69.2211ZM76.5679 65.2941C78.0669 65.5209 79.1736 66.3145 79.1736 67.2525C79.1736 68.1904 78.0669 68.984 76.5679 69.2108V65.2941ZM12.6637 84.3928L11.5268 83.7847C8.45838 82.1356 6.00362 79.6619 4.32351 76.673V72.9109C6.24507 75.7556 8.85074 78.1881 12.05 79.9093L12.6637 80.2391V84.3928ZM18.3478 87.4643L15.3398 85.8461V81.6924L18.3378 83.3106H18.3478V87.4643ZM30.8832 90.2987L28.4989 88.9382C27.2011 88.1961 25.7322 87.7941 24.2534 87.7735V83.4343C25.5009 83.4652 26.7383 83.795 27.8349 84.4237L30.7927 86.1141C30.8229 86.1347 30.853 86.1244 30.8832 86.1347V90.2987ZM46.6983 91.3706V93.4835V94.0813C46.6983 94.2256 46.638 94.3596 46.5474 94.4523C46.4468 94.5451 46.3261 94.5966 46.1953 94.5863C44.2939 94.4833 43.1973 93.9782 42.3019 93.432C41.658 93.0403 39.7365 91.8447 39.7264 91.8447C38.5191 91.1026 37.161 90.68 35.7626 90.577V86.2377C36.9095 86.3408 38.0262 86.7016 39.0222 87.3097L40.6821 88.33C42.5031 89.4535 44.5756 90.0925 46.6983 90.2059V91.3706ZM63.1372 83.4446C62.8354 83.424 62.5436 83.3827 62.2519 83.3003L59.9983 82.6097C59.5154 82.4654 59.0124 82.4036 58.5194 82.4036V78.0644C58.8816 78.0644 59.2538 78.1056 59.6059 78.2087L61.8595 78.8992C62.272 79.0229 62.7046 79.0848 63.1372 79.1054V83.4446ZM77.2923 84.4959C76.8597 83.4549 75.9945 82.62 74.8878 82.3005L72.7248 81.6718C72.2117 81.5069 71.6785 81.445 71.1453 81.4554V77.1265C71.5578 77.1161 71.9703 77.1677 72.3727 77.3017L74.1534 77.8789C76.0347 78.487 77.3024 80.2494 77.3024 82.2696V84.4959H77.2923ZM83.5197 92.1848C83.4795 92.3085 83.4594 92.4322 83.4191 92.5559C83.0368 93.7721 81.9503 94.5863 80.7028 94.5863C80.5921 94.5863 80.4815 94.5657 80.3708 94.5554V90.2265C80.4513 90.2368 80.5318 90.2471 80.6223 90.2471C81.8396 90.2471 82.9362 89.5463 83.5197 88.495V92.1848ZM95.1799 38.0118C93.8217 40.032 93.1074 42.4025 93.1074 44.8556V46.9994L92.051 48.5661C90.6828 50.5965 89.9484 52.9774 89.9484 55.4408V66.2218C89.9484 67.9739 89.2442 69.6643 88.0067 70.8702L85.7834 73.0346C84.2944 74.4879 83.4694 76.539 83.5298 78.6519L83.5399 79.1363C83.6203 81.9398 83.2682 84.7226 82.5137 87.4127C82.2722 88.2682 81.4976 88.866 80.6223 88.866C79.5358 88.866 78.6605 87.959 78.6605 86.8562V82.2696C78.6605 79.631 77.0106 77.3326 74.5558 76.539L72.7751 75.9618C71.7892 75.6423 70.753 75.6423 69.767 75.9412L64.4149 77.5697C63.7106 77.7861 62.9661 77.7861 62.2519 77.5697L59.9983 76.8791C58.8313 76.5183 57.5637 76.6008 56.4469 77.1058L51.6883 79.2497C48.6501 80.6102 46.6883 83.6919 46.6883 87.0932V88.8454C44.817 88.732 42.986 88.1548 41.3763 87.1654L39.7163 86.145C38.3079 85.2792 36.7083 84.8257 35.0684 84.8257H31.3058L28.5089 83.2281C27.191 82.4757 25.692 82.0635 24.1729 82.0532L18.8307 82.0119L12.6938 78.7034C3.38789 73.653 -0.58601 62.367 3.45831 52.4208L4.68569 49.3906C5.6012 47.1437 6.06398 44.7628 6.06398 42.3304V40.6401H7.39196C8.70989 40.6401 9.81654 39.7021 10.1284 38.455H56.0948C56.8594 38.455 57.5637 38.9188 57.8755 39.6403L59.2438 42.7942C59.6764 43.8043 60.6522 44.4536 61.7287 44.4536C62.8052 44.4536 63.781 43.8043 64.2136 42.8045L65.5819 39.6506C65.8938 38.9291 66.5879 38.4653 67.3626 38.4653H69.0125C69.7268 38.4653 70.3807 38.8673 70.7228 39.5063C71.5679 41.1039 73.0769 42.1758 74.7872 42.4541V62.2639C72.0307 62.5731 69.918 64.2532 69.918 66.3042C69.918 68.5614 72.4934 70.3961 75.6726 70.3961C78.8517 70.3961 81.4272 68.5614 81.4272 66.3042C81.4272 64.2635 79.3145 62.5731 76.5579 62.2639V42.4438C78.2682 42.1655 79.7772 41.0936 80.6223 39.496C80.9644 38.857 81.6183 38.455 82.3326 38.455H84.7874C85.9141 38.455 86.9504 37.8778 87.5641 36.909L91.206 31.1371C91.6889 30.3847 92.4937 29.9312 93.379 29.9312H94.5058C95.3106 29.9312 95.9646 30.6012 95.9646 31.4257V33.2088C95.9646 34.0746 96.2865 34.8888 96.86 35.4969L95.1799 38.0118Z", fill: "white" }))), aV = (t) => /* @__PURE__ */ y.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ y.createElement("path", { d: "M2.25 10.0514C2.25 8.97447 3.12304 8.10142 4.2 8.10142H6.91992C7.2891 8.10142 7.64086 7.94446 7.88744 7.66971L10.4825 4.77808C11.2789 3.8907 12.75 4.45403 12.75 5.64636V18.3565C12.75 19.5488 11.2789 20.1121 10.4825 19.2248L7.88744 16.3331C7.64086 16.0584 7.2891 15.9014 6.91992 15.9014H4.2C3.12304 15.9014 2.25 15.0284 2.25 13.9514V10.0514Z", fill: "white", style: {
  fill: "white",
  fillOpacity: 1
} }), /* @__PURE__ */ y.createElement("path", { d: "M18.0226 12.5545L19.8749 14.4067C20.1678 14.6996 20.6427 14.6996 20.9356 14.4067C21.2284 14.1138 21.2284 13.6389 20.9355 13.346L19.0833 11.4939L20.9355 9.64182C21.2284 9.34894 21.2284 8.87406 20.9356 8.58116C20.6427 8.28825 20.1678 8.28824 19.8749 8.58112L18.0226 10.4333L16.1703 8.58112C15.8774 8.28824 15.4025 8.28825 15.1096 8.58116C14.8167 8.87406 14.8167 9.34894 15.1096 9.64182L16.9619 11.4939L15.1096 13.346C14.8167 13.6389 14.8167 14.1138 15.1096 14.4067C15.4025 14.6996 15.8774 14.6996 16.1703 14.4067L18.0226 12.5545Z", fill: "white", style: {
  fill: "white",
  fillOpacity: 1
} })), cV = (t) => /* @__PURE__ */ y.createElement("svg", { width: 48, height: 48, viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ y.createElement("circle", { opacity: 0.5, cx: 24, cy: 24, r: 24, fill: "black", style: {
  fill: "black",
  fillOpacity: 1
} }), /* @__PURE__ */ y.createElement("rect", { x: 18, y: 13.999, width: 4, height: 20, rx: 1, fill: "white", style: {
  fill: "white",
  fillOpacity: 1
} }), /* @__PURE__ */ y.createElement("rect", { x: 26, y: 13.999, width: 4, height: 20, rx: 1, fill: "white", style: {
  fill: "white",
  fillOpacity: 1
} })), uV = (t) => /* @__PURE__ */ y.createElement("svg", { width: 48, height: 48, viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ y.createElement("circle", { opacity: 0.5, cx: 24, cy: 24.001, r: 24, fill: "black" }), /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M32.5432 24.7938C33.215 24.3331 33.2822 23.5173 32.5432 23.0567C23.7807 17.6245 19.6442 14.918 19.1356 14.5917C18.3486 14.083 17.6 14.6973 17.6 15.2059V32.7501C17.6 33.3259 18.5309 33.8442 19.1356 33.4795C20.2201 32.8172 31.8714 25.2641 32.5336 24.8034L32.5432 24.7938Z", fill: "white" })), hV = (t) => /* @__PURE__ */ y.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ y.createElement("path", { d: "M18.5625 5.0625V18.9375M15.6454 11.3897L7.18592 5.3471C6.68953 4.99253 6 5.34737 6 5.95739L6 18.0426C6 18.6526 6.68953 19.0075 7.18592 18.6529L15.6454 12.6103C16.0642 12.3112 16.0642 11.6888 15.6454 11.3897Z", stroke: "white", style: {
  stroke: "white",
  strokeOpacity: 1
}, strokeWidth: 1.25, strokeLinecap: "round", strokeLinejoin: "round" })), dV = (t) => /* @__PURE__ */ y.createElement("svg", { width: 16, height: 15, viewBox: "0 0 16 15", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ y.createElement("path", { id: "Start - You", d: "M8 0L9.79611 5.52786H15.6085L10.9062 8.94427L12.7023 14.4721L8 11.0557L3.29772 14.4721L5.09383 8.94427L0.391548 5.52786H6.20389L8 0Z", fill: "#F4D22A" })), mV = (t) => /* @__PURE__ */ y.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 22, height: 22, viewBox: "0 0 22 22", fill: "none", ...t }, /* @__PURE__ */ y.createElement("path", { d: "M5.5 2.78867V12.4137C5.5 13.1729 4.88426 13.75 4.125 13.75H1.375C0.615742 13.75 0 13.1343 0 12.4137V2.82734C0 2.06808 0.615742 1.49102 1.375 1.49102H4.125C4.88555 1.41367 5.5 1.99375 5.5 2.78867ZM22 12.3707C22 13.5094 21.077 14.4323 19.9375 14.4323H13.6426C14.621 16.0613 15.1259 17.9077 15.1259 18.5582C15.125 19.5714 14.3301 20.625 12.998 20.625C10.2854 20.625 11.8654 17.3529 8.34883 14.5406L7.64844 13.982C7.14141 13.5738 6.88359 12.9766 6.8793 12.375C6.87829 12.374 6.8793 12.375 6.8793 12.375L6.875 5.5C6.875 4.85117 7.18064 4.23973 7.7 3.85043L9.16695 2.75086C10.3555 1.85625 11.8035 1.375 13.2902 1.375H15.8125C16.952 1.375 17.875 2.29754 17.875 3.43664C17.875 3.59283 17.8544 3.74357 17.8215 3.88996C18.6484 4.15937 19.25 4.92422 19.25 5.84375C19.25 6.23683 19.1341 6.60043 18.9432 6.91281C19.8988 7.08984 20.625 7.92773 20.625 8.9332C20.625 9.47031 20.4148 9.955 20.0784 10.322C21.1492 10.3941 22 11.2793 22 12.3707Z", fill: "white" })), pV = (t) => /* @__PURE__ */ y.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ y.createElement("path", { d: "M17.4777 8.95762C17.4777 8.70612 17.4177 8.47012 17.3172 8.25562C16.6467 6.09262 13.5077 6.25062 9.04275 6.14512C8.29625 6.12762 8.72325 5.24612 8.98525 3.31112C9.15575 2.05262 8.34425 0.120117 6.98025 0.120117C4.73125 0.120117 6.89475 1.89412 4.90625 6.28112C3.84375 8.62512 1.46875 7.31212 1.46875 9.66662V15.0261C1.46875 15.9426 1.55875 16.8236 2.84775 16.9686C4.09725 17.1091 3.81625 17.9996 5.61875 17.9996H14.6407C15.5597 17.9996 16.3072 17.2516 16.3072 16.3326C16.3072 15.9516 16.1737 15.6046 15.9582 15.3236C16.4682 15.0381 16.8182 14.4991 16.8182 13.8741C16.8182 13.4941 16.6852 13.1471 16.4702 12.8666C16.9817 12.5816 17.3327 12.0421 17.3327 11.4161C17.3327 10.9616 17.1487 10.5496 16.8522 10.2481C17.2307 9.94262 17.4777 9.48062 17.4777 8.95762Z", fill: "white" }), /* @__PURE__ */ y.createElement("path", { d: "M11.5088 10.625H15.8108C16.3958 10.625 16.9448 10.312 17.2438 9.80849C17.3668 9.60099 17.2983 9.33249 17.0903 9.20899C16.8828 9.08549 16.6143 9.15499 16.4908 9.36249C16.3493 9.60199 16.0878 9.74999 15.8103 9.74999H11.4053C10.9688 9.74999 10.6138 9.39499 10.6138 8.95849C10.6138 8.52199 10.9688 8.16699 11.4053 8.16699H14.3488C14.5903 8.16699 14.7863 7.97099 14.7863 7.72949C14.7863 7.48799 14.5903 7.29199 14.3488 7.29199H11.4048C10.4858 7.29199 9.73828 8.03949 9.73828 8.95849C9.73828 9.47099 9.97578 9.92449 10.3408 10.2305C10.0333 10.533 9.84178 10.953 9.84178 11.417C9.84178 11.931 10.0808 12.386 10.4478 12.6915C10.1423 12.9935 9.95278 13.412 9.95278 13.875C9.95278 14.435 10.2323 14.929 10.6573 15.2315C10.3953 15.526 10.2313 15.9095 10.2313 16.3335C10.2313 17.2525 10.9788 18 11.8978 18H14.6398C15.2248 18 15.7743 17.6875 16.0733 17.184C16.1968 16.9765 16.1283 16.708 15.9208 16.5845C15.7128 16.462 15.4443 16.5295 15.3213 16.737C15.1788 16.9765 14.9173 17.125 14.6398 17.125H11.8978C11.4613 17.125 11.1063 16.77 11.1063 16.3335C11.1063 15.897 11.4613 15.542 11.8978 15.542H15.1508C15.7358 15.542 16.2858 15.229 16.5843 14.7255C16.7078 14.5175 16.6393 14.249 16.4318 14.126C16.2223 14.0005 15.9548 14.071 15.8323 14.2785C15.6878 14.522 15.4328 14.667 15.1508 14.667H11.6193C11.1828 14.667 10.8278 14.3115 10.8278 13.875C10.8278 13.4385 11.1828 13.0835 11.6193 13.0835H15.6648C16.2498 13.0835 16.7993 12.771 17.0983 12.2675C17.2218 12.06 17.1533 11.7915 16.9458 11.668C16.7373 11.545 16.4693 11.613 16.3463 11.8205C16.2018 12.0635 15.9468 12.2085 15.6648 12.2085H11.5088C11.0723 12.2085 10.7173 11.8535 10.7173 11.417C10.7173 10.9805 11.0718 10.625 11.5088 10.625Z", fill: "#107D57" })), gV = (t) => /* @__PURE__ */ y.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ y.createElement("g", { id: "Trivia" }, /* @__PURE__ */ y.createElement("rect", { id: "Rectangle 328", x: 0.56009, y: 2.8074, width: 16.55, height: 16.55, rx: 2.14375, transform: "rotate(-7.80777 0.56009 2.8074)", stroke: "#006747", style: {
  stroke: "#006747",
  stroke: "color(display-p3 0.0000 0.4039 0.2784)",
  strokeOpacity: 1
}, strokeWidth: 1.4 }), /* @__PURE__ */ y.createElement("path", { id: "Union", fillRule: "evenodd", clipRule: "evenodd", d: "M9.62237 4.17188C10.5053 4.17188 11.2837 4.37793 11.8733 4.76716L11.8732 4.76718C12.5572 5.21938 12.9636 5.89049 13.0796 6.75908C13.2656 8.14856 12.2625 9.08727 11.5284 9.77271C11.2207 10.0589 10.956 10.3079 10.8501 10.5183C10.7752 10.6652 10.7366 10.8269 10.6992 10.9839C10.698 10.989 10.6967 10.994 10.6955 10.9991L10.6952 11.0004C10.5952 11.4278 10.4915 11.8706 9.72822 11.9721C9.67385 11.9793 9.6209 11.9821 9.56938 11.9821C9.28746 11.9821 9.03705 11.8777 8.84673 11.6788C8.67931 11.5056 8.56912 11.2738 8.53621 11.0234C8.40767 10.0551 9.08301 9.37328 9.68028 8.77031L9.68384 8.76671C10.2176 8.23011 10.7199 7.72213 10.6354 7.08534C10.5496 6.43425 10.1275 6.07652 9.44917 6.07652C9.35902 6.07652 9.26601 6.08367 9.1687 6.09655C8.22588 6.22243 8.06263 6.74456 7.88952 7.29821L7.88941 7.29854C7.73775 7.78506 7.58034 8.28732 6.85055 8.38463C6.79188 8.39178 6.73178 8.39608 6.6731 8.39608C6.1279 8.39608 5.72868 8.05407 5.65856 7.52462C5.56127 6.80772 5.86319 6.0307 6.48137 5.39534C7.0924 4.77002 7.94814 4.34216 8.8296 4.22482C9.09577 4.19048 9.36193 4.17188 9.62237 4.17188ZM9.88998 12.7224C9.94722 12.7152 10.0059 12.7109 10.0631 12.7109C10.7228 12.7109 11.2866 13.2032 11.3753 13.8586C11.4697 14.5812 10.9618 15.2466 10.2391 15.3439C10.1804 15.3511 10.1218 15.3554 10.0645 15.3554C9.40485 15.3554 8.84107 14.8617 8.75378 14.2077C8.65791 13.4851 9.16732 12.8197 9.88998 12.7224Z", fill: "#006747", style: {
  fill: "#006747",
  fill: "color(display-p3 0.0000 0.4039 0.2784)",
  fillOpacity: 1
} }))), fV = (t) => /* @__PURE__ */ y.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ y.createElement("path", { d: "M20.6087 5.32569H17.087V4.91284C17.087 4.68495 16.9117 4.5 16.6957 4.5H7.30435C7.08835 4.5 6.91305 4.68495 6.91305 4.91284V5.32569H3.3913C3.1753 5.32569 3 5.51064 3 5.73853V7.77273C3 10.5049 5.106 12.7269 7.69566 12.7269C7.71131 12.7269 7.72462 12.7194 7.73948 12.7178C8.44462 13.8572 9.5434 14.7093 10.8151 15.0446C10.7658 16.0767 10.5162 16.5012 9.76331 17.3186L9.55044 17.5481C8.47357 18.714 7.69566 18.693 7.69566 19.6326C7.69566 19.8605 7.87096 20.0455 8.08696 20.0455H15.9131C16.1291 20.0455 16.3044 19.8605 16.3044 19.6326C16.3044 18.693 15.5265 18.714 14.4496 17.5481L14.2375 17.3178C13.4846 16.5003 13.235 16.0759 13.1857 15.0437C14.4574 14.7093 15.5562 13.8564 16.2613 12.717C16.2754 12.7194 16.2887 12.7269 16.3044 12.7269C18.894 12.7269 21 10.5049 21 7.77273V5.73853C21 5.51064 20.8247 5.32569 20.6087 5.32569ZM3.78261 7.77273V6.15138H6.91305V9.83695C6.91305 10.5479 7.05392 11.2315 7.30435 11.8599C5.33296 11.6493 3.78261 9.90796 3.78261 7.77273ZM20.2174 7.77273C20.2174 9.90796 18.6671 11.6493 16.6957 11.8599C16.9461 11.2324 17.087 10.5487 17.087 9.83695V6.15138H20.2174V7.77273Z", fill: "#107D57", style: {
  fill: "#107D57",
  fill: "color(display-p3 0.0627 0.4902 0.3412)",
  fillOpacity: 1
} })), bV = (t) => /* @__PURE__ */ y.createElement("svg", { width: 12, height: 12, viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ y.createElement("g", { id: "Trophy" }, /* @__PURE__ */ y.createElement("path", { id: "Combined Shape", fillRule: "evenodd", clipRule: "evenodd", d: "M2.76916 3.50002C2.76916 4.49786 2.94705 5.38348 3.30282 6.15692C2.62493 6.01847 2.05883 5.74872 1.6045 5.34768C1.15017 4.94663 0.923008 4.55992 0.923008 4.18752V3.50002H2.76916ZM11.0768 3.50002V4.18752C11.0768 4.55992 10.8497 4.94663 10.3953 5.34768C9.941 5.74872 9.3749 6.01847 8.69701 6.15692C9.05278 5.38348 9.23066 4.49786 9.23066 3.50002H11.0768ZM12 4.1875V3.27083C12 3.07986 11.9327 2.91754 11.7981 2.78385C11.6635 2.65017 11.5 2.58333 11.3077 2.58333H9.23077V1.89583C9.23077 1.58073 9.11779 1.31098 8.89183 1.08659C8.66586 0.862195 8.39423 0.75 8.07692 0.75H3.92308C3.60577 0.75 3.33414 0.862195 3.10817 1.08659C2.88221 1.31098 2.76923 1.58073 2.76923 1.89583V2.58333H0.692308C0.499999 2.58333 0.336539 2.65017 0.201923 2.78385C0.067307 2.91754 0 3.07986 0 3.27083V4.1875C0 4.52648 0.0997586 4.86784 0.299279 5.21159C0.498799 5.55534 0.768027 5.86567 1.10697 6.14258C1.44592 6.41949 1.86178 6.65223 2.35457 6.84082C2.84736 7.02941 3.36538 7.13563 3.90865 7.15951C4.11058 7.41732 4.33894 7.6441 4.59375 7.83984C4.77644 8.00217 4.90264 8.17524 4.97236 8.35905C5.04207 8.54286 5.07692 8.75651 5.07692 9C5.07692 9.25781 5.00361 9.47504 4.85697 9.65169C4.71034 9.82834 4.47596 9.91667 4.15385 9.91667C3.79327 9.91667 3.47236 10.0253 3.19111 10.2425C2.90985 10.4597 2.76923 10.7331 2.76923 11.0625V11.5208C2.76923 11.5877 2.79087 11.6426 2.83413 11.6855C2.8774 11.7285 2.93269 11.75 3 11.75H9C9.06731 11.75 9.1226 11.7285 9.16586 11.6855C9.20913 11.6426 9.23077 11.5877 9.23077 11.5208V11.0625C9.23077 10.7331 9.09015 10.4597 8.80889 10.2425C8.52764 10.0253 8.20673 9.91667 7.84615 9.91667C7.52404 9.91667 7.28966 9.82834 7.14303 9.65169C6.99639 9.47504 6.92308 9.25781 6.92308 9C6.92308 8.75651 6.95793 8.54286 7.02764 8.35905C7.09736 8.17524 7.22356 8.00217 7.40625 7.83984C7.66106 7.6441 7.88942 7.41732 8.09135 7.15951C8.63462 7.13563 9.15264 7.02941 9.64543 6.84082C10.1382 6.65223 10.5541 6.41949 10.893 6.14258C11.232 5.86567 11.5012 5.55534 11.7007 5.21159C11.9002 4.86784 12 4.52648 12 4.1875ZM5.07033 5.38491L6.0383 4.87503L7.00627 5.38491L6.8214 4.30497L7.60451 3.54016L6.52228 3.3826L6.0383 2.40003L5.55431 3.3826L4.47209 3.54016L5.25519 4.30497L5.07033 5.38491Z", fill: "white" }))), AV = (t) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 39, viewBox: "0 0 40 39", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ y.createElement("rect", { x: 0.796875, width: 38.4, height: 38.4, rx: 19.2, fill: "#FFB600" }), /* @__PURE__ */ y.createElement("path", { d: "M31.2752 10.8509H26.5795V10.3005C26.5795 9.99661 26.3458 9.75 26.0578 9.75H13.536C13.248 9.75 13.0143 9.99661 13.0143 10.3005V10.8509H8.31861C8.03061 10.8509 7.79688 11.0975 7.79688 11.4014V14.1136C7.79688 17.7566 10.6049 20.7192 14.0578 20.7192C14.0786 20.7192 14.0964 20.7092 14.1162 20.707C15.0564 22.2263 16.5214 23.3625 18.2171 23.8094C18.1513 25.1856 17.8185 25.7516 16.8146 26.8415L16.5308 27.1475C15.095 28.702 14.0578 28.674 14.0578 29.9268C14.0578 30.2307 14.2915 30.4773 14.5795 30.4773H25.0143C25.3023 30.4773 25.536 30.2307 25.536 29.9268C25.536 28.674 24.4988 28.702 23.063 27.1475L22.7802 26.8404C21.7764 25.7505 21.4435 25.1845 21.3778 23.8083C23.0734 23.3625 24.5385 22.2252 25.4786 20.7059C25.4974 20.7092 25.5152 20.7192 25.536 20.7192C28.9889 20.7192 31.7969 17.7566 31.7969 14.1136V11.4014C31.7969 11.0975 31.5632 10.8509 31.2752 10.8509ZM8.84035 14.1136V11.9518H13.0143V16.8659C13.0143 17.8138 13.2021 18.7254 13.536 19.5632C10.9075 19.2825 8.84035 16.9606 8.84035 14.1136ZM30.7534 14.1136C30.7534 16.9606 28.6863 19.2825 26.0578 19.5632C26.3917 18.7265 26.5795 17.8149 26.5795 16.8659V11.9518H30.7534V14.1136Z", fill: "white" })), VV = (t) => /* @__PURE__ */ y.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ y.createElement("g", { id: "Trophy" }, /* @__PURE__ */ y.createElement("path", { id: "Combined Shape", fillRule: "evenodd", clipRule: "evenodd", d: "M3.69197 4.66662C3.69197 5.99705 3.92914 7.17787 4.4035 8.20912C3.49966 8.02451 2.74487 7.66486 2.1391 7.13014C1.53333 6.59542 1.23046 6.0798 1.23046 5.58328V4.66662H3.69197ZM14.7686 4.66662V5.58328C14.7686 6.0798 14.4658 6.59542 13.86 7.13014C13.2542 7.66486 12.4994 8.02451 11.5956 8.20912C12.0699 7.17787 12.3071 5.99705 12.3071 4.66662H14.7686ZM15.9998 5.58329V4.36108C15.9998 4.10645 15.9101 3.89002 15.7306 3.71178C15.5511 3.53354 15.3332 3.44442 15.0768 3.44442H12.3076V2.52776C12.3076 2.10763 12.1569 1.74797 11.8556 1.44878C11.5544 1.14959 11.1922 1 10.7691 1H5.23072C4.80764 1 4.44547 1.14959 4.14419 1.44878C3.84291 1.74797 3.69227 2.10763 3.69227 2.52776V3.44442H0.923068C0.666659 3.44442 0.448714 3.53354 0.269228 3.71178C0.0897418 3.89002 0 4.10645 0 4.36108V5.58329C0 6.03525 0.13301 6.49039 0.399034 6.94872C0.665059 7.40705 1.02403 7.82082 1.47595 8.19003C1.92787 8.55924 2.48234 8.86957 3.13939 9.12101C3.79644 9.37246 4.48713 9.51409 5.21149 9.54592C5.48071 9.88967 5.7852 10.192 6.12494 10.453C6.36853 10.6695 6.53679 10.9002 6.62974 11.1453C6.72269 11.3904 6.76916 11.6752 6.76916 11.9999C6.76916 12.3436 6.67141 12.6333 6.4759 12.8688C6.28038 13.1043 5.96789 13.2221 5.53841 13.2221C5.05764 13.2221 4.62976 13.3669 4.25476 13.6566C3.87977 13.9462 3.69227 14.3106 3.69227 14.7499V15.361C3.69227 15.4501 3.72112 15.5233 3.77881 15.5806C3.8365 15.6379 3.91022 15.6665 3.99996 15.6665H11.9999C12.0896 15.6665 12.1633 15.6379 12.221 15.5806C12.2787 15.5233 12.3076 15.4501 12.3076 15.361V14.7499C12.3076 14.3106 12.1201 13.9462 11.7451 13.6566C11.3701 13.3669 10.9422 13.2221 10.4614 13.2221C10.0319 13.2221 9.71945 13.1043 9.52394 12.8688C9.32843 12.6333 9.23068 12.3436 9.23068 11.9999C9.23068 11.6752 9.27715 11.3904 9.3701 11.1453C9.46305 10.9002 9.63131 10.6695 9.8749 10.453C10.2146 10.192 10.5191 9.88967 10.7884 9.54592C11.5127 9.51409 12.2034 9.37246 12.8604 9.12101C13.5175 8.86957 14.072 8.55924 14.5239 8.19003C14.9758 7.82082 15.3348 7.40705 15.6008 6.94872C15.8668 6.49039 15.9998 6.03525 15.9998 5.58329ZM6.76047 7.1798L8.05109 6.49997L9.3417 7.1798L9.09521 5.73989L10.1393 4.72015L8.69639 4.51007L8.05109 3.2L7.40578 4.51007L5.96283 4.72015L7.00696 5.73989L6.76047 7.1798Z", fill: "#F2C94C" }))), RV = (t) => /* @__PURE__ */ y.createElement("svg", { width: 14, height: 14, viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.9234 2.06117C12.6527 2.79041 12.797 3.88306 12.3564 4.75616L12.3698 4.78833C13.2984 5.09432 13.9688 5.96888 13.9688 7C13.9688 8.03112 13.2984 8.90568 12.3698 9.21167L12.3565 9.24364C12.7971 10.1167 12.6527 11.2094 11.9235 11.9386C11.1944 12.6678 10.1019 12.8122 9.22883 12.3718L9.19604 12.3854C8.89006 13.314 8.0155 13.9844 6.98438 13.9844C5.95325 13.9844 5.07869 13.314 4.77271 12.3854L4.74027 12.3719C3.8673 12.8121 2.77506 12.6676 2.04603 11.9386C1.31703 11.2096 1.17255 10.1174 1.61259 9.24445L1.59899 9.21167C0.670333 8.90568 0 8.03112 0 7C0 5.96888 0.670334 5.09432 1.59899 4.78833L1.61267 4.75535C1.17263 3.8824 1.31711 2.79023 2.04611 2.06123C2.77519 1.33215 3.86754 1.18772 4.74054 1.62795L4.77271 1.61461C5.07869 0.685958 5.95325 0.015625 6.98438 0.015625C8.0155 0.015625 8.89006 0.685958 9.19604 1.61461L9.22857 1.6281C10.1016 1.18761 11.1942 1.33196 11.9234 2.06117ZM9.80606 4.98029C9.97643 4.7077 9.89356 4.34862 9.62098 4.17825C9.34839 4.00788 8.98931 4.09075 8.81894 4.36333L6.29655 8.39915L5.06781 7.17041C4.84051 6.94311 4.47199 6.94311 4.24469 7.17041C4.01739 7.39771 4.01739 7.76623 4.24469 7.99353L5.99079 9.73962C6.11621 9.86504 6.29197 9.92642 6.4682 9.90635C6.64444 9.88628 6.8019 9.78695 6.89591 9.63654L9.80606 4.98029Z", fill: "#0092E9" })), EV = (t) => /* @__PURE__ */ y.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.3616 7.95688C15.7313 7.77023 16.1824 7.91869 16.3691 8.28847C16.9328 9.40532 17.25 10.6674 17.25 12.0014C17.25 13.3354 16.9328 14.5975 16.3691 15.7144C16.1824 16.0841 15.7313 16.2326 15.3616 16.0459C14.9918 15.8593 14.8433 15.4082 15.03 15.0385C15.4903 14.1264 15.75 13.0953 15.75 12.0014C15.75 10.9075 15.4903 9.87641 15.03 8.96438C14.8433 8.5946 14.9918 8.14353 15.3616 7.95688Z", fill: "white", style: {
  fill: "white",
  fillOpacity: 1
} }), /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.507 5.93713C18.87 5.73776 19.326 5.87048 19.5254 6.23356C20.4656 7.94589 21 9.91236 21 12.0014C21 14.0905 20.4656 16.057 19.5254 17.7693C19.326 18.1324 18.87 18.2651 18.507 18.0657C18.1439 17.8663 18.0112 17.4104 18.2105 17.0473C19.0323 15.5506 19.5 13.8318 19.5 12.0014C19.5 10.1711 19.0323 8.45221 18.2105 6.95552C18.0112 6.59244 18.1439 6.13649 18.507 5.93713Z", fill: "white", style: {
  fill: "white",
  fillOpacity: 1
} }), /* @__PURE__ */ y.createElement("path", { d: "M2.25 10.0514C2.25 8.97447 3.12304 8.10142 4.2 8.10142H6.91992C7.2891 8.10142 7.64086 7.94446 7.88744 7.66971L10.4825 4.77808C11.2789 3.8907 12.75 4.45403 12.75 5.64636V18.3565C12.75 19.5488 11.2789 20.1122 10.4825 19.2248L7.88744 16.3331C7.64086 16.0584 7.2891 15.9014 6.91992 15.9014H4.2C3.12304 15.9014 2.25 15.0284 2.25 13.9514V10.0514Z", fill: "white", style: {
  fill: "white",
  fillOpacity: 1
} })), yV = (t) => /* @__PURE__ */ y.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ y.createElement("g", { id: "Chevron Up" }, /* @__PURE__ */ y.createElement("path", { id: "Vector", d: "M4 9.6001L8 5.6001L12 9.6001", stroke: "#107D57", strokeWidth: 1.25, strokeLinecap: "round", strokeLinejoin: "round" }))), CV = (t) => /* @__PURE__ */ y.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ y.createElement("g", { id: "cross" }, /* @__PURE__ */ y.createElement("path", { id: "Vector", d: "M6 18L18 6M6 6L18 18", stroke: "#BA0C2F", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }))), WV = (t) => /* @__PURE__ */ y.createElement("svg", { width: 25, height: 24, viewBox: "0 0 25 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ y.createElement("g", { id: "Friends" }, /* @__PURE__ */ y.createElement("path", { id: "Vector", d: "M4.19231 7.03125C2.66346 7.03125 1.42308 8.19973 1.42308 9.63994C1.42308 11.0802 2.66346 12.2486 4.19231 12.2486C5.72115 12.2486 6.96154 11.0802 6.96154 9.63994C6.96154 8.19973 5.72115 7.03125 4.19231 7.03125ZM4.19231 12.2486C2.16226 12.2486 0.5 13.8145 0.5 15.7269V17.629C0.5 17.629 1.42308 18.3356 4.19231 18.3356C6.96154 18.3356 7.88461 17.629 7.88461 17.629V15.7269C7.88461 13.8145 6.22236 12.2486 4.19231 12.2486ZM20.8077 7.03125C19.2788 7.03125 18.0385 8.19973 18.0385 9.63994C18.0385 11.0802 19.2788 12.2486 20.8077 12.2486C22.3365 12.2486 23.5769 11.0802 23.5769 9.63994C23.5769 8.19973 22.3365 7.03125 20.8077 7.03125ZM20.8077 12.2486C18.7776 12.2486 17.1154 13.8145 17.1154 15.7269V17.629C17.1154 17.629 18.0385 18.3356 20.8077 18.3356C23.5769 18.3356 24.5 17.629 24.5 17.629V15.7269C24.5 13.8145 22.8377 12.2486 20.8077 12.2486ZM12.5 10.5095C10.9712 10.5095 9.73077 11.678 9.73077 13.1182C9.73077 14.5584 10.9712 15.7269 12.5 15.7269C14.0288 15.7269 15.2692 14.5584 15.2692 13.1182C15.2692 11.678 14.0288 10.5095 12.5 10.5095ZM12.5 15.7269C10.47 15.7269 8.80769 17.2928 8.80769 19.2051V21.1073C8.80769 21.1073 9.73077 21.8138 12.5 21.8138C15.2692 21.8138 16.1923 21.1073 16.1923 21.1073V19.2051C16.1923 17.2928 14.53 15.7269 12.5 15.7269Z", fill: "white" }), /* @__PURE__ */ y.createElement("path", { id: "Vector_2", d: "M8.58473 1.5C6.96392 1.5 5.64893 2.73876 5.64893 4.2656C5.64893 5.79245 6.96392 7.03121 8.58473 7.03121C10.2055 7.03121 11.5205 5.79245 11.5205 4.2656C11.5205 2.73876 10.2055 1.5 8.58473 1.5ZM8.58473 7.03121C8.29038 7.03121 7.99221 7.024 7.69787 7.11763C8.28656 7.85584 8.58473 8.78131 8.58473 9.79681C8.58473 10.1641 8.49298 10.5242 8.49298 10.8915C9.27663 9.78601 10.5419 9.05859 12.0098 8.87494C11.3256 7.76942 10.0526 7.03121 8.58473 7.03121ZM16.4135 1.5C14.7927 1.5 13.4777 2.73876 13.4777 4.2656C13.4777 5.79245 14.7927 7.03121 16.4135 7.03121C18.0343 7.03121 19.3493 5.79245 19.3493 4.2656C19.3493 2.73876 18.0343 1.5 16.4135 1.5ZM16.4135 7.03121C14.9456 7.03121 13.6727 7.76942 12.9884 8.87494C14.4563 9.05859 15.7216 9.78601 16.5053 10.8915C16.5053 10.5242 16.4135 10.1641 16.4135 9.79681C16.4135 8.78131 16.7117 7.85584 17.3004 7.11763C17.006 7.024 16.7079 7.03121 16.4135 7.03121Z", fill: "white", fillOpacity: 0.4 }))), SV = (t) => /* @__PURE__ */ y.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 200 200", ...t }, /* @__PURE__ */ y.createElement("radialGradient", { id: "a9", cx: 0.66, fx: 0.66, cy: 0.3125, fy: 0.3125, gradientTransform: "scale(1.5)" }, /* @__PURE__ */ y.createElement("stop", { offset: 0, stopColor: "#006944" }), /* @__PURE__ */ y.createElement("stop", { offset: 0.3, stopColor: "#006944", stopOpacity: 0.9 }), /* @__PURE__ */ y.createElement("stop", { offset: 0.6, stopColor: "#006944", stopOpacity: 0.6 }), /* @__PURE__ */ y.createElement("stop", { offset: 0.8, stopColor: "#006944", stopOpacity: 0.3 }), /* @__PURE__ */ y.createElement("stop", { offset: 1, stopColor: "#006944", stopOpacity: 0 })), /* @__PURE__ */ y.createElement("circle", { "transform-origin": "center", fill: "none", stroke: "url(#a9)", strokeWidth: 17, strokeLinecap: "round", strokeDasharray: "200 1000", strokeDashoffset: 0, cx: 100, cy: 100, r: 70 }, /* @__PURE__ */ y.createElement("animateTransform", { type: "rotate", attributeName: "transform", calcMode: "spline", dur: 1.8, values: "360;0", keyTimes: "0;1", keySplines: "0 0 1 1", repeatCount: "indefinite" })), /* @__PURE__ */ y.createElement("circle", { "transform-origin": "center", fill: "none", opacity: 0.2, stroke: "#006944", strokeWidth: 17, strokeLinecap: "round", cx: 100, cy: 100, r: 70 })), ZV = (t) => /* @__PURE__ */ y.createElement("svg", { width: 86, height: 21, viewBox: "0 0 86 21", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ y.createElement("path", { d: "M39.7699 17.519L41.7975 10.3564C42.019 9.57525 42.5964 8.94819 43.3515 8.66775L43.4069 8.43457H40.5888L35.8028 14.1928L33.9712 8.43457H31.393L31.3309 8.66775C31.7723 8.88885 32.0156 9.54952 32.0156 10.087V10.1204C32.0156 13.1879 29.7696 18.4607 26.6104 18.4607C25.3827 18.4607 24.7463 17.5842 24.7463 16.8536C24.7463 15.9687 25.4791 15.3393 26.2522 15.3393C26.6778 15.3393 26.8988 15.4303 27.0895 15.5088C27.2342 15.5684 27.3615 15.6208 27.5475 15.6208C27.8106 15.6208 28.0628 15.4845 28.1888 15.2511C28.3867 14.8845 28.2367 14.4368 27.8748 14.2614L27.6773 14.1661C25.8352 13.2706 23.6992 14.6266 23.6992 16.6919V16.7205C23.6992 18.2238 24.8674 19.4811 26.3546 19.5336C30.1873 19.6694 32.751 14.4452 33.1588 10.6214L33.4534 11.656L34.9632 16.2284H35.5351L40.2511 10.5434L38.2726 17.5264C38.0457 18.3275 37.4171 18.948 36.6191 19.1592L36.5637 19.3923H40.3559L40.4177 19.1592C39.8575 18.8252 39.5911 18.1508 39.7699 17.519Z", fill: "#006747", style: {
  fill: "#006747",
  fill: "color(display-p3 0.0000 0.4039 0.2784)",
  fillOpacity: 1
} }), /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M49.2539 12.3311C47.4839 12.3332 45.5808 12.5062 44.568 15.4136C44.443 15.7724 44.3314 16.1004 44.2299 16.3988C43.6403 18.1314 43.3898 18.8676 42.8227 18.8676C42.6317 18.8676 42.5473 18.6987 42.4545 18.5128C42.3409 18.2851 42.2145 18.0318 41.8638 18.0318C41.5768 18.0318 41.2768 18.2645 41.2552 18.6014C41.2175 19.1835 41.9922 19.5357 42.576 19.5357C44.3546 19.5357 45.0362 18.2246 45.2587 17.6138C45.2876 17.534 45.4446 17.1017 45.6299 16.5923H47.499L47.1824 17.7708C47.0152 18.3926 46.6713 18.9015 46.0895 19.1617L46.0394 19.3947H49.0969L49.1536 19.1617C48.7397 18.8167 48.5601 18.2634 48.6943 17.7482L49.8448 13.3292C49.9332 12.9901 50.1656 12.7105 50.4806 12.5642L50.5306 12.3311H49.2539ZM47.6519 16.0223H45.8369C46.043 15.4562 46.2403 14.9158 46.3069 14.7388C46.766 13.5136 47.6389 13.0178 48.4845 12.9485L48.4757 12.9558L47.6519 16.0223Z", fill: "#006747", style: {
  fill: "#006747",
  fill: "color(display-p3 0.0000 0.4039 0.2784)",
  fillOpacity: 1
} }), /* @__PURE__ */ y.createElement("path", { d: "M64.9086 12.2791C64.9086 12.4194 64.8148 12.6704 64.7165 12.8348C64.487 13.2187 64.077 13.5109 63.6767 13.6265L63.4976 13.678C63 13.8213 62.489 13.794 61.9847 13.6879L60.8352 17.7483C60.6891 18.2633 60.8565 18.8168 61.2623 19.1616L61.2001 19.395H58.0542L58.1098 19.1616C58.6973 18.9016 59.1413 18.3925 59.3228 17.7712L60.6376 13.2639C59.4267 12.8561 59.1564 12.8823 58.8962 13.2526C58.7642 13.4721 58.7796 13.7795 58.7931 14.0483C58.7962 14.1086 58.7991 14.1673 58.8003 14.2223C58.8062 14.5193 58.6037 14.7795 58.316 14.842C57.9611 14.9189 57.6305 14.6359 57.6492 14.2698V14.2688C57.6508 14.2386 57.6651 14.1553 57.6846 14.0529C57.8161 13.356 58.2541 12.7534 58.8816 12.4351L58.892 12.4299L58.8972 12.4272C59.5396 12.1051 60.5191 12.3038 61.3075 12.5205C61.3166 12.5234 61.3246 12.5252 61.3335 12.5276C61.5009 12.574 61.6597 12.6208 61.8043 12.6636V12.6662C63.3842 13.1244 63.7271 13.1473 63.9416 12.8802C64.0349 12.7644 64.0788 12.527 64.0755 12.3059C64.0716 12.0932 64.2202 11.9086 64.4259 11.8637C64.6827 11.8078 64.9221 12.0139 64.9086 12.2791Z", fill: "#006747", style: {
  fill: "#006747",
  fill: "color(display-p3 0.0000 0.4039 0.2784)",
  fillOpacity: 1
} }), /* @__PURE__ */ y.createElement("path", { d: "M65.9742 12.3311L65.9123 12.5645C66.302 12.8363 66.4774 13.327 66.3516 13.7863L65.1826 17.7661C65.0012 18.3879 64.5572 18.8968 63.9697 19.1568L63.9141 19.3899H69.5602L70.0661 17.524H69.8285L69.7432 17.7028C69.4261 18.3695 68.758 18.7939 68.0255 18.7939H66.4015L67.2661 15.6704L67.956 15.6696C68.4214 15.6693 68.7712 16.0981 68.6821 16.5592H68.9197L69.4872 14.448H69.2496C69.112 14.8385 68.7468 15.0995 68.3361 15.0998L67.4239 15.1008L68.0239 12.9329L69.745 12.9316C70.3068 12.9311 70.7274 13.4515 70.6151 14.0077H70.8527L71.3034 12.3311H65.9742Z", fill: "#006747", style: {
  fill: "#006747",
  fill: "color(display-p3 0.0000 0.4039 0.2784)",
  fillOpacity: 1
} }), /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M72.9481 12.334H76.7502C77.7432 12.334 78.4622 13.2914 78.195 14.2577C77.9634 15.0938 77.2093 15.6717 76.3501 15.6723L75.871 15.6725C76.1731 15.6725 76.4653 15.8923 76.5235 16.1297C76.6323 16.575 76.8508 17.403 76.9765 17.8796L76.9891 17.9274C77.1191 18.4223 77.4099 18.7968 77.8116 19.0376L78.0151 19.1594L77.9597 19.3929H76.5378C75.969 19.3929 75.7192 19.0153 75.5289 18.3677C75.3836 17.8722 75.2017 16.4314 75.1884 16.3138C75.1484 15.9493 74.8437 15.6736 74.4808 15.6733H74.2406L73.6643 17.7456C73.5187 18.2606 73.6859 18.8141 74.0917 19.1589L74.0295 19.3926H70.8867L70.9421 19.1589C71.5298 18.8989 71.9736 18.39 72.155 17.7682L73.3456 13.7013C73.4277 13.2683 73.251 12.8216 72.886 12.5672L72.9481 12.334ZM75.395 15.1028C76.0496 15.1028 76.6259 14.6685 76.8136 14.0354C76.9763 13.4866 76.5692 12.9344 76.0015 12.9346L75.0017 12.9352L74.3984 15.1036L75.395 15.1028Z", fill: "#006747", style: {
  fill: "#006747",
  fill: "color(display-p3 0.0000 0.4039 0.2784)",
  fillOpacity: 1
} }), /* @__PURE__ */ y.createElement("path", { d: "M55.8673 12.6932C55.7651 12.6932 55.5452 12.6228 55.2078 12.481C54.8701 12.3392 54.529 12.2686 54.1851 12.2686C53.4713 12.2686 52.8755 12.502 52.3883 13.0009C51.9828 13.4161 51.8027 13.8769 51.8027 14.2758C51.8027 14.7004 52.0486 15.1996 52.5412 15.6032C52.9175 15.9119 53.3062 16.2101 53.6975 16.5103C53.7898 16.5812 53.8823 16.6521 53.9748 16.7233C54.4843 17.1353 54.7393 17.5153 54.7393 17.8244C54.7393 18.5029 54.3023 18.8679 53.3977 18.8679C52.4785 18.8679 51.8429 18.1875 51.6391 16.9132H51.3906L50.668 19.3933H50.897C51.1957 19.182 51.4081 19.0459 51.8411 19.0459C52.0058 19.0459 52.1751 19.1238 52.3786 19.2175C52.6859 19.3588 53.0713 19.5362 53.6377 19.5362C54.3894 19.5362 54.9845 19.3786 55.4942 18.8634C55.9276 18.4134 56.1441 17.7832 56.1441 17.268C56.1441 16.7916 55.8485 16.2362 55.332 15.8361C55.0681 15.6317 54.793 15.4404 54.5168 15.2482C54.3292 15.1177 54.1411 14.9869 53.9556 14.8514C53.4585 14.478 53.21 14.161 53.21 13.8134C53.21 13.6198 53.3057 13.4271 53.497 13.2341C53.7388 12.9896 54.0627 12.9355 54.496 12.9355C55.3655 12.9355 55.9741 13.425 56.0253 14.4546H56.2546L56.861 12.2686H56.6318C56.3895 12.5519 56.1347 12.6932 55.8673 12.6932Z", fill: "#006747", style: {
  fill: "#006747",
  fill: "color(display-p3 0.0000 0.4039 0.2784)",
  fillOpacity: 1
} }), /* @__PURE__ */ y.createElement("path", { d: "M84.2951 14.4543C84.2441 13.4247 83.6353 12.9353 82.7658 12.9353C82.3325 12.9353 82.0086 12.9894 81.7665 13.2338C81.5755 13.4268 81.4798 13.6201 81.4798 13.8128C81.4798 14.1605 81.7283 14.478 82.2256 14.8511C82.4108 14.9864 82.5985 15.117 82.7858 15.2473C83.0623 15.4397 83.3377 15.6313 83.6021 15.8361C84.1183 16.2363 84.4139 16.7916 84.4139 17.268C84.4139 17.7829 84.1974 18.4128 83.764 18.8634C83.2542 19.3781 82.6592 19.5362 81.9074 19.5362C81.341 19.5362 80.9556 19.3588 80.6483 19.2175C80.4448 19.1238 80.2755 19.0459 80.1107 19.0459C79.6778 19.0459 79.4655 19.182 79.167 19.3933H78.9375L79.6602 16.9132H79.9087C80.1127 18.1873 80.7483 18.8676 81.6675 18.8676C82.5721 18.8676 83.0091 18.5026 83.0091 17.8241C83.0091 17.5153 82.7538 17.1354 82.2446 16.7231C82.15 16.6502 82.0554 16.5777 81.961 16.5052C81.5718 16.2067 81.1852 15.9102 80.811 15.6032C80.3184 15.199 80.0724 14.7006 80.0724 14.2755C80.0724 13.8769 80.2526 13.4158 80.6581 13.0006C81.1453 12.502 81.7411 12.2686 82.4546 12.2686C82.7988 12.2686 83.1396 12.3392 83.4773 12.4807C83.815 12.6223 84.0349 12.6929 84.1368 12.6929C84.4048 12.6929 84.6593 12.5514 84.9013 12.2686H85.1308L84.5246 14.4543H84.2951Z", fill: "#006747", style: {
  fill: "#006747",
  fill: "color(display-p3 0.0000 0.4039 0.2784)",
  fillOpacity: 1
} }), /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21.4366 7.2801C21.4366 7.10548 21.2957 6.96289 21.1226 6.96289H20.88C20.6903 6.96289 20.5153 7.059 20.4126 7.21996L19.6278 8.4452C19.4953 8.65133 19.2714 8.77422 19.0281 8.77422H18.4981C18.3442 8.77422 18.203 8.8593 18.1295 8.99611C17.9478 9.33563 17.6228 9.56329 17.2542 9.62264V13.8311C17.848 13.896 18.3023 14.2547 18.3023 14.6885C18.3023 15.1685 17.7471 15.5576 17.0616 15.5576C16.3766 15.5576 15.8209 15.1685 15.8209 14.6885C15.8209 14.2547 16.2755 13.896 16.8687 13.8311V9.62264C16.5001 9.56277 16.1754 9.33511 15.9942 8.99637C15.9209 8.85956 15.78 8.77474 15.6261 8.77474H15.2708C15.1052 8.77474 14.9552 8.87295 14.8876 9.02578L14.5923 9.69643C14.4982 9.90965 14.2877 10.0478 14.0563 10.0478C13.8249 10.0478 13.6144 9.90965 13.5208 9.69564L13.225 9.02604C13.1579 8.87348 13.0074 8.77474 12.8423 8.77474H2.93715C2.87113 9.04127 2.63171 9.23926 2.34784 9.23926H2.06112V9.59927C2.06112 10.1174 1.96104 10.622 1.76425 11.0994L1.49962 11.7425C0.628527 13.8561 1.48429 16.2538 3.48955 17.3207L4.81218 18.0241L5.96298 18.0325C6.28922 18.0349 6.61208 18.1213 6.89673 18.282L7.49982 18.6223H8.31372C8.66648 18.6223 9.01273 18.7195 9.31506 18.9027L9.67301 19.121C10.0208 19.3318 10.4136 19.4542 10.8178 19.4781V19.1055C10.8178 18.3833 11.2405 17.7292 11.8948 17.4393L12.919 16.9845C13.1597 16.8777 13.4309 16.8609 13.6833 16.9368L14.1694 17.0833C14.3222 17.1295 14.4829 17.1295 14.6347 17.0841L15.7876 16.7388C16.0007 16.6747 16.2251 16.6768 16.4364 16.7437L16.8198 16.8656C17.3486 17.0334 17.7037 17.5223 17.7037 18.0827V19.0566C17.7037 19.2922 17.8934 19.4841 18.1271 19.4841C18.3143 19.4841 18.4815 19.357 18.5337 19.1756C18.6977 18.6039 18.7726 18.0126 18.7554 17.4175L18.7539 17.3144C18.7411 16.8656 18.9187 16.431 19.24 16.1214L19.7191 15.6614C19.9853 15.4048 20.1381 15.0451 20.1381 14.6732V12.3819C20.1381 11.8575 20.2946 11.3526 20.5907 10.9214L20.8179 10.5897V10.1342C20.8179 9.61266 20.9726 9.11033 21.265 8.68126L21.63 8.14506C21.507 8.01534 21.4366 7.84203 21.4366 7.65848V7.2801Z", fill: "#FCE300", style: {
  fill: "#FCE300",
  fill: "color(display-p3 0.9882 0.8902 0.0000)",
  fillOpacity: 1
} }), /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.16479 19.1581C8.95111 19.0284 8.71091 18.953 8.46344 18.9305V19.8514C8.7642 19.8745 9.05691 19.9643 9.3166 20.1218C9.31738 20.1221 9.73122 20.3763 9.87082 20.4587C10.064 20.573 10.2987 20.6817 10.7094 20.7029C10.7383 20.7042 10.7648 20.694 10.7856 20.6743C10.8072 20.6533 10.8191 20.6255 10.8191 20.5953V19.7736C10.3619 19.7492 9.91605 19.6148 9.523 19.3758L9.16479 19.1581Z", fill: "white", style: {
  fill: "white",
  fillOpacity: 1
} }), /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.7527 18.5415C6.51744 18.4083 6.25099 18.3369 5.98116 18.3314V19.2523C6.30116 19.2578 6.61752 19.3429 6.89645 19.5002L7.40934 19.7898V18.9065C7.40284 18.9036 7.39582 18.9044 7.38932 18.9009L6.7527 18.5415Z", fill: "white", style: {
  fill: "white",
  fillOpacity: 1
} }), /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.5993 17.2219C13.5226 17.1988 13.4436 17.1904 13.3651 17.1904V18.1123C13.4722 18.1123 13.5796 18.1239 13.6838 18.1551L14.1699 18.3022C14.2323 18.3205 14.2962 18.33 14.3602 18.3334V17.4125C14.2676 17.4086 14.1754 17.3954 14.0854 17.3687L13.5993 17.2219Z", fill: "white", style: {
  fill: "white",
  fillOpacity: 1
} }), /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.731 17.1493L16.3481 17.0275C16.2623 17.0002 16.1729 16.9891 16.0843 16.9915V17.9121C16.1987 17.9098 16.313 17.9245 16.424 17.9589L16.8896 18.0912C17.1282 18.1598 17.3151 18.3362 17.409 18.5576V18.0823C17.409 17.6532 17.1366 17.2782 16.731 17.1493Z", fill: "white", style: {
  fill: "white",
  fillOpacity: 1
} }), /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.1277 19.7819C18.1092 19.7819 18.0923 19.7777 18.0739 19.7764V20.6957C18.0978 20.6983 18.1209 20.7028 18.1454 20.7028C18.4139 20.7028 18.6491 20.5292 18.7305 20.2708C18.7388 20.2448 18.7443 20.2175 18.7521 20.1915V19.409C18.627 19.6338 18.3902 19.7819 18.1277 19.7819Z", fill: "white", style: {
  fill: "white",
  fillOpacity: 1
} }), /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.6875 16.096V16.8948C2.04935 17.5315 2.57913 18.0549 3.23993 18.4062L3.48402 18.5359V17.6534L3.35275 17.5838C2.66232 17.2167 2.10186 16.7005 1.6875 16.096Z", fill: "white", style: {
  fill: "white",
  fillOpacity: 1
} }), /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.06076 17.9608V18.8434L4.70907 19.1879V18.3048C4.70829 18.3048 4.70725 18.3048 4.70647 18.3043L4.06076 17.9608Z", fill: "white", style: {
  fill: "white",
  fillOpacity: 1
} }), /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.8159 14.8958C17.8159 14.6949 17.577 14.5274 17.2541 14.4785V15.313C17.577 15.2637 17.8159 15.0966 17.8159 14.8958Z", fill: "white", style: {
  fill: "white",
  fillOpacity: 1
} }), /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.3086 14.8958C16.3086 15.0966 16.5475 15.2637 16.8704 15.313V14.4785C16.5475 14.5274 16.3086 14.6949 16.3086 14.8958Z", fill: "white", style: {
  fill: "white",
  fillOpacity: 1
} }), /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.2923 1.62988C15.0123 1.54322 14.7326 1.69736 14.4526 1.85623C14.3536 1.91268 14.2831 2.00879 14.259 2.12092L13.8189 4.19615C13.8025 4.27282 13.8708 4.34214 13.9468 4.32481C14.4095 4.2182 14.8496 3.80962 15.3123 3.95246C15.8309 4.11317 16.3492 3.44987 16.8678 3.45775V1.06348C16.3464 1.06584 15.8111 1.79006 15.2923 1.62988", fill: "#BA0C2F", style: {
  fill: "#BA0C2F",
  fill: "color(display-p3 0.7294 0.0471 0.1843)",
  fillOpacity: 1
} }), /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21.2656 8.68074C20.9732 9.11033 20.8185 9.6124 20.8185 10.1336V10.5895L20.5913 10.9211C20.2949 11.352 20.1384 11.857 20.1384 12.3816V14.6727C20.1384 15.0445 19.9859 15.4046 19.7197 15.6608L19.2406 16.1214C18.919 16.4305 18.742 16.8651 18.7545 17.3141L18.7563 17.417C18.7732 18.012 18.6983 18.6037 18.5343 19.1756C18.482 19.3568 18.3149 19.4836 18.1277 19.4836C17.894 19.4836 17.7043 19.2916 17.7043 19.0561V18.0822C17.7043 17.5221 17.3492 17.0334 16.8204 16.8651L16.437 16.7435C16.2257 16.6763 16.0013 16.6747 15.7882 16.7382L14.6353 17.0835C14.4835 17.129 14.3226 17.129 14.17 17.0833L13.6839 16.9365C13.4317 16.8603 13.1603 16.8771 12.9196 16.9843L11.8954 17.4388C11.2411 17.729 10.8184 18.3828 10.8184 19.1049V19.4778C10.4142 19.4542 10.0214 19.3315 9.67385 19.1204L9.31564 18.9027C9.01332 18.7192 8.66706 18.622 8.31431 18.622H7.5004L6.89731 18.2817C6.61241 18.1208 6.28981 18.0344 5.96357 18.032L4.81276 18.0239L3.49013 17.3204C1.48461 16.2538 0.62911 13.8558 1.50021 11.7422L1.76484 11.0994C1.96162 10.6218 2.0617 10.1168 2.0617 9.59901V9.239H2.34843C2.63229 9.239 2.87171 9.04075 2.93774 8.77422H12.8429C13.008 8.77422 13.1585 8.87295 13.2256 9.02578L13.5211 9.69564C13.615 9.90912 13.8255 10.0475 14.0569 10.0475C14.2882 10.0475 14.4988 9.90939 14.5929 9.6959L14.8885 9.02525C14.9558 8.87269 15.1058 8.77422 15.2714 8.77422H15.6267C15.7806 8.77422 15.9215 8.85956 15.9948 8.99611C16.176 9.33484 16.5007 9.56251 16.8693 9.62238V13.8309C16.2761 13.896 15.8214 14.2544 15.8214 14.6882C15.8214 15.1685 16.3772 15.5574 17.0622 15.5574C17.7477 15.5574 18.3029 15.1685 18.3029 14.6882C18.3029 14.2544 17.8485 13.896 17.2548 13.8309V9.62264C17.6234 9.56277 17.9484 9.33511 18.1301 8.99611C18.2036 8.8593 18.3445 8.77396 18.4987 8.77396H19.029C19.272 8.77396 19.4958 8.65107 19.6282 8.44494L20.4132 7.21944C20.5159 7.05847 20.6908 6.96263 20.8806 6.96263H21.1234C21.2963 6.96263 21.4372 7.10495 21.4372 7.27957V7.65796C21.4372 7.84151 21.5076 8.01508 21.6306 8.14454L21.2656 8.68074ZM18.7515 20.1908C18.7437 20.2171 18.7382 20.2441 18.7299 20.2704C18.6486 20.5291 18.4133 20.7026 18.1448 20.7026C18.1203 20.7026 18.0972 20.6979 18.0733 20.6953V19.7757C18.0912 19.7775 18.1086 19.7812 18.1271 19.7812C18.3891 19.7812 18.6265 19.6331 18.7515 19.4086V20.1908ZM17.4081 18.5572C17.3143 18.3358 17.1279 18.1591 16.8893 18.0908L16.4235 17.9585C16.3125 17.9241 16.1981 17.9094 16.0837 17.9117V16.9911C16.1726 16.9887 16.2615 16.9998 16.3473 17.0273L16.7305 17.1489C17.136 17.2778 17.4081 17.6528 17.4081 18.0819V18.5572ZM14.3601 18.3327C14.2957 18.3296 14.2317 18.3204 14.1693 18.3015L13.6832 18.155C13.5795 18.1232 13.4719 18.1119 13.3645 18.1119V17.19C13.4435 17.19 13.5226 17.1986 13.5987 17.2212L14.0848 17.3683C14.1748 17.3953 14.2673 17.4084 14.3601 17.4121V18.3327ZM10.8185 20.5951C10.8185 20.6251 10.8061 20.6529 10.7847 20.6739C10.764 20.6939 10.7374 20.7038 10.7086 20.7028C10.2979 20.6815 10.0631 20.5726 9.86998 20.4583C9.73039 20.3756 9.31628 20.122 9.31576 20.1217C9.05607 19.9636 8.76311 19.8743 8.46286 19.851V18.9301C8.71008 18.9526 8.95001 19.028 9.16395 19.1577L9.5219 19.3754C9.91521 19.6144 10.3608 19.7488 10.8185 19.7732V20.5951ZM7.40902 19.7897L6.89588 19.4998C6.61669 19.3422 6.30059 19.2574 5.98059 19.2519V18.331C6.25016 18.3362 6.51661 18.4082 6.75238 18.5411L7.38901 18.9008C7.39498 18.9042 7.40252 18.9034 7.40902 18.9058V19.7897ZM4.70824 19.1875L4.06018 18.8427V17.9604L4.7059 18.3039C4.70668 18.3042 4.70772 18.3039 4.70824 18.3042V19.1875ZM3.48345 18.5355L3.23935 18.4058C2.57856 18.0545 2.04904 17.5309 1.68693 16.8944V16.0956C2.10129 16.7001 2.66174 17.2163 3.35191 17.5831L3.48345 17.653V18.5355ZM17.2536 14.4781C17.5762 14.527 17.8153 14.6945 17.8153 14.8954C17.8153 15.0962 17.5762 15.2638 17.2536 15.3129V14.4781ZM16.8698 15.3129C16.5474 15.2638 16.308 15.0962 16.308 14.8954C16.308 14.6945 16.5474 14.527 16.8698 14.4781V15.3129ZM21.9089 7.99494C21.7979 7.91906 21.7314 7.79328 21.7314 7.65778V7.27939C21.7314 6.94065 21.4582 6.66494 21.1229 6.66494H20.8801C20.59 6.66494 20.3227 6.81172 20.1649 7.05777L19.3804 8.28274C19.3027 8.40405 19.1709 8.47627 19.0284 8.47627H18.4981C18.2361 8.47627 17.9954 8.62095 17.8698 8.8557C17.7401 9.09702 17.5137 9.26271 17.2543 9.31891V0.800046C17.2543 0.692385 17.1682 0.605469 17.0616 0.605469C16.9553 0.605469 16.8688 0.692385 16.8688 0.800046V9.31891C16.6093 9.26245 16.3832 9.09676 16.2537 8.85465C16.1292 8.62148 15.8887 8.47627 15.6262 8.47627H15.2708C14.9893 8.47627 14.733 8.64432 14.6189 8.90402L14.323 9.57467C14.2763 9.68049 14.1715 9.74929 14.0563 9.74929C13.9409 9.74929 13.8364 9.68049 13.7899 9.57441L13.4943 8.90455C13.3799 8.64432 13.1239 8.47627 12.8424 8.47627H2.80773C2.72611 8.47627 2.66034 8.54296 2.66034 8.62515C2.66034 8.79951 2.51996 8.94078 2.34788 8.94078H1.91376C1.83239 8.94078 1.76637 9.00748 1.76637 9.08967V9.59883C1.76637 10.077 1.67434 10.5434 1.49186 10.9848L1.22775 11.6273C0.981833 12.2234 0.866155 12.8405 0.867194 13.4463V14.9262C0.867194 15.3261 0.924384 15.7287 1.03954 16.1247C1.36162 17.2291 2.0939 18.1329 3.10251 18.6694L4.70667 19.5223C4.72747 19.5336 4.75113 19.5396 4.77452 19.5399L5.96094 19.5488C6.23779 19.5506 6.51178 19.6239 6.75327 19.7599L7.38989 20.1194C7.41199 20.1317 7.43642 20.1383 7.46164 20.1383H8.31376C8.61296 20.1383 8.90697 20.2208 9.16276 20.3762C9.16276 20.3762 9.57998 20.6314 9.72009 20.7149C9.94521 20.8481 10.2189 20.9749 10.6926 20.9996C10.8002 21.0046 10.9065 20.9662 10.9871 20.8896C11.0666 20.8129 11.1127 20.7058 11.1127 20.5949V20.0178C11.1127 19.5997 11.357 19.2208 11.7365 19.0525L13.0376 18.4751C13.2146 18.3971 13.4137 18.384 13.5988 18.4401L14.0849 18.5869C14.2921 18.6489 14.5113 18.6494 14.719 18.5877L15.8716 18.2419C16.0242 18.1962 16.1864 18.1965 16.3416 18.244L16.81 18.3774C17.0278 18.4396 17.1804 18.6434 17.1804 18.8724V20.0259C17.1804 20.5634 17.613 21.0004 18.1449 21.0004C18.5426 21.0004 18.8904 20.7428 19.0105 20.3605C19.2281 19.6698 19.338 18.9517 19.338 18.2264V17.7359C19.338 17.3874 19.4818 17.0503 19.7326 16.8111L20.212 16.3534C20.5351 16.0425 20.7207 15.6058 20.7207 15.1549V12.4203C20.7207 11.9965 20.847 11.5879 21.0862 11.2392C21.1034 11.2145 21.113 11.1849 21.113 11.1547V10.51C21.113 10.0891 21.2375 9.68338 21.4738 9.33624L21.9479 8.6396C21.9651 8.61517 21.9742 8.58576 21.9742 8.5553V8.11836C21.9742 8.03538 21.9266 8.00676 21.9089 7.99494Z", fill: "#006747", style: {
  fill: "#006747",
  fill: "color(display-p3 0.0000 0.4039 0.2784)",
  fillOpacity: 1
} })), vV = (t) => /* @__PURE__ */ y.createElement("svg", { width: 154, height: 37, viewBox: "0 0 154 37", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ y.createElement("path", { d: "M70.9776 30.8796L74.668 18.1381C75.0696 16.7473 76.1186 15.6318 77.4936 15.1371L77.5928 14.7217H72.466L63.7623 24.9662L60.431 14.7217H55.7389L55.6255 15.1371C56.4288 15.5291 56.8683 16.7052 56.8683 17.662V17.7227C56.8683 23.1787 52.781 32.5598 47.0352 32.5598C44.8002 32.5598 43.6425 31.0009 43.6425 29.7035C43.6425 28.1306 44.975 27.0105 46.3831 27.0105C47.744 27.0105 47.9519 27.5099 48.741 27.5099C49.2182 27.5099 49.6766 27.2672 49.9081 26.8518C50.2672 26.1984 49.9931 25.4049 49.3363 25.0922L48.9772 24.9242C45.6271 23.3327 41.7383 25.7457 41.7383 29.4188V29.4701C41.7383 32.1444 43.8646 34.38 46.5674 34.4733C53.5417 34.716 58.2055 25.4236 58.9473 18.6188L59.486 20.4577L62.2313 28.5927H63.2709L71.8518 18.4741L68.2512 30.8936C67.8401 32.3171 66.6966 33.4232 65.2412 33.7966L65.142 34.212H72.0408L72.1542 33.7966C71.1383 33.2039 70.6516 32.0044 70.9776 30.8796Z", fill: "white" }), /* @__PURE__ */ y.createElement("path", { d: "M88.2952 21.6521H88.2385C85.016 21.6568 81.5571 21.9648 79.7143 27.1361C78.1692 31.4813 77.7487 33.2828 76.539 33.2828C75.7641 33.2828 75.9531 31.794 74.7954 31.794C74.2709 31.794 73.7275 32.2094 73.6897 32.8068C73.6236 33.8429 75.0317 34.4683 76.0949 34.4683C79.3316 34.4683 80.5696 32.1347 80.9759 31.0472C81.0279 30.9072 81.3162 30.1371 81.6517 29.2317H85.0538L84.4773 31.3273C84.1749 32.4334 83.5464 33.3388 82.488 33.8009L82.3982 34.2163H87.9597L88.0637 33.8009C87.3124 33.1848 86.9816 32.2 87.2273 31.2853L89.3206 23.4257C89.4812 22.8236 89.9018 22.3242 90.4783 22.0628L90.568 21.6475H88.7536H88.2952V21.6521ZM85.3231 28.2189H82.0202C82.3935 27.2108 82.7526 26.2493 82.8755 25.9366C83.7118 23.757 85.2995 22.8749 86.8399 22.7536L86.8257 22.7676L85.3231 28.2189Z", fill: "white" }), /* @__PURE__ */ y.createElement("path", { d: "M116.358 22.5486C116.538 22.2545 116.708 21.8112 116.708 21.5591C116.732 21.0877 116.297 20.7237 115.829 20.8217C115.456 20.9011 115.187 21.2324 115.191 21.6058C115.196 21.9978 115.12 22.4226 114.95 22.6279C114.558 23.104 113.934 23.062 111.062 22.2452V22.2405C110.797 22.1659 110.509 22.0819 110.206 21.9978C110.187 21.9932 110.173 21.9885 110.159 21.9838C108.723 21.6011 106.941 21.2464 105.774 21.8205C105.765 21.8252 105.755 21.8298 105.746 21.8345C104.602 22.3992 103.808 23.4727 103.567 24.7142C103.53 24.8962 103.506 25.0455 103.501 25.0969C103.468 25.7456 104.068 26.2544 104.711 26.1143C105.235 26.0023 105.604 25.5403 105.59 25.0129C105.58 24.4808 105.472 23.7667 105.765 23.286C106.237 22.6279 106.729 22.5812 108.935 23.3047L106.544 31.323C106.214 32.4291 105.406 33.3345 104.338 33.7966L104.238 34.212H109.961L110.074 33.7966C109.337 33.1852 109.03 32.1957 109.299 31.2809L111.392 24.0561C112.309 24.2428 113.24 24.2941 114.147 24.0374L114.473 23.9441C115.196 23.7527 115.943 23.2347 116.358 22.5486Z", fill: "white" }), /* @__PURE__ */ y.createElement("path", { d: "M118.649 21.6523L118.536 22.0677C119.245 22.5531 119.561 23.4259 119.335 24.2427L117.208 31.3228C116.877 32.429 116.069 33.3344 115.002 33.7964L114.902 34.2118H117.931H118.21H125.18L126.101 30.8934H125.666L125.51 31.2108C124.934 32.3963 123.72 33.1524 122.382 33.1524H119.429L121.003 27.5937H122.259C123.105 27.5937 123.743 28.3545 123.582 29.1759H124.012L125.043 25.4188H124.613C124.362 26.1142 123.696 26.5763 122.949 26.5809H121.291L122.382 22.7258L125.515 22.7211C126.536 22.7211 127.301 23.6452 127.098 24.6347H127.528L128.35 21.6523H118.649Z", fill: "white" }), /* @__PURE__ */ y.createElement("path", { d: "M138.251 21.6582H131.333L131.22 22.0736C131.881 22.5263 132.207 23.3197 132.056 24.0898L129.892 31.324C129.561 32.4301 128.753 33.3356 127.685 33.7976L127.586 34.213H133.303L133.417 33.7976C132.68 33.1862 132.373 32.2014 132.637 31.282L133.686 27.5949H134.126C134.787 27.5949 135.34 28.085 135.416 28.7337C135.439 28.9437 135.77 31.506 136.035 32.3881C136.379 33.5409 136.833 34.213 137.868 34.213H140.453L140.552 33.7976L140.183 33.5829C139.451 33.1536 138.922 32.4908 138.685 31.6087C138.463 30.7779 138.043 29.2284 137.84 28.4117C137.736 27.9916 137.202 27.5996 136.654 27.5996H137.523C139.087 27.5996 140.457 26.5681 140.878 25.0839C141.365 23.3617 140.056 21.6582 138.251 21.6582ZM138.369 24.6872C138.029 25.812 136.98 26.5868 135.789 26.5868H133.974L135.071 22.7317H136.89C137.925 22.727 138.662 23.7118 138.369 24.6872Z", fill: "white" }), /* @__PURE__ */ y.createElement("path", { d: "M100.265 22.2961C100.081 22.2961 99.6794 22.1701 99.0651 21.9181C98.4508 21.6661 97.8318 21.54 97.2034 21.54C95.904 21.54 94.8219 21.9554 93.9336 22.8422C93.1964 23.5796 92.8704 24.401 92.8704 25.1105C92.8704 25.8665 93.3193 26.7533 94.2124 27.4721C95.0582 28.1488 95.937 28.8022 96.8206 29.465C97.7468 30.1977 98.2098 30.8745 98.2098 31.4252C98.2098 32.634 97.416 33.2828 95.7669 33.2828C94.0942 33.2828 92.9366 32.074 92.568 29.8057H92.1144L90.8008 34.2162H91.226C91.7694 33.8382 92.1569 33.6001 92.946 33.6001C93.6973 33.6001 94.5006 34.4729 96.2158 34.4729C97.5814 34.4729 98.6682 34.1929 99.5943 33.2781C100.383 32.4753 100.776 31.3552 100.776 30.4404C100.776 29.591 100.237 28.6062 99.2966 27.8921C98.4886 27.2807 97.6286 26.7347 96.7923 26.1419C95.8898 25.4792 95.4362 24.9144 95.4362 24.2937C95.4362 23.9483 95.611 23.6076 95.9559 23.2622C96.3954 22.8282 96.986 22.7302 97.7751 22.7302C99.3581 22.7302 100.464 23.5983 100.558 25.4325H100.974L102.08 21.5447H101.664C101.215 22.0441 100.752 22.2961 100.265 22.2961Z", fill: "white" }), /* @__PURE__ */ y.createElement("path", { d: "M149.201 22.7304C150.784 22.7304 151.89 23.6032 151.984 25.4327H152.4L153.501 21.5449H153.085C152.646 22.049 152.182 22.301 151.696 22.301C151.512 22.301 151.11 22.175 150.496 21.923C149.881 21.6709 149.262 21.5449 148.634 21.5449C147.334 21.5449 146.252 21.9603 145.364 22.8471C144.627 23.5845 144.296 24.4059 144.296 25.1153C144.296 25.8714 144.745 26.7582 145.638 27.477C146.484 28.1537 147.363 28.8071 148.246 29.4699C149.173 30.2026 149.636 30.8794 149.636 31.4301C149.636 32.6389 148.842 33.2876 147.193 33.2876C145.52 33.2876 144.362 32.0788 143.994 29.8106H143.54L142.227 34.2211H142.642C143.186 33.843 143.573 33.605 144.358 33.605C145.109 33.605 145.912 34.4778 147.627 34.4778C148.993 34.4778 150.075 34.1978 151.006 33.283C151.795 32.4802 152.187 31.3601 152.187 30.4453C152.187 29.6005 151.649 28.6111 150.708 27.897C149.9 27.2856 149.04 26.7395 148.204 26.1468C147.301 25.4841 146.848 24.9193 146.848 24.2986C146.848 23.9532 147.023 23.6125 147.368 23.2671C147.826 22.8237 148.412 22.7304 149.201 22.7304Z", fill: "white" }), /* @__PURE__ */ y.createElement("path", { d: "M26.5433 2.60035C26.0377 2.44633 25.5321 2.72169 25.0265 3.00173C24.8469 3.09974 24.7194 3.27243 24.6768 3.46845L23.883 7.13222C23.8547 7.26757 23.9775 7.38891 24.1145 7.36091C24.9509 7.17422 25.7447 6.4508 26.5811 6.70283C27.5167 6.98753 28.4522 5.81606 29.3878 5.83006V1.60156C28.4475 1.60623 27.4789 2.88505 26.5433 2.60035Z", fill: "white" }), /* @__PURE__ */ y.createElement("path", { d: "M38.4856 13.8398C38.2871 13.7044 38.1643 13.4851 38.1643 13.2471V12.5796C38.1643 11.9822 37.6729 11.4922 37.0633 11.4922H36.6239C36.0994 11.4922 35.6174 11.7536 35.3339 12.1876L33.9164 14.3485C33.7746 14.5632 33.5383 14.6892 33.2832 14.6892H32.3287C31.8562 14.6892 31.4215 14.9459 31.1947 15.3566C30.9631 15.7814 30.552 16.0754 30.0843 16.1734V1.1403C30.0843 0.94894 29.9283 0.794922 29.7346 0.794922C29.5409 0.794922 29.3849 0.94894 29.3849 1.1403V1.60702V5.83552V16.1827C28.9171 16.0847 28.506 15.7907 28.2745 15.3613C28.0524 14.9506 27.6177 14.6939 27.1405 14.6939H26.4979C25.9875 14.6939 25.5292 14.9879 25.3213 15.45L24.7873 16.6308C24.7023 16.8175 24.5133 16.9388 24.3054 16.9388C24.0975 16.9388 23.9085 16.8175 23.8234 16.6308L23.2895 15.45C23.0816 14.9926 22.6232 14.6939 22.1129 14.6939H4.00135C3.85487 14.6939 3.73674 14.8106 3.73674 14.9553C3.73674 15.2633 3.48158 15.5107 3.17444 15.5107H2.39007C2.24359 15.5107 2.12546 15.6273 2.12546 15.772V16.6728C2.12546 17.5176 1.96008 18.339 1.62931 19.1184L1.15207 20.2526C0.707907 21.3027 0.5 22.3901 0.5 23.4589V26.0726C0.5 26.7773 0.603954 27.4914 0.811861 28.1868C1.39306 30.1377 2.7161 31.7339 4.53529 32.6767L7.43182 34.1842C7.46962 34.2029 7.51214 34.2122 7.55467 34.2122L9.69517 34.2309C10.196 34.2355 10.6875 34.3616 11.1269 34.6043L12.2751 35.239C12.3129 35.2623 12.3602 35.2717 12.4074 35.2717H13.9431C14.4818 35.2717 15.0157 35.4163 15.474 35.6917C15.474 35.6917 16.2253 36.1444 16.4805 36.2891C16.8869 36.5225 17.3783 36.7465 18.2335 36.7932C18.4273 36.8025 18.621 36.7325 18.7675 36.5972C18.9092 36.4618 18.9943 36.2704 18.9943 36.0791V35.0616C18.9943 34.3242 19.4337 33.6521 20.1189 33.3581L22.4673 32.3406C22.7886 32.2006 23.1477 32.1773 23.4832 32.28L24.3621 32.5367C24.7354 32.644 25.1323 32.6487 25.5056 32.5367L27.5846 31.9253C27.8587 31.8459 28.1517 31.8459 28.4304 31.9299L29.2763 32.1633C29.6684 32.2706 29.9472 32.6347 29.9472 33.0361V35.071C29.9472 36.0184 30.7269 36.7932 31.6861 36.7932C32.4043 36.7932 33.0328 36.3405 33.2501 35.6637C33.6423 34.4456 33.8408 33.1761 33.8408 31.8973V31.0292C33.8408 30.4131 34.1006 29.8204 34.5543 29.3956L35.419 28.5882C36.0002 28.0421 36.3356 27.2674 36.3356 26.474V21.6481C36.3356 20.9013 36.5625 20.1779 36.9972 19.5618C37.0302 19.5198 37.0444 19.4638 37.0444 19.4125V18.2737C37.0444 17.5316 37.2712 16.8128 37.6965 16.2014L38.5517 14.9739C38.5848 14.9319 38.599 14.8806 38.599 14.8246V14.0545C38.6037 13.9098 38.5139 13.8585 38.4856 13.8398ZM30.0843 25.2838C30.6654 25.3725 31.1002 25.6665 31.1002 26.0212C31.1002 26.3759 30.6702 26.67 30.0843 26.7587V25.2838ZM5.22516 32.4433L4.78572 32.2146C3.59026 31.5939 2.63577 30.6698 1.9837 29.545V28.1355C2.73028 29.2043 3.74619 30.1144 4.98891 30.7631L5.22516 30.8845V32.4433ZM7.43654 33.5961L6.2647 32.9894V31.4305L7.43182 32.0373H7.43654V33.5961ZM12.3129 34.6556L11.3868 34.1422C10.8812 33.8622 10.3142 33.7128 9.73297 33.7035V32.0793C10.2197 32.0886 10.7016 32.2146 11.1269 32.448L12.2751 33.0827C12.2846 33.0874 12.2987 33.0874 12.3129 33.0921V34.6556ZM18.4603 35.0616V35.8551V36.0791C18.4603 36.1304 18.4367 36.1818 18.3989 36.2191C18.3611 36.2564 18.3139 36.2705 18.2619 36.2705C17.52 36.2331 17.0948 36.0418 16.7498 35.8411C16.4994 35.6964 15.7528 35.2483 15.7481 35.2483C15.2803 34.9683 14.7511 34.8143 14.2077 34.7723V33.1387C14.6519 33.1808 15.0866 33.3114 15.474 33.5401L16.1214 33.9228C16.8302 34.3429 17.6382 34.5809 18.4603 34.6276V35.0616ZM24.8582 32.0886C24.7448 32.084 24.6267 32.0653 24.5133 32.0326L23.6344 31.7713C23.4454 31.7152 23.2517 31.6966 23.0579 31.6966V30.0677C23.1997 30.0677 23.3414 30.0817 23.4832 30.1237L24.3621 30.3804C24.5227 30.4271 24.6928 30.4504 24.8582 30.4598V32.0886ZM30.363 32.4807C30.1929 32.0886 29.8574 31.7759 29.4275 31.6592L28.5864 31.4259C28.3879 31.3652 28.18 31.3419 27.9721 31.3419V29.7177C28.1328 29.713 28.2934 29.7317 28.4493 29.783L29.1392 29.9977C29.8716 30.2264 30.363 30.8891 30.363 31.6452V32.4807ZM32.787 35.365C32.7729 35.4117 32.7634 35.4584 32.7492 35.505C32.6028 35.9624 32.1775 36.2658 31.6955 36.2658C31.653 36.2658 31.6105 36.2564 31.568 36.2518V34.6323C31.601 34.6369 31.6294 34.6416 31.6625 34.6416C32.135 34.6416 32.565 34.3802 32.7918 33.9835V35.365H32.787ZM37.3232 15.0486C36.794 15.8047 36.5152 16.6915 36.5152 17.6109V18.4137L36.1041 19.0017C35.5702 19.7625 35.2867 20.6539 35.2867 21.578V25.6245C35.2867 26.2779 35.0126 26.9173 34.5306 27.3654L33.6659 28.1775C33.0847 28.7236 32.7634 29.489 32.787 30.2824L32.7918 30.4644C32.8248 31.5146 32.6878 32.56 32.3901 33.5681C32.2956 33.8902 31.9932 34.1142 31.6577 34.1142C31.2372 34.1142 30.8923 33.7782 30.8923 33.3581V31.6452C30.8923 30.6558 30.2496 29.7923 29.2952 29.4983L28.6053 29.2836C28.2225 29.1669 27.8209 29.1623 27.4334 29.2743L25.3544 29.881C25.0803 29.9604 24.7873 29.9604 24.5133 29.881L23.6344 29.6243C23.1808 29.489 22.6894 29.5217 22.2547 29.7083L20.4071 30.5111C19.2258 31.0245 18.4651 32.1773 18.4651 33.4515V34.1095C17.7374 34.0675 17.0286 33.8528 16.4002 33.4795L15.7528 33.0967C15.2047 32.7747 14.581 32.602 13.9431 32.602H12.4736L11.3868 31.9999C10.8717 31.7152 10.2905 31.5659 9.69989 31.5612L7.62082 31.5472L5.23461 30.3057C1.61514 28.4249 0.0700101 24.1917 1.64349 20.4579L2.12073 19.3238C2.47512 18.4837 2.6594 17.5922 2.6594 16.6775V16.0427H3.17444C3.68476 16.0427 4.11948 15.6927 4.2376 15.2213H22.1176C22.4153 15.2213 22.6894 15.394 22.8075 15.6647L23.3414 16.8455C23.5115 17.2235 23.8896 17.4662 24.3101 17.4662C24.7259 17.4662 25.1087 17.2235 25.2788 16.8455L25.8127 15.66C25.9356 15.3893 26.2049 15.2166 26.5026 15.2166H27.1452C27.424 15.2166 27.6791 15.366 27.8114 15.6087C28.1375 16.2061 28.7234 16.6075 29.3897 16.7148V24.145C28.317 24.2617 27.4949 24.8918 27.4949 25.6572C27.4949 26.5066 28.4966 27.1927 29.7346 27.1927C30.9726 27.1927 31.9743 26.5066 31.9743 25.6572C31.9743 24.8918 31.1521 24.257 30.0795 24.145V16.7101C30.7458 16.6028 31.3317 16.2014 31.6577 15.604C31.79 15.3613 32.0452 15.212 32.324 15.212H33.2785C33.7179 15.212 34.1195 14.9926 34.3605 14.6286L35.7781 12.4676C35.9624 12.1829 36.2789 12.0149 36.6239 12.0149H37.0633C37.3752 12.0149 37.6303 12.2669 37.6303 12.575V13.2424C37.6303 13.5644 37.7579 13.8725 37.98 14.1012L37.3232 15.0486ZM29.3849 25.2838V26.7587C28.8037 26.67 28.3737 26.3759 28.3737 26.0212C28.3737 25.6665 28.8037 25.3678 29.3849 25.2838Z", fill: "white" })), IV = (t) => /* @__PURE__ */ y.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ y.createElement("g", { id: "Group 483737" }, /* @__PURE__ */ y.createElement("g", { id: "Icon / Live" }, /* @__PURE__ */ y.createElement("path", { id: "circle-path", fillRule: "evenodd", clipRule: "evenodd", d: "M9 17C4.58172 17 1 13.4183 1 9C1 4.58172 4.58172 1 9 1C13.4183 1 17 4.58172 17 9C17 13.4183 13.4183 17 9 17Z", stroke: "#107D57" }), /* @__PURE__ */ y.createElement("path", { id: "Combined Shape", fillRule: "evenodd", clipRule: "evenodd", d: "M10.6432 6.12891C10.9551 6.12891 11.2103 6.37162 11.2302 6.67846L11.2315 6.71714V7.55879L13.3334 6.46776C13.6362 6.31058 13.9959 6.51777 14.0195 6.85057L14.0207 6.88543V11.1406C14.0207 11.4763 13.6813 11.7002 13.3764 11.578L13.345 11.5641L11.2315 10.54V11.2818C11.2315 11.5937 10.9887 11.8489 10.6819 11.8688L10.6432 11.8701H5.11851C4.80663 11.8701 4.55144 11.6274 4.53152 11.3205L4.53027 11.2818V6.71714C4.53027 6.40526 4.77299 6.15007 5.07983 6.13016L5.11851 6.12891H10.6432ZM10.2897 7.07007H5.4709V10.9289H10.2897V7.07007ZM13.0792 7.65972L11.2396 8.61454V9.49831L13.0792 10.3896V7.65972Z", fill: "#107D57" })))), NV = (t) => /* @__PURE__ */ y.createElement("svg", { width: 14, height: 17, viewBox: "0 0 14 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ y.createElement("g", { id: "Icon / Games" }, /* @__PURE__ */ y.createElement("path", { id: "Icon / Games_2", d: "M6.27412 2.68557L6.27411 2.68557C5.62309 2.63368 5.0525 3.12172 5.00064 3.7713L5.00064 3.77134L4.14164 14.5465C4.14163 14.5465 4.14163 14.5465 4.14163 14.5465C4.08978 15.1963 4.57588 15.7681 5.22739 15.82C5.22741 15.82 5.22742 15.82 5.22744 15.82L11.3107 16.3052L11.3108 16.3052C11.9618 16.3571 12.5324 15.869 12.5842 15.2194L12.5842 15.2194L13.4432 4.4443C13.4951 3.79528 13.0091 3.22266 12.3575 3.17076C12.3575 3.17076 12.3574 3.17076 12.3574 3.17076L6.27412 2.68557ZM8.15378 7.95339C8.06822 8.08171 8.00584 8.22011 7.96597 8.36701L7.39679 8.32084C7.47153 7.93067 7.63452 7.64794 7.86868 7.44845C8.15963 7.20058 8.54037 7.08303 9.04377 7.12388C9.36277 7.14976 9.62596 7.23281 9.84206 7.36455L9.84205 7.36458L9.84603 7.36693C10.0639 7.49535 10.2189 7.65832 10.3213 7.85605C10.4234 8.05317 10.4683 8.27793 10.4483 8.53948C10.4345 8.71901 10.392 8.86521 10.3278 8.98465L10.3277 8.98461L10.3242 8.99151C10.2546 9.12905 10.1759 9.23612 10.0908 9.31799L10.0907 9.31793L10.0855 9.32326C9.98974 9.41994 9.85909 9.53313 9.69013 9.66317C9.48159 9.8217 9.31317 9.96772 9.19518 10.0999L9.19509 10.0998L9.18961 10.1063C9.10272 10.2092 9.04052 10.3244 9.00219 10.449L8.46556 10.4054C8.49427 10.3132 8.5356 10.2357 8.58714 10.17C8.70826 10.0178 8.8862 9.84033 9.1277 9.63726C9.33755 9.46764 9.50811 9.30895 9.63088 9.16198L9.39343 8.96362L9.63088 9.16198C9.77451 8.99005 9.86011 8.79 9.87715 8.56784C9.89609 8.32086 9.82923 8.08941 9.6571 7.90614C9.48861 7.71582 9.25493 7.62752 9.00193 7.60699L8.97691 7.91539L9.00193 7.60699C8.67115 7.58016 8.35479 7.66584 8.15766 7.94771L8.1576 7.94766L8.15378 7.95339ZM8.84046 11.5393L8.84024 11.5394L8.84882 11.5493C8.9033 11.6122 8.9274 11.681 8.92009 11.7763C8.91337 11.8639 8.88049 11.9307 8.81121 11.9916L8.81117 11.9915L8.8063 11.996C8.74838 12.0491 8.68489 12.0727 8.59225 12.0652C8.49804 12.0575 8.43752 12.0248 8.38914 11.9687C8.34013 11.9019 8.31721 11.826 8.32494 11.7253L8.01644 11.7016L8.32494 11.7253C8.33288 11.6218 8.36807 11.5555 8.42399 11.5042L8.2147 11.2763L8.42377 11.5044C8.48168 11.4513 8.54518 11.4277 8.63782 11.4352C8.73051 11.4427 8.79051 11.4764 8.84046 11.5393Z", stroke: "#107D57", strokeWidth: 0.618817 }), /* @__PURE__ */ y.createElement("path", { id: "Icon / Games_3", d: "M7.74941 0.00278796L1.66605 0.487981C1.18503 0.526267 0.82584 0.949506 0.864126 1.42843L1.72313 12.2036C1.76142 12.6832 2.18327 13.0438 2.66359 13.0055L3.18754 12.9637L3.97219 3.12062C4.0418 2.24421 4.81101 1.58916 5.68742 1.65878L8.7776 1.90524L8.68986 0.804714C8.65157 0.32509 8.22973 -0.0354984 7.74941 0.00278796Z", fill: "#107D57" }))), FV = (t) => /* @__PURE__ */ y.createElement("svg", { width: 19, height: 14, viewBox: "0 0 19 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ y.createElement("g", { id: "Icon / LeaderBoard" }, /* @__PURE__ */ y.createElement("path", { id: "Combined Shape", fillRule: "evenodd", clipRule: "evenodd", d: "M16.8236 2.46643C16.436 2.23624 16.1759 1.81093 16.1759 1.32432C16.1759 0.59292 16.7636 0 17.4885 0C18.2134 0 18.8011 0.59292 18.8011 1.32432C18.8011 1.81093 18.541 2.23624 18.1534 2.46643C18.5192 2.51678 18.8011 2.83327 18.8011 3.2162V10.7838C18.8011 11.2017 18.4653 11.5405 18.051 11.5405H16.926L16.9147 11.5404H10.9255V11.5406V13.2433C10.9255 13.6612 10.5897 14 10.1755 14H8.67539C8.26115 14 7.92534 13.6612 7.92534 13.2433V11.5406V11.5404H1.93622L1.92493 11.5405H0.799856C0.385614 11.5405 0.0498047 11.2017 0.0498047 10.7838V3.2162C0.0498047 2.83328 0.331692 2.51678 0.697521 2.46643C0.309923 2.23624 0.0498047 1.81093 0.0498047 1.32432C0.0498047 0.59292 0.637471 0 1.36239 0C2.08732 0 2.67498 0.59292 2.67498 1.32432C2.67498 1.81093 2.41487 2.23624 2.02727 2.46643C2.16328 2.48515 2.28769 2.54066 2.39032 2.62269C4.78264 1.62379 7.12768 1.12793 9.42545 1.13511C11.7225 1.14228 14.0669 1.63872 16.4584 2.62442C16.5615 2.54144 16.6867 2.48528 16.8236 2.46643ZM1.92494 10.7837L1.92493 3.21617H0.799862V10.7837H1.92494ZM16.1759 3.32547C13.8707 2.37522 11.6209 1.89875 9.42314 1.89189C7.2272 1.88503 4.97905 2.36051 2.675 3.32285V10.7837H16.1759V3.32547ZM17.4885 1.89189C17.7992 1.89189 18.0511 1.63779 18.0511 1.32433C18.0511 1.01087 17.7992 0.75676 17.4885 0.75676C17.1778 0.75676 16.926 1.01087 16.926 1.32433C16.926 1.63779 17.1778 1.89189 17.4885 1.89189ZM16.926 3.21617V10.7837H18.0511V3.21617H16.926ZM8.67538 13.2432V11.5405H10.1755V13.2432H8.67538ZM1.3624 1.89189C1.67308 1.89189 1.92494 1.63779 1.92494 1.32433C1.92494 1.01087 1.67308 0.75676 1.3624 0.75676C1.05172 0.75676 0.799862 1.01087 0.799862 1.32433C0.799862 1.63779 1.05172 1.89189 1.3624 1.89189Z", fill: "#107D57" }))), GV = (t) => /* @__PURE__ */ y.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ y.createElement("g", { clipPath: "url(#clip0_1664_3009)" }, /* @__PURE__ */ y.createElement("path", { d: "M21 19V5C21 3.9 20.1 3 19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19ZM8.5 13.5L11 16.51L14.5 12L19 18H5L8.5 13.5Z", fill: "#B6B9C6" })), /* @__PURE__ */ y.createElement("defs", null, /* @__PURE__ */ y.createElement("clipPath", { id: "clip0_1664_3009" }, /* @__PURE__ */ y.createElement("rect", { width: 24, height: 24, fill: "white" })))), XV = (t) => /* @__PURE__ */ y.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ y.createElement("g", { id: "check" }, /* @__PURE__ */ y.createElement("path", { id: "Vector", d: "M3.59985 10.8L7.59985 14.8L16.3999 5.20001", stroke: "white", strokeWidth: 1.2, strokeLinecap: "round", strokeLinejoin: "round" }))), UV = (t) => /* @__PURE__ */ y.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ y.createElement("g", { id: "cross" }, /* @__PURE__ */ y.createElement("path", { id: "Vector", d: "M5.19995 14.8L14.8 5.20001M5.19995 5.20001L14.8 14.8", stroke: "white", strokeWidth: 1.2, strokeLinecap: "round", strokeLinejoin: "round" }))), BV = (t) => /* @__PURE__ */ y.createElement("svg", { width: 32, height: 32, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16 2.46154C8.52291 2.46154 2.46154 8.52291 2.46154 16C2.46154 23.4771 8.52291 29.5385 16 29.5385C23.4771 29.5385 29.5385 23.4771 29.5385 16C29.5385 8.52291 23.4771 2.46154 16 2.46154ZM0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z", fill: "#FFB600" }), /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16 8.20513C16.6797 8.20513 17.2308 8.75616 17.2308 9.4359V17.641C17.2308 18.3208 16.6797 18.8718 16 18.8718C15.3203 18.8718 14.7692 18.3208 14.7692 17.641V9.4359C14.7692 8.75616 15.3203 8.20513 16 8.20513Z", fill: "#FFB600" }), /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.7692 22.5641C14.7692 21.8844 15.3203 21.3333 16 21.3333H16.0164C16.6961 21.3333 17.2472 21.8844 17.2472 22.5641C17.2472 23.2438 16.6961 23.7949 16.0164 23.7949H16C15.3203 23.7949 14.7692 23.2438 14.7692 22.5641Z", fill: "#FFB600" })), wV = (t) => /* @__PURE__ */ y.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ y.createElement("g", { id: "Icon/Insight" }, /* @__PURE__ */ y.createElement("path", { id: "Fill-1", fillRule: "evenodd", clipRule: "evenodd", d: "M9.3336 9.33644C8.59749 10.0725 7.40264 10.0725 6.66652 9.33644C5.93041 8.60039 5.93041 7.40565 6.66652 6.6696C7.40264 5.93355 8.59749 5.93355 9.3336 6.6696C10.0697 7.40565 10.0697 8.60039 9.3336 9.33644Z", fill: "#107D57" }), /* @__PURE__ */ y.createElement("path", { id: "Fill-3", fillRule: "evenodd", clipRule: "evenodd", d: "M12.3345 12.3306C11.7818 12.8833 10.8863 12.8827 10.3342 12.3306C9.78211 11.7786 9.78145 10.8832 10.3342 10.3305C10.8869 9.77781 11.7824 9.77847 12.3345 10.3305C12.8866 10.8825 12.8873 11.7779 12.3345 12.3306Z", fill: "#107D57" }), /* @__PURE__ */ y.createElement("path", { id: "Fill-5", fillRule: "evenodd", clipRule: "evenodd", d: "M5.66586 5.66365C5.11311 6.21635 4.21831 6.21635 3.66556 5.66365C3.11281 5.11094 3.11281 4.21622 3.66556 3.66352C4.21831 3.11081 5.11311 3.11081 5.66586 3.66352C6.21861 4.21622 6.21861 5.11094 5.66586 5.66365Z", fill: "#107D57" }), /* @__PURE__ */ y.createElement("path", { id: "Fill-7", fillRule: "evenodd", clipRule: "evenodd", d: "M12.3345 5.66365C11.7818 6.21635 10.8869 6.21635 10.3342 5.66365C9.78145 5.11094 9.78145 4.21622 10.3342 3.66352C10.8869 3.11081 11.7818 3.11081 12.3345 3.66352C12.8873 4.21622 12.8873 5.11094 12.3345 5.66365Z", fill: "#107D57" }), /* @__PURE__ */ y.createElement("path", { id: "Fill-9", fillRule: "evenodd", clipRule: "evenodd", d: "M5.66586 12.3306C5.11378 12.8827 4.21831 12.8833 3.66556 12.3306C3.11281 11.7779 3.11347 10.8825 3.66556 10.3305C4.21764 9.77847 5.11311 9.77781 5.66586 10.3305C6.21861 10.8832 6.21795 11.7786 5.66586 12.3306Z", fill: "#107D57" }), /* @__PURE__ */ y.createElement("path", { id: "Fill-11", opacity: 0.5, fillRule: "evenodd", clipRule: "evenodd", d: "M8.66683 1.99964C8.29877 2.36766 7.70135 2.36766 7.33329 1.99964C6.96524 1.63162 6.96524 1.03425 7.33329 0.666221C7.70135 0.298198 8.29877 0.298198 8.66683 0.666221C9.03489 1.03425 9.03489 1.63162 8.66683 1.99964Z", fill: "#107D57" }), /* @__PURE__ */ y.createElement("path", { id: "Fill-13", opacity: 0.5, fillRule: "evenodd", clipRule: "evenodd", d: "M15.3332 8.66676C14.9652 9.03478 14.3684 9.03545 13.9997 8.66675C13.631 8.29806 13.6316 7.70136 13.9997 7.33334C14.3677 6.96531 14.9645 6.96464 15.3332 7.33334C15.7019 7.70203 15.7013 8.29873 15.3332 8.66676Z", fill: "#107D57" }), /* @__PURE__ */ y.createElement("path", { id: "Fill-15", opacity: 0.5, fillRule: "evenodd", clipRule: "evenodd", d: "M8.66683 15.3339C8.29811 15.7026 7.70202 15.7026 7.33329 15.3339C6.96457 14.9652 6.96457 14.3691 7.33329 14.0004C7.70202 13.6318 8.29811 13.6318 8.66683 14.0005C9.03555 14.3691 9.03555 14.9652 8.66683 15.3339Z", fill: "#107D57" }), /* @__PURE__ */ y.createElement("path", { id: "Fill-17", opacity: 0.5, fillRule: "evenodd", clipRule: "evenodd", d: "M2.00033 8.66676C1.6316 9.03545 1.03484 9.03478 0.666788 8.66676C0.298732 8.29873 0.298065 7.70203 0.666788 7.33334C1.03551 6.96465 1.63227 6.96531 2.00033 7.33334C2.36838 7.70136 2.36905 8.29806 2.00033 8.66676Z", fill: "#107D57" }))), YV = (t) => /* @__PURE__ */ y.createElement("svg", { width: 23, height: 19, viewBox: "0 0 23 19", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0.406282 4.85302C0.406282 2.58132 2.24786 0.739746 4.51956 0.739746H18.2305C20.5022 0.739746 22.3437 2.58132 22.3437 4.85302C22.3437 7.12472 20.5022 8.96629 18.2305 8.96629H4.51955C2.24785 8.96629 0.406282 7.12472 0.406282 4.85302ZM1.97322 4.85306C1.97322 3.44677 3.11324 2.30675 4.51953 2.30675H16.0759V7.39937H4.51953C3.11324 7.39937 1.97322 6.25935 1.97322 4.85306Z", fill: "white" }), /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0.40625 14.6465C0.40625 12.3748 2.24783 10.5332 4.51952 10.5332H18.2304C20.5021 10.5332 22.3437 12.3748 22.3437 14.6465C22.3437 16.9182 20.5021 18.7597 18.2304 18.7597H4.51952C2.24782 18.7597 0.40625 16.9182 0.40625 14.6465ZM1.97322 14.6465C1.97322 13.2402 3.11324 12.1002 4.51953 12.1002H12.1585V17.1928H4.51953C3.11324 17.1928 1.97322 16.0528 1.97322 14.6465Z", fill: "white" })), TV = (t) => /* @__PURE__ */ y.createElement("svg", { width: 35, height: 35, viewBox: "0 0 35 35", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ y.createElement("path", { d: "M18.0391 21.544C18.4637 21.544 18.7634 21.2688 18.7884 20.8184C19.5129 14.9393 19.7877 14.7892 25.7831 13.7885C26.2576 13.7384 26.5324 13.4882 26.5324 13.0629C26.5324 12.6627 26.2576 12.4125 25.8831 12.3374L25.617 12.2868C19.8278 11.1861 19.5021 11.1241 18.7884 5.33245C18.7634 4.88213 18.4637 4.60693 18.0391 4.60693C17.6643 4.60693 17.3646 4.88213 17.3394 5.30743C16.5652 11.2867 16.3652 11.4618 10.2449 12.3374C9.87015 12.3875 9.59537 12.6627 9.59537 13.0629C9.59537 13.4632 9.87015 13.7384 10.2449 13.7885L10.4306 13.8249C16.3689 14.9894 16.5482 15.0246 17.3394 20.8685C17.3646 21.2688 17.6643 21.544 18.0391 21.544Z", fill: "white" }), /* @__PURE__ */ y.createElement("path", { d: "M22.6105 31.3153C22.8391 31.3153 23.0005 31.1672 23.014 30.9247C23.4041 27.759 23.5521 27.6781 26.7804 27.1393C27.0359 27.1124 27.1838 26.9776 27.1838 26.7486C27.1838 26.5331 27.0359 26.3984 26.8342 26.358L26.6909 26.3307C23.5737 25.738 23.3983 25.7047 23.014 22.5861C23.0005 22.3436 22.8391 22.1954 22.6105 22.1954C22.4087 22.1954 22.2473 22.3436 22.2338 22.5726C21.8169 25.7922 21.7092 25.8865 18.4136 26.358C18.2119 26.3849 18.0639 26.5331 18.0639 26.7486C18.0639 26.9642 18.2119 27.1124 18.4136 27.1393L18.5136 27.1589C21.7112 27.786 21.8077 27.8049 22.2338 30.9516C22.2473 31.1672 22.4087 31.3153 22.6105 31.3153Z", fill: "white" }), /* @__PURE__ */ y.createElement("path", { d: "M7.86401 20.6693C7.85634 20.8079 7.76411 20.8925 7.63346 20.8925C7.51815 20.8925 7.42593 20.8079 7.41819 20.6847C7.17473 18.8866 7.11956 18.8758 5.29238 18.5174L5.23526 18.5062C5.11995 18.4908 5.0354 18.4062 5.0354 18.283C5.0354 18.1598 5.11995 18.0752 5.23526 18.0598C7.11844 17.7903 7.17996 17.7365 7.41819 15.8967C7.42593 15.7658 7.51815 15.6811 7.63346 15.6811C7.76411 15.6811 7.85634 15.7658 7.86401 15.9044C8.08364 17.6864 8.18385 17.7055 9.96513 18.0442L10.047 18.0598C10.1623 18.0829 10.2468 18.1598 10.2468 18.283C10.2468 18.4139 10.1623 18.4908 10.0162 18.5062C8.1715 18.8141 8.08695 18.8603 7.86401 20.6693Z", fill: "white" })), LV = (t) => /* @__PURE__ */ y.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ y.createElement("g", { id: "Icon/Notification/Trivia" }, /* @__PURE__ */ y.createElement("path", { id: "Notification/Icon/Trivia", fillRule: "evenodd", clipRule: "evenodd", d: "M2.01663 1.3808C0.739913 1.55586 -0.153153 2.73276 0.021912 4.00948L1.3808 13.9196C1.55586 15.1963 2.73276 16.0894 4.00948 15.9143L13.9196 14.5554C15.1963 14.3803 16.0894 13.2034 15.9143 11.9267L14.5554 2.01663C14.3803 0.739913 13.2034 -0.153153 11.9267 0.021912L2.01663 1.3808ZM9.59613 3.788C9.11431 3.46991 8.47813 3.30151 7.7566 3.30151C7.54377 3.30151 7.32625 3.31671 7.10872 3.34478C6.38836 3.44067 5.68901 3.79034 5.18965 4.30138C4.68445 4.82062 4.4377 5.45563 4.51722 6.04151C4.57452 6.4742 4.90078 6.7537 5.34635 6.7537C5.39429 6.7537 5.44341 6.7502 5.49136 6.74435C6.08778 6.66483 6.21642 6.25436 6.34036 5.85675L6.34045 5.85648C6.48192 5.40401 6.61534 4.97731 7.38585 4.87444C7.46537 4.86391 7.54138 4.85806 7.61506 4.85806C8.16939 4.85806 8.51436 5.15042 8.58454 5.68252C8.65353 6.20293 8.24307 6.61807 7.80684 7.0566L7.80393 7.05954C7.31582 7.55231 6.7639 8.1095 6.86895 8.90083C6.89585 9.10548 6.9859 9.29493 7.12272 9.43644C7.27826 9.599 7.4829 9.68436 7.71331 9.68436C7.75541 9.68436 7.79868 9.68203 7.84311 9.67618C8.46691 9.59324 8.55162 9.23139 8.63338 8.8821L8.63365 8.88097L8.63661 8.86859C8.66723 8.7403 8.69877 8.60813 8.75995 8.48804C8.84649 8.31613 9.06283 8.11265 9.31428 7.87875C9.9142 7.31858 10.734 6.55143 10.582 5.41589C10.4872 4.70603 10.1551 4.15757 9.59611 3.78802L9.59613 3.788ZM8.11605 10.28C8.06927 10.28 8.02132 10.2836 7.97454 10.2894C7.38396 10.3689 6.96765 10.9127 7.04599 11.5033C7.11733 12.0377 7.57808 12.4412 8.1172 12.4412C8.16397 12.4412 8.21192 12.4377 8.25987 12.4318C8.85045 12.3523 9.2656 11.8085 9.18842 11.2179C9.11591 10.6823 8.65517 10.28 8.11605 10.28Z", fill: "white", fillOpacity: 0.5 }))), kV = (t) => /* @__PURE__ */ y.createElement("svg", { width: 17, height: 16, viewBox: "0 0 17 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ y.createElement("rect", { x: 0.5, width: 16, height: 16, rx: 8, fill: "white", style: {
  fill: "white",
  fillOpacity: 1
} }), /* @__PURE__ */ y.createElement("path", { d: "M4.75 8.5L7.09375 11L12.25 5", stroke: "#107D57", style: {
  stroke: "#107D57",
  stroke: "color(display-p3 0.0627 0.4902 0.3412)",
  strokeOpacity: 1
}, strokeLinecap: "round", strokeLinejoin: "round" })), JV = (t) => /* @__PURE__ */ y.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ y.createElement("path", { id: "Selected", fillRule: "evenodd", clipRule: "evenodd", d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM11.6057 5.43441C11.2933 5.12199 10.7868 5.12199 10.4744 5.43441L6.93812 9.97066L5.08382 8.73446C4.7162 8.48938 4.2195 8.58871 3.97442 8.95634C3.72934 9.32396 3.82868 9.82065 4.1963 10.0657L6.5963 11.6657C6.9136 11.8773 7.33609 11.8354 7.60574 11.5658L11.6057 6.56578C11.9182 6.25336 11.9182 5.74683 11.6057 5.43441Z", fill: "#107D57" })), xV = (t) => /* @__PURE__ */ y.createElement("svg", { width: 103, height: 18, viewBox: "0 0 103 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ y.createElement("g", { clipPath: "url(#clip0_6919_104497)" }, /* @__PURE__ */ y.createElement("path", { d: "M9.89618 3.45801C9.91951 3.45801 9.94451 3.46134 9.96784 3.46134C9.97618 3.46134 9.98284 3.46134 9.99118 3.46467H9.99784C10.0095 3.46467 10.0212 3.46801 10.0312 3.46801C10.0412 3.46801 10.0462 3.46801 10.0545 3.47134C10.0762 3.47467 10.0962 3.47467 10.1178 3.47634C10.1412 3.47967 10.1662 3.48134 10.1895 3.48467H10.2012C10.2462 3.48967 10.2945 3.49634 10.3395 3.50467C10.4512 3.52467 10.5595 3.54801 10.6662 3.57801C10.6928 3.58301 10.7178 3.59301 10.7445 3.60134H10.7478C10.7745 3.60967 10.7995 3.61801 10.8262 3.62467C10.8528 3.63301 10.8778 3.64134 10.9045 3.65134C10.9312 3.65967 10.9562 3.66801 10.9795 3.67967C11.0012 3.68801 11.0212 3.69634 11.0428 3.70634C11.0495 3.70967 11.0578 3.71134 11.0645 3.71467C11.0828 3.72301 11.1012 3.72967 11.1195 3.73801C11.1262 3.74134 11.1312 3.74301 11.1378 3.74634C11.1562 3.75467 11.1712 3.76134 11.1895 3.76967C11.1962 3.77301 11.2045 3.77467 11.2128 3.78134C11.2345 3.78967 11.2528 3.79801 11.2728 3.80967C11.2762 3.80967 11.2795 3.81301 11.2812 3.81301C11.3045 3.82467 11.3295 3.83634 11.3512 3.84801C11.3695 3.85634 11.3878 3.86801 11.4062 3.87634C11.4212 3.88134 11.4328 3.89134 11.4462 3.89967C11.4645 3.91134 11.4828 3.91967 11.5012 3.93134C11.5045 3.93467 11.5078 3.93467 11.5095 3.93634L11.5728 3.97467H11.5762L15.2178 6.18801L15.4412 6.32467C16.3228 6.90801 16.9028 7.88467 16.9028 8.99301C16.9028 10.1013 16.3262 11.0763 15.4445 11.6613L15.2095 11.803L11.5745 14.0113H11.5712L11.5078 14.0497C11.5078 14.0497 11.5012 14.053 11.4995 14.0547C11.4812 14.0663 11.4628 14.0747 11.4445 14.0863C11.4595 14.078 11.4745 14.0697 11.4895 14.0597L5.94951 17.433C5.94951 17.433 5.94618 17.433 5.94618 17.4363L5.74451 17.558H5.74118C5.19784 17.863 4.55784 18.0247 3.87784 17.993C2.73618 17.938 1.75784 17.3463 1.19284 16.4847C0.837844 15.9413 0.64451 15.2913 0.681177 14.6013C0.71451 13.983 0.922844 13.4147 1.26118 12.9397L1.26951 12.9247L4.04451 8.99634L6.77784 5.12634C6.81118 5.07967 6.84784 5.03301 6.87784 4.98467C6.87451 4.98967 6.86951 4.99967 6.86284 5.00467C6.87118 4.98967 6.88118 4.97634 6.88951 4.96134C6.88951 4.95801 6.89284 4.95801 6.89284 4.95634C6.89618 4.95301 6.89951 4.94801 6.90118 4.94467C6.90118 4.94467 6.90118 4.94134 6.90451 4.94134C6.91951 4.92134 6.93451 4.90134 6.94618 4.87801C6.96118 4.85801 6.97618 4.83801 6.99118 4.81634C7.00618 4.79634 7.02118 4.77634 7.03618 4.75467C7.03951 4.75134 7.03951 4.74967 7.04284 4.74634C7.04618 4.74301 7.04618 4.74134 7.04951 4.74134C7.06451 4.72134 7.07951 4.70134 7.09784 4.67967C7.10951 4.66467 7.12118 4.65134 7.13451 4.63634C7.16784 4.59801 7.20118 4.56134 7.23784 4.52301C7.25284 4.50801 7.26451 4.49467 7.27951 4.47967C7.30118 4.45634 7.32118 4.43634 7.34618 4.41634C7.36451 4.39967 7.38284 4.38134 7.40118 4.36467C7.41951 4.34801 7.43451 4.33301 7.45284 4.31801C7.45618 4.31467 7.45951 4.31301 7.45951 4.31301C7.47118 4.30134 7.48118 4.29301 7.49284 4.28467C7.50451 4.27301 7.51951 4.26134 7.53284 4.25301C7.53618 4.24967 7.53951 4.24801 7.54118 4.24801C7.55951 4.23301 7.57451 4.21967 7.59284 4.20467C7.60784 4.18967 7.62618 4.17801 7.64118 4.16634C7.65618 4.15467 7.66784 4.14634 7.68284 4.13467C7.70118 4.11967 7.71951 4.10801 7.73784 4.09467C7.75284 4.08634 7.76451 4.07467 7.77951 4.06634C7.78618 4.06134 7.79451 4.05467 7.80284 4.05134C7.81784 4.03967 7.83284 4.03134 7.84784 4.02301C7.85118 4.01967 7.85618 4.01801 7.85951 4.01467C7.87784 4.00301 7.89618 3.99134 7.91118 3.98301C7.91784 3.97801 7.92618 3.97467 7.93284 3.96801C7.94784 3.95967 7.95951 3.95134 7.97451 3.94134C7.98284 3.93634 7.99284 3.92967 8.00118 3.92467C8.01618 3.91634 8.03451 3.90801 8.04951 3.89634C8.05284 3.89301 8.05784 3.89134 8.06451 3.88801C8.08618 3.87634 8.10451 3.86467 8.12451 3.85634C8.12784 3.85301 8.13118 3.85301 8.13618 3.85134C8.15784 3.83967 8.17784 3.82801 8.19951 3.81967C8.19951 3.81967 8.20284 3.81967 8.20284 3.81634C8.22618 3.80467 8.24784 3.79301 8.27284 3.78134C8.27284 3.78134 8.27618 3.78134 8.27618 3.77801C8.29451 3.76967 8.31284 3.76134 8.33284 3.75134C8.34118 3.74801 8.35118 3.74301 8.35951 3.73967C8.37118 3.73467 8.38284 3.72801 8.39618 3.72467C8.41118 3.71967 8.42284 3.71301 8.43784 3.70801C8.46118 3.69967 8.48284 3.69134 8.50784 3.68134C8.52284 3.67634 8.53451 3.66967 8.54951 3.66634C8.57118 3.65801 8.59118 3.65134 8.61284 3.64301C8.63118 3.63801 8.65284 3.63134 8.66951 3.62301C8.75451 3.59634 8.83784 3.57134 8.92284 3.54967C8.94118 3.54467 8.96284 3.54134 8.97951 3.53801C9.08451 3.51467 9.19451 3.49467 9.30284 3.48301C9.32951 3.47967 9.35784 3.47801 9.38451 3.47467C9.42118 3.47134 9.45951 3.46967 9.49618 3.46634C9.51118 3.46634 9.52284 3.46301 9.53784 3.46301H9.55951C9.58951 3.46301 9.61618 3.45967 9.64784 3.45967H9.73784C9.79451 3.45967 9.84284 3.45967 9.89451 3.46301L9.89618 3.45801ZM10.6662 14.413C10.5612 14.4413 10.4512 14.4647 10.3395 14.4863C10.4512 14.4663 10.5595 14.443 10.6662 14.413ZM9.56118 14.5313H9.56951C9.56118 14.5313 9.54784 14.5313 9.53951 14.528C9.54618 14.528 9.55451 14.5313 9.56118 14.5313ZM7.08784 13.293C7.05451 13.253 7.02451 13.2147 6.99451 13.1747C7.02451 13.2147 7.05784 13.253 7.08784 13.293ZM6.90284 13.043C6.90284 13.043 6.90618 13.0463 6.90618 13.048C6.90284 13.0447 6.90284 13.043 6.89951 13.0363C6.89618 13.033 6.89618 13.0297 6.89284 13.0247C6.86951 12.9897 6.84784 12.953 6.82284 12.918C6.84451 12.953 6.86784 12.9913 6.88951 13.0247C6.89618 13.0297 6.89784 13.0363 6.90118 13.0413L6.90284 13.043ZM6.89451 13.0263C6.85784 12.968 6.81951 12.913 6.77618 12.858L6.89451 13.0263Z", fill: "#1652A8", style: {
  fill: "#1652A8",
  fill: "color(display-p3 0.0863 0.3216 0.6588)",
  fillOpacity: 1
} }), /* @__PURE__ */ y.createElement("g", { opacity: 0.85 }, /* @__PURE__ */ y.createElement("path", { d: "M5.77088 0.453306L5.97588 0.578306L5.97921 0.581639L11.5225 3.94997C11.5075 3.94164 11.4925 3.93331 11.4775 3.92331C11.4959 3.93497 11.5142 3.94331 11.5325 3.95497C11.5359 3.95831 11.5392 3.95831 11.5409 3.95997L11.6042 3.99831H11.6075L15.2492 6.21164L15.4725 6.34831C16.3542 6.93164 16.9342 7.9083 16.9342 9.01664C16.9342 10.125 16.3575 11.1 15.4759 11.685L15.2409 11.8266L11.6059 14.035H11.6025L11.5392 14.0733C11.5392 14.0733 11.5325 14.0766 11.5309 14.0783C11.5125 14.09 11.4942 14.0983 11.4759 14.11C11.4642 14.1183 11.4492 14.125 11.4359 14.1333C11.4175 14.145 11.3992 14.1533 11.3809 14.1616C11.3575 14.1733 11.3359 14.185 11.3109 14.1966C11.3075 14.2 11.3042 14.2 11.3025 14.2C11.2842 14.2116 11.2625 14.22 11.2425 14.2283C11.2359 14.2316 11.2275 14.2333 11.2192 14.24C11.2009 14.2483 11.1859 14.255 11.1675 14.2633C11.1609 14.2666 11.1592 14.2683 11.1525 14.2683C11.1309 14.2766 11.1109 14.285 11.0859 14.2966C11.0625 14.3083 11.0342 14.3166 11.0109 14.325C10.9875 14.3333 10.9592 14.345 10.9359 14.3533C10.9092 14.3616 10.8842 14.37 10.8575 14.38C10.8309 14.3883 10.8059 14.3966 10.7792 14.4033H10.7759C10.7492 14.4116 10.7242 14.4183 10.6975 14.4266C10.5925 14.455 10.4825 14.4783 10.3709 14.4983C10.3259 14.5066 10.2775 14.5133 10.2325 14.5183C10.2259 14.5183 10.2242 14.5183 10.2209 14.5216C10.1975 14.525 10.1725 14.5283 10.1492 14.53C10.1009 14.5366 10.0525 14.5383 10.0042 14.5416C9.92921 14.5483 9.85254 14.5483 9.77754 14.5483H9.68088C9.65421 14.5483 9.62921 14.545 9.60254 14.545C9.59421 14.545 9.58088 14.545 9.57254 14.5416C9.53254 14.5383 9.49088 14.5366 9.45254 14.5333C9.27421 14.5166 9.09588 14.4866 8.92754 14.4466C8.90421 14.44 8.87921 14.435 8.85254 14.4266C8.81921 14.4183 8.78588 14.41 8.74921 14.3983C8.73088 14.3933 8.70921 14.3866 8.69254 14.3816C8.66588 14.3733 8.64088 14.365 8.61421 14.355C8.58754 14.3466 8.56254 14.3383 8.53921 14.3266C8.51588 14.3183 8.48754 14.3066 8.46421 14.2983C8.44088 14.29 8.41921 14.2816 8.39754 14.27C8.38921 14.2666 8.38254 14.265 8.37421 14.2583C8.35588 14.25 8.33754 14.2416 8.31754 14.2316C8.31754 14.2316 8.31421 14.2316 8.31421 14.2283C8.29088 14.2166 8.26588 14.205 8.24254 14.1933C8.21921 14.1816 8.19421 14.17 8.17088 14.155C8.14754 14.1433 8.12254 14.1283 8.10088 14.1166C8.07754 14.105 8.05254 14.09 8.03088 14.0766C8.00754 14.0616 7.98588 14.0483 7.96088 14.0366C7.93754 14.0216 7.91588 14.0083 7.89421 13.9933C7.87254 13.9783 7.85254 13.965 7.83088 13.95C7.82754 13.95 7.82754 13.9466 7.82421 13.945C7.80588 13.9333 7.78754 13.9183 7.76754 13.905C7.76421 13.9016 7.76088 13.9016 7.75921 13.9C7.74088 13.885 7.72254 13.8733 7.70421 13.86C7.70088 13.8566 7.69588 13.855 7.69254 13.8483C7.67421 13.8333 7.65588 13.82 7.63754 13.805C7.63754 13.805 7.63421 13.805 7.63421 13.8016C7.61588 13.7866 7.59754 13.7733 7.57754 13.755C7.57421 13.7516 7.57088 13.7516 7.56921 13.7483C7.55421 13.7366 7.53921 13.7216 7.52421 13.71C7.51754 13.705 7.51254 13.6983 7.50588 13.695C7.49421 13.6833 7.47921 13.6716 7.46588 13.66C7.43921 13.6366 7.41421 13.6133 7.39088 13.5866C7.37254 13.57 7.35754 13.5516 7.33921 13.535C7.32754 13.5233 7.31754 13.5116 7.30588 13.5C7.29421 13.4883 7.28421 13.48 7.27588 13.4683C7.25754 13.4516 7.24254 13.43 7.22421 13.4133C7.19088 13.375 7.15754 13.3383 7.12421 13.2966C7.09088 13.2566 7.06088 13.2183 7.03088 13.1783C7.01588 13.1583 7.00088 13.1383 6.98588 13.1166C6.97088 13.0966 6.95588 13.0766 6.94421 13.0533C6.94088 13.05 6.94088 13.0483 6.93754 13.0416C6.93421 13.0383 6.93421 13.0366 6.93088 13.03C6.90754 12.995 6.88588 12.9583 6.86088 12.9233C6.88254 12.9583 6.90588 12.995 6.92754 13.03C6.89088 12.9716 6.85254 12.9166 6.80921 12.8616L4.07921 8.99664L1.34088 5.12997L1.23254 4.97664L1.22921 4.97164C0.92421 4.51164 0.737543 3.97497 0.707543 3.39497C0.670877 2.70497 0.86421 2.05164 1.22088 1.50997C1.78588 0.648306 2.76588 0.0566391 3.90421 -2.75556e-05C4.58421 -0.0150276 5.22421 0.148306 5.77088 0.453306Z", fill: "url(#paint0_linear_6919_104497)", style: {} })), /* @__PURE__ */ y.createElement("path", { d: "M32.4132 12.862C31.2015 12.862 30.4482 12.0503 30.4482 10.7203V8.4453H32.6632V7.02697H30.4482V4.72363L28.8548 5.9053V7.0253H27.9648V8.44363H28.8548V10.7053C28.8548 12.9953 30.1982 14.412 32.4282 14.412H32.7682V12.862H32.4132Z", fill: "#687C8B", style: {
  fill: "#687C8B",
  fill: "color(display-p3 0.4078 0.4863 0.5451)",
  fillOpacity: 1
} }), /* @__PURE__ */ y.createElement("path", { d: "M19.9812 12.5767L21.4028 11.4651C22.0395 12.4867 22.8995 13.0351 23.9962 13.0351C25.1962 13.0351 25.9512 12.2651 25.9512 11.3017C25.9512 10.1901 24.7662 9.83506 23.5212 9.43506C22.0545 8.96172 20.4695 8.36839 20.4695 6.38339C20.4695 4.73839 21.9362 3.43506 23.9362 3.43506C25.5812 3.43506 26.6028 4.07172 27.4328 5.03506L26.1145 6.01339C25.6262 5.25839 24.8995 4.85839 23.9362 4.85839C22.8395 4.85839 22.1278 5.51006 22.1278 6.35506C22.1278 7.39172 23.2695 7.73339 24.5128 8.14839C25.9945 8.65172 27.6095 9.29006 27.6095 11.3051C27.6095 12.9651 26.2462 14.5501 24.0095 14.5501C22.1578 14.5501 20.8978 13.7651 19.9795 12.5801L19.9812 12.5767Z", fill: "#687C8B", style: {
  fill: "#687C8B",
  fill: "color(display-p3 0.4078 0.4863 0.5451)",
  fillOpacity: 1
} }), /* @__PURE__ */ y.createElement("path", { d: "M38.2695 10.7367C38.2695 8.56503 39.9379 6.8667 42.1095 6.8667C44.2812 6.8667 45.9062 8.4467 45.9062 10.6334V11.2534H39.7912C39.9979 12.39 40.8845 13.1434 42.1695 13.1434C43.1745 13.1434 43.9429 12.6117 44.3262 11.8134L45.6262 12.5367C44.9762 13.7484 43.8095 14.545 42.1695 14.545C39.8362 14.545 38.2695 12.8767 38.2695 10.735V10.7367ZM39.8645 9.91003H44.2962C44.0595 8.8467 43.2479 8.25503 42.1095 8.25503C40.9712 8.25503 40.1595 8.93503 39.8645 9.91003Z", fill: "#687C8B", style: {
  fill: "#687C8B",
  fill: "color(display-p3 0.4078 0.4863 0.5451)",
  fillOpacity: 1
} }), /* @__PURE__ */ y.createElement("path", { d: "M33.7549 10.72C33.7549 8.42999 35.0982 7.02832 37.3282 7.02832H38.0366V8.56499H37.3132C36.1016 8.56499 35.3199 9.40665 35.3349 10.7367V14.415H33.7549V10.7233V10.72Z", fill: "#687C8B", style: {
  fill: "#687C8B",
  fill: "color(display-p3 0.4078 0.4863 0.5451)",
  fillOpacity: 1
} }), /* @__PURE__ */ y.createElement("path", { d: "M46.6882 10.7218C46.6882 8.56517 48.3865 6.88184 50.5132 6.88184C52.6399 6.88184 54.3082 8.56517 54.3082 10.7218V14.4135H52.7582V13.4535C52.2415 14.1468 51.4432 14.5468 50.4682 14.5468C48.3565 14.5468 46.6865 12.8935 46.6865 10.7218H46.6882ZM52.7882 10.7218C52.7882 9.40684 51.7832 8.3585 50.5132 8.3585C49.2432 8.3585 48.2382 9.40684 48.2382 10.7218C48.2382 12.0368 49.2282 13.0852 50.5132 13.0852C51.7982 13.0852 52.7882 12.0218 52.7882 10.7218Z", fill: "#687C8B", style: {
  fill: "#687C8B",
  fill: "color(display-p3 0.4078 0.4863 0.5451)",
  fillOpacity: 1
} }), /* @__PURE__ */ y.createElement("path", { d: "M55.3027 10.2717C55.3027 8.30667 56.6461 6.875 58.6411 6.875C59.7777 6.875 60.6944 7.33333 61.2694 8.10167C61.8161 7.33333 62.7027 6.875 63.8394 6.875C65.8477 6.875 67.2511 8.27833 67.2511 10.2717V14.4067H65.6711V10.2867C65.6711 9.165 64.9177 8.38167 63.8394 8.38167C62.7611 8.38167 62.0527 9.18 62.0677 10.2433V14.4083H60.4877V10.2883C60.4877 9.16667 59.7194 8.38333 58.6411 8.38333C57.5627 8.38333 56.8694 9.18167 56.8827 10.245V14.41H55.3027V10.275V10.2717Z", fill: "#687C8B", style: {
  fill: "#687C8B",
  fill: "color(display-p3 0.4078 0.4863 0.5451)",
  fillOpacity: 1
} }), /* @__PURE__ */ y.createElement("path", { d: "M68.2646 3.62695H69.8746V12.872H74.2313V14.4086H68.2646V3.62695Z", fill: "#687C8B", style: {
  fill: "#687C8B",
  fill: "color(display-p3 0.4078 0.4863 0.5451)",
  fillOpacity: 1
} }), /* @__PURE__ */ y.createElement("path", { d: "M89.418 10.7367C89.418 8.56503 91.0863 6.8667 93.258 6.8667C95.4296 6.8667 97.0546 8.4467 97.0546 10.6334V11.2534H90.9396C91.1463 12.39 92.033 13.1434 93.318 13.1434C94.323 13.1434 95.0913 12.6117 95.4746 11.8134L96.7746 12.5367C96.1246 13.7484 94.958 14.545 93.318 14.545C90.9846 14.545 89.418 12.8767 89.418 10.735V10.7367ZM91.013 9.91003H95.4446C95.208 8.8467 94.3963 8.25503 93.258 8.25503C92.1196 8.25503 91.308 8.93503 91.013 9.91003Z", fill: "#687C8B", style: {
  fill: "#687C8B",
  fill: "color(display-p3 0.4078 0.4863 0.5451)",
  fillOpacity: 1
} }), /* @__PURE__ */ y.createElement("path", { d: "M74.4948 10.7218C74.4948 8.56517 76.1932 6.88184 78.3198 6.88184C80.4465 6.88184 82.1148 8.56517 82.1148 10.7218V14.4135H80.5648V13.4535C80.0482 14.1468 79.2498 14.5468 78.2748 14.5468C76.1632 14.5468 74.4932 12.8935 74.4932 10.7218H74.4948ZM80.5948 10.7218C80.5948 9.40684 79.5898 8.3585 78.3198 8.3585C77.0498 8.3585 76.0448 9.40684 76.0448 10.7218C76.0448 12.0368 77.0348 13.0852 78.3198 13.0852C79.6048 13.0852 80.5948 12.0218 80.5948 10.7218Z", fill: "#687C8B", style: {
  fill: "#687C8B",
  fill: "color(display-p3 0.4078 0.4863 0.5451)",
  fillOpacity: 1
} }), /* @__PURE__ */ y.createElement("path", { d: "M85.0381 14.0498L81.9814 7.0498H83.6798L85.8364 12.1748L87.8748 7.0498H89.5431L85.0831 17.8465H83.4581L85.0381 14.0515V14.0498Z", fill: "#687C8B", style: {
  fill: "#687C8B",
  fill: "color(display-p3 0.4078 0.4863 0.5451)",
  fillOpacity: 1
} }), /* @__PURE__ */ y.createElement("path", { d: "M98.041 10.7151C98.041 8.4251 99.3843 7.02344 101.614 7.02344H102.323V8.5601H101.599C100.388 8.5601 99.606 9.40177 99.621 10.7318V14.4101H98.041V10.7184V10.7151Z", fill: "#687C8B", style: {
  fill: "#687C8B",
  fill: "color(display-p3 0.4078 0.4863 0.5451)",
  fillOpacity: 1
} })), /* @__PURE__ */ y.createElement("defs", null, /* @__PURE__ */ y.createElement("linearGradient", { id: "paint0_linear_6919_104497", x1: 4.31754, y1: 8.70664, x2: 13.6359, y2: 3.59497, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ y.createElement("stop", { offset: 0.2, stopColor: "#1589EE", style: {
  stopColor: "#1589EE",
  stopColor: "color(display-p3 0.0824 0.5373 0.9333)",
  stopOpacity: 1
} }), /* @__PURE__ */ y.createElement("stop", { offset: 1, stopColor: "#5EB4FF", style: {
  stopColor: "#5EB4FF",
  stopColor: "color(display-p3 0.3686 0.7059 1.0000)",
  stopOpacity: 1
} })), /* @__PURE__ */ y.createElement("clipPath", { id: "clip0_6919_104497" }, /* @__PURE__ */ y.createElement("rect", { width: 101.648, height: 18, fill: "white", style: {
  fill: "white",
  fillOpacity: 1
}, transform: "translate(0.675781)" })))), MV = (t) => /* @__PURE__ */ y.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ y.createElement("g", { id: "Frame 3469523" }, /* @__PURE__ */ y.createElement("rect", { x: 0.5, y: 0.5, width: 17, height: 17, rx: 8.5, fill: "black" }), /* @__PURE__ */ y.createElement("rect", { x: 0.5, y: 0.5, width: 17, height: 17, rx: 8.5, stroke: "#F2F2F1" }), /* @__PURE__ */ y.createElement("g", { id: "layer1" }, /* @__PURE__ */ y.createElement("path", { id: "path1009", d: "M5.10046 5L8.32856 9.3097L5.08008 12.8137H5.81118L8.65522 9.74589L10.9531 12.8137H13.4411L10.0314 8.26155L13.055 5H12.3239L9.70471 7.82536L7.58843 5H5.10046ZM6.1756 5.53771H7.31858L12.3658 12.2759H11.2228L6.1756 5.53771Z", fill: "white" })))), Ch = {
  "invite-game-icon": WV,
  "icon-trophy": VV,
  "icon-trophy-green": bV,
  "icon-trophy-solid": AV,
  "icon-trivia": LV,
  "icon-thumb-down": mV,
  "icon-thumb-up": pV,
  "icon-star": dV,
  "icon-prediction": TV,
  "icon-insight": wV,
  "icon-poll": YV,
  "icon-play": uV,
  "icon-pause": cV,
  "icon-masters-logo": lV,
  "icon-logout": oV,
  "icon-link": rV,
  "icon-external-link": nV,
  "icon-invite-arrow": sV,
  "icon-friends": iV,
  "icon-exit": tV,
  "icon-default-user-avatar": q6,
  "icon-copy": j6,
  "icon-cross": Y6,
  "icon-close": P6,
  "icon-close-btn-white": D6,
  "icon-close-btn-gray": O6,
  "icon-circle-arrow-right": H6,
  "icon-chevron": K6,
  "icon-chevron-white-left": z6,
  "icon-chevron-left": Q6,
  "icon-check": X6,
  "icon-check-white": M6,
  "icon-check-green": x6,
  "icon-check-circle": J6,
  "icon-correct": w6,
  "icon-btn-channels": IV,
  "icon-btn-feature-groups": NV,
  "icon-btn-leaderboard": FV,
  "icon-arrow": G6,
  "icon-twitter-verified": RV,
  "icon-trophy-bet-pack": fV,
  "icon-trivia-transparent": gV,
  dashboard: $6,
  iconMute: aV,
  iconUnMute: EV,
  correct: XV,
  iconSkip: hV,
  incorrect: UV,
  questionExpired: BV,
  selected: JV,
  selectedBetPack: kV,
  circleClose: B6,
  incorrectVoted: CV,
  mastersLogo: ZV,
  streamLayerLogo: xV,
  twitter: MV,
  iconUp: yV,
  iconCopySuccess: _6,
  chevronRight: U6,
  noImageIcon: GV,
  iconArrowRight: k6,
  iconEarlyPrediction: eV,
  iconArrowPrev: L6,
  mastersLogoWhite: vV,
  loader: SV,
  fgIcon: T6
}, oe = ({
  name: t,
  style: e,
  className: n,
  ...i
}) => {
  if (!Ch[t])
    return /* @__PURE__ */ f("span", {
      children: t
    });
  const s = Ch[t];
  return /* @__PURE__ */ f(s, {
    "data-testid": "svg-icon",
    style: e,
    className: n,
    ...i
  });
};
var kn = {}, Wo = { exports: {} }, So, Wh;
function QV() {
  if (Wh) return So;
  Wh = 1;
  var t = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return So = t, So;
}
var Zo, Sh;
function zV() {
  if (Sh) return Zo;
  Sh = 1;
  var t = /* @__PURE__ */ QV();
  function e() {
  }
  function n() {
  }
  return n.resetWarningCache = e, Zo = function() {
    function i(o, l, a, c, u, h) {
      if (h !== t) {
        var d = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw d.name = "Invariant Violation", d;
      }
    }
    i.isRequired = i;
    function s() {
      return i;
    }
    var r = {
      array: i,
      bigint: i,
      bool: i,
      func: i,
      number: i,
      object: i,
      string: i,
      symbol: i,
      any: i,
      arrayOf: s,
      element: i,
      elementType: i,
      instanceOf: s,
      node: i,
      objectOf: s,
      oneOf: s,
      oneOfType: s,
      shape: s,
      exact: s,
      checkPropTypes: n,
      resetWarningCache: e
    };
    return r.PropTypes = r, r;
  }, Zo;
}
var Zh;
function T2() {
  return Zh || (Zh = 1, Wo.exports = /* @__PURE__ */ zV()()), Wo.exports;
}
var vo, vh;
function L2() {
  return vh || (vh = 1, vo = {
    L: 1,
    M: 0,
    Q: 3,
    H: 2
  }), vo;
}
var Io, Ih;
function k2() {
  return Ih || (Ih = 1, Io = {
    MODE_NUMBER: 1,
    MODE_ALPHA_NUM: 2,
    MODE_8BIT_BYTE: 4,
    MODE_KANJI: 8
  }), Io;
}
var No, Nh;
function KV() {
  if (Nh) return No;
  Nh = 1;
  var t = k2();
  function e(n) {
    this.mode = t.MODE_8BIT_BYTE, this.data = n;
  }
  return e.prototype = {
    getLength: function(n) {
      return this.data.length;
    },
    write: function(n) {
      for (var i = 0; i < this.data.length; i++)
        n.put(this.data.charCodeAt(i), 8);
    }
  }, No = e, No;
}
var Fo, Fh;
function HV() {
  if (Fh) return Fo;
  Fh = 1;
  var t = L2();
  function e(n, i) {
    this.totalCount = n, this.dataCount = i;
  }
  return e.RS_BLOCK_TABLE = [
    // L
    // M
    // Q
    // H
    // 1
    [1, 26, 19],
    [1, 26, 16],
    [1, 26, 13],
    [1, 26, 9],
    // 2
    [1, 44, 34],
    [1, 44, 28],
    [1, 44, 22],
    [1, 44, 16],
    // 3
    [1, 70, 55],
    [1, 70, 44],
    [2, 35, 17],
    [2, 35, 13],
    // 4		
    [1, 100, 80],
    [2, 50, 32],
    [2, 50, 24],
    [4, 25, 9],
    // 5
    [1, 134, 108],
    [2, 67, 43],
    [2, 33, 15, 2, 34, 16],
    [2, 33, 11, 2, 34, 12],
    // 6
    [2, 86, 68],
    [4, 43, 27],
    [4, 43, 19],
    [4, 43, 15],
    // 7		
    [2, 98, 78],
    [4, 49, 31],
    [2, 32, 14, 4, 33, 15],
    [4, 39, 13, 1, 40, 14],
    // 8
    [2, 121, 97],
    [2, 60, 38, 2, 61, 39],
    [4, 40, 18, 2, 41, 19],
    [4, 40, 14, 2, 41, 15],
    // 9
    [2, 146, 116],
    [3, 58, 36, 2, 59, 37],
    [4, 36, 16, 4, 37, 17],
    [4, 36, 12, 4, 37, 13],
    // 10		
    [2, 86, 68, 2, 87, 69],
    [4, 69, 43, 1, 70, 44],
    [6, 43, 19, 2, 44, 20],
    [6, 43, 15, 2, 44, 16],
    // 11
    [4, 101, 81],
    [1, 80, 50, 4, 81, 51],
    [4, 50, 22, 4, 51, 23],
    [3, 36, 12, 8, 37, 13],
    // 12
    [2, 116, 92, 2, 117, 93],
    [6, 58, 36, 2, 59, 37],
    [4, 46, 20, 6, 47, 21],
    [7, 42, 14, 4, 43, 15],
    // 13
    [4, 133, 107],
    [8, 59, 37, 1, 60, 38],
    [8, 44, 20, 4, 45, 21],
    [12, 33, 11, 4, 34, 12],
    // 14
    [3, 145, 115, 1, 146, 116],
    [4, 64, 40, 5, 65, 41],
    [11, 36, 16, 5, 37, 17],
    [11, 36, 12, 5, 37, 13],
    // 15
    [5, 109, 87, 1, 110, 88],
    [5, 65, 41, 5, 66, 42],
    [5, 54, 24, 7, 55, 25],
    [11, 36, 12],
    // 16
    [5, 122, 98, 1, 123, 99],
    [7, 73, 45, 3, 74, 46],
    [15, 43, 19, 2, 44, 20],
    [3, 45, 15, 13, 46, 16],
    // 17
    [1, 135, 107, 5, 136, 108],
    [10, 74, 46, 1, 75, 47],
    [1, 50, 22, 15, 51, 23],
    [2, 42, 14, 17, 43, 15],
    // 18
    [5, 150, 120, 1, 151, 121],
    [9, 69, 43, 4, 70, 44],
    [17, 50, 22, 1, 51, 23],
    [2, 42, 14, 19, 43, 15],
    // 19
    [3, 141, 113, 4, 142, 114],
    [3, 70, 44, 11, 71, 45],
    [17, 47, 21, 4, 48, 22],
    [9, 39, 13, 16, 40, 14],
    // 20
    [3, 135, 107, 5, 136, 108],
    [3, 67, 41, 13, 68, 42],
    [15, 54, 24, 5, 55, 25],
    [15, 43, 15, 10, 44, 16],
    // 21
    [4, 144, 116, 4, 145, 117],
    [17, 68, 42],
    [17, 50, 22, 6, 51, 23],
    [19, 46, 16, 6, 47, 17],
    // 22
    [2, 139, 111, 7, 140, 112],
    [17, 74, 46],
    [7, 54, 24, 16, 55, 25],
    [34, 37, 13],
    // 23
    [4, 151, 121, 5, 152, 122],
    [4, 75, 47, 14, 76, 48],
    [11, 54, 24, 14, 55, 25],
    [16, 45, 15, 14, 46, 16],
    // 24
    [6, 147, 117, 4, 148, 118],
    [6, 73, 45, 14, 74, 46],
    [11, 54, 24, 16, 55, 25],
    [30, 46, 16, 2, 47, 17],
    // 25
    [8, 132, 106, 4, 133, 107],
    [8, 75, 47, 13, 76, 48],
    [7, 54, 24, 22, 55, 25],
    [22, 45, 15, 13, 46, 16],
    // 26
    [10, 142, 114, 2, 143, 115],
    [19, 74, 46, 4, 75, 47],
    [28, 50, 22, 6, 51, 23],
    [33, 46, 16, 4, 47, 17],
    // 27
    [8, 152, 122, 4, 153, 123],
    [22, 73, 45, 3, 74, 46],
    [8, 53, 23, 26, 54, 24],
    [12, 45, 15, 28, 46, 16],
    // 28
    [3, 147, 117, 10, 148, 118],
    [3, 73, 45, 23, 74, 46],
    [4, 54, 24, 31, 55, 25],
    [11, 45, 15, 31, 46, 16],
    // 29
    [7, 146, 116, 7, 147, 117],
    [21, 73, 45, 7, 74, 46],
    [1, 53, 23, 37, 54, 24],
    [19, 45, 15, 26, 46, 16],
    // 30
    [5, 145, 115, 10, 146, 116],
    [19, 75, 47, 10, 76, 48],
    [15, 54, 24, 25, 55, 25],
    [23, 45, 15, 25, 46, 16],
    // 31
    [13, 145, 115, 3, 146, 116],
    [2, 74, 46, 29, 75, 47],
    [42, 54, 24, 1, 55, 25],
    [23, 45, 15, 28, 46, 16],
    // 32
    [17, 145, 115],
    [10, 74, 46, 23, 75, 47],
    [10, 54, 24, 35, 55, 25],
    [19, 45, 15, 35, 46, 16],
    // 33
    [17, 145, 115, 1, 146, 116],
    [14, 74, 46, 21, 75, 47],
    [29, 54, 24, 19, 55, 25],
    [11, 45, 15, 46, 46, 16],
    // 34
    [13, 145, 115, 6, 146, 116],
    [14, 74, 46, 23, 75, 47],
    [44, 54, 24, 7, 55, 25],
    [59, 46, 16, 1, 47, 17],
    // 35
    [12, 151, 121, 7, 152, 122],
    [12, 75, 47, 26, 76, 48],
    [39, 54, 24, 14, 55, 25],
    [22, 45, 15, 41, 46, 16],
    // 36
    [6, 151, 121, 14, 152, 122],
    [6, 75, 47, 34, 76, 48],
    [46, 54, 24, 10, 55, 25],
    [2, 45, 15, 64, 46, 16],
    // 37
    [17, 152, 122, 4, 153, 123],
    [29, 74, 46, 14, 75, 47],
    [49, 54, 24, 10, 55, 25],
    [24, 45, 15, 46, 46, 16],
    // 38
    [4, 152, 122, 18, 153, 123],
    [13, 74, 46, 32, 75, 47],
    [48, 54, 24, 14, 55, 25],
    [42, 45, 15, 32, 46, 16],
    // 39
    [20, 147, 117, 4, 148, 118],
    [40, 75, 47, 7, 76, 48],
    [43, 54, 24, 22, 55, 25],
    [10, 45, 15, 67, 46, 16],
    // 40
    [19, 148, 118, 6, 149, 119],
    [18, 75, 47, 31, 76, 48],
    [34, 54, 24, 34, 55, 25],
    [20, 45, 15, 61, 46, 16]
  ], e.getRSBlocks = function(n, i) {
    var s = e.getRsBlockTable(n, i);
    if (s == null)
      throw new Error("bad rs block @ typeNumber:" + n + "/errorCorrectLevel:" + i);
    for (var r = s.length / 3, o = new Array(), l = 0; l < r; l++)
      for (var a = s[l * 3 + 0], c = s[l * 3 + 1], u = s[l * 3 + 2], h = 0; h < a; h++)
        o.push(new e(c, u));
    return o;
  }, e.getRsBlockTable = function(n, i) {
    switch (i) {
      case t.L:
        return e.RS_BLOCK_TABLE[(n - 1) * 4 + 0];
      case t.M:
        return e.RS_BLOCK_TABLE[(n - 1) * 4 + 1];
      case t.Q:
        return e.RS_BLOCK_TABLE[(n - 1) * 4 + 2];
      case t.H:
        return e.RS_BLOCK_TABLE[(n - 1) * 4 + 3];
      default:
        return;
    }
  }, Fo = e, Fo;
}
var Go, Gh;
function OV() {
  if (Gh) return Go;
  Gh = 1;
  function t() {
    this.buffer = new Array(), this.length = 0;
  }
  return t.prototype = {
    get: function(e) {
      var n = Math.floor(e / 8);
      return (this.buffer[n] >>> 7 - e % 8 & 1) == 1;
    },
    put: function(e, n) {
      for (var i = 0; i < n; i++)
        this.putBit((e >>> n - i - 1 & 1) == 1);
    },
    getLengthInBits: function() {
      return this.length;
    },
    putBit: function(e) {
      var n = Math.floor(this.length / 8);
      this.buffer.length <= n && this.buffer.push(0), e && (this.buffer[n] |= 128 >>> this.length % 8), this.length++;
    }
  }, Go = t, Go;
}
var Xo, Xh;
function J2() {
  if (Xh) return Xo;
  Xh = 1;
  for (var t = {
    glog: function(n) {
      if (n < 1)
        throw new Error("glog(" + n + ")");
      return t.LOG_TABLE[n];
    },
    gexp: function(n) {
      for (; n < 0; )
        n += 255;
      for (; n >= 256; )
        n -= 255;
      return t.EXP_TABLE[n];
    },
    EXP_TABLE: new Array(256),
    LOG_TABLE: new Array(256)
  }, e = 0; e < 8; e++)
    t.EXP_TABLE[e] = 1 << e;
  for (var e = 8; e < 256; e++)
    t.EXP_TABLE[e] = t.EXP_TABLE[e - 4] ^ t.EXP_TABLE[e - 5] ^ t.EXP_TABLE[e - 6] ^ t.EXP_TABLE[e - 8];
  for (var e = 0; e < 255; e++)
    t.LOG_TABLE[t.EXP_TABLE[e]] = e;
  return Xo = t, Xo;
}
var Uo, Uh;
function x2() {
  if (Uh) return Uo;
  Uh = 1;
  var t = J2();
  function e(n, i) {
    if (n.length == null)
      throw new Error(n.length + "/" + i);
    for (var s = 0; s < n.length && n[s] == 0; )
      s++;
    this.num = new Array(n.length - s + i);
    for (var r = 0; r < n.length - s; r++)
      this.num[r] = n[r + s];
  }
  return e.prototype = {
    get: function(n) {
      return this.num[n];
    },
    getLength: function() {
      return this.num.length;
    },
    multiply: function(n) {
      for (var i = new Array(this.getLength() + n.getLength() - 1), s = 0; s < this.getLength(); s++)
        for (var r = 0; r < n.getLength(); r++)
          i[s + r] ^= t.gexp(t.glog(this.get(s)) + t.glog(n.get(r)));
      return new e(i, 0);
    },
    mod: function(n) {
      if (this.getLength() - n.getLength() < 0)
        return this;
      for (var i = t.glog(this.get(0)) - t.glog(n.get(0)), s = new Array(this.getLength()), r = 0; r < this.getLength(); r++)
        s[r] = this.get(r);
      for (var r = 0; r < n.getLength(); r++)
        s[r] ^= t.gexp(t.glog(n.get(r)) + i);
      return new e(s, 0).mod(n);
    }
  }, Uo = e, Uo;
}
var Bo, Bh;
function DV() {
  if (Bh) return Bo;
  Bh = 1;
  var t = k2(), e = x2(), n = J2(), i = {
    PATTERN000: 0,
    PATTERN001: 1,
    PATTERN010: 2,
    PATTERN011: 3,
    PATTERN100: 4,
    PATTERN101: 5,
    PATTERN110: 6,
    PATTERN111: 7
  }, s = {
    PATTERN_POSITION_TABLE: [
      [],
      [6, 18],
      [6, 22],
      [6, 26],
      [6, 30],
      [6, 34],
      [6, 22, 38],
      [6, 24, 42],
      [6, 26, 46],
      [6, 28, 50],
      [6, 30, 54],
      [6, 32, 58],
      [6, 34, 62],
      [6, 26, 46, 66],
      [6, 26, 48, 70],
      [6, 26, 50, 74],
      [6, 30, 54, 78],
      [6, 30, 56, 82],
      [6, 30, 58, 86],
      [6, 34, 62, 90],
      [6, 28, 50, 72, 94],
      [6, 26, 50, 74, 98],
      [6, 30, 54, 78, 102],
      [6, 28, 54, 80, 106],
      [6, 32, 58, 84, 110],
      [6, 30, 58, 86, 114],
      [6, 34, 62, 90, 118],
      [6, 26, 50, 74, 98, 122],
      [6, 30, 54, 78, 102, 126],
      [6, 26, 52, 78, 104, 130],
      [6, 30, 56, 82, 108, 134],
      [6, 34, 60, 86, 112, 138],
      [6, 30, 58, 86, 114, 142],
      [6, 34, 62, 90, 118, 146],
      [6, 30, 54, 78, 102, 126, 150],
      [6, 24, 50, 76, 102, 128, 154],
      [6, 28, 54, 80, 106, 132, 158],
      [6, 32, 58, 84, 110, 136, 162],
      [6, 26, 54, 82, 110, 138, 166],
      [6, 30, 58, 86, 114, 142, 170]
    ],
    G15: 1335,
    G18: 7973,
    G15_MASK: 21522,
    getBCHTypeInfo: function(r) {
      for (var o = r << 10; s.getBCHDigit(o) - s.getBCHDigit(s.G15) >= 0; )
        o ^= s.G15 << s.getBCHDigit(o) - s.getBCHDigit(s.G15);
      return (r << 10 | o) ^ s.G15_MASK;
    },
    getBCHTypeNumber: function(r) {
      for (var o = r << 12; s.getBCHDigit(o) - s.getBCHDigit(s.G18) >= 0; )
        o ^= s.G18 << s.getBCHDigit(o) - s.getBCHDigit(s.G18);
      return r << 12 | o;
    },
    getBCHDigit: function(r) {
      for (var o = 0; r != 0; )
        o++, r >>>= 1;
      return o;
    },
    getPatternPosition: function(r) {
      return s.PATTERN_POSITION_TABLE[r - 1];
    },
    getMask: function(r, o, l) {
      switch (r) {
        case i.PATTERN000:
          return (o + l) % 2 == 0;
        case i.PATTERN001:
          return o % 2 == 0;
        case i.PATTERN010:
          return l % 3 == 0;
        case i.PATTERN011:
          return (o + l) % 3 == 0;
        case i.PATTERN100:
          return (Math.floor(o / 2) + Math.floor(l / 3)) % 2 == 0;
        case i.PATTERN101:
          return o * l % 2 + o * l % 3 == 0;
        case i.PATTERN110:
          return (o * l % 2 + o * l % 3) % 2 == 0;
        case i.PATTERN111:
          return (o * l % 3 + (o + l) % 2) % 2 == 0;
        default:
          throw new Error("bad maskPattern:" + r);
      }
    },
    getErrorCorrectPolynomial: function(r) {
      for (var o = new e([1], 0), l = 0; l < r; l++)
        o = o.multiply(new e([1, n.gexp(l)], 0));
      return o;
    },
    getLengthInBits: function(r, o) {
      if (1 <= o && o < 10)
        switch (r) {
          case t.MODE_NUMBER:
            return 10;
          case t.MODE_ALPHA_NUM:
            return 9;
          case t.MODE_8BIT_BYTE:
            return 8;
          case t.MODE_KANJI:
            return 8;
          default:
            throw new Error("mode:" + r);
        }
      else if (o < 27)
        switch (r) {
          case t.MODE_NUMBER:
            return 12;
          case t.MODE_ALPHA_NUM:
            return 11;
          case t.MODE_8BIT_BYTE:
            return 16;
          case t.MODE_KANJI:
            return 10;
          default:
            throw new Error("mode:" + r);
        }
      else if (o < 41)
        switch (r) {
          case t.MODE_NUMBER:
            return 14;
          case t.MODE_ALPHA_NUM:
            return 13;
          case t.MODE_8BIT_BYTE:
            return 16;
          case t.MODE_KANJI:
            return 12;
          default:
            throw new Error("mode:" + r);
        }
      else
        throw new Error("type:" + o);
    },
    getLostPoint: function(r) {
      for (var o = r.getModuleCount(), l = 0, a = 0; a < o; a++)
        for (var c = 0; c < o; c++) {
          for (var u = 0, h = r.isDark(a, c), d = -1; d <= 1; d++)
            if (!(a + d < 0 || o <= a + d))
              for (var m = -1; m <= 1; m++)
                c + m < 0 || o <= c + m || d == 0 && m == 0 || h == r.isDark(a + d, c + m) && u++;
          u > 5 && (l += 3 + u - 5);
        }
      for (var a = 0; a < o - 1; a++)
        for (var c = 0; c < o - 1; c++) {
          var p = 0;
          r.isDark(a, c) && p++, r.isDark(a + 1, c) && p++, r.isDark(a, c + 1) && p++, r.isDark(a + 1, c + 1) && p++, (p == 0 || p == 4) && (l += 3);
        }
      for (var a = 0; a < o; a++)
        for (var c = 0; c < o - 6; c++)
          r.isDark(a, c) && !r.isDark(a, c + 1) && r.isDark(a, c + 2) && r.isDark(a, c + 3) && r.isDark(a, c + 4) && !r.isDark(a, c + 5) && r.isDark(a, c + 6) && (l += 40);
      for (var c = 0; c < o; c++)
        for (var a = 0; a < o - 6; a++)
          r.isDark(a, c) && !r.isDark(a + 1, c) && r.isDark(a + 2, c) && r.isDark(a + 3, c) && r.isDark(a + 4, c) && !r.isDark(a + 5, c) && r.isDark(a + 6, c) && (l += 40);
      for (var g = 0, c = 0; c < o; c++)
        for (var a = 0; a < o; a++)
          r.isDark(a, c) && g++;
      var A = Math.abs(100 * g / o / o - 50) / 5;
      return l += A * 10, l;
    }
  };
  return Bo = s, Bo;
}
var wo, wh;
function PV() {
  if (wh) return wo;
  wh = 1;
  var t = KV(), e = HV(), n = OV(), i = DV(), s = x2();
  function r(l, a) {
    this.typeNumber = l, this.errorCorrectLevel = a, this.modules = null, this.moduleCount = 0, this.dataCache = null, this.dataList = [];
  }
  var o = r.prototype;
  return o.addData = function(l) {
    var a = new t(l);
    this.dataList.push(a), this.dataCache = null;
  }, o.isDark = function(l, a) {
    if (l < 0 || this.moduleCount <= l || a < 0 || this.moduleCount <= a)
      throw new Error(l + "," + a);
    return this.modules[l][a];
  }, o.getModuleCount = function() {
    return this.moduleCount;
  }, o.make = function() {
    if (this.typeNumber < 1) {
      var l = 1;
      for (l = 1; l < 40; l++) {
        for (var a = e.getRSBlocks(l, this.errorCorrectLevel), c = new n(), u = 0, h = 0; h < a.length; h++)
          u += a[h].dataCount;
        for (var h = 0; h < this.dataList.length; h++) {
          var d = this.dataList[h];
          c.put(d.mode, 4), c.put(d.getLength(), i.getLengthInBits(d.mode, l)), d.write(c);
        }
        if (c.getLengthInBits() <= u * 8)
          break;
      }
      this.typeNumber = l;
    }
    this.makeImpl(!1, this.getBestMaskPattern());
  }, o.makeImpl = function(l, a) {
    this.moduleCount = this.typeNumber * 4 + 17, this.modules = new Array(this.moduleCount);
    for (var c = 0; c < this.moduleCount; c++) {
      this.modules[c] = new Array(this.moduleCount);
      for (var u = 0; u < this.moduleCount; u++)
        this.modules[c][u] = null;
    }
    this.setupPositionProbePattern(0, 0), this.setupPositionProbePattern(this.moduleCount - 7, 0), this.setupPositionProbePattern(0, this.moduleCount - 7), this.setupPositionAdjustPattern(), this.setupTimingPattern(), this.setupTypeInfo(l, a), this.typeNumber >= 7 && this.setupTypeNumber(l), this.dataCache == null && (this.dataCache = r.createData(this.typeNumber, this.errorCorrectLevel, this.dataList)), this.mapData(this.dataCache, a);
  }, o.setupPositionProbePattern = function(l, a) {
    for (var c = -1; c <= 7; c++)
      if (!(l + c <= -1 || this.moduleCount <= l + c))
        for (var u = -1; u <= 7; u++)
          a + u <= -1 || this.moduleCount <= a + u || (0 <= c && c <= 6 && (u == 0 || u == 6) || 0 <= u && u <= 6 && (c == 0 || c == 6) || 2 <= c && c <= 4 && 2 <= u && u <= 4 ? this.modules[l + c][a + u] = !0 : this.modules[l + c][a + u] = !1);
  }, o.getBestMaskPattern = function() {
    for (var l = 0, a = 0, c = 0; c < 8; c++) {
      this.makeImpl(!0, c);
      var u = i.getLostPoint(this);
      (c == 0 || l > u) && (l = u, a = c);
    }
    return a;
  }, o.createMovieClip = function(l, a, c) {
    var u = l.createEmptyMovieClip(a, c), h = 1;
    this.make();
    for (var d = 0; d < this.modules.length; d++)
      for (var m = d * h, p = 0; p < this.modules[d].length; p++) {
        var g = p * h, A = this.modules[d][p];
        A && (u.beginFill(0, 100), u.moveTo(g, m), u.lineTo(g + h, m), u.lineTo(g + h, m + h), u.lineTo(g, m + h), u.endFill());
      }
    return u;
  }, o.setupTimingPattern = function() {
    for (var l = 8; l < this.moduleCount - 8; l++)
      this.modules[l][6] == null && (this.modules[l][6] = l % 2 == 0);
    for (var a = 8; a < this.moduleCount - 8; a++)
      this.modules[6][a] == null && (this.modules[6][a] = a % 2 == 0);
  }, o.setupPositionAdjustPattern = function() {
    for (var l = i.getPatternPosition(this.typeNumber), a = 0; a < l.length; a++)
      for (var c = 0; c < l.length; c++) {
        var u = l[a], h = l[c];
        if (this.modules[u][h] == null)
          for (var d = -2; d <= 2; d++)
            for (var m = -2; m <= 2; m++)
              d == -2 || d == 2 || m == -2 || m == 2 || d == 0 && m == 0 ? this.modules[u + d][h + m] = !0 : this.modules[u + d][h + m] = !1;
      }
  }, o.setupTypeNumber = function(l) {
    for (var a = i.getBCHTypeNumber(this.typeNumber), c = 0; c < 18; c++) {
      var u = !l && (a >> c & 1) == 1;
      this.modules[Math.floor(c / 3)][c % 3 + this.moduleCount - 8 - 3] = u;
    }
    for (var c = 0; c < 18; c++) {
      var u = !l && (a >> c & 1) == 1;
      this.modules[c % 3 + this.moduleCount - 8 - 3][Math.floor(c / 3)] = u;
    }
  }, o.setupTypeInfo = function(l, a) {
    for (var c = this.errorCorrectLevel << 3 | a, u = i.getBCHTypeInfo(c), h = 0; h < 15; h++) {
      var d = !l && (u >> h & 1) == 1;
      h < 6 ? this.modules[h][8] = d : h < 8 ? this.modules[h + 1][8] = d : this.modules[this.moduleCount - 15 + h][8] = d;
    }
    for (var h = 0; h < 15; h++) {
      var d = !l && (u >> h & 1) == 1;
      h < 8 ? this.modules[8][this.moduleCount - h - 1] = d : h < 9 ? this.modules[8][15 - h - 1 + 1] = d : this.modules[8][15 - h - 1] = d;
    }
    this.modules[this.moduleCount - 8][8] = !l;
  }, o.mapData = function(l, a) {
    for (var c = -1, u = this.moduleCount - 1, h = 7, d = 0, m = this.moduleCount - 1; m > 0; m -= 2)
      for (m == 6 && m--; ; ) {
        for (var p = 0; p < 2; p++)
          if (this.modules[u][m - p] == null) {
            var g = !1;
            d < l.length && (g = (l[d] >>> h & 1) == 1);
            var A = i.getMask(a, u, m - p);
            A && (g = !g), this.modules[u][m - p] = g, h--, h == -1 && (d++, h = 7);
          }
        if (u += c, u < 0 || this.moduleCount <= u) {
          u -= c, c = -c;
          break;
        }
      }
  }, r.PAD0 = 236, r.PAD1 = 17, r.createData = function(l, a, c) {
    for (var u = e.getRSBlocks(l, a), h = new n(), d = 0; d < c.length; d++) {
      var m = c[d];
      h.put(m.mode, 4), h.put(m.getLength(), i.getLengthInBits(m.mode, l)), m.write(h);
    }
    for (var p = 0, d = 0; d < u.length; d++)
      p += u[d].dataCount;
    if (h.getLengthInBits() > p * 8)
      throw new Error("code length overflow. (" + h.getLengthInBits() + ">" + p * 8 + ")");
    for (h.getLengthInBits() + 4 <= p * 8 && h.put(0, 4); h.getLengthInBits() % 8 != 0; )
      h.putBit(!1);
    for (; !(h.getLengthInBits() >= p * 8 || (h.put(r.PAD0, 8), h.getLengthInBits() >= p * 8)); )
      h.put(r.PAD1, 8);
    return r.createBytes(h, u);
  }, r.createBytes = function(l, a) {
    for (var c = 0, u = 0, h = 0, d = new Array(a.length), m = new Array(a.length), p = 0; p < a.length; p++) {
      var g = a[p].dataCount, A = a[p].totalCount - g;
      u = Math.max(u, g), h = Math.max(h, A), d[p] = new Array(g);
      for (var b = 0; b < d[p].length; b++)
        d[p][b] = 255 & l.buffer[b + c];
      c += g;
      var R = i.getErrorCorrectPolynomial(A), S = new s(d[p], R.getLength() - 1), E = S.mod(R);
      m[p] = new Array(R.getLength() - 1);
      for (var b = 0; b < m[p].length; b++) {
        var Z = b + E.getLength() - m[p].length;
        m[p][b] = Z >= 0 ? E.get(Z) : 0;
      }
    }
    for (var G = 0, b = 0; b < a.length; b++)
      G += a[b].totalCount;
    for (var T = new Array(G), C = 0, b = 0; b < u; b++)
      for (var p = 0; p < a.length; p++)
        b < d[p].length && (T[C++] = d[p][b]);
    for (var b = 0; b < h; b++)
      for (var p = 0; p < a.length; p++)
        b < m[p].length && (T[C++] = m[p][b]);
    return T;
  }, wo = r, wo;
}
var gs = {}, Yh;
function _V() {
  if (Yh) return gs;
  Yh = 1, Object.defineProperty(gs, "__esModule", {
    value: !0
  });
  var t = Object.assign || function(c) {
    for (var u = 1; u < arguments.length; u++) {
      var h = arguments[u];
      for (var d in h)
        Object.prototype.hasOwnProperty.call(h, d) && (c[d] = h[d]);
    }
    return c;
  }, e = /* @__PURE__ */ T2(), n = r(e), i = xt, s = r(i);
  function r(c) {
    return c && c.__esModule ? c : { default: c };
  }
  function o(c, u) {
    var h = {};
    for (var d in c)
      u.indexOf(d) >= 0 || Object.prototype.hasOwnProperty.call(c, d) && (h[d] = c[d]);
    return h;
  }
  var l = {
    bgColor: n.default.oneOfType([n.default.object, n.default.string]).isRequired,
    bgD: n.default.string.isRequired,
    fgColor: n.default.oneOfType([n.default.object, n.default.string]).isRequired,
    fgD: n.default.string.isRequired,
    size: n.default.number.isRequired,
    title: n.default.string,
    viewBoxSize: n.default.number.isRequired,
    xmlns: n.default.string
  }, a = (0, i.forwardRef)(function(c, u) {
    var h = c.bgColor, d = c.bgD, m = c.fgD, p = c.fgColor, g = c.size, A = c.title, b = c.viewBoxSize, R = c.xmlns, S = R === void 0 ? "http://www.w3.org/2000/svg" : R, E = o(c, ["bgColor", "bgD", "fgD", "fgColor", "size", "title", "viewBoxSize", "xmlns"]);
    return s.default.createElement(
      "svg",
      t({}, E, { height: g, ref: u, viewBox: "0 0 " + b + " " + b, width: g, xmlns: S }),
      A ? s.default.createElement(
        "title",
        null,
        A
      ) : null,
      s.default.createElement("path", { d, fill: h }),
      s.default.createElement("path", { d: m, fill: p })
    );
  });
  return a.displayName = "QRCodeSvg", a.propTypes = l, gs.default = a, gs;
}
var Th;
function jV() {
  if (Th) return kn;
  Th = 1, Object.defineProperty(kn, "__esModule", {
    value: !0
  }), kn.QRCode = void 0;
  var t = Object.assign || function(g) {
    for (var A = 1; A < arguments.length; A++) {
      var b = arguments[A];
      for (var R in b)
        Object.prototype.hasOwnProperty.call(b, R) && (g[R] = b[R]);
    }
    return g;
  }, e = /* @__PURE__ */ T2(), n = h(e), i = L2(), s = h(i), r = PV(), o = h(r), l = xt, a = h(l), c = _V(), u = h(c);
  function h(g) {
    return g && g.__esModule ? g : { default: g };
  }
  function d(g, A) {
    var b = {};
    for (var R in g)
      A.indexOf(R) >= 0 || Object.prototype.hasOwnProperty.call(g, R) && (b[R] = g[R]);
    return b;
  }
  var m = {
    bgColor: n.default.oneOfType([n.default.object, n.default.string]),
    fgColor: n.default.oneOfType([n.default.object, n.default.string]),
    level: n.default.string,
    size: n.default.number,
    value: n.default.string.isRequired
  }, p = (0, l.forwardRef)(function(g, A) {
    var b = g.bgColor, R = b === void 0 ? "#FFFFFF" : b, S = g.fgColor, E = S === void 0 ? "#000000" : S, Z = g.level, G = Z === void 0 ? "L" : Z, T = g.size, C = T === void 0 ? 256 : T, N = g.value, Y = d(g, ["bgColor", "fgColor", "level", "size", "value"]), L = new o.default(-1, s.default[G]);
    L.addData(N), L.make();
    var w = L.modules;
    return a.default.createElement(u.default, t({}, Y, {
      bgColor: R,
      bgD: w.map(function(D, ie) {
        return D.map(function(X, Q) {
          return X ? "" : "M " + Q + " " + ie + " l 1 0 0 1 -1 0 Z";
        }).join(" ");
      }).join(" "),
      fgColor: E,
      fgD: w.map(function(D, ie) {
        return D.map(function(X, Q) {
          return X ? "M " + Q + " " + ie + " l 1 0 0 1 -1 0 Z" : "";
        }).join(" ");
      }).join(" "),
      ref: A,
      size: C,
      viewBoxSize: w.length
    }));
  });
  return kn.QRCode = p, p.displayName = "QRCode", p.propTypes = m, kn.default = p, kn;
}
var $V = jV();
const qV = /* @__PURE__ */ H3($V), eR = ({ height: t = "37px", width: e = "37px" }) => /* @__PURE__ */ f("div", { style: { height: t, width: e }, children: /* @__PURE__ */ f(oe, { name: "loader" }) }), tR = /* @__PURE__ */ V("div")({
  name: "Container",
  class: "c1bgb86j",
  propsAsIs: !1
}), nR = /* @__PURE__ */ V("video")({
  name: "Player",
  class: "p6703cq",
  propsAsIs: !1
}), iR = /* @__PURE__ */ V("img")({
  name: "Poster",
  class: "p12ow7zo",
  propsAsIs: !1
}), Ms = /* @__PURE__ */ V("div")({
  name: "Control",
  class: "cdpal9o",
  propsAsIs: !1
}), sR = "t1xke4ml", rR = "h1yzxv57", oR = /* @__PURE__ */ V("div")({
  name: "VideoControls",
  class: "vxo8xch",
  propsAsIs: !1
}), Aa = /* @__PURE__ */ V("button")({
  name: "ControlBtn",
  class: "coyuzu0",
  propsAsIs: !1
}), lR = () => Aa, aR = /* @__PURE__ */ V(lR())({
  name: "MuteIcon",
  class: "musmi9a",
  propsAsIs: !0
}), cR = () => Aa, uR = /* @__PURE__ */ V(cR())({
  name: "PauseIcon",
  class: "p1qe7rum",
  propsAsIs: !0
}), hR = () => Aa, dR = /* @__PURE__ */ V(hR())({
  name: "PlayIcon",
  class: "psevery",
  propsAsIs: !0
}), M2 = /* @__PURE__ */ V("button")({
  name: "WebOSIconButton",
  class: "w1q3u7py",
  propsAsIs: !1
}), mR = () => M2, hr = /* @__PURE__ */ V(mR())({
  name: "WebOSIconButtonAnimation",
  class: "wdlqvum",
  propsAsIs: !0
}), pR = () => hr, gR = /* @__PURE__ */ V(pR())({
  name: "WebOSIconButtonPlay",
  class: "w1ylz9ea",
  propsAsIs: !0
}), fR = () => hr, bR = /* @__PURE__ */ V(fR())({
  name: "WebOSIconButtonPause",
  class: "w1iylt55",
  propsAsIs: !0
}), AR = () => hr, VR = /* @__PURE__ */ V(AR())({
  name: "WebOSIconButtonMute",
  class: "w8h4h7",
  propsAsIs: !0
}), RR = () => hr, ER = /* @__PURE__ */ V(RR())({
  name: "WebOSIconButtonUnmute",
  class: "w12l12kt",
  propsAsIs: !0
}), yR = (t) => {
  for (const e of t)
    e.isIntersecting ? e.target instanceof HTMLVideoElement && e.target.autoplay && e.target.play() : e.target instanceof HTMLVideoElement && !e.target.paused && e.target.pause();
}, Q2 = new IntersectionObserver(yR, { threshold: 0.5 }), Va = /* @__PURE__ */ new Set(), CR = (t) => {
  Q2.observe(t), Va.add(t);
}, WR = (t) => {
  Q2.unobserve(t), Va.delete(t);
}, SR = () => {
  for (const t of Va)
    t instanceof HTMLVideoElement && !t.paused && t.pause();
};
function ZR(...t) {
  return Ue(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (e) => {
      for (const n of t)
        n !== null && (typeof n == "function" ? n(e) : n && (n.current = e));
    },
    // Re-run the callback if the array of refs changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [...t]
  );
}
const vR = ht(tR), IR = ({ loading: t, autoPlay: e, played: n, playing: i, isMuted: s, unmute: r, mute: o, togglePlaying: l }) => !t && !e && !n ? /* @__PURE__ */ f(Ms, { children: i ? /* @__PURE__ */ f(oe, { name: "icon-pause" }) : /* @__PURE__ */ f(oe, { name: "icon-play" }) }) : n ? /* @__PURE__ */ U(oR, { children: [
  i ? /* @__PURE__ */ f(uR, { onClick: l }) : /* @__PURE__ */ f(dR, { onClick: l }),
  /* @__PURE__ */ f(aR, { className: Oe(!s && "muted"), onClick: s ? r : o })
] }) : null, NR = ({
  loading: t,
  autoPlay: e,
  playMuted: n,
  playing: i,
  played: s,
  unmute: r,
  mute: o,
  isMuted: l,
  hasNotPausedVideo: a,
  hasInteractedWithAudio: c
}) => /* @__PURE__ */ U(at, { children: [
  !t && !(e && n) && /* @__PURE__ */ f(Ms, { "data-control-btn": "true", children: i ? a ? null : /* @__PURE__ */ f(gR, { children: /* @__PURE__ */ f(oe, { name: "icon-play" }) }) : s ? /* @__PURE__ */ f(bR, { children: /* @__PURE__ */ f(oe, { name: "icon-pause" }) }) : /* @__PURE__ */ f(M2, { "data-control-icon": "true", children: /* @__PURE__ */ f(oe, { name: "icon-play" }) }) }),
  !t && e && n && c && /* @__PURE__ */ f(Ms, { children: l ? /* @__PURE__ */ f(VR, { onClick: r, children: /* @__PURE__ */ f(oe, { name: "iconMute" }) }) : /* @__PURE__ */ f(ER, { onClick: o, children: /* @__PURE__ */ f(oe, { name: "iconUnMute" }) }) })
] }), Hi = Ii(
  ({
    poster: t,
    source: e,
    aspectRatio: n,
    controlVideo: i,
    onReplay: s,
    onPlay: r,
    onPause: o,
    onEnd: l,
    onRender: a,
    onMute: c,
    onMuteClick: u,
    onQuartile: h,
    autoPlay: d,
    playMuted: m,
    className: p,
    muted: g,
    webos: A,
    hasNotPausedVideo: b
  }, R) => {
    const S = Ee(null), E = ZR(S, R), Z = Ee(!1), G = Ee(!1), T = Ee(/* @__PURE__ */ new Set()), [C, N] = re(!1), [Y, L] = re(!1), [w, D] = re(!1), [ie, X] = re(!0), [Q, J] = re(m), [q, k] = re(!1);
    te(() => {
      e && (J(m), N(!1));
    }, [e]);
    const O = Ue(() => {
      i?.({ muted: !1 });
    }, [i]), ee = Ue(() => {
      i?.({ muted: !0 });
    }, [i]), W = Ue(
      (_) => {
        _?.stopPropagation(), S.current && (S.current.muted = !0), J(!0), u?.(!0);
      },
      [u]
    ), v = Ue(
      (_) => {
        _?.stopPropagation(), S.current && (S.current.muted = !1), J(!1), q || k(!0), u?.(!1);
      },
      [q, u]
    );
    te(() => {
      g !== void 0 && (g ? W() : v());
    }, [W, g, v]);
    const F = (_) => {
      _.stopPropagation?.();
      const $ = S?.current;
      if ($)
        if (Y)
          $.pause();
        else {
          const j = S?.current;
          if (!j)
            return;
          SR(), j.play().catch((z) => console.log(z)), X(!1);
        }
    }, K = () => {
      S?.current?.load(), X(!0);
    };
    return te(() => () => {
      O();
    }, [O]), te(() => {
      const _ = S.current;
      return _ ? (G.current = _.muted, J(_.muted), CR(_), () => {
        WR(_);
      }) : () => {
      };
    }, []), te(() => {
      a?.();
    }, [a]), te(() => {
      T.current.clear(), Z.current = !1;
    }, [e]), /* @__PURE__ */ U(
      vR,
      {
        webos: A,
        onClick: d && m ? Q ? v : W : F,
        "data-a": "intr",
        autoFocus: !0,
        options: { focusKey: "video-play-btn" },
        className: Oe(Y && !A && sR, d && rR, p),
        style: n ? { aspectRatio: n } : {},
        children: [
          /* @__PURE__ */ f(
            nR,
            {
              ref: E,
              src: e,
              autoPlay: d,
              onPlay: () => {
                N(!0), Z.current && (s?.(), T.current.clear()), L(!0), X(!1), r?.(), m ? W() : ee();
              },
              onTimeUpdate: (_) => {
                const $ = _.target.duration, j = _.target.currentTime;
                if ($ && j) {
                  const z = Math.floor(j / $ * 100);
                  z >= 25 && z < 50 && !T.current.has(25) ? (h?.(25), T.current.add(25)) : z >= 50 && z < 75 && !T.current.has(50) ? (h?.(50), T.current.add(50)) : z >= 75 && !T.current.has(75) && (h?.(75), T.current.add(75));
                }
              },
              onVolumeChange: (_) => {
                const $ = _.target.muted;
                G.current !== $ && (c?.($), G.current = $, ($ !== g || g === void 0) && ($ ? O() : ee()));
              },
              onError: async (_) => {
                try {
                  if (_.target instanceof HTMLVideoElement) {
                    D(!0);
                    const $ = await (await fetch(_.target.src)).blob(), j = URL.createObjectURL($);
                    _.target.src = j;
                  }
                } catch ($) {
                  console.error("video fallback fetch failed", $), L(!0), X(!0);
                } finally {
                  D(!1), O();
                }
              },
              onPause: () => {
                L(!1), o?.(), O();
              },
              onEnded: () => {
                L(!1), Z.current = !0, K(), l?.(), O();
              },
              style: { visibility: ie ? "hidden" : "visible" },
              controls: !1,
              playsInline: !0
            }
          ),
          /* @__PURE__ */ f(iR, { src: t, style: { visibility: ie ? "visible" : "hidden" } }),
          !A && /* @__PURE__ */ f(
            IR,
            {
              loading: w,
              autoPlay: d,
              played: C,
              playing: Y,
              isMuted: Q,
              unmute: v,
              mute: W,
              togglePlaying: F
            }
          ),
          A && /* @__PURE__ */ f(
            NR,
            {
              loading: w,
              autoPlay: d,
              playMuted: m,
              playing: Y,
              played: C,
              unmute: v,
              mute: W,
              isMuted: Q,
              hasNotPausedVideo: b,
              hasInteractedWithAudio: q
            }
          ),
          w && /* @__PURE__ */ f(Ms, { children: /* @__PURE__ */ f(eR, {}) })
        ]
      }
    );
  }
), FR = /* @__PURE__ */ V("div")({
  name: "Wrap",
  class: "wlxplqv",
  propsAsIs: !1
}), GR = /* @__PURE__ */ V("div")({
  name: "Container",
  class: "c18fzrta",
  propsAsIs: !1
}), XR = /* @__PURE__ */ V("div")({
  name: "Content",
  class: "cxfcca1",
  propsAsIs: !1
}), UR = /* @__PURE__ */ V("div")({
  name: "ContentWrap",
  class: "cz4xk2s",
  propsAsIs: !1
}), BR = /* @__PURE__ */ V("div")({
  name: "Header",
  class: "h1udizru",
  propsAsIs: !1
}), wR = /* @__PURE__ */ V("div")({
  name: "BrandBlock",
  class: "b1keaj5j",
  propsAsIs: !1
}), YR = /* @__PURE__ */ V("img")({
  name: "LogoIcon",
  class: "l17io0yd",
  propsAsIs: !1
}), TR = /* @__PURE__ */ V("div")({
  name: "BrandText",
  class: "b4ldrvh",
  propsAsIs: !1
}), LR = /* @__PURE__ */ V("div")({
  name: "BrandNameContainer",
  class: "bxfmzcm",
  propsAsIs: !1
}), kR = /* @__PURE__ */ V("span")({
  name: "BrandName",
  class: "baubznb",
  propsAsIs: !1
}), JR = /* @__PURE__ */ V("span")({
  name: "Sponsored",
  class: "s1n8ue7o",
  propsAsIs: !1
}), xR = (t) => /* @__PURE__ */ f("svg", {
  viewBox: "0 0 24 24",
  fill: "white",
  xmlns: "http://www.w3.org/2000/svg",
  ...t,
  children: /* @__PURE__ */ f("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.225 4.811a.75.75 0 0 1 1.06 0L12 9.525l4.715-4.714a.75.75 0 1 1 1.06 1.06L13.06 10.5l4.715 4.715a.75.75 0 0 1-1.06 1.06L12 11.56l-4.715 4.715a.75.75 0 0 1-1.06-1.06L10.94 10.5 6.225 5.785a.75.75 0 0 1 0-1.06z"
  })
}), MR = /* @__PURE__ */ V("button")({
  name: "CloseButton",
  class: "cexkm55",
  propsAsIs: !1
}), QR = () => Hi, zR = /* @__PURE__ */ V(QR())({
  name: "FocusableVideo",
  class: "filh2qp",
  propsAsIs: !0
}), KR = /* @__PURE__ */ V("div")({
  name: "VideoWrapper",
  class: "v1x04fia",
  propsAsIs: !1
}), HR = /* @__PURE__ */ V("div")({
  name: "VideoBlock",
  class: "vddh3kx",
  propsAsIs: !1
}), OR = () => ({
  backgroundColor: t
}) => t || "#0f6cd4", DR = () => ({
  textColor: t
}) => t || "#fff", PR = /* @__PURE__ */ V("div")({
  name: "SendToUserButton",
  class: "s13i81d3",
  propsAsIs: !1,
  vars: {
    "s13i81d3-0": [OR()],
    "s13i81d3-1": [DR()]
  }
}), Lh = () => /* @__PURE__ */ f("svg", {
  fill: "white",
  style: {
    fill: "white",
    width: "30px",
    height: "30px",
    verticalAlign: "middle",
    marginRight: "8px"
  },
  viewBox: "0 0 40 28",
  xmlns: "http://www.w3.org/2000/svg",
  children: /* @__PURE__ */ f("path", {
    d: "M5.57502 27.5H34.9099C37.803 27.5 39.5 25.8713 39.5 22.645V5.355C39.5 2.12878 37.7869 0.5 34.4251 0.5H5.09014C2.19706 0.5 0.5 2.12878 0.5 5.355V22.645C0.5 25.8713 2.21323 27.5 5.57502 27.5ZM5.47805 25.1039C3.87796 25.1039 2.97286 24.2425 2.97286 22.6294V5.33933C2.97286 3.74189 3.87796 2.89618 5.47805 2.89618H34.5058C36.1059 2.89618 37.0272 3.74189 37.0272 5.355V22.645C37.0272 24.2425 36.1059 25.1039 34.5058 25.1039H5.47805ZM19.9919 18.1189C21.0263 18.1189 22.0285 17.7431 22.9496 16.9287L38.1586 3.66359L36.4776 2.01915L21.5435 15.0651C21.0425 15.5035 20.5253 15.7071 19.9919 15.7071C19.4586 15.7071 18.9414 15.5035 18.4403 15.0651L3.50622 2.01915L1.82532 3.66359L17.0342 16.9287C17.9554 17.7431 18.9575 18.1189 19.9919 18.1189ZM3.74866 25.4954L15.224 14.3602L13.5431 12.7315L2.06776 23.851L3.74866 25.4954ZM36.2676 25.5111L37.9484 23.8666L26.4569 12.7315L24.7598 14.3602L36.2676 25.5111Z",
    fill: "white"
  })
}), _R = /* @__PURE__ */ V("div")({
  name: "SendToUserText",
  class: "s1vr1bii",
  propsAsIs: !1
}), kh = /* @__PURE__ */ V("div")({
  name: "VideoStatus",
  class: "v1st3522",
  propsAsIs: !1
}), jR = /* @__PURE__ */ V("h2")({
  name: "Title",
  class: "tjnj4vf",
  propsAsIs: !1
}), $R = /* @__PURE__ */ V("p")({
  name: "Description",
  class: "d1bj8s6q",
  propsAsIs: !1
}), Yo = /* @__PURE__ */ V("div")({
  name: "QRBlock",
  class: "q1nyi744",
  propsAsIs: !1
}), To = /* @__PURE__ */ V("div")({
  name: "QRDescBlock",
  class: "q1ri138g",
  propsAsIs: !1
}), Lo = /* @__PURE__ */ V("div")({
  name: "LearnMore",
  class: "l1asn3je",
  propsAsIs: !1
}), ko = /* @__PURE__ */ V("div")({
  name: "QRHint",
  class: "qa9pwin",
  propsAsIs: !1
}), qR = /* @__PURE__ */ V("div")({
  name: "QRWrapper",
  class: "q1j7gm7x",
  propsAsIs: !1
}), eE = () => qV, tE = /* @__PURE__ */ V(eE())({
  name: "StyledQRCode",
  class: "s1sb0ho1",
  propsAsIs: !0
}), Jo = xt.forwardRef(({
  value: t,
  size: e = 200,
  fgColor: n = "#0f172a",
  bgColor: i = "#ffffff",
  level: s = "M",
  tabIndex: r = 0
}, o) => /* @__PURE__ */ f("a", {
  ref: o,
  href: t,
  target: "_blank",
  rel: "noopener noreferrer",
  style: {
    textDecoration: "none",
    borderRadius: 10
  },
  tabIndex: r,
  children: /* @__PURE__ */ f(qR, {
    children: /* @__PURE__ */ f(tE, {
      value: t,
      size: e,
      fgColor: n,
      bgColor: i,
      level: s,
      viewBox: `0 0 ${e} ${e}`
    })
  })
})), xo = ht(PR), nE = ({ promotion: t, promotionId: e, onClose: n, sendWebhookEvent: i }) => {
  const s = t.buttonType, r = t.coupon, o = t.banner?.url, l = t.type, a = () => {
    i && e && t.buttonOptions?.case === "sendToUserOptions" && i(e, t.buttonOptions.value.userAccountInfo).catch(console.error);
  };
  return s === gi.BASIC ? /* @__PURE__ */ U(Yo, { children: [
    o && /* @__PURE__ */ f(Jo, { value: o }),
    /* @__PURE__ */ U(To, { children: [
      /* @__PURE__ */ f(Lo, { children: "LEARN MORE" }),
      /* @__PURE__ */ f(ko, { children: "SCAN QR CODE WITH YOUR PHONE CAMERA" })
    ] })
  ] }) : s === gi.ADD_TO_WALLET ? /* @__PURE__ */ U(Yo, { children: [
    /* @__PURE__ */ f(Jo, { value: r }),
    /* @__PURE__ */ U(To, { children: [
      /* @__PURE__ */ f(Lo, { style: { fontSize: 18, fontWeight: 400 }, children: "ADD TO APPLE WALLET" }),
      /* @__PURE__ */ f(ko, { style: { fontSize: 17 }, children: "SCAN QR CODE WITH YOUR PHONE CAMERA" })
    ] })
  ] }) : s === gi.SEND_TO_USER && l !== ce.INGAME_IAB11_LBAR ? /* @__PURE__ */ U(at, { children: [
    /* @__PURE__ */ U(
      xo,
      {
        backgroundColor: t?.banner?.ctaButton?.color,
        textColor: t?.banner?.ctaButton?.textColor,
        autoFocus: !0,
        webos: !0,
        onClick: a,
        children: [
          /* @__PURE__ */ f(Lh, {}),
          "SEND INFO TO ACCOUNT EMAIL"
        ]
      }
    ),
    /* @__PURE__ */ U(Yo, { children: [
      o && /* @__PURE__ */ f(Jo, { value: o }),
      /* @__PURE__ */ U(To, { children: [
        /* @__PURE__ */ f(Lo, { children: "LEARN MORE" }),
        /* @__PURE__ */ f(ko, { children: "SCAN QR CODE WITH YOUR PHONE CAMERA" })
      ] })
    ] })
  ] }) : s === gi.SEND_TO_USER && l === ce.INGAME_IAB11_LBAR ? /* @__PURE__ */ U(
    xo,
    {
      backgroundColor: t?.banner?.ctaButton?.color,
      textColor: t?.banner?.ctaButton?.textColor,
      webos: !0,
      autoFocus: !0,
      onClick: a,
      children: [
        /* @__PURE__ */ f(Lh, {}),
        /* @__PURE__ */ f(_R, { children: "SEND INFO TO ACCOUNT EMAIL" })
      ]
    }
  ) : s === gi.RETURN_TO_VIDEO ? /* @__PURE__ */ f(
    xo,
    {
      webos: !0,
      autoFocus: !0,
      backgroundColor: t?.banner?.ctaButton?.color,
      textColor: t?.banner?.ctaButton?.textColor,
      onClick: n,
      children: "BACK TO VIDEO"
    }
  ) : null;
}, iE = ht(MR, {
  isFocusBoundary: !0
}), sE = (t) => {
  const {
    promotion: e,
    open: n,
    togglePause: i,
    controlVideo: s,
    promotionId: r,
    onClose: o,
    markAsViewed: l,
    advertisementPaused: a,
    isEventFired: c,
    fireEvent: u,
    muted: h,
    sendWebhookEvent: d
  } = t, m = Ee(null), p = Ee(null), [g, A] = re(0), b = e.type === ce.INGAME_IAB11_LBAR || e.type === ce.INGAME_IAB11 || e.type === ce.INGAME_IAB11_SIDEBAR, R = b ? g + 1 : g / 2, S = !!e.banner?.video?.url, E = e.autoPlayVideo === Bs.ENABLED, Z = e.playVideoMuted === m0.ENABLED, G = Z && E, [T, C] = re(!0), [N, Y] = re(void 0);
  let L = e.banner?.url;
  return L && !L.startsWith("http") && (L = `https://${L}`), te(() => {
    if (!p.current) return;
    const w = new ResizeObserver(([D]) => {
      const ie = D.contentRect.width;
      A(ie);
    });
    return w.observe(p.current), w3(), () => {
      w.disconnect();
    };
  }, []), te(() => {
    i?.(S || E), n?.();
  }, [S, E, n, i]), te(() => {
    r && e.type && l && l();
  }, [r, e.type, l]), te(() => () => {
    s?.({ muted: !1 });
  }, [s]), /* @__PURE__ */ f(FR, { children: /* @__PURE__ */ U(GR, { ref: p, children: [
    /* @__PURE__ */ U(BR, { children: [
      e.logoMode === 1 && /* @__PURE__ */ U(wR, { children: [
        /* @__PURE__ */ f(YR, { src: e.sponsor?.logo, alt: "Logo" }),
        /* @__PURE__ */ U(TR, { children: [
          /* @__PURE__ */ f(LR, { children: /* @__PURE__ */ f(kR, { children: e.sponsor?.name }) }),
          /* @__PURE__ */ f(JR, { children: "SPONSORED" })
        ] })
      ] }),
      e.logoMode === 2 && b && /* @__PURE__ */ f("img", { src: e.sponsor?.logo, alt: "Video paused preview", style: { height: "56px" } }),
      /* @__PURE__ */ f(
        iE,
        {
          autoFocus: !0,
          options: { focusKey: "close-ad-button" },
          webos: !0,
          onClick: o,
          "data-close-btn": "true",
          children: /* @__PURE__ */ f(xR, {})
        }
      )
    ] }),
    e.logoMode === 2 && !b && /* @__PURE__ */ f(
      "img",
      {
        src: e.sponsor?.logo,
        alt: "Video paused preview",
        style: {
          display: "block",
          alignSelf: "center",
          maxHeight: "72px",
          width: "auto"
        }
      }
    ),
    /* @__PURE__ */ U(XR, { "data-format11": b, children: [
      e.banner?.imageUrl && /* @__PURE__ */ f(HR, { style: { height: R }, children: /* @__PURE__ */ f(
        "img",
        {
          src: e.banner?.imageUrl,
          alt: "Video paused preview",
          style: { width: "100%", height: "100%", objectFit: "cover" }
        }
      ) }),
      e.banner?.video && /* @__PURE__ */ U(KR, { children: [
        /* @__PURE__ */ f(
          zR,
          {
            source: e.banner.video.url,
            poster: e.banner?.video?.thumbnailUrl,
            webos: !0,
            aspectRatio: b ? "1/1" : "2/1",
            ref: m,
            onRender: () => {
              c?.("video-rendered") || (be.emit("advertisement", {
                action: "videoRendered",
                payload: {
                  id: r,
                  type: e.type
                }
              }), u?.("video-rendered"));
            },
            onQuartile: (w) => {
              c?.(`video-quartile-${w}`) || (be.emit("advertisement", {
                action: "quartileCompleted",
                payload: {
                  id: r,
                  type: e.type,
                  quartile: w
                }
              }), u?.(`video-quartile-${w}`));
            },
            onMuteClick: (w) => {
              const D = w ? "muted" : "unmuted";
              c?.(D) || (be.emit("advertisement", {
                action: w ? "videoMuted" : "videoUnmuted",
                payload: {
                  id: r,
                  type: e.type
                }
              }), u?.(D));
            },
            onMute: (w) => {
              Y(w);
            },
            onPause: () => {
              i?.(!0), C(!1);
            },
            onReplay: () => {
              c?.("replayed") || (be.emit("advertisement", {
                action: "videoReplayed",
                payload: {
                  id: r,
                  type: e.type
                }
              }), u?.("replayed"));
            },
            onPlay: () => {
              c?.("played") || (be.emit("advertisement", {
                action: "videoPlay",
                payload: {
                  id: r,
                  type: e.type
                }
              }), u?.("played")), i?.(!1), c?.("played") && c?.("ended") && !c?.("replayed") && (be.emit("advertisement", {
                action: "videoReplayed",
                payload: {
                  id: r,
                  type: e.type
                }
              }), u?.("replayed"));
            },
            onEnd: () => {
              c?.("ended") || (be.emit("advertisement", {
                action: "videoEnd",
                payload: {
                  id: r,
                  type: e.type
                }
              }), u?.("ended"));
            },
            muted: h,
            autoPlay: E,
            playMuted: Z,
            controlVideo: s,
            hasNotPausedVideo: T
          }
        ),
        a && !T && /* @__PURE__ */ U(kh, { children: [
          /* @__PURE__ */ f(oe, { name: "icon-pause" }),
          "PAUSED"
        ] }),
        N && G && /* @__PURE__ */ U(kh, { children: [
          /* @__PURE__ */ f(oe, { name: "iconMute" }),
          "MUTED"
        ] })
      ] }),
      /* @__PURE__ */ U(UR, { "data-format11": b, children: [
        !b && /* @__PURE__ */ U("div", { children: [
          /* @__PURE__ */ f(jR, { children: e.banner?.title }),
          /* @__PURE__ */ f($R, { children: e.banner?.body })
        ] }),
        /* @__PURE__ */ f(
          nE,
          {
            promotion: e,
            onClose: o,
            promotionId: r,
            sendWebhookEvent: d
          }
        )
      ] })
    ] })
  ] }) });
}, rE = /* @__PURE__ */ V("div")({
  name: "NotificationContent",
  class: "n18wsqoo",
  propsAsIs: !1
}), oE = /* @__PURE__ */ V("div")({
  name: "Body",
  class: "b1ia90c2",
  propsAsIs: !1
}), lE = /* @__PURE__ */ V("div")({
  name: "Title",
  class: "tg2z08v",
  propsAsIs: !1
}), aE = /* @__PURE__ */ V("div")({
  name: "Text",
  class: "t59zdk1",
  propsAsIs: !1
}), Mn = /* @__PURE__ */ V("div")({
  name: "MediaImgBottom",
  class: "m1ab9fq",
  propsAsIs: !1
}), cE = () => Mn, uE = /* @__PURE__ */ V(cE())({
  name: "MediaImgMiddle",
  class: "m9fsr0y",
  propsAsIs: !0
}), Jh = /* @__PURE__ */ V("img")({
  name: "CtaIcon",
  class: "cvi9y5q",
  propsAsIs: !1
}), hE = /* @__PURE__ */ V("div")({
  name: "Logo",
  class: "l5mq0z",
  propsAsIs: !1
}), dE = /* @__PURE__ */ V("div")({
  name: "Footer",
  class: "f1mse0ft",
  propsAsIs: !1
}), mE = /* @__PURE__ */ V("div")({
  name: "Vector",
  class: "v1hcloah",
  propsAsIs: !1
}), pE = /* @__PURE__ */ V("div")({
  name: "NotificationContainer",
  class: "n3n65jf",
  propsAsIs: !1
}), z2 = /* @__PURE__ */ V("button")({
  name: "TVButton",
  class: "tkkfuqy",
  propsAsIs: !1
}), gE = () => z2, fE = /* @__PURE__ */ V(gE())({
  name: "DismissButton",
  class: "dh9vato",
  propsAsIs: !0
}), bE = () => z2, K2 = /* @__PURE__ */ V(bE())({
  name: "OpenButton",
  class: "oeah8gv",
  propsAsIs: !0
}), AE = {
  [ot.UNSET]: Mn,
  [ot.FIT]: Mn,
  [ot.CENTERED]: Mn,
  [ot.SOLID]: Mn,
  [ot.BOTTOM]: Mn,
  [ot.MIDDLE]: uE
}, VE = ({ src: t, imagePosition: e }) => {
  const n = AE[e];
  return /* @__PURE__ */ f(n, { children: /* @__PURE__ */ f("img", { src: t, alt: "" }) });
}, RE = ht(fE), EE = ht(K2), yE = ({ notification: t, open: e, close: n, webos: i }) => {
  if (!t || !t.promotion || t.enabled !== Us.NOTIFICATION_ENABLED)
    return null;
  const { title: s, body: r, image: o, promotion: l } = t, { sponsorLogo: a, sponsorLogoMode: c, imagePosition: u, ctaButton: h } = l;
  return /* @__PURE__ */ U(
    pE,
    {
      "data-webos": i,
      className: "SL_Lower_Third_Notification",
      onClick: i ? void 0 : e,
      children: [
        /* @__PURE__ */ U(rE, { children: [
          /* @__PURE__ */ f(VE, { src: o, imagePosition: u }),
          /* @__PURE__ */ U(oE, { children: [
            s && /* @__PURE__ */ f(lE, { children: s }),
            r && /* @__PURE__ */ f(aE, { children: r })
          ] })
        ] }),
        /* @__PURE__ */ U(dE, { children: [
          c !== d0.NOTIFICATION_SPONSOR_LOGO_NONE && /* @__PURE__ */ U(at, { children: [
            /* @__PURE__ */ f(hE, { children: /* @__PURE__ */ f("img", { src: a, alt: s }) }),
            /* @__PURE__ */ f(mE, {})
          ] }),
          i ? /* @__PURE__ */ U(at, { children: [
            /* @__PURE__ */ f(RE, { webos: !0, onClick: n, children: "Dismiss" }),
            /* @__PURE__ */ U(
              EE,
              {
                webos: !0,
                autoFocus: !0,
                style: { color: h?.textColor, backgroundColor: h?.color },
                onClick: e,
                children: [
                  h?.ctaIcon && h?.ctaIconMode === sl.CTA_ICON_TRANSPARENT && /* @__PURE__ */ f(Jh, { src: h?.ctaIcon, alt: "cta-icon" }),
                  h?.label || "Open"
                ]
              }
            )
          ] }) : /* @__PURE__ */ U(K2, { name: "promo-button", style: { color: h?.textColor, backgroundColor: h?.color }, children: [
            h?.ctaIcon && h?.ctaIconMode === sl.CTA_ICON_TRANSPARENT && /* @__PURE__ */ f(Jh, { src: h?.ctaIcon, alt: "cta-icon" }),
            h?.label || "Open"
          ] })
        ] })
      ]
    }
  );
}, CE = /* @__PURE__ */ V("div")({
  name: "NotificationContent",
  class: "n1ku6hz",
  propsAsIs: !1
}), WE = /* @__PURE__ */ V("div")({
  name: "NotificationContainer",
  class: "nbxqmol",
  propsAsIs: !1
}), SE = /* @__PURE__ */ V("div")({
  name: "Body",
  class: "b1gu3eml",
  propsAsIs: !1
}), ZE = /* @__PURE__ */ V("div")({
  name: "Title",
  class: "t1u17zva",
  propsAsIs: !1
}), vE = /* @__PURE__ */ V("div")({
  name: "Text",
  class: "t10ko1g",
  propsAsIs: !1
}), dr = /* @__PURE__ */ V("div")({
  name: "Media",
  class: "mntc42e",
  propsAsIs: !1
}), IE = () => dr, xh = /* @__PURE__ */ V(IE())({
  name: "MediaImgFit",
  class: "ml060eo",
  propsAsIs: !0
}), NE = () => dr, H2 = /* @__PURE__ */ V(NE())({
  name: "MediaImgCentered",
  class: "m1vqlvig",
  propsAsIs: !0
}), FE = () => H2, GE = /* @__PURE__ */ V(FE())({
  name: "MediaImgBottom",
  class: "m1e7tvi5",
  propsAsIs: !0
}), XE = () => dr, UE = /* @__PURE__ */ V(XE())({
  name: "MediaImgSolid",
  class: "mqvntt2",
  propsAsIs: !0
}), BE = () => dr, wE = /* @__PURE__ */ V(BE())({
  name: "MediaImgMiddle",
  class: "m12jtj3u",
  propsAsIs: !0
}), YE = /* @__PURE__ */ V("img")({
  name: "CtaIcon",
  class: "ckq1frv",
  propsAsIs: !1
}), TE = () => oe, LE = /* @__PURE__ */ V(TE())({
  name: "StyledChevronRight",
  class: "s9mjmz3",
  propsAsIs: !0
}), kE = /* @__PURE__ */ V("div")({
  name: "Logo",
  class: "l1cf50a7",
  propsAsIs: !1
}), O2 = /* @__PURE__ */ V("button")({
  name: "TVButton",
  class: "thdqfl0",
  propsAsIs: !1
}), JE = () => O2, xE = /* @__PURE__ */ V(JE())({
  name: "DismissButton",
  class: "d11pe8bx",
  propsAsIs: !0
}), ME = () => O2, QE = /* @__PURE__ */ V(ME())({
  name: "OpenButton",
  class: "oy9k0kp",
  propsAsIs: !0
}), zE = {
  [ot.UNSET]: xh,
  [ot.FIT]: xh,
  [ot.CENTERED]: H2,
  [ot.BOTTOM]: GE,
  [ot.SOLID]: UE,
  [ot.MIDDLE]: wE
}, KE = ({ src: t, imagePosition: e }) => {
  const n = zE[e];
  return /* @__PURE__ */ f(n, { children: /* @__PURE__ */ f("img", { src: t, alt: "" }) });
}, HE = ht(xE), OE = ht(QE), DE = ({ notification: t, open: e, promotionId: n, hiding: i, direction: s = "left", close: r, webos: o }) => {
  if (!t || !t.promotion || t.enabled !== Us.NOTIFICATION_ENABLED)
    return null;
  if (t.promotion.mode === h9.LOWER_THIRD)
    return /* @__PURE__ */ f(yE, { notification: t, open: e, close: r, webos: o });
  const { title: l, body: a, image: c, promotion: u } = t, { sponsorLogo: h, sponsorLogoMode: d, imagePosition: m, ctaButton: p } = u, g = (A) => {
    A.stopPropagation(), r?.();
  };
  return /* @__PURE__ */ f(fa, { className: "SL_Rich_Notification", direction: s, hiding: i, children: /* @__PURE__ */ U(WE, { onClick: o ? () => {
  } : e, children: [
    d !== d0.NOTIFICATION_SPONSOR_LOGO_NONE && h && /* @__PURE__ */ f(kE, { children: /* @__PURE__ */ f("img", { src: h, alt: l }) }),
    /* @__PURE__ */ U(CE, { children: [
      /* @__PURE__ */ f(KE, { src: c, imagePosition: m }),
      /* @__PURE__ */ U(SE, { children: [
        l && /* @__PURE__ */ f(ZE, { children: l }),
        a && /* @__PURE__ */ f(vE, { children: a })
      ] }),
      o && /* @__PURE__ */ f(HE, { webos: !0, onClick: g, children: "Dismiss" }),
      /* @__PURE__ */ U(
        OE,
        {
          webos: o,
          autoFocus: o,
          onClick: o ? e : () => {
          },
          name: "promo-button",
          style: { color: p?.textColor, backgroundColor: p?.color },
          children: [
            p?.ctaIcon && p?.ctaIconMode === sl.CTA_ICON_TRANSPARENT && /* @__PURE__ */ f(YE, { src: p?.ctaIcon, alt: "cta-icon" }),
            p?.label || "Open"
          ]
        }
      ),
      /* @__PURE__ */ f(LE, { name: "chevronRight" })
    ] })
  ] }) });
}, PE = /* @__PURE__ */ V("div")({
  name: "SidebarContainer",
  class: "s1abskp8",
  propsAsIs: !1
}), _E = ({
  children: t,
  direction: e,
  style: n,
  className: i,
  hiding: s
}) => /* @__PURE__ */ f(fa, {
  direction: e,
  style: n,
  hiding: s,
  className: i,
  children: /* @__PURE__ */ f(PE, {
    children: t
  })
}), jE = ({
  advertisement: t,
  close: e,
  skipAutoClose: n,
  sidebar: i,
  banner: s,
  markAsViewed: r,
  open: o,
  controlVideo: l,
  advertisementPaused: a,
  togglePause: c,
  isEventFired: u,
  fireEvent: h,
  muted: d,
  toggleMute: m,
  isNotification: p,
  sendWebhookEvent: g
}) => t.promotion ? p && t.notification ? /* @__PURE__ */ f(
  DE,
  {
    open: () => o?.({ fromNotification: !0 }),
    notification: t.notification,
    promotionId: t.question.id,
    close: e,
    webos: !0
  }
) : i ? /* @__PURE__ */ f(_E, { className: "PromoSidebarContainer", direction: i, hiding: !1, children: /* @__PURE__ */ f(
  sE,
  {
    markAsViewed: r,
    promotionId: t.question.id,
    promotion: t.promotion,
    onClose: e,
    open: o,
    controlVideo: l,
    skipAutoClose: n,
    advertisementPaused: a,
    togglePause: c,
    isEventFired: u,
    fireEvent: h,
    muted: d,
    toggleMute: m,
    sendWebhookEvent: g
  }
) }) : s ? /* @__PURE__ */ f(
  w2,
  {
    promotionId: t.question.id,
    hiding: !1,
    promotion: t.promotion,
    direction: s,
    isEventFired: u,
    fireEvent: h
  }
) : null : null, Mh = /* @__PURE__ */ V("div")({
  name: "AdvertisementUIWrap",
  class: "a17b2u9w",
  propsAsIs: !1
}), $E = (t) => {
  const e = t.target;
  if (e instanceof HTMLAnchorElement && e.target === "_blank") {
    const n = e.getAttribute("data-promo-id") || "", i = e.getAttribute("data-promo-type") || ce.UNSET;
    e.getAttribute("data-a") === "button" && be.emit("advertisement", {
      action: "buttonSelect",
      payload: {
        id: n,
        type: i
      }
    }), e.getAttribute("data-a") === "banner" && be.emit("advertisement", {
      action: "bannerSelect",
      payload: {
        id: n,
        type: i
      }
    });
  }
}, qE = Ii(({
  gamification: t,
  skipAutoClose: e,
  containerId: n,
  muted: i,
  notification: s,
  sidebar: r,
  banner: o,
  persistent: l,
  controlVideo: a
}, c) => {
  const u = He(t.advertisement.$store), h = He(t.openedQuestion.$store), d = He(t.openedQuestion.$extendedStore), {
    finished: m
  } = ba();
  S6(c, {
    enabled: !!u.data,
    event: "click",
    listener: $E
  }), te(() => {
    m && u.close?.();
  }, [m]);
  const p = u.data?.question?.backgroundImage?.landscapeUrl || u.data?.promotion?.backgroundImageLandscapeUrl, g = u.data?.question?.backgroundImage?.portraitUrl || u.data?.promotion?.backgroundImagePortraitUrl, A = Y2({
    containerId: n,
    landscapeUrl: p,
    portraitUrl: g
  }), b = d?.data?.appearance?.position === a9.LBAR;
  return o && u.data === void 0 && (h?.attributes?.adUnit === Ne.STANDART || h?.attributes?.adPromotion?.adUnit === Ne.STANDART) && b && h?.attributes?.adPromotion?.banner?.imageUrl ? /* @__PURE__ */ f(Mh, {
    ref: c,
    className: Oe("SL-AdvertisementWebOs", "SL-AdvertisementWebOs--banner"),
    children: /* @__PURE__ */ f(W6, {
      cardId: h.id,
      isEventFired: h.isEventFired,
      fireEvent: h.fireEvent,
      promotion: {
        ...h.attributes.adPromotion,
        adUnit: h.attributes.adUnit || h.attributes.adPromotion?.adUnit
      },
      direction: o
    })
  }) : u.data === void 0 || !l && u.isViewed ? null : /* @__PURE__ */ U(Mh, {
    ref: c,
    style: {
      height: r ? "100%" : o ? void 0 : "auto"
    },
    className: Oe("SL-AdvertisementWebOs", !r && !o && !s && "SL-AdvertisementWebOs--overlay", r && "SL-AdvertisementWebOs--sidebar", o && "SL-AdvertisementWebOs--banner", s && "SL-AdvertisementWebOs--notification"),
    children: [!s && A, /* @__PURE__ */ f(jE, {
      sidebar: r,
      banner: o,
      advertisement: u.data,
      advertisementPaused: !!u.isPaused,
      togglePause: u.togglePause || (() => {
      }),
      toggleMute: u.toggleMute || (() => {
      }),
      close: u.close,
      isEventFired: u.isEventFired,
      fireEvent: u.fireEvent,
      markAsViewed: t.advertisement.markAsViewed,
      open: t.advertisement.open,
      isNotification: s,
      skipAutoClose: e,
      controlVideo: a,
      muted: i,
      sendWebhookEvent: t.sendWebhookEvent
    })]
  });
}), qn = ({
  sdk: t,
  sidebar: e,
  muted: n,
  banner: i,
  skipAutoClose: s,
  persistent: r,
  notification: o
}) => {
  const {
    containerId: l
  } = He(t.options), a = He(t.featuresList.getStore()), c = Ee(null);
  if (!a)
    return null;
  const u = t.getFeature(pe.GAMES);
  return u?.advertisement ? /* @__PURE__ */ f(qE, {
    ref: c,
    gamification: u,
    sidebar: e,
    banner: i,
    persistent: r,
    skipAutoClose: s,
    muted: n,
    notification: o,
    containerId: l,
    controlVideo: t.controlVideoPlayer
  }) : null;
}, e7 = /* @__PURE__ */ V("div")({
  name: "PauseAdOverlay",
  class: "pw9gih8",
  propsAsIs: !1
}), t7 = /* @__PURE__ */ V("div")({
  name: "PauseAdContent",
  class: "p8lpomy",
  propsAsIs: !1
}), n7 = /* @__PURE__ */ V("div")({
  name: "PauseAdTopLeft",
  class: "pv7u167",
  propsAsIs: !1
}), i7 = /* @__PURE__ */ V("h2")({
  name: "PauseAdTitle",
  class: "p1kh2yb0",
  propsAsIs: !1
}), s7 = /* @__PURE__ */ V("p")({
  name: "PauseAdCaption",
  class: "pl8f94x",
  propsAsIs: !1
}), r7 = /* @__PURE__ */ V("div")({
  name: "PauseAdBottomLeft",
  class: "p1m6zmrt",
  propsAsIs: !1
}), o7 = /* @__PURE__ */ V("button")({
  name: "PauseAdPlayButton",
  class: "pm3vwfa",
  propsAsIs: !1
}), l7 = /* @__PURE__ */ V("div")({
  name: "PauseAdSidebarGradient",
  class: "p1tibuhw",
  propsAsIs: !1
}), a7 = /* @__PURE__ */ V("div")({
  name: "PauseAdSidebar",
  class: "ptqqrqd",
  propsAsIs: !1
}), Qh = /* @__PURE__ */ V("img")({
  name: "ExternalAdContainer",
  class: "e14estxv",
  propsAsIs: !1
}), c7 = ({
  vastUrl: t,
  isDesktop: e,
  content: n
}) => (te(() => {
  n.imageSrc && n.id && be.emit("exposedPauseAd", {
    action: "rendered",
    payload: {
      id: n.id,
      parentId: n.parentId
    }
  });
}, [n, t]), n?.imageSrc ? !n.adUrl || !e ? /* @__PURE__ */ f(Qh, { src: n.imageSrc }) : /* @__PURE__ */ f(
  "a",
  {
    onClick: () => {
      be.emit("exposedPauseAd", {
        action: "navigated",
        payload: {
          id: n.id,
          parentId: n.parentId
        }
      });
    },
    href: n.adUrl,
    target: "_blank",
    rel: "noopener noreferrer",
    children: /* @__PURE__ */ f(Qh, { src: n.imageSrc })
  }
) : null), u7 = ({ isClosing: t, content: e, externalPauseAdStore: n, title: i, caption: s, onPlay: r, onClose: o, vastUrl: l, options: a, isDesktop: c }) => {
  const u = a?.showPauseButton ?? !0, { ref: h, focusSelf: d } = gd({
    focusKey: "sl-pause-ad-play",
    onEnterRelease: r,
    isFocusBoundary: !0,
    forceFocus: !0
  });
  return te(() => () => {
    n.revalidate();
  }, [n]), te(() => {
    h.current && d();
  }, [h, d]), te(() => {
    if (!o)
      return () => {
      };
    const m = (p) => {
      const g = p.keyCode;
      if (g === 461 || g === 10009 || g === 27 || g === 8) {
        p.preventDefault(), p.stopPropagation(), p.stopImmediatePropagation(), o();
        return;
      }
    };
    return window.addEventListener("keydown", m, { capture: !0 }), () => window.removeEventListener("keydown", m, { capture: !0 });
  }, [o]), /* @__PURE__ */ f(e7, { className: Oe("SL_PauseAd", t && "pause-ad-closing"), children: /* @__PURE__ */ U(t7, { children: [
    /* @__PURE__ */ U(n7, { children: [
      /* @__PURE__ */ f(i7, { children: i }),
      /* @__PURE__ */ f(s7, { children: s })
    ] }),
    u && /* @__PURE__ */ f(r7, { children: /* @__PURE__ */ f(
      o7,
      {
        ref: h,
        onClick: r,
        onMouseEnter: () => h.current.focus(),
        "aria-label": "Resume playback"
      }
    ) }),
    /* @__PURE__ */ f(l7, { className: "SL_PauseAdSidebar", children: /* @__PURE__ */ f(a7, { children: l && /* @__PURE__ */ f(c7, { content: e, isDesktop: c, vastUrl: l }) }) })
  ] }) });
}, D2 = ({ showPauseAd: t, vastUrls: e, title: n, caption: i, sdk: s, onClose: r, onRender: o, options: l, isDesktop: a }) => {
  const c = l?.pauseAdDelay ?? 0, u = l?.pauseAdRefetchInterval ?? 1e3 * 60 * 50, [h, d] = re(!1), [m, p] = re(!1), g = Ee(), A = e?.[0].url, b = Ee(A), R = Ee(""), S = Ee("");
  b.current = A;
  const [E, Z] = s.advertisement.getExternalPauseAd(A, {
    refetchInterval: u,
    $enabled: c === 0 || !!t,
    prefetch: c === 0 && u > 0
  }), G = He(E), T = Ue(() => {
    if (r) {
      S.current = b.current;
      const N = E.get().data;
      be.emit("exposedPauseAd", {
        action: "closed",
        payload: N?.url === S.current ? {
          id: N?.id,
          parentId: N?.parentId
        } : {}
      }), r();
    }
  }, [r, E]), C = Ue(() => {
    s.controlVideoPlayer({ play: !0 });
  }, [s]);
  return te(() => {
    Z === b.current && G.error && (clearTimeout(g.current), T?.());
  }, [G, T, Z]), te(() => {
    if (t && A) {
      R.current = b.current, S.current = "";
      const N = E.get().data;
      be.emit("exposedPauseAd", {
        action: "enabled",
        payload: N?.url === R.current ? {
          id: N?.id,
          parentId: N?.parentId
        } : {}
      });
      const Y = () => {
        const L = E.get(), w = L.data;
        (!w || w?.url === b.current) && (!L.loading && w?.imageSrc ? (clearTimeout(g.current), p(!1), d(!0)) : L.loading && (g.current = setTimeout(() => {
          Y();
        }, 200)));
      };
      clearTimeout(g.current), g.current = setTimeout(() => {
        Y();
      }, c);
    } else {
      if (S.current !== b.current) {
        const N = E.get().data;
        S.current = "", R.current !== "" && (be.emit("exposedPauseAd", {
          action: "disabled",
          payload: R.current === N?.url ? {
            id: N?.id,
            parentId: N?.parentId
          } : {}
        }), R.current = "");
      }
      p(!0), g.current = setTimeout(() => {
        d(!1);
      }, 400);
    }
    return () => {
      g.current && clearTimeout(g.current);
    };
  }, [E, T, c, t, A]), te(() => {
    o?.({ rendered: h });
  }, [h, o]), te(() => () => {
    o?.({ rendered: !1 });
  }, [o]), !h || !G.data ? null : /* @__PURE__ */ f(
    u7,
    {
      onClose: T,
      isClosing: m,
      title: n,
      caption: i,
      onPlay: C,
      vastUrl: A,
      options: l,
      isDesktop: a,
      externalPauseAdStore: E,
      content: G.data
    }
  );
}, h7 = pd({
  sdk: null,
  topNavigation: !1
}), d7 = () => wi(h7), m7 = [10, 10, 1, 0], p7 = /* @__PURE__ */ V("div")({
  name: "RemainingTimeCircle",
  class: "r165427",
  propsAsIs: !1
}), g7 = /* @__PURE__ */ V("div")({
  name: "RemainingTime",
  class: "r17garf3",
  propsAsIs: !1
}), f7 = n5, Wl = i5, zh = s5, b7 = ({
  className: t,
  duration: e = 30,
  onTimerExpired: n,
  isPlaying: i = !0
}) => /* @__PURE__ */ f(fd, {
  isPlaying: i,
  strokeWidth: 0,
  duration: e,
  colors: Wl,
  size: 24,
  onComplete: n,
  children: ({
    remainingTime: s
  }) => /* @__PURE__ */ f(g7, {
    className: t,
    children: e === 0 ? 0 : s
  })
}), A7 = ({
  isPlaying: t = !0,
  duration: e = 30,
  onTimerExpired: n
}) => {
  const [i, s] = re(e > 10 ? f7 : Wl), [r, o] = re(2);
  te(() => {
    e === 0 && (o(0), s(zh));
  }, [e]);
  const l = ({
    remainingTime: u
  }) => /* @__PURE__ */ f(p7, {
    children: e === 0 ? 0 : u
  }), a = Ue(() => {
    n?.(), s(zh);
  }, [n, s]), c = Ue((u) => {
    u === 10 && s(Wl);
  }, [s]);
  return /* @__PURE__ */ f(fd, {
    isPlaying: t,
    duration: e,
    colors: t5,
    colorsTime: m7,
    size: 32,
    strokeWidth: r,
    trailStrokeWidth: 2,
    trailColor: i,
    onComplete: a,
    onUpdate: c,
    children: l
  });
}, V7 = /* @__PURE__ */ V("div")({
  name: "CloseIconWrap",
  class: "c3v6bv6",
  propsAsIs: !1
}), R7 = /* @__PURE__ */ V("div")({
  name: "TimerWrap",
  class: "teuhmro",
  propsAsIs: !1
}), E7 = () => oe, y7 = /* @__PURE__ */ V(E7())({
  name: "Icon",
  class: "i17rfxv5",
  propsAsIs: !0
}), C7 = ({
  close: t,
  className: e,
  timerClassName: n,
  skipIcon: i,
  isPlaying: s = !0,
  duration: r = 0,
  autoClose: o
}) => {
  const [l, a] = re(r === 0);
  te(() => {
    a(!r);
  }, [r]);
  const c = Ue(() => {
    o === W9.ENABLED ? t?.() : a(!0);
  }, [o, t]);
  return l ? /* @__PURE__ */ U(V7, {
    "data-a": "intr",
    onClick: t,
    className: e,
    style: i ? {
      width: "auto"
    } : {},
    children: [i && /* @__PURE__ */ f("span", {
      "data-a": "intr",
      children: "Skip"
    }), /* @__PURE__ */ f(y7, {
      "data-a": "intr",
      name: i ? "iconSkip" : "icon-cross"
    })]
  }) : /* @__PURE__ */ f(R7, {
    children: /* @__PURE__ */ f(b7, {
      className: n,
      isPlaying: s,
      duration: r,
      onTimerExpired: c
    })
  });
}, P2 = {
  [M.TWEET]: { label: "Insight", iconName: "icon-insight" },
  [M.PROMOTION]: { label: "Insight", iconName: "icon-insight" },
  [M.UNSET]: void 0,
  [M.FACTOID]: { label: "Insight", iconName: "icon-insight" },
  [M.POLL]: { label: "Poll", iconName: "icon-poll" },
  [M.TRIVIA]: { label: "Trivia", iconName: "icon-trivia" },
  [M.PREDICTION]: { label: "Prediction", iconName: "icon-prediction" }
};
M.TWEET + "", M.FACTOID + "", M.POLL + "", M.TRIVIA + "", M.PREDICTION + "", M.PROMOTION + "", M.UNSET + "";
const W7 = /* @__PURE__ */ V("div")({
  name: "Container",
  class: "c1vwopgc",
  propsAsIs: !1
}), S7 = /* @__PURE__ */ V("div")({
  name: "QuestionTypeWrap",
  class: "qyktpt0",
  propsAsIs: !1
}), Z7 = () => oe, v7 = /* @__PURE__ */ V(Z7())({
  name: "QuestionTypeIcon",
  class: "q951jdx",
  propsAsIs: !0
}), I7 = /* @__PURE__ */ V("span")({
  name: "QuestionTypeTitle",
  class: "qss5f0e",
  propsAsIs: !1
}), N7 = /* @__PURE__ */ V("button")({
  name: "CloseIconWrap",
  class: "c1ao1jtv",
  propsAsIs: !1
}), F7 = () => oe, G7 = /* @__PURE__ */ V(F7())({
  name: "CloseIcon",
  class: "cvsl7l3",
  propsAsIs: !0
}), X7 = ht(N7, {}), U7 = ({ webos: t, type: e, closeTimer: n, close: i, label: s, mastersApp: r }) => {
  const o = e ? P2[e] : { label: s, iconName: void 0 };
  return /* @__PURE__ */ U(W7, { children: [
    /* @__PURE__ */ U(S7, { children: [
      o?.iconName && /* @__PURE__ */ f(
        v7,
        {
          "data-type-trivia": e === M.TRIVIA,
          "data-type-poll": e === M.POLL,
          "data-type-prediction": e === M.PREDICTION,
          "data-masters-app": !!r,
          name: o.iconName
        }
      ),
      o?.label && /* @__PURE__ */ f(I7, { children: o.label })
    ] }),
    n?.seconds ? /* @__PURE__ */ f(C7, { close: i, autoClose: n.auto, duration: n.seconds }) : /* @__PURE__ */ f(X7, { webos: t, "data-a": "intr", onClick: i, type: "button", "data-close-btn": "true", children: /* @__PURE__ */ f(G7, { "data-a": "intr", name: "icon-cross" }) })
  ] });
}, B7 = "data:image/svg+xml,%3csvg%20width='103'%20height='18'%20viewBox='0%200%20103%2018'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_6919_104497)'%3e%3cpath%20d='M9.89618%203.45801C9.91951%203.45801%209.94451%203.46134%209.96784%203.46134C9.97618%203.46134%209.98284%203.46134%209.99118%203.46467H9.99784C10.0095%203.46467%2010.0212%203.46801%2010.0312%203.46801C10.0412%203.46801%2010.0462%203.46801%2010.0545%203.47134C10.0762%203.47467%2010.0962%203.47467%2010.1178%203.47634C10.1412%203.47967%2010.1662%203.48134%2010.1895%203.48467H10.2012C10.2462%203.48967%2010.2945%203.49634%2010.3395%203.50467C10.4512%203.52467%2010.5595%203.54801%2010.6662%203.57801C10.6928%203.58301%2010.7178%203.59301%2010.7445%203.60134H10.7478C10.7745%203.60967%2010.7995%203.61801%2010.8262%203.62467C10.8528%203.63301%2010.8778%203.64134%2010.9045%203.65134C10.9312%203.65967%2010.9562%203.66801%2010.9795%203.67967C11.0012%203.68801%2011.0212%203.69634%2011.0428%203.70634C11.0495%203.70967%2011.0578%203.71134%2011.0645%203.71467C11.0828%203.72301%2011.1012%203.72967%2011.1195%203.73801C11.1262%203.74134%2011.1312%203.74301%2011.1378%203.74634C11.1562%203.75467%2011.1712%203.76134%2011.1895%203.76967C11.1962%203.77301%2011.2045%203.77467%2011.2128%203.78134C11.2345%203.78967%2011.2528%203.79801%2011.2728%203.80967C11.2762%203.80967%2011.2795%203.81301%2011.2812%203.81301C11.3045%203.82467%2011.3295%203.83634%2011.3512%203.84801C11.3695%203.85634%2011.3878%203.86801%2011.4062%203.87634C11.4212%203.88134%2011.4328%203.89134%2011.4462%203.89967C11.4645%203.91134%2011.4828%203.91967%2011.5012%203.93134C11.5045%203.93467%2011.5078%203.93467%2011.5095%203.93634L11.5728%203.97467H11.5762L15.2178%206.18801L15.4412%206.32467C16.3228%206.90801%2016.9028%207.88467%2016.9028%208.99301C16.9028%2010.1013%2016.3262%2011.0763%2015.4445%2011.6613L15.2095%2011.803L11.5745%2014.0113H11.5712L11.5078%2014.0497C11.5078%2014.0497%2011.5012%2014.053%2011.4995%2014.0547C11.4812%2014.0663%2011.4628%2014.0747%2011.4445%2014.0863C11.4595%2014.078%2011.4745%2014.0697%2011.4895%2014.0597L5.94951%2017.433C5.94951%2017.433%205.94618%2017.433%205.94618%2017.4363L5.74451%2017.558H5.74118C5.19784%2017.863%204.55784%2018.0247%203.87784%2017.993C2.73618%2017.938%201.75784%2017.3463%201.19284%2016.4847C0.837844%2015.9413%200.64451%2015.2913%200.681177%2014.6013C0.71451%2013.983%200.922844%2013.4147%201.26118%2012.9397L1.26951%2012.9247L4.04451%208.99634L6.77784%205.12634C6.81118%205.07967%206.84784%205.03301%206.87784%204.98467C6.87451%204.98967%206.86951%204.99967%206.86284%205.00467C6.87118%204.98967%206.88118%204.97634%206.88951%204.96134C6.88951%204.95801%206.89284%204.95801%206.89284%204.95634C6.89618%204.95301%206.89951%204.94801%206.90118%204.94467C6.90118%204.94467%206.90118%204.94134%206.90451%204.94134C6.91951%204.92134%206.93451%204.90134%206.94618%204.87801C6.96118%204.85801%206.97618%204.83801%206.99118%204.81634C7.00618%204.79634%207.02118%204.77634%207.03618%204.75467C7.03951%204.75134%207.03951%204.74967%207.04284%204.74634C7.04618%204.74301%207.04618%204.74134%207.04951%204.74134C7.06451%204.72134%207.07951%204.70134%207.09784%204.67967C7.10951%204.66467%207.12118%204.65134%207.13451%204.63634C7.16784%204.59801%207.20118%204.56134%207.23784%204.52301C7.25284%204.50801%207.26451%204.49467%207.27951%204.47967C7.30118%204.45634%207.32118%204.43634%207.34618%204.41634C7.36451%204.39967%207.38284%204.38134%207.40118%204.36467C7.41951%204.34801%207.43451%204.33301%207.45284%204.31801C7.45618%204.31467%207.45951%204.31301%207.45951%204.31301C7.47118%204.30134%207.48118%204.29301%207.49284%204.28467C7.50451%204.27301%207.51951%204.26134%207.53284%204.25301C7.53618%204.24967%207.53951%204.24801%207.54118%204.24801C7.55951%204.23301%207.57451%204.21967%207.59284%204.20467C7.60784%204.18967%207.62618%204.17801%207.64118%204.16634C7.65618%204.15467%207.66784%204.14634%207.68284%204.13467C7.70118%204.11967%207.71951%204.10801%207.73784%204.09467C7.75284%204.08634%207.76451%204.07467%207.77951%204.06634C7.78618%204.06134%207.79451%204.05467%207.80284%204.05134C7.81784%204.03967%207.83284%204.03134%207.84784%204.02301C7.85118%204.01967%207.85618%204.01801%207.85951%204.01467C7.87784%204.00301%207.89618%203.99134%207.91118%203.98301C7.91784%203.97801%207.92618%203.97467%207.93284%203.96801C7.94784%203.95967%207.95951%203.95134%207.97451%203.94134C7.98284%203.93634%207.99284%203.92967%208.00118%203.92467C8.01618%203.91634%208.03451%203.90801%208.04951%203.89634C8.05284%203.89301%208.05784%203.89134%208.06451%203.88801C8.08618%203.87634%208.10451%203.86467%208.12451%203.85634C8.12784%203.85301%208.13118%203.85301%208.13618%203.85134C8.15784%203.83967%208.17784%203.82801%208.19951%203.81967C8.19951%203.81967%208.20284%203.81967%208.20284%203.81634C8.22618%203.80467%208.24784%203.79301%208.27284%203.78134C8.27284%203.78134%208.27618%203.78134%208.27618%203.77801C8.29451%203.76967%208.31284%203.76134%208.33284%203.75134C8.34118%203.74801%208.35118%203.74301%208.35951%203.73967C8.37118%203.73467%208.38284%203.72801%208.39618%203.72467C8.41118%203.71967%208.42284%203.71301%208.43784%203.70801C8.46118%203.69967%208.48284%203.69134%208.50784%203.68134C8.52284%203.67634%208.53451%203.66967%208.54951%203.66634C8.57118%203.65801%208.59118%203.65134%208.61284%203.64301C8.63118%203.63801%208.65284%203.63134%208.66951%203.62301C8.75451%203.59634%208.83784%203.57134%208.92284%203.54967C8.94118%203.54467%208.96284%203.54134%208.97951%203.53801C9.08451%203.51467%209.19451%203.49467%209.30284%203.48301C9.32951%203.47967%209.35784%203.47801%209.38451%203.47467C9.42118%203.47134%209.45951%203.46967%209.49618%203.46634C9.51118%203.46634%209.52284%203.46301%209.53784%203.46301H9.55951C9.58951%203.46301%209.61618%203.45967%209.64784%203.45967H9.73784C9.79451%203.45967%209.84284%203.45967%209.89451%203.46301L9.89618%203.45801ZM10.6662%2014.413C10.5612%2014.4413%2010.4512%2014.4647%2010.3395%2014.4863C10.4512%2014.4663%2010.5595%2014.443%2010.6662%2014.413ZM9.56118%2014.5313H9.56951C9.56118%2014.5313%209.54784%2014.5313%209.53951%2014.528C9.54618%2014.528%209.55451%2014.5313%209.56118%2014.5313ZM7.08784%2013.293C7.05451%2013.253%207.02451%2013.2147%206.99451%2013.1747C7.02451%2013.2147%207.05784%2013.253%207.08784%2013.293ZM6.90284%2013.043C6.90284%2013.043%206.90618%2013.0463%206.90618%2013.048C6.90284%2013.0447%206.90284%2013.043%206.89951%2013.0363C6.89618%2013.033%206.89618%2013.0297%206.89284%2013.0247C6.86951%2012.9897%206.84784%2012.953%206.82284%2012.918C6.84451%2012.953%206.86784%2012.9913%206.88951%2013.0247C6.89618%2013.0297%206.89784%2013.0363%206.90118%2013.0413L6.90284%2013.043ZM6.89451%2013.0263C6.85784%2012.968%206.81951%2012.913%206.77618%2012.858L6.89451%2013.0263Z'%20fill='%231652A8'%20style='fill:%231652A8;fill:color(display-p3%200.0863%200.3216%200.6588);fill-opacity:1;'/%3e%3cg%20opacity='0.85'%3e%3cpath%20d='M5.77088%200.453306L5.97588%200.578306L5.97921%200.581639L11.5225%203.94997C11.5075%203.94164%2011.4925%203.93331%2011.4775%203.92331C11.4959%203.93497%2011.5142%203.94331%2011.5325%203.95497C11.5359%203.95831%2011.5392%203.95831%2011.5409%203.95997L11.6042%203.99831H11.6075L15.2492%206.21164L15.4725%206.34831C16.3542%206.93164%2016.9342%207.9083%2016.9342%209.01664C16.9342%2010.125%2016.3575%2011.1%2015.4759%2011.685L15.2409%2011.8266L11.6059%2014.035H11.6025L11.5392%2014.0733C11.5392%2014.0733%2011.5325%2014.0766%2011.5309%2014.0783C11.5125%2014.09%2011.4942%2014.0983%2011.4759%2014.11C11.4642%2014.1183%2011.4492%2014.125%2011.4359%2014.1333C11.4175%2014.145%2011.3992%2014.1533%2011.3809%2014.1616C11.3575%2014.1733%2011.3359%2014.185%2011.3109%2014.1966C11.3075%2014.2%2011.3042%2014.2%2011.3025%2014.2C11.2842%2014.2116%2011.2625%2014.22%2011.2425%2014.2283C11.2359%2014.2316%2011.2275%2014.2333%2011.2192%2014.24C11.2009%2014.2483%2011.1859%2014.255%2011.1675%2014.2633C11.1609%2014.2666%2011.1592%2014.2683%2011.1525%2014.2683C11.1309%2014.2766%2011.1109%2014.285%2011.0859%2014.2966C11.0625%2014.3083%2011.0342%2014.3166%2011.0109%2014.325C10.9875%2014.3333%2010.9592%2014.345%2010.9359%2014.3533C10.9092%2014.3616%2010.8842%2014.37%2010.8575%2014.38C10.8309%2014.3883%2010.8059%2014.3966%2010.7792%2014.4033H10.7759C10.7492%2014.4116%2010.7242%2014.4183%2010.6975%2014.4266C10.5925%2014.455%2010.4825%2014.4783%2010.3709%2014.4983C10.3259%2014.5066%2010.2775%2014.5133%2010.2325%2014.5183C10.2259%2014.5183%2010.2242%2014.5183%2010.2209%2014.5216C10.1975%2014.525%2010.1725%2014.5283%2010.1492%2014.53C10.1009%2014.5366%2010.0525%2014.5383%2010.0042%2014.5416C9.92921%2014.5483%209.85254%2014.5483%209.77754%2014.5483H9.68088C9.65421%2014.5483%209.62921%2014.545%209.60254%2014.545C9.59421%2014.545%209.58088%2014.545%209.57254%2014.5416C9.53254%2014.5383%209.49088%2014.5366%209.45254%2014.5333C9.27421%2014.5166%209.09588%2014.4866%208.92754%2014.4466C8.90421%2014.44%208.87921%2014.435%208.85254%2014.4266C8.81921%2014.4183%208.78588%2014.41%208.74921%2014.3983C8.73088%2014.3933%208.70921%2014.3866%208.69254%2014.3816C8.66588%2014.3733%208.64088%2014.365%208.61421%2014.355C8.58754%2014.3466%208.56254%2014.3383%208.53921%2014.3266C8.51588%2014.3183%208.48754%2014.3066%208.46421%2014.2983C8.44088%2014.29%208.41921%2014.2816%208.39754%2014.27C8.38921%2014.2666%208.38254%2014.265%208.37421%2014.2583C8.35588%2014.25%208.33754%2014.2416%208.31754%2014.2316C8.31754%2014.2316%208.31421%2014.2316%208.31421%2014.2283C8.29088%2014.2166%208.26588%2014.205%208.24254%2014.1933C8.21921%2014.1816%208.19421%2014.17%208.17088%2014.155C8.14754%2014.1433%208.12254%2014.1283%208.10088%2014.1166C8.07754%2014.105%208.05254%2014.09%208.03088%2014.0766C8.00754%2014.0616%207.98588%2014.0483%207.96088%2014.0366C7.93754%2014.0216%207.91588%2014.0083%207.89421%2013.9933C7.87254%2013.9783%207.85254%2013.965%207.83088%2013.95C7.82754%2013.95%207.82754%2013.9466%207.82421%2013.945C7.80588%2013.9333%207.78754%2013.9183%207.76754%2013.905C7.76421%2013.9016%207.76088%2013.9016%207.75921%2013.9C7.74088%2013.885%207.72254%2013.8733%207.70421%2013.86C7.70088%2013.8566%207.69588%2013.855%207.69254%2013.8483C7.67421%2013.8333%207.65588%2013.82%207.63754%2013.805C7.63754%2013.805%207.63421%2013.805%207.63421%2013.8016C7.61588%2013.7866%207.59754%2013.7733%207.57754%2013.755C7.57421%2013.7516%207.57088%2013.7516%207.56921%2013.7483C7.55421%2013.7366%207.53921%2013.7216%207.52421%2013.71C7.51754%2013.705%207.51254%2013.6983%207.50588%2013.695C7.49421%2013.6833%207.47921%2013.6716%207.46588%2013.66C7.43921%2013.6366%207.41421%2013.6133%207.39088%2013.5866C7.37254%2013.57%207.35754%2013.5516%207.33921%2013.535C7.32754%2013.5233%207.31754%2013.5116%207.30588%2013.5C7.29421%2013.4883%207.28421%2013.48%207.27588%2013.4683C7.25754%2013.4516%207.24254%2013.43%207.22421%2013.4133C7.19088%2013.375%207.15754%2013.3383%207.12421%2013.2966C7.09088%2013.2566%207.06088%2013.2183%207.03088%2013.1783C7.01588%2013.1583%207.00088%2013.1383%206.98588%2013.1166C6.97088%2013.0966%206.95588%2013.0766%206.94421%2013.0533C6.94088%2013.05%206.94088%2013.0483%206.93754%2013.0416C6.93421%2013.0383%206.93421%2013.0366%206.93088%2013.03C6.90754%2012.995%206.88588%2012.9583%206.86088%2012.9233C6.88254%2012.9583%206.90588%2012.995%206.92754%2013.03C6.89088%2012.9716%206.85254%2012.9166%206.80921%2012.8616L4.07921%208.99664L1.34088%205.12997L1.23254%204.97664L1.22921%204.97164C0.92421%204.51164%200.737543%203.97497%200.707543%203.39497C0.670877%202.70497%200.86421%202.05164%201.22088%201.50997C1.78588%200.648306%202.76588%200.0566391%203.90421%20-2.75556e-05C4.58421%20-0.0150276%205.22421%200.148306%205.77088%200.453306Z'%20fill='url(%23paint0_linear_6919_104497)'%20style=''/%3e%3c/g%3e%3cpath%20d='M32.4132%2012.862C31.2015%2012.862%2030.4482%2012.0503%2030.4482%2010.7203V8.4453H32.6632V7.02697H30.4482V4.72363L28.8548%205.9053V7.0253H27.9648V8.44363H28.8548V10.7053C28.8548%2012.9953%2030.1982%2014.412%2032.4282%2014.412H32.7682V12.862H32.4132Z'%20fill='%23687C8B'%20style='fill:%23687C8B;fill:color(display-p3%200.4078%200.4863%200.5451);fill-opacity:1;'/%3e%3cpath%20d='M19.9812%2012.5767L21.4028%2011.4651C22.0395%2012.4867%2022.8995%2013.0351%2023.9962%2013.0351C25.1962%2013.0351%2025.9512%2012.2651%2025.9512%2011.3017C25.9512%2010.1901%2024.7662%209.83506%2023.5212%209.43506C22.0545%208.96172%2020.4695%208.36839%2020.4695%206.38339C20.4695%204.73839%2021.9362%203.43506%2023.9362%203.43506C25.5812%203.43506%2026.6028%204.07172%2027.4328%205.03506L26.1145%206.01339C25.6262%205.25839%2024.8995%204.85839%2023.9362%204.85839C22.8395%204.85839%2022.1278%205.51006%2022.1278%206.35506C22.1278%207.39172%2023.2695%207.73339%2024.5128%208.14839C25.9945%208.65172%2027.6095%209.29006%2027.6095%2011.3051C27.6095%2012.9651%2026.2462%2014.5501%2024.0095%2014.5501C22.1578%2014.5501%2020.8978%2013.7651%2019.9795%2012.5801L19.9812%2012.5767Z'%20fill='%23687C8B'%20style='fill:%23687C8B;fill:color(display-p3%200.4078%200.4863%200.5451);fill-opacity:1;'/%3e%3cpath%20d='M38.2695%2010.7367C38.2695%208.56503%2039.9379%206.8667%2042.1095%206.8667C44.2812%206.8667%2045.9062%208.4467%2045.9062%2010.6334V11.2534H39.7912C39.9979%2012.39%2040.8845%2013.1434%2042.1695%2013.1434C43.1745%2013.1434%2043.9429%2012.6117%2044.3262%2011.8134L45.6262%2012.5367C44.9762%2013.7484%2043.8095%2014.545%2042.1695%2014.545C39.8362%2014.545%2038.2695%2012.8767%2038.2695%2010.735V10.7367ZM39.8645%209.91003H44.2962C44.0595%208.8467%2043.2479%208.25503%2042.1095%208.25503C40.9712%208.25503%2040.1595%208.93503%2039.8645%209.91003Z'%20fill='%23687C8B'%20style='fill:%23687C8B;fill:color(display-p3%200.4078%200.4863%200.5451);fill-opacity:1;'/%3e%3cpath%20d='M33.7549%2010.72C33.7549%208.42999%2035.0982%207.02832%2037.3282%207.02832H38.0366V8.56499H37.3132C36.1016%208.56499%2035.3199%209.40665%2035.3349%2010.7367V14.415H33.7549V10.7233V10.72Z'%20fill='%23687C8B'%20style='fill:%23687C8B;fill:color(display-p3%200.4078%200.4863%200.5451);fill-opacity:1;'/%3e%3cpath%20d='M46.6882%2010.7218C46.6882%208.56517%2048.3865%206.88184%2050.5132%206.88184C52.6399%206.88184%2054.3082%208.56517%2054.3082%2010.7218V14.4135H52.7582V13.4535C52.2415%2014.1468%2051.4432%2014.5468%2050.4682%2014.5468C48.3565%2014.5468%2046.6865%2012.8935%2046.6865%2010.7218H46.6882ZM52.7882%2010.7218C52.7882%209.40684%2051.7832%208.3585%2050.5132%208.3585C49.2432%208.3585%2048.2382%209.40684%2048.2382%2010.7218C48.2382%2012.0368%2049.2282%2013.0852%2050.5132%2013.0852C51.7982%2013.0852%2052.7882%2012.0218%2052.7882%2010.7218Z'%20fill='%23687C8B'%20style='fill:%23687C8B;fill:color(display-p3%200.4078%200.4863%200.5451);fill-opacity:1;'/%3e%3cpath%20d='M55.3027%2010.2717C55.3027%208.30667%2056.6461%206.875%2058.6411%206.875C59.7777%206.875%2060.6944%207.33333%2061.2694%208.10167C61.8161%207.33333%2062.7027%206.875%2063.8394%206.875C65.8477%206.875%2067.2511%208.27833%2067.2511%2010.2717V14.4067H65.6711V10.2867C65.6711%209.165%2064.9177%208.38167%2063.8394%208.38167C62.7611%208.38167%2062.0527%209.18%2062.0677%2010.2433V14.4083H60.4877V10.2883C60.4877%209.16667%2059.7194%208.38333%2058.6411%208.38333C57.5627%208.38333%2056.8694%209.18167%2056.8827%2010.245V14.41H55.3027V10.275V10.2717Z'%20fill='%23687C8B'%20style='fill:%23687C8B;fill:color(display-p3%200.4078%200.4863%200.5451);fill-opacity:1;'/%3e%3cpath%20d='M68.2646%203.62695H69.8746V12.872H74.2313V14.4086H68.2646V3.62695Z'%20fill='%23687C8B'%20style='fill:%23687C8B;fill:color(display-p3%200.4078%200.4863%200.5451);fill-opacity:1;'/%3e%3cpath%20d='M89.418%2010.7367C89.418%208.56503%2091.0863%206.8667%2093.258%206.8667C95.4296%206.8667%2097.0546%208.4467%2097.0546%2010.6334V11.2534H90.9396C91.1463%2012.39%2092.033%2013.1434%2093.318%2013.1434C94.323%2013.1434%2095.0913%2012.6117%2095.4746%2011.8134L96.7746%2012.5367C96.1246%2013.7484%2094.958%2014.545%2093.318%2014.545C90.9846%2014.545%2089.418%2012.8767%2089.418%2010.735V10.7367ZM91.013%209.91003H95.4446C95.208%208.8467%2094.3963%208.25503%2093.258%208.25503C92.1196%208.25503%2091.308%208.93503%2091.013%209.91003Z'%20fill='%23687C8B'%20style='fill:%23687C8B;fill:color(display-p3%200.4078%200.4863%200.5451);fill-opacity:1;'/%3e%3cpath%20d='M74.4948%2010.7218C74.4948%208.56517%2076.1932%206.88184%2078.3198%206.88184C80.4465%206.88184%2082.1148%208.56517%2082.1148%2010.7218V14.4135H80.5648V13.4535C80.0482%2014.1468%2079.2498%2014.5468%2078.2748%2014.5468C76.1632%2014.5468%2074.4932%2012.8935%2074.4932%2010.7218H74.4948ZM80.5948%2010.7218C80.5948%209.40684%2079.5898%208.3585%2078.3198%208.3585C77.0498%208.3585%2076.0448%209.40684%2076.0448%2010.7218C76.0448%2012.0368%2077.0348%2013.0852%2078.3198%2013.0852C79.6048%2013.0852%2080.5948%2012.0218%2080.5948%2010.7218Z'%20fill='%23687C8B'%20style='fill:%23687C8B;fill:color(display-p3%200.4078%200.4863%200.5451);fill-opacity:1;'/%3e%3cpath%20d='M85.0381%2014.0498L81.9814%207.0498H83.6798L85.8364%2012.1748L87.8748%207.0498H89.5431L85.0831%2017.8465H83.4581L85.0381%2014.0515V14.0498Z'%20fill='%23687C8B'%20style='fill:%23687C8B;fill:color(display-p3%200.4078%200.4863%200.5451);fill-opacity:1;'/%3e%3cpath%20d='M98.041%2010.7151C98.041%208.4251%2099.3843%207.02344%20101.614%207.02344H102.323V8.5601H101.599C100.388%208.5601%2099.606%209.40177%2099.621%2010.7318V14.4101H98.041V10.7184V10.7151Z'%20fill='%23687C8B'%20style='fill:%23687C8B;fill:color(display-p3%200.4078%200.4863%200.5451);fill-opacity:1;'/%3e%3c/g%3e%3cdefs%3e%3clinearGradient%20id='paint0_linear_6919_104497'%20x1='4.31754'%20y1='8.70664'%20x2='13.6359'%20y2='3.59497'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20offset='0.2'%20stop-color='%231589EE'%20style='stop-color:%231589EE;stop-color:color(display-p3%200.0824%200.5373%200.9333);stop-opacity:1;'/%3e%3cstop%20offset='1'%20stop-color='%235EB4FF'%20style='stop-color:%235EB4FF;stop-color:color(display-p3%200.3686%200.7059%201.0000);stop-opacity:1;'/%3e%3c/linearGradient%3e%3cclipPath%20id='clip0_6919_104497'%3e%3crect%20width='101.648'%20height='18'%20fill='white'%20style='fill:white;fill-opacity:1;'%20transform='translate(0.675781)'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", Mo = /* @__PURE__ */ V("div")({
  name: "SponsorLogoWrap",
  class: "s8p5v5z",
  propsAsIs: !1
}), w7 = () => oe, Y7 = /* @__PURE__ */ V(w7())({
  name: "SponsorLogo",
  class: "s755yti",
  propsAsIs: !0
}), T7 = /* @__PURE__ */ V("img")({
  name: "AdSponsorLogo",
  class: "a1dflj8e",
  propsAsIs: !1
}), L7 = ({
  mastersApp: t,
  sponsorLogo: e
}) => t ? /* @__PURE__ */ f(Mo, {
  children: /* @__PURE__ */ f(Y7, {
    name: "mastersLogo"
  })
}) : e ? /* @__PURE__ */ f(Mo, {
  children: /* @__PURE__ */ f(T7, {
    src: e,
    alt: "ad-sponsor-logo"
  })
}) : /* @__PURE__ */ f(Mo, {
  children: /* @__PURE__ */ f("img", {
    src: B7,
    alt: "stream-layer-logo"
  })
}), k7 = /* @__PURE__ */ V("div")({
  name: "Container",
  class: "cqg02m",
  propsAsIs: !1
}), Qo = ({ children: t, style: e, loading: n }) => n ? /* @__PURE__ */ f(k7, { style: e, children: t }) : t, J7 = /* @__PURE__ */ V("div")({
  name: "Container",
  class: "c1gcvmcj",
  propsAsIs: !1
}), x7 = /* @__PURE__ */ V("div")({
  name: "Title",
  class: "tnr592a",
  propsAsIs: !1
}), M7 = /* @__PURE__ */ V("div")({
  name: "Description",
  class: "d1e8jqpv",
  propsAsIs: !1
}), Q7 = () => oe, z7 = /* @__PURE__ */ V(Q7())({
  name: "Icon",
  class: "i1vs651k",
  propsAsIs: !0
}), K7 = ({ icon: t, title: e, description: n }) => /* @__PURE__ */ U(J7, { children: [
  /* @__PURE__ */ f(z7, { name: t }),
  /* @__PURE__ */ f(x7, { children: e }),
  /* @__PURE__ */ f(M7, { children: n })
] }), H7 = /* @__PURE__ */ V("div")({
  name: "Container",
  class: "c1pgyo67",
  propsAsIs: !1
}), O7 = "sx17qu6", D7 = "h1692c5m", Ra = ({
  children: t,
  style: e,
  className: n,
  enabled: i = !0,
  hiding: s,
  onAnimationEnd: r
}) => /* @__PURE__ */ f(H7, {
  style: e,
  className: Oe(n, i && O7, i && s && D7),
  onAnimationEnd: r,
  children: t
}), P7 = () => Ra, _7 = /* @__PURE__ */ V(P7())({
  name: "GrowingContainer",
  class: "gck55ev",
  propsAsIs: !0
}), _2 = ({
  children: t,
  style: e,
  enabled: n,
  animate: i,
  ...s
}) => {
  const r = Ee(null);
  return /* @__PURE__ */ f(_7, {
    ...s,
    enabled: n && i,
    style: {
      ...e,
      ...(() => {
        const o = r?.current, l = (o && window.getComputedStyle(o))?.getPropertyValue("height");
        return n ? {
          height: i ? l : 0
        } : {};
      })()
    },
    children: /* @__PURE__ */ f("div", {
      ref: r,
      children: t
    })
  });
}, j7 = () => _2, $7 = /* @__PURE__ */ V(j7())({
  name: "ShowInContainer",
  class: "s16sbdnm",
  propsAsIs: !0
}), mn = /* @__PURE__ */ V("div")({
  name: "FeedbackContainer",
  class: "fbhorgl",
  propsAsIs: !1
}), Kh = "s1g20ja7", q7 = /* @__PURE__ */ V("div")({
  name: "Container",
  class: "c455ozj",
  propsAsIs: !1
}), ey = () => oe, Hh = /* @__PURE__ */ V(ey())({
  name: "IconPrediction",
  class: "i1913njx",
  propsAsIs: !0
}), Vi = /* @__PURE__ */ V("div")({
  name: "FeedbackIconWrap",
  class: "fzfk69z",
  propsAsIs: !1
}), fs = /* @__PURE__ */ V("div")({
  name: "FeedbackHeader",
  class: "fx87qaj",
  propsAsIs: !1
}), ty = /* @__PURE__ */ V("span")({
  name: "FeedbackTitle",
  class: "fvek9ew",
  propsAsIs: !1
}), bn = /* @__PURE__ */ V("span")({
  name: "FeedbackDescription",
  class: "f1kbtp09",
  propsAsIs: !1
}), ny = /* @__PURE__ */ V("div")({
  name: "FeedbackTitleWrap",
  class: "f4i8rro",
  propsAsIs: !1
}), iy = /* @__PURE__ */ V("div")({
  name: "FeedbackResultDescriptionWrap",
  class: "fqyssr",
  propsAsIs: !1
}), sy = () => bn, ry = /* @__PURE__ */ V(sy())({
  name: "FeedbackDynamicDescription",
  class: "fyv794i",
  propsAsIs: !0
}), oy = () => bn, ly = /* @__PURE__ */ V(oy())({
  name: "FeedbackResultDescription",
  class: "f1jkj9vx",
  propsAsIs: !0
}), zo = /* @__PURE__ */ V("div")({
  name: "FeedbackText",
  class: "f1pxh3a6",
  propsAsIs: !1
}), ay = /* @__PURE__ */ V("span")({
  name: "DynamicWrap",
  class: "d1afvufn",
  propsAsIs: !1
}), cy = /* @__PURE__ */ V("div")({
  name: "EarlyFeedbackDescription",
  class: "eq8u24d",
  propsAsIs: !1
}), Oh = ({
  feedbackMessages: t,
  questionVotedCorrectly: e,
  questionVoted: n,
  questionType: i,
  hasCorrectAnswer: s,
  showExpiredNotification: r,
  showClosedNotificationTrivia: o,
  votedInCurrentRender: l,
  votedAfterQuestionClosed: a,
  voteErrorMessage: c,
  enteredAnActiveQuestion: u,
  marketClosed: h,
  percentsAnimated: d,
  votedAnswer: m,
  isEarlyPrediction: p,
  correctAnswer: g,
  onAnimationEnd: A
}) => {
  const b = n && (i === M.TRIVIA || i === M.PREDICTION), R = i === M.PREDICTION && !s, S = h && i === M.PREDICTION && !n || i === M.PREDICTION && a && l && u, E = b && R, Z = b && s, G = i === M.PREDICTION && n && l && s, T = n && i === M.POLL && l, C = e ? "correct" : "incorrect", N = e ? t?.correctFeedback : t?.incorrectFeedback;
  return r || o || E || Z || S || T || G || c ? /* @__PURE__ */ f(
    $7,
    {
      enabled: l,
      animate: !c && r ? !0 : d,
      onAnimationEnd: A,
      children: /* @__PURE__ */ U(q7, { "data-prediction": R, children: [
        c && !S && /* @__PURE__ */ U(mn, { children: [
          !p && /* @__PURE__ */ f(Hh, { name: "questionExpired" }),
          /* @__PURE__ */ f(bn, { children: c })
        ] }),
        !c && r && /* @__PURE__ */ U(mn, { children: [
          !p && /* @__PURE__ */ f(Vi, { children: /* @__PURE__ */ f(oe, { name: "questionExpired" }) }),
          /* @__PURE__ */ U("div", { children: [
            /* @__PURE__ */ f(fs, { children: /* @__PURE__ */ f(bn, { children: "Question Expired" }) }),
            /* @__PURE__ */ f(zo, { children: "You can still answer to see if you're correct, but no points are awarded for expired questions." })
          ] })
        ] }),
        !c && o && /* @__PURE__ */ U(mn, { className: Oe(Kh), children: [
          /* @__PURE__ */ f(Vi, { children: /* @__PURE__ */ f(oe, { name: "questionExpired" }) }),
          /* @__PURE__ */ U("div", { children: [
            /* @__PURE__ */ f(fs, { children: /* @__PURE__ */ f(bn, { children: "Question Closed" }) }),
            /* @__PURE__ */ f(zo, { children: "This question was answered after the moderator closed the question. So the points for this answer won’t tally." })
          ] })
        ] }),
        S && /* @__PURE__ */ U(mn, { children: [
          !p && /* @__PURE__ */ f(Vi, { children: /* @__PURE__ */ f(oe, { name: "questionExpired" }) }),
          /* @__PURE__ */ U("div", { children: [
            /* @__PURE__ */ f(fs, { children: /* @__PURE__ */ f(bn, { children: p ? s ? "The results are already in!" : "Question is Closed" : "Question Closed" }) }),
            /* @__PURE__ */ f(zo, { children: p ? /* @__PURE__ */ f(cy, { children: s ? `Correct: ${g?.text}` : "Event affecting the outcome has occurred." }) : "This event has already taken place, so the ability to make a prediction on its outcome is no longer available." })
          ] })
        ] }),
        !c && E && /* @__PURE__ */ U(mn, { children: [
          !p && /* @__PURE__ */ f(Hh, { name: "icon-prediction" }),
          /* @__PURE__ */ U(ry, { children: [
            "Your pick has been recorded. ",
            /* @__PURE__ */ f(ay, { children: "We’ll notify you of the result." })
          ] })
        ] }),
        !c && T && /* @__PURE__ */ U(mn, { children: [
          !p && /* @__PURE__ */ f(Vi, { "data-feedback-type": "correct", children: /* @__PURE__ */ f(oe, { name: "correct" }) }),
          /* @__PURE__ */ f(bn, { children: "Thanks for answering. Please stay tuned for the next question." })
        ] }),
        !c && (Z || G) && /* @__PURE__ */ U(mn, { className: Oe(o && Kh), children: [
          !p && /* @__PURE__ */ f(Vi, { "data-feedback-type": C, children: /* @__PURE__ */ f(oe, { name: C }) }),
          /* @__PURE__ */ f("div", { children: /* @__PURE__ */ U(fs, { children: [
            p ? /* @__PURE__ */ f(ny, { children: C === "incorrect" ? /* @__PURE__ */ U(at, { children: [
              /* @__PURE__ */ f("div", { children: "So close!" }),
              /* @__PURE__ */ f("div", { children: "Better luck next time" })
            ] }) : /* @__PURE__ */ U(at, { children: [
              /* @__PURE__ */ f("div", { children: "That’s correct!" }),
              /* @__PURE__ */ f("div", { children: "You chose wisely." })
            ] }) }) : /* @__PURE__ */ f(ty, { "data-feedback-type": C, children: N?.title }),
            p ? /* @__PURE__ */ U(iy, { children: [
              /* @__PURE__ */ U("div", { children: [
                "Your pick: ",
                m?.text
              ] }),
              /* @__PURE__ */ f("div", { children: C === "incorrect" ? `Correct: ${g?.text}` : "" })
            ] }) : /* @__PURE__ */ f(ly, { children: N?.description })
          ] }) })
        ] })
      ] })
    }
  ) : null;
}, uy = /* @__PURE__ */ V("div")({
  name: "Container",
  class: "c1hygj0s",
  propsAsIs: !1
}), hy = /* @__PURE__ */ V("div")({
  name: "Title",
  class: "t1r84tez",
  propsAsIs: !1
}), dy = /* @__PURE__ */ V("div")({
  name: "Description",
  class: "d1aj1a7k",
  propsAsIs: !1
}), my = /* @__PURE__ */ V("div")({
  name: "AdditionalDescription",
  class: "ax09ezs",
  propsAsIs: !1
}), py = () => oe, gy = /* @__PURE__ */ V(py())({
  name: "Icon",
  class: "inkrac",
  propsAsIs: !0
}), fy = ({ icon: t, title: e, description: n, additionalDescription: i }) => /* @__PURE__ */ U(uy, { children: [
  t && /* @__PURE__ */ f(gy, { name: t }),
  /* @__PURE__ */ f(hy, { children: e }),
  /* @__PURE__ */ f(dy, { children: n }),
  i && /* @__PURE__ */ f(my, { children: i })
] }), by = /* @__PURE__ */ V("div")({
  name: "SDKScrollContainer",
  class: "s102vcph",
  propsAsIs: !1
}), j2 = /* @__PURE__ */ V("div")({
  name: "Container",
  class: "c14ielyq",
  propsAsIs: !1
}), Ay = () => by, Vy = /* @__PURE__ */ V(Ay())({
  name: "QuestionScrollContainer",
  class: "q1tlqx57",
  propsAsIs: !0
}), Ry = /* @__PURE__ */ V("div")({
  name: "TopShadow",
  class: "t1hq58md",
  propsAsIs: !1
}), Ey = /* @__PURE__ */ V("div")({
  name: "BottomShadow",
  class: "b1c8nxcx",
  propsAsIs: !1
}), yy = /* @__PURE__ */ V("div")({
  name: "SponsorLogo",
  class: "siozuc3",
  propsAsIs: !1
}), $2 = /* @__PURE__ */ V("div")({
  name: "Content",
  class: "cpnc44r",
  propsAsIs: !1
}), Cy = /* @__PURE__ */ V("div")({
  name: "Title",
  class: "tq7p3w0",
  propsAsIs: !1
}), Wy = /* @__PURE__ */ V("div")({
  name: "OptionsWrap",
  class: "o1jlfj9g",
  propsAsIs: !1
}), q2 = /* @__PURE__ */ V("div")({
  name: "Options",
  class: "o84pmnd",
  propsAsIs: !1
}), Sy = () => Ra, Dh = /* @__PURE__ */ V(Sy())({
  name: "AlertContainer",
  class: "a1dybjw9",
  propsAsIs: !0
}), Zy = /* @__PURE__ */ V("div")({
  name: "EarlyPrediction",
  class: "e1l05ict",
  propsAsIs: !1
}), vy = () => oe, Iy = /* @__PURE__ */ V(vy())({
  name: "EarlyPredictionIcon",
  class: "ez9juex",
  propsAsIs: !0
}), Ny = () => oe, Fy = /* @__PURE__ */ V(Ny())({
  name: "SponsorIcon",
  class: "s8p4aob",
  propsAsIs: !0
}), Ea = ({ value: t = 0, decimals: e, duration: n = 1, preserveValue: i = !0, ...s }) => {
  const [, r] = t.toString().split("."), o = e ?? (r?.length || 0);
  return /* @__PURE__ */ f(
    L3,
    {
      end: t,
      ...s,
      duration: n,
      decimals: o,
      enableScrollSpy: !1,
      preserveValue: i
    }
  );
}, Gy = /* @__PURE__ */ V("button")({
  name: "ButtonContainer",
  class: "b1b6dl8t",
  propsAsIs: !1
}), Xy = /* @__PURE__ */ V("div")({
  name: "ButtonPctWrap",
  class: "b4iik8i",
  propsAsIs: !1
}), Uy = /* @__PURE__ */ V("div")({
  name: "ButtonPct",
  class: "b1gq1lnf",
  propsAsIs: !1
}), By = /* @__PURE__ */ V("span")({
  name: "ButtonBody",
  class: "b1j65z51",
  propsAsIs: !1
}), wy = /* @__PURE__ */ V("div")({
  name: "IconContainer",
  class: "i19tpfua",
  propsAsIs: !1
}), Yy = /* @__PURE__ */ V("div")({
  name: "IconWrap",
  class: "i1tubmma",
  propsAsIs: !1
}), e3 = /* @__PURE__ */ V("img")({
  name: "Icon",
  class: "i1grrgwj",
  propsAsIs: !1
}), Ty = () => e3, Ly = /* @__PURE__ */ V(Ty())({
  name: "IconDefault",
  class: "ibemyq8",
  propsAsIs: !0
}), ky = () => e3, Jy = /* @__PURE__ */ V(ky())({
  name: "IconCircle",
  class: "i1dceht",
  propsAsIs: !0
}), xy = /* @__PURE__ */ V("span")({
  name: "Title",
  class: "t116q4vq",
  propsAsIs: !1
}), My = /* @__PURE__ */ V("span")({
  name: "Indicators",
  class: "i17ajcu2",
  propsAsIs: !1
}), Qy = /* @__PURE__ */ V("div")({
  name: "PtsWrap",
  class: "pu9kmlb",
  propsAsIs: !1
}), zy = /* @__PURE__ */ V("span")({
  name: "Pts",
  class: "p1j2j0s0",
  propsAsIs: !1
}), Ky = /* @__PURE__ */ V("span")({
  name: "Percentage",
  class: "p1mzj1sj",
  propsAsIs: !1
}), Hy = () => oe, Oy = /* @__PURE__ */ V(Hy())({
  name: "CheckIcon",
  class: "cichgz8",
  propsAsIs: !0
}), Dy = {
  [xe.CENTERED]: (t) => /* @__PURE__ */ f(Ly, { "data-testid": "vote-icon", alt: "option-icon", src: t }),
  [xe.TRANSPARENT]: (t) => /* @__PURE__ */ f(wy, { "data-testid": "vote-icon", children: /* @__PURE__ */ f(Yy, { style: { backgroundImage: `url(${t})` } }) }),
  [xe.ROUNDED]: (t) => /* @__PURE__ */ f(Jy, { "data-testid": "vote-icon", alt: "option-icon", src: t }),
  [xe.NONE]: () => null,
  [xe.UNSET]: () => null
}, Py = ({ questionType: t, hasCorrectAnswer: e, correct: n, youVoted: i, questionVoted: s }) => {
  if (t === M.POLL && i)
    return "voted";
  if (t === M.PREDICTION) {
    if (!e && s)
      return i ? "voted" : "unset";
    if (e && s)
      return i ? n ? "correct" : "incorrect" : "unset";
    if (i)
      return "correct";
  }
  return t === M.TRIVIA && s && i ? n ? "correct" : "incorrect" : "unset";
}, _y = ({
  questionType: t,
  questionVoted: e,
  correct: n,
  hasCorrectAnswer: i,
  questionStatus: s
}) => t === M.TRIVIA ? e && n : t === M.PREDICTION ? e && n && i || s === ve.RESOLVED && n : !1, jy = ht(Gy), $y = (t) => {
  const {
    // option props
    id: e,
    icon: n,
    text: i,
    percentageDecimal: s,
    points: r,
    // extra props
    onVote: o,
    markThatVoted: l,
    firstOption: a,
    onPercentsAnimated: c,
    youSelected: u,
    youVoted: h,
    questionVoted: d,
    imageMode: m,
    answerTimeExpired: p,
    questionStatus: g,
    isLoading: A,
    questionType: b,
    correct: R,
    hasCorrectAnswer: S,
    marketClosed: E,
    isEarlyPrediction: Z,
    isAd: G,
    webos: T
  } = t, [C, N] = re(0), Y = Py(t), L = _y({ questionType: b, questionVoted: d, correct: R, hasCorrectAnswer: S, questionStatus: g }), w = E && b === M.PREDICTION, D = d || w, ie = b === M.PREDICTION && !d && !E && !G, X = d && !u && Y !== "incorrect" && !h;
  return X3(() => {
    N(0), requestAnimationFrame(() => {
      N(s);
    });
  }, [s]), /* @__PURE__ */ U(
    jy,
    {
      value: e,
      webos: T,
      autoFocus: a,
      "data-selected": u,
      "data-answer-state": Y,
      disabled: d || A || p || w,
      "data-is-not-checked": X,
      "data-a": "intr",
      onClick: (Q) => {
        l(
          b === M.PREDICTION ? E : g === ve.RESOLVED
        ), o(Q);
      },
      "data-is-ad": G,
      children: [
        /* @__PURE__ */ f(Xy, { children: /* @__PURE__ */ f(
          Uy,
          {
            "data-answer-state": Y,
            "data-is-not-checked": X,
            style: { width: `${D ? C : 0}%` },
            onTransitionEnd: () => {
              w || c?.();
            },
            "data-is-ad": G
          }
        ) }),
        /* @__PURE__ */ U(By, { "data-a": "intr", children: [
          n && m && Dy[m]?.(n),
          /* @__PURE__ */ f(xy, { "data-a": "intr", children: i }),
          ie && /* @__PURE__ */ U(Qy, { children: [
            r,
            /* @__PURE__ */ f(zy, { children: "pts" })
          ] }),
          D && /* @__PURE__ */ U(My, { children: [
            L && /* @__PURE__ */ f(Oy, { name: Z ? "selectedBetPack" : "selected" }),
            /* @__PURE__ */ f(Ky, { children: /* @__PURE__ */ f(Ea, { value: s, suffix: "%" }) })
          ] })
        ] })
      ]
    }
  );
}, qy = () => _2, eC = /* @__PURE__ */ V(qy())({
  name: "ShowInContainer",
  class: "sie6cqo",
  propsAsIs: !0
}), tC = /* @__PURE__ */ V("div")({
  name: "WinBarContainer",
  class: "wgizw4u",
  propsAsIs: !1
}), nC = /* @__PURE__ */ V("div")({
  name: "Content",
  class: "c1l3ucjp",
  propsAsIs: !1
}), iC = /* @__PURE__ */ V("div")({
  name: "Title",
  class: "tx7j799",
  propsAsIs: !1
}), sC = () => oe, rC = /* @__PURE__ */ V(sC())({
  name: "WinIcon",
  class: "w4lwuj0",
  propsAsIs: !0
}), oC = /* @__PURE__ */ V("div")({
  name: "Points",
  class: "po9i64o",
  propsAsIs: !1
}), lC = /* @__PURE__ */ V("span")({
  name: "PointsCount",
  class: "pe5g05h",
  propsAsIs: !1
}), aC = /* @__PURE__ */ V("span")({
  name: "PointsUnits",
  class: "p1hdtpmb",
  propsAsIs: !1
}), cC = ({
  title: t,
  points: e,
  isPlayingTimer: n,
  isTimer: i,
  animatePoints: s,
  questionType: r,
  timerDuration: o,
  votedInCurrentRender: l,
  percentsAnimated: a,
  onTimerExpired: c
}) => /* @__PURE__ */ f(
  eC,
  {
    enabled: r === M.PREDICTION && l,
    animate: a,
    children: /* @__PURE__ */ U(
      tC,
      {
        style: {
          justifyContent: r === M.PREDICTION ? "center" : "space-between"
        },
        children: [
          /* @__PURE__ */ U(nC, { children: [
            t && /* @__PURE__ */ f(iC, { children: t }),
            e !== void 0 && r !== M.POLL && /* @__PURE__ */ U(at, { children: [
              /* @__PURE__ */ f(rC, { name: "icon-trophy" }),
              /* @__PURE__ */ U(oC, { children: [
                /* @__PURE__ */ f(lC, { children: s ? /* @__PURE__ */ f(Ea, { value: e, delay: 0.3 }) : e }),
                /* @__PURE__ */ f(aC, { children: "PTS" })
              ] })
            ] })
          ] }),
          i && r !== M.PREDICTION && /* @__PURE__ */ f(A7, { isPlaying: n, onTimerExpired: c, duration: o })
        ]
      }
    )
  }
), uC = (t, e) => t === "already_voted" ? e === M.POLL ? "You’ve already answered this question on another device." : "You’ve already answered this question on another device. So the points for this answer won't tally." : "Something went wrong, please try again", hC = () => /* @__PURE__ */ f(j2, { children: /* @__PURE__ */ U($2, { children: [
  /* @__PURE__ */ f(Qo, { loading: !0, style: { height: "40px", borderRadius: "100px" } }),
  /* @__PURE__ */ f(Qo, { loading: !0, style: { height: "24px", margin: "16px 0" } }),
  /* @__PURE__ */ f(q2, { children: Array.from({ length: 5 }).map((t, e) => /* @__PURE__ */ f(Qo, { loading: !0, style: { height: "44px" } }, e)) })
] }) }), dC = ({
  openedQuestion: t,
  isLoading: e,
  vote: n,
  close: i,
  isEarlyPrediction: s,
  mastersApp: r,
  webos: o
}) => {
  const l = t.subject, a = t.type, c = t.status, u = t.options?.options, h = t.marketClosed, d = t.id, m = Ee(), p = Ee(), g = r ? !1 : t?.adUnit === Ne.STANDART, [A, b] = re(!1), [R, S] = re(!1), [E, Z] = re(!0), [G, T] = re(!1), [C, N] = re(!1), [Y, L] = re(""), [w, D] = re(""), [ie, X] = re(!1), [Q, J] = re(!1), [q, k] = re(!1), { runAnimation: O, finished: ee } = ba();
  te(() => {
    ee && i(d);
  }, [i, ee]), te(() => {
    a === M.PREDICTION ? h && Z(!1) : c === ve.RESOLVED && Z(!1);
  }, []);
  const W = Ue((Ge) => {
    S(Ge), b(!0);
  }, []), v = Ue(() => {
    s && b(!1);
  }, [s]), F = Ee(!1), K = Ue(() => {
    p.current && clearTimeout(p.current), p.current = setTimeout(() => {
      k(!0), O({ delay: 5500 });
    }, 4e3);
  }, [O]), _ = Ue(
    async (Ge) => {
      if (!F.current && (F.current = !0, d)) {
        const Et = Ge.currentTarget.value;
        L(Et);
        try {
          await n(d, Et), g && K();
        } catch (Un) {
          D(uC(Un.message, a)), L(""), console.error("Error while voting", Un), F.current = !1;
        }
      }
    },
    [a, d, L, n, g, K]
  ), $ = Ue(() => {
    T(!0), O({ delay: 3500 });
  }, [O]), j = Ue(() => {
    N(!0), O({ delay: 3500 });
  }, [O]), z = t?.answers.find((Ge) => Ge.youVoted === !0), P = gt(
    () => !!t?.answers.find((Ge) => Ge.correct === !0),
    [t]
  ), ne = gt(
    () => t?.answers.find((Ge) => Ge.correct === !0),
    [t]
  );
  te(() => {
    z && A && !Q && (m.current = setTimeout(j, 1e4), J(!0));
  }, [z]), te(() => () => {
    clearTimeout(m.current), clearTimeout(p.current);
  }, []);
  const le = gt(() => t ? t.answers.map((Ge) => ({
    ...Ge,
    questionVoted: !!z,
    youSelected: Y === Ge.id,
    isLoading: e,
    hasCorrectAnswer: P,
    questionType: t.type,
    answerTimeExpired: G,
    questionStatus: c,
    imageMode: t.appearance?.images,
    onVote: _
  })) : [], [
    P,
    G,
    e,
    t,
    z,
    c,
    _,
    Y
  ]);
  te(() => {
    const Ge = le.some(({ percentageDecimal: Un }) => Un !== 0), Et = z && a === M.PREDICTION;
    w && (s || !Ge || h && Et) && X(!0);
  }, [le, w, s, h, a, z]);
  const Ce = u && (u.case === "trivia" || u.case === "prediction") ? u.value : void 0, ue = c === ve.RESOLVED && a === M.TRIVIA && !z && !E, ye = a === M.TRIVIA && R, Qe = gt(() => g ? !1 : a === M.PREDICTION ? s ? !1 : !!(z && !P || z && P && ne?.youVoted) : !0, [a, z, P, ne, s, g]), qe = gt(() => {
    if (a === M.PREDICTION && z && (!P || P && ne?.youVoted))
      return z.points;
    if (!(ue || G))
      return z ? z.correct ? z.pointsEarned : 0 : ne?.points;
  }, [G, z, ne, ue, a, P]), dt = gt(() => a === M.PREDICTION && z ? P ? P && ne?.youVoted ? "You won" : "" : "To win" : ue || G ? "Time expired" : a === M.POLL ? "Time remaining" : z ? "You won" : "To win", [G, a, z, ue, P, ne]), x = !Qe || Qe && a === M.PREDICTION && A && !ie, rt = (a === M.TRIVIA || a === M.PREDICTION) && z && P && ne?.youVoted, Xn = z || ue || ye || a === M.TRIVIA && c === ve.RESOLVED && E, F3 = !s && (G || C) || q, G3 = () => {
    const Ge = () => a === M.TRIVIA ? z?.correct ? `That's correct!
You chose wisely.` : `So close!
Better luck next time.` : a === M.POLL ? `Thanks for answering.
Please stay tuned for the next question.` : a === M.PREDICTION ? "Stay tuned to see if your prediction was correct." : "", Et = () => a === M.TRIVIA ? `Your Pick: ${ne?.text}` : a === M.POLL || a === M.PREDICTION ? `Your Pick: ${z?.text}` : "", Un = () => a === M.TRIVIA && u?.case === "trivia" ? u?.value.explanation : a === M.PREDICTION ? l : "";
    return q ? /* @__PURE__ */ f(Dh, { children: /* @__PURE__ */ f(
      fy,
      {
        title: Ge(),
        description: Et(),
        ...z?.correct || a === M.POLL || a === M.PREDICTION ? { icon: "icon-correct" } : {},
        ...a === M.TRIVIA || a === M.PREDICTION ? { additionalDescription: Un() } : {}
      }
    ) }) : !s && (G || C) ? /* @__PURE__ */ f(Dh, { children: /* @__PURE__ */ f(
      K7,
      {
        icon: "icon-check-circle",
        title: "More to come...",
        description: C ? /* @__PURE__ */ U(at, { children: [
          "Stay tuned for more questions ",
          /* @__PURE__ */ f("br", {}),
          " and insights."
        ] }) : /* @__PURE__ */ U(at, { children: [
          "Watch for additional enhanced stream ",
          /* @__PURE__ */ f("br", {}),
          " interactive experience."
        ] })
      }
    ) }) : null;
  };
  return /* @__PURE__ */ U(Vy, { children: [
    s && /* @__PURE__ */ f(Ry, {}),
    /* @__PURE__ */ f(j2, { style: s ? { marginTop: "-40px" } : {}, children: /* @__PURE__ */ U($2, { children: [
      !s && !g && /* @__PURE__ */ f(
        Oh,
        {
          feedbackMessages: Ce,
          questionVoted: !!z,
          questionVotedCorrectly: z?.correct,
          questionType: a,
          hasCorrectAnswer: P,
          showExpiredNotification: ue,
          showClosedNotificationTrivia: ye,
          votedInCurrentRender: A,
          votedAfterQuestionClosed: R,
          enteredAnActiveQuestion: E,
          marketClosed: h,
          percentsAnimated: ie,
          voteErrorMessage: w,
          votedAnswer: z
        }
      ),
      Qe && /* @__PURE__ */ f(
        cC,
        {
          title: dt,
          points: qe,
          onTimerExpired: $,
          questionType: t.type,
          isTimer: !e,
          isPlayingTimer: !z,
          animatePoints: rt,
          timerDuration: Xn ? 0 : Number(t?.appearance?.autoHideInterval || "30"),
          votedInCurrentRender: A,
          percentsAnimated: ie
        }
      ),
      F3 ? G3() : /* @__PURE__ */ U(at, { children: [
        s && /* @__PURE__ */ U(Zy, { children: [
          /* @__PURE__ */ f(Iy, { name: "iconEarlyPrediction" }),
          "EARLY PREDICTION"
        ] }),
        /* @__PURE__ */ f(Cy, { style: x ? { marginTop: 0 } : {}, children: l }),
        s && /* @__PURE__ */ f(
          Oh,
          {
            feedbackMessages: Ce,
            questionVoted: !!z,
            questionVotedCorrectly: z?.correct,
            questionType: a,
            hasCorrectAnswer: P,
            showExpiredNotification: ue,
            showClosedNotificationTrivia: ye,
            votedInCurrentRender: A,
            votedAfterQuestionClosed: R,
            enteredAnActiveQuestion: E,
            marketClosed: h,
            percentsAnimated: ie,
            voteErrorMessage: w,
            isEarlyPrediction: s,
            correctAnswer: ne,
            votedAnswer: z,
            onAnimationEnd: v
          }
        ),
        /* @__PURE__ */ U(Wy, { children: [
          /* @__PURE__ */ f(q2, { children: le.sort((Ge, Et) => Ge.id > Et.id ? 1 : -1).map((Ge, Et) => /* @__PURE__ */ f(
            $y,
            {
              ...Ge,
              firstOption: Et === 0,
              markThatVoted: W,
              onPercentsAnimated: () => X(!0),
              votedAfterQuestionClosed: R,
              enteredAnActiveQuestion: E,
              marketClosed: h,
              isEarlyPrediction: s,
              isAd: g,
              webos: o
            },
            Ge.id
          )) }),
          s && /* @__PURE__ */ U(at, { children: [
            /* @__PURE__ */ f(Ey, {}),
            /* @__PURE__ */ f(yy, { children: /* @__PURE__ */ f(Fy, { name: "mastersLogoWhite" }) })
          ] })
        ] })
      ] })
    ] }) })
  ] });
}, mC = /* @__PURE__ */ V("div")({
  name: "Container",
  class: "cq8qxhy",
  propsAsIs: !1
}), pC = /* @__PURE__ */ V("div")({
  name: "VideoWrapper",
  class: "v18kj6dc",
  propsAsIs: !1
}), gC = () => Hi, fC = /* @__PURE__ */ V(gC())({
  name: "FocusableVideo",
  class: "fv2nwib",
  propsAsIs: !0
}), Ph = /* @__PURE__ */ V("div")({
  name: "VideoStatus",
  class: "v8ptucg",
  propsAsIs: !1
}), _h = "caip8y5", bC = /* @__PURE__ */ V("div")({
  name: "Content",
  class: "ccgc65e",
  propsAsIs: !1
}), AC = /* @__PURE__ */ V("h3")({
  name: "Title",
  class: "t1q3iml2",
  propsAsIs: !1
}), VC = /* @__PURE__ */ V("div")({
  name: "Description",
  class: "d1y2pxs8",
  propsAsIs: !1
}), RC = /* @__PURE__ */ V("img")({
  name: "Image",
  class: "ig2j4fc",
  propsAsIs: !1
}), EC = /* @__PURE__ */ V("div")({
  name: "ImageContainer",
  class: "i3dd6iy",
  propsAsIs: !1
}), yC = ({
  instantView: t,
  isDetail: e,
  notification: n,
  controlVideo: i,
  muted: s,
  questionId: r,
  fireEvent: o,
  isEventFired: l
}) => {
  const a = Ee(null), [c, u] = re(!1), [h, d] = re(void 0), m = t?.playVideoMuted === m0.ENABLED, p = e && t?.autoPlayVideo === Bs.ENABLED, g = m && p, A = t?.heading, b = t?.body, R = A || b, [S, E] = re(!0), Z = n?.title, G = n?.body;
  return /* @__PURE__ */ U(mC, { children: [
    t?.video?.url && /* @__PURE__ */ U(pC, { children: [
      /* @__PURE__ */ f(
        fC,
        {
          className: _h,
          source: t.video.url,
          poster: t.video.thumbnailUrl,
          controlVideo: i,
          muted: s,
          autoPlay: e && t.autoPlayVideo === Bs.ENABLED,
          ref: a,
          onRender: () => {
            l?.("video-rendered") || (be.emit("advertisement", {
              action: "videoRendered",
              payload: {
                id: r
              }
            }), o?.("video-rendered"));
          },
          onQuartile: (T) => {
            l?.(`video-quartile-${T}`) || (be.emit("advertisement", {
              action: "quartileCompleted",
              payload: {
                id: r,
                quartile: T
              }
            }), o?.(`video-quartile-${T}`));
          },
          onMuteClick: (T) => {
            const C = T ? "muted" : "unmuted";
            l?.(C) || (be.emit("advertisement", {
              action: T ? "videoMuted" : "videoUnmuted",
              payload: {
                id: r
              }
            }), o?.(C));
          },
          onPause: () => {
            u?.(!0), E(!1);
          },
          onMute: (T) => {
            d(T);
          },
          onReplay: () => {
            l?.("replayed") || (be.emit("advertisement", {
              action: "videoReplayed",
              payload: {
                id: r
              }
            }), o?.("replayed"));
          },
          onPlay: () => {
            l?.("played") || (be.emit("advertisement", {
              action: "videoPlay",
              payload: {
                id: r
              }
            }), o?.("played")), u?.(!1), l?.("played") && l?.("ended") && !l?.("replayed") && (be.emit("advertisement", {
              action: "videoReplayed",
              payload: {
                id: r
              }
            }), o?.("replayed"));
          },
          onEnd: () => {
            l?.("ended") || (be.emit("advertisement", {
              action: "videoEnd",
              payload: {
                id: r
              }
            }), o?.("ended"));
          },
          playMuted: m,
          hasNotPausedVideo: S,
          webos: !0
        }
      ),
      c && !S && /* @__PURE__ */ U(Ph, { children: [
        /* @__PURE__ */ f(oe, { name: "icon-pause" }),
        "PAUSED"
      ] }),
      h && g && /* @__PURE__ */ U(Ph, { children: [
        /* @__PURE__ */ f(oe, { name: "iconMute" }),
        "MUTED"
      ] })
    ] }),
    t?.image && !t?.video?.url && /* @__PURE__ */ f(
      EC,
      {
        className: _h,
        "data-rounded": t.imageMode === xe.ROUNDED,
        children: /* @__PURE__ */ f(RC, { src: t?.image })
      }
    ),
    /* @__PURE__ */ U(bC, { children: [
      /* @__PURE__ */ f(AC, { children: e && R ? A : Z }),
      /* @__PURE__ */ f(VC, { children: e && R ? b : G })
    ] })
  ] });
}, CC = /* @__PURE__ */ V("div")({
  name: "Container",
  class: "cgn5uen",
  propsAsIs: !1
}), jh = "c1px8nt6", WC = /* @__PURE__ */ V("div")({
  name: "Content",
  class: "c5et2jt",
  propsAsIs: !1
}), SC = /* @__PURE__ */ V("h3")({
  name: "Title",
  class: "t1i2kpk2",
  propsAsIs: !1
}), ZC = /* @__PURE__ */ V("div")({
  name: "Description",
  class: "dd3lh3p",
  propsAsIs: !1
}), vC = /* @__PURE__ */ V("img")({
  name: "Image",
  class: "i1gfjeu5",
  propsAsIs: !1
}), IC = /* @__PURE__ */ V("div")({
  name: "ImageContainer",
  class: "i58y999",
  propsAsIs: !1
}), NC = ({
  instantView: t,
  isDetail: e,
  notification: n,
  controlVideo: i,
  muted: s,
  questionId: r,
  fireEvent: o,
  isEventFired: l
}) => {
  const a = t?.heading, c = t?.body, u = a || c, h = n?.title, d = n?.body;
  return /* @__PURE__ */ U(CC, { children: [
    t?.video?.url && /* @__PURE__ */ f(
      Hi,
      {
        className: jh,
        source: t.video.url,
        poster: t.video.thumbnailUrl,
        controlVideo: i,
        muted: s,
        autoPlay: e && t.autoPlayVideo === Bs.ENABLED,
        onRender: () => {
          l?.("video-rendered") || (be.emit("advertisement", {
            action: "videoRendered",
            payload: {
              id: r
            }
          }), o?.("video-rendered"));
        },
        onQuartile: (m) => {
          l?.(`video-quartile-${m}`) || (be.emit("advertisement", {
            action: "quartileCompleted",
            payload: {
              id: r,
              quartile: m
            }
          }), o?.(`video-quartile-${m}`));
        },
        onMuteClick: (m) => {
          const p = m ? "muted" : "unmuted";
          l?.(p) || (be.emit("advertisement", {
            action: m ? "videoMuted" : "videoUnmuted",
            payload: {
              id: r
            }
          }), o?.(p));
        },
        onReplay: () => {
          l?.("replayed") || (be.emit("advertisement", {
            action: "videoReplayed",
            payload: {
              id: r
            }
          }), o?.("replayed"));
        },
        onPlay: () => {
          l?.("played") || (be.emit("advertisement", {
            action: "videoPlay",
            payload: {
              id: r
            }
          }), o?.("played")), l?.("played") && l?.("ended") && !l?.("replayed") && (be.emit("advertisement", {
            action: "videoReplayed",
            payload: {
              id: r
            }
          }), o?.("replayed"));
        },
        onEnd: () => {
          l?.("ended") || (be.emit("advertisement", {
            action: "videoEnd",
            payload: {
              id: r
            }
          }), o?.("ended"));
        }
      }
    ),
    t?.image && !t?.video?.url && /* @__PURE__ */ f(
      IC,
      {
        className: jh,
        "data-rounded": t.imageMode === xe.ROUNDED,
        children: /* @__PURE__ */ f(vC, { src: t?.image })
      }
    ),
    /* @__PURE__ */ U(WC, { children: [
      /* @__PURE__ */ f(SC, { children: e && u ? a : h }),
      /* @__PURE__ */ f(ZC, { children: e && u ? c : d })
    ] })
  ] });
}, FC = /* @__PURE__ */ V("div")({
  name: "Container",
  class: "c1euiow",
  propsAsIs: !1
}), GC = /* @__PURE__ */ V("a")({
  name: "WebLinkBtn",
  class: "w19zie3h",
  propsAsIs: !1
}), XC = () => oe, UC = /* @__PURE__ */ V(XC())({
  name: "WebLinkIcon",
  class: "wyg5v7z",
  propsAsIs: !0
}), BC = ({ instantView: t, ...e }) => /* @__PURE__ */ U(FC, { children: [
  e.webos ? /* @__PURE__ */ f(yC, { instantView: t, ...e, isDetail: !0 }) : /* @__PURE__ */ f(NC, { instantView: t, ...e, isDetail: !0 }),
  t?.webLink && /* @__PURE__ */ U(GC, { href: t?.webLink.url, target: "_blank", "data-a": "web-link", children: [
    t?.webLink.label,
    /* @__PURE__ */ f(UC, { name: "icon-external-link" })
  ] })
] }), wC = (t) => {
  const e = new Date(t);
  if (!e)
    return "";
  const n = /* @__PURE__ */ new Date(), i = Math.floor(n.getTime() - e.getTime());
  return i < 6e4 ? `${Math.floor(i / 1e3)}s` : i < 36e5 ? `${Math.floor(i / 6e4)}m` : i < 864e5 ? `${Math.floor(i / 36e5)}h` : e.getFullYear() === n.getFullYear() ? `${e.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric"
  })}` : `${e.toLocaleDateString("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "2-digit"
  })}`;
}, YC = /* @__PURE__ */ V("div")({
  name: "Container",
  class: "cjq447q",
  propsAsIs: !1
}), TC = /* @__PURE__ */ V("div")({
  name: "ImageContainer",
  class: "i14egogb",
  propsAsIs: !1
}), LC = /* @__PURE__ */ V("img")({
  name: "Image",
  class: "i2g9g4l",
  propsAsIs: !1
}), kC = () => oe, JC = /* @__PURE__ */ V(kC())({
  name: "TwitterIcon",
  class: "t1c454nm",
  propsAsIs: !0
}), xC = /* @__PURE__ */ V("div")({
  name: "Details",
  class: "d11nigc3",
  propsAsIs: !1
}), MC = /* @__PURE__ */ V("div")({
  name: "Name",
  class: "nrxa4k8",
  propsAsIs: !1
}), QC = /* @__PURE__ */ V("div")({
  name: "UserNameAndDate",
  class: "u1p051g3",
  propsAsIs: !1
}), zC = ({ image: t, name: e, userName: n, verified: i, createdTweet: s }) => {
  const r = s && wC(s);
  return /* @__PURE__ */ U(YC, { children: [
    t && /* @__PURE__ */ U(TC, { children: [
      /* @__PURE__ */ f(LC, { className: "SL_AccountImage", src: t }),
      /* @__PURE__ */ f(JC, { name: "twitter" })
    ] }),
    /* @__PURE__ */ U(xC, { children: [
      e && /* @__PURE__ */ U(MC, { className: "SL_TweetAccountName", children: [
        e,
        " ",
        i && /* @__PURE__ */ f(oe, { name: "icon-twitter-verified" })
      ] }),
      n && /* @__PURE__ */ U(QC, { className: "SL_TweetAccountUserName", children: [
        "@",
        n,
        " ",
        r && `･ ${r}`
      ] })
    ] })
  ] });
}, KC = /* @__PURE__ */ V("div")({
  name: "Container",
  class: "c1kzqw87",
  propsAsIs: !1
}), HC = /* @__PURE__ */ V("div")({
  name: "Details",
  class: "d9r1hf9",
  propsAsIs: !1
}), OC = /* @__PURE__ */ V("div")({
  name: "Body",
  class: "bezygt5",
  propsAsIs: !1
}), Ri = /* @__PURE__ */ V("div")({
  name: "ImagesContainer",
  class: "i1y8f7ym",
  propsAsIs: !1
}), Ko = /* @__PURE__ */ V("div")({
  name: "ImagesBlock",
  class: "i18gwonx",
  propsAsIs: !1
}), t3 = /* @__PURE__ */ V("img")({
  name: "Image",
  class: "i3g0xjd",
  propsAsIs: !1
}), DC = () => t3, nn = /* @__PURE__ */ V(DC())({
  name: "ImageFullSize",
  class: "io8rt7p",
  propsAsIs: !0
}), PC = () => t3, Ho = /* @__PURE__ */ V(PC())({
  name: "ImageHalfSize",
  class: "i4hn3ox",
  propsAsIs: !0
}), _C = new RegExp("\\s?https?://t.co[^\\s]+(\\s+)?$"), jC = (t) => t?.replace(_C, ""), $C = U3(
  ({ image: t, body: e, muted: n, account: i, accountVerified: s, tweet: r, isDetail: o, controlVideo: l }) => {
    const a = r?.meta?.extendedEntities?.media, c = a?.find(
      ({ type: h }) => h === "photo"
      /* PHOTO */
    ), u = gt(() => a?.[0]?.videoInfo?.variants?.findLast(
      ({ contentType: h }) => h === "video/mp4"
      /* VIDEO */
    )?.url, [a]);
    return /* @__PURE__ */ U(KC, { children: [
      /* @__PURE__ */ U(HC, { children: [
        /* @__PURE__ */ f(
          zC,
          {
            image: t,
            name: r?.meta?.accountName,
            userName: i,
            verified: s,
            createdTweet: r?.date
          }
        ),
        /* @__PURE__ */ f(OC, { children: jC(e) }),
        !o && c && /* @__PURE__ */ f(Ri, { children: /* @__PURE__ */ f(nn, { src: a?.[0].mediaUrlHttps }) }),
        o && c && /* @__PURE__ */ U(at, { children: [
          a?.length === 1 && /* @__PURE__ */ f(Ri, { children: /* @__PURE__ */ f(nn, { src: a[0].mediaUrlHttps }) }),
          a?.length === 2 && /* @__PURE__ */ U(Ri, { children: [
            /* @__PURE__ */ f(Ho, { src: a[0].mediaUrlHttps }),
            /* @__PURE__ */ f(Ho, { src: a[1].mediaUrlHttps })
          ] }),
          a?.length === 3 && /* @__PURE__ */ U(Ri, { children: [
            /* @__PURE__ */ f(Ho, { src: a[0].mediaUrlHttps }),
            /* @__PURE__ */ U(Ko, { children: [
              /* @__PURE__ */ f(nn, { src: a[1].mediaUrlHttps }),
              /* @__PURE__ */ f(nn, { src: a[2].mediaUrlHttps })
            ] })
          ] }),
          a?.length === 4 && /* @__PURE__ */ U(Ri, { children: [
            /* @__PURE__ */ U(Ko, { children: [
              /* @__PURE__ */ f(nn, { src: a[0].mediaUrlHttps }),
              /* @__PURE__ */ f(nn, { src: a[1].mediaUrlHttps })
            ] }),
            /* @__PURE__ */ U(Ko, { children: [
              /* @__PURE__ */ f(nn, { src: a[2].mediaUrlHttps }),
              /* @__PURE__ */ f(nn, { src: a[3].mediaUrlHttps })
            ] })
          ] })
        ] })
      ] }),
      !c && (a?.[0]?.type === "video" || a?.[0]?.type === "animated_gif") && u && /* @__PURE__ */ f(
        Hi,
        {
          muted: n,
          source: u,
          poster: a[0].mediaUrlHttps,
          controlVideo: l
        }
      )
    ] });
  }
), qC = /* @__PURE__ */ V("div")({
  name: "Container",
  class: "c1dcxmvf",
  propsAsIs: !1
}), eW = /* @__PURE__ */ V("blockquote")({
  name: "Quote",
  class: "qb4q22c",
  propsAsIs: !1
}), tW = (t) => /* @__PURE__ */ U(qC, { children: [
  t.title && /* @__PURE__ */ f(eW, { children: t.title }),
  /* @__PURE__ */ f($C, { ...t, isDetail: !0 })
] }), nW = /* @__PURE__ */ V("div")({
  name: "QuestionAdvertisementContainer",
  class: "qwludgs",
  propsAsIs: !1
}), iW = /* @__PURE__ */ V("div")({
  name: "QuestionAdvertisementText",
  class: "qvce6pv",
  propsAsIs: !1
}), sW = /* @__PURE__ */ V("div")({
  name: "QuestionAdvertisementImage",
  class: "qsid7hx",
  propsAsIs: !1
}), rW = ({
  sponsorLogo: t,
  id: e,
  setAdShowed: n
}) => {
  const i = Ee();
  return te(() => (i.current = setTimeout(() => {
    n(!0);
  }, 5e3), () => {
    clearTimeout(i.current);
  }), [n, e]), /* @__PURE__ */ U(nW, {
    children: [/* @__PURE__ */ f(iW, {
      children: "PRESENTED BY"
    }), /* @__PURE__ */ f(sW, {
      children: /* @__PURE__ */ f("img", {
        src: t,
        alt: "ad-sponsor-logo"
      })
    })]
  });
}, $h = /* @__PURE__ */ V("div")({
  name: "QuestionContainer",
  class: "q14ckf9e",
  propsAsIs: !1
}), oW = ({
  openedQuestion: t,
  muted: e,
  webos: n
}) => {
  const {
    sdk: i
  } = d7();
  return t?.attributes?.attributes.case === "insight" ? /* @__PURE__ */ f(BC, {
    ...t.attributes.attributes.value,
    muted: e,
    controlVideo: i?.controlVideoPlayer,
    webos: n,
    questionId: t.id,
    fireEvent: t.fireEvent,
    isEventFired: t.isEventFired
  }) : t?.attributes?.attributes.case === "tweet" ? /* @__PURE__ */ f(tW, {
    ...t.attributes.attributes.value,
    muted: e,
    controlVideo: i?.controlVideoPlayer
  }) : null;
}, lW = ({
  extendedQuestion: t,
  vote: e,
  close: n,
  webos: i
}) => {
  const {
    loading: s,
    data: r
  } = t;
  return r ? /* @__PURE__ */ f(dC, {
    webos: i,
    vote: e,
    close: n,
    openedQuestion: r,
    isLoading: !!s
  }) : /* @__PURE__ */ f(hC, {});
}, aW = ({
  gamification: t,
  sdk: e,
  muted: n,
  skipAutoClose: i,
  hideSponsor: s,
  className: r,
  hideHeader: o,
  webos: l
}) => {
  const a = He(t.openedQuestion.$store), c = He(t.openedQuestion.$extendedStore), [u, h] = re(!1), d = He(e.options), m = a?.attributes?.type === M.FACTOID, p = a?.attributes?.backgroundImage, g = c.data?.backgroundImage, A = m ? p?.landscapeUrl ?? g?.landscapeUrl : g?.landscapeUrl, b = m ? p?.portraitUrl ?? g?.portraitUrl : g?.portraitUrl, R = Y2({
    containerId: d.containerId,
    landscapeUrl: A,
    portraitUrl: b
  });
  if (!a || !c.data)
    return null;
  const S = a.type, E = c.data?.options?.options.case === "factoid" ? c.data.options.options.value.closeTimer : void 0;
  return c.data && (c.data.adUnit === Ne.STANDART || c.data.promotion?.adUnit === Ne.STANDART) && !u ? /* @__PURE__ */ U($h, {
    className: r,
    children: [R, /* @__PURE__ */ f(rW, {
      id: c.data.id,
      setAdShowed: h,
      sponsorLogo: c.data.promotion?.sponsor?.logo || c.data.sponsorship?.logo || ""
    })]
  }) : /* @__PURE__ */ U($h, {
    className: r,
    children: [R, !o && /* @__PURE__ */ f(U7, {
      closeTimer: i ? void 0 : E,
      close: t.closeQuestion,
      type: a.attributes?.type || M.UNSET,
      webos: l
    }), S === "question" && /* @__PURE__ */ f(lW, {
      webos: l,
      vote: t.submitAnswer,
      close: t.closeQuestion,
      extendedQuestion: c
    }), S !== "question" && /* @__PURE__ */ f(oW, {
      muted: n,
      openedQuestion: a,
      webos: l
    }), !s && /* @__PURE__ */ f(L7, {
      sponsorLogo: c.data?.promotion?.sponsor?.logo || c.data?.sponsorship?.logo
    })]
  });
};
function cW(t) {
  return t instanceof DOMException && // everything except Firefox
  (t.code === 22 || // Firefox
  t.code === 1014 || // test name field too, because code might not be present
  // everything except Firefox
  t.name === "QuotaExceededError" || // Firefox
  t.name === "NS_ERROR_DOM_QUOTA_REACHED");
}
class uW {
  delimiter = ":";
  prefix;
  storage;
  constructor(e = "main", n = window.localStorage) {
    this.prefix = `sl-sdk${this.delimiter}${e}`, this.storage = n;
  }
  clear = () => {
    for (const e in window.localStorage)
      e.startsWith(this.prefix) && this.storage.removeItem(e);
  };
  generateKey = (e) => `${this.prefix}${this.delimiter}${e.join(this.delimiter)}`;
  write = (...e) => {
    const n = e.pop() || "", i = this.generateKey(e);
    try {
      this.storage.setItem(i, n);
    } catch (s) {
      cW(s) && this.storage === window.sessionStorage && (window.sessionStorage.removeItem("slstreamlogs"), this.storage.setItem(i, n));
    }
  };
  read = (...e) => {
    const n = this.storage.getItem(this.generateKey(e));
    return n === null ? void 0 : n;
  };
  remove = (...e) => {
    this.storage.removeItem(this.generateKey(e));
  };
}
var qh;
(function(t) {
  t.OPENED = "opened";
})(qh || (qh = {}));
const hW = /* @__PURE__ */ V("div")({
  name: "QuestionCaption",
  class: "q2sl39u",
  propsAsIs: !1
}), dW = () => oe, Is = /* @__PURE__ */ V(dW())({
  name: "QuestionActionIcon",
  class: "q1fa0b9h",
  propsAsIs: !0
}), mW = () => Is, pW = /* @__PURE__ */ V(mW())({
  name: "QuestionCheckIcon",
  class: "qxlt78s",
  propsAsIs: !0
}), gW = () => oe, fW = /* @__PURE__ */ V(gW())({
  name: "QuestionTypeIcon",
  class: "qmg0vkx",
  propsAsIs: !0
}), bW = /* @__PURE__ */ V("div")({
  name: "QuestionTypeLabel",
  class: "q1uz5j1g",
  propsAsIs: !1
});
on.LOST + "", on.WON + "", on.UNSET + "", on.DNP + "";
const AW = ({ questionTypeData: t, questionType: e, questionStatus: n }) => /* @__PURE__ */ U(hW, { className: "SL_QuestionCaption", children: [
  /* @__PURE__ */ f(
    fW,
    {
      className: "SL_QuestionTypeIcon",
      "data-testid": "question-type-icon",
      "data-type-trivia": e === M.TRIVIA,
      "data-type-poll": e === M.POLL,
      name: t.iconName
    }
  ),
  /* @__PURE__ */ U(bW, { className: "SL_QuestionTypeLabel", children: [
    t.label,
    e === M.TRIVIA && n === ve.RESOLVED && " • Expired"
  ] })
] }), VW = () => ({
  color: t
}) => t || "transparent", ed = /* @__PURE__ */ V("div")({
  name: "MediaComponentWrap",
  class: "mek728j",
  propsAsIs: !1,
  vars: {
    "mek728j-0": [VW()]
  }
}), Gn = /* @__PURE__ */ V("div")({
  name: "Media",
  class: "m461t56",
  propsAsIs: !1
}), RW = () => Gn, EW = /* @__PURE__ */ V(RW())({
  name: "MediaImgBottom",
  class: "m22bh04",
  propsAsIs: !0
}), yW = () => Gn, CW = /* @__PURE__ */ V(yW())({
  name: "MediaVideo",
  class: "m17u1e34",
  propsAsIs: !0
}), WW = () => Gn, SW = /* @__PURE__ */ V(WW())({
  name: "MediaImgContentMedia",
  class: "m4j3eds",
  propsAsIs: !0
}), ZW = () => Gn, vW = /* @__PURE__ */ V(ZW())({
  name: "MediaImgSolid",
  class: "m1lp3swr",
  propsAsIs: !0
}), IW = () => Gn, NW = /* @__PURE__ */ V(IW())({
  name: "MediaImgRounded",
  class: "mc7lij",
  propsAsIs: !0
}), FW = () => Gn, GW = /* @__PURE__ */ V(FW())({
  name: "MediaImgCentered",
  class: "mwwaw7o",
  propsAsIs: !0
}), XW = () => Gn, Sl = /* @__PURE__ */ V(XW())({
  name: "MediaNone",
  class: "mqfzyyr",
  propsAsIs: !0
}), UW = "v170mtgf", BW = {
  [xe.UNSET]: Sl,
  [xe.NONE]: Sl,
  [xe.ROUNDED]: NW,
  [xe.CENTERED]: GW,
  [xe.TRANSPARENT]: EW,
  [xe.SOLID]: vW
}, td = ({
  src: t,
  imageMode: e = xe.UNSET,
  withVideo: n,
  color: i,
  useContentMedia: s,
  thumbnailUrl: r
}) => {
  if (!t)
    return /* @__PURE__ */ f(ed, {
      color: i,
      children: /* @__PURE__ */ f(Sl, {})
    });
  const o = s === rl.ENABLED ? SW : BW[e];
  return /* @__PURE__ */ f(ed, {
    color: i,
    children: n ? /* @__PURE__ */ f(CW, {
      children: /* @__PURE__ */ f(Hi, {
        className: UW,
        source: t,
        poster: r || ""
      })
    }) : /* @__PURE__ */ f(o, {
      children: /* @__PURE__ */ f("img", {
        src: t,
        alt: ""
      })
    })
  });
}, wW = () => ({
  withoutPadding: t
}) => t ? "0px" : "1rem", n3 = /* @__PURE__ */ V("div")({
  name: "NotificationContent",
  class: "n1p3bk1c",
  propsAsIs: !1,
  vars: {
    "n1p3bk1c-0": [wW()]
  }
}), YW = /* @__PURE__ */ V("div")({
  name: "MainContent",
  class: "m1g211mu",
  propsAsIs: !1
}), TW = () => oe, LW = /* @__PURE__ */ V(TW())({
  name: "StyledChevronRight",
  class: "sx1hq4c",
  propsAsIs: !0
}), i3 = /* @__PURE__ */ V("div")({
  name: "NotificationContainer",
  class: "n1fcriet",
  propsAsIs: !1
}), kW = () => ({
  questionType: t
}) => t === M.FACTOID ? "7.3rem" : "4.5rem", JW = () => ({
  webos: t
}) => t ? "11px 0px 8px 0px" : "11px 0px", xW = () => ({
  imageMode: t,
  webos: e
}) => e ? "330px" : t === xe.SOLID ? "310px" : t === xe.CENTERED || t === xe.ROUNDED || t === xe.TRANSPARENT ? "370px" : "430px", MW = /* @__PURE__ */ V("div")({
  name: "Body",
  class: "b1byyovs",
  propsAsIs: !1,
  vars: {
    "b1byyovs-0": [kW()],
    "b1byyovs-1": [JW()],
    "b1byyovs-2": [xW()]
  }
}), QW = () => ({
  webos: t
}) => t ? "0.85rem" : "1.033rem", zW = () => ({
  webos: t
}) => t ? "0.95rem" : "1.25rem", KW = () => ({
  webos: t
}) => t ? "4.7rem" : "2.25rem", HW = () => ({
  webos: t
}) => t ? "pre-wrap" : "nowrap", OW = /* @__PURE__ */ V("div")({
  name: "Title",
  class: "t1y5k5id",
  propsAsIs: !1,
  vars: {
    "t1y5k5id-0": [QW()],
    "t1y5k5id-1": [zW()],
    "t1y5k5id-2": [KW()],
    "t1y5k5id-3": [HW()]
  }
}), DW = /* @__PURE__ */ V("div")({
  name: "Description",
  class: "dw9eb7l",
  propsAsIs: !1
}), PW = /* @__PURE__ */ V("div")({
  name: "LogoImgContainer",
  class: "ldu8wgy",
  propsAsIs: !1
}), s3 = /* @__PURE__ */ V("img")({
  name: "LogoImg",
  class: "ln4a3eh",
  propsAsIs: !1
}), _W = () => i3, jW = /* @__PURE__ */ V(_W())({
  name: "NotificationInterstitialContainer",
  class: "no2k63v",
  propsAsIs: !0
}), $W = /* @__PURE__ */ V("div")({
  name: "TVButtons",
  class: "th9nn6a",
  propsAsIs: !1
}), r3 = /* @__PURE__ */ V("button")({
  name: "TVButton",
  class: "t1eee77p",
  propsAsIs: !1
}), qW = () => r3, eS = /* @__PURE__ */ V(qW())({
  name: "DismissButton",
  class: "ds000hw",
  propsAsIs: !0
}), tS = () => r3, nS = /* @__PURE__ */ V(tS())({
  name: "AnswerButton",
  class: "a1nz9hoe",
  propsAsIs: !0
}), iS = ({ title: t, questionType: e, questionTypeData: n, description: i, imageMode: s, webos: r }) => /* @__PURE__ */ U(MW, { imageMode: s, questionType: e, webos: r, children: [
  /* @__PURE__ */ f(
    AW,
    {
      questionTypeData: n,
      questionType: e,
      questionStatus: ve.UNSET
    }
  ),
  t && /* @__PURE__ */ f(OW, { webos: r, children: t }),
  i && /* @__PURE__ */ f(DW, { children: i })
] }), sS = ht(jW), rS = ht(eS), oS = ht(nS), lS = ({
  className: t,
  sponsorLogo: e,
  onClick: n,
  webos: i
}) => /* @__PURE__ */ f(
  sS,
  {
    className: t,
    autoFocus: !0,
    webos: i,
    onClick: n,
    "data-webos": i,
    children: /* @__PURE__ */ f(n3, { withoutPadding: !0, children: /* @__PURE__ */ f(s3, { src: e }) })
  }
), aS = ({
  action: t,
  close: e,
  questionType: n,
  inApp: i,
  insight: s,
  color: r,
  webos: o,
  className: l
}) => {
  const [a, c] = re(!1), u = Ee();
  te(() => (i?.sponsorLogo && (c(!0), u.current = setTimeout(() => {
    c(!1);
  }, 5e3)), () => clearTimeout(u.current)), [i?.sponsorLogo]);
  const h = P2[n];
  if (!h || !i || !i.notification)
    return null;
  const { title: d, image: m, imageMode: p, useContentMedia: g } = i.notification, A = n === M.FACTOID ? s?.heading : d, b = n === M.FACTOID ? s?.body : "", R = m, S = n === M.FACTOID && s?.video?.url && i?.isVideo && g === rl.ENABLED, E = g === rl.ENABLED ? S ? s?.video?.url : s?.image : "";
  return i?.sponsorLogo && a ? /* @__PURE__ */ f(
    lS,
    {
      className: l,
      sponsorLogo: i?.sponsorLogo,
      webos: o,
      onClick: () => c(!1)
    }
  ) : /* @__PURE__ */ U(
    i3,
    {
      "data-a": "intr",
      className: Oe("SL_InApp", l),
      onClick: (Z) => {
        o || t?.(Z);
      },
      "data-is-insight": n === M.FACTOID,
      "data-webos": o,
      children: [
        i?.sponsorLogo && /* @__PURE__ */ f(PW, { children: /* @__PURE__ */ f(s3, { src: i?.sponsorLogo }) }),
        /* @__PURE__ */ U(n3, { children: [
          /* @__PURE__ */ U(YW, { children: [
            !E && /* @__PURE__ */ f(td, { src: R, imageMode: p, withVideo: !!S, color: r }),
            E && /* @__PURE__ */ f(
              td,
              {
                src: E,
                imageMode: p,
                withVideo: !!S,
                color: r,
                useContentMedia: g,
                thumbnailUrl: s?.video?.thumbnailUrl
              }
            ),
            /* @__PURE__ */ f(
              iS,
              {
                questionTypeData: h,
                questionType: n,
                title: A,
                description: b,
                imageMode: p,
                webos: o
              }
            )
          ] }),
          !o && /* @__PURE__ */ f(LW, { name: "chevronRight" }),
          o && /* @__PURE__ */ U($W, { children: [
            /* @__PURE__ */ f(
              rS,
              {
                webos: !0,
                "data-close-btn": "true",
                onClick: (Z) => {
                  Z.stopPropagation(), e?.(Z);
                },
                children: "Dismiss"
              }
            ),
            /* @__PURE__ */ f(oS, { webos: !0, autoFocus: !0, onClick: t, children: "Answer" })
          ] })
        ] })
      ]
    }
  );
}, cS = /* @__PURE__ */ V("div")({
  name: "Container",
  class: "cef8huz",
  propsAsIs: !1
}), uS = () => oe, hS = /* @__PURE__ */ V(uS())({
  name: "CheckIcon",
  class: "c1mo15kk",
  propsAsIs: !0
}), dS = () => oe, mS = /* @__PURE__ */ V(dS())({
  name: "PredictionIcon",
  class: "p16zkqnm",
  propsAsIs: !0
}), pS = /* @__PURE__ */ V("div")({
  name: "PredictionIconContainer",
  class: "pjszi7a",
  propsAsIs: !1
}), gS = /* @__PURE__ */ V("div")({
  name: "BodyContainer",
  class: "bftbmo3",
  propsAsIs: !1
}), fS = /* @__PURE__ */ V("div")({
  name: "Body",
  class: "barrbyu",
  propsAsIs: !1
}), bS = /* @__PURE__ */ V("div")({
  name: "Subtitle",
  class: "sz7237i",
  propsAsIs: !1
}), AS = ({
  step: t,
  children: e,
  answer: n,
  state: i = "pending"
}) => {
  const [s, r] = re(0), [o] = re(() => new ResizeObserver((a) => {
    window.requestAnimationFrame(() => {
      r(a?.[0]?.contentRect?.width ?? 0);
    });
  })), l = Ue((a) => {
    a ? o.observe(a) : o.disconnect();
  }, [o]);
  return te(() => () => {
    o.disconnect();
  }, [o]), /* @__PURE__ */ U(cS, {
    children: [/* @__PURE__ */ f(pS, {
      children: /* @__PURE__ */ f(mS, {
        name: "icon-prediction"
      })
    }), /* @__PURE__ */ f(gS, {
      style: {
        minWidth: `${s}px`
      },
      children: /* @__PURE__ */ f(fS, {
        children: e
      }, t)
    }), /* @__PURE__ */ f(bS, {
      ref: l,
      className: i,
      children: /* @__PURE__ */ U("div", {
        children: [/* @__PURE__ */ f(hS, {
          name: "icon-check"
        }), "Your Pick: ", n]
      })
    })]
  });
}, VS = /* @__PURE__ */ V("div")({
  name: "Container",
  class: "ckyzolp",
  propsAsIs: !1
}), ya = /* @__PURE__ */ V("div")({
  name: "Line",
  class: "l16t1zr7",
  propsAsIs: !1
}), RS = () => ya, ES = /* @__PURE__ */ V(RS())({
  name: "Line1",
  class: "le78kvg",
  propsAsIs: !0
}), yS = () => ya, CS = /* @__PURE__ */ V(yS())({
  name: "Line2",
  class: "l1o7966d",
  propsAsIs: !0
}), WS = () => ya, SS = /* @__PURE__ */ V(WS())({
  name: "Line3",
  class: "lu9lyxq",
  propsAsIs: !0
}), ZS = () => /* @__PURE__ */ U(VS, {
  children: [/* @__PURE__ */ f(ES, {
    children: /* @__PURE__ */ f("div", {})
  }), /* @__PURE__ */ f(CS, {
    children: /* @__PURE__ */ f("div", {})
  }), /* @__PURE__ */ f(SS, {
    children: /* @__PURE__ */ f("div", {})
  })]
}), vS = /* @__PURE__ */ V("div")({
  name: "Container",
  class: "c10jy6zf",
  propsAsIs: !1
}), IS = () => oe, NS = /* @__PURE__ */ V(IS())({
  name: "CheckIcon",
  class: "c1c7scay",
  propsAsIs: !0
}), FS = () => /* @__PURE__ */ U(vS, {
  children: [/* @__PURE__ */ f(NS, {
    name: "icon-check"
  }), " Prediction results are in!"]
}), GS = /* @__PURE__ */ V("div")({
  name: "Container",
  class: "cf6k2yy",
  propsAsIs: !1
}), XS = /* @__PURE__ */ V("div")({
  name: "Caption",
  class: "c1c8xjus",
  propsAsIs: !1
}), US = /* @__PURE__ */ V("div")({
  name: "Title",
  class: "t1d1uekn",
  propsAsIs: !1
}), BS = ({
  title: t
}) => /* @__PURE__ */ U(GS, {
  children: [/* @__PURE__ */ f(XS, {
    children: "Results for"
  }), /* @__PURE__ */ f(US, {
    children: t
  })]
}), o3 = /* @__PURE__ */ V("div")({
  name: "Container",
  class: "c181a1as",
  propsAsIs: !1
}), l3 = /* @__PURE__ */ V("div")({
  name: "Title",
  class: "t1cduox6",
  propsAsIs: !1
}), wS = () => oe, a3 = /* @__PURE__ */ V(wS())({
  name: "CorrectIcon",
  class: "c1onrv6j",
  propsAsIs: !0
}), YS = () => a3, TS = /* @__PURE__ */ V(YS())({
  name: "InCorrectIcon",
  class: "i17n9o7e",
  propsAsIs: !0
}), LS = () => /* @__PURE__ */ U(o3, {
  children: [/* @__PURE__ */ U(l3, {
    children: ["Congratulations!", /* @__PURE__ */ f("br", {}), "You answered correctly."]
  }), /* @__PURE__ */ f(a3, {
    name: "icon-check"
  })]
}), kS = ({
  title: t
}) => /* @__PURE__ */ U(o3, {
  children: [/* @__PURE__ */ U(l3, {
    children: ["Better luck next time!", /* @__PURE__ */ f("br", {}), "Correct: ", t]
  }), /* @__PURE__ */ f(TS, {
    name: "icon-cross"
  })]
}), JS = /* @__PURE__ */ V("div")({
  name: "Container",
  class: "cnxgcs2",
  propsAsIs: !1
}), xS = /* @__PURE__ */ V("div")({
  name: "Title",
  class: "t903f8n",
  propsAsIs: !1
}), MS = () => oe, QS = /* @__PURE__ */ V(MS())({
  name: "CheckIcon",
  class: "ceyu3qj",
  propsAsIs: !0
}), zS = ({
  points: t
}) => /* @__PURE__ */ U(JS, {
  children: [/* @__PURE__ */ U(xS, {
    children: ["You won ", /* @__PURE__ */ f(Ea, {
      delay: 0.5,
      prefix: "+",
      suffix: " points",
      value: t
    })]
  }), /* @__PURE__ */ f(QS, {
    name: "icon-trophy-solid"
  })]
}), nd = /* @__PURE__ */ V("div")({
  name: "Container",
  class: "cq3agu2",
  propsAsIs: !1
}), id = /* @__PURE__ */ V("div")({
  name: "Body",
  class: "b16qj0do",
  propsAsIs: !1
}), sd = {
  1: 3e3,
  2: 4e3,
  3: 4e3,
  4: 4e3
}, KS = ({ close: t, action: e, setStep: n, votedAnswer: i, correct: s, correctAnswerTitle: r, questionTitle: o, step: l }) => {
  if (te(() => {
    if (n) {
      const c = setTimeout(() => {
        sd[l + 1] && (s || l < 3) ? n(l + 1) : t?.();
      }, sd[l]);
      return () => {
        c && clearTimeout(c);
      };
    }
    return () => {
    };
  }, [n, l, t, s]), l === 1)
    return /* @__PURE__ */ f(nd, { children: /* @__PURE__ */ f(id, { children: /* @__PURE__ */ f(FS, {}) }) });
  let a = "pending";
  return (l === 3 || l === 4) && (a = s ? "correct" : "incorrect"), /* @__PURE__ */ f(nd, { "data-a": "intr", onClick: () => e?.(), children: /* @__PURE__ */ U(id, { children: [
    l !== 1 && /* @__PURE__ */ f(ZS, {}, l),
    /* @__PURE__ */ U(AS, { state: a, step: l, answer: i?.title || "unknown", children: [
      l === 2 && /* @__PURE__ */ f(BS, { title: o || "unknown" }),
      l === 3 && s && /* @__PURE__ */ f(LS, {}),
      l === 3 && !s && /* @__PURE__ */ f(kS, { title: r || "unknown" }),
      l === 4 && /* @__PURE__ */ f(zS, { points: i?.points || 0 })
    ] })
  ] }) });
}, HS = ({ close: t, action: e, votedAnswer: n, correct: i, correctAnswerTitle: s, questionTitle: r }) => {
  const [o, l] = re(1);
  return /* @__PURE__ */ f(
    KS,
    {
      close: t,
      action: e,
      votedAnswer: n,
      correct: i,
      correctAnswerTitle: s,
      questionTitle: r,
      setStep: l,
      step: o,
      title: ""
    }
  );
}, OS = /* @__PURE__ */ V("div")({
  name: "NotificationContainer",
  class: "n1i4h28u",
  propsAsIs: !1
}), DS = ({ className: t, ...e }) => /* @__PURE__ */ f(OS, { className: t, children: /* @__PURE__ */ f(HS, { ...e }) }), PS = /* @__PURE__ */ V("div")({
  name: "Container",
  class: "cwa9tgs",
  propsAsIs: !1
}), _S = /* @__PURE__ */ V("div")({
  name: "BodyContainer",
  class: "b1xx7swj",
  propsAsIs: !1
}), jS = /* @__PURE__ */ V("div")({
  name: "Body",
  class: "b1a21en",
  propsAsIs: !1
}), $S = ({
  step: t,
  children: e,
  state: n = "pending"
}) => {
  const [i, s] = re(0);
  return te(() => {
    const r = new ResizeObserver((o) => {
      window.requestAnimationFrame(() => {
        const l = o?.[0]?.contentRect?.width ?? 0;
        s(l);
      });
    });
    return () => {
      r.disconnect();
    };
  }, []), /* @__PURE__ */ f(PS, {
    style: {
      padding: `${t === 3 && n === "incorrect" || t === 1 ? "5px 100px" : "5px 40px"}`
    },
    children: /* @__PURE__ */ f(_S, {
      style: {
        minWidth: `${i}px`
      },
      children: /* @__PURE__ */ f(jS, {
        children: e
      }, t)
    })
  });
}, qS = /* @__PURE__ */ V("div")({
  name: "Container",
  class: "c1nd5cu8",
  propsAsIs: !1
}), Ca = /* @__PURE__ */ V("div")({
  name: "Line",
  class: "lgbipw0",
  propsAsIs: !1
}), eZ = () => Ca, tZ = /* @__PURE__ */ V(eZ())({
  name: "Line1",
  class: "l1anth16",
  propsAsIs: !0
}), nZ = () => Ca, iZ = /* @__PURE__ */ V(nZ())({
  name: "Line2",
  class: "l193yd7v",
  propsAsIs: !0
}), sZ = () => Ca, rZ = /* @__PURE__ */ V(sZ())({
  name: "Line3",
  class: "lhbflsp",
  propsAsIs: !0
}), oZ = () => /* @__PURE__ */ U(qS, {
  children: [/* @__PURE__ */ f(tZ, {
    children: /* @__PURE__ */ f("div", {})
  }), /* @__PURE__ */ f(iZ, {
    children: /* @__PURE__ */ f("div", {})
  }), /* @__PURE__ */ f(rZ, {
    children: /* @__PURE__ */ f("div", {})
  })]
}), lZ = /* @__PURE__ */ V("div")({
  name: "Container",
  class: "c1lvd429",
  propsAsIs: !1
}), aZ = () => oe, cZ = /* @__PURE__ */ V(aZ())({
  name: "PredictionIcon",
  class: "p1n4m87t",
  propsAsIs: !0
}), uZ = () => /* @__PURE__ */ U(lZ, {
  children: [/* @__PURE__ */ f(cZ, {
    name: "icon-prediction"
  }), " Prediction results are in!"]
}), hZ = () => oe, dZ = /* @__PURE__ */ V(hZ())({
  name: "CheckIcon",
  class: "c126r8f9",
  propsAsIs: !0
}), mZ = /* @__PURE__ */ V("div")({
  name: "Answer",
  class: "a1o2rpgl",
  propsAsIs: !1
}), pZ = /* @__PURE__ */ V("div")({
  name: "Container",
  class: "cej6ci1",
  propsAsIs: !1
}), gZ = /* @__PURE__ */ V("div")({
  name: "Title",
  class: "tob24mr",
  propsAsIs: !1
}), fZ = ({
  title: t,
  answer: e
}) => /* @__PURE__ */ U(pZ, {
  children: [/* @__PURE__ */ f(gZ, {
    children: t
  }), /* @__PURE__ */ U(mZ, {
    children: [/* @__PURE__ */ f(dZ, {
      name: "icon-prediction"
    }), "Your Pick: ", e]
  })]
}), c3 = /* @__PURE__ */ V("div")({
  name: "Container",
  class: "c1lesal4",
  propsAsIs: !1
}), u3 = /* @__PURE__ */ V("div")({
  name: "Title",
  class: "tv66n4w",
  propsAsIs: !1
}), bZ = () => oe, AZ = /* @__PURE__ */ V(bZ())({
  name: "CorrectIcon",
  class: "cx0vlv2",
  propsAsIs: !0
}), h3 = /* @__PURE__ */ V("div")({
  name: "Answer",
  class: "akfh4v5",
  propsAsIs: !1
}), VZ = ({
  answer: t
}) => /* @__PURE__ */ U(c3, {
  children: [/* @__PURE__ */ f(u3, {
    children: "Congratulations! You answered correctly."
  }), /* @__PURE__ */ U(h3, {
    children: [/* @__PURE__ */ f(AZ, {
      name: "icon-correct"
    }), "Your Pick: ", t]
  })]
}), RZ = ({
  title: t,
  answer: e
}) => /* @__PURE__ */ U(c3, {
  children: [/* @__PURE__ */ U(u3, {
    children: ["Better luck next time!", /* @__PURE__ */ f("br", {}), "Correct: ", t]
  }), /* @__PURE__ */ U(h3, {
    children: ["Your Pick: ", e]
  })]
}), rd = /* @__PURE__ */ V("div")({
  name: "Container",
  class: "cmox3ot",
  propsAsIs: !1
}), od = /* @__PURE__ */ V("div")({
  name: "Body",
  class: "bqq1ix4",
  propsAsIs: !1
}), ld = {
  1: 3e3,
  2: 4e3,
  3: 4e3
}, EZ = ({ close: t, action: e, setStep: n, votedAnswer: i, correct: s, correctAnswerTitle: r, questionTitle: o, step: l }) => {
  if (te(() => {
    if (n) {
      const c = setTimeout(() => {
        ld[l + 1] && (s || l < 3) ? n(l + 1) : t?.();
      }, ld[l]);
      return () => {
        c && clearTimeout(c);
      };
    }
    return () => {
    };
  }, [n, l, t, s]), l === 1)
    return /* @__PURE__ */ f(rd, { children: /* @__PURE__ */ f(od, { children: /* @__PURE__ */ f(uZ, {}) }) });
  let a = "pending";
  return l === 3 && (a = s ? "correct" : "incorrect"), /* @__PURE__ */ f(rd, { "data-a": "intr", onClick: () => e?.(), children: /* @__PURE__ */ U(od, { children: [
    l !== 1 && /* @__PURE__ */ f(oZ, {}, l),
    /* @__PURE__ */ U($S, { state: a, step: l, children: [
      l === 2 && /* @__PURE__ */ f(fZ, { title: o || "unknown", answer: i?.title || "unknown" }),
      l === 3 && s && /* @__PURE__ */ f(VZ, { answer: i?.title || "unknown" }),
      l === 3 && !s && /* @__PURE__ */ f(RZ, { title: r || "unknown", answer: i?.title || "unknown" })
    ] })
  ] }) });
}, yZ = ({ close: t, action: e, votedAnswer: n, correct: i, correctAnswerTitle: s, questionTitle: r }) => {
  const [o, l] = re(1);
  return /* @__PURE__ */ f(
    EZ,
    {
      close: t,
      action: e,
      votedAnswer: n,
      correct: i,
      correctAnswerTitle: s,
      questionTitle: r,
      setStep: l,
      step: o,
      title: ""
    }
  );
}, d3 = /* @__PURE__ */ V("div")({
  name: "NotificationContainer",
  class: "nn0nqh6",
  propsAsIs: !1
}), CZ = () => ({
  withoutPadding: t
}) => t ? "0px" : "1rem", WZ = /* @__PURE__ */ V("div")({
  name: "NotificationContent",
  class: "n1bcdf3j",
  propsAsIs: !1,
  vars: {
    "n1bcdf3j-0": [CZ()]
  }
}), m3 = /* @__PURE__ */ V("img")({
  name: "LogoImg",
  class: "l8jorbq",
  propsAsIs: !1
}), SZ = () => d3, ZZ = /* @__PURE__ */ V(SZ())({
  name: "NotificationInterstitialContainer",
  class: "nf920y3",
  propsAsIs: !0
}), vZ = /* @__PURE__ */ V("div")({
  name: "LogoImgContainer",
  class: "lzsmehn",
  propsAsIs: !1
}), IZ = ({
  className: t,
  sponsorLogo: e,
  onClick: n
}) => /* @__PURE__ */ f(ZZ, { className: t, onClick: n, children: /* @__PURE__ */ f(WZ, { withoutPadding: !0, children: /* @__PURE__ */ f(m3, { src: e }) }) }), NZ = ({ className: t, ...e }) => {
  const [n, i] = re(!1), s = Ee();
  return te(() => (e?.inApp?.sponsorLogo && (i(!0), s.current = setTimeout(() => {
    i(!1);
  }, 5e3)), () => clearTimeout(s.current)), [e?.inApp?.sponsorLogo]), e?.inApp?.sponsorLogo && n ? /* @__PURE__ */ f(
    IZ,
    {
      className: t,
      sponsorLogo: e.inApp?.sponsorLogo,
      onClick: () => i(!1)
    }
  ) : /* @__PURE__ */ f(d3, { className: t, children: /* @__PURE__ */ U("div", { children: [
    e?.inApp?.sponsorLogo && /* @__PURE__ */ f(vZ, { children: /* @__PURE__ */ f(m3, { src: e?.inApp?.sponsorLogo }) }),
    /* @__PURE__ */ f(yZ, { ...e })
  ] }) });
}, FZ = () => Ra, GZ = /* @__PURE__ */ V(FZ())({
  name: "OpenedContainer",
  class: "osyjgip",
  propsAsIs: !0
}), Qs = ({
  sdk: t,
  notification: e
}) => {
  const n = He(t.featuresList.getStore()), {
    hiding: i,
    onAnimationEnd: s,
    finished: r
  } = ba(), [o] = re(t.getNotificationsStore()), l = He(o), a = gt(() => t.getActiveNotification(), [t, l]);
  te(() => {
    a && be.emit("notification", {
      action: "rendered",
      payload: {
        questionId: a.data.questionId,
        questionType: a.data.questionType
      }
    });
  }, [a]);
  const c = t.getFeature(pe.GAMES);
  return te(() => {
    r && c?.closeQuestion();
  }, [r, c]), !n || !c ? null : e && a && a.type === Cl.QUESTION_RESOLVED && a.data.questionType === M.PREDICTION && a.data.question ? a.data.inApp?.adUnit === Ne.STANDART ? /* @__PURE__ */ f(NZ, {
    className: "SL-CardNotificationWebOs",
    action: a.action,
    close: a.close,
    ...a.data.question,
    inApp: a.data.inApp
  }) : /* @__PURE__ */ f(DS, {
    className: "SL-CardNotificationWebOs",
    action: a.action,
    close: a.close,
    ...a.data.question
  }) : e && a && a.data.inApp?.adUnit === Ne.STANDART ? /* @__PURE__ */ f(aS, {
    className: "SL-CardNotificationWebOs",
    ...a.data,
    action: a.action,
    close: a.close,
    color: a?.data?.inApp?.notification?.indicatorColor || a?.data?.inApp?.appearance?.primaryColor || "",
    webos: !0
  }) : e ? null : /* @__PURE__ */ f(GZ, {
    hiding: i,
    onAnimationEnd: s,
    children: /* @__PURE__ */ f(aW, {
      sdk: t,
      gamification: c,
      className: "SL-CardWebOs",
      webos: !0
    })
  });
};
Y3({
  shouldFocusDOMNode: !0
});
const XZ = ({
  persistent: t,
  children: e,
  sdk: n,
  showPauseAd: i,
  pauseAdVastUrl: s,
  onClosePauseAd: r,
  onRenderPauseAd: o,
  options: l
}) => {
  const a = He(n.uiState), c = Ue(() => {
    r?.();
  }, [r]);
  return /* @__PURE__ */ U(
    S5,
    {
      sdk: n,
      sidebar: ({ promo: u }) => a.exposedPauseAd ? null : a.polymarket ? /* @__PURE__ */ f(o6, { sdk: n, webos: !0 }) : u ? /* @__PURE__ */ f(qn, { sdk: n, persistent: t, sidebar: "right" }) : /* @__PURE__ */ f(Qs, { sdk: n, persistent: t }),
      notification: ({ promo: u }) => a.exposedPauseAd || a.polymarket ? null : u ? /* @__PURE__ */ f(qn, { sdk: n, notification: !0, persistent: t }) : /* @__PURE__ */ f(Qs, { notification: !0, sdk: n, persistent: t }),
      banner: a.exposedPauseAd || a.polymarket ? null : /* @__PURE__ */ f(qn, { sdk: n, persistent: t, banner: "bottom" }),
      webos: !0,
      children: [
        e,
        s && /* @__PURE__ */ f(
          D2,
          {
            showPauseAd: i,
            vastUrls: s,
            sdk: n,
            onClose: c,
            onRender: o,
            options: l
          }
        ),
        l?.showPolymarketButton && /* @__PURE__ */ f(r6, { sdk: n })
      ]
    }
  );
};
class UZ extends B3 {
  constructor(e) {
    super(e), this.state = { hasError: !1 };
  }
  static getDerivedStateFromError() {
    return { hasError: !0 };
  }
  componentDidCatch(e, n) {
    console.error("StreamLayerSDKTv error:", e, n.componentStack);
  }
  render() {
    return this.state.hasError ? this.props.children : /* @__PURE__ */ f(XZ, { ...this.props });
  }
}
window.dispatchEvent(new CustomEvent("grpc_devtools_loaded"));
var ad;
(function(t) {
  t.Init = "init", t.Ready = "ready", t.Connecting = "connecting", t.Connected = "connected", t.Disconnected = "disconnected", t.Failed = "failed", t.Reconnect = "reconnect", t.Reconnecting = "reconnecting";
})(ad || (ad = {}));
Ki("grpc:stream");
se.Unknown, se.Internal, se.DeadlineExceeded, se.ResourceExhausted, se.FailedPrecondition, se.Unavailable, se.DataLoss;
Ki("grpc:retry");
ws(10, { description: "Number of attempts to retry" }), ws(3e4, { description: "Max delay between retries in milliseconds" });
const BZ = (t, e) => {
  const { client: n, createRequestOptions: i } = t.createPromiseClient(qs, { method: "bypassAuth" }), s = i({ retryAttempts: 0 });
  return n.bypassAuth(e, { contextValues: s });
}, Fe = crypto, Gt = (t) => t instanceof CryptoKey, wZ = async (t, e) => {
  const n = `SHA-${t.slice(-3)}`;
  return new Uint8Array(await Fe.subtle.digest(n, e));
}, cn = new TextEncoder(), p3 = new TextDecoder(), zs = 2 ** 32;
function Oi(...t) {
  const e = t.reduce((s, { length: r }) => s + r, 0), n = new Uint8Array(e);
  let i = 0;
  for (const s of t)
    n.set(s, i), i += s.length;
  return n;
}
function YZ(t, e) {
  return Oi(cn.encode(t), new Uint8Array([0]), e);
}
function Zl(t, e, n) {
  if (e < 0 || e >= zs)
    throw new RangeError(`value must be >= 0 and <= ${zs - 1}. Received ${e}`);
  t.set([e >>> 24, e >>> 16, e >>> 8, e & 255], n);
}
function TZ(t) {
  const e = Math.floor(t / zs), n = t % zs, i = new Uint8Array(8);
  return Zl(i, e, 0), Zl(i, n, 4), i;
}
function Wa(t) {
  const e = new Uint8Array(4);
  return Zl(e, t), e;
}
function Oo(t) {
  return Oi(Wa(t.length), t);
}
async function LZ(t, e, n) {
  const i = Math.ceil((e >> 3) / 32), s = new Uint8Array(i * 32);
  for (let r = 0; r < i; r++) {
    const o = new Uint8Array(4 + t.length + n.length);
    o.set(Wa(r + 1)), o.set(t, 4), o.set(n, 4 + t.length), s.set(await wZ("sha256", o), r * 32);
  }
  return s.slice(0, e >> 3);
}
const kZ = (t) => {
  let e = t;
  typeof e == "string" && (e = cn.encode(e));
  const n = 32768, i = [];
  for (let s = 0; s < e.length; s += n)
    i.push(String.fromCharCode.apply(null, e.subarray(s, s + n)));
  return btoa(i.join(""));
}, lt = (t) => kZ(t).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_"), JZ = (t) => {
  const e = atob(t), n = new Uint8Array(e.length);
  for (let i = 0; i < e.length; i++)
    n[i] = e.charCodeAt(i);
  return n;
}, mr = (t) => {
  let e = t;
  e instanceof Uint8Array && (e = p3.decode(e)), e = e.replace(/-/g, "+").replace(/_/g, "/").replace(/\s/g, "");
  try {
    return JZ(e);
  } catch {
    throw new TypeError("The input to be decoded is not correctly encoded.");
  }
};
class g3 extends Error {
  static get code() {
    return "ERR_JOSE_GENERIC";
  }
  constructor(e) {
    super(e), this.code = "ERR_JOSE_GENERIC", this.name = this.constructor.name, Error.captureStackTrace?.(this, this.constructor);
  }
}
class _e extends g3 {
  constructor() {
    super(...arguments), this.code = "ERR_JOSE_NOT_SUPPORTED";
  }
  static get code() {
    return "ERR_JOSE_NOT_SUPPORTED";
  }
}
class rn extends g3 {
  constructor() {
    super(...arguments), this.code = "ERR_JWE_INVALID";
  }
  static get code() {
    return "ERR_JWE_INVALID";
  }
}
const Sa = Fe.getRandomValues.bind(Fe);
function f3(t) {
  switch (t) {
    case "A128GCM":
    case "A128GCMKW":
    case "A192GCM":
    case "A192GCMKW":
    case "A256GCM":
    case "A256GCMKW":
      return 96;
    case "A128CBC-HS256":
    case "A192CBC-HS384":
    case "A256CBC-HS512":
      return 128;
    default:
      throw new _e(`Unsupported JWE Algorithm: ${t}`);
  }
}
const xZ = (t) => Sa(new Uint8Array(f3(t) >> 3)), MZ = (t, e) => {
  if (e.length << 3 !== f3(t))
    throw new rn("Invalid Initialization Vector length");
}, cd = (t, e) => {
  const n = t.byteLength << 3;
  if (n !== e)
    throw new rn(`Invalid Content Encryption Key length. Expected ${e} bits, got ${n} bits`);
};
function sn(t, e = "algorithm.name") {
  return new TypeError(`CryptoKey does not support this operation, its ${e} must be ${t}`);
}
function bs(t, e) {
  return t.name === e;
}
function QZ(t) {
  return parseInt(t.name.slice(4), 10);
}
function zZ(t, e) {
  if (e.length && !e.some((n) => t.usages.includes(n))) {
    let n = "CryptoKey does not support this operation, its usages must include ";
    if (e.length > 2) {
      const i = e.pop();
      n += `one of ${e.join(", ")}, or ${i}.`;
    } else e.length === 2 ? n += `one of ${e[0]} or ${e[1]}.` : n += `${e[0]}.`;
    throw new TypeError(n);
  }
}
function ci(t, e, ...n) {
  switch (e) {
    case "A128GCM":
    case "A192GCM":
    case "A256GCM": {
      if (!bs(t.algorithm, "AES-GCM"))
        throw sn("AES-GCM");
      const i = parseInt(e.slice(1, 4), 10);
      if (t.algorithm.length !== i)
        throw sn(i, "algorithm.length");
      break;
    }
    case "A128KW":
    case "A192KW":
    case "A256KW": {
      if (!bs(t.algorithm, "AES-KW"))
        throw sn("AES-KW");
      const i = parseInt(e.slice(1, 4), 10);
      if (t.algorithm.length !== i)
        throw sn(i, "algorithm.length");
      break;
    }
    case "ECDH": {
      switch (t.algorithm.name) {
        case "ECDH":
        case "X25519":
        case "X448":
          break;
        default:
          throw sn("ECDH, X25519, or X448");
      }
      break;
    }
    case "PBES2-HS256+A128KW":
    case "PBES2-HS384+A192KW":
    case "PBES2-HS512+A256KW":
      if (!bs(t.algorithm, "PBKDF2"))
        throw sn("PBKDF2");
      break;
    case "RSA-OAEP":
    case "RSA-OAEP-256":
    case "RSA-OAEP-384":
    case "RSA-OAEP-512": {
      if (!bs(t.algorithm, "RSA-OAEP"))
        throw sn("RSA-OAEP");
      const i = parseInt(e.slice(9), 10) || 1;
      if (QZ(t.algorithm.hash) !== i)
        throw sn(`SHA-${i}`, "algorithm.hash");
      break;
    }
    default:
      throw new TypeError("CryptoKey does not support this operation");
  }
  zZ(t, n);
}
function b3(t, e, ...n) {
  if (n = n.filter(Boolean), n.length > 2) {
    const i = n.pop();
    t += `one of type ${n.join(", ")}, or ${i}.`;
  } else n.length === 2 ? t += `one of type ${n[0]} or ${n[1]}.` : t += `of type ${n[0]}.`;
  return e == null ? t += ` Received ${e}` : typeof e == "function" && e.name ? t += ` Received function ${e.name}` : typeof e == "object" && e != null && e.constructor?.name && (t += ` Received an instance of ${e.constructor.name}`), t;
}
const Xt = (t, ...e) => b3("Key must be ", t, ...e);
function A3(t, e, ...n) {
  return b3(`Key for the ${t} algorithm must be `, e, ...n);
}
const V3 = (t) => Gt(t) ? !0 : t?.[Symbol.toStringTag] === "KeyObject", Vt = ["CryptoKey"], KZ = (...t) => {
  const e = t.filter(Boolean);
  if (e.length === 0 || e.length === 1)
    return !0;
  let n;
  for (const i of e) {
    const s = Object.keys(i);
    if (!n || n.size === 0) {
      n = new Set(s);
      continue;
    }
    for (const r of s) {
      if (n.has(r))
        return !1;
      n.add(r);
    }
  }
  return !0;
};
function HZ(t) {
  return typeof t == "object" && t !== null;
}
function Za(t) {
  if (!HZ(t) || Object.prototype.toString.call(t) !== "[object Object]")
    return !1;
  if (Object.getPrototypeOf(t) === null)
    return !0;
  let e = t;
  for (; Object.getPrototypeOf(e) !== null; )
    e = Object.getPrototypeOf(e);
  return Object.getPrototypeOf(t) === e;
}
const R3 = [
  { hash: "SHA-256", name: "HMAC" },
  !0,
  ["sign"]
];
function OZ(t, e) {
  if (t.algorithm.length !== parseInt(e.slice(1, 4), 10))
    throw new TypeError(`Invalid key size for alg: ${e}`);
}
function DZ(t, e, n) {
  if (Gt(t))
    return ci(t, e, n), t;
  if (t instanceof Uint8Array)
    return Fe.subtle.importKey("raw", t, "AES-KW", !0, [n]);
  throw new TypeError(Xt(t, ...Vt, "Uint8Array"));
}
const vl = async (t, e, n) => {
  const i = await DZ(e, t, "wrapKey");
  OZ(i, t);
  const s = await Fe.subtle.importKey("raw", n, ...R3);
  return new Uint8Array(await Fe.subtle.wrapKey("raw", s, i, "AES-KW"));
};
async function PZ(t, e, n, i, s = new Uint8Array(0), r = new Uint8Array(0)) {
  if (!Gt(t))
    throw new TypeError(Xt(t, ...Vt));
  if (ci(t, "ECDH"), !Gt(e))
    throw new TypeError(Xt(e, ...Vt));
  ci(e, "ECDH", "deriveBits");
  const o = Oi(Oo(cn.encode(n)), Oo(s), Oo(r), Wa(i));
  let l;
  t.algorithm.name === "X25519" ? l = 256 : t.algorithm.name === "X448" ? l = 448 : l = Math.ceil(parseInt(t.algorithm.namedCurve.substr(-3), 10) / 8) << 3;
  const a = new Uint8Array(await Fe.subtle.deriveBits({
    name: t.algorithm.name,
    public: t
  }, e, l));
  return LZ(a, i, o);
}
async function _Z(t) {
  if (!Gt(t))
    throw new TypeError(Xt(t, ...Vt));
  return Fe.subtle.generateKey(t.algorithm, !0, ["deriveBits"]);
}
function jZ(t) {
  if (!Gt(t))
    throw new TypeError(Xt(t, ...Vt));
  return ["P-256", "P-384", "P-521"].includes(t.algorithm.namedCurve) || t.algorithm.name === "X25519" || t.algorithm.name === "X448";
}
function $Z(t) {
  if (!(t instanceof Uint8Array) || t.length < 8)
    throw new rn("PBES2 Salt Input must be 8 or more octets");
}
function qZ(t, e) {
  if (t instanceof Uint8Array)
    return Fe.subtle.importKey("raw", t, "PBKDF2", !1, ["deriveBits"]);
  if (Gt(t))
    return ci(t, e, "deriveBits", "deriveKey"), t;
  throw new TypeError(Xt(t, ...Vt, "Uint8Array"));
}
async function ev(t, e, n, i) {
  $Z(t);
  const s = YZ(e, t), r = parseInt(e.slice(13, 16), 10), o = {
    hash: `SHA-${e.slice(8, 11)}`,
    iterations: n,
    name: "PBKDF2",
    salt: s
  }, l = {
    length: r,
    name: "AES-KW"
  }, a = await qZ(i, e);
  if (a.usages.includes("deriveBits"))
    return new Uint8Array(await Fe.subtle.deriveBits(o, a, r));
  if (a.usages.includes("deriveKey"))
    return Fe.subtle.deriveKey(o, a, l, !1, ["wrapKey", "unwrapKey"]);
  throw new TypeError('PBKDF2 key "usages" must include "deriveBits" or "deriveKey"');
}
const tv = async (t, e, n, i = 2048, s = Sa(new Uint8Array(16))) => {
  const r = await ev(s, t, i, e);
  return { encryptedKey: await vl(t.slice(-6), r, n), p2c: i, p2s: lt(s) };
};
function ud(t) {
  switch (t) {
    case "RSA-OAEP":
    case "RSA-OAEP-256":
    case "RSA-OAEP-384":
    case "RSA-OAEP-512":
      return "RSA-OAEP";
    default:
      throw new _e(`alg ${t} is not supported either by JOSE or your javascript runtime`);
  }
}
const nv = (t, e) => {
  if (t.startsWith("RS") || t.startsWith("PS")) {
    const { modulusLength: n } = e.algorithm;
    if (typeof n != "number" || n < 2048)
      throw new TypeError(`${t} requires key modulusLength to be 2048 bits or larger`);
  }
}, iv = async (t, e, n) => {
  if (!Gt(e))
    throw new TypeError(Xt(e, ...Vt));
  if (ci(e, t, "encrypt", "wrapKey"), nv(t, e), e.usages.includes("encrypt"))
    return new Uint8Array(await Fe.subtle.encrypt(ud(t), e, n));
  if (e.usages.includes("wrapKey")) {
    const i = await Fe.subtle.importKey("raw", n, ...R3);
    return new Uint8Array(await Fe.subtle.wrapKey("raw", i, e, ud(t)));
  }
  throw new TypeError('RSA-OAEP key "usages" must include "encrypt" or "wrapKey" for this operation');
};
function Di(t) {
  return Za(t) && typeof t.kty == "string";
}
function sv(t) {
  return t.kty !== "oct" && typeof t.d == "string";
}
function rv(t) {
  return t.kty !== "oct" && typeof t.d > "u";
}
function ov(t) {
  return Di(t) && t.kty === "oct" && typeof t.k == "string";
}
function lv(t) {
  let e, n;
  switch (t.kty) {
    case "RSA": {
      switch (t.alg) {
        case "PS256":
        case "PS384":
        case "PS512":
          e = { name: "RSA-PSS", hash: `SHA-${t.alg.slice(-3)}` }, n = t.d ? ["sign"] : ["verify"];
          break;
        case "RS256":
        case "RS384":
        case "RS512":
          e = { name: "RSASSA-PKCS1-v1_5", hash: `SHA-${t.alg.slice(-3)}` }, n = t.d ? ["sign"] : ["verify"];
          break;
        case "RSA-OAEP":
        case "RSA-OAEP-256":
        case "RSA-OAEP-384":
        case "RSA-OAEP-512":
          e = {
            name: "RSA-OAEP",
            hash: `SHA-${parseInt(t.alg.slice(-3), 10) || 1}`
          }, n = t.d ? ["decrypt", "unwrapKey"] : ["encrypt", "wrapKey"];
          break;
        default:
          throw new _e('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
      }
      break;
    }
    case "EC": {
      switch (t.alg) {
        case "ES256":
          e = { name: "ECDSA", namedCurve: "P-256" }, n = t.d ? ["sign"] : ["verify"];
          break;
        case "ES384":
          e = { name: "ECDSA", namedCurve: "P-384" }, n = t.d ? ["sign"] : ["verify"];
          break;
        case "ES512":
          e = { name: "ECDSA", namedCurve: "P-521" }, n = t.d ? ["sign"] : ["verify"];
          break;
        case "ECDH-ES":
        case "ECDH-ES+A128KW":
        case "ECDH-ES+A192KW":
        case "ECDH-ES+A256KW":
          e = { name: "ECDH", namedCurve: t.crv }, n = t.d ? ["deriveBits"] : [];
          break;
        default:
          throw new _e('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
      }
      break;
    }
    case "OKP": {
      switch (t.alg) {
        case "EdDSA":
          e = { name: t.crv }, n = t.d ? ["sign"] : ["verify"];
          break;
        case "ECDH-ES":
        case "ECDH-ES+A128KW":
        case "ECDH-ES+A192KW":
        case "ECDH-ES+A256KW":
          e = { name: t.crv }, n = t.d ? ["deriveBits"] : [];
          break;
        default:
          throw new _e('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
      }
      break;
    }
    default:
      throw new _e('Invalid or unsupported JWK "kty" (Key Type) Parameter value');
  }
  return { algorithm: e, keyUsages: n };
}
const E3 = async (t) => {
  if (!t.alg)
    throw new TypeError('"alg" argument is required when "jwk.alg" is not present');
  const { algorithm: e, keyUsages: n } = lv(t), i = [
    e,
    t.ext ?? !1,
    t.key_ops ?? n
  ], s = { ...t };
  return delete s.alg, delete s.use, Fe.subtle.importKey("jwk", s, ...i);
}, y3 = (t) => mr(t);
let Jn, xn;
const C3 = (t) => t?.[Symbol.toStringTag] === "KeyObject", Ks = async (t, e, n, i, s = !1) => {
  let r = t.get(e);
  if (r?.[i])
    return r[i];
  const o = await E3({ ...n, alg: i });
  return s && Object.freeze(e), r ? r[i] = o : t.set(e, { [i]: o }), o;
}, av = (t, e) => {
  if (C3(t)) {
    let n = t.export({ format: "jwk" });
    return delete n.d, delete n.dp, delete n.dq, delete n.p, delete n.q, delete n.qi, n.k ? y3(n.k) : (xn || (xn = /* @__PURE__ */ new WeakMap()), Ks(xn, t, n, e));
  }
  return Di(t) ? t.k ? mr(t.k) : (xn || (xn = /* @__PURE__ */ new WeakMap()), Ks(xn, t, t, e, !0)) : t;
}, cv = (t, e) => {
  if (C3(t)) {
    let n = t.export({ format: "jwk" });
    return n.k ? y3(n.k) : (Jn || (Jn = /* @__PURE__ */ new WeakMap()), Ks(Jn, t, n, e));
  }
  return Di(t) ? t.k ? mr(t.k) : (Jn || (Jn = /* @__PURE__ */ new WeakMap()), Ks(Jn, t, t, e, !0)) : t;
}, uv = { normalizePublicKey: av, normalizePrivateKey: cv };
function W3(t) {
  switch (t) {
    case "A128GCM":
      return 128;
    case "A192GCM":
      return 192;
    case "A256GCM":
    case "A128CBC-HS256":
      return 256;
    case "A192CBC-HS384":
      return 384;
    case "A256CBC-HS512":
      return 512;
    default:
      throw new _e(`Unsupported JWE Algorithm: ${t}`);
  }
}
const Ei = (t) => Sa(new Uint8Array(W3(t) >> 3));
async function hv(t, e) {
  if (!Za(t))
    throw new TypeError("JWK must be an object");
  switch (e || (e = t.alg), t.kty) {
    case "oct":
      if (typeof t.k != "string" || !t.k)
        throw new TypeError('missing "k" (Key Value) Parameter value');
      return mr(t.k);
    case "RSA":
      if (t.oth !== void 0)
        throw new _e('RSA JWK "oth" (Other Primes Info) Parameter value is not supported');
    case "EC":
    case "OKP":
      return E3({ ...t, alg: e });
    default:
      throw new _e('Unsupported "kty" (Key Type) Parameter value');
  }
}
const Qn = (t) => t?.[Symbol.toStringTag], Il = (t, e, n) => {
  if (e.use !== void 0 && e.use !== "sig")
    throw new TypeError("Invalid key for this operation, when present its use must be sig");
  if (e.key_ops !== void 0 && e.key_ops.includes?.(n) !== !0)
    throw new TypeError(`Invalid key for this operation, when present its key_ops must include ${n}`);
  if (e.alg !== void 0 && e.alg !== t)
    throw new TypeError(`Invalid key for this operation, when present its alg must be ${t}`);
  return !0;
}, dv = (t, e, n, i) => {
  if (!(e instanceof Uint8Array)) {
    if (i && Di(e)) {
      if (ov(e) && Il(t, e, n))
        return;
      throw new TypeError('JSON Web Key for symmetric algorithms must have JWK "kty" (Key Type) equal to "oct" and the JWK "k" (Key Value) present');
    }
    if (!V3(e))
      throw new TypeError(A3(t, e, ...Vt, "Uint8Array", i ? "JSON Web Key" : null));
    if (e.type !== "secret")
      throw new TypeError(`${Qn(e)} instances for symmetric algorithms must be of type "secret"`);
  }
}, mv = (t, e, n, i) => {
  if (i && Di(e))
    switch (n) {
      case "sign":
        if (sv(e) && Il(t, e, n))
          return;
        throw new TypeError("JSON Web Key for this operation be a private JWK");
      case "verify":
        if (rv(e) && Il(t, e, n))
          return;
        throw new TypeError("JSON Web Key for this operation be a public JWK");
    }
  if (!V3(e))
    throw new TypeError(A3(t, e, ...Vt, i ? "JSON Web Key" : null));
  if (e.type === "secret")
    throw new TypeError(`${Qn(e)} instances for asymmetric algorithms must not be of type "secret"`);
  if (n === "sign" && e.type === "public")
    throw new TypeError(`${Qn(e)} instances for asymmetric algorithm signing must be of type "private"`);
  if (n === "decrypt" && e.type === "public")
    throw new TypeError(`${Qn(e)} instances for asymmetric algorithm decryption must be of type "private"`);
  if (e.algorithm && n === "verify" && e.type === "private")
    throw new TypeError(`${Qn(e)} instances for asymmetric algorithm verifying must be of type "public"`);
  if (e.algorithm && n === "encrypt" && e.type === "private")
    throw new TypeError(`${Qn(e)} instances for asymmetric algorithm encryption must be of type "public"`);
};
function S3(t, e, n, i) {
  e.startsWith("HS") || e === "dir" || e.startsWith("PBES2") || /^A\d{3}(?:GCM)?KW$/.test(e) ? dv(e, n, i, t) : mv(e, n, i, t);
}
const pv = S3.bind(void 0, !1);
S3.bind(void 0, !0);
async function gv(t, e, n, i, s) {
  if (!(n instanceof Uint8Array))
    throw new TypeError(Xt(n, "Uint8Array"));
  const r = parseInt(t.slice(1, 4), 10), o = await Fe.subtle.importKey("raw", n.subarray(r >> 3), "AES-CBC", !1, ["encrypt"]), l = await Fe.subtle.importKey("raw", n.subarray(0, r >> 3), {
    hash: `SHA-${r << 1}`,
    name: "HMAC"
  }, !1, ["sign"]), a = new Uint8Array(await Fe.subtle.encrypt({
    iv: i,
    name: "AES-CBC"
  }, o, e)), c = Oi(s, i, a, TZ(s.length << 3)), u = new Uint8Array((await Fe.subtle.sign("HMAC", l, c)).slice(0, r >> 3));
  return { ciphertext: a, tag: u, iv: i };
}
async function fv(t, e, n, i, s) {
  let r;
  n instanceof Uint8Array ? r = await Fe.subtle.importKey("raw", n, "AES-GCM", !1, ["encrypt"]) : (ci(n, t, "encrypt"), r = n);
  const o = new Uint8Array(await Fe.subtle.encrypt({
    additionalData: s,
    iv: i,
    name: "AES-GCM",
    tagLength: 128
  }, r, e)), l = o.slice(-16);
  return { ciphertext: o.slice(0, -16), tag: l, iv: i };
}
const Z3 = async (t, e, n, i, s) => {
  if (!Gt(n) && !(n instanceof Uint8Array))
    throw new TypeError(Xt(n, ...Vt, "Uint8Array"));
  switch (i ? MZ(t, i) : i = xZ(t), t) {
    case "A128CBC-HS256":
    case "A192CBC-HS384":
    case "A256CBC-HS512":
      return n instanceof Uint8Array && cd(n, parseInt(t.slice(-3), 10)), gv(t, e, n, i, s);
    case "A128GCM":
    case "A192GCM":
    case "A256GCM":
      return n instanceof Uint8Array && cd(n, parseInt(t.slice(1, 4), 10)), fv(t, e, n, i, s);
    default:
      throw new _e("Unsupported JWE Content Encryption Algorithm");
  }
};
async function bv(t, e, n, i) {
  const s = t.slice(0, 7), r = await Z3(s, n, e, i, new Uint8Array(0));
  return {
    encryptedKey: r.ciphertext,
    iv: lt(r.iv),
    tag: lt(r.tag)
  };
}
function Av(t, e, n, i, s) {
  if (s.crit !== void 0 && i?.crit === void 0)
    throw new t('"crit" (Critical) Header Parameter MUST be integrity protected');
  if (!i || i.crit === void 0)
    return /* @__PURE__ */ new Set();
  if (!Array.isArray(i.crit) || i.crit.length === 0 || i.crit.some((o) => typeof o != "string" || o.length === 0))
    throw new t('"crit" (Critical) Header Parameter MUST be an array of non-empty strings when present');
  let r;
  n !== void 0 ? r = new Map([...Object.entries(n), ...e.entries()]) : r = e;
  for (const o of i.crit) {
    if (!r.has(o))
      throw new _e(`Extension Header Parameter "${o}" is not recognized`);
    if (s[o] === void 0)
      throw new t(`Extension Header Parameter "${o}" is missing`);
    if (r.get(o) && i[o] === void 0)
      throw new t(`Extension Header Parameter "${o}" MUST be integrity protected`);
  }
  return new Set(i.crit);
}
const Vv = /* @__PURE__ */ Symbol(), Rv = async (t) => {
  if (t instanceof Uint8Array)
    return {
      kty: "oct",
      k: lt(t)
    };
  if (!Gt(t))
    throw new TypeError(Xt(t, ...Vt, "Uint8Array"));
  if (!t.extractable)
    throw new TypeError("non-extractable CryptoKey cannot be exported as a JWK");
  const { ext: e, key_ops: n, alg: i, use: s, ...r } = await Fe.subtle.exportKey("jwk", t);
  return r;
};
async function Ev(t) {
  return Rv(t);
}
async function yv(t, e, n, i, s = {}) {
  let r, o, l;
  switch (pv(t, n, "encrypt"), n = await uv.normalizePublicKey?.(n, t) || n, t) {
    case "dir": {
      l = n;
      break;
    }
    case "ECDH-ES":
    case "ECDH-ES+A128KW":
    case "ECDH-ES+A192KW":
    case "ECDH-ES+A256KW": {
      if (!jZ(n))
        throw new _e("ECDH with the provided key is not allowed or not supported by your javascript runtime");
      const { apu: a, apv: c } = s;
      let { epk: u } = s;
      u || (u = (await _Z(n)).privateKey);
      const { x: h, y: d, crv: m, kty: p } = await Ev(u), g = await PZ(n, u, t === "ECDH-ES" ? e : t, t === "ECDH-ES" ? W3(e) : parseInt(t.slice(-5, -2), 10), a, c);
      if (o = { epk: { x: h, crv: m, kty: p } }, p === "EC" && (o.epk.y = d), a && (o.apu = lt(a)), c && (o.apv = lt(c)), t === "ECDH-ES") {
        l = g;
        break;
      }
      l = i || Ei(e);
      const A = t.slice(-6);
      r = await vl(A, g, l);
      break;
    }
    case "RSA1_5":
    case "RSA-OAEP":
    case "RSA-OAEP-256":
    case "RSA-OAEP-384":
    case "RSA-OAEP-512": {
      l = i || Ei(e), r = await iv(t, n, l);
      break;
    }
    case "PBES2-HS256+A128KW":
    case "PBES2-HS384+A192KW":
    case "PBES2-HS512+A256KW": {
      l = i || Ei(e);
      const { p2c: a, p2s: c } = s;
      ({ encryptedKey: r, ...o } = await tv(t, n, l, a, c));
      break;
    }
    case "A128KW":
    case "A192KW":
    case "A256KW": {
      l = i || Ei(e), r = await vl(t, n, l);
      break;
    }
    case "A128GCMKW":
    case "A192GCMKW":
    case "A256GCMKW": {
      l = i || Ei(e);
      const { iv: a } = s;
      ({ encryptedKey: r, ...o } = await bv(t, n, l, a));
      break;
    }
    default:
      throw new _e('Invalid or unsupported "alg" (JWE Algorithm) header value');
  }
  return { cek: l, encryptedKey: r, parameters: o };
}
class Cv {
  constructor(e) {
    if (!(e instanceof Uint8Array))
      throw new TypeError("plaintext must be an instance of Uint8Array");
    this._plaintext = e;
  }
  setKeyManagementParameters(e) {
    if (this._keyManagementParameters)
      throw new TypeError("setKeyManagementParameters can only be called once");
    return this._keyManagementParameters = e, this;
  }
  setProtectedHeader(e) {
    if (this._protectedHeader)
      throw new TypeError("setProtectedHeader can only be called once");
    return this._protectedHeader = e, this;
  }
  setSharedUnprotectedHeader(e) {
    if (this._sharedUnprotectedHeader)
      throw new TypeError("setSharedUnprotectedHeader can only be called once");
    return this._sharedUnprotectedHeader = e, this;
  }
  setUnprotectedHeader(e) {
    if (this._unprotectedHeader)
      throw new TypeError("setUnprotectedHeader can only be called once");
    return this._unprotectedHeader = e, this;
  }
  setAdditionalAuthenticatedData(e) {
    return this._aad = e, this;
  }
  setContentEncryptionKey(e) {
    if (this._cek)
      throw new TypeError("setContentEncryptionKey can only be called once");
    return this._cek = e, this;
  }
  setInitializationVector(e) {
    if (this._iv)
      throw new TypeError("setInitializationVector can only be called once");
    return this._iv = e, this;
  }
  async encrypt(e, n) {
    if (!this._protectedHeader && !this._unprotectedHeader && !this._sharedUnprotectedHeader)
      throw new rn("either setProtectedHeader, setUnprotectedHeader, or sharedUnprotectedHeader must be called before #encrypt()");
    if (!KZ(this._protectedHeader, this._unprotectedHeader, this._sharedUnprotectedHeader))
      throw new rn("JWE Protected, JWE Shared Unprotected and JWE Per-Recipient Header Parameter names must be disjoint");
    const i = {
      ...this._protectedHeader,
      ...this._unprotectedHeader,
      ...this._sharedUnprotectedHeader
    };
    if (Av(rn, /* @__PURE__ */ new Map(), n?.crit, this._protectedHeader, i), i.zip !== void 0)
      throw new _e('JWE "zip" (Compression Algorithm) Header Parameter is not supported.');
    const { alg: s, enc: r } = i;
    if (typeof s != "string" || !s)
      throw new rn('JWE "alg" (Algorithm) Header Parameter missing or invalid');
    if (typeof r != "string" || !r)
      throw new rn('JWE "enc" (Encryption Algorithm) Header Parameter missing or invalid');
    let o;
    if (this._cek && (s === "dir" || s === "ECDH-ES"))
      throw new TypeError(`setContentEncryptionKey cannot be called with JWE "alg" (Algorithm) Header ${s}`);
    let l;
    {
      let g;
      ({ cek: l, encryptedKey: o, parameters: g } = await yv(s, r, e, this._cek, this._keyManagementParameters)), g && (n && Vv in n ? this._unprotectedHeader ? this._unprotectedHeader = { ...this._unprotectedHeader, ...g } : this.setUnprotectedHeader(g) : this._protectedHeader ? this._protectedHeader = { ...this._protectedHeader, ...g } : this.setProtectedHeader(g));
    }
    let a, c, u;
    this._protectedHeader ? c = cn.encode(lt(JSON.stringify(this._protectedHeader))) : c = cn.encode(""), this._aad ? (u = lt(this._aad), a = Oi(c, cn.encode("."), cn.encode(u))) : a = c;
    const { ciphertext: h, tag: d, iv: m } = await Z3(r, this._plaintext, l, this._iv, a), p = {
      ciphertext: lt(h)
    };
    return m && (p.iv = lt(m)), d && (p.tag = lt(d)), o && (p.encrypted_key = lt(o)), u && (p.aad = u), this._protectedHeader && (p.protected = p3.decode(c)), this._sharedUnprotectedHeader && (p.unprotected = this._sharedUnprotectedHeader), this._unprotectedHeader && (p.header = this._unprotectedHeader), p;
  }
}
const pn = (t) => Math.floor(t.getTime() / 1e3), v3 = 60, I3 = v3 * 60, va = I3 * 24, Wv = va * 7, Sv = va * 365.25, Zv = /^(\+|\-)? ?(\d+|\d+\.\d+) ?(seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)(?: (ago|from now))?$/i, Do = (t) => {
  const e = Zv.exec(t);
  if (!e || e[4] && e[1])
    throw new TypeError("Invalid time period format");
  const n = parseFloat(e[2]), i = e[3].toLowerCase();
  let s;
  switch (i) {
    case "sec":
    case "secs":
    case "second":
    case "seconds":
    case "s":
      s = Math.round(n);
      break;
    case "minute":
    case "minutes":
    case "min":
    case "mins":
    case "m":
      s = Math.round(n * v3);
      break;
    case "hour":
    case "hours":
    case "hr":
    case "hrs":
    case "h":
      s = Math.round(n * I3);
      break;
    case "day":
    case "days":
    case "d":
      s = Math.round(n * va);
      break;
    case "week":
    case "weeks":
    case "w":
      s = Math.round(n * Wv);
      break;
    default:
      s = Math.round(n * Sv);
      break;
  }
  return e[1] === "-" || e[4] === "ago" ? -s : s;
};
class vv {
  constructor(e) {
    this._flattened = new Cv(e);
  }
  setContentEncryptionKey(e) {
    return this._flattened.setContentEncryptionKey(e), this;
  }
  setInitializationVector(e) {
    return this._flattened.setInitializationVector(e), this;
  }
  setProtectedHeader(e) {
    return this._flattened.setProtectedHeader(e), this;
  }
  setKeyManagementParameters(e) {
    return this._flattened.setKeyManagementParameters(e), this;
  }
  async encrypt(e, n) {
    const i = await this._flattened.encrypt(e, n);
    return [i.protected, i.encrypted_key, i.iv, i.ciphertext, i.tag].join(".");
  }
}
function gn(t, e) {
  if (!Number.isFinite(e))
    throw new TypeError(`Invalid ${t} input`);
  return e;
}
class Iv {
  constructor(e = {}) {
    if (!Za(e))
      throw new TypeError("JWT Claims Set MUST be an object");
    this._payload = e;
  }
  setIssuer(e) {
    return this._payload = { ...this._payload, iss: e }, this;
  }
  setSubject(e) {
    return this._payload = { ...this._payload, sub: e }, this;
  }
  setAudience(e) {
    return this._payload = { ...this._payload, aud: e }, this;
  }
  setJti(e) {
    return this._payload = { ...this._payload, jti: e }, this;
  }
  setNotBefore(e) {
    return typeof e == "number" ? this._payload = { ...this._payload, nbf: gn("setNotBefore", e) } : e instanceof Date ? this._payload = { ...this._payload, nbf: gn("setNotBefore", pn(e)) } : this._payload = { ...this._payload, nbf: pn(/* @__PURE__ */ new Date()) + Do(e) }, this;
  }
  setExpirationTime(e) {
    return typeof e == "number" ? this._payload = { ...this._payload, exp: gn("setExpirationTime", e) } : e instanceof Date ? this._payload = { ...this._payload, exp: gn("setExpirationTime", pn(e)) } : this._payload = { ...this._payload, exp: pn(/* @__PURE__ */ new Date()) + Do(e) }, this;
  }
  setIssuedAt(e) {
    return typeof e > "u" ? this._payload = { ...this._payload, iat: pn(/* @__PURE__ */ new Date()) } : e instanceof Date ? this._payload = { ...this._payload, iat: gn("setIssuedAt", pn(e)) } : typeof e == "string" ? this._payload = {
      ...this._payload,
      iat: gn("setIssuedAt", pn(/* @__PURE__ */ new Date()) + Do(e))
    } : this._payload = { ...this._payload, iat: gn("setIssuedAt", e) }, this;
  }
}
class Nv extends Iv {
  setProtectedHeader(e) {
    if (this._protectedHeader)
      throw new TypeError("setProtectedHeader can only be called once");
    return this._protectedHeader = e, this;
  }
  setKeyManagementParameters(e) {
    if (this._keyManagementParameters)
      throw new TypeError("setKeyManagementParameters can only be called once");
    return this._keyManagementParameters = e, this;
  }
  setContentEncryptionKey(e) {
    if (this._cek)
      throw new TypeError("setContentEncryptionKey can only be called once");
    return this._cek = e, this;
  }
  setInitializationVector(e) {
    if (this._iv)
      throw new TypeError("setInitializationVector can only be called once");
    return this._iv = e, this;
  }
  replicateIssuerAsHeader() {
    return this._replicateIssuerAsHeader = !0, this;
  }
  replicateSubjectAsHeader() {
    return this._replicateSubjectAsHeader = !0, this;
  }
  replicateAudienceAsHeader() {
    return this._replicateAudienceAsHeader = !0, this;
  }
  async encrypt(e, n) {
    const i = new vv(cn.encode(JSON.stringify(this._payload)));
    return this._replicateIssuerAsHeader && (this._protectedHeader = { ...this._protectedHeader, iss: this._payload.iss }), this._replicateSubjectAsHeader && (this._protectedHeader = { ...this._protectedHeader, sub: this._payload.sub }), this._replicateAudienceAsHeader && (this._protectedHeader = { ...this._protectedHeader, aud: this._payload.aud }), i.setProtectedHeader(this._protectedHeader), this._iv && i.setInitializationVector(this._iv), this._cek && i.setContentEncryptionKey(this._cek), this._keyManagementParameters && i.setKeyManagementParameters(this._keyManagementParameters), i.encrypt(e, n);
  }
}
var Tt;
(function(t) {
  t.SCHEMA = "schema", t.EXTERNAL_TOKEN = "eToken", t.TOKEN = "token";
})(Tt || (Tt = {}));
class Fv extends uW {
  constructor() {
    super("user");
  }
  // Schema
  setSchema = (e) => {
    this.write(Tt.SCHEMA, e);
  };
  getSchema = () => this.read(Tt.SCHEMA);
  // Token
  setToken = (e) => {
    this.write(Tt.TOKEN, e);
  };
  getToken = () => this.read(Tt.TOKEN);
  // External Token
  setExternalToken = (e) => {
    this.write(Tt.EXTERNAL_TOKEN, e);
  };
  getExternalToken = () => this.read(Tt.EXTERNAL_TOKEN);
  removeToken = () => {
    this.remove(Tt.TOKEN);
  };
}
var hd;
(function(t) {
  t.DISABLED = "disabled", t.INITIALIZATION = "initialization", t.READY = "ready", t.FAILED = "failed", t.SUSPENDED = "suspended";
})(hd || (hd = {}));
Ki("deep_link");
Ki("bypass");
const dd = new Fv(), md = async (t, e = {}) => {
  const { schemaName: n, issuer: i } = {
    schemaName: "slra",
    issuer: "sdk-web",
    ...e
  };
  t.sdk.withAuth = !0;
  const s = await t.stores.organizationSettings.getValue();
  if (!s)
    throw new Error("unknown organization");
  const r = `${s.pub?.kid}`, o = `${n}:${s.id}`, a = (await BZ(t.transport, { userKey: r, schema: o, init: !0 })).meta?.token, c = s.pub, u = await hv({ ...c }), h = crypto.getRandomValues(new Uint8Array(16));
  h[6] = h[6] & 15 | 64, h[8] = h[8] & 63 | 128;
  const d = Array.from(h, (g) => g.toString(16).padStart(2, "0")).join(""), m = `${d.slice(0, 8)}-${d.slice(8, 12)}-${d.slice(12, 16)}-${d.slice(16, 20)}-${d.slice(20)}`, p = await new Nv({ "device-id": m, totp: a }).setProtectedHeader({ alg: c.alg || "", enc: "A256CBC-HS512", kid: c.kid }).setIssuedAt().setIssuer(i).setAudience(s.id).setExpirationTime("2m").encrypt(u);
  await t.auth.login(o, p), dd.setSchema("streamlayer:streamlayer"), dd.setExternalToken(p);
}, Gv = async (t, e = {}) => {
  try {
    await t.auth.reLogin({ skipLogin: !0 }) || await md(t, e).catch((i) => {
      console.error(i, "fail anon login");
    });
  } catch (n) {
    console.log(n, "fail anon re-login"), await md(t, e);
  }
}, Xv = (t, e = {}) => new Promise((n, i) => {
  const s = setTimeout(() => {
    i(new Error("timeout"));
  }, 3e4);
  t.stores.status.subscribe(async (r) => {
    if (r === "ready")
      try {
        await Gv(t, e), n(!0);
      } catch (o) {
        i(o);
      } finally {
        clearTimeout(s);
      }
  });
}), Uv = (t, e, n) => {
  t.sdk.anonymousAuthorization = async () => {
    await Xv(t, e);
  }, n();
}, Bv = /* @__PURE__ */ new Set([Uv]), N3 = ({
  videoPlayerController: t
}) => {
  const e = Qi(), n = Ee();
  return te(() => {
    if (e)
      return n.current = t, e.addVideoPlayerController(n.current), () => {
        n.current && e.removeVideoPlayerController(n.current);
      };
  }, [e]), null;
}, vI = ({
  children: t,
  videoPlayerController: e,
  ...n
}) => /* @__PURE__ */ U(
  W4,
  {
    ...n,
    themeMode: "dark",
    withAd: !0,
    skipOnboarding: !0,
    withAdNotification: !0,
    autoEnable: !0,
    plugins: Bv,
    friendsTab: "disabled",
    hideFriends: !0,
    webOS: !0,
    children: [
      t,
      e && /* @__PURE__ */ f(N3, { videoPlayerController: e })
    ]
  }
), wv = ({ sdk: t }) => (te(() => {
  t.anonymousAuthorization();
}, [t]), null), Yv = ({ persistent: t, notification: e, banner: n, sdk: i }) => {
  const s = He(i.uiState);
  return s.exposedPauseAd ? null : n ? s.promotionBanner || s.appBanner ? /* @__PURE__ */ f(qn, { sdk: i, persistent: t, banner: "bottom" }) : null : e ? s.promotionNotification ? /* @__PURE__ */ f(qn, { sdk: i, notification: !0, persistent: t }) : s.onboardingNotification || s.appNotification ? /* @__PURE__ */ f(Qs, { sdk: i, notification: !0, persistent: t }) : null : s.promotionSidebar ? /* @__PURE__ */ f(qn, { sdk: i, persistent: t, sidebar: "right" }) : s.app || s.appSidebar ? /* @__PURE__ */ f(Qs, { sdk: i, persistent: t }) : null;
}, II = (t) => {
  const e = Qi(), n = ua();
  return e ? /* @__PURE__ */ f("div", { className: "StreamLayerSDK StreamLayerSDKTvContent", children: /* @__PURE__ */ f(Fl, { customTheme: n.theme, themeMode: n.themeMode, children: /* @__PURE__ */ f(Yv, { sdk: e, ...t }) }) }) : null;
}, NI = ({
  videoPlayerController: t,
  ...e
}) => {
  const n = Qi(), i = ua();
  return n ? /* @__PURE__ */ U("div", { className: "StreamLayerSDK StreamLayerSDKTvPauseAd", children: [
    /* @__PURE__ */ f(Fl, { customTheme: i.theme, themeMode: i.themeMode, children: /* @__PURE__ */ f(D2, { ...e, sdk: n, isDesktop: !1 }) }),
    t && /* @__PURE__ */ f(N3, { videoPlayerController: t })
  ] }) : null;
}, FI = ({
  persistent: t,
  children: e,
  showPauseAd: n,
  pauseAdVastUrl: i,
  videoPlayerController: s,
  onRenderPauseAd: r,
  onClosePauseAd: o,
  options: l
}) => {
  const a = Qi(), c = ua(), u = Ee();
  return te(() => {
    if (a)
      return s && (u.current = s, a.addVideoPlayerController(u.current)), () => {
        u.current && a.removeVideoPlayerController(u.current);
      };
  }, [a]), a ? /* @__PURE__ */ f("div", { className: "StreamLayerSDK StreamLayerSDKTv", children: /* @__PURE__ */ U(Fl, { customTheme: c.theme, themeMode: c.themeMode, children: [
    /* @__PURE__ */ f(
      UZ,
      {
        sdk: a,
        persistent: t,
        showPauseAd: n,
        onRenderPauseAd: r,
        pauseAdVastUrl: i,
        onClosePauseAd: o,
        options: l,
        children: e
      }
    ),
    /* @__PURE__ */ f(wv, { sdk: a })
  ] }) }) : null;
};
export {
  vI as S,
  Qi as Y,
  ua as _,
  Tb as a,
  FI as b,
  II as c,
  NI as d,
  Z4 as q
};
